(function(){try{if(typeof document<`u`){var e=document.createElement(`style`);e.appendChild(document.createTextNode(`._unmatchedHeader_qcj19_1{opacity:.55}/*$vite$:1*/`)),document.head.appendChild(e)}}catch(e){console.error(`vite-plugin-css-injected-by-js`,e)}})();
import { Attachment as e, Avatar as t, Badge as n, Banner as r, Box as i, Button as a, Checkbox as o, CollapseCard as s, CopyToClipboardButton as c, Divider as l, EmptyState as u, ErrorBoundaryContext as d, FieldLabel as f, FieldSwitch as p, FieldText as m, FieldTextarea as h, FieldWrapper as g, FlexBox as _, FormField as v, FormGrid as y, Icon as b, IconButton as x, Image as S, InputSelectionList as C, InputText as w, List as T, Modal as E, ModalBody as D, ModalFoot as O, ModalHead as k, NavigationButton as A, Select as j, SelectionList as M, Spinner as N, Switch as P, Table as F, Tag as I, TagsInput as ee, Text as L, TextWithHighlight as te, Textarea as ne, Timestamp as re, Tooltip as R, getSelectionListContext as ie } from "@dixa/lib-shared-habla";
import ae from "classnames";
import { DisplayErrors as z, IntegrationModal as oe, MisconfigurationBanner as se, OAuthSettings as ce, PartnerHookFormBasicAuth as le, PartnerHookFormSecretText as ue, PartnerSettingsWrapper as de, WidgetContextProvider as fe, WidgetSettingsFormFooter as pe, capitalizeFirstCharacter as me, defaultDateFormat as he, displayAttributeValue as ge, getCountryNameFromCountryCode as _e, getPartnerDevApiHeaders as ve, handleWidgetSubmit as ye, hasDownstreamApiAuthorizationError as be, hasDownstreamApiForbiddenError as xe, hasDownstreamApiNotFoundError as Se, hasDownstreamApiPermissionError as Ce, hasDownstreamApiTooManyRequestsError as we, humanizeKey as Te, isDownstreamApiAuthorizationError as Ee, isDownstreamApiNotFoundError as De, isDownstreamApiPermissionError as Oe, isRunningLocalPartnerApi as ke, makeExecuteQuery as Ae, makeUseLazyQuery as je, makeUseMutation as Me, makeUseQuery as Ne, mapLabels as Pe, parseBoolean as Fe, parseString as Ie, settingsToFormValues as Le, useCopyWithDelay as Re, useData as ze, useRenderConditions as Be, useTracking as B, useWidgetContext as V, useWidgetSettingsMutations as Ve, useWidgetSettingsQuery as He, validateApiHostName as Ue } from "lib-integrations-partner-support";
import H, { Fragment as We, createContext as Ge, createElement as Ke, isValidElement as qe, useCallback as Je, useContext as Ye, useEffect as U, useLayoutEffect as Xe, useMemo as Ze, useReducer as Qe, useRef as $e, useState as W } from "react";
import { ApolloClient as et, ApolloConsumer as tt, ApolloError as nt, ApolloLink as rt, ApolloProvider as it, InMemoryCache as at, NetworkStatus as ot, Observable as st, createHttpLink as ct, gql as lt, isApolloError as ut, useApolloClient as dt } from "@apollo/client";
import ft from "cross-fetch";
import { config as pt } from "lib-shared-backend-config";
import { Fragment as G, jsx as K, jsxs as q } from "react/jsx-runtime";
import mt from "moment";
import ht from "lodash/pick";
import "moment-timezone";
import "lodash/omit";
import gt from "lodash/identity";
import { __assign as _t, __rest as vt } from "tslib";
export * from "lib-integrations-partner-support";
//#region \0rolldown/runtime.js
var yt = Object.create, bt = Object.defineProperty, xt = Object.getOwnPropertyDescriptor, St = Object.getOwnPropertyNames, Ct = Object.getPrototypeOf, wt = Object.prototype.hasOwnProperty, Tt = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), Et = (e, t) => {
	let n = {};
	for (var r in e) bt(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || bt(n, Symbol.toStringTag, { value: "Module" }), n;
}, Dt = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = St(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !wt.call(e, s) && s !== n && bt(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = xt(t, s)) || r.enumerable
	});
	return e;
}, Ot = (e, t, n) => (n = e == null ? {} : yt(Ct(e)), Dt(t || !e || !e.__esModule ? bt(n, "default", {
	value: e,
	enumerable: !0
}) : n, e));
//#endregion
//#region ../../../node_modules/axios/lib/helpers/bind.js
function kt(e, t) {
	return function() {
		return e.apply(t, arguments);
	};
}
//#endregion
//#region ../../../node_modules/axios/lib/utils.js
var { toString: At } = Object.prototype, { getPrototypeOf: jt } = Object, { iterator: Mt, toStringTag: Nt } = Symbol, Pt = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Ft = (e, t) => {
	let n = e, r = [];
	for (; n != null && n !== Object.prototype;) {
		if (r.indexOf(n) !== -1) return !1;
		if (r.push(n), Pt(n, t)) return !0;
		n = jt(n);
	}
	return !1;
}, It = (e, t) => e != null && Ft(e, t) ? e[t] : void 0, Lt = ((e) => (t) => {
	let n = At.call(t);
	return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(Object.create(null)), Rt = (e) => (e = e.toLowerCase(), (t) => Lt(t) === e), zt = (e) => (t) => typeof t === e, { isArray: Bt } = Array, Vt = zt("undefined");
function Ht(e) {
	return e !== null && !Vt(e) && e.constructor !== null && !Vt(e.constructor) && Kt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
var Ut = Rt("ArrayBuffer");
function Wt(e) {
	let t;
	return t = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && Ut(e.buffer), t;
}
var Gt = zt("string"), Kt = zt("function"), qt = zt("number"), Jt = (e) => typeof e == "object" && !!e, Yt = (e) => e === !0 || e === !1, Xt = (e) => {
	if (!Jt(e)) return !1;
	let t = jt(e);
	return (t === null || t === Object.prototype || jt(t) === null) && !Ft(e, Nt) && !Ft(e, Mt);
}, Zt = (e) => {
	if (!Jt(e) || Ht(e)) return !1;
	try {
		return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
	} catch {
		return !1;
	}
}, Qt = Rt("Date"), $t = Rt("File"), en = (e) => !!(e && e.uri !== void 0), tn = (e) => e && e.getParts !== void 0, nn = Rt("Blob"), rn = Rt("FileList"), an = (e) => Jt(e) && Kt(e.pipe);
function on() {
	return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
var sn = on(), cn = sn.FormData === void 0 ? void 0 : sn.FormData, ln = (e) => {
	if (!e) return !1;
	if (cn && e instanceof cn) return !0;
	let t = jt(e);
	if (!t || t === Object.prototype || !Kt(e.append)) return !1;
	let n = Lt(e);
	return n === "formdata" || n === "object" && Kt(e.toString) && e.toString() === "[object FormData]";
}, un = Rt("URLSearchParams"), [dn, fn, pn, mn] = [
	"ReadableStream",
	"Request",
	"Response",
	"Headers"
].map(Rt), hn = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function gn(e, t, { allOwnKeys: n = !1 } = {}) {
	if (e == null) return;
	let r, i;
	if (typeof e != "object" && (e = [e]), Bt(e)) for (r = 0, i = e.length; r < i; r++) t.call(null, e[r], r, e);
	else {
		if (Ht(e)) return;
		let i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length, o;
		for (r = 0; r < a; r++) o = i[r], t.call(null, e[o], o, e);
	}
}
function _n(e, t) {
	if (Ht(e)) return null;
	t = t.toLowerCase();
	let n = Object.keys(e), r = n.length, i;
	for (; r-- > 0;) if (i = n[r], t === i.toLowerCase()) return i;
	return null;
}
var vn = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, yn = (e) => !Vt(e) && e !== vn;
function bn(...e) {
	let { caseless: t, skipUndefined: n } = yn(this) && this || {}, r = {}, i = (e, i) => {
		if (i === "__proto__" || i === "constructor" || i === "prototype") return;
		let a = t && typeof i == "string" && _n(r, i) || i, o = Pt(r, a) ? r[a] : void 0;
		Xt(o) && Xt(e) ? r[a] = bn(o, e) : Xt(e) ? r[a] = bn({}, e) : Bt(e) ? r[a] = e.slice() : (!n || !Vt(e)) && (r[a] = e);
	};
	for (let t = 0, n = e.length; t < n; t++) {
		let n = e[t];
		if (!n || Ht(n) || (gn(n, i), typeof n != "object" || Bt(n))) continue;
		let r = Object.getOwnPropertySymbols(n);
		for (let e = 0; e < r.length; e++) {
			let t = r[e];
			Mn.call(n, t) && i(n[t], t);
		}
	}
	return r;
}
var xn = (e, t, n, { allOwnKeys: r } = {}) => (gn(t, (t, r) => {
	n && Kt(t) ? Object.defineProperty(e, r, {
		__proto__: null,
		value: kt(t, n),
		writable: !0,
		enumerable: !0,
		configurable: !0
	}) : Object.defineProperty(e, r, {
		__proto__: null,
		value: t,
		writable: !0,
		enumerable: !0,
		configurable: !0
	});
}, { allOwnKeys: r }), e), Sn = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Cn = (e, t, n, r) => {
	e.prototype = Object.create(t.prototype, r), Object.defineProperty(e.prototype, "constructor", {
		__proto__: null,
		value: e,
		writable: !0,
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(e, "super", {
		__proto__: null,
		value: t.prototype
	}), n && Object.assign(e.prototype, n);
}, wn = (e, t, n, r) => {
	let i, a, o, s = {};
	if (t ||= {}, e == null) return t;
	do {
		for (i = Object.getOwnPropertyNames(e), a = i.length; a-- > 0;) o = i[a], (!r || r(o, e, t)) && !s[o] && (t[o] = e[o], s[o] = !0);
		e = n !== !1 && jt(e);
	} while (e && (!n || n(e, t)) && e !== Object.prototype);
	return t;
}, Tn = (e, t, n) => {
	e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
	let r = e.indexOf(t, n);
	return r !== -1 && r === n;
}, En = (e) => {
	if (!e) return null;
	if (Bt(e)) return e;
	let t = e.length;
	if (!qt(t)) return null;
	let n = Array(t);
	for (; t-- > 0;) n[t] = e[t];
	return n;
}, Dn = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && jt(Uint8Array)), On = (e, t) => {
	let n = (e && e[Mt]).call(e), r;
	for (; (r = n.next()) && !r.done;) {
		let n = r.value;
		t.call(e, n[0], n[1]);
	}
}, kn = (e, t) => {
	let n, r = [];
	for (; (n = e.exec(t)) !== null;) r.push(n);
	return r;
}, An = Rt("HTMLFormElement"), jn = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, t, n) {
	return t.toUpperCase() + n;
}), { propertyIsEnumerable: Mn } = Object.prototype, Nn = Rt("RegExp"), Pn = (e, t) => {
	let n = Object.getOwnPropertyDescriptors(e), r = {};
	gn(n, (n, i) => {
		let a;
		(a = t(n, i, e)) !== !1 && (r[i] = a || n);
	}), Object.defineProperties(e, r);
}, Fn = (e) => {
	Pn(e, (t, n) => {
		if (Kt(e) && [
			"arguments",
			"caller",
			"callee"
		].includes(n)) return !1;
		let r = e[n];
		if (Kt(r)) {
			if (t.enumerable = !1, "writable" in t) {
				t.writable = !1;
				return;
			}
			t.set ||= () => {
				throw Error("Can not rewrite read-only method '" + n + "'");
			};
		}
	});
}, In = (e, t) => {
	let n = {}, r = (e) => {
		e.forEach((e) => {
			n[e] = !0;
		});
	};
	return Bt(e) ? r(e) : r(String(e).split(t)), n;
}, Ln = () => {}, Rn = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function zn(e) {
	return !!(e && Kt(e.append) && e[Nt] === "FormData" && e[Mt]);
}
var Bn = (e) => {
	let t = /* @__PURE__ */ new WeakSet(), n = (e) => {
		if (Jt(e)) {
			if (t.has(e)) return;
			if (Ht(e)) return e;
			if (!("toJSON" in e)) {
				t.add(e);
				let r = Bt(e) ? [] : {};
				return gn(e, (e, t) => {
					let i = n(e);
					!Vt(i) && (r[t] = i);
				}), t.delete(e), r;
			}
		}
		return e;
	};
	return n(e);
}, Vn = Rt("AsyncFunction"), Hn = (e) => e && (Jt(e) || Kt(e)) && Kt(e.then) && Kt(e.catch), Un = ((e, t) => e ? setImmediate : t ? ((e, t) => (vn.addEventListener("message", ({ source: n, data: r }) => {
	n === vn && r === e && t.length && t.shift()();
}, !1), (n) => {
	t.push(n), vn.postMessage(e, "*");
}))(`axios@${Math.random()}`, []) : (e) => setTimeout(e))(typeof setImmediate == "function", Kt(vn.postMessage)), Wn = typeof queueMicrotask < "u" ? queueMicrotask.bind(vn) : typeof process < "u" && process.nextTick || Un, Gn = (e) => e != null && Kt(e[Mt]), J = {
	isArray: Bt,
	isArrayBuffer: Ut,
	isBuffer: Ht,
	isFormData: ln,
	isArrayBufferView: Wt,
	isString: Gt,
	isNumber: qt,
	isBoolean: Yt,
	isObject: Jt,
	isPlainObject: Xt,
	isEmptyObject: Zt,
	isReadableStream: dn,
	isRequest: fn,
	isResponse: pn,
	isHeaders: mn,
	isUndefined: Vt,
	isDate: Qt,
	isFile: $t,
	isReactNativeBlob: en,
	isReactNative: tn,
	isBlob: nn,
	isRegExp: Nn,
	isFunction: Kt,
	isStream: an,
	isURLSearchParams: un,
	isTypedArray: Dn,
	isFileList: rn,
	forEach: gn,
	merge: bn,
	extend: xn,
	trim: hn,
	stripBOM: Sn,
	inherits: Cn,
	toFlatObject: wn,
	kindOf: Lt,
	kindOfTest: Rt,
	endsWith: Tn,
	toArray: En,
	forEachEntry: On,
	matchAll: kn,
	isHTMLForm: An,
	hasOwnProperty: Pt,
	hasOwnProp: Pt,
	hasOwnInPrototypeChain: Ft,
	getSafeProp: It,
	reduceDescriptors: Pn,
	freezeMethods: Fn,
	toObjectSet: In,
	toCamelCase: jn,
	noop: Ln,
	toFiniteNumber: Rn,
	findKey: _n,
	global: vn,
	isContextDefined: yn,
	isSpecCompliantForm: zn,
	toJSONObject: Bn,
	isAsyncFn: Vn,
	isThenable: Hn,
	setImmediate: Un,
	asap: Wn,
	isIterable: Gn,
	isSafeIterable: (e) => e != null && Ft(e, Mt) && Gn(e)
}, Kn = J.toObjectSet([
	"age",
	"authorization",
	"content-length",
	"content-type",
	"etag",
	"expires",
	"from",
	"host",
	"if-modified-since",
	"if-unmodified-since",
	"last-modified",
	"location",
	"max-forwards",
	"proxy-authorization",
	"referer",
	"retry-after",
	"user-agent"
]), qn = (e) => {
	let t = {}, n, r, i;
	return e && e.split("\n").forEach(function(e) {
		i = e.indexOf(":"), n = e.substring(0, i).trim().toLowerCase(), r = e.substring(i + 1).trim(), !(!n || t[n] && Kn[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
	}), t;
};
//#endregion
//#region ../../../node_modules/axios/lib/helpers/sanitizeHeaderValue.js
function Jn(e) {
	let t = 0, n = e.length;
	for (; t < n;) {
		let n = e.charCodeAt(t);
		if (n !== 9 && n !== 32) break;
		t += 1;
	}
	for (; n > t;) {
		let t = e.charCodeAt(n - 1);
		if (t !== 9 && t !== 32) break;
		--n;
	}
	return t === 0 && n === e.length ? e : e.slice(t, n);
}
var Yn = /* @__PURE__ */ RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), Xn = /* @__PURE__ */ RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function Zn(e, t) {
	return J.isArray(e) ? e.map((e) => Zn(e, t)) : Jn(String(e).replace(t, ""));
}
var Qn = (e) => Zn(e, Yn), $n = (e) => Zn(e, Xn);
function er(e) {
	let t = Object.create(null);
	return J.forEach(e.toJSON(), (e, n) => {
		t[n] = $n(e);
	}), t;
}
//#endregion
//#region ../../../node_modules/axios/lib/core/AxiosHeaders.js
var tr = Symbol("internals");
function nr(e) {
	return e && String(e).trim().toLowerCase();
}
function rr(e) {
	return e === !1 || e == null ? e : J.isArray(e) ? e.map(rr) : Qn(String(e));
}
function ir(e) {
	let t = Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g, r;
	for (; r = n.exec(e);) t[r[1]] = r[2];
	return t;
}
var ar = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function or(e, t, n, r, i) {
	if (J.isFunction(r)) return r.call(this, t, n);
	if (i && (t = n), J.isString(t)) {
		if (J.isString(r)) return t.indexOf(r) !== -1;
		if (J.isRegExp(r)) return r.test(t);
	}
}
function sr(e) {
	return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, n) => t.toUpperCase() + n);
}
function cr(e, t) {
	let n = J.toCamelCase(" " + t);
	[
		"get",
		"set",
		"has"
	].forEach((r) => {
		Object.defineProperty(e, r + n, {
			__proto__: null,
			value: function(e, n, i) {
				return this[r].call(this, t, e, n, i);
			},
			configurable: !0
		});
	});
}
var lr = class {
	constructor(e) {
		e && this.set(e);
	}
	set(e, t, n) {
		let r = this;
		function i(e, t, n) {
			let i = nr(t);
			if (!i) return;
			let a = J.findKey(r, i);
			(!a || r[a] === void 0 || n === !0 || n === void 0 && r[a] !== !1) && (r[a || t] = rr(e));
		}
		let a = (e, t) => J.forEach(e, (e, n) => i(e, n, t));
		if (J.isPlainObject(e) || e instanceof this.constructor) a(e, t);
		else if (J.isString(e) && (e = e.trim()) && !ar(e)) a(qn(e), t);
		else if (J.isObject(e) && J.isSafeIterable(e)) {
			let n = Object.create(null), r, i;
			for (let t of e) {
				if (!J.isArray(t)) throw TypeError("Object iterator must return a key-value pair");
				i = t[0], J.hasOwnProp(n, i) ? (r = n[i], n[i] = J.isArray(r) ? [...r, t[1]] : [r, t[1]]) : n[i] = t[1];
			}
			a(n, t);
		} else e != null && i(t, e, n);
		return this;
	}
	get(e, t) {
		if (e = nr(e), e) {
			let n = J.findKey(this, e);
			if (n) {
				let e = this[n];
				if (!t) return e;
				if (t === !0) return ir(e);
				if (J.isFunction(t)) return t.call(this, e, n);
				if (J.isRegExp(t)) return t.exec(e);
				throw TypeError("parser must be boolean|regexp|function");
			}
		}
	}
	has(e, t) {
		if (e = nr(e), e) {
			let n = J.findKey(this, e);
			return !!(n && this[n] !== void 0 && (!t || or(this, this[n], n, t)));
		}
		return !1;
	}
	delete(e, t) {
		let n = this, r = !1;
		function i(e) {
			if (e = nr(e), e) {
				let i = J.findKey(n, e);
				i && (!t || or(n, n[i], i, t)) && (delete n[i], r = !0);
			}
		}
		return J.isArray(e) ? e.forEach(i) : i(e), r;
	}
	clear(e) {
		let t = Object.keys(this), n = t.length, r = !1;
		for (; n--;) {
			let i = t[n];
			(!e || or(this, this[i], i, e, !0)) && (delete this[i], r = !0);
		}
		return r;
	}
	normalize(e) {
		let t = this, n = {};
		return J.forEach(this, (r, i) => {
			let a = J.findKey(n, i);
			if (a) {
				t[a] = rr(r), delete t[i];
				return;
			}
			let o = e ? sr(i) : String(i).trim();
			o !== i && delete t[i], t[o] = rr(r), n[o] = !0;
		}), this;
	}
	concat(...e) {
		return this.constructor.concat(this, ...e);
	}
	toJSON(e) {
		let t = Object.create(null);
		return J.forEach(this, (n, r) => {
			n != null && n !== !1 && (t[r] = e && J.isArray(n) ? n.join(", ") : n);
		}), t;
	}
	[Symbol.iterator]() {
		return Object.entries(this.toJSON())[Symbol.iterator]();
	}
	toString() {
		return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join("\n");
	}
	getSetCookie() {
		return this.get("set-cookie") || [];
	}
	get [Symbol.toStringTag]() {
		return "AxiosHeaders";
	}
	static from(e) {
		return e instanceof this ? e : new this(e);
	}
	static concat(e, ...t) {
		let n = new this(e);
		return t.forEach((e) => n.set(e)), n;
	}
	static accessor(e) {
		let t = (this[tr] = this[tr] = { accessors: {} }).accessors, n = this.prototype;
		function r(e) {
			let r = nr(e);
			t[r] || (cr(n, e), t[r] = !0);
		}
		return J.isArray(e) ? e.forEach(r) : r(e), this;
	}
};
lr.accessor([
	"Content-Type",
	"Content-Length",
	"Accept",
	"Accept-Encoding",
	"User-Agent",
	"Authorization"
]), J.reduceDescriptors(lr.prototype, ({ value: e }, t) => {
	let n = t[0].toUpperCase() + t.slice(1);
	return {
		get: () => e,
		set(e) {
			this[n] = e;
		}
	};
}), J.freezeMethods(lr);
//#endregion
//#region ../../../node_modules/axios/lib/core/AxiosError.js
var ur = "[REDACTED ****]";
function dr(e) {
	if (J.hasOwnProp(e, "toJSON")) return !0;
	let t = Object.getPrototypeOf(e);
	for (; t && t !== Object.prototype;) {
		if (J.hasOwnProp(t, "toJSON")) return !0;
		t = Object.getPrototypeOf(t);
	}
	return !1;
}
function fr(e, t) {
	let n = new Set(t.map((e) => String(e).toLowerCase())), r = [], i = (e) => {
		if (typeof e != "object" || !e || J.isBuffer(e)) return e;
		if (r.indexOf(e) !== -1) return;
		e instanceof lr && (e = e.toJSON()), r.push(e);
		let t;
		if (J.isArray(e)) t = [], e.forEach((e, n) => {
			let r = i(e);
			J.isUndefined(r) || (t[n] = r);
		});
		else {
			if (!J.isPlainObject(e) && dr(e)) return r.pop(), e;
			t = Object.create(null);
			for (let [r, a] of Object.entries(e)) {
				let e = n.has(r.toLowerCase()) ? ur : i(a);
				J.isUndefined(e) || (t[r] = e);
			}
		}
		return r.pop(), t;
	};
	return i(e);
}
var Y = class e extends Error {
	static from(t, n, r, i, a, o) {
		let s = new e(t.message, n || t.code, r, i, a);
		return s.cause = t, s.name = t.name, t.status != null && s.status == null && (s.status = t.status), o && Object.assign(s, o), s;
	}
	constructor(e, t, n, r, i) {
		super(e), Object.defineProperty(this, "message", {
			__proto__: null,
			value: e,
			enumerable: !0,
			writable: !0,
			configurable: !0
		}), this.name = "AxiosError", this.isAxiosError = !0, t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i, this.status = i.status);
	}
	toJSON() {
		let e = this.config, t = e && J.hasOwnProp(e, "redact") ? e.redact : void 0, n = J.isArray(t) && t.length > 0 ? fr(e, t) : J.toJSONObject(e);
		return {
			message: this.message,
			name: this.name,
			description: this.description,
			number: this.number,
			fileName: this.fileName,
			lineNumber: this.lineNumber,
			columnNumber: this.columnNumber,
			stack: this.stack,
			config: n,
			code: this.code,
			status: this.status
		};
	}
};
Y.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE", Y.ERR_BAD_OPTION = "ERR_BAD_OPTION", Y.ECONNABORTED = "ECONNABORTED", Y.ETIMEDOUT = "ETIMEDOUT", Y.ECONNREFUSED = "ECONNREFUSED", Y.ERR_NETWORK = "ERR_NETWORK", Y.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS", Y.ERR_DEPRECATED = "ERR_DEPRECATED", Y.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE", Y.ERR_BAD_REQUEST = "ERR_BAD_REQUEST", Y.ERR_CANCELED = "ERR_CANCELED", Y.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT", Y.ERR_INVALID_URL = "ERR_INVALID_URL", Y.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
function pr(e) {
	return J.isPlainObject(e) || J.isArray(e);
}
function mr(e) {
	return J.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function hr(e, t, n) {
	return e ? e.concat(t).map(function(e, t) {
		return e = mr(e), !n && t ? "[" + e + "]" : e;
	}).join(n ? "." : "") : t;
}
function gr(e) {
	return J.isArray(e) && !e.some(pr);
}
var _r = J.toFlatObject(J, {}, null, function(e) {
	return /^is[A-Z]/.test(e);
});
function vr(e, t, n) {
	if (!J.isObject(e)) throw TypeError("target must be an object");
	t ||= new FormData(), n = J.toFlatObject(n, {
		metaTokens: !0,
		dots: !1,
		indexes: !1
	}, !1, function(e, t) {
		return !J.isUndefined(t[e]);
	});
	let r = n.metaTokens, i = n.visitor || m, a = n.dots, o = n.indexes, s = n.Blob || typeof Blob < "u" && Blob, c = n.maxDepth === void 0 ? 100 : n.maxDepth, l = s && J.isSpecCompliantForm(t), u = [];
	if (!J.isFunction(i)) throw TypeError("visitor must be a function");
	function d(e) {
		if (e === null) return "";
		if (J.isDate(e)) return e.toISOString();
		if (J.isBoolean(e)) return e.toString();
		if (!l && J.isBlob(e)) throw new Y("Blob is not supported. Use a Buffer instead.");
		return J.isArrayBuffer(e) || J.isTypedArray(e) ? l && typeof Blob == "function" ? new Blob([e]) : Buffer.from(e) : e;
	}
	function f(e) {
		if (e > c) throw new Y("Object is too deeply nested (" + e + " levels). Max depth: " + c, Y.ERR_FORM_DATA_DEPTH_EXCEEDED);
	}
	function p(e, t) {
		if (c === Infinity) return JSON.stringify(e);
		let n = [];
		return JSON.stringify(e, function(e, r) {
			if (!J.isObject(r)) return r;
			for (; n.length && n[n.length - 1] !== this;) n.pop();
			return n.push(r), f(t + n.length - 1), r;
		});
	}
	function m(e, n, i) {
		let s = e;
		if (J.isReactNative(t) && J.isReactNativeBlob(e)) return t.append(hr(i, n, a), d(e)), !1;
		if (e && !i && typeof e == "object") {
			if (J.endsWith(n, "{}")) n = r ? n : n.slice(0, -2), e = p(e, 1);
			else if (J.isArray(e) && gr(e) || (J.isFileList(e) || J.endsWith(n, "[]")) && (s = J.toArray(e))) return n = mr(n), s.forEach(function(e, r) {
				!(J.isUndefined(e) || e === null) && t.append(o === !0 ? hr([n], r, a) : o === null ? n : n + "[]", d(e));
			}), !1;
		}
		return pr(e) ? !0 : (t.append(hr(i, n, a), d(e)), !1);
	}
	let h = Object.assign(_r, {
		defaultVisitor: m,
		convertValue: d,
		isVisitable: pr
	});
	function g(e, n, r = 0) {
		if (!J.isUndefined(e)) {
			if (f(r), u.indexOf(e) !== -1) throw Error("Circular reference detected in " + n.join("."));
			u.push(e), J.forEach(e, function(e, a) {
				(!(J.isUndefined(e) || e === null) && i.call(t, e, J.isString(a) ? a.trim() : a, n, h)) === !0 && g(e, n ? n.concat(a) : [a], r + 1);
			}), u.pop();
		}
	}
	if (!J.isObject(e)) throw TypeError("data must be an object");
	return g(e), t;
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/AxiosURLSearchParams.js
function yr(e) {
	let t = {
		"!": "%21",
		"'": "%27",
		"(": "%28",
		")": "%29",
		"~": "%7E",
		"%20": "+"
	};
	return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(e) {
		return t[e];
	});
}
function br(e, t) {
	this._pairs = [], e && vr(e, this, t);
}
var xr = br.prototype;
xr.append = function(e, t) {
	this._pairs.push([e, t]);
}, xr.toString = function(e) {
	let t = e ? function(t) {
		return e.call(this, t, yr);
	} : yr;
	return this._pairs.map(function(e) {
		return t(e[0]) + "=" + t(e[1]);
	}, "").join("&");
};
//#endregion
//#region ../../../node_modules/axios/lib/helpers/buildURL.js
function Sr(e) {
	return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Cr(e, t, n) {
	if (!t) return e;
	let r = J.isFunction(n) ? { serialize: n } : n, i = J.getSafeProp(r, "encode") || Sr, a = J.getSafeProp(r, "serialize"), o;
	if (o = a ? a(t, r) : J.isURLSearchParams(t) ? t.toString() : new br(t, r).toString(i), o) {
		let t = e.indexOf("#");
		t !== -1 && (e = e.slice(0, t)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
	}
	return e;
}
//#endregion
//#region ../../../node_modules/axios/lib/core/InterceptorManager.js
var wr = class {
	constructor() {
		this.handlers = [];
	}
	use(e, t, n) {
		return this.handlers.push({
			fulfilled: e,
			rejected: t,
			synchronous: n ? n.synchronous : !1,
			runWhen: n ? n.runWhen : null
		}), this.handlers.length - 1;
	}
	eject(e) {
		this.handlers[e] && (this.handlers[e] = null);
	}
	clear() {
		this.handlers &&= [];
	}
	forEach(e) {
		J.forEach(this.handlers, function(t) {
			t !== null && e(t);
		});
	}
}, Tr = {
	silentJSONParsing: !0,
	forcedJSONParsing: !0,
	clarifyTimeoutError: !1,
	legacyInterceptorReqResOrdering: !0,
	advertiseZstdAcceptEncoding: !1,
	validateStatusUndefinedResolves: !0
}, Er = {
	isBrowser: !0,
	classes: {
		URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : br,
		FormData: typeof FormData < "u" ? FormData : null,
		Blob: typeof Blob < "u" ? Blob : null
	},
	protocols: [
		"http",
		"https",
		"file",
		"blob",
		"url",
		"data"
	]
}, Dr = /* @__PURE__ */ Et({
	hasBrowserEnv: () => Or,
	hasStandardBrowserEnv: () => Ar,
	hasStandardBrowserWebWorkerEnv: () => jr,
	navigator: () => kr,
	origin: () => Mr
}), Or = typeof window < "u" && typeof document < "u", kr = typeof navigator == "object" && navigator || void 0, Ar = Or && (!kr || [
	"ReactNative",
	"NativeScript",
	"NS"
].indexOf(kr.product) < 0), jr = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Mr = Or && window.location.href || "http://localhost", Nr = {
	...Dr,
	...Er
};
//#endregion
//#region ../../../node_modules/axios/lib/helpers/toURLEncodedForm.js
function Pr(e, t) {
	return vr(e, new Nr.classes.URLSearchParams(), {
		visitor: function(e, t, n, r) {
			return Nr.isNode && J.isBuffer(e) ? (this.append(t, e.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
		},
		...t
	});
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/formDataToJSON.js
var Fr = 100;
function Ir(e) {
	if (e > Fr) throw new Y("FormData field is too deeply nested (" + e + " levels). Max depth: " + Fr, Y.ERR_FORM_DATA_DEPTH_EXCEEDED);
}
function Lr(e) {
	let t = [], n = /\w+|\[(\w*)]/g, r;
	for (; (r = n.exec(e)) !== null;) Ir(t.length), t.push(r[0] === "[]" ? "" : r[1] || r[0]);
	return t;
}
function Rr(e) {
	let t = {}, n = Object.keys(e), r, i = n.length, a;
	for (r = 0; r < i; r++) a = n[r], t[a] = e[a];
	return t;
}
function zr(e) {
	function t(e, n, r, i) {
		Ir(i);
		let a = e[i++];
		if (a === "__proto__") return !0;
		let o = Number.isFinite(+a), s = i >= e.length;
		return a = !a && J.isArray(r) ? r.length : a, s ? (J.hasOwnProp(r, a) ? r[a] = J.isArray(r[a]) ? r[a].concat(n) : [r[a], n] : r[a] = n, !o) : ((!J.hasOwnProp(r, a) || !J.isObject(r[a])) && (r[a] = []), t(e, n, r[a], i) && J.isArray(r[a]) && (r[a] = Rr(r[a])), !o);
	}
	if (J.isFormData(e) && J.isFunction(e.entries)) {
		let n = {};
		return J.forEachEntry(e, (e, r) => {
			t(Lr(e), r, n, 0);
		}), n;
	}
	return null;
}
//#endregion
//#region ../../../node_modules/axios/lib/defaults/index.js
var Br = (e, t) => e != null && J.hasOwnProp(e, t) ? e[t] : void 0;
function Vr(e, t, n) {
	if (J.isString(e)) try {
		return (t || JSON.parse)(e), J.trim(e);
	} catch (e) {
		if (e.name !== "SyntaxError") throw e;
	}
	return (n || JSON.stringify)(e);
}
var Hr = {
	transitional: Tr,
	adapter: [
		"xhr",
		"http",
		"fetch"
	],
	transformRequest: [function(e, t) {
		let n = t.getContentType() || "", r = n.indexOf("application/json") > -1, i = J.isObject(e);
		if (i && J.isHTMLForm(e) && (e = new FormData(e)), J.isFormData(e)) return r ? JSON.stringify(zr(e)) : e;
		if (J.isArrayBuffer(e) || J.isBuffer(e) || J.isStream(e) || J.isFile(e) || J.isBlob(e) || J.isReadableStream(e)) return e;
		if (J.isArrayBufferView(e)) return e.buffer;
		if (J.isURLSearchParams(e)) return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
		let a;
		if (i) {
			let t = Br(this, "formSerializer");
			if (n.indexOf("application/x-www-form-urlencoded") > -1) return Pr(e, t).toString();
			if ((a = J.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
				let n = Br(this, "env"), r = n && n.FormData;
				return vr(a ? { "files[]": e } : e, r && new r(), t);
			}
		}
		return i || r ? (t.setContentType("application/json", !1), Vr(e)) : e;
	}],
	transformResponse: [function(e) {
		let t = Br(this, "transitional") || Hr.transitional, n = t && t.forcedJSONParsing, r = Br(this, "responseType"), i = r === "json";
		if (J.isResponse(e) || J.isReadableStream(e)) return e;
		if (e && J.isString(e) && (n && !r || i)) {
			let n = !(t && t.silentJSONParsing) && i;
			try {
				return JSON.parse(e, Br(this, "parseReviver"));
			} catch (e) {
				if (n) throw e.name === "SyntaxError" ? Y.from(e, Y.ERR_BAD_RESPONSE, this, null, Br(this, "response")) : e;
			}
		}
		return e;
	}],
	timeout: 0,
	xsrfCookieName: "XSRF-TOKEN",
	xsrfHeaderName: "X-XSRF-TOKEN",
	maxContentLength: -1,
	maxBodyLength: -1,
	env: {
		FormData: Nr.classes.FormData,
		Blob: Nr.classes.Blob
	},
	validateStatus: function(e) {
		return e >= 200 && e < 300;
	},
	headers: { common: {
		Accept: "application/json, text/plain, */*",
		"Content-Type": void 0
	} }
};
J.forEach([
	"delete",
	"get",
	"head",
	"post",
	"put",
	"patch",
	"query"
], (e) => {
	Hr.headers[e] = {};
});
//#endregion
//#region ../../../node_modules/axios/lib/core/transformData.js
function Ur(e, t) {
	let n = this || Hr, r = t || n, i = lr.from(r.headers), a = r.data;
	return J.forEach(e, function(e) {
		a = e.call(n, a, i.normalize(), t ? t.status : void 0);
	}), i.normalize(), a;
}
//#endregion
//#region ../../../node_modules/axios/lib/cancel/isCancel.js
function Wr(e) {
	return !!(e && e.__CANCEL__);
}
//#endregion
//#region ../../../node_modules/axios/lib/cancel/CanceledError.js
var Gr = class extends Y {
	constructor(e, t, n) {
		super(e ?? "canceled", Y.ERR_CANCELED, t, n), this.name = "CanceledError", this.__CANCEL__ = !0;
	}
};
//#endregion
//#region ../../../node_modules/axios/lib/core/settle.js
function Kr(e, t, n) {
	let r = n.config.validateStatus;
	!n.status || !r || r(n.status) ? e(n) : t(new Y("Request failed with status code " + n.status, n.status >= 400 && n.status < 500 ? Y.ERR_BAD_REQUEST : Y.ERR_BAD_RESPONSE, n.config, n.request, n));
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/parseProtocol.js
function qr(e) {
	let t = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
	return t && t[1] || "";
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/speedometer.js
function Jr(e, t) {
	e ||= 10;
	let n = Array(e), r = Array(e), i = 0, a = 0, o;
	return t = t === void 0 ? 1e3 : t, function(s) {
		let c = Date.now(), l = r[a];
		o ||= c, n[i] = s, r[i] = c;
		let u = a, d = 0;
		for (; u !== i;) d += n[u++], u %= e;
		if (i = (i + 1) % e, i === a && (a = (a + 1) % e), c - o < t) return;
		let f = l && c - l;
		return f ? Math.round(d * 1e3 / f) : void 0;
	};
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/throttle.js
function Yr(e, t) {
	let n = 0, r = 1e3 / t, i, a, o = (t, r = Date.now()) => {
		n = r, i = null, a &&= (clearTimeout(a), null), e(...t);
	};
	return [(...e) => {
		let t = Date.now(), s = t - n;
		s >= r ? o(e, t) : (i = e, a ||= setTimeout(() => {
			a = null, o(i);
		}, r - s));
	}, () => i && o(i)];
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/progressEventReducer.js
var Xr = (e, t, n = 3) => {
	let r = 0, i = Jr(50, 250);
	return Yr((n) => {
		if (!n || typeof n.loaded != "number") return;
		let a = n.loaded, o = n.lengthComputable ? n.total : void 0, s = o == null ? a : Math.min(a, o), c = Math.max(0, s - r), l = i(c);
		r = Math.max(r, s), e({
			loaded: s,
			total: o,
			progress: o ? s / o : void 0,
			bytes: c,
			rate: l || void 0,
			estimated: l && o ? (o - s) / l : void 0,
			event: n,
			lengthComputable: o != null,
			[t ? "download" : "upload"]: !0
		});
	}, n);
}, Zr = (e, t) => {
	let n = e != null;
	return [(r) => t[0]({
		lengthComputable: n,
		total: e,
		loaded: r
	}), t[1]];
}, Qr = (e) => (...t) => J.asap(() => e(...t)), $r = Nr.hasStandardBrowserEnv ? ((e, t) => (n) => (n = new URL(n, Nr.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(new URL(Nr.origin), Nr.navigator && /(msie|trident)/i.test(Nr.navigator.userAgent)) : () => !0, ei = Nr.hasStandardBrowserEnv ? {
	write(e, t, n, r, i, a, o) {
		if (typeof document > "u") return;
		let s = [`${e}=${encodeURIComponent(t)}`];
		J.isNumber(n) && s.push(`expires=${new Date(n).toUTCString()}`), J.isString(r) && s.push(`path=${r}`), J.isString(i) && s.push(`domain=${i}`), a === !0 && s.push("secure"), J.isString(o) && s.push(`SameSite=${o}`), document.cookie = s.join("; ");
	},
	read(e) {
		if (typeof document > "u") return null;
		let t = document.cookie.split(";");
		for (let n = 0; n < t.length; n++) {
			let r = t[n].replace(/^\s+/, ""), i = r.indexOf("=");
			if (i !== -1 && r.slice(0, i) === e) return decodeURIComponent(r.slice(i + 1));
		}
		return null;
	},
	remove(e) {
		this.write(e, "", Date.now() - 864e5, "/");
	}
} : {
	write() {},
	read() {
		return null;
	},
	remove() {}
};
//#endregion
//#region ../../../node_modules/axios/lib/helpers/isAbsoluteURL.js
function ti(e) {
	return typeof e == "string" && /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/combineURLs.js
function ni(e, t) {
	return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
//#endregion
//#region ../../../node_modules/axios/lib/core/buildFullPath.js
var ri = /^https?:(?!\/\/)/i, ii = /[\t\n\r]/g;
function ai(e) {
	let t = 0;
	for (; t < e.length && e.charCodeAt(t) <= 32;) t++;
	return e.slice(t);
}
function oi(e) {
	return ai(e).replace(ii, "");
}
function si(e, t) {
	if (typeof e == "string" && ri.test(oi(e))) throw new Y("Invalid URL: missing \"//\" after protocol", Y.ERR_INVALID_URL, t);
}
function ci(e, t, n, r) {
	si(t, r);
	let i = !ti(t);
	return e && (i || n === !1) ? (si(e, r), ni(e, t)) : t;
}
//#endregion
//#region ../../../node_modules/axios/lib/core/mergeConfig.js
var li = (e) => e instanceof lr ? { ...e } : e;
function ui(e, t) {
	t ||= {};
	let n = Object.create(null);
	Object.defineProperty(n, "hasOwnProperty", {
		__proto__: null,
		value: Object.prototype.hasOwnProperty,
		enumerable: !1,
		writable: !0,
		configurable: !0
	});
	function r(e, t, n, r) {
		return J.isPlainObject(e) && J.isPlainObject(t) ? J.merge.call({ caseless: r }, e, t) : J.isPlainObject(t) ? J.merge({}, t) : J.isArray(t) ? t.slice() : t;
	}
	function i(e, t, n, i) {
		if (!J.isUndefined(t)) return r(e, t, n, i);
		if (!J.isUndefined(e)) return r(void 0, e, n, i);
	}
	function a(e, t) {
		if (!J.isUndefined(t)) return r(void 0, t);
	}
	function o(e, t) {
		if (!J.isUndefined(t)) return r(void 0, t);
		if (!J.isUndefined(e)) return r(void 0, e);
	}
	function s(n) {
		let r = J.hasOwnProp(t, "transitional") ? t.transitional : void 0;
		if (!J.isUndefined(r)) if (J.isPlainObject(r)) {
			if (J.hasOwnProp(r, n)) return r[n];
		} else return;
		let i = J.hasOwnProp(e, "transitional") ? e.transitional : void 0;
		if (J.isPlainObject(i) && J.hasOwnProp(i, n)) return i[n];
	}
	function c(n, i, a) {
		if (J.hasOwnProp(t, a)) return r(n, i);
		if (J.hasOwnProp(e, a)) return r(void 0, n);
	}
	let l = {
		url: a,
		method: a,
		data: a,
		baseURL: o,
		transformRequest: o,
		transformResponse: o,
		paramsSerializer: o,
		timeout: o,
		timeoutMessage: o,
		withCredentials: o,
		withXSRFToken: o,
		adapter: o,
		responseType: o,
		xsrfCookieName: o,
		xsrfHeaderName: o,
		onUploadProgress: o,
		onDownloadProgress: o,
		decompress: o,
		maxContentLength: o,
		maxBodyLength: o,
		beforeRedirect: o,
		transport: o,
		httpAgent: o,
		httpsAgent: o,
		cancelToken: o,
		socketPath: o,
		allowedSocketPaths: o,
		responseEncoding: o,
		validateStatus: c,
		headers: (e, t, n) => i(li(e), li(t), n, !0)
	};
	return J.forEach(Object.keys({
		...e,
		...t
	}), function(r) {
		if (r === "__proto__" || r === "constructor" || r === "prototype") return;
		let a = J.hasOwnProp(l, r) ? l[r] : i, o = a(J.hasOwnProp(e, r) ? e[r] : void 0, J.hasOwnProp(t, r) ? t[r] : void 0, r);
		J.isUndefined(o) && a !== c || (n[r] = o);
	}), J.hasOwnProp(t, "validateStatus") && J.isUndefined(t.validateStatus) && s("validateStatusUndefinedResolves") === !1 && (J.hasOwnProp(e, "validateStatus") ? n.validateStatus = r(void 0, e.validateStatus) : delete n.validateStatus), n;
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/resolveConfig.js
var di = ["content-type", "content-length"];
function fi(e, t, n) {
	if (n !== "content-only") {
		e.set(t);
		return;
	}
	Object.entries(t).forEach(([t, n]) => {
		di.includes(t.toLowerCase()) && e.set(t, n);
	});
}
var pi = (e) => encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) => String.fromCharCode(parseInt(t, 16)));
function mi(e) {
	let t = ui({}, e), n = (e) => J.hasOwnProp(t, e) ? t[e] : void 0, r = n("data"), i = n("withXSRFToken"), a = n("xsrfHeaderName"), o = n("xsrfCookieName"), s = n("headers"), c = n("auth"), l = n("baseURL"), u = n("allowAbsoluteUrls"), d = n("url");
	if (t.headers = s = lr.from(s), t.url = Cr(ci(l, d, u, t), n("params"), n("paramsSerializer")), c) {
		let e = J.getSafeProp(c, "username") || "", t = J.getSafeProp(c, "password") || "";
		s.set("Authorization", "Basic " + btoa(e + ":" + (t ? pi(t) : "")));
	}
	if (J.isFormData(r) && (Nr.hasStandardBrowserEnv || Nr.hasStandardBrowserWebWorkerEnv || J.isReactNative(r) ? s.setContentType(void 0) : J.isFunction(r.getHeaders) && fi(s, r.getHeaders(), n("formDataHeaderPolicy"))), Nr.hasStandardBrowserEnv && (J.isFunction(i) && (i = i(t)), i === !0 || i == null && $r(t.url))) {
		let e = a && o && ei.read(o);
		e && s.set(a, e);
	}
	return t;
}
var hi = typeof XMLHttpRequest < "u" && function(e) {
	return new Promise(function(t, n) {
		let r = mi(e), i = r.data, a = lr.from(r.headers).normalize(), { responseType: o, onUploadProgress: s, onDownloadProgress: c } = r, l, u, d, f, p;
		function m() {
			f && f(), p && p(), r.cancelToken && r.cancelToken.unsubscribe(l), r.signal && r.signal.removeEventListener("abort", l);
		}
		let h = new XMLHttpRequest();
		h.open(r.method.toUpperCase(), r.url, !0), h.timeout = r.timeout;
		function g() {
			if (!h) return;
			let r = lr.from("getAllResponseHeaders" in h && h.getAllResponseHeaders());
			Kr(function(e) {
				t(e), m();
			}, function(e) {
				n(e), m();
			}, {
				data: !o || o === "text" || o === "json" ? h.responseText : h.response,
				status: h.status,
				statusText: h.statusText,
				headers: r,
				config: e,
				request: h
			}), h = null;
		}
		"onloadend" in h ? h.onloadend = g : h.onreadystatechange = function() {
			!h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.startsWith("file:")) || setTimeout(g);
		}, h.onabort = function() {
			h &&= (n(new Y("Request aborted", Y.ECONNABORTED, e, h)), m(), null);
		}, h.onerror = function(t) {
			let r = new Y(t && t.message ? t.message : "Network Error", Y.ERR_NETWORK, e, h);
			r.event = t || null, n(r), m(), h = null;
		}, h.ontimeout = function() {
			let t = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded", i = r.transitional || Tr;
			r.timeoutErrorMessage && (t = r.timeoutErrorMessage), n(new Y(t, i.clarifyTimeoutError ? Y.ETIMEDOUT : Y.ECONNABORTED, e, h)), m(), h = null;
		}, i === void 0 && a.setContentType(null), "setRequestHeader" in h && J.forEach(er(a), function(e, t) {
			h.setRequestHeader(t, e);
		}), J.isUndefined(r.withCredentials) || (h.withCredentials = !!r.withCredentials), o && o !== "json" && (h.responseType = r.responseType), c && ([d, p] = Xr(c, !0), h.addEventListener("progress", d)), s && h.upload && ([u, f] = Xr(s), h.upload.addEventListener("progress", u), h.upload.addEventListener("loadend", f)), (r.cancelToken || r.signal) && (l = (t) => {
			h &&= (n(!t || t.type ? new Gr(null, e, h) : t), h.abort(), m(), null);
		}, r.cancelToken && r.cancelToken.subscribe(l), r.signal && (r.signal.aborted ? l() : r.signal.addEventListener("abort", l)));
		let _ = qr(r.url);
		if (_ && !Nr.protocols.includes(_)) {
			n(new Y("Unsupported protocol " + _ + ":", Y.ERR_BAD_REQUEST, e));
			return;
		}
		h.send(i || null);
	});
}, gi = (e, t) => {
	if (e = e ? e.filter(Boolean) : [], !t && !e.length) return;
	let n = new AbortController(), r = !1, i = function(e) {
		if (!r) {
			r = !0, o();
			let t = e instanceof Error ? e : this.reason;
			n.abort(t instanceof Y ? t : new Gr(t instanceof Error ? t.message : t));
		}
	}, a = t && setTimeout(() => {
		a = null, i(new Y(`timeout of ${t}ms exceeded`, Y.ETIMEDOUT));
	}, t), o = () => {
		e &&= (a && clearTimeout(a), a = null, e.forEach((e) => {
			e.unsubscribe ? e.unsubscribe(i) : e.removeEventListener("abort", i);
		}), null);
	};
	e.forEach((e) => e.addEventListener("abort", i));
	let { signal: s } = n;
	return s.unsubscribe = () => J.asap(o), s;
}, _i = function* (e, t) {
	let n = e.byteLength;
	if (!t || n < t) {
		yield e;
		return;
	}
	let r = 0, i;
	for (; r < n;) i = r + t, yield e.slice(r, i), r = i;
}, vi = async function* (e, t) {
	for await (let n of yi(e)) yield* _i(n, t);
}, yi = async function* (e) {
	if (e[Symbol.asyncIterator]) {
		yield* e;
		return;
	}
	let t = e.getReader();
	try {
		for (;;) {
			let { done: e, value: n } = await t.read();
			if (e) break;
			yield n;
		}
	} finally {
		await t.cancel();
	}
}, bi = (e, t, n, r) => {
	let i = vi(e, t), a = 0, o, s = (e) => {
		o || (o = !0, r && r(e));
	};
	return new ReadableStream({
		async pull(e) {
			try {
				let { done: t, value: r } = await i.next();
				if (t) {
					s(), e.close();
					return;
				}
				let o = r.byteLength;
				n && n(a += o), e.enqueue(new Uint8Array(r));
			} catch (e) {
				throw s(e), e;
			}
		},
		cancel(e) {
			return s(e), i.return();
		}
	}, { highWaterMark: 2 });
}, xi = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, Si = (e, t, n) => t + 2 < n && xi(e.charCodeAt(t + 1)) && xi(e.charCodeAt(t + 2));
function Ci(e) {
	if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
	let t = e.indexOf(",");
	if (t < 0) return 0;
	let n = e.slice(5, t), r = e.slice(t + 1);
	if (/;base64/i.test(n)) {
		let e = r.length, t = r.length;
		for (let n = 0; n < t; n++) if (r.charCodeAt(n) === 37 && n + 2 < t) {
			let t = r.charCodeAt(n + 1), i = r.charCodeAt(n + 2);
			xi(t) && xi(i) && (e -= 2, n += 2);
		}
		let n = 0, i = t - 1, a = (e) => e >= 2 && r.charCodeAt(e - 2) === 37 && r.charCodeAt(e - 1) === 51 && (r.charCodeAt(e) === 68 || r.charCodeAt(e) === 100);
		i >= 0 && (r.charCodeAt(i) === 61 ? (n++, i--) : a(i) && (n++, i -= 3)), n === 1 && i >= 0 && (r.charCodeAt(i) === 61 || a(i)) && n++;
		let o = Math.floor(e / 4) * 3 - (n || 0);
		return o > 0 ? o : 0;
	}
	let i = 0;
	for (let e = 0, t = r.length; e < t; e++) {
		let n = r.charCodeAt(e);
		if (n === 37 && Si(r, e, t)) i += 1, e += 2;
		else if (n < 128) i += 1;
		else if (n < 2048) i += 2;
		else if (n >= 55296 && n <= 56319 && e + 1 < t) {
			let t = r.charCodeAt(e + 1);
			t >= 56320 && t <= 57343 ? (i += 4, e++) : i += 3;
		} else i += 3;
	}
	return i;
}
//#endregion
//#region ../../../node_modules/axios/lib/env/data.js
var wi = "1.18.0", Ti = 64 * 1024, { isFunction: Ei } = J, Di = (e) => encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) => String.fromCharCode(parseInt(t, 16))), Oi = (e) => {
	if (!J.isString(e)) return e;
	try {
		return decodeURIComponent(e);
	} catch {
		return e;
	}
}, ki = (e, ...t) => {
	try {
		return !!e(...t);
	} catch {
		return !1;
	}
}, Ai = (e) => {
	let t = e.indexOf("://"), n = e;
	return t !== -1 && (n = n.slice(t + 3)), n.includes("@") || n.includes(":");
}, ji = (e) => {
	let t = J.global !== void 0 && J.global !== null ? J.global : globalThis, { ReadableStream: n, TextEncoder: r } = t;
	e = J.merge.call({ skipUndefined: !0 }, {
		Request: t.Request,
		Response: t.Response
	}, e);
	let { fetch: i, Request: a, Response: o } = e, s = i ? Ei(i) : typeof fetch == "function", c = Ei(a), l = Ei(o);
	if (!s) return !1;
	let u = s && Ei(n), d = s && (typeof r == "function" ? ((e) => (t) => e.encode(t))(new r()) : async (e) => new Uint8Array(await new a(e).arrayBuffer())), f = c && u && ki(() => {
		let e = !1, t = new a(Nr.origin, {
			body: new n(),
			method: "POST",
			get duplex() {
				return e = !0, "half";
			}
		}), r = t.headers.has("Content-Type");
		return t.body != null && t.body.cancel(), e && !r;
	}), p = l && u && ki(() => J.isReadableStream(new o("").body)), m = { stream: p && ((e) => e.body) };
	s && [
		"text",
		"arrayBuffer",
		"blob",
		"formData",
		"stream"
	].forEach((e) => {
		!m[e] && (m[e] = (t, n) => {
			let r = t && t[e];
			if (r) return r.call(t);
			throw new Y(`Response type '${e}' is not supported`, Y.ERR_NOT_SUPPORT, n);
		});
	});
	let h = async (e) => {
		if (e == null) return 0;
		if (J.isBlob(e)) return e.size;
		if (J.isSpecCompliantForm(e)) return (await new a(Nr.origin, {
			method: "POST",
			body: e
		}).arrayBuffer()).byteLength;
		if (J.isArrayBufferView(e) || J.isArrayBuffer(e)) return e.byteLength;
		if (J.isURLSearchParams(e) && (e += ""), J.isString(e)) return (await d(e)).byteLength;
	}, g = async (e, t) => J.toFiniteNumber(e.getContentLength()) ?? h(t);
	return async (e) => {
		let { url: t, method: n, data: s, signal: l, cancelToken: d, timeout: _, onDownloadProgress: v, onUploadProgress: y, responseType: b, headers: x, withCredentials: S = "same-origin", fetchOptions: C, maxContentLength: w, maxBodyLength: T } = mi(e), E = J.isNumber(w) && w > -1, D = J.isNumber(T) && T > -1, O = (t) => J.hasOwnProp(e, t) ? e[t] : void 0, k = i || fetch;
		b = b ? (b + "").toLowerCase() : "text";
		let A = gi([l, d && d.toAbortSignal()], _), j = null, M = A && A.unsubscribe && (() => {
			A.unsubscribe();
		}), N, P = null, F = () => new Y("Request body larger than maxBodyLength limit", Y.ERR_BAD_REQUEST, e, j);
		try {
			let i, l = O("auth");
			if (l && (i = {
				username: J.getSafeProp(l, "username") || "",
				password: J.getSafeProp(l, "password") || ""
			}), Ai(t)) {
				let e = new URL(t, Nr.origin);
				!i && (e.username || e.password) && (i = {
					username: Oi(e.username),
					password: Oi(e.password)
				}), (e.username || e.password) && (e.username = "", e.password = "", t = e.href);
			}
			if (i && (x.delete("authorization"), x.set("Authorization", "Basic " + btoa(Di((i.username || "") + ":" + (i.password || ""))))), E && typeof t == "string" && t.startsWith("data:") && Ci(t) > w) throw new Y("maxContentLength size of " + w + " exceeded", Y.ERR_BAD_RESPONSE, e, j);
			if (D && n !== "get" && n !== "head") {
				let e = await h(s);
				if (typeof e == "number" && isFinite(e) && (N = e, e > T)) throw F();
			}
			let d = D && (J.isReadableStream(s) || J.isStream(s)), _ = (e, t, n) => bi(e, Ti, (e) => {
				if (D && e > T) throw P = F();
				t && t(e);
			}, n);
			if (f && n !== "get" && n !== "head" && (y || d)) {
				if (N ??= await g(x, s), N !== 0 || d) {
					let e = new a(t, {
						method: "POST",
						body: s,
						duplex: "half"
					}), n;
					if (J.isFormData(s) && (n = e.headers.get("content-type")) && x.setContentType(n), e.body) {
						let [t, n] = y && Zr(N, Xr(Qr(y))) || [];
						s = _(e.body, t, n);
					}
				}
			} else if (d && !c && u && n !== "get" && n !== "head") s = _(s);
			else if (d && c && !f && n !== "get" && n !== "head") throw new Y("Stream request bodies are not supported by the current fetch implementation", Y.ERR_NOT_SUPPORT, e, j);
			J.isString(S) || (S = S ? "include" : "omit");
			let I = c && "credentials" in a.prototype;
			if (J.isFormData(s)) {
				let e = x.getContentType();
				e && /^multipart\/form-data/i.test(e) && !/boundary=/i.test(e) && x.delete("content-type");
			}
			x.set("User-Agent", "axios/" + wi, !1);
			let ee = {
				...C,
				signal: A,
				method: n.toUpperCase(),
				headers: er(x.normalize()),
				body: s,
				duplex: "half",
				credentials: I ? S : void 0
			};
			j = c && new a(t, ee);
			let L = await (c ? k(j, C) : k(t, ee)), te = lr.from(L.headers);
			if (E) {
				let t = J.toFiniteNumber(te.getContentLength());
				if (t != null && t > w) throw new Y("maxContentLength size of " + w + " exceeded", Y.ERR_BAD_RESPONSE, e, j);
			}
			let ne = p && (b === "stream" || b === "response");
			if (p && L.body && (v || E || ne && M)) {
				let t = {};
				[
					"status",
					"statusText",
					"headers"
				].forEach((e) => {
					t[e] = L[e];
				});
				let n = J.toFiniteNumber(te.getContentLength()), [r, i] = v && Zr(n, Xr(Qr(v), !0)) || [], a = 0;
				L = new o(bi(L.body, Ti, (t) => {
					if (E && (a = t, a > w)) throw new Y("maxContentLength size of " + w + " exceeded", Y.ERR_BAD_RESPONSE, e, j);
					r && r(t);
				}, () => {
					i && i(), M && M();
				}), t);
			}
			b ||= "text";
			let re = await m[J.findKey(m, b) || "text"](L, e);
			if (E && !p && !ne) {
				let t;
				if (re != null && (typeof re.byteLength == "number" ? t = re.byteLength : typeof re.size == "number" ? t = re.size : typeof re == "string" && (t = typeof r == "function" ? new r().encode(re).byteLength : re.length)), typeof t == "number" && t > w) throw new Y("maxContentLength size of " + w + " exceeded", Y.ERR_BAD_RESPONSE, e, j);
			}
			return !ne && M && M(), await new Promise((t, n) => {
				Kr(t, n, {
					data: re,
					headers: lr.from(L.headers),
					status: L.status,
					statusText: L.statusText,
					config: e,
					request: j
				});
			});
		} catch (t) {
			if (M && M(), A && A.aborted && A.reason instanceof Y) {
				let n = A.reason;
				throw n.config = e, j && (n.request = j), t !== n && (n.cause = t), n;
			}
			throw P ? (j && !P.request && (P.request = j), P) : t instanceof Y ? (j && !t.request && (t.request = j), t) : t && t.name === "TypeError" && /Load failed|fetch/i.test(t.message) ? Object.assign(new Y("Network Error", Y.ERR_NETWORK, e, j, t && t.response), { cause: t.cause || t }) : Y.from(t, t && t.code, e, j, t && t.response);
		}
	};
}, Mi = /* @__PURE__ */ new Map(), Ni = (e) => {
	let t = e && e.env || {}, { fetch: n, Request: r, Response: i } = t, a = [
		r,
		i,
		n
	], o = a.length, s, c, l = Mi;
	for (; o--;) s = a[o], c = l.get(s), c === void 0 && l.set(s, c = o ? /* @__PURE__ */ new Map() : ji(t)), l = c;
	return c;
};
Ni();
//#endregion
//#region ../../../node_modules/axios/lib/adapters/adapters.js
var Pi = {
	http: null,
	xhr: hi,
	fetch: { get: Ni }
};
J.forEach(Pi, (e, t) => {
	if (e) {
		try {
			Object.defineProperty(e, "name", {
				__proto__: null,
				value: t
			});
		} catch {}
		Object.defineProperty(e, "adapterName", {
			__proto__: null,
			value: t
		});
	}
});
var Fi = (e) => `- ${e}`, Ii = (e) => J.isFunction(e) || e === null || e === !1;
function Li(e, t) {
	e = J.isArray(e) ? e : [e];
	let { length: n } = e, r, i, a = {};
	for (let o = 0; o < n; o++) {
		r = e[o];
		let n;
		if (i = r, !Ii(r) && (i = Pi[(n = String(r)).toLowerCase()], i === void 0)) throw new Y(`Unknown adapter '${n}'`);
		if (i && (J.isFunction(i) || (i = i.get(t)))) break;
		a[n || "#" + o] = i;
	}
	if (!i) {
		let e = Object.entries(a).map(([e, t]) => `adapter ${e} ` + (t === !1 ? "is not supported by the environment" : "is not available in the build"));
		throw new Y("There is no suitable adapter to dispatch the request " + (n ? e.length > 1 ? "since :\n" + e.map(Fi).join("\n") : " " + Fi(e[0]) : "as no adapter specified"), "ERR_NOT_SUPPORT");
	}
	return i;
}
var Ri = {
	getAdapter: Li,
	adapters: Pi
};
//#endregion
//#region ../../../node_modules/axios/lib/core/dispatchRequest.js
function zi(e) {
	if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new Gr(null, e);
}
function Bi(e) {
	return zi(e), e.headers = lr.from(e.headers), e.data = Ur.call(e, e.transformRequest), [
		"post",
		"put",
		"patch"
	].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Ri.getAdapter(e.adapter || Hr.adapter, e)(e).then(function(t) {
		zi(e), e.response = t;
		try {
			t.data = Ur.call(e, e.transformResponse, t);
		} finally {
			delete e.response;
		}
		return t.headers = lr.from(t.headers), t;
	}, function(t) {
		if (!Wr(t) && (zi(e), t && t.response)) {
			e.response = t.response;
			try {
				t.response.data = Ur.call(e, e.transformResponse, t.response);
			} finally {
				delete e.response;
			}
			t.response.headers = lr.from(t.response.headers);
		}
		return Promise.reject(t);
	});
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/validator.js
var Vi = {};
[
	"object",
	"boolean",
	"number",
	"function",
	"string",
	"symbol"
].forEach((e, t) => {
	Vi[e] = function(n) {
		return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
	};
});
var Hi = {};
Vi.transitional = function(e, t, n) {
	function r(e, t) {
		return "[Axios v" + wi + "] Transitional option '" + e + "'" + t + (n ? ". " + n : "");
	}
	return (n, i, a) => {
		if (e === !1) throw new Y(r(i, " has been removed" + (t ? " in " + t : "")), Y.ERR_DEPRECATED);
		return t && !Hi[i] && (Hi[i] = !0, console.warn(r(i, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(n, i, a);
	};
}, Vi.spelling = function(e) {
	return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function Ui(e, t, n) {
	if (typeof e != "object") throw new Y("options must be an object", Y.ERR_BAD_OPTION_VALUE);
	let r = Object.keys(e), i = r.length;
	for (; i-- > 0;) {
		let a = r[i], o = Object.prototype.hasOwnProperty.call(t, a) ? t[a] : void 0;
		if (o) {
			let t = e[a], n = t === void 0 || o(t, a, e);
			if (n !== !0) throw new Y("option " + a + " must be " + n, Y.ERR_BAD_OPTION_VALUE);
			continue;
		}
		if (n !== !0) throw new Y("Unknown option " + a, Y.ERR_BAD_OPTION);
	}
}
var Wi = {
	assertOptions: Ui,
	validators: Vi
}, Gi = Wi.validators, Ki = class {
	constructor(e) {
		this.defaults = e || {}, this.interceptors = {
			request: new wr(),
			response: new wr()
		};
	}
	async request(e, t) {
		try {
			return await this._request(e, t);
		} catch (e) {
			if (e instanceof Error) {
				let t = {};
				Error.captureStackTrace ? Error.captureStackTrace(t) : t = /* @__PURE__ */ Error();
				let n = (() => {
					if (!t.stack) return "";
					let e = t.stack.indexOf("\n");
					return e === -1 ? "" : t.stack.slice(e + 1);
				})();
				try {
					if (!e.stack) e.stack = n;
					else if (n) {
						let t = n.indexOf("\n"), r = t === -1 ? -1 : n.indexOf("\n", t + 1), i = r === -1 ? "" : n.slice(r + 1);
						String(e.stack).endsWith(i) || (e.stack += "\n" + n);
					}
				} catch {}
			}
			throw e;
		}
	}
	_request(e, t) {
		typeof e == "string" ? (t ||= {}, t.url = e) : t = e || {}, t = ui(this.defaults, t);
		let { transitional: n, paramsSerializer: r, headers: i } = t;
		n !== void 0 && Wi.assertOptions(n, {
			silentJSONParsing: Gi.transitional(Gi.boolean),
			forcedJSONParsing: Gi.transitional(Gi.boolean),
			clarifyTimeoutError: Gi.transitional(Gi.boolean),
			legacyInterceptorReqResOrdering: Gi.transitional(Gi.boolean),
			advertiseZstdAcceptEncoding: Gi.transitional(Gi.boolean),
			validateStatusUndefinedResolves: Gi.transitional(Gi.boolean)
		}, !1), r != null && (J.isFunction(r) ? t.paramsSerializer = { serialize: r } : Wi.assertOptions(r, {
			encode: Gi.function,
			serialize: Gi.function
		}, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls === void 0 ? t.allowAbsoluteUrls = !0 : t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls), Wi.assertOptions(t, {
			baseUrl: Gi.spelling("baseURL"),
			withXsrfToken: Gi.spelling("withXSRFToken")
		}, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
		let a = i && J.merge(i.common, i[t.method]);
		i && J.forEach([
			"delete",
			"get",
			"head",
			"post",
			"put",
			"patch",
			"query",
			"common"
		], (e) => {
			delete i[e];
		}), t.headers = lr.concat(a, i);
		let o = [], s = !0;
		this.interceptors.request.forEach(function(e) {
			if (typeof e.runWhen == "function" && e.runWhen(t) === !1) return;
			s &&= e.synchronous;
			let n = t.transitional || Tr;
			n && n.legacyInterceptorReqResOrdering ? o.unshift(e.fulfilled, e.rejected) : o.push(e.fulfilled, e.rejected);
		});
		let c = [];
		this.interceptors.response.forEach(function(e) {
			c.push(e.fulfilled, e.rejected);
		});
		let l, u = 0, d;
		if (!s) {
			let e = [Bi.bind(this), void 0];
			for (e.unshift(...o), e.push(...c), d = e.length, l = Promise.resolve(t); u < d;) l = l.then(e[u++], e[u++]);
			return l;
		}
		d = o.length;
		let f = t;
		for (; u < d;) {
			let e = o[u++], t = o[u++];
			try {
				f = e(f);
			} catch (e) {
				t.call(this, e);
				break;
			}
		}
		try {
			l = Bi.call(this, f);
		} catch (e) {
			return Promise.reject(e);
		}
		for (u = 0, d = c.length; u < d;) l = l.then(c[u++], c[u++]);
		return l;
	}
	getUri(e) {
		return e = ui(this.defaults, e), Cr(ci(e.baseURL, e.url, e.allowAbsoluteUrls, e), e.params, e.paramsSerializer);
	}
};
J.forEach([
	"delete",
	"get",
	"head",
	"options"
], function(e) {
	Ki.prototype[e] = function(t, n) {
		return this.request(ui(n || {}, {
			method: e,
			url: t,
			data: n && J.hasOwnProp(n, "data") ? n.data : void 0
		}));
	};
}), J.forEach([
	"post",
	"put",
	"patch",
	"query"
], function(e) {
	function t(t) {
		return function(n, r, i) {
			return this.request(ui(i || {}, {
				method: e,
				headers: t ? { "Content-Type": "multipart/form-data" } : {},
				url: n,
				data: r
			}));
		};
	}
	Ki.prototype[e] = t(), e !== "query" && (Ki.prototype[e + "Form"] = t(!0));
});
//#endregion
//#region ../../../node_modules/axios/lib/cancel/CancelToken.js
var qi = class e {
	constructor(e) {
		if (typeof e != "function") throw TypeError("executor must be a function.");
		let t;
		this.promise = new Promise(function(e) {
			t = e;
		});
		let n = this;
		this.promise.then((e) => {
			if (!n._listeners) return;
			let t = n._listeners.length;
			for (; t-- > 0;) n._listeners[t](e);
			n._listeners = null;
		}), this.promise.then = (e) => {
			let t, r = new Promise((e) => {
				n.subscribe(e), t = e;
			}).then(e);
			return r.cancel = function() {
				n.unsubscribe(t);
			}, r;
		}, e(function(e, r, i) {
			n.reason || (n.reason = new Gr(e, r, i), t(n.reason));
		});
	}
	throwIfRequested() {
		if (this.reason) throw this.reason;
	}
	subscribe(e) {
		if (this.reason) {
			e(this.reason);
			return;
		}
		this._listeners ? this._listeners.push(e) : this._listeners = [e];
	}
	unsubscribe(e) {
		if (!this._listeners) return;
		let t = this._listeners.indexOf(e);
		t !== -1 && this._listeners.splice(t, 1);
	}
	toAbortSignal() {
		let e = new AbortController(), t = (t) => {
			e.abort(t);
		};
		return this.subscribe(t), e.signal.unsubscribe = () => this.unsubscribe(t), e.signal;
	}
	static source() {
		let t;
		return {
			token: new e(function(e) {
				t = e;
			}),
			cancel: t
		};
	}
};
//#endregion
//#region ../../../node_modules/axios/lib/helpers/spread.js
function Ji(e) {
	return function(t) {
		return e.apply(null, t);
	};
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/isAxiosError.js
function Yi(e) {
	return J.isObject(e) && e.isAxiosError === !0;
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/HttpStatusCode.js
var Xi = {
	Continue: 100,
	SwitchingProtocols: 101,
	Processing: 102,
	EarlyHints: 103,
	Ok: 200,
	Created: 201,
	Accepted: 202,
	NonAuthoritativeInformation: 203,
	NoContent: 204,
	ResetContent: 205,
	PartialContent: 206,
	MultiStatus: 207,
	AlreadyReported: 208,
	ImUsed: 226,
	MultipleChoices: 300,
	MovedPermanently: 301,
	Found: 302,
	SeeOther: 303,
	NotModified: 304,
	UseProxy: 305,
	Unused: 306,
	TemporaryRedirect: 307,
	PermanentRedirect: 308,
	BadRequest: 400,
	Unauthorized: 401,
	PaymentRequired: 402,
	Forbidden: 403,
	NotFound: 404,
	MethodNotAllowed: 405,
	NotAcceptable: 406,
	ProxyAuthenticationRequired: 407,
	RequestTimeout: 408,
	Conflict: 409,
	Gone: 410,
	LengthRequired: 411,
	PreconditionFailed: 412,
	PayloadTooLarge: 413,
	UriTooLong: 414,
	UnsupportedMediaType: 415,
	RangeNotSatisfiable: 416,
	ExpectationFailed: 417,
	ImATeapot: 418,
	MisdirectedRequest: 421,
	UnprocessableEntity: 422,
	Locked: 423,
	FailedDependency: 424,
	TooEarly: 425,
	UpgradeRequired: 426,
	PreconditionRequired: 428,
	TooManyRequests: 429,
	RequestHeaderFieldsTooLarge: 431,
	UnavailableForLegalReasons: 451,
	InternalServerError: 500,
	NotImplemented: 501,
	BadGateway: 502,
	ServiceUnavailable: 503,
	GatewayTimeout: 504,
	HttpVersionNotSupported: 505,
	VariantAlsoNegotiates: 506,
	InsufficientStorage: 507,
	LoopDetected: 508,
	NotExtended: 510,
	NetworkAuthenticationRequired: 511,
	WebServerIsDown: 521,
	ConnectionTimedOut: 522,
	OriginIsUnreachable: 523,
	TimeoutOccurred: 524,
	SslHandshakeFailed: 525,
	InvalidSslCertificate: 526
};
Object.entries(Xi).forEach(([e, t]) => {
	Xi[t] = e;
});
//#endregion
//#region ../../../node_modules/axios/lib/axios.js
function Zi(e) {
	let t = new Ki(e), n = kt(Ki.prototype.request, t);
	return J.extend(n, Ki.prototype, t, { allOwnKeys: !0 }), J.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(t) {
		return Zi(ui(e, t));
	}, n;
}
var Qi = Zi(Hr);
Qi.Axios = Ki, Qi.CanceledError = Gr, Qi.CancelToken = qi, Qi.isCancel = Wr, Qi.VERSION = wi, Qi.toFormData = vr, Qi.AxiosError = Y, Qi.Cancel = Qi.CanceledError, Qi.all = function(e) {
	return Promise.all(e);
}, Qi.spread = Ji, Qi.isAxiosError = Yi, Qi.mergeConfig = ui, Qi.AxiosHeaders = lr, Qi.formToJSON = (e) => zr(J.isHTMLForm(e) ? new FormData(e) : e), Qi.getAdapter = Ri.getAdapter, Qi.HttpStatusCode = Xi, Qi.default = Qi;
//#endregion
//#region ../../../node_modules/axios/index.js
var { Axios: $i, AxiosError: ea, CanceledError: ta, isCancel: na, CancelToken: ra, VERSION: ia, all: aa, Cancel: oa, isAxiosError: sa, spread: ca, toFormData: la, AxiosHeaders: ua, HttpStatusCode: da, formToJSON: fa, getAdapter: pa, mergeConfig: ma, create: ha } = Qi, ga = new class {
	isElectron() {
		return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
	}
	async getVersion() {
		return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
	}
	async isStandaloneBuild() {
		return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
	}
	async isMsiBuild() {
		return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
	}
}();
//#endregion
//#region ../../shared/semver/dist/index.es.js
function _a(e, t) {
	return va(e), va(t), e.localeCompare(t, void 0, { numeric: !0 });
}
function va(e) {
	if (e.split(".").length !== 3) throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/is.js
var ya = Object.prototype.toString;
function ba(e, t) {
	return ya.call(e) === `[object ${t}]`;
}
function xa(e) {
	return ba(e, "Object");
}
function Sa(e) {
	return !!(e && e.then && typeof e.then == "function");
}
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/version.js
var Ca = "8.36.0", wa = globalThis;
function Ta(e, t, n) {
	let r = n || wa, i = r.__SENTRY__ = r.__SENTRY__ || {}, a = i[Ca] = i["8.36.0"] || {};
	return a[e] || (a[e] = t());
}
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/debug-build.js
var Ea = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Da = "Sentry Logger ", Oa = [
	"debug",
	"info",
	"warn",
	"error",
	"log",
	"assert",
	"trace"
], ka = {};
function Aa(e) {
	if (!("console" in wa)) return e();
	let t = wa.console, n = {}, r = Object.keys(ka);
	r.forEach((e) => {
		let r = ka[e];
		n[e] = t[e], t[e] = r;
	});
	try {
		return e();
	} finally {
		r.forEach((e) => {
			t[e] = n[e];
		});
	}
}
function ja() {
	let e = !1, t = {
		enable: () => {
			e = !0;
		},
		disable: () => {
			e = !1;
		},
		isEnabled: () => e
	};
	return Ea ? Oa.forEach((n) => {
		t[n] = (...t) => {
			e && Aa(() => {
				wa.console[n](`${Da}[${n}]:`, ...t);
			});
		};
	}) : Oa.forEach((e) => {
		t[e] = () => void 0;
	}), t;
}
var Ma = Ta("logger", ja);
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/object.js
function Na(e, t, n) {
	try {
		Object.defineProperty(e, t, {
			value: n,
			writable: !0,
			configurable: !0
		});
	} catch {
		Ea && Ma.log(`Failed to add non-enumerable property "${t}" to object`, e);
	}
}
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/time.js
var Pa = 1e3;
function Fa() {
	return Date.now() / Pa;
}
function Ia() {
	let { performance: e } = wa;
	if (!e || !e.now) return Fa;
	let t = Date.now() - e.now(), n = e.timeOrigin == null ? t : e.timeOrigin;
	return () => (n + e.now()) / Pa;
}
var La = Ia();
(() => {
	let { performance: e } = wa;
	if (!e || !e.now) return;
	let t = 3600 * 1e3, n = e.now(), r = Date.now(), i = e.timeOrigin ? Math.abs(e.timeOrigin + n - r) : t, a = i < t, o = e.timing && e.timing.navigationStart, s = typeof o == "number" ? Math.abs(o + n - r) : t;
	return a || s < t ? i <= s ? e.timeOrigin : o : r;
})();
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/misc.js
function Ra() {
	let e = wa, t = e.crypto || e.msCrypto, n = () => Math.random() * 16;
	try {
		if (t && t.randomUUID) return t.randomUUID().replace(/-/g, "");
		t && t.getRandomValues && (n = () => {
			let e = /* @__PURE__ */ new Uint8Array(1);
			return t.getRandomValues(e), e[0];
		});
	} catch {}
	return "10000000100040008000100000000000".replace(/[018]/g, (e) => (e ^ (n() & 15) >> e / 4).toString(16));
}
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/propagationContext.js
function za() {
	return {
		traceId: Ra(),
		spanId: Ra().substring(16)
	};
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/carrier.js
function Ba() {
	return Va(wa), wa;
}
function Va(e) {
	let t = e.__SENTRY__ = e.__SENTRY__ || {};
	return t.version = t.version || "8.36.0", t[Ca] = t["8.36.0"] || {};
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/session.js
function Ha(e, t = {}) {
	if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || La(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : Ra()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration) e.duration = void 0;
	else if (typeof t.duration == "number") e.duration = t.duration;
	else {
		let t = e.timestamp - e.started;
		e.duration = t >= 0 ? t : 0;
	}
	t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/spanOnScope.js
var Ua = "_sentrySpan";
function Wa(e, t) {
	t ? Na(e, Ua, t) : delete e[Ua];
}
function Ga(e) {
	return e[Ua];
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/scope.js
var Ka = 100, qa = class e {
	constructor() {
		this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = za();
	}
	clone() {
		let t = new e();
		return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._requestSession = this._requestSession, t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, Wa(t, Ga(this)), t;
	}
	setClient(e) {
		this._client = e;
	}
	setLastEventId(e) {
		this._lastEventId = e;
	}
	getClient() {
		return this._client;
	}
	lastEventId() {
		return this._lastEventId;
	}
	addScopeListener(e) {
		this._scopeListeners.push(e);
	}
	addEventProcessor(e) {
		return this._eventProcessors.push(e), this;
	}
	setUser(e) {
		return this._user = e || {
			email: void 0,
			id: void 0,
			ip_address: void 0,
			username: void 0
		}, this._session && Ha(this._session, { user: e }), this._notifyScopeListeners(), this;
	}
	getUser() {
		return this._user;
	}
	getRequestSession() {
		return this._requestSession;
	}
	setRequestSession(e) {
		return this._requestSession = e, this;
	}
	setTags(e) {
		return this._tags = {
			...this._tags,
			...e
		}, this._notifyScopeListeners(), this;
	}
	setTag(e, t) {
		return this._tags = {
			...this._tags,
			[e]: t
		}, this._notifyScopeListeners(), this;
	}
	setExtras(e) {
		return this._extra = {
			...this._extra,
			...e
		}, this._notifyScopeListeners(), this;
	}
	setExtra(e, t) {
		return this._extra = {
			...this._extra,
			[e]: t
		}, this._notifyScopeListeners(), this;
	}
	setFingerprint(e) {
		return this._fingerprint = e, this._notifyScopeListeners(), this;
	}
	setLevel(e) {
		return this._level = e, this._notifyScopeListeners(), this;
	}
	setTransactionName(e) {
		return this._transactionName = e, this._notifyScopeListeners(), this;
	}
	setContext(e, t) {
		return t === null ? delete this._contexts[e] : this._contexts[e] = t, this._notifyScopeListeners(), this;
	}
	setSession(e) {
		return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
	}
	getSession() {
		return this._session;
	}
	update(e) {
		if (!e) return this;
		let t = typeof e == "function" ? e(this) : e, [n, r] = t instanceof qa ? [t.getScopeData(), t.getRequestSession()] : xa(t) ? [e, e.requestSession] : [], { tags: i, extra: a, user: o, contexts: s, level: c, fingerprint: l = [], propagationContext: u } = n || {};
		return this._tags = {
			...this._tags,
			...i
		}, this._extra = {
			...this._extra,
			...a
		}, this._contexts = {
			...this._contexts,
			...s
		}, o && Object.keys(o).length && (this._user = o), c && (this._level = c), l.length && (this._fingerprint = l), u && (this._propagationContext = u), r && (this._requestSession = r), this;
	}
	clear() {
		return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Wa(this, void 0), this._attachments = [], this._propagationContext = za(), this._notifyScopeListeners(), this;
	}
	addBreadcrumb(e, t) {
		let n = typeof t == "number" ? t : Ka;
		if (n <= 0) return this;
		let r = {
			timestamp: Fa(),
			...e
		}, i = this._breadcrumbs;
		return i.push(r), this._breadcrumbs = i.length > n ? i.slice(-n) : i, this._notifyScopeListeners(), this;
	}
	getLastBreadcrumb() {
		return this._breadcrumbs[this._breadcrumbs.length - 1];
	}
	clearBreadcrumbs() {
		return this._breadcrumbs = [], this._notifyScopeListeners(), this;
	}
	addAttachment(e) {
		return this._attachments.push(e), this;
	}
	clearAttachments() {
		return this._attachments = [], this;
	}
	getScopeData() {
		return {
			breadcrumbs: this._breadcrumbs,
			attachments: this._attachments,
			contexts: this._contexts,
			tags: this._tags,
			extra: this._extra,
			user: this._user,
			level: this._level,
			fingerprint: this._fingerprint || [],
			eventProcessors: this._eventProcessors,
			propagationContext: this._propagationContext,
			sdkProcessingMetadata: this._sdkProcessingMetadata,
			transactionName: this._transactionName,
			span: Ga(this)
		};
	}
	setSDKProcessingMetadata(e) {
		return this._sdkProcessingMetadata = {
			...this._sdkProcessingMetadata,
			...e
		}, this;
	}
	setPropagationContext(e) {
		return this._propagationContext = e, this;
	}
	getPropagationContext() {
		return this._propagationContext;
	}
	captureException(e, t) {
		let n = t && t.event_id ? t.event_id : Ra();
		if (!this._client) return Ma.warn("No client configured on scope - will not capture exception!"), n;
		let r = /* @__PURE__ */ Error("Sentry syntheticException");
		return this._client.captureException(e, {
			originalException: e,
			syntheticException: r,
			...t,
			event_id: n
		}, this), n;
	}
	captureMessage(e, t, n) {
		let r = n && n.event_id ? n.event_id : Ra();
		if (!this._client) return Ma.warn("No client configured on scope - will not capture message!"), r;
		let i = Error(e);
		return this._client.captureMessage(e, t, {
			originalException: e,
			syntheticException: i,
			...n,
			event_id: r
		}, this), r;
	}
	captureEvent(e, t) {
		let n = t && t.event_id ? t.event_id : Ra();
		return this._client ? (this._client.captureEvent(e, {
			...t,
			event_id: n
		}, this), n) : (Ma.warn("No client configured on scope - will not capture event!"), n);
	}
	_notifyScopeListeners() {
		this._notifyingListeners ||= (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
			e(this);
		}), !1);
	}
};
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/defaultScopes.js
function Ja() {
	return Ta("defaultCurrentScope", () => new qa());
}
function Ya() {
	return Ta("defaultIsolationScope", () => new qa());
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/asyncContext/stackStrategy.js
var Xa = class {
	constructor(e, t) {
		let n;
		n = e || new qa();
		let r;
		r = t || new qa(), this._stack = [{ scope: n }], this._isolationScope = r;
	}
	withScope(e) {
		let t = this._pushScope(), n;
		try {
			n = e(t);
		} catch (e) {
			throw this._popScope(), e;
		}
		return Sa(n) ? n.then((e) => (this._popScope(), e), (e) => {
			throw this._popScope(), e;
		}) : (this._popScope(), n);
	}
	getClient() {
		return this.getStackTop().client;
	}
	getScope() {
		return this.getStackTop().scope;
	}
	getIsolationScope() {
		return this._isolationScope;
	}
	getStackTop() {
		return this._stack[this._stack.length - 1];
	}
	_pushScope() {
		let e = this.getScope().clone();
		return this._stack.push({
			client: this.getClient(),
			scope: e
		}), e;
	}
	_popScope() {
		return this._stack.length <= 1 ? !1 : !!this._stack.pop();
	}
};
function Za() {
	let e = Va(Ba());
	return e.stack = e.stack || new Xa(Ja(), Ya());
}
function Qa(e) {
	return Za().withScope(e);
}
function $a(e, t) {
	let n = Za();
	return n.withScope(() => (n.getStackTop().scope = e, t(e)));
}
function eo(e) {
	return Za().withScope(() => e(Za().getIsolationScope()));
}
function to() {
	return {
		withIsolationScope: eo,
		withScope: Qa,
		withSetScope: $a,
		withSetIsolationScope: (e, t) => eo(t),
		getCurrentScope: () => Za().getScope(),
		getIsolationScope: () => Za().getIsolationScope()
	};
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/asyncContext/index.js
function no(e) {
	let t = Va(e);
	return t.acs ? t.acs : to();
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/currentScopes.js
function ro() {
	return no(Ba()).getCurrentScope();
}
function io() {
	return no(Ba()).getIsolationScope();
}
function ao() {
	return ro().getClient();
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/prepareEvent.js
function oo(e) {
	if (e) return so(e) || lo(e) ? { captureContext: e } : e;
}
function so(e) {
	return e instanceof qa || typeof e == "function";
}
var co = [
	"user",
	"level",
	"extra",
	"contexts",
	"tags",
	"fingerprint",
	"requestSession",
	"propagationContext"
];
function lo(e) {
	return Object.keys(e).some((e) => co.includes(e));
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/exports.js
function uo(e, t) {
	return ro().captureException(e, oo(t));
}
function fo(e, t) {
	let n = typeof t == "string" ? t : void 0, r = typeof t == "string" ? void 0 : { captureContext: t };
	return ro().captureMessage(e, n, r);
}
function po(e, t) {
	io().setContext(e, t);
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/breadcrumbs.js
var mo = 100;
function ho(e, t) {
	let n = ao(), r = io();
	if (!n) return;
	let { beforeBreadcrumb: i = null, maxBreadcrumbs: a = mo } = n.getOptions();
	if (a <= 0) return;
	let o = {
		timestamp: Fa(),
		...e
	}, s = i ? Aa(() => i(o, t)) : o;
	s !== null && (n.emit && n.emit("beforeAddBreadcrumb", s, t), r.addBreadcrumb(s, a));
}
//#endregion
//#region ../../shared/sentry/dist/index.js
var go;
(function(e) {
	e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(go ||= {});
//#endregion
//#region ../../shared/auth/dist/jwt/jwt.js
function _o(e) {
	let t = e.split(".")[1];
	if (!t) throw Error("Invalid token");
	let n = t.replace(/-/g, "+").replace(/_/g, "/");
	try {
		return JSON.parse(Buffer.from(n, "base64").toString());
	} catch (e) {
		throw Error(`Failed to parse the JSON Web Token with the following error: ${e}`);
	}
}
//#endregion
//#region ../../shared/auth/dist/redirect/redirect.js
var vo = pt.backendDomain ? { "backend-domain": pt.backendDomain } : void 0;
function yo() {
	let e = new URLSearchParams({
		noToken: "true",
		...vo
	}).toString();
	document.location.href = `${pt.url.logIn}?${e}`;
}
//#endregion
//#region ../../shared/auth/dist/authManager/authStorageConfig.js
var bo = "authData", xo = 600, So = 5, Co = new class {
	authData = null;
	accessTokenExpiresAt = 0;
	clientServerTimeDiff = 0;
	estimatedServerTime() {
		let e = Date.now() / 1e3;
		return this.clientServerTimeDiff >= So || this.clientServerTimeDiff <= -5 ? Math.ceil(e + this.clientServerTimeDiff) : Math.ceil(e);
	}
	setAuthData(e) {
		this.authData = e;
		let t = Math.ceil(Date.now() / 1e3) + xo, n = _o(e.access_token).exp;
		if (this.clientServerTimeDiff = n - t, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > So) {
			let e = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
			console.info(`Client time is ${e} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
		}
		this.accessTokenExpiresAt = n, localStorage.setItem(bo, JSON.stringify(e));
	}
	getAuthData() {
		if (this.authData) return this.authData;
		let e = localStorage.getItem(bo), t = e ? JSON.parse(e) : null;
		return this.validateAuthDataComplete(t) && (this.authData = t), t;
	}
	removeAuthData() {
		this.authData = null, localStorage.removeItem(bo);
	}
	getAccessToken() {
		return this.authData?.access_token || null;
	}
	getRefreshToken() {
		return this.authData?.refresh_token || null;
	}
	validateAuthDataComplete(e) {
		return e ? [
			"access_token",
			"refresh_token",
			"expires_in"
		].every((t) => e[t] !== void 0) : !1;
	}
	isAccessTokenExpired() {
		if (!this.getAccessToken()) return !0;
		let e = this.accessTokenExpiresAt - 30;
		return this.estimatedServerTime() >= e;
	}
	isRefreshTokenExpired(e) {
		if (!e) return !0;
		let t = _o(e), n = t.exp - 30;
		return !t || this.estimatedServerTime() >= n;
	}
	accessTokenExpiresInMs() {
		return (this.accessTokenExpiresAt - 30 - this.estimatedServerTime()) * 1e3;
	}
}();
//#endregion
//#region ../../shared/auth/dist/authManager/interceptor.js
async function wo(e) {
	let t = window.location.origin.replace(/^https?:\/\//, "");
	if (!(!e.response || ["localhost:8080", "uptrends-monitor"].some((e) => t.includes(e)))) {
		try {
			let t = e.response.config.headers.Authorization ?? "", n = t ? t.toString()?.split("Basic ")[1] : "", r = n ? atob(n).split("token:")[1] : "", i = r ? _o(r).exp : "None", a = await Po.getAuthData({ localStorageOnly: !0 }), o = Math.floor(Date.now() / 1e3), s = a?.access_token, c = a?.refresh_token, l = s ? _o(s).exp : "None", u = c ? _o(c).exp : "None", d = typeof i == "number" ? o - i : "Unknown", f = typeof l == "number" ? o - l : "Unknown", p = typeof u == "number" ? o - u : "Unknown", m = e.response.headers["x-dixa-rid"];
			po("Expires", {
				currentTimestamp: o,
				accessTokenFromHeader: i,
				accessTokenFromHeaderDiff: d,
				accessTokenFromLocalStorage: l,
				accessTokenFromLocalStorageDiff: f,
				refreshTokenFromLocalStorage: u,
				refreshTokenFromLocalStorageDiff: p,
				xDixaRid: m,
				navigatorOnline: navigator.onLine
			});
		} catch (e) {
			console.error("Error adding Sentry error context", e);
		}
		fo("401 unauthorized interceptor", {
			level: "debug",
			tags: {
				team: go.Platform,
				domain: t
			}
		});
	}
}
var To = /* @__PURE__ */ new Map(), Eo = 3;
function Do(e) {
	e.interceptors.response.use((e) => (To.delete(e.config.url), e), (t) => {
		if (t.response) {
			let { status: n } = t.response;
			switch (n) {
				case Fo.Unauthorized:
					if (!Po.isRefreshTokenExpired() && t.config) {
						ho({
							category: "errorInterceptor",
							message: "Access token expired after request",
							level: "debug"
						});
						let n = To.get(t.config.url) ?? 0;
						if (console.log(`Retrying request (${n + 1}): ${t.config.url}`), n <= Eo) return To.set(t.config.url, n + 1), e(t.config);
					}
					wo(t), console.error("401 unauthorized interceptor"), yo();
					break;
			}
		}
		return Promise.reject(t);
	});
}
//#endregion
//#region ../../shared/auth/dist/authManager/authManager.js
var Oo = Qi.create();
Do(Oo);
var ko = console.log;
async function Ao(e) {
	return new Promise((t) => setTimeout(t, e * 1e3));
}
var jo = class extends Error {
	constructor(e, t) {
		super(e, t);
	}
};
function Mo(e = 0) {
	return Math.min(Math.round((Math.random() + 1) * 1.5 ** e), 30);
}
var No = 5, Po = new class {
	authDataPromise = null;
	retryCount = 0;
	async init(e) {
		let t = await this.refresh(e);
		if (t) Co.setAuthData(t);
		else throw new jo("Failed to init refresh token", { cause: Co.isRefreshTokenExpired(e) ? "expired" : "unknown" });
	}
	getDebugInfo() {
		let e = Co.getAccessToken();
		if (!e) return {};
		let { exp: t } = _o(e);
		return {
			expire: t ? (/* @__PURE__ */ new Date(t * 1e3)).toISOString() : null,
			now: (/* @__PURE__ */ new Date()).toISOString()
		};
	}
	async getAuthData({ localStorageOnly: e = !1 } = {}) {
		if (e) return Co.getAuthData();
		if (this.authDataPromise) return await this.authDataPromise;
		let t = Co.getAuthData();
		return t ? Co.isAccessTokenExpired() ? (ho({
			category: "refreshToken",
			message: "expired or about to expire",
			level: "debug",
			data: this.getDebugInfo()
		}), this.authDataPromise = this.refresh(t.refresh_token).then((e) => (e && Co.setAuthData(e), this.authDataPromise = null, e)), await this.authDataPromise) : t : null;
	}
	removeAuthData() {
		return Co.removeAuthData();
	}
	validateAuthDataComplete(e) {
		return Co.validateAuthDataComplete(e);
	}
	isAccessTokenExpired() {
		return Co.isAccessTokenExpired();
	}
	isRefreshTokenExpired() {
		let e = Co.getAuthData();
		return !e || Co.isRefreshTokenExpired(e.refresh_token);
	}
	async isSupported() {
		return !ga.isElectron() || _a(await ga.getVersion(), "3.7.0") === 1;
	}
	async refresh(e, t = No) {
		try {
			return await Oo.post(`${pt.url.rest}/v2/login/refresh`, { refreshToken: e }).then((e) => (this.retryCount = 0, e.data.data));
		} catch (n) {
			return await this.handleRefreshError(n, e, t);
		}
	}
	async waitUntilOnline() {
		let e = navigator.onLine === !1;
		for (e && (ko("AUTH", "Network connection offline - waiting..."), ho({
			category: "refreshToken",
			message: "Network connection offline - waiting...",
			level: "debug"
		})); navigator.onLine === !1;) await Ao(5);
		e && (ko("AUTH", "Network connection restored"), ho({
			category: "refreshToken",
			message: "Network connection restored",
			level: "debug"
		}));
	}
	async retryRefresh(e, t) {
		await this.waitUntilOnline(), this.retryCount++;
		let n = Mo(this.retryCount);
		return ko("AUTH", `Retrying in ${n} seconds`), await Ao(n), await this.refresh(e, t);
	}
	async handleRefreshError(e, t, n) {
		if (Co.isRefreshTokenExpired(t)) return ko("AUTH", "Refresh token expired"), ho({
			category: "refreshToken",
			message: "Refresh token expired",
			level: "debug"
		}), Co.removeAuthData(), yo(), null;
		if (sa(e)) {
			if (e.message === "timeout exceeded") return ko("AUTH", "Timeout exceeded"), ho({
				category: "refreshToken",
				message: "Timeout exceeded",
				level: "debug"
			}), await this.retryRefresh(t, n);
			if (e.message === "Network Error") return ko("AUTH", "Network error"), ho({
				category: "refreshToken",
				message: "Network error",
				level: "debug"
			}), await this.retryRefresh(t, n);
			if (e.response?.status === 401) return ko("AUTH", "Refresh token invalid (401)"), Co.removeAuthData(), yo(), null;
			uo(e, {
				level: "error",
				tags: {
					team: go.Platform,
					errorSource: "authManager.refresh"
				}
			});
		}
		return n <= 0 ? (ko("AUTH", "Retries exhausted, logging out"), uo(e, {
			level: "error",
			tags: {
				team: go.Platform,
				errorSource: "authManager.refresh"
			}
		}), Co.removeAuthData(), yo(), null) : (ko("AUTH", `Retrying ${n} more times`), await this.retryRefresh(t, n - 1));
	}
	accessTokenExpiresInMs() {
		return Co.accessTokenExpiresInMs();
	}
}(), Fo;
(function(e) {
	e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Fo ||= {});
//#endregion
//#region src/helpers/graphQLClient/utils/authorizationLink.ts
var Io = new rt((e, t) => new st((n) => {
	Po.getAuthData().then((r) => {
		let i = r?.access_token, a = e.getContext().headers;
		return e.setContext({
			...a,
			headers: { Authorization: i ? `Bearer ${i}` : "" }
		}), t(e).subscribe(n);
	}).catch((e) => n.error(e));
})), Lo = new rt((e, t) => new st((n) => {
	let r = e.getContext(), { headers: i, widgetId: a, widgetType: o, operationName: s } = r;
	Po.getAuthData().then((c) => (e.setContext({
		...r,
		headers: {
			...i,
			...a && { "x-integration-widget-id": a },
			...o && { "x-integration-widget-type": o },
			...s && { "x-integration-widget-operation": s },
			...ke(pt.url.partnerIntegrations) && c?.access_token && ve(c.access_token)
		}
	}), t(e).subscribe(n))).catch((e) => n.error(e));
})), Ro = new AbortController(), zo = (e) => new et({
	queryDeduplication: !1,
	cache: new at(),
	link: rt.from([
		Io,
		Lo,
		ct({
			uri: `${e}/graphql`,
			fetch: ft,
			fetchOptions: {
				mode: "cors",
				signal: Ro.signal
			}
		})
	]),
	defaultOptions: {
		watchQuery: {
			fetchPolicy: "no-cache",
			errorPolicy: "all"
		},
		query: {
			fetchPolicy: "no-cache",
			errorPolicy: "all"
		},
		mutate: {
			fetchPolicy: "no-cache",
			errorPolicy: "all"
		}
	}
}), Bo = ({ configuration: e, children: t }) => /* @__PURE__ */ K(it, {
	client: Ze(() => zo(e.baseUrl), [e.baseUrl]),
	children: t
});
//#endregion
//#region src/hooks/useHasApolloClient/useHasApolloClient.ts
function Vo() {
	try {
		return dt(), !0;
	} catch {
		return !1;
	}
}
//#endregion
//#region src/helpers/withWidgetContextProvider/withWidgetContextProvider.tsx
var Ho = ({ configuration: e, children: t }) => Vo() ? t : /* @__PURE__ */ K(Bo, {
	configuration: e,
	children: t
}), Uo = ({ integrationId: e, type: t, showNotification: n, showModal: r, children: i }) => /* @__PURE__ */ K(tt, { children: (a) => /* @__PURE__ */ K(fe, {
	value: {
		useMutation: Me(e, t),
		useQuery: Ne(e, t),
		useLazyQuery: je(e, t),
		executeQuery: Ae(e, t, a),
		showNotification: n,
		showModal: r ?? (() => null)
	},
	children: i
}) }), Wo = ({ integrationId: e, type: t, configuration: n, showNotification: r, showModal: i, children: a }) => /* @__PURE__ */ K(Ho, {
	configuration: n,
	children: e && t ? /* @__PURE__ */ K(Uo, {
		integrationId: e,
		type: t,
		showNotification: r,
		showModal: i,
		children: a
	}) : a
}), Go = Ge(() => void 0), Ko = () => Ye(Go), qo = ({ children: e }) => {
	let [t, n] = W(!1), r = {
		headline: "",
		text: "",
		onConfirm: () => n(!1),
		confirmLabel: "Confirm",
		confirmVariant: "primary"
	}, [i, a] = W(r), o = (e) => {
		n(!0), a(e);
	}, s = () => {
		n(!1), a(r);
	};
	return /* @__PURE__ */ q(Go.Provider, {
		value: o,
		children: [e, /* @__PURE__ */ K(oe, {
			isOpen: t,
			setIsOpen: n,
			headline: i.headline,
			text: i.text,
			confirmLabel: i.confirmLabel,
			confirmVariant: i.confirmVariant,
			cancelLabel: i.cancelLabel,
			cancelVariant: i.cancelVariant,
			onConfirm: i.onConfirm ? () => {
				try {
					i.onConfirm && i.onConfirm();
				} finally {
					s();
				}
			} : void 0,
			onCancel: i.onCancel ? () => {
				try {
					i.onCancel && i.onCancel();
				} finally {
					s();
				}
			} : void 0,
			children: i.children
		})]
	});
}, Jo = { unmatchedHeader: "_unmatchedHeader_qcj19_1" }, Yo = mt, Xo = ht, Zo = (e) => e.type === "checkbox", Qo = (e) => e instanceof Date, $o = (e) => e == null, es = (e) => typeof e == "object", ts = (e) => !$o(e) && !Array.isArray(e) && es(e) && !Qo(e), ns = (e) => ts(e) && e.target ? Zo(e.target) ? e.target.checked : e.target.value : e, rs = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, is = (e, t) => e.has(rs(t)), as = (e) => {
	let t = e.constructor && e.constructor.prototype;
	return ts(t) && t.hasOwnProperty("isPrototypeOf");
}, os = typeof window < "u" && window.HTMLElement !== void 0 && typeof document < "u";
function ss(e) {
	let t, n = Array.isArray(e), r = typeof FileList < "u" && e instanceof FileList;
	if (e instanceof Date) t = new Date(e);
	else if (e instanceof Set) t = new Set(e);
	else if (!(os && (e instanceof Blob || r)) && (n || ts(e))) if (t = n ? [] : {}, !n && !as(e)) t = e;
	else for (let n in e) e.hasOwnProperty(n) && (t[n] = ss(e[n]));
	else return e;
	return t;
}
var cs = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ls = (e) => e === void 0, X = (e, t, n) => {
	if (!t || !ts(e)) return n;
	let r = cs(t.split(/[,[\].]+?/)).reduce((e, t) => $o(e) ? e : e[t], e);
	return ls(r) || r === e ? ls(e[t]) ? n : e[t] : r;
}, us = (e) => typeof e == "boolean", ds = (e) => /^\w*$/.test(e), fs = (e) => cs(e.replace(/["|']|\]/g, "").split(/\.|\[/)), ps = (e, t, n) => {
	let r = -1, i = ds(t) ? [t] : fs(t), a = i.length, o = a - 1;
	for (; ++r < a;) {
		let t = i[r], a = n;
		if (r !== o) {
			let n = e[t];
			a = ts(n) || Array.isArray(n) ? n : isNaN(+i[r + 1]) ? {} : [];
		}
		if (t === "__proto__" || t === "constructor" || t === "prototype") return;
		e[t] = a, e = e[t];
	}
}, ms = {
	BLUR: "blur",
	FOCUS_OUT: "focusout",
	CHANGE: "change"
}, hs = {
	onBlur: "onBlur",
	onChange: "onChange",
	onSubmit: "onSubmit",
	onTouched: "onTouched",
	all: "all"
}, gs = {
	max: "max",
	min: "min",
	maxLength: "maxLength",
	minLength: "minLength",
	pattern: "pattern",
	required: "required",
	validate: "validate"
}, _s = H.createContext(null), vs = () => H.useContext(_s), ys = (e) => {
	let { children: t, ...n } = e;
	return H.createElement(_s.Provider, { value: n }, t);
}, bs = (e, t, n, r = !0) => {
	let i = { defaultValues: t._defaultValues };
	for (let a in e) Object.defineProperty(i, a, { get: () => {
		let i = a;
		return t._proxyFormState[i] !== hs.all && (t._proxyFormState[i] = !r || hs.all), n && (n[i] = !0), e[i];
	} });
	return i;
};
function xs(e) {
	let t = vs(), { control: n = t.control, disabled: r, name: i, exact: a } = e || {}, [o, s] = H.useState(n._formState), c = H.useRef({
		isDirty: !1,
		isLoading: !1,
		dirtyFields: !1,
		touchedFields: !1,
		validatingFields: !1,
		isValidating: !1,
		isValid: !1,
		errors: !1
	}), l = H.useRef(i);
	return l.current = i, H.useEffect(() => n._subscribe({
		name: l.current,
		formState: c.current,
		exact: a,
		callback: (e) => {
			!r && s({
				...n._formState,
				...e
			});
		}
	}), [
		n,
		r,
		a
	]), H.useEffect(() => {
		c.current.isValid && n._setValid(!0);
	}, [n]), H.useMemo(() => bs(o, n, c.current, !1), [o, n]);
}
var Ss = (e) => typeof e == "string", Cs = (e, t, n, r, i) => Ss(e) ? (r && t.watch.add(e), X(n, e, i)) : Array.isArray(e) ? e.map((e) => (r && t.watch.add(e), X(n, e))) : (r && (t.watchAll = !0), n);
function ws(e) {
	let t = vs(), { control: n = t.control, name: r, defaultValue: i, disabled: a, exact: o } = e || {}, s = H.useRef(r), c = H.useRef(i);
	s.current = r, H.useEffect(() => n._subscribe({
		name: s.current,
		formState: { values: !0 },
		exact: o,
		callback: (e) => !a && u(Cs(s.current, n._names, e.values || n._formValues, !1, c.current))
	}), [
		n,
		a,
		o
	]);
	let [l, u] = H.useState(n._getWatch(r, i));
	return H.useEffect(() => n._removeUnmounted()), l;
}
function Ts(e) {
	let t = vs(), { name: n, disabled: r, control: i = t.control, shouldUnregister: a } = e, o = is(i._names.array, n), s = ws({
		control: i,
		name: n,
		defaultValue: X(i._formValues, n, X(i._defaultValues, n, e.defaultValue)),
		exact: !0
	}), c = xs({
		control: i,
		name: n,
		exact: !0
	}), l = H.useRef(e), u = H.useRef(i.register(n, {
		...e.rules,
		value: s,
		...us(e.disabled) ? { disabled: e.disabled } : {}
	})), d = H.useMemo(() => Object.defineProperties({}, {
		invalid: {
			enumerable: !0,
			get: () => !!X(c.errors, n)
		},
		isDirty: {
			enumerable: !0,
			get: () => !!X(c.dirtyFields, n)
		},
		isTouched: {
			enumerable: !0,
			get: () => !!X(c.touchedFields, n)
		},
		isValidating: {
			enumerable: !0,
			get: () => !!X(c.validatingFields, n)
		},
		error: {
			enumerable: !0,
			get: () => X(c.errors, n)
		}
	}), [c, n]), f = H.useCallback((e) => u.current.onChange({
		target: {
			value: ns(e),
			name: n
		},
		type: ms.CHANGE
	}), [n]), p = H.useCallback(() => u.current.onBlur({
		target: {
			value: X(i._formValues, n),
			name: n
		},
		type: ms.BLUR
	}), [n, i._formValues]), m = H.useCallback((e) => {
		let t = X(i._fields, n);
		t && e && (t._f.ref = {
			focus: () => e.focus(),
			select: () => e.select(),
			setCustomValidity: (t) => e.setCustomValidity(t),
			reportValidity: () => e.reportValidity()
		});
	}, [i._fields, n]), h = H.useMemo(() => ({
		name: n,
		value: s,
		...us(r) || c.disabled ? { disabled: c.disabled || r } : {},
		onChange: f,
		onBlur: p,
		ref: m
	}), [
		n,
		r,
		c.disabled,
		f,
		p,
		m,
		s
	]);
	return H.useEffect(() => {
		let e = i._options.shouldUnregister || a;
		i.register(n, {
			...l.current.rules,
			...us(l.current.disabled) ? { disabled: l.current.disabled } : {}
		});
		let t = (e, t) => {
			let n = X(i._fields, e);
			n && n._f && (n._f.mount = t);
		};
		if (t(n, !0), e) {
			let e = ss(X(i._options.defaultValues, n));
			ps(i._defaultValues, n, e), ls(X(i._formValues, n)) && ps(i._formValues, n, e);
		}
		return !o && i.register(n), () => {
			(o ? e && !i._state.action : e) ? i.unregister(n) : t(n, !1);
		};
	}, [
		n,
		i,
		o,
		a
	]), H.useEffect(() => {
		i._setDisabledField({
			disabled: r,
			name: n
		});
	}, [
		r,
		n,
		i
	]), H.useMemo(() => ({
		field: h,
		formState: c,
		fieldState: d
	}), [
		h,
		c,
		d
	]);
}
var Es = (e) => e.render(Ts(e)), Ds = (e, t, n, r, i) => t ? {
	...n[e],
	types: {
		...n[e] && n[e].types ? n[e].types : {},
		[r]: i || !0
	}
} : {}, Os = (e) => Array.isArray(e) ? e : [e], ks = () => {
	let e = [];
	return {
		get observers() {
			return e;
		},
		next: (t) => {
			for (let n of e) n.next && n.next(t);
		},
		subscribe: (t) => (e.push(t), { unsubscribe: () => {
			e = e.filter((e) => e !== t);
		} }),
		unsubscribe: () => {
			e = [];
		}
	};
}, As = (e) => $o(e) || !es(e);
function js(e, t) {
	if (As(e) || As(t)) return e === t;
	if (Qo(e) && Qo(t)) return e.getTime() === t.getTime();
	let n = Object.keys(e), r = Object.keys(t);
	if (n.length !== r.length) return !1;
	for (let i of n) {
		let n = e[i];
		if (!r.includes(i)) return !1;
		if (i !== "ref") {
			let e = t[i];
			if (Qo(n) && Qo(e) || ts(n) && ts(e) || Array.isArray(n) && Array.isArray(e) ? !js(n, e) : n !== e) return !1;
		}
	}
	return !0;
}
var Ms = (e) => ts(e) && !Object.keys(e).length, Ns = (e) => e.type === "file", Ps = (e) => typeof e == "function", Fs = (e) => {
	if (!os) return !1;
	let t = e ? e.ownerDocument : 0;
	return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, Is = (e) => e.type === "select-multiple", Ls = (e) => e.type === "radio", Rs = (e) => Ls(e) || Zo(e), zs = (e) => Fs(e) && e.isConnected;
function Bs(e, t) {
	let n = t.slice(0, -1).length, r = 0;
	for (; r < n;) e = ls(e) ? r++ : e[t[r++]];
	return e;
}
function Vs(e) {
	for (let t in e) if (e.hasOwnProperty(t) && !ls(e[t])) return !1;
	return !0;
}
function Hs(e, t) {
	let n = Array.isArray(t) ? t : ds(t) ? [t] : fs(t), r = n.length === 1 ? e : Bs(e, n), i = n.length - 1, a = n[i];
	return r && delete r[a], i !== 0 && (ts(r) && Ms(r) || Array.isArray(r) && Vs(r)) && Hs(e, n.slice(0, -1)), e;
}
var Us = (e) => {
	for (let t in e) if (Ps(e[t])) return !0;
	return !1;
};
function Ws(e, t = {}) {
	let n = Array.isArray(e);
	if (ts(e) || n) for (let n in e) Array.isArray(e[n]) || ts(e[n]) && !Us(e[n]) ? (t[n] = Array.isArray(e[n]) ? [] : {}, Ws(e[n], t[n])) : $o(e[n]) || (t[n] = !0);
	return t;
}
function Gs(e, t, n) {
	let r = Array.isArray(e);
	if (ts(e) || r) for (let r in e) Array.isArray(e[r]) || ts(e[r]) && !Us(e[r]) ? ls(t) || As(n[r]) ? n[r] = Array.isArray(e[r]) ? Ws(e[r], []) : { ...Ws(e[r]) } : Gs(e[r], $o(t) ? {} : t[r], n[r]) : n[r] = !js(e[r], t[r]);
	return n;
}
var Ks = (e, t) => Gs(e, t, Ws(t)), qs = {
	value: !1,
	isValid: !1
}, Js = {
	value: !0,
	isValid: !0
}, Ys = (e) => {
	if (Array.isArray(e)) {
		if (e.length > 1) {
			let t = e.filter((e) => e && e.checked && !e.disabled).map((e) => e.value);
			return {
				value: t,
				isValid: !!t.length
			};
		}
		return e[0].checked && !e[0].disabled ? e[0].attributes && !ls(e[0].attributes.value) ? ls(e[0].value) || e[0].value === "" ? Js : {
			value: e[0].value,
			isValid: !0
		} : Js : qs;
	}
	return qs;
}, Xs = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => ls(e) ? e : t ? e === "" ? NaN : e && +e : n && Ss(e) ? new Date(e) : r ? r(e) : e, Zs = {
	isValid: !1,
	value: null
}, Qs = (e) => Array.isArray(e) ? e.reduce((e, t) => t && t.checked && !t.disabled ? {
	isValid: !0,
	value: t.value
} : e, Zs) : Zs;
function $s(e) {
	let t = e.ref;
	return Ns(t) ? t.files : Ls(t) ? Qs(e.refs).value : Is(t) ? [...t.selectedOptions].map(({ value: e }) => e) : Zo(t) ? Ys(e.refs).value : Xs(ls(t.value) ? e.ref.value : t.value, e);
}
var ec = (e, t, n, r) => {
	let i = {};
	for (let n of e) {
		let e = X(t, n);
		e && ps(i, n, e._f);
	}
	return {
		criteriaMode: n,
		names: [...e],
		fields: i,
		shouldUseNativeValidation: r
	};
}, tc = (e) => e instanceof RegExp, nc = (e) => ls(e) ? e : tc(e) ? e.source : ts(e) ? tc(e.value) ? e.value.source : e.value : e, rc = (e) => ({
	isOnSubmit: !e || e === hs.onSubmit,
	isOnBlur: e === hs.onBlur,
	isOnChange: e === hs.onChange,
	isOnAll: e === hs.all,
	isOnTouch: e === hs.onTouched
}), ic = "AsyncFunction", ac = (e) => !!e && !!e.validate && !!(Ps(e.validate) && e.validate.constructor.name === ic || ts(e.validate) && Object.values(e.validate).find((e) => e.constructor.name === ic)), oc = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), sc = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((t) => e.startsWith(t) && /^\.\w+/.test(e.slice(t.length)))), cc = (e, t, n, r) => {
	for (let i of n || Object.keys(e)) {
		let n = X(e, i);
		if (n) {
			let { _f: e, ...a } = n;
			if (e) {
				if (e.refs && e.refs[0] && t(e.refs[0], i) && !r || e.ref && t(e.ref, e.name) && !r) return !0;
				if (cc(a, t)) break;
			} else if (ts(a) && cc(a, t)) break;
		}
	}
};
function lc(e, t, n) {
	let r = X(e, n);
	if (r || ds(n)) return {
		error: r,
		name: n
	};
	let i = n.split(".");
	for (; i.length;) {
		let r = i.join("."), a = X(t, r), o = X(e, r);
		if (a && !Array.isArray(a) && n !== r) return { name: n };
		if (o && o.type) return {
			name: r,
			error: o
		};
		i.pop();
	}
	return { name: n };
}
var uc = (e, t, n, r) => {
	n(e);
	let { name: i, ...a } = e;
	return Ms(a) || Object.keys(a).length >= Object.keys(t).length || Object.keys(a).find((e) => t[e] === (!r || hs.all));
}, dc = (e, t, n) => !e || !t || e === t || Os(e).some((e) => e && (n ? e === t : e.startsWith(t) || t.startsWith(e))), fc = (e, t, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(t || e) : (n ? r.isOnBlur : i.isOnBlur) ? !e : (n ? r.isOnChange : i.isOnChange) ? e : !0, pc = (e, t) => !cs(X(e, t)).length && Hs(e, t), mc = (e, t, n) => {
	let r = Os(X(e, n));
	return ps(r, "root", t[n]), ps(e, n, r), e;
}, hc = (e) => Ss(e);
function gc(e, t, n = "validate") {
	if (hc(e) || Array.isArray(e) && e.every(hc) || us(e) && !e) return {
		type: n,
		message: hc(e) ? e : "",
		ref: t
	};
}
var _c = (e) => ts(e) && !tc(e) ? e : {
	value: e,
	message: ""
}, vc = async (e, t, n, r, i, a) => {
	let { ref: o, refs: s, required: c, maxLength: l, minLength: u, min: d, max: f, pattern: p, validate: m, name: h, valueAsNumber: g, mount: _ } = e._f, v = X(n, h);
	if (!_ || t.has(h)) return {};
	let y = s ? s[0] : o, b = (e) => {
		i && y.reportValidity && (y.setCustomValidity(us(e) ? "" : e || ""), y.reportValidity());
	}, x = {}, S = Ls(o), C = Zo(o), w = S || C, T = (g || Ns(o)) && ls(o.value) && ls(v) || Fs(o) && o.value === "" || v === "" || Array.isArray(v) && !v.length, E = Ds.bind(null, h, r, x), D = (e, t, n, r = gs.maxLength, i = gs.minLength) => {
		let a = e ? t : n;
		x[h] = {
			type: e ? r : i,
			message: a,
			ref: o,
			...E(e ? r : i, a)
		};
	};
	if (a ? !Array.isArray(v) || !v.length : c && (!w && (T || $o(v)) || us(v) && !v || C && !Ys(s).isValid || S && !Qs(s).isValid)) {
		let { value: e, message: t } = hc(c) ? {
			value: !!c,
			message: c
		} : _c(c);
		if (e && (x[h] = {
			type: gs.required,
			message: t,
			ref: y,
			...E(gs.required, t)
		}, !r)) return b(t), x;
	}
	if (!T && (!$o(d) || !$o(f))) {
		let e, t, n = _c(f), i = _c(d);
		if (!$o(v) && !isNaN(v)) {
			let r = o.valueAsNumber || v && +v;
			$o(n.value) || (e = r > n.value), $o(i.value) || (t = r < i.value);
		} else {
			let r = o.valueAsDate || new Date(v), a = (e) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + e), s = o.type == "time", c = o.type == "week";
			Ss(n.value) && v && (e = s ? a(v) > a(n.value) : c ? v > n.value : r > new Date(n.value)), Ss(i.value) && v && (t = s ? a(v) < a(i.value) : c ? v < i.value : r < new Date(i.value));
		}
		if ((e || t) && (D(!!e, n.message, i.message, gs.max, gs.min), !r)) return b(x[h].message), x;
	}
	if ((l || u) && !T && (Ss(v) || a && Array.isArray(v))) {
		let e = _c(l), t = _c(u), n = !$o(e.value) && v.length > +e.value, i = !$o(t.value) && v.length < +t.value;
		if ((n || i) && (D(n, e.message, t.message), !r)) return b(x[h].message), x;
	}
	if (p && !T && Ss(v)) {
		let { value: e, message: t } = _c(p);
		if (tc(e) && !v.match(e) && (x[h] = {
			type: gs.pattern,
			message: t,
			ref: o,
			...E(gs.pattern, t)
		}, !r)) return b(t), x;
	}
	if (m) {
		if (Ps(m)) {
			let e = gc(await m(v, n), y);
			if (e && (x[h] = {
				...e,
				...E(gs.validate, e.message)
			}, !r)) return b(e.message), x;
		} else if (ts(m)) {
			let e = {};
			for (let t in m) {
				if (!Ms(e) && !r) break;
				let i = gc(await m[t](v, n), y, t);
				i && (e = {
					...i,
					...E(t, i.message)
				}, b(i.message), r && (x[h] = e));
			}
			if (!Ms(e) && (x[h] = {
				ref: y,
				...e
			}, !r)) return x;
		}
	}
	return b(!0), x;
}, yc = {
	mode: hs.onSubmit,
	reValidateMode: hs.onChange,
	shouldFocusError: !0
};
function bc(e = {}) {
	let t = {
		...yc,
		...e
	}, n = {
		submitCount: 0,
		isDirty: !1,
		isLoading: Ps(t.defaultValues),
		isValidating: !1,
		isSubmitted: !1,
		isSubmitting: !1,
		isSubmitSuccessful: !1,
		isValid: !1,
		touchedFields: {},
		dirtyFields: {},
		validatingFields: {},
		errors: t.errors || {},
		disabled: t.disabled || !1
	}, r = {}, i = (ts(t.defaultValues) || ts(t.values)) && ss(t.values || t.defaultValues) || {}, a = t.shouldUnregister ? {} : ss(i), o = {
		action: !1,
		mount: !1,
		watch: !1
	}, s = {
		mount: /* @__PURE__ */ new Set(),
		disabled: /* @__PURE__ */ new Set(),
		unMount: /* @__PURE__ */ new Set(),
		array: /* @__PURE__ */ new Set(),
		watch: /* @__PURE__ */ new Set()
	}, c, l = 0, u = {
		isDirty: !1,
		dirtyFields: !1,
		validatingFields: !1,
		touchedFields: !1,
		isValidating: !1,
		isValid: !1,
		errors: !1
	}, d = { ...u }, f = {
		array: ks(),
		state: ks()
	}, p = rc(t.mode), m = rc(t.reValidateMode), h = t.criteriaMode === hs.all, g = (e) => (t) => {
		clearTimeout(l), l = setTimeout(e, t);
	}, _ = async (e) => {
		if (!t.disabled && (u.isValid || d.isValid || e)) {
			let e = t.resolver ? Ms((await T()).errors) : await D(r, !0);
			e !== n.isValid && f.state.next({ isValid: e });
		}
	}, v = (e, r) => {
		!t.disabled && (u.isValidating || u.validatingFields || d.isValidating || d.validatingFields) && ((e || Array.from(s.mount)).forEach((e) => {
			e && (r ? ps(n.validatingFields, e, r) : Hs(n.validatingFields, e));
		}), f.state.next({
			validatingFields: n.validatingFields,
			isValidating: !Ms(n.validatingFields)
		}));
	}, y = (e, s = [], c, l, p = !0, m = !0) => {
		if (l && c && !t.disabled) {
			if (o.action = !0, m && Array.isArray(X(r, e))) {
				let t = c(X(r, e), l.argA, l.argB);
				p && ps(r, e, t);
			}
			if (m && Array.isArray(X(n.errors, e))) {
				let t = c(X(n.errors, e), l.argA, l.argB);
				p && ps(n.errors, e, t), pc(n.errors, e);
			}
			if ((u.touchedFields || d.touchedFields) && m && Array.isArray(X(n.touchedFields, e))) {
				let t = c(X(n.touchedFields, e), l.argA, l.argB);
				p && ps(n.touchedFields, e, t);
			}
			(u.dirtyFields || d.dirtyFields) && (n.dirtyFields = Ks(i, a)), f.state.next({
				name: e,
				isDirty: k(e, s),
				dirtyFields: n.dirtyFields,
				errors: n.errors,
				isValid: n.isValid
			});
		} else ps(a, e, s);
	}, b = (e, t) => {
		ps(n.errors, e, t), f.state.next({ errors: n.errors });
	}, x = (e) => {
		n.errors = e, f.state.next({
			errors: n.errors,
			isValid: !1
		});
	}, S = (e, t, n, s) => {
		let c = X(r, e);
		if (c) {
			let r = X(a, e, ls(n) ? X(i, e) : n);
			ls(r) || s && s.defaultChecked || t ? ps(a, e, t ? r : $s(c._f)) : M(e, r), o.mount && _();
		}
	}, C = (e, r, a, o, s) => {
		let c = !1, l = !1, p = { name: e };
		if (!t.disabled) {
			if (!a || o) {
				(u.isDirty || d.isDirty) && (l = n.isDirty, n.isDirty = p.isDirty = k(), c = l !== p.isDirty);
				let t = js(X(i, e), r);
				l = !!X(n.dirtyFields, e), t ? Hs(n.dirtyFields, e) : ps(n.dirtyFields, e, !0), p.dirtyFields = n.dirtyFields, c ||= (u.dirtyFields || d.dirtyFields) && l !== !t;
			}
			if (a) {
				let t = X(n.touchedFields, e);
				t || (ps(n.touchedFields, e, a), p.touchedFields = n.touchedFields, c ||= (u.touchedFields || d.touchedFields) && t !== a);
			}
			c && s && f.state.next(p);
		}
		return c ? p : {};
	}, w = (e, r, i, a) => {
		let o = X(n.errors, e), s = (u.isValid || d.isValid) && us(r) && n.isValid !== r;
		if (t.delayError && i ? (c = g(() => b(e, i)), c(t.delayError)) : (clearTimeout(l), c = null, i ? ps(n.errors, e, i) : Hs(n.errors, e)), (i ? !js(o, i) : o) || !Ms(a) || s) {
			let t = {
				...a,
				...s && us(r) ? { isValid: r } : {},
				errors: n.errors,
				name: e
			};
			n = {
				...n,
				...t
			}, f.state.next(t);
		}
	}, T = async (e) => {
		v(e, !0);
		let n = await t.resolver(a, t.context, ec(e || s.mount, r, t.criteriaMode, t.shouldUseNativeValidation));
		return v(e), n;
	}, E = async (e) => {
		let { errors: t } = await T(e);
		if (e) for (let r of e) {
			let e = X(t, r);
			e ? ps(n.errors, r, e) : Hs(n.errors, r);
		}
		else n.errors = t;
		return t;
	}, D = async (e, r, i = { valid: !0 }) => {
		for (let o in e) {
			let c = e[o];
			if (c) {
				let { _f: e, ...l } = c;
				if (e) {
					let l = s.array.has(e.name), d = c._f && ac(c._f);
					d && u.validatingFields && v([o], !0);
					let f = await vc(c, s.disabled, a, h, t.shouldUseNativeValidation && !r, l);
					if (d && u.validatingFields && v([o]), f[e.name] && (i.valid = !1, r)) break;
					!r && (X(f, e.name) ? l ? mc(n.errors, f, e.name) : ps(n.errors, e.name, f[e.name]) : Hs(n.errors, e.name));
				}
				!Ms(l) && await D(l, r, i);
			}
		}
		return i.valid;
	}, O = () => {
		for (let e of s.unMount) {
			let t = X(r, e);
			t && (t._f.refs ? t._f.refs.every((e) => !zs(e)) : !zs(t._f.ref)) && z(e);
		}
		s.unMount = /* @__PURE__ */ new Set();
	}, k = (e, n) => !t.disabled && (e && n && ps(a, e, n), !js(L(), i)), A = (e, t, n) => Cs(e, s, { ...o.mount ? a : ls(t) ? i : Ss(e) ? { [e]: t } : t }, n, t), j = (e) => cs(X(o.mount ? a : i, e, t.shouldUnregister ? X(i, e, []) : [])), M = (e, t, n = {}) => {
		let i = X(r, e), o = t;
		if (i) {
			let n = i._f;
			n && (!n.disabled && ps(a, e, Xs(t, n)), o = Fs(n.ref) && $o(t) ? "" : t, Is(n.ref) ? [...n.ref.options].forEach((e) => e.selected = o.includes(e.value)) : n.refs ? Zo(n.ref) ? n.refs.length > 1 ? n.refs.forEach((e) => (!e.defaultChecked || !e.disabled) && (e.checked = Array.isArray(o) ? !!o.find((t) => t === e.value) : o === e.value)) : n.refs[0] && (n.refs[0].checked = !!o) : n.refs.forEach((e) => e.checked = e.value === o) : Ns(n.ref) ? n.ref.value = "" : (n.ref.value = o, n.ref.type || f.state.next({
				name: e,
				values: ss(a)
			})));
		}
		(n.shouldDirty || n.shouldTouch) && C(e, o, n.shouldTouch, n.shouldDirty, !0), n.shouldValidate && ee(e);
	}, N = (e, t, n) => {
		for (let i in t) {
			let a = t[i], o = `${e}.${i}`, c = X(r, o);
			(s.array.has(e) || ts(a) || c && !c._f) && !Qo(a) ? N(o, a, n) : M(o, a, n);
		}
	}, P = (e, t, c = {}) => {
		let l = X(r, e), p = s.array.has(e), m = ss(t);
		ps(a, e, m), p ? (f.array.next({
			name: e,
			values: ss(a)
		}), (u.isDirty || u.dirtyFields || d.isDirty || d.dirtyFields) && c.shouldDirty && f.state.next({
			name: e,
			dirtyFields: Ks(i, a),
			isDirty: k(e, m)
		})) : l && !l._f && !$o(m) ? N(e, m, c) : M(e, m, c), sc(e, s) && f.state.next({ ...n }), f.state.next({
			name: o.mount ? e : void 0,
			values: ss(a)
		});
	}, F = async (e) => {
		o.mount = !0;
		let i = e.target, l = i.name, g = !0, y = X(r, l), b = (e) => {
			g = Number.isNaN(e) || Qo(e) && isNaN(e.getTime()) || js(e, X(a, l, e));
		};
		if (y) {
			let o, x, S = i.type ? $s(y._f) : ns(e), E = e.type === ms.BLUR || e.type === ms.FOCUS_OUT, O = !oc(y._f) && !t.resolver && !X(n.errors, l) && !y._f.deps || fc(E, X(n.touchedFields, l), n.isSubmitted, m, p), k = sc(l, s, E);
			ps(a, l, S), E ? (y._f.onBlur && y._f.onBlur(e), c && c(0)) : y._f.onChange && y._f.onChange(e);
			let A = C(l, S, E), j = !Ms(A) || k;
			if (!E && f.state.next({
				name: l,
				type: e.type,
				values: ss(a)
			}), O) return (u.isValid || d.isValid) && (t.mode === "onBlur" ? E && _() : E || _()), j && f.state.next({
				name: l,
				...k ? {} : A
			});
			if (!E && k && f.state.next({ ...n }), t.resolver) {
				let { errors: e } = await T([l]);
				if (b(S), g) {
					let t = lc(n.errors, r, l), i = lc(e, r, t.name || l);
					o = i.error, l = i.name, x = Ms(e);
				}
			} else v([l], !0), o = (await vc(y, s.disabled, a, h, t.shouldUseNativeValidation))[l], v([l]), b(S), g && (o ? x = !1 : (u.isValid || d.isValid) && (x = await D(r, !0)));
			g && (y._f.deps && ee(y._f.deps), w(l, x, o, A));
		}
	}, I = (e, t) => {
		if (X(n.errors, t) && e.focus) return e.focus(), 1;
	}, ee = async (e, i = {}) => {
		let a, o, c = Os(e);
		if (t.resolver) {
			let t = await E(ls(e) ? e : c);
			a = Ms(t), o = e ? !c.some((e) => X(t, e)) : a;
		} else e ? (o = (await Promise.all(c.map(async (e) => {
			let t = X(r, e);
			return await D(t && t._f ? { [e]: t } : t);
		}))).every(Boolean), !(!o && !n.isValid) && _()) : o = a = await D(r);
		return f.state.next({
			...!Ss(e) || (u.isValid || d.isValid) && a !== n.isValid ? {} : { name: e },
			...t.resolver || !e ? { isValid: a } : {},
			errors: n.errors
		}), i.shouldFocus && !o && cc(r, I, e ? c : s.mount), o;
	}, L = (e) => {
		let t = { ...o.mount ? a : i };
		return ls(e) ? t : Ss(e) ? X(t, e) : e.map((e) => X(t, e));
	}, te = (e, t) => ({
		invalid: !!X((t || n).errors, e),
		isDirty: !!X((t || n).dirtyFields, e),
		error: X((t || n).errors, e),
		isValidating: !!X(n.validatingFields, e),
		isTouched: !!X((t || n).touchedFields, e)
	}), ne = (e) => {
		e && Os(e).forEach((e) => Hs(n.errors, e)), f.state.next({ errors: e ? n.errors : {} });
	}, re = (e, t, i) => {
		let a = (X(r, e, { _f: {} })._f || {}).ref, { ref: o, message: s, type: c, ...l } = X(n.errors, e) || {};
		ps(n.errors, e, {
			...l,
			...t,
			ref: a
		}), f.state.next({
			name: e,
			errors: n.errors,
			isValid: !1
		}), i && i.shouldFocus && a && a.focus && a.focus();
	}, R = (e, t) => Ps(e) ? f.state.subscribe({ next: (n) => e(A(void 0, t), n) }) : A(e, t, !0), ie = (e) => f.state.subscribe({ next: (t) => {
		dc(e.name, t.name, e.exact) && uc(t, e.formState || u, he, e.reRenderRoot) && e.callback({
			values: { ...a },
			...n,
			...t
		});
	} }).unsubscribe, ae = (e) => (o.mount = !0, d = {
		...d,
		...e.formState
	}, ie({
		...e,
		formState: d
	})), z = (e, o = {}) => {
		for (let c of e ? Os(e) : s.mount) s.mount.delete(c), s.array.delete(c), o.keepValue || (Hs(r, c), Hs(a, c)), !o.keepError && Hs(n.errors, c), !o.keepDirty && Hs(n.dirtyFields, c), !o.keepTouched && Hs(n.touchedFields, c), !o.keepIsValidating && Hs(n.validatingFields, c), !t.shouldUnregister && !o.keepDefaultValue && Hs(i, c);
		f.state.next({ values: ss(a) }), f.state.next({
			...n,
			...o.keepDirty ? { isDirty: k() } : {}
		}), !o.keepIsValid && _();
	}, oe = ({ disabled: e, name: t }) => {
		(us(e) && o.mount || e || s.disabled.has(t)) && (e ? s.disabled.add(t) : s.disabled.delete(t));
	}, se = (e, n = {}) => {
		let a = X(r, e), c = us(n.disabled) || us(t.disabled);
		return ps(r, e, {
			...a || {},
			_f: {
				...a && a._f ? a._f : { ref: { name: e } },
				name: e,
				mount: !0,
				...n
			}
		}), s.mount.add(e), a ? oe({
			disabled: us(n.disabled) ? n.disabled : t.disabled,
			name: e
		}) : S(e, !0, n.value), {
			...c ? { disabled: n.disabled || t.disabled } : {},
			...t.progressive ? {
				required: !!n.required,
				min: nc(n.min),
				max: nc(n.max),
				minLength: nc(n.minLength),
				maxLength: nc(n.maxLength),
				pattern: nc(n.pattern)
			} : {},
			name: e,
			onChange: F,
			onBlur: F,
			ref: (c) => {
				if (c) {
					se(e, n), a = X(r, e);
					let t = ls(c.value) && c.querySelectorAll && c.querySelectorAll("input,select,textarea")[0] || c, o = Rs(t), s = a._f.refs || [];
					if (o ? s.find((e) => e === t) : t === a._f.ref) return;
					ps(r, e, { _f: {
						...a._f,
						...o ? {
							refs: [
								...s.filter(zs),
								t,
								...Array.isArray(X(i, e)) ? [{}] : []
							],
							ref: {
								type: t.type,
								name: e
							}
						} : { ref: t }
					} }), S(e, !1, void 0, t);
				} else a = X(r, e, {}), a._f && (a._f.mount = !1), (t.shouldUnregister || n.shouldUnregister) && !(is(s.array, e) && o.action) && s.unMount.add(e);
			}
		};
	}, ce = () => t.shouldFocusError && cc(r, I, s.mount), le = (e) => {
		us(e) && (f.state.next({ disabled: e }), cc(r, (t, n) => {
			let i = X(r, n);
			i && (t.disabled = i._f.disabled || e, Array.isArray(i._f.refs) && i._f.refs.forEach((t) => {
				t.disabled = i._f.disabled || e;
			}));
		}, 0, !1));
	}, ue = (e, i) => async (o) => {
		let c;
		o && (o.preventDefault && o.preventDefault(), o.persist && o.persist());
		let l = ss(a);
		if (f.state.next({ isSubmitting: !0 }), t.resolver) {
			let { errors: e, values: t } = await T();
			n.errors = e, l = t;
		} else await D(r);
		if (s.disabled.size) for (let e of s.disabled) ps(l, e, void 0);
		if (Hs(n.errors, "root"), Ms(n.errors)) {
			f.state.next({ errors: {} });
			try {
				await e(l, o);
			} catch (e) {
				c = e;
			}
		} else i && await i({ ...n.errors }, o), ce(), setTimeout(ce);
		if (f.state.next({
			isSubmitted: !0,
			isSubmitting: !1,
			isSubmitSuccessful: Ms(n.errors) && !c,
			submitCount: n.submitCount + 1,
			errors: n.errors
		}), c) throw c;
	}, de = (e, t = {}) => {
		X(r, e) && (ls(t.defaultValue) ? P(e, ss(X(i, e))) : (P(e, t.defaultValue), ps(i, e, ss(t.defaultValue))), t.keepTouched || Hs(n.touchedFields, e), t.keepDirty || (Hs(n.dirtyFields, e), n.isDirty = t.defaultValue ? k(e, ss(X(i, e))) : k()), t.keepError || (Hs(n.errors, e), u.isValid && _()), f.state.next({ ...n }));
	}, fe = (e, c = {}) => {
		let l = e ? ss(e) : i, d = ss(l), p = Ms(e), m = p ? i : d;
		if (c.keepDefaultValues || (i = l), !c.keepValues) {
			if (c.keepDirtyValues) {
				let e = /* @__PURE__ */ new Set([...s.mount, ...Object.keys(Ks(i, a))]);
				for (let t of Array.from(e)) X(n.dirtyFields, t) ? ps(m, t, X(a, t)) : P(t, X(m, t));
			} else {
				if (os && ls(e)) for (let e of s.mount) {
					let t = X(r, e);
					if (t && t._f) {
						let e = Array.isArray(t._f.refs) ? t._f.refs[0] : t._f.ref;
						if (Fs(e)) {
							let t = e.closest("form");
							if (t) {
								t.reset();
								break;
							}
						}
					}
				}
				for (let e of s.mount) P(e, X(m, e));
			}
			a = ss(m), f.array.next({ values: { ...m } }), f.state.next({ values: { ...m } });
		}
		s = {
			mount: c.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
			unMount: /* @__PURE__ */ new Set(),
			array: /* @__PURE__ */ new Set(),
			disabled: /* @__PURE__ */ new Set(),
			watch: /* @__PURE__ */ new Set(),
			watchAll: !1,
			focus: ""
		}, o.mount = !u.isValid || !!c.keepIsValid || !!c.keepDirtyValues, o.watch = !!t.shouldUnregister, f.state.next({
			submitCount: c.keepSubmitCount ? n.submitCount : 0,
			isDirty: p ? !1 : c.keepDirty ? n.isDirty : !!(c.keepDefaultValues && !js(e, i)),
			isSubmitted: c.keepIsSubmitted ? n.isSubmitted : !1,
			dirtyFields: p ? {} : c.keepDirtyValues ? c.keepDefaultValues && a ? Ks(i, a) : n.dirtyFields : c.keepDefaultValues && e ? Ks(i, e) : c.keepDirty ? n.dirtyFields : {},
			touchedFields: c.keepTouched ? n.touchedFields : {},
			errors: c.keepErrors ? n.errors : {},
			isSubmitSuccessful: c.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
			isSubmitting: !1
		});
	}, pe = (e, t) => fe(Ps(e) ? e(a) : e, t), me = (e, t = {}) => {
		let n = X(r, e), i = n && n._f;
		if (i) {
			let e = i.refs ? i.refs[0] : i.ref;
			e.focus && (e.focus(), t.shouldSelect && Ps(e.select) && e.select());
		}
	}, he = (e) => {
		n = {
			...n,
			...e
		};
	}, ge = {
		control: {
			register: se,
			unregister: z,
			getFieldState: te,
			handleSubmit: ue,
			setError: re,
			_subscribe: ie,
			_runSchema: T,
			_getWatch: A,
			_getDirty: k,
			_setValid: _,
			_setFieldArray: y,
			_setDisabledField: oe,
			_setErrors: x,
			_getFieldArray: j,
			_reset: fe,
			_resetDefaultValues: () => Ps(t.defaultValues) && t.defaultValues().then((e) => {
				pe(e, t.resetOptions), f.state.next({ isLoading: !1 });
			}),
			_removeUnmounted: O,
			_disableForm: le,
			_subjects: f,
			_proxyFormState: u,
			get _fields() {
				return r;
			},
			get _formValues() {
				return a;
			},
			get _state() {
				return o;
			},
			set _state(e) {
				o = e;
			},
			get _defaultValues() {
				return i;
			},
			get _names() {
				return s;
			},
			set _names(e) {
				s = e;
			},
			get _formState() {
				return n;
			},
			get _options() {
				return t;
			},
			set _options(e) {
				t = {
					...t,
					...e
				};
			}
		},
		subscribe: ae,
		trigger: ee,
		register: se,
		handleSubmit: ue,
		watch: R,
		setValue: P,
		getValues: L,
		reset: pe,
		resetField: de,
		clearErrors: ne,
		unregister: z,
		setError: re,
		setFocus: me,
		getFieldState: te
	};
	return {
		...ge,
		formControl: ge
	};
}
function xc(e = {}) {
	let t = H.useRef(void 0), n = H.useRef(void 0), [r, i] = H.useState({
		isDirty: !1,
		isValidating: !1,
		isLoading: Ps(e.defaultValues),
		isSubmitted: !1,
		isSubmitting: !1,
		isSubmitSuccessful: !1,
		isValid: !1,
		submitCount: 0,
		dirtyFields: {},
		touchedFields: {},
		validatingFields: {},
		errors: e.errors || {},
		disabled: e.disabled || !1,
		defaultValues: Ps(e.defaultValues) ? void 0 : e.defaultValues
	});
	t.current || (t.current = {
		...e.formControl ? e.formControl : bc(e),
		formState: r
	}, e.formControl && e.defaultValues && !Ps(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
	let a = t.current.control;
	return a._options = e, H.useLayoutEffect(() => a._subscribe({
		formState: a._proxyFormState,
		callback: () => i({ ...a._formState }),
		reRenderRoot: !0
	}), [a]), H.useEffect(() => a._disableForm(e.disabled), [a, e.disabled]), H.useEffect(() => {
		if (a._proxyFormState.isDirty) {
			let e = a._getDirty();
			e !== r.isDirty && a._subjects.state.next({ isDirty: e });
		}
	}, [a, r.isDirty]), H.useEffect(() => {
		e.values && !js(e.values, n.current) ? (a._reset(e.values, a._options.resetOptions), n.current = e.values, i((e) => ({ ...e }))) : a._resetDefaultValues();
	}, [e.values, a]), H.useEffect(() => {
		e.errors && !Ms(e.errors) && a._setErrors(e.errors);
	}, [e.errors, a]), H.useEffect(() => {
		a._state.mount || (a._setValid(), a._state.mount = !0), a._state.watch && (a._state.watch = !1, a._subjects.state.next({ ...a._formState })), a._removeUnmounted();
	}), H.useEffect(() => {
		e.shouldUnregister && a._subjects.state.next({ values: a._getWatch() });
	}, [e.shouldUnregister, a]), t.current.formState = bs(r, a), t.current;
}
//#endregion
//#region \0callable-external:lodash/identity
var Sc = gt;
//#endregion
//#region ../../shared/hook-form/dist/index.js
function Cc(e) {
	return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var wc = Xo, Tc = [
	"control",
	"defaultValue",
	"name",
	"rules",
	"shouldUnregister"
];
function Ec(e) {
	let t = wc(e, Tc);
	return {
		controller: Ts(t),
		controllerProps: t
	};
}
var Dc = [
	"className",
	"description",
	"disabled",
	"helpIcon",
	"label",
	"noAlert",
	"noLabel",
	"style"
];
function Oc(e) {
	let { controller: t, controllerProps: n } = Ec(e);
	return {
		controller: t,
		controllerProps: n,
		fieldWrapperProps: {
			...wc(e, Dc),
			required: Cc(n.rules?.required),
			meta: {
				touched: t.fieldState.isTouched,
				error: t.fieldState.error?.message,
				success: e.meta?.success,
				warning: e.meta?.warning
			},
			labelFor: n.name,
			noLabel: e.noLabel,
			noAlert: e.noAlert
		}
	};
}
var kc = ({ children: e, ...t }) => {
	let { controller: n, controllerProps: r, fieldWrapperProps: i } = Oc(t), { name: a, onBlur: o, onChange: s, ...c } = n.field;
	return /* @__PURE__ */ K(g, {
		...i,
		children: /* @__PURE__ */ K(C, {
			...t.componentProps,
			...c,
			multiple: !1,
			value: c.value ? [c.value] : [],
			onBlur: (e) => {
				t.componentProps?.onBlur?.(e), o();
			},
			onChange: (e) => {
				t.componentProps?.onChange?.(e), s(e.selectedValues[0] ?? null);
			},
			id: r.name,
			"aria-disabled": i.disabled,
			disabled: i.disabled,
			"aria-required": i.required,
			required: i.required,
			status: g.getStatus(i.meta),
			children: e
		})
	});
}, Ac = Sc, Z = ({ transformValue: e = Ac, label: t, helpIcon: n, className: r, ...i }) => {
	let { controller: { field: a }, controllerProps: { name: o } } = Ec(i);
	return /* @__PURE__ */ q(_, {
		gap: "200",
		alignItems: "center",
		className: r,
		children: [/* @__PURE__ */ K(P, {
			...a,
			id: o,
			checked: e(a.value),
			disabled: i.componentProps?.disabled,
			onChange: (t) => {
				i.componentProps?.onChange?.(t), a.onChange(e(t.target.checked));
			}
		}), t && /* @__PURE__ */ K(f, {
			htmlFor: o,
			helpIcon: n,
			children: t
		})]
	});
}, jc = (e) => {
	let { controller: t, controllerProps: n, fieldWrapperProps: r } = Oc(e);
	return /* @__PURE__ */ K(g, {
		...r,
		children: /* @__PURE__ */ K(w, {
			...e.componentProps,
			...t.field,
			value: e.componentProps?.type === "number" && isNaN(t.field.value) ? "" : t.field.value ?? "",
			onBlur: (n) => {
				e.componentProps?.onBlur?.(n), t.field.onBlur();
			},
			onChange: (n) => {
				e.componentProps?.onChange?.(n), t.field.onChange(e.componentProps?.type === "number" ? n.target.valueAsNumber : n);
			},
			id: n.name,
			"aria-disabled": r.disabled,
			disabled: r.disabled,
			"aria-required": r.required,
			required: r.required,
			status: g.getStatus(r.meta)
		})
	});
};
//#endregion
//#region ../widget-braze/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._copyIcon_10dvk_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_10dvk_59{background:linear-gradient(var(--dixa-color-neutral-000) 33%, #fff0), linear-gradient(#fff0, var(--dixa-color-neutral-000) 66%) 0 100%, radial-gradient(farthest-side at 50% 0, var(--dixa-color-neutral-200), #0000), radial-gradient(farthest-side at 50% 100%, var(--dixa-color-neutral-200), #0000) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-200), 100% var(--dixa-size-spacer-200);max-height:250px;padding:0;overflow-y:auto}._listItem_10dvk_69{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);background-color:#0000}._listItem_10dvk_69:last-child:not(:only-child){border-bottom:none}._collapsible_10dvk_78{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_10dvk_78:hover,._collapsibleIsOpen_10dvk_86{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_10dvk_89{cursor:pointer}._collapsibleIconTrue_10dvk_92{color:var(--dixa-color-green-500)}._collapsibleIconFalse_10dvk_95{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var Mc = {
	"\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "getCustomerDetails"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Braze_exportUserDetails_request_Input"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Braze"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "exportUserDetails"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Braze_exportUserDetails_response"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Braze_ExportedUserDetails"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "message"
													}
												}, {
													kind: "Field",
													name: {
														kind: "Name",
														value: "users"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "external_id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "braze_id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "created_at"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "email"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "first_name"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "last_name"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "dob"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "home_city"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "country"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "phone"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "language"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "time_zone"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "total_revenue"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "push_subscribe"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "email_subscribe"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "custom_attributes"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "apps"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "name"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "platform"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "version"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "sessions"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "first_used"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "last_used"
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "devices"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "model"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "os"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "carrier"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "idfv"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "idfa"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "google_ad_id"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "roku_ad_id"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "ad_tracking_enabled"
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "custom_events"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "name"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "first"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "last"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "count"
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "purchases"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "name"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "first"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "last"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "count"
																			}
																		}
																	]
																}
															}
														]
													}
												}]
											}
										}, {
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Braze_BasicResponse"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "message"
													}
												}]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "updateEmailSubscriptionStatus"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Braze_updateEmailSubscriptionStatus_request_Input"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Braze"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "updateEmailSubscriptionStatus"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "message"
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	}
};
function Nc(e) {
	return Mc[e] ?? {};
}
var Pc = Nc("\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n"), Fc = Nc("\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n"), Ic = Yo, Lc = {
	copyIcon: "_copyIcon_10dvk_54",
	list: "_list_10dvk_59",
	listItem: "_listItem_10dvk_69",
	collapsible: "_collapsible_10dvk_78",
	collapsibleIsOpen: "_collapsibleIsOpen_10dvk_86",
	collapsibleHeader: "_collapsibleHeader_10dvk_89",
	collapsibleIconTrue: "_collapsibleIconTrue_10dvk_92",
	collapsibleIconFalse: "_collapsibleIconFalse_10dvk_95"
}, Rc = ({ app: e, openByDefault: t }) => {
	let [n, r] = W(t);
	if (!e) return null;
	let { name: i, platform: a, version: o, sessions: s, first_used: c, last_used: l } = e;
	return /* @__PURE__ */ q(_, {
		className: ae(Lc.collapsible, { [Lc.collapsibleIsOpen]: n }),
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			justifyContent: "space-between",
			alignItems: "center",
			className: Lc.collapsibleHeader,
			onClick: () => r(!n),
			children: [/* @__PURE__ */ K(L.Paragraph, {
				variant: "1",
				children: i
			}), /* @__PURE__ */ K(x, {
				variant: "tertiary",
				icon: n ? "angle-down" : "angle-right"
			})]
		}), n && /* @__PURE__ */ q(T, {
			className: Lc.list,
			children: [
				/* @__PURE__ */ K(T.Text, {
					variant: "dense",
					className: Lc.listItem,
					children: /* @__PURE__ */ q(_, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Platform"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: a
						})]
					})
				}),
				/* @__PURE__ */ K(T.Text, {
					variant: "dense",
					className: Lc.listItem,
					children: /* @__PURE__ */ q(_, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Version"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: o
						})]
					})
				}),
				/* @__PURE__ */ K(T.Text, {
					variant: "dense",
					className: Lc.listItem,
					children: /* @__PURE__ */ q(_, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Sessions"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: s
						})]
					})
				}),
				/* @__PURE__ */ K(T.Text, {
					variant: "dense",
					className: Lc.listItem,
					children: /* @__PURE__ */ q(_, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "First used"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: Ic(c).format(he)
						})]
					})
				}),
				/* @__PURE__ */ K(T.Text, {
					variant: "dense",
					className: Lc.listItem,
					children: /* @__PURE__ */ q(_, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Last used"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: Ic(l).format(he)
						})]
					})
				})
			]
		})]
	});
}, zc = ({ apps: e }) => {
	let t = e && e?.length > 0;
	return /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		margin: "200 0 0",
		children: [
			/* @__PURE__ */ q(_, {
				gap: "200",
				flexDirection: "row",
				alignItems: "center",
				children: [/* @__PURE__ */ K(L.Heading, {
					variant: "heading-3",
					children: "Apps"
				}), t && /* @__PURE__ */ K(n, {
					size: "small",
					variant: "success",
					children: e.length
				})]
			}),
			!t && /* @__PURE__ */ K(L.Paragraph, {
				variant: "4",
				margin: "200 0 300 0",
				color: "secondary",
				align: "center",
				children: "There are no apps associated with this customer"
			}),
			e?.map((e, t) => /* @__PURE__ */ K(Rc, {
				app: e,
				openByDefault: t === 0
			}, t))
		]
	});
}, Bc = ({ customerDetails: e }) => {
	if (!e) return null;
	let { custom_attributes: t } = e, n = !!t && Object.keys(t).length > 0;
	return /* @__PURE__ */ K(G, { children: /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ K(L.Heading, {
				variant: "heading-3",
				children: "Custom attributes"
			}),
			!n && /* @__PURE__ */ K(L.Paragraph, {
				variant: "4",
				color: "secondary",
				align: "center",
				children: "No custom attributes available"
			}),
			n && /* @__PURE__ */ K(T, {
				className: Lc.list,
				children: Object.entries(t).map(([e, t], n) => (typeof t == "boolean" || typeof t == "string" || typeof t == "number") && /* @__PURE__ */ K(T.Text, {
					variant: "dense",
					className: Lc.listItem,
					children: /* @__PURE__ */ q(_, {
						justifyContent: "space-between",
						alignItems: "center",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: e
						}), ge(t)]
					})
				}, n))
			})
		]
	}) });
}, Vc = ({ customerDetails: e }) => {
	if (!e) return null;
	let { custom_events: t } = e, n = t?.sort((e, t) => t?.count - e?.count), r = n && n.length > 0;
	return /* @__PURE__ */ K(G, { children: /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ K(L.Heading, {
				variant: "heading-3",
				children: "Custom events"
			}),
			!r && /* @__PURE__ */ K(L.Paragraph, {
				variant: "4",
				color: "secondary",
				align: "center",
				children: "No custom events available"
			}),
			r && /* @__PURE__ */ K(T, {
				className: Lc.list,
				children: n.map((e, t) => /* @__PURE__ */ K(T.Text, {
					variant: "dense",
					className: Lc.listItem,
					children: /* @__PURE__ */ q(_, {
						justifyContent: "space-between",
						children: [/* @__PURE__ */ K(R, {
							content: /* @__PURE__ */ q(_, {
								flexDirection: "column",
								children: [/* @__PURE__ */ K(_, { children: `First ${Ic(e?.first).format(he)}` }), /* @__PURE__ */ K(_, { children: `Last ${Ic(e?.last).format(he)}` })]
							}),
							children: /* @__PURE__ */ K(L.Paragraph, {
								variant: "4",
								children: e?.name
							})
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "5",
							children: e?.count
						})]
					})
				}, t))
			})
		]
	}) });
}, Hc = ({ state: e, noTooltip: t = !1, isPush: n = !1 }) => {
	if (!e) return null;
	let r = e === "subscribed", i = e === "unsubscribed";
	return /* @__PURE__ */ K(R, {
		content: t ? null : (() => {
			let e = n ? "push notifications" : "emails";
			return r ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${e}. This is the default subscription state when a user profile is created.` : i ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${e}.` : `Opted in: The user has explicitly confirmed they want to receive ${e}.`;
		})(),
		children: /* @__PURE__ */ K(_, {
			alignItems: "center",
			children: /* @__PURE__ */ K(b, {
				size: 14,
				name: r ? "exclamation" : i ? "close-circle-filled" : "check-circle-filled",
				color: r ? "neutral.500" : i ? "red.500" : "green.500"
			})
		})
	});
}, Uc = {
	wrapper: "_wrapper_1xucg_1",
	externalLink: "_externalLink_1xucg_7"
}, Wc = ({ customerDetails: e }) => {
	let { isCopied: t, copy: n } = Re(), { isCopied: r, copy: i } = Re(), { isCopied: a, copy: o } = Re(), { isCopied: s, copy: c } = Re(), { isCopied: l, copy: u } = Re();
	if (!e) return null;
	let { external_id: d, braze_id: f, first_name: p, last_name: m, home_city: h, country: g, email: v, phone: y, dob: x, created_at: S, email_subscribe: C, push_subscribe: w } = e, T = `${p || ""} ${m || ""}`.trim() || "A customer has no name", E = `${h ? `${h} /` : ""} ${g || ""}`.trim(), D = x ? Ic(x).isSame(Date.now(), "day") : !1;
	return /* @__PURE__ */ K(_, {
		gap: "300",
		flexDirection: "column",
		children: /* @__PURE__ */ q(_, {
			className: Uc.wrapper,
			gap: "200",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ q(_, {
					justifyContent: "space-between",
					className: Uc.block,
					alignItems: "center",
					children: [/* @__PURE__ */ K(L.Heading, {
						variant: "heading-2",
						children: T
					}), D && /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: "... has birthday today 🥳"
					})]
				}),
				S && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					margin: "0 0 200",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: "Member since"
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: Ic(S).format(he)
					})]
				}),
				E && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "map-pin"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: E
						})]
					}), /* @__PURE__ */ K(R, {
						content: "Copy location",
						children: /* @__PURE__ */ K(_, {
							alignItems: "center",
							children: /* @__PURE__ */ K(b, {
								size: 14,
								name: a ? "done" : "copy",
								onClick: () => o(E),
								className: Lc.copyIcon
							})
						})
					})]
				}),
				v && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "mail"
						}), /* @__PURE__ */ K("span", {
							className: Uc.externalLink,
							children: v
						})]
					}), /* @__PURE__ */ K(R, {
						content: "Copy email",
						children: /* @__PURE__ */ K(_, {
							alignItems: "center",
							children: /* @__PURE__ */ K(b, {
								size: 14,
								name: t ? "done" : "copy",
								onClick: () => n(v),
								className: Lc.copyIcon
							})
						})
					})]
				}),
				y && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "phone"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: y
						})]
					}), /* @__PURE__ */ K(R, {
						content: "Copy phone number",
						children: /* @__PURE__ */ K(_, {
							alignItems: "center",
							children: /* @__PURE__ */ K(b, {
								size: 14,
								name: r ? "done" : "copy",
								onClick: () => i(y),
								className: Lc.copyIcon
							})
						})
					})]
				}),
				f && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						gap: "200",
						alignItems: "center",
						children: [
							/* @__PURE__ */ K(b, {
								size: 14,
								name: "user"
							}),
							/* @__PURE__ */ K(L.Paragraph, {
								variant: "4",
								children: "Braze ID"
							}),
							/* @__PURE__ */ q(L.Paragraph, {
								variant: "5",
								subdued: !0,
								color: "tertiary",
								children: [
									"(",
									f,
									")"
								]
							})
						]
					}), /* @__PURE__ */ K(R, {
						content: "Copy Braze ID",
						children: /* @__PURE__ */ K(_, {
							alignItems: "center",
							children: /* @__PURE__ */ K(b, {
								size: 14,
								name: s ? "done" : "copy",
								onClick: () => c(f),
								className: Lc.copyIcon
							})
						})
					})]
				}),
				d && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						gap: "200",
						alignItems: "center",
						children: [
							/* @__PURE__ */ K(b, {
								size: 14,
								name: "tag"
							}),
							/* @__PURE__ */ K(L.Paragraph, {
								variant: "4",
								children: "External ID"
							}),
							/* @__PURE__ */ q(L.Paragraph, {
								variant: "5",
								subdued: !0,
								color: "tertiary",
								children: [
									"(",
									d,
									")"
								]
							})
						]
					}), /* @__PURE__ */ K(R, {
						content: "Copy External ID",
						children: /* @__PURE__ */ K(_, {
							alignItems: "center",
							children: /* @__PURE__ */ K(b, {
								size: 14,
								name: l ? "done" : "copy",
								onClick: () => u(d),
								className: Lc.copyIcon
							})
						})
					})]
				}),
				C && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "sync"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: "Email subscription state"
						})]
					}), /* @__PURE__ */ K(Hc, { state: C })]
				}),
				w && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "bell"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: "Push notification subscription state"
						})]
					}), /* @__PURE__ */ K(Hc, {
						isPush: !0,
						state: w
					})]
				})
			]
		})
	});
}, Gc = ({ device: e, openByDefault: t }) => {
	let [n, r] = W(t);
	if (!e) return null;
	let { model: i, os: a, carrier: o, ad_tracking_enabled: s, idfa: c, idfv: l, google_ad_id: u, roku_ad_id: d } = e;
	return /* @__PURE__ */ q(_, {
		className: ae(Lc.collapsible, { [Lc.collapsibleIsOpen]: n }),
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			justifyContent: "space-between",
			alignItems: "center",
			className: Lc.collapsibleHeader,
			onClick: () => r(!n),
			children: [/* @__PURE__ */ K(L.Paragraph, {
				variant: "1",
				children: i
			}), /* @__PURE__ */ K(x, {
				variant: "tertiary",
				icon: n ? "angle-down" : "angle-right"
			})]
		}), n && /* @__PURE__ */ q(T, {
			className: Lc.list,
			children: [
				/* @__PURE__ */ K(T.Text, {
					variant: "dense",
					className: Lc.listItem,
					children: /* @__PURE__ */ q(_, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "OS"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: a
						})]
					})
				}),
				/* @__PURE__ */ K(T.Text, {
					variant: "dense",
					className: Lc.listItem,
					children: /* @__PURE__ */ q(_, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Carrier"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: o
						})]
					})
				}),
				/* @__PURE__ */ K(T.Text, {
					variant: "dense",
					className: Lc.listItem,
					children: /* @__PURE__ */ q(_, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Ad tracking enabled"
						}), /* @__PURE__ */ K(b, {
							size: 14,
							className: ae({
								[Lc.collapsibleIconTrue]: s,
								[Lc.collapsibleIconFalse]: !s
							}),
							name: s ? "check-circle-filled" : "close-circle-filled"
						})]
					})
				}),
				/* @__PURE__ */ K(R, {
					content: "The Apple Identifier for Vendor (iOS)",
					children: /* @__PURE__ */ K(T.Text, {
						variant: "dense",
						className: Lc.listItem,
						children: /* @__PURE__ */ q(_, {
							gap: "200",
							justifyContent: "space-between",
							width: "100%",
							flexWrap: "wrap",
							children: [/* @__PURE__ */ K(L.Paragraph, {
								variant: "3",
								children: "Braze device identifier"
							}), /* @__PURE__ */ K(L.Paragraph, {
								variant: "5",
								color: "secondary",
								children: l
							})]
						})
					})
				}),
				/* @__PURE__ */ K(R, {
					content: "For iOS",
					children: /* @__PURE__ */ K(T.Text, {
						variant: "dense",
						className: Lc.listItem,
						children: /* @__PURE__ */ q(_, {
							gap: "200",
							justifyContent: "space-between",
							width: "100%",
							flexWrap: "wrap",
							children: [/* @__PURE__ */ K(L.Paragraph, {
								variant: "3",
								children: "Identifier for Advertising"
							}), /* @__PURE__ */ K(L.Paragraph, {
								variant: "5",
								color: "secondary",
								children: c
							})]
						})
					})
				}),
				/* @__PURE__ */ K(T.Text, {
					variant: "dense",
					className: Lc.listItem,
					children: /* @__PURE__ */ q(_, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						flexWrap: "wrap",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Roku Advertising id"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: d
						})]
					})
				}),
				/* @__PURE__ */ K(T.Text, {
					variant: "dense",
					className: Lc.listItem,
					children: /* @__PURE__ */ q(_, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						flexWrap: "wrap",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Google Play Advertising id"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: u
						})]
					})
				})
			]
		})]
	});
}, Kc = ({ devices: e }) => {
	let t = e && e?.length > 0;
	return /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		margin: "200 0 0",
		children: [
			/* @__PURE__ */ q(_, {
				gap: "200",
				flexDirection: "row",
				alignItems: "center",
				children: [/* @__PURE__ */ K(L.Heading, {
					variant: "heading-3",
					children: "Devices"
				}), t && /* @__PURE__ */ K(n, {
					size: "small",
					variant: "success",
					children: e.length
				})]
			}),
			!t && /* @__PURE__ */ K(L.Paragraph, {
				variant: "4",
				margin: "200 0 300 0",
				color: "secondary",
				align: "center",
				children: "There are no devices associated with this customer"
			}),
			e?.map((e, t) => /* @__PURE__ */ K(Gc, {
				device: e,
				openByDefault: t === 0
			}, t))
		]
	});
}, qc = {
	optIn: {
		label: "Opt in",
		icon: "check-circle-filled",
		color: "var(--dixa-color-green-500)",
		tooltipContent: "Opt in to receive emails",
		parameter: "opted_in"
	},
	unsubscribe: {
		label: "Unsubscribe",
		icon: "close-circle-filled",
		color: "var(--dixa-color-red-500)",
		tooltipContent: "Unsubscribe from emails",
		parameter: "unsubscribed"
	}
}, Jc = ({ email: e, updateTo: t, refetchCustomerDetails: n }) => {
	let { track: r } = B(), { useMutation: i } = V(), [o, s] = W(!1), [c] = i(Fc, { onCompleted: (e) => {
		e?.Braze?.updateEmailSubscriptionStatus?.message === "success" && r(t === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
	} }), l = async () => {
		s(!0), await c({ variables: { input: {
			email: e,
			subscription_state: qc[t].parameter
		} } }), setTimeout(async () => {
			await n().finally(() => s(!1));
		}, 500);
	};
	return /* @__PURE__ */ K(R, {
		content: qc[t].tooltipContent,
		children: /* @__PURE__ */ K(a, {
			variant: "secondary",
			color: qc[t].color,
			isLoading: o,
			onClick: () => l(),
			"data-testid": "braze-subscription-button",
			children: /* @__PURE__ */ q(_, {
				gap: "100",
				alignItems: "center",
				children: [/* @__PURE__ */ K(Hc, {
					noTooltip: !0,
					state: qc[t].parameter
				}), qc[t].label]
			})
		})
	});
}, Yc = ({ customerDetails: e, showCustomerDetails: t, refetchCustomerDetails: n }) => {
	if (!e) return null;
	let { email: r, email_subscribe: i } = e;
	if (!r) return null;
	let a = i === "subscribed", o = i === "unsubscribed", s = i === "opted_in";
	return /* @__PURE__ */ K(_, {
		gap: "300",
		flexDirection: "column",
		children: /* @__PURE__ */ q(_, {
			gap: "200",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ K(L.Heading, {
					variant: "heading-3",
					children: "Update Email subscription state"
				}),
				!t && /* @__PURE__ */ K(T, {
					className: Lc.list,
					children: /* @__PURE__ */ K(T.Text, {
						variant: "dense",
						className: Lc.listItem,
						children: /* @__PURE__ */ q(_, {
							justifyContent: "space-between",
							children: [/* @__PURE__ */ q(_, {
								gap: "200",
								alignItems: "center",
								children: [/* @__PURE__ */ K(b, {
									size: 14,
									name: "sync"
								}), /* @__PURE__ */ K(L.Paragraph, {
									variant: "4",
									children: "Email subscription state"
								})]
							}), /* @__PURE__ */ K(Hc, { state: i })]
						})
					})
				}),
				/* @__PURE__ */ q(_, {
					gap: "200",
					alignItems: "center",
					children: [
						a && /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(Jc, {
							email: r,
							updateTo: "optIn",
							refetchCustomerDetails: n
						}), /* @__PURE__ */ K(Jc, {
							email: r,
							updateTo: "unsubscribe",
							refetchCustomerDetails: n
						})] }),
						o && /* @__PURE__ */ K(Jc, {
							email: r,
							updateTo: "optIn",
							refetchCustomerDetails: n
						}),
						s && /* @__PURE__ */ K(Jc, {
							email: r,
							updateTo: "unsubscribe",
							refetchCustomerDetails: n
						})
					]
				})
			]
		})
	});
}, Xc = ({ customerDetails: e }) => {
	if (!e) return null;
	let { purchases: t } = e, n = t?.sort((e, t) => t?.count - e?.count), r = n && n.length > 0;
	return /* @__PURE__ */ K(G, { children: /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ K(L.Heading, {
				variant: "heading-3",
				children: "Purchases"
			}),
			!r && /* @__PURE__ */ K(L.Paragraph, {
				variant: "4",
				color: "secondary",
				align: "center",
				children: "No purchases available"
			}),
			r && /* @__PURE__ */ K(T, {
				className: Lc.list,
				children: n.map((e, t) => /* @__PURE__ */ K(T.Text, {
					variant: "dense",
					className: Lc.listItem,
					children: /* @__PURE__ */ q(_, {
						justifyContent: "space-between",
						children: [/* @__PURE__ */ K(R, {
							content: /* @__PURE__ */ q(_, {
								flexDirection: "column",
								children: [/* @__PURE__ */ K(_, { children: `First ${Ic(e?.first).format(he)}` }), /* @__PURE__ */ K(_, { children: `Last ${Ic(e?.last).format(he)}` })]
							}),
							children: /* @__PURE__ */ K(L.Paragraph, {
								variant: "4",
								children: e?.name
							})
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "5",
							children: e?.count
						})]
					})
				}, t))
			})
		]
	}) });
}, Zc = ({ conversationContext: e, settings: t }) => {
	let { track: n } = B(), { useMutation: r } = V(), [i, a] = W(), [o, s] = W(!1), [c, l] = W(!1), u = e?.customer?.email, d = e?.customer?.phone_number, f = t.displayCustomerDetails ?? !1, p = t.updateEmailSubscriptionState ?? !1, m = t.displayCustomAttributes ?? !1, h = t.displayCustomEvents ?? !1, g = t.displayPuchases ?? !1, v = t.displayDevices ?? !1, y = t.displayApps ?? !1, b = !f && !p && !m && !h && !g, [x, { error: S }] = r(Pc, {
		onError: () => {},
		onCompleted: (e) => {
			let t = (e?.Braze?.exportUserDetails)?.users?.[0];
			t ? (a(t), s(!1), n("braze:profile:received")) : (a(void 0), s(!0));
		}
	}), C = async () => {
		u || d ? await x({ variables: { input: {
			...u ? { email_address: u } : { phone: d },
			fields_to_export: [
				"external_id",
				"braze_id",
				"created_at",
				"email",
				"first_name",
				"last_name",
				"dob",
				"home_city",
				"country",
				"phone",
				"language",
				"time_zone",
				"total_revenue",
				"push_subscribe",
				"email_subscribe",
				"custom_attributes",
				"custom_events",
				"purchases",
				"apps",
				"devices"
			]
		} } }) : s(!0);
	};
	if (U(() => {
		async function e() {
			l(!0), await C();
		}
		e().finally(() => l(!1));
	}, [u, d]), S) {
		let e = S.graphQLErrors;
		return xe({ errors: e }) ? /* @__PURE__ */ K(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			"data-testid": "widget-downstream-api-forbidden-error",
			children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
		}) : be({ errors: e }) ? /* @__PURE__ */ K(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			"data-testid": "widget-downstream-api-authorization-error",
			children: "The integration could not authorize against Braze. Please contact your administrator."
		}) : /* @__PURE__ */ K(z, { error: S });
	}
	return c ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "300",
		children: /* @__PURE__ */ K(N, {})
	}) : b ? /* @__PURE__ */ K(L.Paragraph, {
		margin: "200 0 300 0",
		color: "secondary",
		align: "center",
		"data-testid": "widget-no-features",
		children: "All features toggles in the settings are disabled."
	}) : o ? /* @__PURE__ */ K(L.Paragraph, {
		margin: "200 0 300 0",
		color: "secondary",
		align: "center",
		"data-testid": "widget-no-customer-found",
		children: "No customer found with this email or phone number."
	}) : /* @__PURE__ */ q(_, {
		gap: "300",
		flexDirection: "column",
		margin: "0 0 300 0",
		"data-testid": "widget-wrapper",
		children: [
			f && /* @__PURE__ */ K(Wc, { customerDetails: i }),
			p && !!i && /* @__PURE__ */ K(Yc, {
				customerDetails: i,
				showCustomerDetails: f,
				refetchCustomerDetails: async () => await C()
			}),
			m && !!i && /* @__PURE__ */ K(Bc, { customerDetails: i }),
			h && !!i && /* @__PURE__ */ K(Vc, { customerDetails: i }),
			g && !!i && /* @__PURE__ */ K(Xc, { customerDetails: i }),
			v && !!i && /* @__PURE__ */ K(Kc, { devices: i?.devices }),
			y && !!i && /* @__PURE__ */ K(zc, { apps: i?.apps })
		]
	});
}, Qc = [
	{
		key: "apiHostName",
		label: "API endpoint",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "brazeApiKey",
		label: "API key",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "displayCustomerDetails",
		label: "Display customer details",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "updateEmailSubscriptionState",
		label: "Display the button to change the email subscription state",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayCustomAttributes",
		label: "Display a list of custom attributes",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayCustomEvents",
		label: "Display a list of custom events",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayPuchases",
		label: "Display a list of purchases",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayDevices",
		label: "Display customer devices",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayApps",
		label: "Display customer apps",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	}
], $c = Pe(Qc), el = {
	enabled: !1,
	name: "",
	brazeApiKey: "",
	...Le([], Qc)
}, tl = ({ integrationId: e, handleRedirect: t, showNotification: n, automationCouplingState: r, renderConditionsEditor: i }) => {
	let a = !e, o = xc({
		mode: "onChange",
		defaultValues: el
	}), { create: s, update: c, remove: l, isLoading: u, error: d, misconfigurationCause: f, setMisconfigurationCause: p } = Ve({
		integrationId: e,
		integrationType: "BRAZE",
		handleRedirect: t,
		showNotification: n
	}), { isLoading: m, error: h, isWidgetUnknown: _, refetch: b, widgetConfiguration: x } = He({
		integrationId: e,
		fieldDefinitions: Qc,
		form: o,
		onMisconfigured: p
	}), { renderConditions: S, setRenderConditions: C, renderConditionsForSubmit: w } = Be({
		integrationId: e,
		widgetConfiguration: x,
		renderConditionsEditor: i
	}), T = (e) => ye(e, {
		fieldDefinitions: Qc,
		isCreationMode: a,
		create: s,
		update: c,
		renderConditions: w
	}), E = o.watch("name");
	return /* @__PURE__ */ q(de, {
		form: o,
		integrationId: e,
		onValidSubmit: T,
		error: h ?? d,
		onRetry: h ? b : void 0,
		isLoading: u || m,
		isWidgetUnknown: _,
		children: [
			f && /* @__PURE__ */ K(se, { cause: f }),
			/* @__PURE__ */ q(y, { children: [
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ K(Z, {
						name: "enabled",
						control: o.control
					})
				}) }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "name",
						label: "Widget name",
						control: o.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "apiHostName",
						label: $c.apiHostName,
						control: o.control,
						rules: {
							required: "API endpoint is required",
							validate: (e) => Ue(e) || !0
						},
						componentProps: {
							placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
							autoComplete: "off",
							prefix: "https://"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(ue, {
						name: "brazeApiKey",
						label: $c.brazeApiKey,
						control: o.control,
						isCreationMode: a,
						rules: { required: "API key is required" },
						componentProps: {
							placeholder: "Insert your API key",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: $c.displayCustomerDetails,
						children: /* @__PURE__ */ K(Z, {
							name: "displayCustomerDetails",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: $c.updateEmailSubscriptionState,
						children: /* @__PURE__ */ K(Z, {
							name: "updateEmailSubscriptionState",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: $c.displayCustomAttributes,
						children: /* @__PURE__ */ K(Z, {
							name: "displayCustomAttributes",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: $c.displayCustomEvents,
						children: /* @__PURE__ */ K(Z, {
							name: "displayCustomEvents",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: $c.displayPuchases,
						children: /* @__PURE__ */ K(Z, {
							name: "displayPuchases",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: $c.displayDevices,
						children: /* @__PURE__ */ K(Z, {
							name: "displayDevices",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: $c.displayApps,
						children: /* @__PURE__ */ K(Z, {
							name: "displayApps",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				i && S !== null && /* @__PURE__ */ K(v, { children: i({
					value: S,
					onChange: C,
					configurationKey: x?.id
				}) })
			] }),
			/* @__PURE__ */ K(pe, {
				integrationType: "BRAZE",
				integrationId: e,
				widgetName: E,
				isCreationMode: a,
				isSubmitting: o.formState.isSubmitting,
				automationCouplingState: r,
				onConfirmDelete: () => l()
			})
		]
	});
};
//#endregion
//#region ../../../node_modules/react-use/esm/useMountedState.js
function nl() {
	var e = $e(!1), t = Je(function() {
		return e.current;
	}, []);
	return U(function() {
		return e.current = !0, function() {
			e.current = !1;
		};
	}, []), t;
}
//#endregion
//#region ../../../node_modules/react-use/esm/useSetState.js
var rl = function(e) {
	e === void 0 && (e = {});
	var t = W(e), n = t[0], r = t[1];
	return [n, Je(function(e) {
		r(function(t) {
			return Object.assign({}, t, e instanceof Function ? e(t) : e);
		});
	}, [])];
}, il = function(e, t) {
	return typeof t == "boolean" ? t : !e;
}, al = function(e) {
	return Qe(il, e);
}, ol = /* @__PURE__ */ Tt(((e, t) => {
	t.exports = function() {
		var e = document.getSelection();
		if (!e.rangeCount) return function() {};
		for (var t = document.activeElement, n = [], r = 0; r < e.rangeCount; r++) n.push(e.getRangeAt(r));
		switch (t.tagName.toUpperCase()) {
			case "INPUT":
			case "TEXTAREA":
				t.blur();
				break;
			default:
				t = null;
				break;
		}
		return e.removeAllRanges(), function() {
			e.type === "Caret" && e.removeAllRanges(), e.rangeCount || n.forEach(function(t) {
				e.addRange(t);
			}), t && t.focus();
		};
	};
})), sl = /* @__PURE__ */ Ot((/* @__PURE__ */ Tt(((e, t) => {
	var n = ol(), r = {
		"text/plain": "Text",
		"text/html": "Url",
		default: "Text"
	}, i = "Copy to clipboard: #{key}, Enter";
	function a(e) {
		var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
		return e.replace(/#{\s*key\s*}/g, t);
	}
	function o(e, t) {
		var o, s, c, l, u, d, f = !1;
		t ||= {}, o = t.debug || !1;
		try {
			if (c = n(), l = document.createRange(), u = document.getSelection(), d = document.createElement("span"), d.textContent = e, d.ariaHidden = "true", d.style.all = "unset", d.style.position = "fixed", d.style.top = 0, d.style.clip = "rect(0, 0, 0, 0)", d.style.whiteSpace = "pre", d.style.webkitUserSelect = "text", d.style.MozUserSelect = "text", d.style.msUserSelect = "text", d.style.userSelect = "text", d.addEventListener("copy", function(n) {
				if (n.stopPropagation(), t.format) if (n.preventDefault(), n.clipboardData === void 0) {
					o && console.warn("unable to use e.clipboardData"), o && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
					var i = r[t.format] || r.default;
					window.clipboardData.setData(i, e);
				} else n.clipboardData.clearData(), n.clipboardData.setData(t.format, e);
				t.onCopy && (n.preventDefault(), t.onCopy(n.clipboardData));
			}), document.body.appendChild(d), l.selectNodeContents(d), u.addRange(l), !document.execCommand("copy")) throw Error("copy command was unsuccessful");
			f = !0;
		} catch (n) {
			o && console.error("unable to copy using execCommand: ", n), o && console.warn("trying IE specific stuff");
			try {
				window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), f = !0;
			} catch (n) {
				o && console.error("unable to copy using clipboardData: ", n), o && console.error("falling back to prompt"), s = a("message" in t ? t.message : i), window.prompt(s, e);
			}
		} finally {
			u && (typeof u.removeRange == "function" ? u.removeRange(l) : u.removeAllRanges()), d && document.body.removeChild(d), c();
		}
		return f;
	}
	t.exports = o;
})))()), cl = function() {
	var e = nl(), t = rl({
		value: void 0,
		error: void 0,
		noUserInteraction: !0
	}), n = t[0], r = t[1];
	return [n, Je(function(t) {
		if (e()) {
			var n, i;
			try {
				if (typeof t != "string" && typeof t != "number") {
					var a = /* @__PURE__ */ Error("Cannot copy typeof " + typeof t + " to clipboard, must be a string");
					process.env.NODE_ENV === "development" && console.error(a), r({
						value: t,
						error: a,
						noUserInteraction: !0
					});
					return;
				} else if (t === "") {
					var a = /* @__PURE__ */ Error("Cannot copy empty string to clipboard.");
					process.env.NODE_ENV === "development" && console.error(a), r({
						value: t,
						error: a,
						noUserInteraction: !0
					});
					return;
				}
				i = t.toString(), n = (0, sl.default)(i), r({
					value: i,
					error: void 0,
					noUserInteraction: n
				});
			} catch (e) {
				r({
					value: i,
					error: e,
					noUserInteraction: n
				});
			}
		}
	}, [])];
};
//#endregion
//#region ../../../node_modules/react-use/esm/useTimeoutFn.js
function ll(e, t) {
	t === void 0 && (t = 0);
	var n = $e(!1), r = $e(), i = $e(e), a = Je(function() {
		return n.current;
	}, []), o = Je(function() {
		n.current = !1, r.current && clearTimeout(r.current), r.current = setTimeout(function() {
			n.current = !0, i.current();
		}, t);
	}, [t]), s = Je(function() {
		n.current = null, r.current && clearTimeout(r.current);
	}, []);
	return U(function() {
		i.current = e;
	}, [e]), U(function() {
		return o(), s;
	}, [t]), [
		a,
		s,
		o
	];
}
//#endregion
//#region ../../../node_modules/react-use/esm/useDebounce.js
function ul(e, t, n) {
	t === void 0 && (t = 0), n === void 0 && (n = []);
	var r = ll(e, t), i = r[0], a = r[1], o = r[2];
	return U(o, n), [i, a];
}
//#endregion
//#region ../../../node_modules/react-use/esm/useEffectOnce.js
var dl = function(e) {
	U(e, []);
}, fl = function(e, t) {
	var n = $e(function() {});
	U(function() {
		n.current = e;
	}), U(function() {
		if (t !== null) {
			var e = setInterval(function() {
				return n.current();
			}, t || 0);
			return function() {
				return clearInterval(e);
			};
		}
	}, [t]);
}, pl = function(e) {
	e === void 0 && (e = {});
	var t = W(e), n = t[0], r = t[1], i = Ze(function() {
		return {
			set: function(e, t) {
				r(function(n) {
					var r;
					return _t(_t({}, n), (r = {}, r[e] = t, r));
				});
			},
			setAll: function(e) {
				r(e);
			},
			remove: function(e) {
				r(function(t) {
					var n = t, r = e;
					return n[r], vt(n, [typeof r == "symbol" ? r : r + ""]);
				});
			},
			reset: function() {
				return r(e);
			}
		};
	}, [r]);
	return [n, _t({ get: Je(function(e) {
		return n[e];
	}, [n]) }, i)];
}, ml = function(e) {
	var t = $e(e);
	t.current = e, dl(function() {
		return function() {
			return t.current();
		};
	});
};
//#endregion
//#region ../widget-github/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{width:var(--dixa-size-spacer-300);vertical-align:middle;border-radius:50%}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_8dnbe_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_8dnbe_8>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_8dnbe_8>div>div>p{white-space:unset!important}._collapseHeader_8dnbe_8>div:first-child,._collapseHeader_8dnbe_8>div:first-child div:first-child{width:100%}._collapseHeader_8dnbe_8>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_8dnbe_8{padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500);background-color:#0000!important}._collapseHeaderKey_8dnbe_33{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_8dnbe_38{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_8dnbe_43{text-decoration:none}._collapseHeaderIcon_8dnbe_46{margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom;padding-top:.35em}._collapseHeaderTitle_8dnbe_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_8dnbe_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_8dnbe_62{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_8dnbe_65{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;cursor:pointer;border:0;outline:0;align-items:center;width:100%;height:48px;margin:0;font-size:12px;line-height:32px;display:flex;position:relative}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{text-align:left;white-space:nowrap;text-overflow:ellipsis;width:100%;font-weight:var(--dixa-typography-weight-semibold);overflow:hidden}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{text-align:left;width:100%;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em;overflow:hidden}._resultLinkIcon_1uaom_46{background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);color:var(--dixa-color-neutral-500);border-radius:5px;position:absolute;right:5px}._tooltip_1uaom_55{text-overflow:ellipsis;width:500px;max-height:60vh;overflow:hidden}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;font-size:var(--dixa-typography-size-200);cursor:pointer;border:0;outline:0;align-items:center;width:100%;height:48px;margin:0;line-height:32px;display:flex;position:relative}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{text-align:left;white-space:nowrap;text-overflow:ellipsis;width:100%;font-weight:var(--dixa-typography-weight-normal);overflow:hidden}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200);border-radius:50%}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400);display:grid}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var hl = {
	"\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getGithubOrganizationMembersByName"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "organizationQuery"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "usersQuery"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "maxResults"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Int"
							}
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "GitHub"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "organization"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "login"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "organizationQuery"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "teams"
									},
									arguments: [{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "first"
										},
										value: {
											kind: "Variable",
											name: {
												kind: "Name",
												value: "maxResults"
											}
										}
									}],
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "edges"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "node"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "members"
																},
																arguments: [{
																	kind: "Argument",
																	name: {
																		kind: "Name",
																		value: "first"
																	},
																	value: {
																		kind: "Variable",
																		name: {
																			kind: "Name",
																			value: "maxResults"
																		}
																	}
																}, {
																	kind: "Argument",
																	name: {
																		kind: "Name",
																		value: "query"
																	},
																	value: {
																		kind: "Variable",
																		name: {
																			kind: "Name",
																			value: "usersQuery"
																		}
																	}
																}],
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "edges"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "node"
																				},
																				selectionSet: {
																					kind: "SelectionSet",
																					selections: [
																						{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "id"
																							}
																						},
																						{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "name"
																							}
																						},
																						{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "login"
																							}
																						},
																						{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "avatarUrl"
																							}
																						}
																					]
																				}
																			}]
																		}
																	}]
																}
															}
														]
													}
												}]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "createGithubIssue"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "GitHub_CreateIssueInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "GitHub"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "createIssue"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "issue"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "number"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "repository"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "name"
														}
													}]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getGithubRepositoriesByName"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "query"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "maxResults"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "GitHub"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "search"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "query"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "query"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "type"
									},
									value: {
										kind: "EnumValue",
										value: "REPOSITORY"
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "first"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "maxResults"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "repositoryCount"
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "edges"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "node"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "InlineFragment",
													typeCondition: {
														kind: "NamedType",
														name: {
															kind: "Name",
															value: "GitHub_Repository"
														}
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														}, {
															kind: "Field",
															name: {
																kind: "Name",
																value: "name"
															}
														}]
													}
												}]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "FragmentDefinition",
			name: {
				kind: "Name",
				value: "IssueFields"
			},
			typeCondition: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "GitHub_Issue"
				}
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "id"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "number"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "title"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "body"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "bodyText"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "author"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "avatarUrl"
								}
							}, {
								kind: "Field",
								name: {
									kind: "Name",
									value: "login"
								}
							}]
						}
					},
					{
						kind: "Field",
						alias: {
							kind: "Name",
							value: "issueState"
						},
						name: {
							kind: "Name",
							value: "state"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "assignees"
						},
						arguments: [{
							kind: "Argument",
							name: {
								kind: "Name",
								value: "first"
							},
							value: {
								kind: "IntValue",
								value: "10"
							}
						}],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "nodes"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "avatarUrl"
										}
									}, {
										kind: "Field",
										name: {
											kind: "Name",
											value: "name"
										}
									}]
								}
							}]
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "labels"
						},
						arguments: [{
							kind: "Argument",
							name: {
								kind: "Name",
								value: "first"
							},
							value: {
								kind: "IntValue",
								value: "10"
							}
						}],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "nodes"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "color"
										}
									}, {
										kind: "Field",
										name: {
											kind: "Name",
											value: "name"
										}
									}]
								}
							}]
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "repository"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "name"
								}
							}, {
								kind: "Field",
								name: {
									kind: "Name",
									value: "owner"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "login"
										}
									}]
								}
							}]
						}
					}
				]
			}
		}]
	},
	"\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "FragmentDefinition",
			name: {
				kind: "Name",
				value: "PullRequestFields"
			},
			typeCondition: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "GitHub_PullRequest"
				}
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "id"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "number"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "title"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "body"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "bodyText"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "author"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "avatarUrl"
								}
							}, {
								kind: "Field",
								name: {
									kind: "Name",
									value: "login"
								}
							}]
						}
					},
					{
						kind: "Field",
						alias: {
							kind: "Name",
							value: "prState"
						},
						name: {
							kind: "Name",
							value: "state"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "assignees"
						},
						arguments: [{
							kind: "Argument",
							name: {
								kind: "Name",
								value: "first"
							},
							value: {
								kind: "IntValue",
								value: "10"
							}
						}],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "nodes"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "avatarUrl"
										}
									}, {
										kind: "Field",
										name: {
											kind: "Name",
											value: "name"
										}
									}]
								}
							}]
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "labels"
						},
						arguments: [{
							kind: "Argument",
							name: {
								kind: "Name",
								value: "first"
							},
							value: {
								kind: "IntValue",
								value: "10"
							}
						}],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "nodes"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "color"
										}
									}, {
										kind: "Field",
										name: {
											kind: "Name",
											value: "name"
										}
									}]
								}
							}]
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "repository"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "name"
								}
							}, {
								kind: "Field",
								name: {
									kind: "Name",
									value: "owner"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "login"
										}
									}]
								}
							}]
						}
					}
				]
			}
		}]
	},
	"\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "searchItems"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "issueQuery"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "prQuery"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "maxIssueResults"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "maxPRResults"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "GitHub"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							alias: {
								kind: "Name",
								value: "issues"
							},
							name: {
								kind: "Name",
								value: "search"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "query"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "issueQuery"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "type"
									},
									value: {
										kind: "EnumValue",
										value: "ISSUE"
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "first"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "maxIssueResults"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "issueCount"
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "nodes"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "GitHub_Issue"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "number"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "body"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "bodyText"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "author"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "avatarUrl"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "login"
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "state"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "assignees"
														},
														arguments: [{
															kind: "Argument",
															name: {
																kind: "Name",
																value: "first"
															},
															value: {
																kind: "IntValue",
																value: "10"
															}
														}],
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "nodes"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "avatarUrl"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "name"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "labels"
														},
														arguments: [{
															kind: "Argument",
															name: {
																kind: "Name",
																value: "first"
															},
															value: {
																kind: "IntValue",
																value: "10"
															}
														}],
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "nodes"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "color"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "name"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "repository"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "owner"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "login"
																		}
																	}]
																}
															}]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}, {
							kind: "Field",
							alias: {
								kind: "Name",
								value: "pullRequests"
							},
							name: {
								kind: "Name",
								value: "search"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "query"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "prQuery"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "type"
									},
									value: {
										kind: "EnumValue",
										value: "ISSUE"
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "first"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "maxPRResults"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "issueCount"
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "nodes"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "GitHub_PullRequest"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "number"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "body"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "bodyText"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "author"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "avatarUrl"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "login"
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "state"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "assignees"
														},
														arguments: [{
															kind: "Argument",
															name: {
																kind: "Name",
																value: "first"
															},
															value: {
																kind: "IntValue",
																value: "10"
															}
														}],
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "nodes"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "avatarUrl"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "name"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "labels"
														},
														arguments: [{
															kind: "Argument",
															name: {
																kind: "Name",
																value: "first"
															},
															value: {
																kind: "IntValue",
																value: "10"
															}
														}],
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "nodes"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "color"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "name"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "repository"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "owner"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "login"
																		}
																	}]
																}
															}]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getIssue"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "owner"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "repositoryName"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "issueNumber"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Int"
							}
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "GitHub"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "repository"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "owner"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "owner"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "name"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "repositoryName"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "issue"
									},
									arguments: [{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "number"
										},
										value: {
											kind: "Variable",
											name: {
												kind: "Name",
												value: "issueNumber"
											}
										}
									}],
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "number"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "title"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "body"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "bodyText"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "author"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "avatarUrl"
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "login"
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "state"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "assignees"
												},
												arguments: [{
													kind: "Argument",
													name: {
														kind: "Name",
														value: "first"
													},
													value: {
														kind: "IntValue",
														value: "10"
													}
												}],
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "nodes"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "avatarUrl"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "labels"
												},
												arguments: [{
													kind: "Argument",
													name: {
														kind: "Name",
														value: "first"
													},
													value: {
														kind: "IntValue",
														value: "10"
													}
												}],
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "nodes"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "color"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "repository"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "name"
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "owner"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "login"
																}
															}]
														}
													}]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getPullRequest"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "owner"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "repositoryName"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "prNumber"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Int"
							}
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "GitHub"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "repository"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "owner"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "owner"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "name"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "repositoryName"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "pullRequest"
									},
									arguments: [{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "number"
										},
										value: {
											kind: "Variable",
											name: {
												kind: "Name",
												value: "prNumber"
											}
										}
									}],
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "number"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "title"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "body"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "bodyText"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "author"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "avatarUrl"
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "login"
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "state"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "assignees"
												},
												arguments: [{
													kind: "Argument",
													name: {
														kind: "Name",
														value: "first"
													},
													value: {
														kind: "IntValue",
														value: "10"
													}
												}],
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "nodes"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "avatarUrl"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "labels"
												},
												arguments: [{
													kind: "Argument",
													name: {
														kind: "Name",
														value: "first"
													},
													value: {
														kind: "IntValue",
														value: "10"
													}
												}],
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "nodes"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "color"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "repository"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "name"
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "owner"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "login"
																}
															}]
														}
													}]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	}
};
function gl(e) {
	return hl[e] ?? {};
}
var _l = gl("\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), vl = gl("\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n"), yl = gl("\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n"), bl = ({ owner: e, repository: t, number: n }) => `https://github.com/${e}/${t}/issues/${n}`, xl = ({ owner: e, repository: t, number: n }) => `${e}/${t} #${n}`, Sl = ({ number: e, repository: t }) => ({
	number: e,
	repository: t.name,
	owner: t.owner.login
}), Cl = (e) => {
	switch (e) {
		case "ISSUE": return "issue";
		case "PR": return "pull request";
		default: return e;
	}
}, wl = (e, t, n) => e === "ISSUE" ? {
	OPEN: /* @__PURE__ */ q("svg", {
		className: n,
		fill: "#3fb950",
		height: "16",
		width: "16",
		"aria-hidden": "true",
		children: [/* @__PURE__ */ K("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }), /* @__PURE__ */ K("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })]
	}),
	CLOSED: /* @__PURE__ */ q("svg", {
		className: n,
		fill: "#a371f7",
		width: "16",
		height: "16",
		"aria-hidden": "true",
		children: [/* @__PURE__ */ K("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }), /* @__PURE__ */ K("path", {
			fillRule: "evenodd",
			d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
		})]
	})
}[t] : {
	OPEN: /* @__PURE__ */ K("svg", {
		className: n,
		fill: "#3fb950",
		width: "16",
		height: "16",
		"aria-hidden": "true",
		children: /* @__PURE__ */ K("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
	}),
	MERGED: /* @__PURE__ */ K("svg", {
		className: n,
		fill: "#a371f7",
		width: "16",
		height: "16",
		"aria-hidden": "true",
		children: /* @__PURE__ */ K("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
	}),
	CLOSED: /* @__PURE__ */ K("svg", {
		className: n,
		fill: "#f85149",
		width: "16",
		height: "16",
		"aria-hidden": "true",
		children: /* @__PURE__ */ K("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
	})
}[t];
function Tl({ conversationId: e, githubOrganization: t }) {
	let n = { github: {
		issues: [],
		pullRequests: []
	} }, [r, i] = W([]), [a, o] = W([]), [s, c] = W([]), [l, u] = W([]), [d, f] = W(), { showNotification: p, showModal: m, executeQuery: h } = V(), { track: g } = B(), { loading: _, data: v, error: y, store: b } = ze(e ?? null), x = v?.github?.issues || [], S = v?.github?.pullRequests || [], [C, w] = W(!1), [T, E] = W();
	U(() => f(y || T || void 0), [y, T]), U(() => {
		!_ && (x?.length || S?.length) ? (i(x), o(S), O(x, S)) : (i([]), o([]), c([]), u([]));
	}, [v]);
	let D = async (e, t) => {
		await b(e).then(() => {
			p({
				icon: "check-circle-filled",
				severity: "success",
				title: t.success.title,
				text: t.success.text
			});
		}).catch((e) => {
			p({
				title: t.error.title,
				text: `${t.error.text} ${e.message && " (" + e.message + ")"}`,
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		});
	}, O = (e, t) => {
		if (!e?.length && !t?.length) {
			c([]), u([]);
			return;
		}
		let n = (e || []).map((e) => h(vl, {
			owner: e.owner,
			repositoryName: e.repository,
			issueNumber: e.number
		})), r = (t || []).map((e) => h(yl, {
			owner: e.owner,
			repositoryName: e.repository,
			prNumber: e.number
		})), i = [...n, ...r];
		w(!0), Promise.all(i).then((e) => {
			let t = [], n = [];
			e.forEach((e) => {
				let r = e?.data?.GitHub;
				if (!r) {
					c([]), u([]);
					return;
				}
				Object.keys(r).forEach((e) => {
					if (e.startsWith("repository")) {
						let i = r[e];
						Object.keys(i).forEach((e) => {
							let r = i[e], a = {
								number: r?.number,
								owner: r?.repository?.owner?.login,
								repository: r?.repository?.name
							};
							e.startsWith("issue") && t.push({
								...r,
								type: "ISSUE",
								key: a
							}), e.startsWith("pullRequest") && n.push({
								...r,
								type: "PR",
								key: a
							});
						});
					}
				});
			}), c(t), u(n);
		}).catch(E).finally(() => {
			w(!1);
		});
	}, k = ({ key: e, type: r }) => {
		g("github:link:issue:clicked", { githubOrganization: t });
		let i = v && (x.length || S.length) ? v : n, a = r === "ISSUE" ? "issues" : "pullRequests";
		i.github[a] = Array.from(new Set(i.github[a]).add(e)), D(i, {
			success: {
				title: "GitHub issue linked",
				text: `You linked the GitHub issue ${xl(e)} to this conversation.`
			},
			error: {
				title: "Linking failed",
				text: `Linking ${xl(e)} failed. Please try again.`
			}
		});
	}, A = async ({ key: e, type: r }) => {
		g("github:link:issue:clicked", { githubOrganization: t });
		let i = v && (x.length || S.length) ? v : n, a = r === "ISSUE" ? "issues" : "pullRequests";
		i.github[a] = Array.from(new Set(i.github[a]).add(e)), await b(i).catch((t) => {
			p({
				title: "Linking failed",
				text: `Linking ${e} failed. Please try again. ${t.message && " (" + t.message + ")"}`,
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		});
	}, j = ({ key: e, type: n }) => {
		g("github:unlink:issue:clicked", { githubOrganization: t });
		let r = n === "ISSUE" ? "issue" : "pull request";
		m({
			headline: `Unlink ${r} ${xl(e)}?`,
			text: `You are about to unlink the ${r} ${xl(e)}. Do you want to proceed?`,
			confirmLabel: `Unlink GitHub ${r}`,
			confirmVariant: "danger",
			cancelLabel: "Cancel",
			onConfirm: () => {
				let i = n === "ISSUE" ? "issues" : "pullRequests";
				if (!v) return;
				let a = {
					...v,
					github: {
						...v?.github,
						[i]: v?.github?.[i].filter((t) => t.number !== e.number || t.owner !== e.owner || t.repository !== e.repository)
					}
				};
				g("github:unlink:issue:confirmed", { githubOrganization: t }), D(a, {
					success: {
						title: `GitHub ${r} unlinked`,
						text: `You unlinked the GitHub ${r} ${xl(e)}`
					},
					error: {
						title: "Unlinking failed",
						text: `Unlinking ${xl(e)} failed.`
					}
				});
			},
			onCancel: () => {
				g("github:unlink:issue:canceled", { githubOrganization: t });
			}
		});
	}, M = () => {
		g("github:unlink:all:clicked", { githubOrganization: t }), m({
			headline: "Unlink all GitHub issues/pull requests?",
			text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
			confirmLabel: "Unlink ALL issues/pull requests",
			confirmVariant: "danger",
			cancelLabel: "Cancel",
			onConfirm: () => {
				g("github:unlink:all:confirmed", { githubOrganization: t }), D(n, {
					success: {
						title: "Unlinking successful",
						text: "All GitHub issues/pull requests were unlinked"
					},
					error: {
						title: "Unlinking failed",
						text: "Unlinking all issues/pull requests failed."
					}
				});
			},
			onCancel: () => {
				g("github:unlink:all:canceled", { githubOrganization: t });
			}
		});
	}, N = x.filter((e) => !r?.includes(e)) || [], P = S.filter((e) => !a?.includes(e)) || [];
	return {
		linkGithubItem: k,
		linkGithubItemQuietly: A,
		unlinkGithubItem: j,
		loadGithubItems: O,
		removeDanglingGithubItemLinks: () => {
			let e = {
				...v,
				github: {
					...v?.github,
					issues: x.filter((e) => !N.includes(e)) || [],
					pullRequests: S.filter((e) => !P.includes(e)) || []
				}
			};
			b(e);
		},
		unlinkAllGithubItems: M,
		isLoadingGithubItemLinks: _,
		danglingIssueLinks: N,
		danglingPullRequestLinks: P,
		isLoadingGithubItems: C,
		issues: s,
		pullRequests: l,
		error: d
	};
}
var El = {
	contentWrapper: "_contentWrapper_1vx3c_1",
	contentWrapperHeadline: "_contentWrapperHeadline_1vx3c_4",
	contentWrapperBody: "_contentWrapperBody_1vx3c_11",
	contentWrapperAssigneeIcon: "_contentWrapperAssigneeIcon_1vx3c_15",
	contentWrapperStatusTag: "_contentWrapperStatusTag_1vx3c_20"
}, Dl = ({ description: e, assignees: t, labels: n }) => /* @__PURE__ */ q(G, { children: [
	e && /* @__PURE__ */ q(i, {
		className: El.contentWrapper,
		children: [/* @__PURE__ */ K(i, {
			className: El.contentWrapperHeadline,
			children: "Description"
		}), /* @__PURE__ */ K(i, {
			className: El.contentWrapperBody,
			children: e
		})]
	}),
	t?.nodes && t.nodes.length > 0 && /* @__PURE__ */ q(i, {
		className: El.contentWrapper,
		children: [/* @__PURE__ */ K(i, {
			className: El.contentWrapperHeadline,
			children: "Assignees"
		}), /* @__PURE__ */ K(i, {
			className: El.contentWrapperBody,
			children: t.nodes.map((e) => e && /* @__PURE__ */ q(i, {
				margin: "100 0",
				children: [
					/* @__PURE__ */ K("img", {
						className: El.contentWrapperAssigneeIcon,
						src: e.avatarUrl,
						alt: e.name || ""
					}),
					" ",
					e.name
				]
			}, e.name))
		})]
	}),
	n?.nodes && n?.nodes.length > 0 && /* @__PURE__ */ K(i, {
		className: El.contentWrapper,
		children: n.nodes.map((e) => e && /* @__PURE__ */ K(I, {
			className: El.contentWrapperStatusTag,
			children: e.name
		}, e.name))
	})
] }), Ol = {
	collapse: "_collapse_8dnbe_1",
	collapseHeader: "_collapseHeader_8dnbe_8",
	collapseHeaderKey: "_collapseHeaderKey_8dnbe_33",
	collapseHeaderKeyIcon: "_collapseHeaderKeyIcon_8dnbe_38",
	collapseHeaderKeyLink: "_collapseHeaderKeyLink_8dnbe_43",
	collapseHeaderIcon: "_collapseHeaderIcon_8dnbe_46",
	collapseHeaderTitle: "_collapseHeaderTitle_8dnbe_51",
	collapseContent: "_collapseContent_8dnbe_59",
	collapseContentButtonSpacer: "_collapseContentButtonSpacer_8dnbe_62",
	collapseContentButtonLink: "_collapseContentButtonLink_8dnbe_65"
}, kl = ({ items: e, unlinkGithubItem: t, githubOrganization: n }) => {
	let [r, o] = W(e.reduce((e, t) => ({
		...e,
		[t.id]: !1
	}), {})), { track: c } = B(), l = (e, t) => {
		o({
			...r,
			[e]: t
		});
	};
	return /* @__PURE__ */ K(_, {
		flexDirection: "column",
		gap: "250",
		children: e?.length ? e.map((e) => {
			let { id: o, number: u, key: d, title: f, bodyText: p, repository: m, type: h, state: g, assignees: v, labels: y } = e, x = r[o];
			return /* @__PURE__ */ q(s, {
				onToggle: () => l(o, !r[o]),
				isOpen: x,
				className: Ol.collapse,
				children: [/* @__PURE__ */ K(s.Header, {
					className: Ol.collapseHeader,
					children: /* @__PURE__ */ q(_, {
						flexDirection: "column",
						gap: "200",
						justifyContent: "space-between",
						children: [/* @__PURE__ */ K(i, { children: /* @__PURE__ */ q(i, {
							as: "span",
							className: Ol.collapseHeaderKey,
							children: [wl(h, g, Ol.collapseHeaderKeyIcon), /* @__PURE__ */ q("a", {
								href: bl(d),
								className: Ol.collapseHeaderKeyLink,
								target: "_blank",
								rel: "noreferrer",
								onClick: (e) => {
									e.stopPropagation();
								},
								children: [xl(d), /* @__PURE__ */ K(b, {
									className: Ol.collapseHeaderIcon,
									name: "external-link",
									size: 16
								})]
							})]
						}) }), /* @__PURE__ */ K(i, {
							className: Ol.collapseHeaderTitle,
							children: f
						})]
					})
				}), /* @__PURE__ */ K(s.Content, {
					className: Ol.collapseContent,
					children: /* @__PURE__ */ q(_, {
						flexDirection: "column",
						margin: "0 0 200 0",
						children: [
							/* @__PURE__ */ K(Dl, {
								description: p,
								assignees: v,
								labels: y
							}),
							/* @__PURE__ */ q(a, {
								icon: "link-slash",
								variant: "secondary",
								className: Ol.collapseContentButtonSpacer,
								onClick: () => t({
									key: {
										number: u,
										owner: m?.owner.login,
										repository: e.repository.name
									},
									type: h
								}),
								children: ["Unlink ", Cl(h)]
							}),
							/* @__PURE__ */ q(A, {
								slotEnd: /* @__PURE__ */ K(b, { name: "external-link" }),
								variant: "tertiary",
								className: Ol.collapseContentButtonLink,
								navigate: () => {
									c("github:view:link:clicked", { githubOrganization: n }), window.open(bl(d), "_blank")?.focus();
								},
								children: [
									"View ",
									Cl(h),
									" in GitHub"
								]
							})
						]
					})
				})]
			}, o);
		}) : /* @__PURE__ */ K(G, {})
	});
}, Al = {
	result: "_result_1uaom_1",
	resultName: "_resultName_1uaom_21",
	resultItemIcon: "_resultItemIcon_1uaom_29",
	resultDescription: "_resultDescription_1uaom_34",
	resultLinkIcon: "_resultLinkIcon_1uaom_46",
	tooltip: "_tooltip_1uaom_55",
	tooltipName: "_tooltipName_1uaom_61",
	tooltipNameIcon: "_tooltipNameIcon_1uaom_66",
	tooltipTag: "_tooltipTag_1uaom_71"
}, jl = ({ item: e, onSelect: t }) => {
	let { key: n, title: r, type: a, state: o, labels: s, bodyText: c, assignees: l } = e, [u, d] = W(!1);
	return /* @__PURE__ */ K(R, {
		className: Al.tooltip,
		content: /* @__PURE__ */ q(_, {
			flexDirection: "column",
			justifyContent: "center",
			width: "100%",
			children: [/* @__PURE__ */ q(_, {
				flexDirection: "row",
				justifyContent: "space-between",
				width: "100%",
				alignItems: "center",
				margin: "0 0 300 0",
				children: [/* @__PURE__ */ q(i, {
					as: "span",
					className: Al.tooltipName,
					children: [wl(a, o, Al.resultItemIcon), r]
				}), /* @__PURE__ */ K(I, {
					className: Al.tooltipTag,
					children: o
				})]
			}), /* @__PURE__ */ K(Dl, {
				description: c,
				assignees: l,
				labels: s
			})]
		}),
		side: "left",
		light: !0,
		children: /* @__PURE__ */ q("button", {
			className: Al.result,
			type: "button",
			onClick: () => {
				t(e);
			},
			onMouseEnter: () => d(!0),
			onMouseLeave: () => d(!1),
			children: [/* @__PURE__ */ q(_, {
				flexDirection: "column",
				justifyContent: "center",
				width: "100%",
				style: { width: u ? "calc(100% - 32px)" : "100%" },
				children: [/* @__PURE__ */ K(_, {
					flexDirection: "row",
					children: /* @__PURE__ */ q(i, {
						as: "span",
						className: Al.resultName,
						children: [wl(a, o, Al.resultItemIcon), xl(n)]
					})
				}), /* @__PURE__ */ K(i, {
					className: Al.resultDescription,
					children: r
				})]
			}), u && /* @__PURE__ */ K(b, {
				className: Al.resultLinkIcon,
				name: "plus",
				size: 32
			})]
		})
	});
}, Ml = ({ className: e, searched: t, githubOrganization: n }) => /* @__PURE__ */ K(A, {
	slotEnd: /* @__PURE__ */ K(b, { name: "external-link" }),
	variant: "tertiary",
	style: { width: "100%" },
	className: e,
	navigate: () => {
		window.open(`https://github.com/search?q=is:issue+org:${n}+${t}`, "_blank")?.focus();
	},
	children: "View matching items on GitHub"
}), Nl = "[a-zA-z0-9_.-]+", Pl = "[0-9]+", Fl = RegExp(`(${Nl})/(${Nl})/(?:issues|pull)/(${Pl})`, "i"), Il = RegExp(`^${Fl.source}$`), Ll = RegExp(`https://github.com/(${Nl})/(${Nl})/(?:issues|pull)/(${Pl})`, "i"), Rl = ({ onSelectItem: e, githubOrganization: t, linkedIssues: n, linkedPullRequests: r }) => {
	let i = Ze(() => n?.map((e) => e.id) || [], [n]), a = Ze(() => r?.map((e) => e.id) || [], [r]), [o, s] = W([]), { useLazyQuery: c } = V(), [l, u] = W(), [d, { loading: f, error: p, data: m, networkStatus: h }] = c(_l, { notifyOnNetworkStatusChange: !0 }), [g, _] = ul(() => {
		!f && l && h === ot.ready ? d({ variables: {
			issueQuery: `${l} type:issue`,
			prQuery: `${l} type:pr`,
			maxIssueResults: 12,
			maxPRResults: 12
		} }) : s([]);
	}, 500, [l]);
	U(() => {
		let e = m?.GitHub?.issues?.nodes || [], t = m?.GitHub?.pullRequests.nodes || [];
		i.length > 0 && (e = e.filter((e) => !i.includes(e.id))), a.length > 0 && (t = t.filter((e) => !a.includes(e.id))), s([...e.map((e) => ({
			...e,
			type: "ISSUE",
			key: {
				number: e.number,
				owner: e.repository.owner.login,
				repository: e.repository.name
			}
		})), ...t.map((e) => ({
			...e,
			type: "PR",
			key: {
				number: e.number,
				owner: e.repository.owner.login,
				repository: e.repository.name
			}
		}))]);
	}, [
		m,
		i,
		a
	]);
	function v(e) {
		let n = e?.trim();
		if (Il.test(n)) {
			let [e, r, i, a] = n.match(Il) || [];
			return r === t ? {
				owner: t,
				repository: i,
				number: parseInt(a)
			} : void 0;
		}
		if (Ll.test(n)) {
			let [e, r, i, a] = n.match(Ll) || [];
			return r === t ? {
				owner: t,
				repository: i,
				number: parseInt(a)
			} : void 0;
		}
	}
	return !f && p ? /* @__PURE__ */ K(z, { error: p }) : /* @__PURE__ */ K(j, {
		items: o?.map((e) => ({
			name: e.title,
			...e
		})),
		loading: f,
		onSearch: (e) => {
			let n = v(e);
			u(n ? `org:${n.owner} repo:${n.repository} ${n.number}` : `org:${t} ${e}`);
		},
		onSelect: (t) => {
			e({
				key: Sl(t),
				type: t.type
			}), u(void 0);
		},
		onClear: () => {
			u(void 0);
		},
		emptyMessage: l ? f ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
		suggestionComponent: ({ className: e, searched: n }) => /* @__PURE__ */ K(Ml, {
			className: e,
			searched: n,
			githubOrganization: t
		}),
		itemComponent: ({ item: e, onSelect: t }) => /* @__PURE__ */ K(jl, {
			item: e,
			onSelect: t
		}),
		placeholder: "Search GitHub items",
		searchable: !0,
		clearable: !0
	});
}, zl = {
	itemButton: "_itemButton_3sxfy_1",
	result: "_result_3sxfy_6",
	resultIcon: "_resultIcon_3sxfy_26",
	resultName: "_resultName_3sxfy_30",
	resultCheckIcon: "_resultCheckIcon_3sxfy_38",
	resultAssigneeIcon: "_resultAssigneeIcon_3sxfy_41"
}, Bl = ({ item: e, checked: t = !1, onSelectItem: n }) => /* @__PURE__ */ K(_, {
	flexDirection: "column",
	justifyContent: "center",
	width: "100%",
	"data-testid": "github-select-item-component",
	children: /* @__PURE__ */ K("button", {
		onClick: () => {
			n(e);
		},
		className: zl.itemButton,
		children: /* @__PURE__ */ q(_, {
			className: zl.result,
			flexDirection: "row",
			width: "100%",
			children: [
				e.iconUrl && /* @__PURE__ */ K(i, {
					margin: "100 0",
					children: /* @__PURE__ */ K("img", {
						className: zl.resultAssigneeIcon,
						src: e.iconUrl,
						alt: e.name
					})
				}, e.name),
				/* @__PURE__ */ K(i, {
					className: zl.resultName,
					children: e.name
				}),
				t && /* @__PURE__ */ K(i, {
					className: zl.resultCheckIcon,
					children: /* @__PURE__ */ K(b, { name: "done" })
				})
			]
		})
	})
}), Vl = gl("\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), Hl = ({ githubOrganization: e, selectedItems: t, onChange: n, multiple: r = !1 }) => {
	let { useLazyQuery: i } = V(), [a, o] = W([]), [s, c] = W(""), [l, { loading: u, error: d, data: f, networkStatus: p }] = i(Vl, { notifyOnNetworkStatusChange: !0 }), [m, h] = ul(() => {
		!u && s && s.length >= 2 && p === ot.ready ? l({ variables: {
			usersQuery: s,
			organizationQuery: e,
			maxResults: 10
		} }) : o([]);
	}, 500, [s]);
	return U(() => {
		let e = f?.GitHub?.organization?.teams || { edges: [] }, t = [];
		e?.edges?.forEach((e) => {
			let n = e?.node?.members?.edges;
			(n?.length || 0) > 0 && n?.forEach((e) => {
				let n = e?.node;
				n && (n?.id && t.find((e) => e.id === n.id) || t.push(n));
			});
		}), o(t.sort((e, t) => {
			let n = e.name?.toLowerCase() || e.login?.toLowerCase(), r = t.name?.toLowerCase() || t.login?.toLowerCase();
			return n.localeCompare(r, void 0, { sensitivity: "base" });
		}));
	}, [f]), !u && d ? /* @__PURE__ */ K(z, { error: d }) : /* @__PURE__ */ K(j, {
		clearable: !0,
		searchable: !0,
		multiple: r,
		items: a?.map(({ id: e, name: t, login: n, avatarUrl: r }) => ({
			id: e,
			name: t || n,
			iconUrl: r
		})) || [],
		loading: u,
		onSearch: (e) => c(e),
		onChange: (e, i) => {
			let a = e.id;
			r ? (i && !t.find((e) => e.id === a) && t.push(e), i || (t = t.filter((e) => e.id !== a))) : t = i ? [e] : [], n(t);
		},
		onClear: () => c(""),
		selectedItems: t,
		emptyMessage: s ? u ? "" : "No user found" : "Search users",
		itemComponent: ({ item: e, onSelect: t, checked: n }) => /* @__PURE__ */ K(Bl, {
			item: e,
			checked: n,
			onSelectItem: t
		}),
		placeholder: "Search GitHub users"
	});
}, Ul = ({ field: e, value: t, onChange: n, githubOrganization: r }) => {
	let { multiple: i, type: a } = e;
	switch (a) {
		case "any": return /* @__PURE__ */ K(w, {
			onChange: n,
			value: t
		});
		case "array": return e?.allowedValues ? /* @__PURE__ */ K(j, {
			onSelect: n,
			selectedItems: Array.isArray(t) ? t : [],
			items: e?.allowedValues.map(({ id: e, name: t, value: n }) => ({
				id: e,
				name: t || n
			}))
		}) : /* @__PURE__ */ K(ee, {
			onChange: n,
			selectedTags: Array.isArray(t) ? t : []
		});
		case "number": return /* @__PURE__ */ K(w, {
			type: "number",
			onChange: n,
			value: t
		});
		case "option": return /* @__PURE__ */ K(j, {
			onSelect: n,
			selectedItems: Array.isArray(t) ? t : [],
			items: (e?.allowedValues)?.map(({ id: e, name: t, value: n }) => ({
				id: e,
				name: t || n
			})) || []
		});
		case "string": return /* @__PURE__ */ K(w, {
			onChange: n,
			value: t || ""
		});
		case "textarea": return /* @__PURE__ */ K(ne, {
			onChange: n,
			value: t || ""
		});
		case "user": return /* @__PURE__ */ K(Hl, {
			githubOrganization: r,
			onChange: n,
			selectedItems: Array.isArray(t) ? t : [],
			multiple: i
		});
		default: return /* @__PURE__ */ K(G, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
	}
}, Wl = ({ issueTypeFields: e, control: t, githubOrganization: n, conversationContext: r, errors: i }) => /* @__PURE__ */ K(G, { children: e.filter(({ key: e }) => e !== "repository").map((e) => /* @__PURE__ */ K(Es, {
	control: t,
	render: ({ field: { onChange: t, value: a } }) => /* @__PURE__ */ K(g, {
		meta: { error: i && e.key in i ? i[e.key].message : null },
		label: e.name,
		required: e.required,
		children: Ul({
			field: e,
			value: a,
			onChange: t,
			githubOrganization: n,
			conversationContext: r
		})
	}, e.key),
	name: e.key,
	rules: { required: e.required ? "This field is required" : !1 }
}, e.key)) }), Gl = ({ createdIssue: e, issueBaseLink: t, issueLinkCopied: n, setIssueLinkCopied: r, copyToClipboard: i }) => {
	let a = `${t}/${e.repository.name}/issues/${e.number}`;
	return /* @__PURE__ */ q(_, {
		flexDirection: "column",
		gap: "400",
		"data-testid": "github-create-issue-success-message",
		children: [/* @__PURE__ */ q(L.Paragraph, { children: [
			"You can visit your new issue by following",
			" ",
			/* @__PURE__ */ q(L.ExternalLink, {
				href: a,
				target: "_blank",
				children: ["this link ", /* @__PURE__ */ K(b, { name: "external-link" })]
			}),
			" ",
			"or copy it from the field below."
		] }), /* @__PURE__ */ K(g, {
			label: "GitHub issue link",
			children: /* @__PURE__ */ K(w, {
				readOnly: !0,
				value: a,
				suffix: {
					type: "button",
					button: {
						icon: n ? "done" : "copy",
						onClick: () => {
							r(!0), i(a);
						}
					}
				}
			})
		})]
	});
}, Kl = {
	modalBody: "_modalBody_1hk1o_1",
	modalBodyFormFields: "_modalBodyFormFields_1hk1o_4"
}, ql = gl("\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n"), Jl = gl("\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n"), Yl = [
	{
		key: "title",
		name: "Title",
		type: "string",
		required: !0
	},
	{
		key: "assignees",
		name: "Assignees",
		type: "user",
		required: !1,
		multiple: !0
	},
	{
		key: "body",
		name: "Description",
		type: "textarea",
		required: !1
	}
], Xl = ({ isOpen: e, onClose: t, linkGithubIssueQuietly: n, conversationContext: r, githubOrganization: i }) => {
	let { showNotification: a, useLazyQuery: o, useMutation: s } = V(), { track: c } = B(), { control: l, handleSubmit: u, formState: { errors: d }, reset: f, getValues: p } = xc(), [m, h] = W(""), [_, b] = W([]), [x, S] = W(), [C, w] = W(!1), [T, A] = W(!1), [M, P] = cl(), [F, { loading: I, error: ee, networkStatus: L }] = o(ql, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0,
		onCompleted: (e) => {
			b(e.GitHub.search?.edges?.map((e) => e?.node));
		},
		onError: () => {
			a({
				title: "Could not get repository list",
				text: "We could not fetch the list of your repositories. Please try again later.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), b([]);
		}
	}), [te, ne] = ul(() => {
		!I && m && L === ot.ready ? F({ variables: {
			query: m,
			maxResults: 10
		} }) : b([]);
	}, 500, [m]), [re, { error: R }] = s(Jl, {
		onError: (e) => {
			w(!1), a({
				title: "Creation was not successful",
				text: "Please try again later or contact your admin.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), console.warn("Error in createMutation", e);
		},
		onCompleted: (e) => {
			w(!1);
			let t = e.GitHub.createIssue?.issue;
			S(t), a({
				title: "Success",
				text: `GitHub issue '${t.number}' created`,
				icon: "check-circle-filled",
				severity: "success"
			}), n({
				owner: i,
				repository: t.repository.name,
				number: t.number
			});
		}
	}), ie = (e) => {
		h(`org:${i} ${e}`);
	}, ae = (e, t) => {
		t(e), h("");
	}, oe = () => {
		h("");
	}, se = (e) => {
		c("github:create:issue:confirmed", { githubOrganization: i }), w(!0), re({ variables: { input: {
			repositoryId: e.repository.id,
			title: e.title,
			body: e.body,
			assigneeIds: e.assignees?.length > 0 ? e.assignees.map((e) => e.id) : void 0
		} } });
	};
	U(() => {
		let e = T ? window.setTimeout(() => A(!1), 2e3) : void 0;
		return () => window.clearTimeout(e);
	}, [T]);
	let ce = () => {
		h(""), b([]), S(void 0), w(!1), A(!1);
	}, le = () => {
		c("github:create:issue:canceled", { githubOrganization: i }), ce(), f(), t();
	};
	return /* @__PURE__ */ q(E, {
		isOpen: e,
		"data-testid": "github-create-issue-modal",
		onClose: le,
		children: [
			/* @__PURE__ */ K(k, {
				title: x ? "Issue creation successful" : "Create new GitHub issue",
				onClose: le
			}),
			/* @__PURE__ */ q(D, {
				className: Kl.modalBody,
				children: [
					!I && ee && /* @__PURE__ */ K(z, { error: ee }),
					!C && R && /* @__PURE__ */ K(z, { error: R }),
					x ? /* @__PURE__ */ K(Gl, {
						createdIssue: x,
						issueBaseLink: `https://github.com/${i}`,
						issueLinkCopied: T,
						setIssueLinkCopied: A,
						copyToClipboard: P
					}) : /* @__PURE__ */ K("form", {
						"data-testid": "github-create-issue-form",
						onSubmit: u(se),
						children: /* @__PURE__ */ q(y, { children: [/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
							label: "Repository",
							required: !0,
							children: /* @__PURE__ */ K(Es, {
								control: l,
								name: "repository",
								rules: { required: "Please select a repository" },
								render: ({ field: { onChange: e, value: t } }) => /* @__PURE__ */ K(j, {
									className: Kl.modalBodyRepository,
									searchable: !0,
									clearable: !0,
									loading: I,
									onSearch: ie,
									onSelect: (t) => ae(t, e),
									onClear: oe,
									selectedItems: [t],
									placeholder: "Search GitHub repositories",
									emptyMessage: ee ? "No repositories found" : "No repositories available",
									items: _ || [],
									itemComponent: ({ item: e, onSelect: t, checked: n }) => /* @__PURE__ */ K(Bl, {
										item: e,
										checked: n,
										onSelectItem: t
									})
								})
							})
						}) }), /* @__PURE__ */ K(v, {
							className: Kl.modalBodyFormFields,
							children: /* @__PURE__ */ K(Wl, {
								control: l,
								errors: d,
								getValues: p,
								githubOrganization: i,
								conversationContext: r,
								issueTypeFields: Yl
							})
						})] })
					})
				]
			}),
			/* @__PURE__ */ K(O, {
				confirmOnClick: x ? le : u(se),
				confirmProps: {
					isLoading: C,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 })
				},
				confirmName: x ? "Close" : "Save",
				cancelOnClick: x ? void 0 : le
			})
		]
	});
}, Zl = {
	wrapper: "_wrapper_19v8w_1",
	inputWrapper: "_inputWrapper_19v8w_6",
	inputField: "_inputField_19v8w_15",
	buttonLink: "_buttonLink_19v8w_19",
	noItemsFound: "_noItemsFound_19v8w_23",
	createIssueButton: "_createIssueButton_19v8w_28"
}, Ql = ({ conversationContext: e, settings: t }) => {
	let [n, r] = W(!1), { track: i } = B(), o = t?.githubOrganization, s = !!t?.enableRemoveAllLinks, { linkGithubItem: c, linkGithubItemQuietly: l, unlinkGithubItem: u, loadGithubItems: d, removeDanglingGithubItemLinks: f, unlinkAllGithubItems: p, isLoadingGithubItemLinks: m, danglingIssueLinks: h, danglingPullRequestLinks: g, isLoadingGithubItems: v, issues: y, pullRequests: x, error: S } = Tl({
		conversationId: e?.conversationId || null,
		githubOrganization: o
	}), C = (e) => l({
		key: e,
		type: "ISSUE"
	}), w = !(!!y?.length).valueOf() && !(!!x?.length).valueOf() && !(!!h?.length).valueOf() && !(!!g?.length).valueOf(), T = !m && !v && !!h?.length && !!g?.length && !!t?.showDanglingLinks, E = t?.enableCreateIssue, D = !!y?.length || !!x?.length;
	return !v && S ? /* @__PURE__ */ K(z, {
		error: S,
		retry: () => d()
	}) : /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ q(_, {
		className: Zl.wrapper,
		flexDirection: "column",
		children: [
			/* @__PURE__ */ q(_, {
				className: Zl.inputWrapper,
				flexDirection: "column",
				children: [E && /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(a, {
					variant: "primary",
					onClick: () => {
						i("github:create:issue:clicked", { githubOrganization: t?.githubOrganization }), r(!0);
					},
					className: Zl.createIssueButton,
					children: "Create new issue"
				}), /* @__PURE__ */ K("div", {
					className: Zl.inputSeparator,
					children: "or"
				})] }), /* @__PURE__ */ K(Rl, {
					onSelectItem: c,
					githubOrganization: o,
					linkedIssues: y,
					linkedPullRequests: x
				})]
			}),
			v ? /* @__PURE__ */ K(_, {
				justifyContent: "center",
				children: /* @__PURE__ */ K(N, { "data-testid": "github-widget-item-spinner" })
			}) : D ? /* @__PURE__ */ K(kl, {
				items: [...y, ...x],
				unlinkGithubItem: u,
				githubOrganization: o
			}) : /* @__PURE__ */ K(L.Paragraph, {
				align: "center",
				className: Zl.noItemsFound,
				children: "No linked items found."
			}),
			T && /* @__PURE__ */ q(_, {
				background: "neutral.100",
				padding: "300",
				borderRadius: "100",
				flexDirection: "column",
				gap: "200",
				children: [
					/* @__PURE__ */ K(L.Heading, {
						variant: "heading-3",
						children: "Unresolved linked issues and/or pull requests"
					}),
					/* @__PURE__ */ q(_, {
						flexDirection: "row",
						flexWrap: "wrap",
						gap: "100",
						children: [h.map((e) => /* @__PURE__ */ K(I, {
							onDelete: () => u({
								key: e,
								type: "ISSUE"
							}),
							children: xl(e)
						}, xl(e))), g.map((e) => /* @__PURE__ */ K(I, {
							onDelete: () => u({
								key: e,
								type: "PR"
							}),
							children: xl(e)
						}, xl(e)))]
					}),
					/* @__PURE__ */ K(a, {
						variant: "secondary",
						onClick: () => f(),
						icon: "link-slash",
						children: "Remove all"
					})
				]
			}),
			s && D && /* @__PURE__ */ K(a, {
				variant: "secondary",
				disabled: w,
				onClick: p,
				children: "Remove all links"
			}),
			/* @__PURE__ */ K(A, {
				slotEnd: /* @__PURE__ */ K(b, { name: "external-link" }),
				variant: "tertiary",
				className: Zl.buttonLink,
				navigate: () => {
					window.open(`https://github.com/${o}`, "_blank")?.focus();
				},
				children: "Open GitHub"
			})
		]
	}), /* @__PURE__ */ K(Xl, {
		isOpen: n,
		onClose: () => r(!1),
		linkGithubIssueQuietly: C,
		conversationContext: e,
		githubOrganization: o
	})] });
}, $l = [
	{
		key: "githubOrganization",
		label: "GitHub organization or user",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "enableRemoveAllLinks",
		label: "Enable the \"Remove all links\" button",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "showDanglingLinks",
		label: "Show unresolved links to GitHub items",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "enableCreateIssue",
		label: "Enable the \"Create issue\" button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	}
], eu = Pe($l), tu = "GITHUB", nu = {
	enabled: !1,
	name: "",
	githubOrganization: "",
	enableRemoveAllLinks: !1,
	showDanglingLinks: !1,
	enableCreateIssue: !0
}, ru = ({ integrationId: e, configuration: t, handleRedirect: n, showNotification: r, automationCouplingState: i, renderConditionsEditor: a }) => {
	let o = !e, s = xc({
		mode: "onChange",
		defaultValues: nu
	}), { create: c, update: l, remove: u, isLoading: d, error: f, misconfigurationCause: p, setMisconfigurationCause: m } = Ve({
		integrationId: e,
		integrationType: tu,
		handleRedirect: n,
		showNotification: r
	}), { isLoading: h, error: x, isWidgetUnknown: S, refetch: C, widgetConfiguration: w } = He({
		integrationId: e,
		fieldDefinitions: $l,
		form: s,
		onMisconfigured: m
	}), { renderConditions: T, setRenderConditions: E, renderConditionsForSubmit: D } = Be({
		integrationId: e,
		widgetConfiguration: w,
		renderConditionsEditor: a
	}), O = (e) => ye(e, {
		fieldDefinitions: $l,
		isCreationMode: o,
		create: c,
		update: l,
		renderConditions: D
	}), k = s.watch("name");
	return /* @__PURE__ */ q(de, {
		form: s,
		integrationId: e,
		onValidSubmit: O,
		error: x ?? f,
		onRetry: x ? C : void 0,
		isLoading: d || h,
		isWidgetUnknown: S,
		children: [
			p && /* @__PURE__ */ K(se, { cause: p }),
			/* @__PURE__ */ q(y, { children: [
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ K(Z, {
						name: "enabled",
						control: s.control
					})
				}) }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "name",
						label: "Widget name",
						control: s.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "githubOrganization",
						label: eu.githubOrganization,
						control: s.control,
						rules: { required: "GitHub organization or user is required" },
						componentProps: {
							placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: eu.enableRemoveAllLinks,
						children: /* @__PURE__ */ K(Z, {
							name: "enableRemoveAllLinks",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: eu.showDanglingLinks,
						children: /* @__PURE__ */ K(Z, {
							name: "showDanglingLinks",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: eu.enableCreateIssue,
						children: /* @__PURE__ */ K(Z, {
							name: "enableCreateIssue",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				!o && e && /* @__PURE__ */ K(ce, {
					configuration: t,
					integrationId: e,
					integrationType: tu,
					label: "Authorize with OAuth"
				}),
				a && T !== null && /* @__PURE__ */ K(v, { children: a({
					value: T,
					onChange: E,
					configurationKey: w?.id
				}) })
			] }),
			/* @__PURE__ */ K(pe, {
				integrationType: tu,
				integrationId: e,
				widgetName: k,
				isCreationMode: o,
				isSubmitting: s.formState.isSubmitting,
				automationCouplingState: i,
				onConfirmDelete: () => u(),
				confirmDeleteVariant: "danger",
				deleteConfirmationBody: /* @__PURE__ */ q(_, {
					gap: "400",
					children: [/* @__PURE__ */ K(b, {
						size: 24,
						name: "exclamation-triangle-filled",
						color: "red.500"
					}), /* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "column",
						children: [
							/* @__PURE__ */ q(L.Heading, {
								withMarginBottom: !0,
								children: [
									"By deleting the ",
									tu,
									" integration, all links between Dixa and ",
									tu,
									" are also deleted."
								]
							}),
							/* @__PURE__ */ q(L.Paragraph, { children: [
								"All data in ",
								tu,
								" stays untouched."
							] }),
							/* @__PURE__ */ q(L.Paragraph, { children: [
								"Are you sure you want to delete the ",
								tu,
								" ",
								"integration \"",
								k,
								"\"?"
							] })
						]
					})]
				})
			})
		]
	});
};
//#endregion
//#region ../widget-ingrid/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._list_1sdc5_1{padding:0}._listItem_1sdc5_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1sdc5_4:last-child{border-bottom:none}._listItemEdit_1sdc5_11{cursor:pointer}._clickableIcon_1sdc5_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productImage_1sdc5_20{max-height:40px}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var iu = /* @__PURE__ */ function(e) {
	return e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e;
}({}), au = /* @__PURE__ */ function(e) {
	return e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e;
}({}), ou = /* @__PURE__ */ function(e) {
	return e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e;
}({}), su = { "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": {
	kind: "Document",
	definitions: [{
		kind: "OperationDefinition",
		operation: "query",
		name: {
			kind: "Name",
			value: "getOrders"
		},
		variableDefinitions: [{
			kind: "VariableDefinition",
			variable: {
				kind: "Variable",
				name: {
					kind: "Name",
					value: "email"
				}
			},
			type: {
				kind: "NonNullType",
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			}
		}, {
			kind: "VariableDefinition",
			variable: {
				kind: "Variable",
				name: {
					kind: "Name",
					value: "locale"
				}
			},
			type: {
				kind: "NonNullType",
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			}
		}],
		selectionSet: {
			kind: "SelectionSet",
			selections: [{
				kind: "Field",
				name: {
					kind: "Name",
					value: "Ingrid"
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "DeliveryTracking_GetTrackingOrders"
						},
						arguments: [{
							kind: "Argument",
							name: {
								kind: "Name",
								value: "email"
							},
							value: {
								kind: "Variable",
								name: {
									kind: "Name",
									value: "email"
								}
							}
						}, {
							kind: "Argument",
							name: {
								kind: "Name",
								value: "locale"
							},
							value: {
								kind: "Variable",
								name: {
									kind: "Name",
									value: "locale"
								}
							}
						}],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "InlineFragment",
								typeCondition: {
									kind: "NamedType",
									name: {
										kind: "Name",
										value: "Ingrid_GetTrackingOrdersResponse"
									}
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "orders"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "analytics_id"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "external_id"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "preselected_parcel_index"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "sender_name"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "site_name"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "tos_id"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "tracking_links"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "links"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "type"
																	}
																}, {
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "url"
																	}
																}]
															}
														}]
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "items"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "discount"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "image"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "price"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "quantity"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "sku"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "total_price"
																}
															}
														]
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "cart"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currency"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "items"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "attributes"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "cancelled_quantity"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "cancelled_total_price"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "discount"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "image"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "name"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "price"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "quantity"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "sku"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "total_price"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "variant"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "color"
																					}
																				}, {
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "size"
																					}
																				}]
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "prices"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "shipping_components"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "discount"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "name"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "price"
																					}
																				}
																			]
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "total"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "discount"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "items_discount"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "items_price"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "price"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "shipping_discount"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "shipping_price"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "tax"
																					}
																				}
																			]
																		}
																	}]
																}
															}
														]
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "parcels"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "alerts"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "created_at"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "type"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "awaiting_supplier"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "estimated_time"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "earliest"
																							}
																						}, {
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "latest"
																							}
																						}]
																					}
																				}, {
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "estimated_time_range"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "end"
																							}
																						}, {
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "start"
																							}
																						}]
																					}
																				}]
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "delivery_attempt_failed"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "delivery_delayed"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "delivery_delayed_from_carrier"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "estimated_delivery_time_updated"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "linehaul"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "estimated_time"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "earliest"
																							}
																						}, {
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "latest"
																							}
																						}]
																					}
																				}, {
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "estimated_time_range"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "end"
																							}
																						}, {
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "start"
																							}
																						}]
																					}
																				}]
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "out_for_delivery"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "submission_delayed"
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "carrier"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "carrier_fallback_enabled"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "carrier_link"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "carrier_logo_pattern"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "carrier_product_id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "carrier_product_ref"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "delivery_type"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "direction_type"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "display_carrier_name"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "estimated_delivery_time"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "end"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "start"
																		}
																	}]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "exceptions"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "created_at"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "status"
																		}
																	}]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "index"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "line_items"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "currency"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "discount"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "image"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "name"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "price"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "properties"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "quantity"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "sku"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "total_price"
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "location"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "address"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "address_lines"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "apartment_number"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "attn"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "building_name"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "care_of"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "city"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "coordinates"
																						},
																						selectionSet: {
																							kind: "SelectionSet",
																							selections: [{
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "lat"
																								}
																							}, {
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "lng"
																								}
																							}]
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "country"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "door_code"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "floor_number"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "name"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "po_box_id"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "postal_code"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "region"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "street"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "street_number"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "subregion"
																						}
																					}
																				]
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "location_external_id"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "location_type"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "operational_hours"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "free_text"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "fri"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "mon"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "sat"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "sun"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "thu"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "tue"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "wed"
																						}
																					}
																				]
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "pickup_instructions"
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "progress"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "estimated_time"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "end"
																					}
																				}, {
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "start"
																					}
																				}]
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "step"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "time"
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "requested_shipping_method"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "sender_name"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "tracking_link"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "tracking_number"
																}
															}
														]
													}
												}
											]
										}
									}]
								}
							}, {
								kind: "InlineFragment",
								typeCondition: {
									kind: "NamedType",
									name: {
										kind: "Name",
										value: "Ingrid_Error"
									}
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "code"
											}
										},
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "details"
											}
										},
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}
									]
								}
							}]
						}
					}]
				}
			}]
		}
	}]
} };
function cu(e) {
	return su[e] ?? {};
}
var lu = cu("\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n"), uu = (e) => {
	if (!e) return "";
	try {
		return new Intl.DateTimeFormat(void 0, {
			dateStyle: "medium",
			timeStyle: "short"
		}).format(new Date(e));
	} catch {
		return e;
	}
}, du = (e, t) => {
	try {
		return new Intl.NumberFormat(void 0, {
			style: "currency",
			currency: t
		}).format(e);
	} catch {
		return e.toString();
	}
}, fu = {
	list: "_list_1sdc5_1",
	listItem: "_listItem_1sdc5_4",
	listItemEdit: "_listItemEdit_1sdc5_11",
	clickableIcon: "_clickableIcon_1sdc5_15",
	productImage: "_productImage_1sdc5_20"
}, pu = ({ items: e, title: t, currency: n, openByDefault: r = !1 }) => {
	let [i, a] = W(r);
	return !e || e.length === 0 ? null : /* @__PURE__ */ K(_, {
		gap: "100",
		flexDirection: "column",
		children: /* @__PURE__ */ q(_, {
			gap: "250",
			flexDirection: "column",
			children: [/* @__PURE__ */ q(_, {
				gap: "250",
				flexDirection: "row",
				children: [/* @__PURE__ */ K(b, {
					size: 14,
					name: "list-ul",
					color: "blue.900"
				}), /* @__PURE__ */ K(_, {
					gap: "200",
					flexDirection: "column",
					children: /* @__PURE__ */ q(_, {
						gap: "100",
						flexDirection: "row",
						onClick: () => a(!i),
						className: fu.clickableIcon,
						alignItems: "center",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: t
						}), /* @__PURE__ */ K(b, {
							size: 14,
							name: i ? "angle-down" : "angle-right"
						})]
					})
				})]
			}), i && /* @__PURE__ */ K(T, { children: e.map((e, t) => {
				if (!e) return null;
				let { name: r, quantity: i, price: a, image: o, sku: s } = e, c = e.currency ?? n;
				return /* @__PURE__ */ K(T.Item, {
					contentLeft: /* @__PURE__ */ q(_, {
						gap: "200",
						children: [/* @__PURE__ */ K(L.Paragraph, { children: i }), /* @__PURE__ */ K(L.Paragraph, { children: "×" })]
					}),
					title: /* @__PURE__ */ q(_, {
						flexDirection: "column",
						gap: "050",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: r
						}), a != null && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							color: "tertiary",
							children: du(a / 100, c)
						})]
					}),
					contentRight: o && /* @__PURE__ */ K(S, {
						src: o,
						alt: r ?? "Product image",
						className: fu.productImage
					}),
					className: fu.listItem
				}, `item-${t}-${s}`);
			}) })]
		})
	});
}, mu = {
	boxWrapper: "_boxWrapper_89s7l_1",
	trackButton: "_trackButton_89s7l_10"
}, hu = {
	[ou.StepUnknown]: "Unknown",
	[ou.StepConfirmedByMerchant]: "Confirmed by merchant",
	[ou.StepPreparedByMerchant]: "Prepared by merchant",
	[ou.StepSubmittedToCarrier]: "Submitted to carrier",
	[ou.StepLinehaulToCarrier]: "Linehaul to carrier",
	[ou.StepOnRoute]: "On route",
	[ou.StepDeliveredToPickupPoint]: "At pickup point",
	[ou.StepDeliveredToConsumer]: "Delivered to customer",
	[ou.StepDeliveredToMerchant]: "Returned to merchant",
	[ou.StepReturnRequested]: "Return requested",
	[ou.StepSentBack]: "Sent back",
	[ou.StepTerminated]: "Terminated",
	[ou.StepAwaitingSupplier]: "Awaiting supplier"
}, gu = {
	[au.Delivery]: "Home delivery",
	[au.Pickup]: "Pickup point",
	[au.Instore]: "In-store pickup",
	[au.Mailbox]: "Mailbox",
	[au.Inwarehouse]: "Warehouse",
	[au.Unknown]: "Unknown"
}, _u = {
	[iu.Outbound]: "From merchant to customer",
	[iu.Return]: "Return from customer to merchant",
	[iu.Unspecified]: "Unspecified",
	[iu.UnknownDirectionType]: "Unknown"
}, vu = (e) => e ? hu[e] ?? e : "", yu = (e) => e ? gu[e] ?? e : "", bu = (e) => e ? _u[e] ?? e : "", xu = (e) => {
	if (!e) return null;
	let t = [e.street, e.street_number].filter(Boolean).join(" ");
	return [
		e.name,
		t,
		e.postal_code,
		e.city,
		e.country
	].filter(Boolean).join("\n");
}, Su = ({ parcel: e }) => {
	let { isCopied: t, copy: n } = Re();
	if (!e) return null;
	let { carrier: r, progress: i, tracking_number: a, line_items: o, carrier_product_ref: s, carrier_link: c, display_carrier_name: l, delivery_type: u, direction_type: d, estimated_delivery_time: f } = e, p = l || s || r, m = i?.filter((e) => e?.time !== ""), h = vu(m?.[0]?.step), g = yu(u), v = bu(d), y = xu(e.location?.address);
	return /* @__PURE__ */ q(_, {
		gap: "300",
		flexDirection: "column",
		padding: "250",
		className: mu.boxWrapper,
		children: [
			/* @__PURE__ */ K(L.Heading, {
				variant: "heading-4",
				children: p
			}),
			/* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ q(_, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "magnifying-glass-chart",
						color: "blue.900"
					}), /* @__PURE__ */ q(_, {
						gap: "100",
						flexDirection: "column",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Carrier tracking ID"
						}), /* @__PURE__ */ q(_, {
							gap: "100",
							flexDirection: "row",
							flexWrap: "wrap",
							children: [!a && /* @__PURE__ */ K(L.Paragraph, {
								variant: "4",
								color: "tertiary",
								children: "No tracking ID here yet"
							}), a && /* @__PURE__ */ K(L.Paragraph, {
								variant: "4",
								color: "secondary",
								children: a
							})]
						})]
					})]
				}), a && /* @__PURE__ */ K(_, {
					flexDirection: "row",
					children: /* @__PURE__ */ K(R, {
						content: "Copy tracking ID",
						children: /* @__PURE__ */ K(b, {
							size: 14,
							name: t ? "done" : "copy",
							className: fu.clickableIcon,
							onClick: () => n(a)
						})
					})
				})]
			}),
			h && /* @__PURE__ */ q(_, {
				gap: "250",
				flexDirection: "row",
				children: [/* @__PURE__ */ K(b, {
					size: 14,
					name: "chart-donut",
					color: "blue.900"
				}), /* @__PURE__ */ q(_, {
					gap: "100",
					flexDirection: "column",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "3",
						children: "Status"
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: h
					})]
				})]
			}),
			v && /* @__PURE__ */ q(_, {
				gap: "250",
				flexDirection: "row",
				children: [/* @__PURE__ */ K(b, {
					size: 14,
					name: "arrow-right",
					color: "blue.900"
				}), /* @__PURE__ */ q(_, {
					gap: "100",
					flexDirection: "column",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "3",
						children: "Direction"
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: v
					})]
				})]
			}),
			f && /* @__PURE__ */ q(_, {
				gap: "250",
				flexDirection: "row",
				children: [/* @__PURE__ */ K(b, {
					size: 14,
					name: "calendar",
					color: "blue.900"
				}), /* @__PURE__ */ q(_, {
					gap: "100",
					flexDirection: "column",
					children: [
						/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Estimated delivery"
						}),
						/* @__PURE__ */ q(L.Paragraph, {
							variant: "4",
							color: "secondary",
							children: [
								uu(f.start),
								" ",
								f.end && " until"
							]
						}),
						f.end && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							color: "secondary",
							children: uu(f.end)
						})
					]
				})]
			}),
			u && /* @__PURE__ */ q(_, {
				gap: "250",
				flexDirection: "row",
				children: [/* @__PURE__ */ K(b, {
					size: 14,
					name: "info",
					color: "blue.900"
				}), /* @__PURE__ */ q(_, {
					gap: "100",
					flexDirection: "column",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "3",
						children: "Delivery type"
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: g
					})]
				})]
			}),
			y && /* @__PURE__ */ q(_, {
				gap: "250",
				flexDirection: "row",
				children: [/* @__PURE__ */ K(b, {
					size: 14,
					name: "map-pin",
					color: "blue.900"
				}), /* @__PURE__ */ q(_, {
					gap: "100",
					flexDirection: "column",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "3",
						children: "Pickup location"
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: y
					})]
				})]
			}),
			/* @__PURE__ */ K(pu, {
				title: "Parcel items",
				items: o
			}),
			c && /* @__PURE__ */ q(A, {
				variant: "secondary",
				className: mu.trackButton,
				navigate: () => window.open(c, "_blank")?.focus(),
				slotStart: /* @__PURE__ */ K(b, { name: "external-link" }),
				children: [
					"Track on ",
					p ?? "carrier",
					" website"
				]
			})
		]
	});
}, Cu = {
	order: "_order_135ze_1",
	orderIsOpen: "_orderIsOpen_135ze_9",
	orderHeader: "_orderHeader_135ze_12"
}, wu = "No order number found", Tu = ({ order: e, openByDefault: t }) => {
	let [r, i] = W(t), { isCopied: a, copy: o } = Re(), { isCopied: s, copy: c } = Re();
	if (!e) return null;
	let { cart: l, parcels: u, sender_name: d, tos_id: f } = e, p = e.external_id?.trim(), m = l?.currency || "", h = du((l?.prices?.total?.price ?? 0) / 100, m), g = d && d.trim() !== "" ? d : "unknown sender";
	return /* @__PURE__ */ q(_, {
		className: ae(Cu.order, { [Cu.orderIsOpen]: r }),
		gap: "300",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			justifyContent: "space-between",
			alignItems: "center",
			className: Cu.orderHeader,
			onClick: () => i(!r),
			children: [/* @__PURE__ */ q(_, {
				gap: "100",
				flexDirection: "column",
				children: [/* @__PURE__ */ q(L.Paragraph, {
					variant: "4",
					children: ["From ", g]
				}), p ? /* @__PURE__ */ K(L.Paragraph, {
					variant: "3",
					children: /* @__PURE__ */ q("span", { children: ["#", p] })
				}) : /* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					color: "tertiary",
					children: wu
				})]
			}), /* @__PURE__ */ K(x, {
				variant: "tertiary",
				icon: r ? "angle-down" : "angle-right"
			})]
		}), r && /* @__PURE__ */ q(_, {
			gap: "250",
			flexDirection: "column",
			margin: "200 0 0",
			children: [
				/* @__PURE__ */ q(_, {
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						gap: "250",
						flexDirection: "row",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "tag",
							color: "blue.900"
						}), /* @__PURE__ */ q(_, {
							gap: "100",
							flexDirection: "column",
							children: [/* @__PURE__ */ K(L.Paragraph, {
								variant: "3",
								children: "Order number"
							}), /* @__PURE__ */ K(_, {
								gap: "100",
								flexDirection: "row",
								flexWrap: "wrap",
								children: p ? /* @__PURE__ */ K(L.Paragraph, {
									variant: "4",
									color: "secondary",
									children: p
								}) : /* @__PURE__ */ K(L.Paragraph, {
									variant: "4",
									color: "tertiary",
									children: wu
								})
							})]
						})]
					}), p && /* @__PURE__ */ K(_, {
						flexDirection: "row",
						children: /* @__PURE__ */ K(R, {
							content: "Copy order number",
							children: /* @__PURE__ */ K(b, {
								size: 14,
								name: s ? "done" : "copy",
								className: fu.clickableIcon,
								onClick: () => c(p)
							})
						})
					})]
				}),
				/* @__PURE__ */ q(_, {
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						gap: "250",
						flexDirection: "row",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "magnifying-glass-chart",
							color: "blue.900"
						}), /* @__PURE__ */ q(_, {
							gap: "100",
							flexDirection: "column",
							children: [/* @__PURE__ */ K(L.Paragraph, {
								variant: "3",
								children: "Ingrid tracking ID"
							}), /* @__PURE__ */ q(_, {
								gap: "100",
								flexDirection: "row",
								flexWrap: "wrap",
								children: [!f && /* @__PURE__ */ K(L.Paragraph, {
									variant: "4",
									color: "tertiary",
									children: "No tracking ID here yet"
								}), f && /* @__PURE__ */ K(L.Paragraph, {
									variant: "4",
									color: "secondary",
									children: f
								})]
							})]
						})]
					}), f && /* @__PURE__ */ K(_, {
						flexDirection: "row",
						children: /* @__PURE__ */ K(R, {
							content: "Copy tracking ID",
							children: /* @__PURE__ */ K(b, {
								size: 14,
								name: a ? "done" : "copy",
								className: fu.clickableIcon,
								onClick: () => o(f)
							})
						})
					})]
				}),
				d && /* @__PURE__ */ q(_, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "user",
						color: "blue.900"
					}), /* @__PURE__ */ q(_, {
						gap: "100",
						flexDirection: "column",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Sender"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: d
						})]
					})]
				}),
				/* @__PURE__ */ q(_, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "chart-bar",
						color: "blue.900"
					}), /* @__PURE__ */ q(_, {
						gap: "100",
						flexDirection: "column",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Order value"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: h
						})]
					})]
				}),
				/* @__PURE__ */ K(pu, {
					openByDefault: !0,
					title: "Order items",
					items: l?.items?.map((e) => e),
					currency: l?.currency
				}),
				u && /* @__PURE__ */ q(_, {
					gap: "200",
					flexDirection: "column",
					margin: "0 0 100 0",
					children: [
						/* @__PURE__ */ q(_, {
							gap: "200",
							flexDirection: "row",
							alignItems: "center",
							children: [/* @__PURE__ */ K(L.Heading, {
								variant: "heading-4",
								children: "Parcels"
							}), u.length > 0 && /* @__PURE__ */ K(n, {
								variant: "success",
								size: "small",
								children: u.length
							})]
						}),
						u.length === 0 && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							color: "secondary",
							children: "No parcels here"
						}),
						u.map((e, t) => /* @__PURE__ */ K(Su, { parcel: e }, `parcel-${t}-${e?.tracking_number}`))
					]
				})
			]
		})]
	});
}, Eu = (e) => {
	let t = [], n = /* @__PURE__ */ new Map();
	for (let r of e) {
		if (!r?.external_id) {
			t.push(r);
			continue;
		}
		let e = n.get(r.external_id);
		if (e) e.parcels = [...e.parcels ?? [], ...r.parcels ?? []];
		else {
			let e = { ...r };
			n.set(r.external_id, e), t.push(e);
		}
	}
	return t;
}, Du = (e) => {
	let t = Infinity;
	for (let n of e?.parcels ?? []) for (let e of n?.progress ?? []) {
		if (!e?.time) continue;
		let n = new Date(e.time).getTime();
		!Number.isNaN(n) && n < t && (t = n);
	}
	return t === Infinity ? -Infinity : t;
}, Ou = (e) => [...e].sort((e, t) => Du(t) - Du(e)), ku = ({ customerEmail: e }) => {
	let { useQuery: t } = V(), [r, i] = W([]), { data: a, loading: o, error: s } = t(lu, {
		skip: !e,
		variables: {
			email: e,
			locale: "en-GB"
		}
	}), c = !o && r.length > 0, l = s ? De({ error: s.graphQLErrors?.[0] }) : !1, u = s ? Ee({ error: s.graphQLErrors?.[0] }) : !1;
	return U(() => {
		let e = a?.Ingrid?.DeliveryTracking_GetTrackingOrders;
		e?.orders && i(Ou(Eu(e.orders)));
	}, [a?.Ingrid?.DeliveryTracking_GetTrackingOrders]), o ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		children: /* @__PURE__ */ K(N, {})
	}) : l || !c && !s ? /* @__PURE__ */ K(L.Paragraph, {
		color: "tertiary",
		align: "center",
		children: "No orders to track"
	}) : u ? /* @__PURE__ */ K(L.Paragraph, {
		color: "tertiary",
		align: "center",
		children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
	}) : s ? /* @__PURE__ */ K(z, { error: s }) : /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			gap: "200",
			flexDirection: "row",
			alignItems: "center",
			children: [/* @__PURE__ */ K(L.Heading, {
				variant: "heading-3",
				children: "Orders"
			}), /* @__PURE__ */ K(n, {
				variant: "success",
				size: "small",
				children: r.length
			})]
		}), /* @__PURE__ */ K(_, {
			gap: "200",
			flexDirection: "column",
			children: /* @__PURE__ */ K(_, {
				gap: "200",
				flexDirection: "column",
				children: r.map((e, t) => /* @__PURE__ */ K(Tu, {
					order: e,
					openByDefault: t === 0
				}, `${t}-${e?.tos_id}`))
			})
		})]
	});
}, Au = ({ conversationContext: e }) => {
	let t = e?.customer?.email;
	return /* @__PURE__ */ K(_, {
		gap: "300",
		flexDirection: "column",
		margin: "200 0 300",
		"data-testid": "widget-wrapper",
		children: /* @__PURE__ */ K(ku, { customerEmail: t })
	});
}, ju = [
	{
		key: "ingridUseStagingEnvironment",
		label: "Use Ingrid staging environment",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "ingridSiteId",
		label: "Site ID",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "ingridApiToken",
		label: "API token",
		type: "string",
		secret: !0,
		defaultValue: ""
	}
], Mu = Pe(ju), Nu = {
	enabled: !1,
	name: "",
	ingridSiteId: "",
	ingridApiToken: "",
	ingridUseStagingEnvironment: !1
}, Pu = ({ integrationId: e, handleRedirect: t, showNotification: n, automationCouplingState: r, renderConditionsEditor: i }) => {
	let a = !e, o = xc({
		mode: "onChange",
		defaultValues: Nu
	}), { create: s, update: c, remove: l, isLoading: u, error: d, misconfigurationCause: f, setMisconfigurationCause: p } = Ve({
		integrationId: e,
		integrationType: "INGRID",
		handleRedirect: t,
		showNotification: n
	}), { isLoading: m, error: h, isWidgetUnknown: _, refetch: b, widgetConfiguration: x } = He({
		integrationId: e,
		fieldDefinitions: ju,
		form: o,
		onMisconfigured: p
	}), { renderConditions: S, setRenderConditions: C, renderConditionsForSubmit: w } = Be({
		integrationId: e,
		widgetConfiguration: x,
		renderConditionsEditor: i
	}), T = (e) => ye(e, {
		fieldDefinitions: ju,
		isCreationMode: a,
		create: s,
		update: c,
		renderConditions: w
	}), E = o.watch("name");
	return /* @__PURE__ */ q(de, {
		form: o,
		integrationId: e,
		onValidSubmit: T,
		error: h ?? d,
		onRetry: h ? b : void 0,
		isLoading: u || m,
		isWidgetUnknown: _,
		children: [
			f && /* @__PURE__ */ K(se, { cause: f }),
			/* @__PURE__ */ q(y, { children: [
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ K(Z, {
						name: "enabled",
						control: o.control
					})
				}) }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "name",
						label: "Widget name",
						control: o.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: Mu.ingridUseStagingEnvironment,
						children: /* @__PURE__ */ K(Z, {
							name: "ingridUseStagingEnvironment",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "ingridSiteId",
						label: Mu.ingridSiteId,
						control: o.control,
						rules: { required: "Site ID is required" },
						componentProps: {
							placeholder: "Site ID from Ingrid",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(ue, {
						name: "ingridApiToken",
						label: Mu.ingridApiToken,
						control: o.control,
						isCreationMode: a,
						rules: { required: "API token is required" },
						componentProps: {
							placeholder: "API token from Ingrid",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				i && S !== null && /* @__PURE__ */ K(v, { children: i({
					value: S,
					onChange: C,
					configurationKey: x?.id
				}) })
			] }),
			/* @__PURE__ */ K(pe, {
				integrationType: "INGRID",
				integrationId: e,
				widgetName: E,
				isCreationMode: a,
				isSubmitting: o.formState.isSubmitting,
				automationCouplingState: r,
				onConfirmDelete: () => l()
			})
		]
	});
};
//#endregion
//#region ../widget-jira/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._jiraCode_h30p6_1{font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px;padding:2px 4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_19ax5_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_19ax5_8>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_19ax5_8>div>div>p{white-space:unset!important}._collapseHeader_19ax5_8>div:first-child,._collapseHeader_19ax5_8>div:first-child div:first-child{width:100%}._collapseHeader_19ax5_8>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_19ax5_8{padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500);background-color:#0000!important}._collapseHeaderLink_19ax5_33{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_19ax5_33:hover{text-decoration:underline}._collapseHeaderStatus_19ax5_42{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_19ax5_48{margin-left:var(--dixa-size-spacer-100);padding-top:.35em;transform:scale(1.4)}._collapseHeaderTitle_19ax5_53{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_19ax5_61{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_19ax5_64{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_19ax5_70{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_19ax5_73{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_19ax5_76{max-width:10em}._collapseContentDescription_19ax5_79{max-height:75vh;overflow-y:auto}._result_1wiub_54{padding:0 var(--dixa-size-spacer-200);color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;cursor:pointer;border:0;outline:0;align-items:center;width:100%;height:48px;margin:0;font-size:12px;line-height:32px;display:flex;position:relative}._result_1wiub_54:hover,._result_1wiub_54:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1wiub_74{text-align:left;white-space:nowrap;text-overflow:ellipsis;width:100%;font-weight:var(--dixa-typography-weight-semibold);overflow:hidden}._resultNameIcon_1wiub_82{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_1wiub_87{text-align:left;width:100%;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em;overflow:hidden}._resultLinkIcon_1wiub_99{background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);color:var(--dixa-color-neutral-500);border-radius:5px;position:absolute;right:5px}._tooltip_1wiub_108{text-overflow:ellipsis;width:500px;max-height:60vh;overflow:hidden}._tooltipContent_1wiub_114{flex-direction:column;width:100%;max-height:60dvh;display:flex}._tooltipName_1wiub_121{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1wiub_126{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_1wiub_131{text-align:left;width:100%;color:var(--dixa-typography-color-secondary);flex-grow:1;padding-top:.5em;overflow-y:auto}._tooltipSummary_1wiub_139{font-weight:var(--dixa-typography-weight-semibold);padding-top:.5em}._tooltipTag_1wiub_143{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;font-size:var(--dixa-typography-size-200);cursor:pointer;border:0;outline:0;align-items:center;width:100%;height:48px;margin:0;line-height:32px;display:flex;position:relative}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{text-align:left;white-space:nowrap;text-overflow:ellipsis;width:100%;font-weight:var(--dixa-typography-weight-semibold);overflow:hidden}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400);display:grid}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var Fu = (e, t) => ((n) => (e.marks || []).map((n) => ({
	formatterFunction: t.marks[e.type]?.[n.type],
	mark: n
})).reduce((e, t) => () => t.formatterFunction?.(t.mark, e) || n, () => n)())((t.nodes[e.type] || t.default)(e, ((e, t) => () => e.content ? e.content.map((e) => Fu(e, t)) : [])(e, t))), Iu = {
	jiraCode: "_jiraCode_h30p6_1",
	jiraCodeInline: "_jiraCodeInline_h30p6_8"
}, Lu = {
	default: (e, t) => t().every((e) => typeof e == "string") ? t().join(" ") : /* @__PURE__ */ K(G, { children: t() }),
	nodes: {
		doc: (e, t) => /* @__PURE__ */ K("div", { children: t() }),
		paragraph: (e, t) => /* @__PURE__ */ K("p", { children: t() }),
		text: (e) => e.text || "",
		hardBreak: () => /* @__PURE__ */ K("br", {}),
		bulletList: (e, t) => /* @__PURE__ */ K("ul", { children: t() }),
		orderedList: (e, t) => /* @__PURE__ */ K("ol", { children: t() }),
		listItem: (e, t) => /* @__PURE__ */ K("li", { children: t() }),
		codeBlock: (e, t) => /* @__PURE__ */ K("pre", { children: /* @__PURE__ */ K("code", {
			className: Iu.jiraCode,
			children: t()
		}) }),
		heading: (e, t) => {
			switch (e.attrs?.level) {
				case 1: return /* @__PURE__ */ K("h3", { children: t() });
				case 2: return /* @__PURE__ */ K("h4", { children: t() });
				case 3: return /* @__PURE__ */ K("h5", { children: t() });
				case 4: return /* @__PURE__ */ K("h6", { children: t() });
				case 5: return /* @__PURE__ */ K("b", { children: t() });
				case 6: return /* @__PURE__ */ K("b", { children: t() });
				default: return /* @__PURE__ */ K("h4", { children: t() });
			}
		}
	},
	marks: { text: {
		em: (e, t) => /* @__PURE__ */ K("em", { children: t() }),
		strong: (e, t) => /* @__PURE__ */ K("b", { children: t() }),
		underline: (e, t) => /* @__PURE__ */ K("u", { children: t() }),
		link: (e, t) => /* @__PURE__ */ K("a", {
			href: e.attrs?.href || "",
			target: "_blank",
			rel: "noreferrer",
			children: t()
		}),
		code: (e, t) => /* @__PURE__ */ K("code", {
			className: ae(Iu.jiraCode, Iu.jiraCodeInline),
			children: t()
		})
	} }
}, Ru = ({ iconUrl: e, className: t, width: n }) => {
	let [r, i] = W(!1);
	return !e || r ? /* @__PURE__ */ K(b, {
		size: n,
		name: "question",
		className: t
	}) : /* @__PURE__ */ K("img", {
		src: e,
		width: n,
		className: t,
		onError: ({ currentTarget: e }) => {
			e.onerror = null, i(!0);
		}
	});
}, zu = {
	collapse: "_collapse_19ax5_1",
	collapseHeader: "_collapseHeader_19ax5_8",
	collapseHeaderLink: "_collapseHeaderLink_19ax5_33",
	collapseHeaderStatus: "_collapseHeaderStatus_19ax5_42",
	collapseHeaderIcon: "_collapseHeaderIcon_19ax5_48",
	collapseHeaderTitle: "_collapseHeaderTitle_19ax5_53",
	collapseContent: "_collapseContent_19ax5_61",
	collapseContentHeadline: "_collapseContentHeadline_19ax5_64",
	collapseContentButtonSpacer: "_collapseContentButtonSpacer_19ax5_70",
	collapseContentButtonLink: "_collapseContentButtonLink_19ax5_73",
	collapseContentStatusTag: "_collapseContentStatusTag_19ax5_76",
	collapseContentDescription: "_collapseContentDescription_19ax5_79"
}, Bu = ({ jiraInstanceUrl: e, avatarId: t, iconUrl: n }) => t ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${t}?size=medium` : n, Vu = ({ issues: e, jiraInstanceUrl: t, unlinkIssue: n }) => {
	let [r, o] = W(e.reduce((e, t) => t?.id ? {
		...e,
		[t.id]: !1
	} : e, {})), { track: c } = B(), l = (e, t) => {
		o({
			...r,
			[e]: t
		});
	};
	return /* @__PURE__ */ K(_, {
		flexDirection: "column",
		gap: "250",
		children: e?.length ? e.map((e) => {
			let { summary: o, description: u, status: d, issuetype: f } = e?.fields || {}, p = Bu({
				avatarId: f?.avatarId,
				iconUrl: f?.iconUrl,
				jiraInstanceUrl: t
			});
			return /* @__PURE__ */ q(s, {
				onToggle: () => e?.id && l(e.id, !r[e.id]),
				isOpen: !!(e?.id && r[e.id]),
				className: zu.collapse,
				children: [/* @__PURE__ */ K(s.Header, {
					className: zu.collapseHeader,
					children: /* @__PURE__ */ q(_, {
						flexDirection: "column",
						gap: "200",
						justifyContent: "space-between",
						children: [/* @__PURE__ */ q(_, {
							flexDirection: "row",
							justifyContent: "space-between",
							children: [/* @__PURE__ */ q(_, {
								alignItems: "center",
								gap: "200",
								children: [/* @__PURE__ */ K(Ru, {
									width: 16,
									iconUrl: p
								}), /* @__PURE__ */ K("a", {
									className: zu.collapseHeaderLink,
									href: `${t}/browse/${e?.key}`,
									target: "_blank",
									rel: "noreferrer",
									onClick: (n) => {
										n.stopPropagation(), e?.key && c("jira:view:issue:clicked", {
											jiraIssueKey: e.key,
											jiraInstanceUrl: t
										});
									},
									children: /* @__PURE__ */ q(_, {
										alignItems: "center",
										gap: "200",
										children: [e?.key, /* @__PURE__ */ K(b, {
											name: "external-link",
											size: 16
										})]
									})
								}, e?.key)]
							}), /* @__PURE__ */ K("span", {
								className: zu.collapseHeaderStatus,
								children: d?.name && /* @__PURE__ */ K(I, {
									className: zu.collapseContentStatusTag,
									children: d.name
								})
							})]
						}), /* @__PURE__ */ K("div", {
							className: zu.collapseHeaderTitle,
							children: o
						})]
					})
				}), /* @__PURE__ */ K(s.Content, {
					className: zu.collapseContent,
					children: /* @__PURE__ */ q(_, {
						flexDirection: "column",
						gap: "250",
						margin: "0 0 200 0",
						children: [
							/* @__PURE__ */ K("div", {
								className: zu.collapseContentHeadline,
								children: "Description"
							}),
							/* @__PURE__ */ K(i, {
								className: zu.collapseContentDescription,
								children: u ? Fu(u, Lu) : ""
							}),
							/* @__PURE__ */ K(a, {
								icon: "link-slash",
								variant: "secondary",
								className: zu.collapseContentButtonSpacer,
								onClick: () => e?.key && n(e.key),
								children: "Unlink issue from Jira"
							}),
							/* @__PURE__ */ K(A, {
								slotEnd: /* @__PURE__ */ K(b, { name: "external-link" }),
								variant: "tertiary",
								className: zu.collapseContentButtonLink,
								navigate: () => {
									e?.key && (c("jira:view:issue:clicked", {
										jiraIssueKey: e.key,
										jiraInstanceUrl: t
									}), window.open(`${t}/browse/${e.key}`, "_blank")?.focus());
								},
								children: "View issue in Jira"
							})
						]
					})
				})]
			}, e?.id);
		}) : /* @__PURE__ */ K(G, {})
	});
}, Hu = {
	"\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: \"Dixa Conversations\"\n            type: \"com.dixa.conversations\"\n          }\n          relationship: \"dixa-backlink\"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: \"https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2\"\n              title: \"Dixa\"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "createBacklink"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "issueKey"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "title"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "url"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "globalId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Jira"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "createOrUpdateRemoteIssueLink"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "issueIdOrKey"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "issueKey"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "ObjectValue",
									fields: [
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "globalId"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "globalId"
												}
											}
										},
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "application"
											},
											value: {
												kind: "ObjectValue",
												fields: [{
													kind: "ObjectField",
													name: {
														kind: "Name",
														value: "name"
													},
													value: {
														kind: "StringValue",
														value: "Dixa Conversations",
														block: !1
													}
												}, {
													kind: "ObjectField",
													name: {
														kind: "Name",
														value: "type"
													},
													value: {
														kind: "StringValue",
														value: "com.dixa.conversations",
														block: !1
													}
												}]
											}
										},
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "relationship"
											},
											value: {
												kind: "StringValue",
												value: "dixa-backlink",
												block: !1
											}
										},
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "object"
											},
											value: {
												kind: "ObjectValue",
												fields: [
													{
														kind: "ObjectField",
														name: {
															kind: "Name",
															value: "title"
														},
														value: {
															kind: "Variable",
															name: {
																kind: "Name",
																value: "title"
															}
														}
													},
													{
														kind: "ObjectField",
														name: {
															kind: "Name",
															value: "url"
														},
														value: {
															kind: "Variable",
															name: {
																kind: "Name",
																value: "url"
															}
														}
													},
													{
														kind: "ObjectField",
														name: {
															kind: "Name",
															value: "icon"
														},
														value: {
															kind: "ObjectValue",
															fields: [{
																kind: "ObjectField",
																name: {
																	kind: "Name",
																	value: "url16x16"
																},
																value: {
																	kind: "StringValue",
																	value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2",
																	block: !1
																}
															}, {
																kind: "ObjectField",
																name: {
																	kind: "Name",
																	value: "title"
																},
																value: {
																	kind: "StringValue",
																	value: "Dixa",
																	block: !1
																}
															}]
														}
													}
												]
											}
										}
									]
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "__typename"
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "removeBacklink"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "issueKey"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "globalId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Jira"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "deleteRemoteIssueLinkByGlobalId"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "issueIdOrKey"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "issueKey"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "globalId"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "globalId"
									}
								}
							}]
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "createIssue"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Jira_IssueUpdateDetails_Input"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Jira"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "createIssue"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Jira_CreatedIssue"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "key"
											}
										}]
									}
								}, {
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Jira_ErrorCollection"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "errorMessages"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "status"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "errors"
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "jira"
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Jira"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getAllProjects"
							},
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "id"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "key"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "name"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "avatarUrls"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "_24x24"
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: \"projects.issuetypes.fields\"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getCreateIssueMeta"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "projectKey"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Jira"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getCreateIssueMeta"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "projectKeys"
								},
								value: {
									kind: "ListValue",
									values: [{
										kind: "Variable",
										name: {
											kind: "Name",
											value: "projectKey"
										}
									}]
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "expand"
								},
								value: {
									kind: "StringValue",
									value: "projects.issuetypes.fields",
									block: !1
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "projects"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "key"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "name"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "issuetypes"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "iconUrl"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "entityId"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "hierarchyLevel"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "subtask"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "scope"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "type"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "project"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "id"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "key"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "name"
																					}
																				}
																			]
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "additionalProperties"
																		}
																	}
																]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "expand"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "subtask"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "description"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "fields"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "additionalProperties"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "key"
																			}
																		}, {
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "value"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "key"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "name"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "required"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "hasDefaultValue"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "schema"
																						},
																						selectionSet: {
																							kind: "SelectionSet",
																							selections: [
																								{
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "type"
																									}
																								},
																								{
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "system"
																									}
																								},
																								{
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "items"
																									}
																								},
																								{
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "custom"
																									}
																								},
																								{
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "customId"
																									}
																								}
																							]
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "allowedValues"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "defaultValue"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "operations"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "autoCompleteUrl"
																						}
																					}
																				]
																			}
																		}]
																	}
																}]
															}
														}
													]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          \"summary\"\n          \"description\"\n          \"status\"\n          \"updated\"\n          \"issuetype\"\n          \"project\"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "searchAndReconsileIssuesUsingJql"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "jql"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "maxResults"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Int"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Jira"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "searchAndReconsileIssuesUsingJql"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "jql"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "jql"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "maxResults"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "maxResults"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "fields"
									},
									value: {
										kind: "ListValue",
										values: [
											{
												kind: "StringValue",
												value: "summary",
												block: !1
											},
											{
												kind: "StringValue",
												value: "description",
												block: !1
											},
											{
												kind: "StringValue",
												value: "status",
												block: !1
											},
											{
												kind: "StringValue",
												value: "updated",
												block: !1
											},
											{
												kind: "StringValue",
												value: "issuetype",
												block: !1
											},
											{
												kind: "StringValue",
												value: "project",
												block: !1
											}
										]
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "issues"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "key"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "fields"
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "findUsers"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "query"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Jira"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "findUsers"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "query"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "query"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "accountId"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "displayName"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "self"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "active"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "avatarUrls"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "_24x24"
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	}
};
function Uu(e) {
	return Hu[e] ?? {};
}
var Wu = Uu("\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          \"summary\"\n          \"description\"\n          \"status\"\n          \"updated\"\n          \"issuetype\"\n          \"project\"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n"), Gu = Uu("\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: \"Dixa Conversations\"\n            type: \"com.dixa.conversations\"\n          }\n          relationship: \"dixa-backlink\"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: \"https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2\"\n              title: \"Dixa\"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n"), Ku = Uu("\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n"), qu = Uu("\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n"), Ju = Uu("\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: \"projects.issuetypes.fields\"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), Yu = Uu("\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n"), Xu = Uu("\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n"), Zu = /* @__PURE__ */ RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), Qu = RegExp(`^${Zu.source}$`), $u = RegExp(`/${Zu.source}$`), ed = RegExp(`.+?[&?]selectedIssue=(${Zu.source})[&?]?.*`);
function td(e, t) {
	let n = { jira: { issues: [] } }, [r, i] = W([]), [a, o] = W([]), [s, c] = W(), { track: l } = B(), { showNotification: u, showModal: d, useLazyQuery: f, useMutation: p } = V(), { loading: m, data: h, error: g, store: _ } = ze(e ?? null), [v, { loading: y, error: b, data: x }] = f(Wu, { notifyOnNetworkStatusChange: !0 });
	U(() => {
		let e = x?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
		e?.length && (o(e), i(e.map((e) => e?.key).filter(Boolean)));
	}, [x]), U(() => c(g || b || void 0), [g, b]), U(() => {
		m || O();
	}, [h?.jira?.issues, m]);
	let S = async (e, t) => {
		await _(e).then(() => {
			u({
				icon: "check-circle-filled",
				severity: "success",
				title: t.success.title,
				text: t.success.text
			});
		}).catch((e) => {
			u({
				title: t.error.title,
				text: `${t.error.text} ${e.message && " (" + e.message + ")"}`,
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		});
	}, [C] = p(Gu, { onError: (e) => {
		u({
			title: "Something went wrong",
			text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${e.message && " (" + e.message + ")"}`,
			icon: "exclamation-triangle-filled",
			severity: "warning"
		});
	} }), w = (t, n) => {
		let r = window.location.href, i = n ? r.replace(e?.toString() ?? "", n?.toString()) : r, a = n ? `# ${n}` : `# ${e}`;
		C({ variables: {
			issueKey: t,
			title: a,
			url: i,
			globalId: `system=${i}`
		} });
	}, [T] = p(Ku, { onError: (e) => {
		u({
			title: "Something went wrong",
			text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${e.message && " (" + e.message + ")"}`,
			icon: "exclamation-triangle-filled",
			severity: "warning"
		});
	} }), E = (e) => {
		let t = window.location.href;
		T({ variables: {
			issueKey: e,
			globalId: `system=${t}`
		} });
	}, D = (e) => ({
		jiraInstanceUrl: t,
		jiraIssueKey: e
	}), O = () => {
		h && h.jira?.issues?.length > 0 ? v({ variables: {
			jql: `key in (${h?.jira?.issues.join(",")})`,
			maxResults: 15
		} }) : o([]);
	}, k = async (e, t) => {
		l("jira:issue:link:clicked", D(e));
		let r = h?.jira?.issues ? h : n;
		r.jira.issues = Array.from(new Set(r.jira.issues).add(e)), await _(r, t?.toString()).then(() => w(e, t)).catch((t) => {
			u({
				title: "Linking failed",
				text: `Linking ${e} failed. Please try again. ${t.message && " (" + t.message + ")"}`,
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		});
	}, A = (e) => {
		l("jira:issue:link:clicked", D(e));
		let t = h?.jira?.issues ? h : n;
		t.jira.issues = Array.from(new Set(t.jira.issues).add(e)), S(t, {
			success: {
				title: "Jira issue linked",
				text: `You linked the Jira issue ${e} to this conversation.`
			},
			error: {
				title: "Linking failed",
				text: `Linking ${e} failed. Please try again.`
			}
		}).then(() => w(e));
	}, j = (e) => {
		l("jira:issue:unlink:clicked", D(e)), d({
			headline: `Unlink issue ${e}?`,
			text: `You are about to unlink the issue ${e}. Do you want to proceed?`,
			confirmLabel: "Unlink Jira issue",
			confirmVariant: "danger",
			cancelLabel: "Cancel",
			onConfirm: () => {
				l("jira:issue:unlink:confirmed", D(e));
				let t = {
					...h,
					jira: {
						...h?.jira,
						issues: h?.jira?.issues.filter((t) => t !== e) || []
					}
				};
				S(t, {
					success: {
						title: "Jira issue unlinked",
						text: `You unlinked the Jira issue ${e}`
					},
					error: {
						title: "Unlinking failed",
						text: `Unlinking ${e} failed.`
					}
				}).then(() => E(e));
			},
			onCancel: () => l("jira:issue:unlink:cancelled", D(e))
		});
	}, M = () => {
		l("jira:issue:unlink-all:clicked", { jiraInstanceUrl: t }), d({
			headline: "Unlink all Jira issues?",
			text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
			confirmLabel: "Unlink ALL issues",
			confirmVariant: "danger",
			cancelLabel: "Cancel",
			onConfirm: () => {
				l("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: t }), a?.forEach((e) => e?.key && E(e.key)), S(n, {
					success: {
						title: "Unlinking successful",
						text: "All Jira issues were unlinked"
					},
					error: {
						title: "Unlinking failed",
						text: "Unlinking all issues failed."
					}
				});
			},
			onCancel: () => l("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: t })
		});
	}, N = h?.jira?.issues?.filter((e) => !r?.includes(e)) || [];
	return {
		linkIssue: A,
		linkIssueQuietly: k,
		unlinkIssue: j,
		loadIssues: O,
		removeDanglingIssueLinks: () => {
			l("jira:issue:unlink-all-dangling:clicked", { jiraInstanceUrl: t });
			let e = {
				...h,
				jira: {
					...h?.jira,
					issues: h?.jira?.issues.filter((e) => !N.includes(e)) || []
				}
			};
			_(e);
		},
		unlinkAllIssues: M,
		maybeExtractIssueKey: (e) => {
			let n = e.replace(/\s/g, "");
			if (Qu.test(n)) return n;
			if (ed.test(e)) return e.match(ed)?.[1];
			if (e.startsWith(t) && $u.test(e)) return e.substring(e.lastIndexOf("/") + 1);
		},
		isLoadingIssueLinks: m,
		danglingIssueLinks: N,
		isLoadingIssues: y,
		issues: a,
		error: s
	};
}
function nd(e = !1, t) {
	let [n, r] = W(e);
	return U(() => {
		let e = n ? window.setTimeout(() => r(!1), t || 2e3) : void 0;
		return () => window.clearTimeout(e);
	}, [t, n]), {
		isCopied: n,
		copyToClipboard: (e) => {
			navigator.clipboard.writeText(e), r(!0);
		}
	};
}
var rd = {
	result: "_result_1wiub_54",
	resultName: "_resultName_1wiub_74",
	resultNameIcon: "_resultNameIcon_1wiub_82",
	resultDescription: "_resultDescription_1wiub_87",
	resultLinkIcon: "_resultLinkIcon_1wiub_99",
	tooltip: "_tooltip_1wiub_108",
	tooltipContent: "_tooltipContent_1wiub_114",
	tooltipName: "_tooltipName_1wiub_121",
	tooltipNameIcon: "_tooltipNameIcon_1wiub_126",
	tooltipDescription: "_tooltipDescription_1wiub_131",
	tooltipSummary: "_tooltipSummary_1wiub_139",
	tooltipTag: "_tooltipTag_1wiub_143"
}, id = ({ item: e, jiraInstanceUrl: t, onSelect: n, disableTooltip: r = !1, ...i }) => {
	let { issuetype: a, name: o, status: s, text: c, description: l } = e, [u, d] = W(!1), f = Bu({
		avatarId: a?.avatarId,
		iconUrl: a?.iconUrl,
		jiraInstanceUrl: t
	});
	return /* @__PURE__ */ K(R, {
		disabled: r,
		className: rd.tooltip,
		content: /* @__PURE__ */ q("div", {
			className: rd.tooltipContent,
			children: [
				/* @__PURE__ */ q(_, {
					flexDirection: "row",
					justifyContent: "space-between",
					width: "100%",
					children: [/* @__PURE__ */ q("span", {
						className: rd.tooltipName,
						children: [
							/* @__PURE__ */ K(Ru, {
								width: 16,
								iconUrl: f,
								className: rd.tooltipNameIcon
							}),
							"\xA0",
							o
						]
					}), /* @__PURE__ */ K(I, {
						className: rd.tooltipTag,
						children: s.name
					})]
				}),
				l && /* @__PURE__ */ K("div", {
					className: rd.tooltipSummary,
					children: l
				}),
				c && /* @__PURE__ */ K("div", {
					className: rd.tooltipDescription,
					children: c
				})
			]
		}),
		side: "left",
		light: !0,
		children: /* @__PURE__ */ q("button", {
			...i,
			className: rd.result,
			type: "button",
			onClick: () => {
				n(e);
			},
			onMouseEnter: () => d(!0),
			onMouseLeave: () => d(!1),
			children: [/* @__PURE__ */ q(_, {
				flexDirection: "column",
				justifyContent: "center",
				style: { width: u ? "calc(100% - 32px)" : "100%" },
				children: [/* @__PURE__ */ K(_, {
					flexDirection: "row",
					children: /* @__PURE__ */ q("span", {
						className: rd.resultName,
						children: [
							/* @__PURE__ */ K(Ru, {
								width: 16,
								iconUrl: f,
								className: rd.resultNameIcon
							}),
							"\xA0",
							o
						]
					})
				}), l && /* @__PURE__ */ K("div", {
					className: rd.resultDescription,
					children: l
				})]
			}), u && /* @__PURE__ */ K(b, {
				className: rd.resultLinkIcon,
				name: "plus",
				size: 32
			})]
		})
	});
}, ad = ({ className: e, searched: t, jiraInstanceUrl: n }) => /* @__PURE__ */ K(A, {
	slotEnd: /* @__PURE__ */ K(b, { name: "external-link" }),
	variant: "tertiary",
	style: { width: "100%" },
	className: e,
	navigate: () => {
		window.open(`${n}/secure/QuickSearch.jspa?searchString=${t}`, "_blank")?.focus();
	},
	children: "View matching issues in Jira"
}), od = ({ onSelectIssue: e, jiraInstanceUrl: t, filterByProjectKey: n, disableTooltip: r }) => {
	let { useLazyQuery: i } = V(), [a, o] = W([]), [s, c] = W(""), [l, { loading: u, error: d, data: f, networkStatus: p }] = i(Wu, { notifyOnNetworkStatusChange: !0 }), { maybeExtractIssueKey: m } = td(null, t), [h, g] = ul(() => {
		!u && s && p === ot.ready ? l({ variables: {
			jql: s,
			maxResults: 25
		} }) : o([]);
	}, 500, [s]);
	return U(() => {
		let e = f?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
		o(e.map((e) => ({
			id: e?.key ?? "",
			name: e?.key ?? "",
			description: e?.fields.summary,
			status: e?.fields.status,
			issuetype: e?.fields.issuetype,
			text: e?.fields.description ? Fu(e?.fields.description, Lu) : /* @__PURE__ */ K(G, {})
		})));
	}, [f]), !u && d ? /* @__PURE__ */ K(z, { error: d }) : /* @__PURE__ */ K(j, {
		items: a,
		loading: u,
		onSearch: (e) => {
			let t = e.trim(), r = m(t);
			if (r) {
				let e = r.replaceAll("[-_|]", "\\\\$0");
				c(`key = '${e}'`);
			} else t !== "" && c(`text ~ '${t}'${n ? " and project = " + n : ""}`);
		},
		onSelect: (t) => {
			e(t.id), c("");
		},
		onClear: () => {
			c("");
		},
		emptyMessage: s ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
		suggestionComponent: (e) => /* @__PURE__ */ K(ad, {
			...e,
			jiraInstanceUrl: t
		}),
		itemComponent: (e) => /* @__PURE__ */ K(id, {
			...e,
			jiraInstanceUrl: t,
			disableTooltip: r
		}),
		placeholder: "Search and link existing issue",
		searchable: !0,
		clearable: !0
	});
}, sd = ({ field: e, value: t, onChange: n }) => {
	let [r, i] = W(t ? [t] : []);
	return U(() => {
		n(r);
	}, [r]), /* @__PURE__ */ K(j, {
		multiple: !0,
		onChange: (e, t) => {
			i(t ? [...r, e] : r.filter(({ id: t }) => t !== e.id));
		},
		selectedItems: r,
		items: (e?.allowedValues)?.map(({ id: e, name: t, value: n }) => ({
			id: e,
			name: t || n
		}))
	});
}, cd = {
	itemButton: "_itemButton_1hl53_1",
	result: "_result_1hl53_6",
	resultIcon: "_resultIcon_1hl53_26",
	resultName: "_resultName_1hl53_30",
	resultCheckIcon: "_resultCheckIcon_1hl53_38"
}, ld = ({ item: e, checked: t = !1, onSelectItem: n, jiraInstanceUrl: r }) => {
	let a = (e) => {
		let t = e.indexOf("/rest/api/");
		return t >= 0 ? `${r}${e?.substring(t)}` : e;
	}, o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
	return o &&= o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o, /* @__PURE__ */ K(_, {
		flexDirection: "column",
		justifyContent: "center",
		width: "100%",
		"data-testid": "jira-select-item-component",
		children: /* @__PURE__ */ K("button", {
			onClick: () => {
				n(e);
			},
			className: cd.itemButton,
			children: /* @__PURE__ */ q(_, {
				className: cd.result,
				flexDirection: "row",
				width: "100%",
				children: [
					/* @__PURE__ */ K(Ru, {
						width: 36,
						iconUrl: o || "",
						className: cd.resultIcon
					}),
					/* @__PURE__ */ K(i, {
						className: cd.resultName,
						children: e.name
					}),
					t && /* @__PURE__ */ K(i, {
						className: cd.resultCheckIcon,
						children: /* @__PURE__ */ K(b, { name: "done" })
					})
				]
			})
		})
	});
}, ud = ({ selectedItems: e, agentEmail: t, onSelect: n, jiraInstanceUrl: r }) => {
	let { useLazyQuery: i } = V(), [a, o] = W([]), [s, c] = W(), [l, { loading: u, error: d, data: f, networkStatus: p }] = i(Xu, { notifyOnNetworkStatusChange: !0 }), [m, h] = ul(() => {
		!u && s && s.length >= 2 && p === ot.ready ? l({ variables: {
			query: s,
			maxResults: 10
		} }) : o([]);
	}, 500, [s]);
	return U(() => {
		t && l({ variables: {
			query: t,
			maxResults: 1
		} }).then((e) => {
			if (e?.data?.Jira.findUsers?.length === 1) {
				let t = e?.data?.Jira?.findUsers[0];
				n(t.accountId), o([{
					id: t.accountId,
					name: t.displayName
				}]);
			}
		});
	}, []), U(() => {
		let e = f?.Jira?.findUsers || [];
		o(e.filter(({ active: e }) => e).map(({ accountId: e, displayName: t, avatarUrls: n, active: r }) => ({
			id: e,
			name: t,
			avatarUrls: n,
			active: r
		})));
	}, [f]), !u && d ? /* @__PURE__ */ K(z, { error: d }) : /* @__PURE__ */ K(j, {
		clearable: !0,
		searchable: !0,
		items: a,
		loading: u,
		onSearch: (e) => c(e),
		onSelect: n,
		onClear: () => c(void 0),
		selectedItems: e,
		emptyMessage: s ? u ? "" : "No user found" : "Enter keyword to search for user",
		itemComponent: ({ item: e, onSelect: t, checked: n }) => /* @__PURE__ */ K(ld, {
			item: e,
			checked: n,
			onSelectItem: t,
			jiraInstanceUrl: r
		}),
		placeholder: "Search Jira users"
	});
}, dd = ({ field: e }) => {
	let [t, n] = W(!1), [r, i] = cl();
	return U(() => {
		let e = t ? window.setTimeout(() => n(!1), 2e3) : void 0;
		return () => window.clearTimeout(e);
	}, [t]), /* @__PURE__ */ q(_, {
		alignItems: "center",
		gap: "400",
		justifyContent: "space-between",
		children: [
			/* @__PURE__ */ K(_, { children: /* @__PURE__ */ K(b, {
				size: 24,
				name: "exclamation-triangle-filled",
				color: "red.500"
			}) }),
			/* @__PURE__ */ K(L.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
			/* @__PURE__ */ K(R, {
				content: t ? "Copied" : "Copy field details",
				children: /* @__PURE__ */ K(x, {
					variant: "secondary",
					icon: t ? "done" : "copy",
					onClick: () => {
						i(JSON.stringify(e, null, 2)), n(!0);
					}
				})
			})
		]
	});
}, fd = ({ field: e, onChange: t, value: n, conversationContext: r, jiraInstanceUrl: i }) => {
	let { type: a, system: o } = e.schema;
	if ([
		"array",
		"option",
		"priority"
	].includes(a) && (!e?.allowedValues || e.allowedValues.length === 0)) return /* @__PURE__ */ K(dd, { field: e });
	switch (a) {
		case "issuelink":
		case "environment":
		case "any": return /* @__PURE__ */ K(w, {
			onChange: t,
			value: n
		});
		case "string": return K(o === "description" ? ne : w, {
			onChange: t,
			value: n
		});
		case "textarea": return /* @__PURE__ */ K(ne, {
			onChange: t,
			value: n
		});
		case "number": return /* @__PURE__ */ K(w, {
			type: "number",
			onChange: t,
			value: n
		});
		case "user": return /* @__PURE__ */ K(ud, {
			onSelect: t,
			selectedItems: n ? [n] : [],
			agentEmail: e.key === "reporter" && r?.agent?.email || void 0,
			jiraInstanceUrl: i
		});
		case "option":
		case "priority": return /* @__PURE__ */ K(j, {
			onSelect: t,
			selectedItems: n ? [n] : [],
			items: (e?.allowedValues)?.map(({ id: e, name: t, value: n }) => ({
				id: e,
				name: t || n
			})) || []
		});
		case "array": return /* @__PURE__ */ K(sd, {
			field: e,
			value: n,
			onChange: t
		});
		default: return /* @__PURE__ */ K(dd, { field: e });
	}
}, pd = [
	"description",
	"reporter",
	"summary"
], md = ({ issueTypeFields: e, control: t, jiraInstanceUrl: n, conversationContext: r, errors: i }) => /* @__PURE__ */ K(G, { children: e.filter(({ key: e }) => e !== "project" && e !== "issuetype").filter(({ key: e, required: t }) => t || pd.includes(e)).map((e) => /* @__PURE__ */ K(Es, {
	control: t,
	render: ({ field: { onChange: t, value: a } }) => /* @__PURE__ */ K(g, {
		meta: { error: i && e.key in i ? i[e.key].message : null },
		label: e.name,
		required: e.required,
		children: fd({
			field: e,
			onChange: t,
			value: a,
			conversationContext: r,
			jiraInstanceUrl: n
		})
	}, e.key),
	name: e.key,
	rules: { required: e.required ? "This field is required" : !1 }
}, e.key)) }), hd = ({ createdIssue: e, issueBaseLink: t, issueLinkCopied: n, setIssueLinkCopied: r, copyToClipboard: i }) => /* @__PURE__ */ q(_, {
	flexDirection: "column",
	gap: "400",
	"data-testid": "jira-create-issue-success-message",
	children: [/* @__PURE__ */ q(L.Paragraph, { children: [
		"You can visit your new issue by following",
		" ",
		/* @__PURE__ */ q(L.ExternalLink, {
			href: `${t}/${e.key}`,
			target: "_blank",
			children: ["this link ", /* @__PURE__ */ K(b, { name: "external-link" })]
		}),
		" ",
		"or copy it from the field below."
	] }), /* @__PURE__ */ K(g, {
		label: "Jira issue link",
		children: /* @__PURE__ */ K(w, {
			readOnly: !0,
			value: `${t}/${e.key}`,
			suffix: {
				type: "button",
				button: {
					icon: n ? "done" : "copy",
					onClick: () => {
						r(!0), i(`${t}/${e.key}`);
					}
				}
			}
		})
	})]
}), gd = {
	modalBody: "_modalBody_1hk1o_1",
	modalBodyFormFields: "_modalBodyFormFields_1hk1o_4"
}, _d = (e) => ({
	version: 1,
	type: "doc",
	content: e?.trim()?.split("\n").filter((e) => e !== "").map((e) => ({
		type: "paragraph",
		content: [{
			type: "text",
			text: e
		}]
	}))
}), vd = (e) => e?.custom?.split(":")?.[1] || null, yd = (e, t) => {
	if (e.startsWith("customfield_")) {
		let n = t.find((t) => t.key === e)?.schema;
		if (n) return n;
	}
	return null;
}, bd = (e, t) => {
	let n = [
		"environment",
		"textarea",
		"description"
	];
	return { fields: {
		...Object.entries(e).reduce((r, [i, a]) => {
			if (!a || a === "") return delete e[i], r;
			let o = yd(i, t), s = vd(o) ?? i;
			return n.includes(s) ? r[i] = _d(a) : o?.type === "number" ? r[i] = parseInt(a) : r[i] = a, r;
		}, {}),
		summary: e.summary,
		project: { id: e.project.id },
		issuetype: { id: e.issuetype.id },
		...e?.parent && { parent: { key: e.parent } },
		...e?.reporter && { reporter: { id: e.reporter?.id ?? e.reporter } },
		...e?.assignee && { assignee: { id: e.assignee?.id ?? e.assignee } }
	} };
}, xd = ({ isOpen: e, onClose: t, linkIssueQuietly: n, conversationContext: i, jiraInstanceUrl: o, hasSortIssueTypeByLabelEnabled: s }) => {
	let c = {
		project: void 0,
		issuetype: void 0
	}, [l, u] = W([]), [d, f] = W(), [p, m] = W(0), [h, b] = W([]), [x, S] = W([]), [C, w] = W(!1), [T, A] = W(!1), [M, P] = W({}), { track: F } = B(), { isCopied: I, copyToClipboard: ee } = nd(), te = Ze(() => i?.conversationId, [e]), { useMutation: ne, useLazyQuery: re, showNotification: R } = V(), { control: ie, handleSubmit: ae, formState: { errors: oe }, reset: se, setValue: ce, getValues: le } = xc({ defaultValues: c }), ue = x.length > 0, de = `${o}/browse`, fe = Object.keys(M).length > 0, [pe, { loading: me, error: he }] = re(qu, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0,
		onCompleted: (e) => {
			u(e.Jira.getAllProjects);
		},
		onError: (e) => {
			R({
				title: "Could not get project list",
				text: "We could not fetch the list of your projects. Please try again later.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), console.warn("Error response when fetching projects", e), u([]);
		}
	}), [ge, { loading: _e, error: ve }] = re(Ju, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0,
		onCompleted: (e) => {
			m(0);
			let t = e?.Jira?.getCreateIssueMeta?.projects[0];
			if (t) {
				let e = t?.issuetypes.filter(({ subtask: e }) => !e);
				b(e || []), ce("issuetype", e.length > 0 ? e[0] : void 0);
			} else R({
				title: "Could not get issue-type list",
				text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), b([]), S([]);
		},
		onError: (e) => {
			R({
				title: "Could not get issue list",
				text: "We could not fetch the list of issue-types for this project. Please try again later.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), console.warn("Error in getCreateIssueMeta", e), b([]), S([]), m(0);
		}
	}), [ye, { error: be }] = ne(Yu, {
		onError: () => {
			w(!1), R({
				title: "Creation was not successful",
				text: "Please try again later or contact your admin.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), F("jira:issue:create:failed", { jiraInstanceUrl: o });
		},
		onCompleted: (e) => {
			if (w(!1), e?.Jira && "key" in e.Jira.createIssue) f(e?.Jira?.createIssue), R({
				title: "Success",
				text: `Jira issue '${e.Jira.createIssue.key}' created`,
				icon: "check-circle-filled",
				severity: "success"
			}), F("jira:issue:create:succeeded", {
				jiraInstanceUrl: o,
				jiraIssueKey: e.Jira.createIssue.key
			}), te && n(e.Jira.createIssue.key, te);
			else if ("errorMessages" in e.Jira.createIssue || "errors" in e.Jira.createIssue) {
				let t = e?.Jira?.createIssue?.errors;
				console.warn("There was a problem creating a Jira issue.", t), R({
					title: "Creation was not successful",
					text: "Something went wrong. Please get in contact with Dixa.",
					icon: "exclamation-triangle-filled",
					severity: "warning"
				});
			}
		}
	}), xe = (e) => {
		w(!0), P({}), ye({ variables: { input: bd(e, x) } });
	};
	U(() => {
		if (e) try {
			pe();
		} catch (e) {
			console.warn("Error when fetching initial projects", e);
		}
	}, [e]), U(() => {
		let e = T ? window.setTimeout(() => A(!1), 2e3) : void 0;
		return () => window.clearTimeout(e);
	}, [T]), U(() => {
		if (h?.length > 0) {
			ce("issuetype", h[p]);
			let e = h[p]?.fields?.additionalProperties;
			if (e?.length > 0) {
				let t = e.map(({ value: e }) => e), n = (s ? t.sort(({ name: e }, { name: t }) => e.localeCompare(t)) : t).sort(({ required: e }, { required: t }) => Number(t) - Number(e)), { project: r, issuetype: i } = le();
				se({
					project: r,
					issuetype: i
				}), S(n);
			}
		} else S([]), ce("issuetype", void 0);
	}, [
		h,
		ce,
		p
	]), U(() => {
		if (be && ut(be)) {
			if (be?.graphQLErrors?.length > 0) {
				let { graphQLErrors: e } = be, t = e[0].extensions?.integration?.responseBody;
				try {
					let e = JSON.parse(t);
					if (e?.errors) {
						let t = Object.keys(e.errors).reduce((t, n) => ({
							...t,
							[n]: {
								type: "required",
								message: e.errors[n],
								ref: { name: n }
							}
						}), {});
						P(t);
					}
				} catch {}
			}
		} else P({});
	}, [be]);
	let Se = () => {
		u([]), S([]), b([]), f(void 0), m(0), w(!1), P({});
	}, Ce = () => {
		Se(), se(c), t();
	}, we = (e) => {
		e && ge({ variables: { projectKey: e } });
	}, Te = (e) => {
		let t = h.map((e) => e.id).indexOf(e);
		m(t ?? 0);
	};
	return /* @__PURE__ */ q(E, {
		isOpen: e,
		"data-testid": "jira-create-issue-modal",
		onClose: Ce,
		children: [
			/* @__PURE__ */ K(k, {
				title: d ? "Issue creation successful" : "Create new Jira issue",
				onClose: Ce
			}),
			/* @__PURE__ */ q(D, {
				className: gd.modalBody,
				children: [
					!me && he && /* @__PURE__ */ K(z, {
						error: he,
						retry: pe
					}),
					!_e && ve && /* @__PURE__ */ K(z, {
						error: ve,
						retry: ge
					}),
					!C && fe && /* @__PURE__ */ K(_, {
						margin: "0 0 400",
						children: /* @__PURE__ */ K(r, {
							variant: "warning",
							description: /* @__PURE__ */ q(_, {
								gap: "300",
								flexDirection: "column",
								alignItems: "flex-start",
								children: [/* @__PURE__ */ K(L.Paragraph, {
									variant: "4",
									children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further."
								}), /* @__PURE__ */ K(a, {
									icon: I ? "done" : "copy",
									variant: "secondary",
									onClick: () => ee(JSON.stringify(x, null, 2)),
									children: "Copy form schema"
								})]
							})
						})
					}),
					d ? /* @__PURE__ */ K(hd, {
						createdIssue: d,
						issueBaseLink: de,
						issueLinkCopied: T,
						setIssueLinkCopied: A,
						copyToClipboard: ee
					}) : /* @__PURE__ */ K("form", {
						"data-testid": "jira-create-issue-form",
						onSubmit: ae(xe),
						children: /* @__PURE__ */ q(y, { children: [
							/* @__PURE__ */ K(v, {
								span: 3,
								children: /* @__PURE__ */ K(g, {
									label: "Project",
									required: !0,
									children: /* @__PURE__ */ K(Es, {
										control: ie,
										name: "project",
										rules: { required: "Please select a project" },
										render: ({ field: { onChange: e, value: t } }) => /* @__PURE__ */ K(j, {
											searchable: !0,
											loading: me,
											onSelect: (t) => {
												we(t.key), e(t);
											},
											selectedItems: [t],
											placeholder: "Select Jira project",
											emptyMessage: he ? "No projects found" : "No projects available",
											items: l || [],
											itemComponent: ({ item: e, onSelect: t, checked: n }) => /* @__PURE__ */ K(ld, {
												item: e,
												checked: n,
												onSelectItem: t,
												jiraInstanceUrl: o
											})
										})
									})
								})
							}),
							/* @__PURE__ */ K(v, {
								span: 3,
								children: /* @__PURE__ */ K(g, {
									label: "Issue type",
									required: !0,
									children: /* @__PURE__ */ K(Es, {
										control: ie,
										name: "issuetype",
										rules: { required: "Please select an issue type" },
										render: ({ field: { onChange: e, value: t } }) => /* @__PURE__ */ K(j, {
											disabled: h.length === 0,
											loading: _e,
											onSelect: (t) => {
												Te(t.id), e(t);
											},
											selectedItems: [t],
											placeholder: h.length > 0 ? "Select Jira issue type" : "",
											emptyMessage: ve ? "No issues found" : "No issues available",
											items: h,
											itemComponent: ({ item: e, onSelect: t, checked: n }) => /* @__PURE__ */ K(ld, {
												item: e,
												checked: n,
												onSelectItem: t,
												jiraInstanceUrl: o
											})
										})
									})
								})
							}),
							ue && /* @__PURE__ */ K(v, {
								className: gd.modalBodyFormFields,
								children: /* @__PURE__ */ K(md, {
									control: ie,
									errors: {
										...oe,
										...M
									},
									getValues: le,
									conversationContext: i,
									jiraInstanceUrl: o,
									issueTypeFields: x
								})
							})
						] })
					})
				]
			}),
			/* @__PURE__ */ K(O, {
				confirmOnClick: d ? Ce : ae(xe),
				confirmProps: {
					disabled: !ue,
					isLoading: C,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 })
				},
				confirmName: d ? "Close" : "Save",
				cancelOnClick: d ? void 0 : Ce
			})
		]
	});
}, Sd = (e) => {
	if (!e) return "";
	let t = "https://";
	return `${t}${(e.startsWith(t) ? e.slice(8) : e).split("/")[0]}`;
}, Cd = (e) => {
	if (!e?.trim()) return "Please add a value";
	let t = "https://";
	if (e.startsWith(" ") || e.endsWith(" ")) return "Please remove any empty spaces before or after the URL";
	let n = e.startsWith(t);
	if (n) {
		let t = e.slice(8).split("/");
		if (t.length > 1) {
			let r = n ? 8 + t[0].length : t[0].length;
			return t.length === 2 && t[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(r)}\``;
		}
	} else return e.includes("://") ? `The protocol \`${e.substring(0, e.indexOf("://") + 3)}\` is not supported` : `Please add \`${t}\` as protocol`;
}, wd = {
	wrapper: "_wrapper_1bylq_1",
	inputWrapper: "_inputWrapper_1bylq_6",
	inputField: "_inputField_1bylq_14",
	inputSeparator: "_inputSeparator_1bylq_18",
	buttonLink: "_buttonLink_1bylq_23",
	noIssuesFound: "_noIssuesFound_1bylq_27"
}, Td = ({ conversationContext: e, settings: t }) => {
	let { track: n } = B(), r = Sd(t?.jiraSiteUrl), [i, o] = W(!1), { linkIssue: s, linkIssueQuietly: c, unlinkIssue: l, unlinkAllIssues: u, loadIssues: d, removeDanglingIssueLinks: f, danglingIssueLinks: p, isLoadingIssueLinks: m, isLoadingIssues: h, issues: g, error: v } = td(e?.conversationId ? e.conversationId : null, r), y = !!t?.enableCreateIssue, x = !!t?.enableSortIssueTypeByLabel, S = !!(g?.length || p?.length), C = !!t?.enableRemoveAllLinks && S, w = !m && !h && p?.length > 0 && !!t?.showDanglingLinks;
	return !h && v ? /* @__PURE__ */ K(z, {
		error: v,
		retry: () => d()
	}) : /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ q(_, {
		className: wd.wrapper,
		flexDirection: "column",
		children: [
			/* @__PURE__ */ q(_, {
				className: wd.inputWrapper,
				flexDirection: "column",
				children: [y && /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(a, {
					variant: "primary",
					onClick: () => o(!0),
					style: { minHeight: "38px" },
					children: "Create new issue"
				}), /* @__PURE__ */ K("div", {
					className: wd.inputSeparator,
					children: "or"
				})] }), /* @__PURE__ */ K(od, {
					onSelectIssue: s,
					jiraInstanceUrl: r
				})]
			}),
			h ? /* @__PURE__ */ K(_, {
				justifyContent: "center",
				margin: "0 0 300 0",
				children: /* @__PURE__ */ K(N, { "data-testid": "jira-widget-issue-spinner" })
			}) : g?.length ? /* @__PURE__ */ K(Vu, {
				issues: g,
				jiraInstanceUrl: r,
				unlinkIssue: l
			}) : /* @__PURE__ */ K(L.Paragraph, {
				align: "center",
				className: wd.noIssuesFound,
				children: "No linked issues found"
			}),
			C && g?.length > 0 && /* @__PURE__ */ K(a, {
				variant: "secondary",
				disabled: !g?.length && !p?.length,
				onClick: u,
				children: "Unlink all issues"
			}),
			w && /* @__PURE__ */ q(_, {
				background: "neutral.100",
				padding: "300",
				borderRadius: "100",
				flexDirection: "column",
				gap: "200",
				children: [
					/* @__PURE__ */ K(L.Heading, {
						variant: "heading-3",
						children: "Unresolved linked issues"
					}),
					/* @__PURE__ */ K(_, {
						flexDirection: "row",
						flexWrap: "wrap",
						gap: "100",
						children: p.map((e) => /* @__PURE__ */ K(I, {
							onDelete: () => l(e),
							children: e
						}, e))
					}),
					/* @__PURE__ */ K(a, {
						variant: "secondary",
						onClick: () => f(),
						icon: "link-slash",
						children: "Remove all unresolved issues"
					})
				]
			}),
			/* @__PURE__ */ K(A, {
				slotEnd: /* @__PURE__ */ K(b, { name: "external-link" }),
				variant: "tertiary",
				className: wd.buttonLink,
				navigate: () => {
					n("jira:view:jira:clicked", { jiraInstanceUrl: r }), window.open(r, "_blank")?.focus();
				},
				children: "Open Jira"
			})
		]
	}), i && /* @__PURE__ */ K(xd, {
		isOpen: i,
		onClose: () => o(!1),
		linkIssueQuietly: c,
		conversationContext: e,
		jiraInstanceUrl: r,
		hasSortIssueTypeByLabelEnabled: x
	})] });
}, Ed = [
	{
		key: "jiraSiteUrl",
		label: "Jira site URL",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "enableRemoveAllLinks",
		label: "Enable the \"Remove all links\" button",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "showDanglingLinks",
		label: "Show unresolved links to Jira issues",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "enableCreateIssue",
		label: "Enable the \"Create issue\" button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "enableSortIssueTypeByLabel",
		label: "Enable to sort the issue types by label",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	}
], Dd = (e) => {
	let t = Cd(e);
	return typeof t != "string" || t;
}, Od = Pe(Ed), kd = "JIRA", Ad = {
	enabled: !1,
	name: "",
	jiraSiteUrl: "",
	enableRemoveAllLinks: !1,
	showDanglingLinks: !1,
	enableCreateIssue: !0,
	enableSortIssueTypeByLabel: !1
}, jd = ({ integrationId: e, configuration: t, handleRedirect: n, showNotification: r, automationCouplingState: i, renderConditionsEditor: a }) => {
	let o = !e, s = xc({
		mode: "onChange",
		defaultValues: Ad
	}), { create: c, update: l, remove: u, isLoading: d, error: f, misconfigurationCause: p, setMisconfigurationCause: m } = Ve({
		integrationId: e,
		integrationType: kd,
		handleRedirect: n,
		showNotification: r
	}), { isLoading: h, error: x, isWidgetUnknown: S, refetch: C, widgetConfiguration: w } = He({
		integrationId: e,
		fieldDefinitions: Ed,
		form: s,
		onMisconfigured: m
	}), { renderConditions: T, setRenderConditions: E, renderConditionsForSubmit: D } = Be({
		integrationId: e,
		widgetConfiguration: w,
		renderConditionsEditor: a
	}), O = (e) => ye(e, {
		fieldDefinitions: Ed,
		isCreationMode: o,
		create: c,
		update: l,
		renderConditions: D
	}), k = s.watch("name");
	return /* @__PURE__ */ q(de, {
		form: s,
		integrationId: e,
		onValidSubmit: O,
		error: x ?? f,
		onRetry: x ? C : void 0,
		isLoading: d || h,
		isWidgetUnknown: S,
		children: [
			p && /* @__PURE__ */ K(se, { cause: p }),
			/* @__PURE__ */ q(y, { children: [
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ K(Z, {
						name: "enabled",
						control: s.control
					})
				}) }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "name",
						label: "Widget name",
						control: s.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "jiraSiteUrl",
						label: Od.jiraSiteUrl,
						control: s.control,
						rules: { validate: (e) => Dd(e) },
						componentProps: {
							placeholder: "Insert your Jira site URL, e.g. \"https://your-site.atlassian.net/\"",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: Od.enableRemoveAllLinks,
						children: /* @__PURE__ */ K(Z, {
							name: "enableRemoveAllLinks",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: Od.showDanglingLinks,
						children: /* @__PURE__ */ K(Z, {
							name: "showDanglingLinks",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: Od.enableCreateIssue,
						children: /* @__PURE__ */ K(Z, {
							name: "enableCreateIssue",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: Od.enableSortIssueTypeByLabel,
						children: /* @__PURE__ */ K(Z, {
							name: "enableSortIssueTypeByLabel",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				!o && e && /* @__PURE__ */ K(ce, {
					configuration: t,
					integrationId: e,
					integrationType: kd,
					label: "Authorize with OAuth"
				}),
				a && T !== null && /* @__PURE__ */ K(v, { children: a({
					value: T,
					onChange: E,
					configurationKey: w?.id
				}) })
			] }),
			/* @__PURE__ */ K(pe, {
				integrationType: kd,
				integrationId: e,
				widgetName: k,
				isCreationMode: o,
				isSubmitting: s.formState.isSubmitting,
				automationCouplingState: i,
				onConfirmDelete: () => u(),
				confirmDeleteVariant: "danger",
				deleteConfirmationBody: /* @__PURE__ */ q(_, {
					gap: "400",
					children: [/* @__PURE__ */ K(b, {
						size: 24,
						name: "exclamation-triangle-filled",
						color: "red.500"
					}), /* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "column",
						children: [
							/* @__PURE__ */ q(L.Heading, {
								withMarginBottom: !0,
								children: [
									"By deleting the ",
									kd,
									" integration, all links between Dixa and ",
									kd,
									" are also deleted."
								]
							}),
							/* @__PURE__ */ q(L.Paragraph, { children: [
								"All data in ",
								kd,
								" stays untouched."
							] }),
							/* @__PURE__ */ q(L.Paragraph, { children: [
								"Are you sure you want to delete the ",
								kd,
								" ",
								"integration \"",
								k,
								"\"?"
							] })
						]
					})]
				})
			})
		]
	});
};
//#endregion
//#region ../widget-klaviyo/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_zrl8q_54{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_zrl8q_54:hover,._messageIsOpen_zrl8q_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_zrl8q_65{cursor:pointer}._messageUnattended_zrl8q_68{text-decoration:line-through}._messageLabel_zrl8q_71{color:var(--dixa-typography-color-secondary)}._messageText_zrl8q_74{max-height:150px;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_zrl8q_74::-webkit-scrollbar{width:7px;height:7px}._messageText_zrl8q_74::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_zrl8q_74::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_zrl8q_74::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
function Md({ query: e, options: t, delayMs: n }) {
	let { useLazyQuery: r } = V(), [i, a] = W([]), [o] = r(e, t), [s, c] = W([]);
	return U(() => () => {
		s.forEach((e) => window.clearTimeout(e));
	}, []), [async (e) => {
		let t = [];
		for (let [r, i] of e.entries()) {
			r !== 0 && await new Promise((e) => {
				let t = setTimeout(e, n);
				c([...s, t]);
			});
			let e = await o({ variables: i });
			t.push(e);
		}
		a(t);
	}, i];
}
var Nd = /* @__PURE__ */ function(e) {
	return e.List = "list", e;
}({}), Pd = /* @__PURE__ */ function(e) {
	return e.Profile = "profile", e;
}({}), Fd = /* @__PURE__ */ function(e) {
	return e.Subscribed = "SUBSCRIBED", e;
}({}), Id = /* @__PURE__ */ function(e) {
	return e.Unsubscribed = "UNSUBSCRIBED", e;
}({}), Ld = {
	"\n  query getLists {\n    Klaviyo {\n      get_lists {\n        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {\n          data {\n            type\n            id\n            attributes {\n              name\n              created\n              updated\n            }\n            links {\n              self\n            }\n          }\n          links {\n            self\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getLists"
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "get_lists"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_GetListListResponseCollectionCompoundDocument"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "data"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "type"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "attributes"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "name"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "created"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "updated"
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "links"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "self"
																		}
																	}]
																}
															}
														]
													}
												}, {
													kind: "Field",
													name: {
														kind: "Name",
														value: "links"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "self"
															}
														}]
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ClientError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ClientErrorResponseFragment"
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ServerError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerErrorResponseFragment"
													}
												}]
											}
										}
									]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "FragmentDefinition",
			name: {
				kind: "Name",
				value: "ClientErrorResponseFragment"
			},
			typeCondition: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "Klaviyo_ClientError_response"
				}
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "errors"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "id"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "code"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "title"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "detail"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "source"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "pointer"
										}
									}, {
										kind: "Field",
										name: {
											kind: "Name",
											value: "parameter"
										}
									}]
								}
							}
						]
					}
				}]
			}
		}]
	},
	"\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "FragmentDefinition",
			name: {
				kind: "Name",
				value: "ServerErrorResponseFragment"
			},
			typeCondition: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "Klaviyo_ServerError_response"
				}
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "errors"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "id"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "code"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "title"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "detail"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "source"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "pointer"
										}
									}, {
										kind: "Field",
										name: {
											kind: "Name",
											value: "parameter"
										}
									}]
								}
							}
						]
					}
				}]
			}
		}]
	},
	"\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "mutation",
				name: {
					kind: "Name",
					value: "subscribeProfileToChannel"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "attributes"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input"
							}
						}
					}
				}, {
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "relationships"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "bulk_subscribe_profiles"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "input"
									},
									value: {
										kind: "ObjectValue",
										fields: [{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "data"
											},
											value: {
												kind: "ObjectValue",
												fields: [
													{
														kind: "ObjectField",
														name: {
															kind: "Name",
															value: "type"
														},
														value: {
															kind: "EnumValue",
															value: "profile_subscription_bulk_create_job"
														}
													},
													{
														kind: "ObjectField",
														name: {
															kind: "Name",
															value: "attributes"
														},
														value: {
															kind: "Variable",
															name: {
																kind: "Name",
																value: "attributes"
															}
														}
													},
													{
														kind: "ObjectField",
														name: {
															kind: "Name",
															value: "relationships"
														},
														value: {
															kind: "Variable",
															name: {
																kind: "Name",
																value: "relationships"
															}
														}
													}
												]
											}
										}]
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Klaviyo_ClientError_response"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "ClientErrorResponseFragment"
												}
											}]
										}
									}, {
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Klaviyo_ServerError_response"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "ServerErrorResponseFragment"
												}
											}]
										}
									}]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "mutation",
				name: {
					kind: "Name",
					value: "unsubscribeProfileByContact"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "attributes"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "bulk_unsubscribe_profiles"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "input"
									},
									value: {
										kind: "ObjectValue",
										fields: [{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "data"
											},
											value: {
												kind: "ObjectValue",
												fields: [{
													kind: "ObjectField",
													name: {
														kind: "Name",
														value: "type"
													},
													value: {
														kind: "EnumValue",
														value: "profile_subscription_bulk_delete_job"
													}
												}, {
													kind: "ObjectField",
													name: {
														kind: "Name",
														value: "attributes"
													},
													value: {
														kind: "Variable",
														name: {
															kind: "Name",
															value: "attributes"
														}
													}
												}]
											}
										}]
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Klaviyo_ClientError_response"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "ClientErrorResponseFragment"
												}
											}]
										}
									}, {
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Klaviyo_ServerError_response"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "ServerErrorResponseFragment"
												}
											}]
										}
									}]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "FragmentDefinition",
			name: {
				kind: "Name",
				value: "GetEventResponseFragment"
			},
			typeCondition: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "Klaviyo_GetEventResponseCollectionCompoundDocument"
				}
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "data"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "id"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "type"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "attributes"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "timestamp"
										}
									}, {
										kind: "Field",
										name: {
											kind: "Name",
											value: "event_properties"
										}
									}]
								}
							}
						]
					}
				}]
			}
		}]
	},
	"\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getEvents"
				},
				variableDefinitions: [
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "receivedEmailEventsFilter"
							}
						},
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "String"
								}
							}
						}
					},
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "openedEmailEventsFilter"
							}
						},
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "String"
								}
							}
						}
					},
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "clickedEmailEventsFilter"
							}
						},
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "String"
								}
							}
						}
					},
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "bouncedEmailEventsFilter"
							}
						},
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "String"
								}
							}
						}
					},
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "receivedSmsEventsFilter"
							}
						},
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "String"
								}
							}
						}
					},
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "pageSize"
							}
						},
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "Klaviyo_PositiveInt"
								}
							}
						}
					}
				],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									alias: {
										kind: "Name",
										value: "receivedEmail"
									},
									name: {
										kind: "Name",
										value: "get_events"
									},
									arguments: [
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "filter"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "receivedEmailEventsFilter"
												}
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "sort"
											},
											value: {
												kind: "EnumValue",
												value: "_datetime"
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "pageSize"
												}
											}
										}
									],
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_GetEventResponseCollectionCompoundDocument"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "GetEventResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ClientError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ClientErrorResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ServerError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ServerErrorResponseFragment"
														}
													}]
												}
											}
										]
									}
								},
								{
									kind: "Field",
									alias: {
										kind: "Name",
										value: "openedEmail"
									},
									name: {
										kind: "Name",
										value: "get_events"
									},
									arguments: [
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "filter"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "openedEmailEventsFilter"
												}
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "sort"
											},
											value: {
												kind: "EnumValue",
												value: "_datetime"
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "pageSize"
												}
											}
										}
									],
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_GetEventResponseCollectionCompoundDocument"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "GetEventResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ClientError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ClientErrorResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ServerError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ServerErrorResponseFragment"
														}
													}]
												}
											}
										]
									}
								},
								{
									kind: "Field",
									alias: {
										kind: "Name",
										value: "clickedEmail"
									},
									name: {
										kind: "Name",
										value: "get_events"
									},
									arguments: [
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "filter"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "clickedEmailEventsFilter"
												}
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "sort"
											},
											value: {
												kind: "EnumValue",
												value: "_datetime"
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "pageSize"
												}
											}
										}
									],
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_GetEventResponseCollectionCompoundDocument"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "GetEventResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ClientError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ClientErrorResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ServerError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ServerErrorResponseFragment"
														}
													}]
												}
											}
										]
									}
								},
								{
									kind: "Field",
									alias: {
										kind: "Name",
										value: "bouncedEmail"
									},
									name: {
										kind: "Name",
										value: "get_events"
									},
									arguments: [
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "filter"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "bouncedEmailEventsFilter"
												}
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "sort"
											},
											value: {
												kind: "EnumValue",
												value: "_datetime"
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "pageSize"
												}
											}
										}
									],
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_GetEventResponseCollectionCompoundDocument"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "GetEventResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ClientError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ClientErrorResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ServerError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ServerErrorResponseFragment"
														}
													}]
												}
											}
										]
									}
								},
								{
									kind: "Field",
									alias: {
										kind: "Name",
										value: "receivedSms"
									},
									name: {
										kind: "Name",
										value: "get_events"
									},
									arguments: [
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "filter"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "receivedSmsEventsFilter"
												}
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "sort"
											},
											value: {
												kind: "EnumValue",
												value: "_datetime"
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "pageSize"
												}
											}
										}
									],
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_GetEventResponseCollectionCompoundDocument"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "GetEventResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ClientError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ClientErrorResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ServerError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ServerErrorResponseFragment"
														}
													}]
												}
											}
										]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "GetEventResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_GetEventResponseCollectionCompoundDocument"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "data"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "type"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "attributes"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "timestamp"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "event_properties"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getFlowMessage"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "messageId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "get_flow_message"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "messageId"
										}
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "data"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "type"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "attributes"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "definition"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "InlineFragment",
																				typeCondition: {
																					kind: "NamedType",
																					name: {
																						kind: "Name",
																						value: "Klaviyo_FlowEmail"
																					}
																				},
																				selectionSet: {
																					kind: "SelectionSet",
																					selections: [{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "preview_text"
																						}
																					}]
																				}
																			}]
																		}
																	}]
																}
															}
														]
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ClientError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ClientErrorResponseFragment"
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ServerError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerErrorResponseFragment"
													}
												}]
											}
										}
									]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getMetrics"
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "get_metrics"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_GetMetricResponseCollectionCompoundDocument"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "data"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														}, {
															kind: "Field",
															name: {
																kind: "Name",
																value: "attributes"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																}]
															}
														}]
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ClientError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ClientErrorResponseFragment"
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ServerError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerErrorResponseFragment"
													}
												}]
											}
										}
									]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getProfileByFilter"
				},
				variableDefinitions: [
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "emailFilter"
							}
						},
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					},
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "phoneNumberFilter"
							}
						},
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					},
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "hasEmail"
							}
						},
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "Boolean"
								}
							}
						}
					},
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "hasPhoneNumber"
							}
						},
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "Boolean"
								}
							}
						}
					}
				],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								alias: {
									kind: "Name",
									value: "profileByEmail"
								},
								name: {
									kind: "Name",
									value: "get_profiles"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "filter"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "emailFilter"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_"
									},
									value: {
										kind: "IntValue",
										value: "1"
									}
								}],
								directives: [{
									kind: "Directive",
									name: {
										kind: "Name",
										value: "include"
									},
									arguments: [{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "if"
										},
										value: {
											kind: "Variable",
											name: {
												kind: "Name",
												value: "hasEmail"
											}
										}
									}]
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_GetProfileResponseCollectionCompoundDocument"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "data"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														}]
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ClientError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ClientErrorResponseFragment"
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ServerError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerErrorResponseFragment"
													}
												}]
											}
										}
									]
								}
							}, {
								kind: "Field",
								alias: {
									kind: "Name",
									value: "profileByPhoneNumber"
								},
								name: {
									kind: "Name",
									value: "get_profiles"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "filter"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "phoneNumberFilter"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_"
									},
									value: {
										kind: "IntValue",
										value: "1"
									}
								}],
								directives: [{
									kind: "Directive",
									name: {
										kind: "Name",
										value: "include"
									},
									arguments: [{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "if"
										},
										value: {
											kind: "Variable",
											name: {
												kind: "Name",
												value: "hasPhoneNumber"
											}
										}
									}]
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_GetProfileResponseCollectionCompoundDocument"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "data"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														}]
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ClientError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ClientErrorResponseFragment"
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ServerError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerErrorResponseFragment"
													}
												}]
											}
										}
									]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getProfileById"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "profileId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "get_profile"
								},
								arguments: [
									{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "id"
										},
										value: {
											kind: "Variable",
											name: {
												kind: "Name",
												value: "profileId"
											}
										}
									},
									{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_"
										},
										value: {
											kind: "ListValue",
											values: [
												{
													kind: "EnumValue",
													value: "subscriptions"
												},
												{
													kind: "EnumValue",
													value: "properties"
												},
												{
													kind: "EnumValue",
													value: "predictive_analytics"
												}
											]
										}
									},
									{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_"
										},
										value: {
											kind: "ListValue",
											values: [{
												kind: "EnumValue",
												value: "subscriptions"
											}, {
												kind: "EnumValue",
												value: "predictive_analytics"
											}]
										}
									}
								],
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_GetProfileResponseCompoundDocument"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "data"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "attributes"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "subscriptions"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "email"
																				},
																				selectionSet: {
																					kind: "SelectionSet",
																					selections: [{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "marketing"
																						},
																						selectionSet: {
																							kind: "SelectionSet",
																							selections: [{
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "consent"
																								}
																							}]
																						}
																					}]
																				}
																			}, {
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "sms"
																				},
																				selectionSet: {
																					kind: "SelectionSet",
																					selections: [{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "marketing"
																						},
																						selectionSet: {
																							kind: "SelectionSet",
																							selections: [{
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "consent"
																								}
																							}]
																						}
																					}]
																				}
																			}]
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "properties"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "predictive_analytics"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "average_order_value"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "churn_probability"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "predicted_clv"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "historic_clv"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "total_clv"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "historic_number_of_orders"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "predicted_number_of_orders"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "average_days_between_orders"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "expected_date_of_next_order"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "ranked_channel_affinity"
																					}
																				}
																			]
																		}
																	}
																]
															}
														}]
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ClientError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ClientErrorResponseFragment"
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ServerError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerErrorResponseFragment"
													}
												}]
											}
										}
									]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getListsByProfileId"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "profileId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "get_lists_for_profile"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "profileId"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_"
									},
									value: {
										kind: "ListValue",
										values: [{
											kind: "EnumValue",
											value: "name"
										}]
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_GetListResponseCollection"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "data"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														}, {
															kind: "Field",
															name: {
																kind: "Name",
																value: "attributes"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																}]
															}
														}]
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ClientError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ClientErrorResponseFragment"
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ServerError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerErrorResponseFragment"
													}
												}]
											}
										}
									]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getSegmentsByProfileId"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "profileId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "get_segments_for_profile"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "profileId"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_"
									},
									value: {
										kind: "ListValue",
										values: [{
											kind: "EnumValue",
											value: "name"
										}]
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_GetSegmentResponseCollection"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "data"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														}, {
															kind: "Field",
															name: {
																kind: "Name",
																value: "attributes"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																}]
															}
														}]
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ClientError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ClientErrorResponseFragment"
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ServerError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerErrorResponseFragment"
													}
												}]
											}
										}
									]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	}
};
function Rd(e) {
	return Ld[e] ?? {};
}
Rd("\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n");
var zd = Rd("\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), Bd = Rd("\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), Vd = Rd("\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), Hd = Rd("\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), Ud = Rd("\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), Wd = Rd("\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), Gd = Rd("\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), Kd = Rd("\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), qd = Rd("\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n");
function Jd(e) {
	return e?.attributes?.event_properties?.$flow !== void 0;
}
function Yd(e) {
	return Jd(e) && e?.attributes?.event_properties?.$message;
}
function Xd(e) {
	return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function Zd(e) {
	let t = e?.attributes?.timestamp;
	if (t) return t;
}
function Qd(e) {
	return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function $d(e) {
	return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((e) => ({
		...e,
		eventType: "EMAIL"
	}));
}
function ef(e) {
	return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((e) => ({
		...e,
		eventType: "SMS"
	}));
}
function tf(e) {
	return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((e) => ({
		...e,
		eventType: "EMAIL"
	}));
}
function nf(e) {
	return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((e) => ({
		...e,
		eventType: "EMAIL"
	}));
}
function rf(e) {
	return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((e) => ({
		...e,
		eventType: "EMAIL"
	}));
}
function af(e) {
	return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function of(e) {
	return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function sf(e) {
	try {
		return JSON.parse(JSON.stringify(e));
	} catch {
		return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
	}
}
var cf = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function lf(e) {
	return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function uf(e) {
	return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function df({ profileId: e, noOfMessagesToShow: t }) {
	let { useLazyQuery: n, useQuery: r } = V(), { track: i } = B(), [a, o] = W(null), [s, c] = W(null), [l, u] = W(null), [d, f] = W(null), [p, m] = W(null), [h, g] = W([]), { data: _, error: v, loading: y, networkStatus: b } = r(Vd, {
		fetchPolicy: "network-only",
		nextFetchPolicy: "cache-first",
		notifyOnNetworkStatusChange: !0
	}), [x, { data: S, error: C, loading: w, networkStatus: T }] = n(zd, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0
	});
	return U(() => {
		if (_ && !y && b === ot.ready) {
			let e = Qd(_);
			o(e.find((e) => e?.attributes?.name === "Received Email")?.id || null), c(e.find((e) => e?.attributes?.name === "Opened Email")?.id || null), u(e.find((e) => e?.attributes?.name === "Clicked Email")?.id || null), f(e.find((e) => e?.attributes?.name === "Bounced Email")?.id || null), m(e.find((e) => e?.attributes?.name === "Received Text Message")?.id || null);
		} else o(null), c(null), u(null), f(null), m(null);
	}, [_]), U(() => {
		a && s && l && d && p && !w && T === ot.ready ? x({ variables: {
			receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${a}")`,
			openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${s}")`,
			clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
			bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${d}")`,
			receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${p}")`,
			pageSize: t
		} }) : g([]);
	}, [
		a,
		s,
		l,
		d,
		p
	]), U(() => {
		if (!w && S) {
			let e = $d(S), n = tf(S).map((e) => e?.attributes?.event_properties.$message), r = nf(S).map((e) => e?.attributes?.event_properties.$message);
			e.forEach((e) => {
				let t = e.attributes?.event_properties.$message;
				e.opened = n.includes(t), e.clicked = r.includes(t);
			});
			let a = ef(S), o = rf(S), s = [
				...e,
				...o,
				...a
			].sort((e, t) => {
				let n = Zd(e), r = Zd(t);
				return n == null && r == null ? 0 : n == null ? 1 : r == null ? -1 : r - n;
			}).slice(0, t);
			g(s);
			let c = s.map((e) => e.id);
			i("klaviyo:messages:received", {
				emailsReceived: e.filter((e) => c.includes(e.id)).length,
				emailsBounced: o.filter((e) => c.includes(e.id)).length,
				smsReceived: a.filter((e) => c.includes(e.id)).length,
				total: c.length
			});
		} else g([]);
	}, [w, S]), Ze(() => ({
		receivedMessages: h,
		isLoading: y || w,
		error: v || C
	}), [
		h,
		y,
		w,
		v,
		C
	]);
}
function ff({ profileId: e }) {
	let { useQuery: t } = V(), [n, r] = W(), [i, a] = W(), { data: o, error: s, loading: c, refetch: l } = t(Ud, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0,
		variables: { profileId: e }
	});
	U(() => {
		s && a(s);
	}, [s]), U(() => {
		!c && o && r(o.Klaviyo.get_profile);
	}, [c, o]);
	let u = async () => {
		let e = await l();
		e.error ? a(e.error) : e.data && r(e.data.Klaviyo.get_profile);
	};
	return Ze(() => ({
		profile: n,
		refetchProfile: u,
		isLoading: c,
		error: i
	}), [
		n,
		c,
		i
	]);
}
function pf({ email: e, phoneNumber: t }) {
	let { track: n } = B(), { useLazyQuery: r } = V(), [i, a] = W(), [o, s] = W(), [c, { data: l, error: u, loading: d }] = r(Hd, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0
	});
	U(() => {
		if (!d && l) {
			let e = l.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && l.Klaviyo.profileByEmail || void 0, t = l.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && l.Klaviyo.profileByPhoneNumber || void 0;
			f(e, t);
		}
	}, [d, l]);
	let f = (r, i) => {
		let o = r?.data?.length === 1 && r.data[0]?.id || void 0, c = i?.data?.length === 1 && i.data[0]?.id || void 0, l = o || c, u = !o || !c || o === c;
		if (l && u) {
			a(o || c), n("klaviyo:profile:received", { hasProfile: !0 });
			return;
		}
		a(void 0), n("klaviyo:profile:received", { hasProfile: !1 }), u || s(/* @__PURE__ */ Error(`Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${o}) and phone number ${t} (profile ID ${c}).`));
	};
	return Ze(() => ({
		profileId: i,
		getProfileId: c,
		isLoading: d,
		error: u || o
	}), [
		i,
		c,
		d,
		u,
		o
	]);
}
var mf = 800, hf = {
	min: 800,
	max: 1200
}, gf = 3, _f = 1.5, vf = ({ query: e, delay: t, delayRange: n, maxCount: r = gf, useDelayRange: i = !1 }) => {
	let a = (e) => Math.floor(Math.random() * (e.max - e.min) + e.min), [o, s] = W(0), [c, l] = W(t || mf), [u, d] = W(n || hf), [f, p] = W(!1), [m, h] = W(!1), g = i || !!n, _ = g ? a(u) : t || mf, [v, y] = W(_);
	fl(async () => {
		let t = o + 1, n = _f ** t;
		s(t), y((g ? a(u) : c) * n), await e().then(() => {
			h(!0), S();
		});
	}, f ? v : null), ml(() => S());
	let b = Je(() => {
		s(0), y(_);
	}, [_]), x = Je((e = {}) => {
		let { delay: t, delayRange: n } = e;
		h(!1), b(), n && (d(n), y(a(n))), t && (l(t), y(t)), p(!0);
	}, [b]), S = Je(() => {
		p(!1), b();
	}, [b]);
	return U(() => {
		o >= r && S();
	}, [
		o,
		r,
		S
	]), Ze(() => ({
		isRunning: f,
		isSuccessful: m,
		start: x,
		stop: S
	}), [
		f,
		m,
		x,
		S
	]);
}, yf = (e) => {
	let t = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
	return t ? parseInt(t, 10) : void 0;
}, bf = (e) => ({
	min: e * 1e3,
	max: e * 1e3 + 500
});
function xf({ profileId: e, query: t }) {
	let { useQuery: n } = V(), [r, i] = W(), [a, o] = W(), { data: s, error: c, loading: l, refetch: u, networkStatus: d } = n(t === "lists" ? Wd : Gd, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0,
		variables: { profileId: e }
	}), { isRunning: f, start: p, stop: m } = vf({
		query: u,
		useDelayRange: !0
	}), h = l || f;
	return U(() => {
		if (c) if (we({ errors: c.graphQLErrors })) {
			if (!f) {
				let e = yf(c);
				p({ ...e && { delayRange: bf(e) } });
			}
		} else o(c);
	}, [c]), U(() => {
		if (!l && s?.Klaviyo) {
			let e = {}, n = {};
			t === "lists" && (e = s?.Klaviyo?.get_lists_for_profile), t === "segments" && (n = s?.Klaviyo?.get_segments_for_profile), (e?.data || n?.data) && (m(), i((t === "lists" ? e?.data : n?.data)?.map((e) => ({
				...e,
				type: t === "lists" ? "list" : "segment"
			}))));
		}
	}, [l, s]), Ze(() => ({
		listsOrSegments: r,
		refetchListOrSegments: p,
		isLoading: h,
		error: a,
		networkStatus: d
	}), [
		r,
		h,
		a,
		d,
		p
	]);
}
var Sf = { notificationText: "_notificationText_1polx_1" }, Cf = ({ error: e }) => {
	let { track: t } = B(), n = e;
	if (ut(e)) {
		let r = e.graphQLErrors, i = r.length === 1 && Ee({ error: r[0] }), a = r.length === 1 && Oe({ error: r[0] });
		if (i) t("klaviyo:profile:failed", { reason: "Invalid access token" }), n = /* @__PURE__ */ Error("It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator.");
		else if (a) t("klaviyo:profile:failed", { reason: "Insufficient permissions" }), n = /* @__PURE__ */ Error("You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration.");
		else return t("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ K(z, { error: e });
	}
	return /* @__PURE__ */ K(_, {
		margin: "0 0 300",
		children: /* @__PURE__ */ K(T.Item, {
			contentLeft: /* @__PURE__ */ K(b, {
				color: "red.500",
				size: 20,
				name: "exclamation-triangle-filled"
			}),
			titleSecondary: n.message,
			title: "Unable to show Klaviyo profile data",
			variant: "dense"
		})
	});
}, wf = Yo, Tf = {
	message: "_message_zrl8q_54",
	messageIsOpen: "_messageIsOpen_zrl8q_62",
	messageHeader: "_messageHeader_zrl8q_65",
	messageUnattended: "_messageUnattended_zrl8q_68",
	messageLabel: "_messageLabel_zrl8q_71",
	messageText: "_messageText_zrl8q_74"
}, Ef = ({ event: e, isLoadingPreview: t }) => {
	let n = e?.attributes?.event_properties, r = e.flowMessage && of(e.flowMessage);
	return /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ q(_, {
		flexDirection: "column",
		justifyContent: "space-between",
		gap: "100",
		children: [/* @__PURE__ */ K(L.Paragraph, {
			variant: "4",
			className: Tf.messageLabel,
			children: "Campaign name"
		}), /* @__PURE__ */ K(L.Paragraph, { children: n["Campaign Name"] })]
	}), t ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "100",
		children: /* @__PURE__ */ K(N, { size: 22 })
	}) : r && r.length > 0 && /* @__PURE__ */ q(_, {
		flexDirection: "column",
		justifyContent: "space-between",
		gap: "100",
		children: [/* @__PURE__ */ K(_, { children: /* @__PURE__ */ K(L.Paragraph, {
			variant: "4",
			className: Tf.messageLabel,
			children: "Preview text"
		}) }), /* @__PURE__ */ K(L.Paragraph, {
			variant: "4",
			className: Tf.messageText,
			children: r
		})]
	})] });
}, Df = ({ event: e }) => {
	let t = e?.attributes?.event_properties;
	return /* @__PURE__ */ K(G, { children: /* @__PURE__ */ q(_, {
		flexDirection: "column",
		justifyContent: "space-between",
		gap: "100",
		children: [/* @__PURE__ */ K(_, { children: /* @__PURE__ */ K(L.Heading, {
			variant: "heading-4",
			children: "Message"
		}) }), /* @__PURE__ */ K(_, { children: t?.extra?.["Message Body"] })]
	}) });
}, Of = ({ event: e, isLoadingPreview: t, openByDefault: r }) => {
	let [i, a] = W(r), { attributes: o, eventType: s } = e, c = o?.datetime, u = o?.timestamp, d = "DD MMM YYYY @ HH:mm", f = Ze(() => () => c ? wf(c).format(d) : u ? wf.unix(u).format(d) : null, [u, c])(), p = s === "EMAIL", m = s === "SMS", h = p && e.opened, g = p && e.clicked, v = p && o?.event_properties.Subject, y = m && o?.event_properties["Message Name"], S = p ? "mail" : "sms";
	return /* @__PURE__ */ q(_, {
		gap: "300",
		flexDirection: "column",
		className: ae(Tf.message, { [Tf.messageIsOpen]: i }),
		children: [/* @__PURE__ */ q(_, {
			alignItems: "center",
			justifyContent: "space-between",
			className: Tf.messageHeader,
			onClick: () => a(!i),
			children: [/* @__PURE__ */ q(_, {
				gap: "100",
				flexDirection: "column",
				children: [
					/* @__PURE__ */ q(_, {
						gap: "200",
						alignItems: "center",
						children: [
							/* @__PURE__ */ K(b, {
								size: 16,
								name: S
							}),
							" ",
							cf(s),
							f && /* @__PURE__ */ K(n, {
								size: "small",
								variant: "info",
								children: f
							})
						]
					}),
					v && v,
					y && y
				]
			}), /* @__PURE__ */ K(x, {
				variant: "tertiary",
				icon: i ? "angle-up" : "angle-down"
			})]
		}), i && /* @__PURE__ */ q(_, {
			flexDirection: "column",
			gap: "300",
			children: [
				/* @__PURE__ */ K(l, {}),
				Xd(e) && /* @__PURE__ */ K(_, { children: /* @__PURE__ */ K(n, {
					size: "medium",
					variant: "error",
					children: "Bounced"
				}) }),
				p && /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ q(_, {
					gap: "200",
					flexDirection: "row",
					flexWrap: "wrap",
					children: [/* @__PURE__ */ K(I, { children: /* @__PURE__ */ q(_, {
						alignItems: "center",
						gap: "200",
						children: [
							/* @__PURE__ */ K(b, {
								size: 16,
								color: h ? "green.400" : "red.400",
								name: h ? "check-circle-filled" : "close-circle-filled"
							}),
							" ",
							"Opened"
						]
					}) }), /* @__PURE__ */ K(I, { children: /* @__PURE__ */ q(_, {
						alignItems: "center",
						gap: "200",
						children: [
							/* @__PURE__ */ K(b, {
								size: 16,
								color: g ? "green.400" : "red.400",
								name: g ? "check-circle-filled" : "close-circle-filled"
							}),
							" ",
							"Clicked"
						]
					}) })]
				}), /* @__PURE__ */ K(Ef, {
					event: e,
					isLoadingPreview: t
				})] }),
				m && /* @__PURE__ */ K(Df, { event: e })
			]
		})]
	});
}, kf = {
	fetchPolicy: "no-cache",
	notifyOnNetworkStatusChange: !0
}, Af = ({ profileId: e, noOfMessagesToShow: t }) => {
	let [n, r] = W(!1), { receivedMessages: i, isLoading: a, error: o } = df({
		profileId: e,
		noOfMessagesToShow: t
	}), [s, c] = Md({
		query: Bd,
		options: kf,
		delayMs: 1e3
	}), [l, u] = W([]);
	U(() => {
		if (i.length > 0) {
			u(i);
			let e = i.filter((e) => Jd(e)).map((e) => Yd(e));
			e.length > 0 && (r(!0), s(e.map((e) => ({ messageId: e }))).finally(() => r(!1)));
		}
	}, [i]), U(() => {
		c.length > 0 && u(i?.map((e) => {
			if (e.eventType === "EMAIL" && Jd(e) && !e.flowMessage) {
				let t = Yd(e), n = c.find((e) => (e.data && af(e.data))?.id === t), r = n?.data && af(n.data);
				if (r) return {
					...sf(e),
					flowMessage: r
				};
			}
			return e;
		}));
	}, [c]);
	let d = [];
	return o && d.push(o), c.length > 0 && d.push(...c.map((e) => e.error).filter((e) => e)), d && d.length > 0 ? /* @__PURE__ */ K(G, { children: d.map((e, t) => e.graphQLErrors ? /* @__PURE__ */ K(z, { error: e }, `lastMessagesError${t}`) : /* @__PURE__ */ K(Cf, { error: e }, `lastMessagesError${t}`)) }) : /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(L.Heading, {
		variant: "heading-3",
		children: "Messages"
	}), a ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "0 0 300 0",
		children: /* @__PURE__ */ K(N, {})
	}) : /* @__PURE__ */ K(G, { children: l?.length > 0 ? /* @__PURE__ */ K(_, {
		gap: "200",
		flexDirection: "column",
		children: l.map((e, t) => /* @__PURE__ */ K(Of, {
			event: e,
			isLoadingPreview: n,
			openByDefault: t === 0
		}, e.id))
	}) : /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "200",
		className: Sf.notificationText,
		children: "No messages found for the profile"
	}) })] });
}, jf = {
	list: "_list_ld0hf_1",
	listItem: "_listItem_ld0hf_4"
}, Mf = ({ profile: e }) => {
	let t = e?.data?.attributes?.properties, n = Object.entries(t ?? {}).filter(([e, t]) => e !== "__typename" && t != null), r = n.length > 0;
	return /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ K(L.Heading, {
				variant: "heading-3",
				children: "Custom properties"
			}),
			!r && /* @__PURE__ */ K(L.Paragraph, {
				variant: "4",
				color: "secondary",
				align: "center",
				children: "No custom properties available"
			}),
			r && /* @__PURE__ */ K(T, {
				className: jf.list,
				children: n.map(([e, t]) => typeof t == "boolean" || typeof t == "string" || typeof t == "number" || Array.isArray(t) && t.every((e) => typeof e == "string") ? /* @__PURE__ */ K(T.Text, {
					variant: "dense",
					className: jf.listItem,
					children: /* @__PURE__ */ q(_, {
						justifyContent: "space-between",
						alignItems: "flex-start",
						gap: "200",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: Te(e)
						}), /* @__PURE__ */ K(_, {
							style: {
								flex: 1,
								minWidth: 0
							},
							justifyContent: "flex-end",
							children: ge(t)
						})]
					})
				}, e) : null)
			})
		]
	});
}, Nf = ({ profileId: e, type: t }) => {
	let [n, r] = W(!1), { listsOrSegments: i, error: o, isLoading: s, networkStatus: c, refetchListOrSegments: l } = xf({
		profileId: e,
		query: t
	});
	U(() => {
		c === 4 && r(!0);
	}, [c]);
	let u = () => {
		i || l();
	}, d = i || [];
	return o ? /* @__PURE__ */ K(Cf, { error: o }) : s ? /* @__PURE__ */ K(T.Text, {
		variant: "dense",
		className: jf.listItem,
		children: /* @__PURE__ */ K(N, { size: 14 })
	}, "loading") : d.length > 0 ? /* @__PURE__ */ K(G, { children: d.map(({ attributes: e, type: t }, n) => /* @__PURE__ */ K(T.Text, {
		variant: "dense",
		className: jf.listItem,
		children: /* @__PURE__ */ q(_, {
			justifyContent: "space-between",
			alignItems: "center",
			children: [/* @__PURE__ */ K(L.Paragraph, {
				variant: "4",
				children: e?.name
			}), !!t && /* @__PURE__ */ K(I, { children: me(t) })]
		})
	}, n)) }) : n && !i ? /* @__PURE__ */ K(T.Text, {
		variant: "dense",
		className: jf.listItem,
		children: /* @__PURE__ */ q(_, {
			justifyContent: "space-between",
			alignItems: "center",
			children: [/* @__PURE__ */ q(_, {
				gap: "200",
				children: [/* @__PURE__ */ K(b, {
					name: "exclamation-triangle-filled",
					color: "red"
				}), /* @__PURE__ */ q(L.Paragraph, {
					variant: "4",
					color: "red.500",
					children: [t === "lists" ? "Lists" : "Segments", " could not be loaded"]
				})]
			}), /* @__PURE__ */ K(R, {
				content: "Refresh lists and segments",
				children: /* @__PURE__ */ K(a, {
					icon: "sync",
					variant: "secondary",
					onClick: () => u(),
					children: "Retry"
				})
			})]
		})
	}, "refetch") : /* @__PURE__ */ K(T.Text, {
		variant: "dense",
		className: jf.listItem,
		children: /* @__PURE__ */ K(_, {
			justifyContent: "space-between",
			alignItems: "center",
			children: /* @__PURE__ */ K(L.Paragraph, {
				variant: "4",
				subdued: !0,
				children: /* @__PURE__ */ K("i", { children: `No ${t === "lists" ? "lists" : "segments"} available` })
			})
		})
	}, "refetch");
}, Pf = .7, Ff = .3, If = (e) => e >= Pf ? {
	variant: "error",
	label: "High risk"
} : e >= Ff ? {
	variant: "warning",
	label: "Medium risk"
} : {
	variant: "success",
	label: "Low risk"
}, Lf = (e) => /* @__PURE__ */ K(L.Paragraph, {
	as: "span",
	variant: "4",
	children: e.toFixed(2)
}), Rf = (e) => {
	let t = If(e);
	return /* @__PURE__ */ q(_, {
		alignItems: "center",
		gap: "100",
		children: [/* @__PURE__ */ K(n, {
			size: "small",
			variant: t.variant,
			children: t.label
		}), /* @__PURE__ */ K(L.Paragraph, {
			as: "span",
			variant: "4",
			children: `${(e * 100).toFixed(1)}%`
		})]
	});
}, zf = (e) => {
	let t = e?.data?.attributes?.predictive_analytics ?? null;
	if (!t) return [];
	let n = [
		["Average order value", t.average_order_value],
		["Historic lifetime value", t.historic_clv],
		["Predicted lifetime value", t.predicted_clv],
		["Total lifetime value", t.total_clv]
	], r = [
		["Historic orders", t.historic_number_of_orders],
		["Predicted orders", t.predicted_number_of_orders],
		["Average days between orders", t.average_days_between_orders],
		["Expected next order", t.expected_date_of_next_order]
	], i = t.churn_probability, a = t.ranked_channel_affinity?.filter(Boolean) ?? null;
	return [
		...n.flatMap(([e, t]) => t ? [{
			label: e,
			content: Lf(t)
		}] : []),
		...r.flatMap(([e, t]) => t ? [{
			label: e,
			content: ge(t)
		}] : []),
		...i ? [{
			label: "Churn probability",
			content: Rf(i)
		}] : [],
		...a?.length ? [{
			label: "Channel affinity",
			content: ge(a)
		}] : []
	];
}, Bf = ({ profile: e }) => {
	let t = zf(e);
	return /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ K(L.Heading, {
				variant: "heading-3",
				children: "Predictive analytics"
			}),
			t.length === 0 && /* @__PURE__ */ K(L.Paragraph, {
				variant: "4",
				color: "secondary",
				align: "center",
				children: "No predictive analytics available"
			}),
			t.length > 0 && /* @__PURE__ */ K(T, {
				className: jf.list,
				children: t.map(({ label: e, content: t }) => /* @__PURE__ */ K(T.Text, {
					variant: "dense",
					className: jf.listItem,
					children: /* @__PURE__ */ q(_, {
						justifyContent: "space-between",
						alignItems: "center",
						gap: "200",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							as: "span",
							variant: "4",
							children: e
						}), t]
					})
				}, e))
			})
		]
	});
}, Vf = {
	tagHover: "_tagHover_kzbzk_1",
	channelUnsubscribed: "_channelUnsubscribed_kzbzk_6"
}, Hf = ({ isSubscribed: e, isLoading: t, channelName: n, channelIcon: r, hasReSubscriptionFeature: i, handleAction: a }) => {
	let o = e ? "Unsubscribe" : "Subscribe", s = !e && !i;
	return /* @__PURE__ */ K(R, {
		content: s ? "You have to select a resubscription list in the settings." : o,
		children: /* @__PURE__ */ K(I, {
			className: Vf.tagHover,
			color: e ? "green.500" : "neutral.200",
			children: /* @__PURE__ */ q(_, {
				"data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
				gap: "200",
				alignItems: "center",
				className: ae({ [Vf.channelUnsubscribed]: !e || s }),
				onClick: () => {
					s || a();
				},
				children: [t ? /* @__PURE__ */ K(N, { size: 16 }) : /* @__PURE__ */ K(b, {
					size: 16,
					name: r
				}), n]
			})
		})
	});
}, Uf = { subscriptionError: "_subscriptionError_1qhhx_1" }, Wf = ({ subscriptionListId: e, profile: t, email: n, phoneNumber: r, profileId: i, refetchProfile: a }) => {
	let [o, s] = W(!1), [c, l] = W(!1), [u, d] = W(), { track: f } = B(), [p, m] = pl({
		channel: null,
		request: null
	}), h = lf(t), g = uf(t), v = !!e, { useMutation: y } = V(), [b] = y(Kd), [x] = y(qd), S = (t) => {
		f("klaviyo:profile:subscribe:clicked", { channel: t }), m.setAll({
			channel: t,
			request: "subscribed"
		}), ((t) => b({ variables: {
			attributes: {
				custom_source: "Dixa integration",
				profiles: { data: [{
					type: Pd.Profile,
					id: i,
					attributes: {
						email: n,
						...r ? { phone_number: r } : {},
						subscriptions: {
							...t === "EMAIL" && { email: { marketing: { consent: Fd.Subscribed } } },
							...t === "SMS" && { sms: { marketing: { consent: Fd.Subscribed } } }
						}
					}
				}] }
			},
			relationships: { list: { data: {
				type: Nd.List,
				id: e
			} } }
		} }))(t).then((e) => w({
			channel: t,
			mutationResponse: e,
			isSubscriptionRequest: !0
		})).catch((e) => w({
			channel: t,
			mutationErrorResponse: e,
			isSubscriptionRequest: !0
		}));
	}, C = (e) => {
		f("klaviyo:profile:unsubscribe:clicked", { channel: e }), m.setAll({
			channel: e,
			request: "unsubscribed"
		}), x({ variables: { attributes: { profiles: { data: [{
			type: Pd.Profile,
			attributes: {
				...e === "EMAIL" ? { email: n } : {},
				...e === "SMS" ? { phone_number: r } : {},
				subscriptions: {
					...e === "EMAIL" && { email: { marketing: { consent: Id.Unsubscribed } } },
					...e === "SMS" && { sms: { marketing: { consent: Id.Unsubscribed } } }
				}
			}
		}] } } } }).then((t) => w({
			channel: e,
			mutationResponse: t,
			isSubscriptionRequest: !1
		})).catch((t) => w({
			channel: e,
			mutationErrorResponse: t,
			isSubscriptionRequest: !1
		}));
	}, w = async ({ channel: e, mutationResponse: t, mutationErrorResponse: n, isSubscriptionRequest: r }) => {
		let i = n?.networkError, o = i ? i?.statusCode : NaN, c = t?.errors, u = !!c && Ce({ errors: c });
		o === 202 ? (f(r ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded", { channel: e }), await a()) : u ? (f(r ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed", {
			channel: e,
			reason: "Insufficient permissions"
		}), d(`Request failed with a permission error. Could not ${r ? "opt-in" : "opt-out"}.`)) : (f(r ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed", {
			channel: e,
			reason: i?.message || "Unexpected error"
		}), d(`Request failed. Could not ${r ? "opt-in" : "opt-out"}.`)), l(!1), s(!1);
	};
	return U(() => {
		if (p.request === "subscribed") {
			let e = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${p.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
			p.channel === "EMAIL" && !o && t?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (d(e), m.reset()), p.channel === "SMS" && !c && t?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (d(e), m.reset());
		}
	}, [
		t?.data?.attributes?.subscriptions?.email?.marketing?.consent,
		t?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
		o,
		c
	]), /* @__PURE__ */ K(_, {
		"data-testid": "subscription-channels",
		gap: "200",
		flexDirection: "column",
		children: /* @__PURE__ */ q(_, {
			gap: "200",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ K(L.Heading, {
					variant: "heading-3",
					children: "Subscription channels"
				}),
				/* @__PURE__ */ q(_, {
					gap: "100",
					flexDirection: "row",
					children: [/* @__PURE__ */ K(Hf, {
						"data-testid": "subscription-channels-email-button",
						isLoading: o,
						isSubscribed: h,
						channelName: "Email",
						channelIcon: "mail",
						hasReSubscriptionFeature: v,
						handleAction: () => {
							s(!0), d(void 0), h ? C("EMAIL") : S("EMAIL");
						}
					}), /* @__PURE__ */ K(Hf, {
						"data-testid": "subscription-channels-sms-button",
						isLoading: c,
						isSubscribed: g,
						channelName: "Sms",
						channelIcon: "sms",
						hasReSubscriptionFeature: v,
						handleAction: () => {
							l(!0), d(void 0), g ? C("SMS") : S("SMS");
						}
					})]
				}),
				u && /* @__PURE__ */ K(_, {
					className: Uf.subscriptionError,
					children: u
				})
			]
		})
	});
}, Gf = ({ profileId: e, email: t, phoneNumber: n, showProfileLists: r, showProfileSegments: i, showSubscriptions: a, showCustomProperties: o, showPredictiveAnalytics: s, noOfMessagesToShow: c, subscriptionListId: l }) => {
	let { profile: u, error: d, isLoading: f, refetchProfile: p } = ff({ profileId: e });
	return d ? /* @__PURE__ */ K(Cf, { error: d }) : f ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "0 0 300 0",
		children: /* @__PURE__ */ K(N, {})
	}) : !u && !f ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "200",
		className: Sf.notificationText,
		children: "No Klaviyo profile data found"
	}) : /* @__PURE__ */ q(_, {
		flexDirection: "column",
		gap: "300",
		margin: "200 0 300",
		children: [
			(r || i) && /* @__PURE__ */ q(_, {
				gap: "200",
				flexDirection: "column",
				children: [/* @__PURE__ */ K(L.Heading, {
					variant: "heading-3",
					children: "Lists & Segments"
				}), /* @__PURE__ */ q(T, {
					className: jf.list,
					children: [r && /* @__PURE__ */ K(Nf, {
						profileId: e,
						type: "lists"
					}), i && /* @__PURE__ */ K(Nf, {
						profileId: e,
						type: "segments"
					})]
				})]
			}),
			u && e && a && /* @__PURE__ */ K(Wf, {
				profile: u,
				profileId: e,
				subscriptionListId: l,
				refetchProfile: p,
				email: t,
				phoneNumber: n
			}),
			u && s && /* @__PURE__ */ K(Bf, { profile: u }),
			u && o && /* @__PURE__ */ K(Mf, { profile: u }),
			/* @__PURE__ */ K(Af, {
				profileId: e,
				noOfMessagesToShow: c
			})
		]
	});
}, Kf = ({ conversationContext: e, settings: t }) => {
	let n = e.customer?.email || void 0, r = e.customer?.phone_number || void 0, i = t?.showProfileLists, a = t?.showProfileSegments, o = t?.showSubscriptions, s = t?.showCustomProperties, c = t?.showPredictiveAnalytics, l = Number(t?.noOfMessagesToShow), u = t?.subscriptionListId, { profileId: d, getProfileId: f, isLoading: p, error: m } = pf({
		email: n,
		phoneNumber: r
	});
	return Xe(() => {
		(n || r) && f({ variables: {
			emailFilter: n ? `equals(email,"${n}")` : void 0,
			phoneNumberFilter: r ? `equals(phone_number,"${r}")` : void 0,
			hasEmail: !!n,
			hasPhoneNumber: !!r
		} });
	}, [n, r]), !n && !r ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "0 0 300 0",
		children: "The customer does not have an email nor a phone number"
	}) : p ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "0 0 300 0",
		children: /* @__PURE__ */ K(N, {})
	}) : m ? /* @__PURE__ */ K(Cf, { error: m }) : d ? /* @__PURE__ */ K(Gf, {
		profileId: d,
		email: n,
		phoneNumber: r,
		showProfileLists: i,
		showProfileSegments: a,
		showSubscriptions: o,
		showCustomProperties: s,
		showPredictiveAnalytics: c,
		noOfMessagesToShow: l,
		subscriptionListId: u
	}) : /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "0 0 300 0",
		className: Sf.notificationText,
		children: "No profile ID found"
	});
}, qf = [
	{
		key: "klaviyoApiKey",
		label: "API key",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "showProfileLists",
		label: "Show Klaviyo lists for a profile",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "showProfileSegments",
		label: "Show Klaviyo segments for a profile",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "showSubscriptions",
		label: "Show subscription channels for Klaviyo messages",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "showCustomProperties",
		label: "Show custom properties for a profile",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showPredictiveAnalytics",
		label: "Show predictive analytics for a profile",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "subscriptionListId",
		label: "Re-/subscription list",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "noOfMessagesToShow",
		label: "Choose how many messages to show",
		type: "string",
		secret: !1,
		defaultValue: "5"
	}
], Jf = [{
	key: "authorizeWithOauth",
	label: "Authorize with OAuth",
	secret: !1,
	type: "custom",
	hideOnCreate: !0,
	component: ce
}], Yf = [{
	key: "klaviyoApiKey",
	label: "API key",
	placeholder: "API key from Klaviyo",
	required: !0,
	secret: !0,
	type: "input"
}], Xf = Pe(qf), Zf = [
	{
		value: "3",
		label: "The three latest messages"
	},
	{
		value: "4",
		label: "The four latest messages"
	},
	{
		value: "5",
		label: "The five latest messages"
	}
], Qf = ({ control: e, name: t }) => /* @__PURE__ */ K(kc, {
	name: t,
	control: e,
	label: Xf.noOfMessagesToShow,
	rules: { required: "Please choose how many messages to show" },
	componentProps: {
		placeholder: "Select an option",
		equalityFn: (e, t) => e === t,
		getItemTitleByValue: (e) => {
			let t = Zf.find((t) => t.value === e)?.label;
			return t ? /* @__PURE__ */ K(L.Paragraph, { children: t }) : null;
		}
	},
	children: Zf.map((e) => /* @__PURE__ */ K(M.Item, {
		value: e.value,
		children: e.label
	}, e.value))
}), $f = { settingsWrapper: "_settingsWrapper_eleyu_1" }, ep = Rd("\n  query getLists {\n    Klaviyo {\n      get_lists {\n        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {\n          data {\n            type\n            id\n            attributes {\n              name\n              created\n              updated\n            }\n            links {\n              self\n            }\n          }\n          links {\n            self\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), tp = [], np = ({ value: e, onChange: t }) => {
	let { useQuery: n } = V(), [r, i] = W(tp), [a, o] = W(!!e), { data: s, error: c, loading: l } = n(ep, {
		skip: !a,
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0
	});
	return U(() => {
		e && o(!0);
	}, [e]), U(() => {
		let e = s?.Klaviyo?.get_lists;
		if (a && e && !l && !c) {
			let t = e?.data?.map((e) => ({
				value: e?.id,
				label: e?.attributes?.name
			})) || tp;
			i(t);
		}
	}, [
		a,
		s,
		l,
		c
	]), /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(v, {
		span: 3,
		children: /* @__PURE__ */ q(_, {
			gap: "300",
			flexDirection: "column",
			className: $f.settingsWrapper,
			children: [
				/* @__PURE__ */ K(g, {
					label: "Activate re-/subscription list selection",
					children: /* @__PURE__ */ K(p, { input: {
						name: "subscriptionListId-switch",
						value: "switchValueFromComponent",
						checked: a,
						onChange: () => {
							let e = !a;
							e || t(""), o(e);
						}
					} })
				}),
				a && c && !l && /* @__PURE__ */ K(g, { children: /* @__PURE__ */ K(z, { error: c }) }),
				a && !c && l && /* @__PURE__ */ K(g, { children: /* @__PURE__ */ K(_, {
					justifyContent: "center",
					margin: "0 0 300 0",
					children: /* @__PURE__ */ K(N, {})
				}) }),
				a && !c && !l && r && /* @__PURE__ */ K(g, {
					label: "Available lists to subscribe to",
					children: /* @__PURE__ */ K(C, {
						required: !0,
						placeholder: "Select a list",
						onChange: (e) => t(e?.selectedValues?.[0]?.value ?? ""),
						getItemTitleByValue: (e) => e ? /* @__PURE__ */ K(L.Paragraph, { children: e.label }) : null,
						value: e ? [{
							label: (r || []).find((t) => t.value === e)?.label,
							value: e
						}] : [],
						equalityFn: (e, t) => e.value === t.value,
						children: r.map((e) => /* @__PURE__ */ K(M.Item, {
							value: e,
							children: e.label
						}, e.value))
					})
				})
			]
		})
	}), /* @__PURE__ */ K(v, { span: 3 })] });
}, rp = Pe(qf), ip = "KLAVIYO", ap = {
	enabled: !1,
	name: "",
	...Le([], qf)
}, op = ({ integrationId: e, configuration: t, handleRedirect: n, showNotification: r, automationCouplingState: i, renderConditionsEditor: a }) => {
	let o = !e, s = xc({
		mode: "onChange",
		defaultValues: ap
	}), { create: c, update: l, remove: u, isLoading: d, error: f, misconfigurationCause: p, setMisconfigurationCause: m } = Ve({
		integrationId: e,
		integrationType: ip,
		handleRedirect: n,
		showNotification: r
	}), { isLoading: h, error: _, isWidgetUnknown: b, refetch: x, widgetConfiguration: S } = He({
		integrationId: e,
		fieldDefinitions: qf,
		form: s,
		onMisconfigured: m
	}), { renderConditions: C, setRenderConditions: w, renderConditionsForSubmit: T } = Be({
		integrationId: e,
		widgetConfiguration: S,
		renderConditionsEditor: a
	}), E = o || !!S?.additionalProperties?.isUsingOAuth, D = (e) => ye(e, {
		fieldDefinitions: qf,
		isCreationMode: o,
		create: c,
		update: l,
		renderConditions: T
	}), O = s.watch("name");
	return /* @__PURE__ */ q(de, {
		form: s,
		integrationId: e,
		onValidSubmit: D,
		error: _ ?? f,
		onRetry: _ ? x : void 0,
		isLoading: d || h,
		isWidgetUnknown: b,
		children: [
			p && /* @__PURE__ */ K(se, { cause: p }),
			/* @__PURE__ */ q(y, { children: [
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ K(Z, {
						name: "enabled",
						control: s.control
					})
				}) }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "name",
						label: "Widget name",
						control: s.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				!E && /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(ue, {
						name: "klaviyoApiKey",
						label: rp.klaviyoApiKey,
						control: s.control,
						isCreationMode: o,
						rules: { required: "API key is required" },
						componentProps: {
							placeholder: "API key from Klaviyo",
							autoComplete: "off"
						}
					})
				}), /* @__PURE__ */ K(v, { span: 3 })] }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: rp.showProfileLists,
						children: /* @__PURE__ */ K(Z, {
							name: "showProfileLists",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: rp.showProfileSegments,
						children: /* @__PURE__ */ K(Z, {
							name: "showProfileSegments",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: rp.showSubscriptions,
						children: /* @__PURE__ */ K(Z, {
							name: "showSubscriptions",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: rp.showCustomProperties,
						children: /* @__PURE__ */ K(Z, {
							name: "showCustomProperties",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: rp.showPredictiveAnalytics,
						children: /* @__PURE__ */ K(Z, {
							name: "showPredictiveAnalytics",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				!o && /* @__PURE__ */ K(Es, {
					name: "subscriptionListId",
					control: s.control,
					render: ({ field: e }) => /* @__PURE__ */ K(np, {
						value: e.value,
						onChange: e.onChange
					})
				}),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(Qf, {
						name: "noOfMessagesToShow",
						control: s.control
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				E && !o && e && /* @__PURE__ */ K(ce, {
					configuration: t,
					integrationId: e,
					integrationType: ip,
					label: "Authorize with OAuth"
				}),
				a && C !== null && /* @__PURE__ */ K(v, { children: a({
					value: C,
					onChange: w,
					configurationKey: S?.id
				}) })
			] }),
			/* @__PURE__ */ K(pe, {
				integrationType: ip,
				integrationId: e,
				widgetName: O,
				isCreationMode: o,
				isSubmitting: s.formState.isSubmitting,
				automationCouplingState: i,
				onConfirmDelete: () => u()
			})
		]
	});
};
//#endregion
//#region ../../../node_modules/comma-separated-tokens/index.js
function sp(e, t) {
	let n = t || {};
	return (e[e.length - 1] === "" ? [...e, ""] : e).join((n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")).trim();
}
//#endregion
//#region ../../../node_modules/estree-util-is-identifier-name/lib/index.js
var cp = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, lp = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, up = {};
function dp(e, t) {
	return ((t || up).jsx ? lp : cp).test(e);
}
//#endregion
//#region ../../../node_modules/hast-util-whitespace/lib/index.js
var fp = /[ \t\n\f\r]/g;
function pp(e) {
	return typeof e == "object" ? e.type === "text" && mp(e.value) : mp(e);
}
function mp(e) {
	return e.replace(fp, "") === "";
}
//#endregion
//#region ../../../node_modules/property-information/lib/util/schema.js
var hp = class {
	constructor(e, t, n) {
		this.property = e, this.normal = t, n && (this.space = n);
	}
};
hp.prototype.property = {}, hp.prototype.normal = {}, hp.prototype.space = null;
//#endregion
//#region ../../../node_modules/property-information/lib/util/merge.js
function gp(e, t) {
	let n = {}, r = {}, i = -1;
	for (; ++i < e.length;) Object.assign(n, e[i].property), Object.assign(r, e[i].normal);
	return new hp(n, r, t);
}
//#endregion
//#region ../../../node_modules/property-information/lib/normalize.js
function _p(e) {
	return e.toLowerCase();
}
//#endregion
//#region ../../../node_modules/property-information/lib/util/info.js
var vp = class {
	constructor(e, t) {
		this.property = e, this.attribute = t;
	}
};
vp.prototype.space = null, vp.prototype.boolean = !1, vp.prototype.booleanish = !1, vp.prototype.overloadedBoolean = !1, vp.prototype.number = !1, vp.prototype.commaSeparated = !1, vp.prototype.spaceSeparated = !1, vp.prototype.commaOrSpaceSeparated = !1, vp.prototype.mustUseProperty = !1, vp.prototype.defined = !1;
//#endregion
//#region ../../../node_modules/property-information/lib/util/types.js
var yp = /* @__PURE__ */ Et({
	boolean: () => xp,
	booleanish: () => Sp,
	commaOrSpaceSeparated: () => Ep,
	commaSeparated: () => Tp,
	number: () => Q,
	overloadedBoolean: () => Cp,
	spaceSeparated: () => wp
}), bp = 0, xp = Dp(), Sp = Dp(), Cp = Dp(), Q = Dp(), wp = Dp(), Tp = Dp(), Ep = Dp();
function Dp() {
	return 2 ** ++bp;
}
//#endregion
//#region ../../../node_modules/property-information/lib/util/defined-info.js
var Op = Object.keys(yp), kp = class extends vp {
	constructor(e, t, n, r) {
		let i = -1;
		if (super(e, t), Ap(this, "space", r), typeof n == "number") for (; ++i < Op.length;) {
			let e = Op[i];
			Ap(this, Op[i], (n & yp[e]) === yp[e]);
		}
	}
};
kp.prototype.defined = !0;
function Ap(e, t, n) {
	n && (e[t] = n);
}
//#endregion
//#region ../../../node_modules/property-information/lib/util/create.js
var jp = {}.hasOwnProperty;
function Mp(e) {
	let t = {}, n = {}, r;
	for (r in e.properties) if (jp.call(e.properties, r)) {
		let i = e.properties[r], a = new kp(r, e.transform(e.attributes || {}, r), i, e.space);
		e.mustUseProperty && e.mustUseProperty.includes(r) && (a.mustUseProperty = !0), t[r] = a, n[_p(r)] = r, n[_p(a.attribute)] = r;
	}
	return new hp(t, n, e.space);
}
//#endregion
//#region ../../../node_modules/property-information/lib/xlink.js
var Np = Mp({
	space: "xlink",
	transform(e, t) {
		return "xlink:" + t.slice(5).toLowerCase();
	},
	properties: {
		xLinkActuate: null,
		xLinkArcRole: null,
		xLinkHref: null,
		xLinkRole: null,
		xLinkShow: null,
		xLinkTitle: null,
		xLinkType: null
	}
}), Pp = Mp({
	space: "xml",
	transform(e, t) {
		return "xml:" + t.slice(3).toLowerCase();
	},
	properties: {
		xmlLang: null,
		xmlBase: null,
		xmlSpace: null
	}
});
//#endregion
//#region ../../../node_modules/property-information/lib/util/case-sensitive-transform.js
function Fp(e, t) {
	return t in e ? e[t] : t;
}
//#endregion
//#region ../../../node_modules/property-information/lib/util/case-insensitive-transform.js
function Ip(e, t) {
	return Fp(e, t.toLowerCase());
}
//#endregion
//#region ../../../node_modules/property-information/lib/xmlns.js
var Lp = Mp({
	space: "xmlns",
	attributes: { xmlnsxlink: "xmlns:xlink" },
	transform: Ip,
	properties: {
		xmlns: null,
		xmlnsXLink: null
	}
}), Rp = Mp({
	transform(e, t) {
		return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
	},
	properties: {
		ariaActiveDescendant: null,
		ariaAtomic: Sp,
		ariaAutoComplete: null,
		ariaBusy: Sp,
		ariaChecked: Sp,
		ariaColCount: Q,
		ariaColIndex: Q,
		ariaColSpan: Q,
		ariaControls: wp,
		ariaCurrent: null,
		ariaDescribedBy: wp,
		ariaDetails: null,
		ariaDisabled: Sp,
		ariaDropEffect: wp,
		ariaErrorMessage: null,
		ariaExpanded: Sp,
		ariaFlowTo: wp,
		ariaGrabbed: Sp,
		ariaHasPopup: null,
		ariaHidden: Sp,
		ariaInvalid: null,
		ariaKeyShortcuts: null,
		ariaLabel: null,
		ariaLabelledBy: wp,
		ariaLevel: Q,
		ariaLive: null,
		ariaModal: Sp,
		ariaMultiLine: Sp,
		ariaMultiSelectable: Sp,
		ariaOrientation: null,
		ariaOwns: wp,
		ariaPlaceholder: null,
		ariaPosInSet: Q,
		ariaPressed: Sp,
		ariaReadOnly: Sp,
		ariaRelevant: null,
		ariaRequired: Sp,
		ariaRoleDescription: wp,
		ariaRowCount: Q,
		ariaRowIndex: Q,
		ariaRowSpan: Q,
		ariaSelected: Sp,
		ariaSetSize: Q,
		ariaSort: null,
		ariaValueMax: Q,
		ariaValueMin: Q,
		ariaValueNow: Q,
		ariaValueText: null,
		role: null
	}
}), zp = Mp({
	space: "html",
	attributes: {
		acceptcharset: "accept-charset",
		classname: "class",
		htmlfor: "for",
		httpequiv: "http-equiv"
	},
	transform: Ip,
	mustUseProperty: [
		"checked",
		"multiple",
		"muted",
		"selected"
	],
	properties: {
		abbr: null,
		accept: Tp,
		acceptCharset: wp,
		accessKey: wp,
		action: null,
		allow: null,
		allowFullScreen: xp,
		allowPaymentRequest: xp,
		allowUserMedia: xp,
		alt: null,
		as: null,
		async: xp,
		autoCapitalize: null,
		autoComplete: wp,
		autoFocus: xp,
		autoPlay: xp,
		blocking: wp,
		capture: null,
		charSet: null,
		checked: xp,
		cite: null,
		className: wp,
		cols: Q,
		colSpan: null,
		content: null,
		contentEditable: Sp,
		controls: xp,
		controlsList: wp,
		coords: Q | Tp,
		crossOrigin: null,
		data: null,
		dateTime: null,
		decoding: null,
		default: xp,
		defer: xp,
		dir: null,
		dirName: null,
		disabled: xp,
		download: Cp,
		draggable: Sp,
		encType: null,
		enterKeyHint: null,
		fetchPriority: null,
		form: null,
		formAction: null,
		formEncType: null,
		formMethod: null,
		formNoValidate: xp,
		formTarget: null,
		headers: wp,
		height: Q,
		hidden: xp,
		high: Q,
		href: null,
		hrefLang: null,
		htmlFor: wp,
		httpEquiv: wp,
		id: null,
		imageSizes: null,
		imageSrcSet: null,
		inert: xp,
		inputMode: null,
		integrity: null,
		is: null,
		isMap: xp,
		itemId: null,
		itemProp: wp,
		itemRef: wp,
		itemScope: xp,
		itemType: wp,
		kind: null,
		label: null,
		lang: null,
		language: null,
		list: null,
		loading: null,
		loop: xp,
		low: Q,
		manifest: null,
		max: null,
		maxLength: Q,
		media: null,
		method: null,
		min: null,
		minLength: Q,
		multiple: xp,
		muted: xp,
		name: null,
		nonce: null,
		noModule: xp,
		noValidate: xp,
		onAbort: null,
		onAfterPrint: null,
		onAuxClick: null,
		onBeforeMatch: null,
		onBeforePrint: null,
		onBeforeToggle: null,
		onBeforeUnload: null,
		onBlur: null,
		onCancel: null,
		onCanPlay: null,
		onCanPlayThrough: null,
		onChange: null,
		onClick: null,
		onClose: null,
		onContextLost: null,
		onContextMenu: null,
		onContextRestored: null,
		onCopy: null,
		onCueChange: null,
		onCut: null,
		onDblClick: null,
		onDrag: null,
		onDragEnd: null,
		onDragEnter: null,
		onDragExit: null,
		onDragLeave: null,
		onDragOver: null,
		onDragStart: null,
		onDrop: null,
		onDurationChange: null,
		onEmptied: null,
		onEnded: null,
		onError: null,
		onFocus: null,
		onFormData: null,
		onHashChange: null,
		onInput: null,
		onInvalid: null,
		onKeyDown: null,
		onKeyPress: null,
		onKeyUp: null,
		onLanguageChange: null,
		onLoad: null,
		onLoadedData: null,
		onLoadedMetadata: null,
		onLoadEnd: null,
		onLoadStart: null,
		onMessage: null,
		onMessageError: null,
		onMouseDown: null,
		onMouseEnter: null,
		onMouseLeave: null,
		onMouseMove: null,
		onMouseOut: null,
		onMouseOver: null,
		onMouseUp: null,
		onOffline: null,
		onOnline: null,
		onPageHide: null,
		onPageShow: null,
		onPaste: null,
		onPause: null,
		onPlay: null,
		onPlaying: null,
		onPopState: null,
		onProgress: null,
		onRateChange: null,
		onRejectionHandled: null,
		onReset: null,
		onResize: null,
		onScroll: null,
		onScrollEnd: null,
		onSecurityPolicyViolation: null,
		onSeeked: null,
		onSeeking: null,
		onSelect: null,
		onSlotChange: null,
		onStalled: null,
		onStorage: null,
		onSubmit: null,
		onSuspend: null,
		onTimeUpdate: null,
		onToggle: null,
		onUnhandledRejection: null,
		onUnload: null,
		onVolumeChange: null,
		onWaiting: null,
		onWheel: null,
		open: xp,
		optimum: Q,
		pattern: null,
		ping: wp,
		placeholder: null,
		playsInline: xp,
		popover: null,
		popoverTarget: null,
		popoverTargetAction: null,
		poster: null,
		preload: null,
		readOnly: xp,
		referrerPolicy: null,
		rel: wp,
		required: xp,
		reversed: xp,
		rows: Q,
		rowSpan: Q,
		sandbox: wp,
		scope: null,
		scoped: xp,
		seamless: xp,
		selected: xp,
		shadowRootClonable: xp,
		shadowRootDelegatesFocus: xp,
		shadowRootMode: null,
		shape: null,
		size: Q,
		sizes: null,
		slot: null,
		span: Q,
		spellCheck: Sp,
		src: null,
		srcDoc: null,
		srcLang: null,
		srcSet: null,
		start: Q,
		step: null,
		style: null,
		tabIndex: Q,
		target: null,
		title: null,
		translate: null,
		type: null,
		typeMustMatch: xp,
		useMap: null,
		value: Sp,
		width: Q,
		wrap: null,
		writingSuggestions: null,
		align: null,
		aLink: null,
		archive: wp,
		axis: null,
		background: null,
		bgColor: null,
		border: Q,
		borderColor: null,
		bottomMargin: Q,
		cellPadding: null,
		cellSpacing: null,
		char: null,
		charOff: null,
		classId: null,
		clear: null,
		code: null,
		codeBase: null,
		codeType: null,
		color: null,
		compact: xp,
		declare: xp,
		event: null,
		face: null,
		frame: null,
		frameBorder: null,
		hSpace: Q,
		leftMargin: Q,
		link: null,
		longDesc: null,
		lowSrc: null,
		marginHeight: Q,
		marginWidth: Q,
		noResize: xp,
		noHref: xp,
		noShade: xp,
		noWrap: xp,
		object: null,
		profile: null,
		prompt: null,
		rev: null,
		rightMargin: Q,
		rules: null,
		scheme: null,
		scrolling: Sp,
		standby: null,
		summary: null,
		text: null,
		topMargin: Q,
		valueType: null,
		version: null,
		vAlign: null,
		vLink: null,
		vSpace: Q,
		allowTransparency: null,
		autoCorrect: null,
		autoSave: null,
		disablePictureInPicture: xp,
		disableRemotePlayback: xp,
		prefix: null,
		property: null,
		results: Q,
		security: null,
		unselectable: null
	}
}), Bp = Mp({
	space: "svg",
	attributes: {
		accentHeight: "accent-height",
		alignmentBaseline: "alignment-baseline",
		arabicForm: "arabic-form",
		baselineShift: "baseline-shift",
		capHeight: "cap-height",
		className: "class",
		clipPath: "clip-path",
		clipRule: "clip-rule",
		colorInterpolation: "color-interpolation",
		colorInterpolationFilters: "color-interpolation-filters",
		colorProfile: "color-profile",
		colorRendering: "color-rendering",
		crossOrigin: "crossorigin",
		dataType: "datatype",
		dominantBaseline: "dominant-baseline",
		enableBackground: "enable-background",
		fillOpacity: "fill-opacity",
		fillRule: "fill-rule",
		floodColor: "flood-color",
		floodOpacity: "flood-opacity",
		fontFamily: "font-family",
		fontSize: "font-size",
		fontSizeAdjust: "font-size-adjust",
		fontStretch: "font-stretch",
		fontStyle: "font-style",
		fontVariant: "font-variant",
		fontWeight: "font-weight",
		glyphName: "glyph-name",
		glyphOrientationHorizontal: "glyph-orientation-horizontal",
		glyphOrientationVertical: "glyph-orientation-vertical",
		hrefLang: "hreflang",
		horizAdvX: "horiz-adv-x",
		horizOriginX: "horiz-origin-x",
		horizOriginY: "horiz-origin-y",
		imageRendering: "image-rendering",
		letterSpacing: "letter-spacing",
		lightingColor: "lighting-color",
		markerEnd: "marker-end",
		markerMid: "marker-mid",
		markerStart: "marker-start",
		navDown: "nav-down",
		navDownLeft: "nav-down-left",
		navDownRight: "nav-down-right",
		navLeft: "nav-left",
		navNext: "nav-next",
		navPrev: "nav-prev",
		navRight: "nav-right",
		navUp: "nav-up",
		navUpLeft: "nav-up-left",
		navUpRight: "nav-up-right",
		onAbort: "onabort",
		onActivate: "onactivate",
		onAfterPrint: "onafterprint",
		onBeforePrint: "onbeforeprint",
		onBegin: "onbegin",
		onCancel: "oncancel",
		onCanPlay: "oncanplay",
		onCanPlayThrough: "oncanplaythrough",
		onChange: "onchange",
		onClick: "onclick",
		onClose: "onclose",
		onCopy: "oncopy",
		onCueChange: "oncuechange",
		onCut: "oncut",
		onDblClick: "ondblclick",
		onDrag: "ondrag",
		onDragEnd: "ondragend",
		onDragEnter: "ondragenter",
		onDragExit: "ondragexit",
		onDragLeave: "ondragleave",
		onDragOver: "ondragover",
		onDragStart: "ondragstart",
		onDrop: "ondrop",
		onDurationChange: "ondurationchange",
		onEmptied: "onemptied",
		onEnd: "onend",
		onEnded: "onended",
		onError: "onerror",
		onFocus: "onfocus",
		onFocusIn: "onfocusin",
		onFocusOut: "onfocusout",
		onHashChange: "onhashchange",
		onInput: "oninput",
		onInvalid: "oninvalid",
		onKeyDown: "onkeydown",
		onKeyPress: "onkeypress",
		onKeyUp: "onkeyup",
		onLoad: "onload",
		onLoadedData: "onloadeddata",
		onLoadedMetadata: "onloadedmetadata",
		onLoadStart: "onloadstart",
		onMessage: "onmessage",
		onMouseDown: "onmousedown",
		onMouseEnter: "onmouseenter",
		onMouseLeave: "onmouseleave",
		onMouseMove: "onmousemove",
		onMouseOut: "onmouseout",
		onMouseOver: "onmouseover",
		onMouseUp: "onmouseup",
		onMouseWheel: "onmousewheel",
		onOffline: "onoffline",
		onOnline: "ononline",
		onPageHide: "onpagehide",
		onPageShow: "onpageshow",
		onPaste: "onpaste",
		onPause: "onpause",
		onPlay: "onplay",
		onPlaying: "onplaying",
		onPopState: "onpopstate",
		onProgress: "onprogress",
		onRateChange: "onratechange",
		onRepeat: "onrepeat",
		onReset: "onreset",
		onResize: "onresize",
		onScroll: "onscroll",
		onSeeked: "onseeked",
		onSeeking: "onseeking",
		onSelect: "onselect",
		onShow: "onshow",
		onStalled: "onstalled",
		onStorage: "onstorage",
		onSubmit: "onsubmit",
		onSuspend: "onsuspend",
		onTimeUpdate: "ontimeupdate",
		onToggle: "ontoggle",
		onUnload: "onunload",
		onVolumeChange: "onvolumechange",
		onWaiting: "onwaiting",
		onZoom: "onzoom",
		overlinePosition: "overline-position",
		overlineThickness: "overline-thickness",
		paintOrder: "paint-order",
		panose1: "panose-1",
		pointerEvents: "pointer-events",
		referrerPolicy: "referrerpolicy",
		renderingIntent: "rendering-intent",
		shapeRendering: "shape-rendering",
		stopColor: "stop-color",
		stopOpacity: "stop-opacity",
		strikethroughPosition: "strikethrough-position",
		strikethroughThickness: "strikethrough-thickness",
		strokeDashArray: "stroke-dasharray",
		strokeDashOffset: "stroke-dashoffset",
		strokeLineCap: "stroke-linecap",
		strokeLineJoin: "stroke-linejoin",
		strokeMiterLimit: "stroke-miterlimit",
		strokeOpacity: "stroke-opacity",
		strokeWidth: "stroke-width",
		tabIndex: "tabindex",
		textAnchor: "text-anchor",
		textDecoration: "text-decoration",
		textRendering: "text-rendering",
		transformOrigin: "transform-origin",
		typeOf: "typeof",
		underlinePosition: "underline-position",
		underlineThickness: "underline-thickness",
		unicodeBidi: "unicode-bidi",
		unicodeRange: "unicode-range",
		unitsPerEm: "units-per-em",
		vAlphabetic: "v-alphabetic",
		vHanging: "v-hanging",
		vIdeographic: "v-ideographic",
		vMathematical: "v-mathematical",
		vectorEffect: "vector-effect",
		vertAdvY: "vert-adv-y",
		vertOriginX: "vert-origin-x",
		vertOriginY: "vert-origin-y",
		wordSpacing: "word-spacing",
		writingMode: "writing-mode",
		xHeight: "x-height",
		playbackOrder: "playbackorder",
		timelineBegin: "timelinebegin"
	},
	transform: Fp,
	properties: {
		about: Ep,
		accentHeight: Q,
		accumulate: null,
		additive: null,
		alignmentBaseline: null,
		alphabetic: Q,
		amplitude: Q,
		arabicForm: null,
		ascent: Q,
		attributeName: null,
		attributeType: null,
		azimuth: Q,
		bandwidth: null,
		baselineShift: null,
		baseFrequency: null,
		baseProfile: null,
		bbox: null,
		begin: null,
		bias: Q,
		by: null,
		calcMode: null,
		capHeight: Q,
		className: wp,
		clip: null,
		clipPath: null,
		clipPathUnits: null,
		clipRule: null,
		color: null,
		colorInterpolation: null,
		colorInterpolationFilters: null,
		colorProfile: null,
		colorRendering: null,
		content: null,
		contentScriptType: null,
		contentStyleType: null,
		crossOrigin: null,
		cursor: null,
		cx: null,
		cy: null,
		d: null,
		dataType: null,
		defaultAction: null,
		descent: Q,
		diffuseConstant: Q,
		direction: null,
		display: null,
		dur: null,
		divisor: Q,
		dominantBaseline: null,
		download: xp,
		dx: null,
		dy: null,
		edgeMode: null,
		editable: null,
		elevation: Q,
		enableBackground: null,
		end: null,
		event: null,
		exponent: Q,
		externalResourcesRequired: null,
		fill: null,
		fillOpacity: Q,
		fillRule: null,
		filter: null,
		filterRes: null,
		filterUnits: null,
		floodColor: null,
		floodOpacity: null,
		focusable: null,
		focusHighlight: null,
		fontFamily: null,
		fontSize: null,
		fontSizeAdjust: null,
		fontStretch: null,
		fontStyle: null,
		fontVariant: null,
		fontWeight: null,
		format: null,
		fr: null,
		from: null,
		fx: null,
		fy: null,
		g1: Tp,
		g2: Tp,
		glyphName: Tp,
		glyphOrientationHorizontal: null,
		glyphOrientationVertical: null,
		glyphRef: null,
		gradientTransform: null,
		gradientUnits: null,
		handler: null,
		hanging: Q,
		hatchContentUnits: null,
		hatchUnits: null,
		height: null,
		href: null,
		hrefLang: null,
		horizAdvX: Q,
		horizOriginX: Q,
		horizOriginY: Q,
		id: null,
		ideographic: Q,
		imageRendering: null,
		initialVisibility: null,
		in: null,
		in2: null,
		intercept: Q,
		k: Q,
		k1: Q,
		k2: Q,
		k3: Q,
		k4: Q,
		kernelMatrix: Ep,
		kernelUnitLength: null,
		keyPoints: null,
		keySplines: null,
		keyTimes: null,
		kerning: null,
		lang: null,
		lengthAdjust: null,
		letterSpacing: null,
		lightingColor: null,
		limitingConeAngle: Q,
		local: null,
		markerEnd: null,
		markerMid: null,
		markerStart: null,
		markerHeight: null,
		markerUnits: null,
		markerWidth: null,
		mask: null,
		maskContentUnits: null,
		maskUnits: null,
		mathematical: null,
		max: null,
		media: null,
		mediaCharacterEncoding: null,
		mediaContentEncodings: null,
		mediaSize: Q,
		mediaTime: null,
		method: null,
		min: null,
		mode: null,
		name: null,
		navDown: null,
		navDownLeft: null,
		navDownRight: null,
		navLeft: null,
		navNext: null,
		navPrev: null,
		navRight: null,
		navUp: null,
		navUpLeft: null,
		navUpRight: null,
		numOctaves: null,
		observer: null,
		offset: null,
		onAbort: null,
		onActivate: null,
		onAfterPrint: null,
		onBeforePrint: null,
		onBegin: null,
		onCancel: null,
		onCanPlay: null,
		onCanPlayThrough: null,
		onChange: null,
		onClick: null,
		onClose: null,
		onCopy: null,
		onCueChange: null,
		onCut: null,
		onDblClick: null,
		onDrag: null,
		onDragEnd: null,
		onDragEnter: null,
		onDragExit: null,
		onDragLeave: null,
		onDragOver: null,
		onDragStart: null,
		onDrop: null,
		onDurationChange: null,
		onEmptied: null,
		onEnd: null,
		onEnded: null,
		onError: null,
		onFocus: null,
		onFocusIn: null,
		onFocusOut: null,
		onHashChange: null,
		onInput: null,
		onInvalid: null,
		onKeyDown: null,
		onKeyPress: null,
		onKeyUp: null,
		onLoad: null,
		onLoadedData: null,
		onLoadedMetadata: null,
		onLoadStart: null,
		onMessage: null,
		onMouseDown: null,
		onMouseEnter: null,
		onMouseLeave: null,
		onMouseMove: null,
		onMouseOut: null,
		onMouseOver: null,
		onMouseUp: null,
		onMouseWheel: null,
		onOffline: null,
		onOnline: null,
		onPageHide: null,
		onPageShow: null,
		onPaste: null,
		onPause: null,
		onPlay: null,
		onPlaying: null,
		onPopState: null,
		onProgress: null,
		onRateChange: null,
		onRepeat: null,
		onReset: null,
		onResize: null,
		onScroll: null,
		onSeeked: null,
		onSeeking: null,
		onSelect: null,
		onShow: null,
		onStalled: null,
		onStorage: null,
		onSubmit: null,
		onSuspend: null,
		onTimeUpdate: null,
		onToggle: null,
		onUnload: null,
		onVolumeChange: null,
		onWaiting: null,
		onZoom: null,
		opacity: null,
		operator: null,
		order: null,
		orient: null,
		orientation: null,
		origin: null,
		overflow: null,
		overlay: null,
		overlinePosition: Q,
		overlineThickness: Q,
		paintOrder: null,
		panose1: null,
		path: null,
		pathLength: Q,
		patternContentUnits: null,
		patternTransform: null,
		patternUnits: null,
		phase: null,
		ping: wp,
		pitch: null,
		playbackOrder: null,
		pointerEvents: null,
		points: null,
		pointsAtX: Q,
		pointsAtY: Q,
		pointsAtZ: Q,
		preserveAlpha: null,
		preserveAspectRatio: null,
		primitiveUnits: null,
		propagate: null,
		property: Ep,
		r: null,
		radius: null,
		referrerPolicy: null,
		refX: null,
		refY: null,
		rel: Ep,
		rev: Ep,
		renderingIntent: null,
		repeatCount: null,
		repeatDur: null,
		requiredExtensions: Ep,
		requiredFeatures: Ep,
		requiredFonts: Ep,
		requiredFormats: Ep,
		resource: null,
		restart: null,
		result: null,
		rotate: null,
		rx: null,
		ry: null,
		scale: null,
		seed: null,
		shapeRendering: null,
		side: null,
		slope: null,
		snapshotTime: null,
		specularConstant: Q,
		specularExponent: Q,
		spreadMethod: null,
		spacing: null,
		startOffset: null,
		stdDeviation: null,
		stemh: null,
		stemv: null,
		stitchTiles: null,
		stopColor: null,
		stopOpacity: null,
		strikethroughPosition: Q,
		strikethroughThickness: Q,
		string: null,
		stroke: null,
		strokeDashArray: Ep,
		strokeDashOffset: null,
		strokeLineCap: null,
		strokeLineJoin: null,
		strokeMiterLimit: Q,
		strokeOpacity: Q,
		strokeWidth: null,
		style: null,
		surfaceScale: Q,
		syncBehavior: null,
		syncBehaviorDefault: null,
		syncMaster: null,
		syncTolerance: null,
		syncToleranceDefault: null,
		systemLanguage: Ep,
		tabIndex: Q,
		tableValues: null,
		target: null,
		targetX: Q,
		targetY: Q,
		textAnchor: null,
		textDecoration: null,
		textRendering: null,
		textLength: null,
		timelineBegin: null,
		title: null,
		transformBehavior: null,
		type: null,
		typeOf: Ep,
		to: null,
		transform: null,
		transformOrigin: null,
		u1: null,
		u2: null,
		underlinePosition: Q,
		underlineThickness: Q,
		unicode: null,
		unicodeBidi: null,
		unicodeRange: null,
		unitsPerEm: Q,
		values: null,
		vAlphabetic: Q,
		vMathematical: Q,
		vectorEffect: null,
		vHanging: Q,
		vIdeographic: Q,
		version: null,
		vertAdvY: Q,
		vertOriginX: Q,
		vertOriginY: Q,
		viewBox: null,
		viewTarget: null,
		visibility: null,
		width: null,
		widths: null,
		wordSpacing: null,
		writingMode: null,
		x: null,
		x1: null,
		x2: null,
		xChannelSelector: null,
		xHeight: Q,
		y: null,
		y1: null,
		y2: null,
		yChannelSelector: null,
		z: null,
		zoomAndPan: null
	}
}), Vp = /^data[-\w.:]+$/i, Hp = /-[a-z]/g, Up = /[A-Z]/g;
function Wp(e, t) {
	let n = _p(t), r = t, i = vp;
	if (n in e.normal) return e.property[e.normal[n]];
	if (n.length > 4 && n.slice(0, 4) === "data" && Vp.test(t)) {
		if (t.charAt(4) === "-") {
			let e = t.slice(5).replace(Hp, Kp);
			r = "data" + e.charAt(0).toUpperCase() + e.slice(1);
		} else {
			let e = t.slice(4);
			if (!Hp.test(e)) {
				let n = e.replace(Up, Gp);
				n.charAt(0) !== "-" && (n = "-" + n), t = "data" + n;
			}
		}
		i = kp;
	}
	return new i(r, t);
}
function Gp(e) {
	return "-" + e.toLowerCase();
}
function Kp(e) {
	return e.charAt(1).toUpperCase();
}
//#endregion
//#region ../../../node_modules/property-information/lib/hast-to-react.js
var qp = {
	classId: "classID",
	dataType: "datatype",
	itemId: "itemID",
	strokeDashArray: "strokeDasharray",
	strokeDashOffset: "strokeDashoffset",
	strokeLineCap: "strokeLinecap",
	strokeLineJoin: "strokeLinejoin",
	strokeMiterLimit: "strokeMiterlimit",
	typeOf: "typeof",
	xLinkActuate: "xlinkActuate",
	xLinkArcRole: "xlinkArcrole",
	xLinkHref: "xlinkHref",
	xLinkRole: "xlinkRole",
	xLinkShow: "xlinkShow",
	xLinkTitle: "xlinkTitle",
	xLinkType: "xlinkType",
	xmlnsXLink: "xmlnsXlink"
}, Jp = gp([
	Pp,
	Np,
	Lp,
	Rp,
	zp
], "html"), Yp = gp([
	Pp,
	Np,
	Lp,
	Rp,
	Bp
], "svg");
//#endregion
//#region ../../../node_modules/space-separated-tokens/index.js
function Xp(e) {
	return e.join(" ").trim();
}
//#endregion
//#region ../../../node_modules/hast-util-to-jsx-runtime/node_modules/inline-style-parser/index.js
var Zp = /* @__PURE__ */ Tt(((e, t) => {
	var n = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, r = /\n/g, i = /^\s*/, a = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, o = /^:\s*/, s = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, c = /^[;\s]*/, l = /^\s+|\s+$/g;
	t.exports = function(e, t) {
		if (typeof e != "string") throw TypeError("First argument must be a string");
		if (!e) return [];
		t ||= {};
		var l = 1, d = 1;
		function f(e) {
			var t = e.match(r);
			t && (l += t.length);
			var n = e.lastIndexOf("\n");
			d = ~n ? e.length - n : d + e.length;
		}
		function p() {
			var e = {
				line: l,
				column: d
			};
			return function(t) {
				return t.position = new m(e), v(), t;
			};
		}
		function m(e) {
			this.start = e, this.end = {
				line: l,
				column: d
			}, this.source = t.source;
		}
		m.prototype.content = e;
		var h = [];
		function g(n) {
			var r = /* @__PURE__ */ Error(t.source + ":" + l + ":" + d + ": " + n);
			if (r.reason = n, r.filename = t.source, r.line = l, r.column = d, r.source = e, t.silent) h.push(r);
			else throw r;
		}
		function _(t) {
			var n = t.exec(e);
			if (n) {
				var r = n[0];
				return f(r), e = e.slice(r.length), n;
			}
		}
		function v() {
			_(i);
		}
		function y(e) {
			var t;
			for (e ||= []; t = b();) t !== !1 && e.push(t);
			return e;
		}
		function b() {
			var t = p();
			if (!(e.charAt(0) != "/" || e.charAt(1) != "*")) {
				for (var n = 2; e.charAt(n) != "" && (e.charAt(n) != "*" || e.charAt(n + 1) != "/");) ++n;
				if (n += 2, e.charAt(n - 1) === "") return g("End of comment missing");
				var r = e.slice(2, n - 2);
				return d += 2, f(r), e = e.slice(n), d += 2, t({
					type: "comment",
					comment: r
				});
			}
		}
		function x() {
			var e = p(), t = _(a);
			if (t) {
				if (b(), !_(o)) return g("property missing ':'");
				var r = _(s), i = e({
					type: "declaration",
					property: u(t[0].replace(n, "")),
					value: r ? u(r[0].replace(n, "")) : ""
				});
				return _(c), i;
			}
		}
		function S() {
			var e = [];
			y(e);
			for (var t; t = x();) t !== !1 && (e.push(t), y(e));
			return e;
		}
		return v(), S();
	};
	function u(e) {
		return e ? e.replace(l, "") : "";
	}
})), Qp = /* @__PURE__ */ Ot((/* @__PURE__ */ Tt(((e) => {
	var t = e && e.__importDefault || function(e) {
		return e && e.__esModule ? e : { default: e };
	};
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = r;
	var n = t(Zp());
	function r(e, t) {
		var r = null;
		if (!e || typeof e != "string") return r;
		var i = (0, n.default)(e), a = typeof t == "function";
		return i.forEach(function(e) {
			if (e.type === "declaration") {
				var n = e.property, i = e.value;
				a ? t(n, i, e) : i && (r ||= {}, r[n] = i);
			}
		}), r;
	}
})))(), 1), $p = Qp.default.default || Qp.default, em = nm("end"), tm = nm("start");
function nm(e) {
	return t;
	function t(t) {
		let n = t && t.position && t.position[e] || {};
		if (typeof n.line == "number" && n.line > 0 && typeof n.column == "number" && n.column > 0) return {
			line: n.line,
			column: n.column,
			offset: typeof n.offset == "number" && n.offset > -1 ? n.offset : void 0
		};
	}
}
function rm(e) {
	let t = tm(e), n = em(e);
	if (t && n) return {
		start: t,
		end: n
	};
}
//#endregion
//#region ../../../node_modules/unist-util-stringify-position/lib/index.js
function im(e) {
	return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? om(e.position) : "start" in e || "end" in e ? om(e) : "line" in e || "column" in e ? am(e) : "";
}
function am(e) {
	return sm(e && e.line) + ":" + sm(e && e.column);
}
function om(e) {
	return am(e && e.start) + "-" + am(e && e.end);
}
function sm(e) {
	return e && typeof e == "number" ? e : 1;
}
//#endregion
//#region ../../../node_modules/vfile-message/lib/index.js
var cm = class extends Error {
	constructor(e, t, n) {
		super(), typeof t == "string" && (n = t, t = void 0);
		let r = "", i = {}, a = !1;
		if (t && (i = "line" in t && "column" in t || "start" in t && "end" in t ? { place: t } : "type" in t ? {
			ancestors: [t],
			place: t.position
		} : { ...t }), typeof e == "string" ? r = e : !i.cause && e && (a = !0, r = e.message, i.cause = e), !i.ruleId && !i.source && typeof n == "string") {
			let e = n.indexOf(":");
			e === -1 ? i.ruleId = n : (i.source = n.slice(0, e), i.ruleId = n.slice(e + 1));
		}
		if (!i.place && i.ancestors && i.ancestors) {
			let e = i.ancestors[i.ancestors.length - 1];
			e && (i.place = e.position);
		}
		let o = i.place && "start" in i.place ? i.place.start : i.place;
		this.ancestors = i.ancestors || void 0, this.cause = i.cause || void 0, this.column = o ? o.column : void 0, this.fatal = void 0, this.file, this.message = r, this.line = o ? o.line : void 0, this.name = im(i.place) || "1:1", this.place = i.place || void 0, this.reason = this.message, this.ruleId = i.ruleId || void 0, this.source = i.source || void 0, this.stack = a && i.cause && typeof i.cause.stack == "string" ? i.cause.stack : "", this.actual, this.expected, this.note, this.url;
	}
};
cm.prototype.file = "", cm.prototype.name = "", cm.prototype.reason = "", cm.prototype.message = "", cm.prototype.stack = "", cm.prototype.column = void 0, cm.prototype.line = void 0, cm.prototype.ancestors = void 0, cm.prototype.cause = void 0, cm.prototype.fatal = void 0, cm.prototype.place = void 0, cm.prototype.ruleId = void 0, cm.prototype.source = void 0;
//#endregion
//#region ../../../node_modules/hast-util-to-jsx-runtime/lib/index.js
var lm = {}.hasOwnProperty, um = /* @__PURE__ */ new Map(), dm = /[A-Z]/g, fm = /-([a-z])/g, pm = /* @__PURE__ */ new Set([
	"table",
	"tbody",
	"thead",
	"tfoot",
	"tr"
]), mm = /* @__PURE__ */ new Set(["td", "th"]);
function hm(e, t) {
	if (!t || t.Fragment === void 0) throw TypeError("Expected `Fragment` in options");
	let n = t.filePath || void 0, r;
	if (t.development) {
		if (typeof t.jsxDEV != "function") throw TypeError("Expected `jsxDEV` in options when `development: true`");
		r = Em(n, t.jsxDEV);
	} else {
		if (typeof t.jsx != "function") throw TypeError("Expected `jsx` in production options");
		if (typeof t.jsxs != "function") throw TypeError("Expected `jsxs` in production options");
		r = Tm(n, t.jsx, t.jsxs);
	}
	let i = {
		Fragment: t.Fragment,
		ancestors: [],
		components: t.components || {},
		create: r,
		elementAttributeNameCase: t.elementAttributeNameCase || "react",
		evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
		filePath: n,
		ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
		passKeys: t.passKeys !== !1,
		passNode: t.passNode || !1,
		schema: t.space === "svg" ? Yp : Jp,
		stylePropertyNameCase: t.stylePropertyNameCase || "dom",
		tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
	}, a = gm(i, e, void 0);
	return a && typeof a != "string" ? a : i.create(e, i.Fragment, { children: a || void 0 }, void 0);
}
function gm(e, t, n) {
	if (t.type === "element") return _m(e, t, n);
	if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression") return vm(e, t);
	if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement") return bm(e, t, n);
	if (t.type === "mdxjsEsm") return ym(e, t);
	if (t.type === "root") return xm(e, t, n);
	if (t.type === "text") return Sm(e, t);
}
function _m(e, t, n) {
	let r = e.schema, i = r;
	t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = Yp, e.schema = i), e.ancestors.push(t);
	let a = Mm(e, t.tagName, !1), o = Dm(e, t), s = km(e, t);
	return pm.has(t.tagName) && (s = s.filter(function(e) {
		return typeof e != "string" || !pp(e);
	})), Cm(e, o, a, t), wm(o, s), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function vm(e, t) {
	if (t.data && t.data.estree && e.evaluater) {
		let n = t.data.estree.body[0];
		return n.type, e.evaluater.evaluateExpression(n.expression);
	}
	Nm(e, t.position);
}
function ym(e, t) {
	if (t.data && t.data.estree && e.evaluater) return e.evaluater.evaluateProgram(t.data.estree);
	Nm(e, t.position);
}
function bm(e, t, n) {
	let r = e.schema, i = r;
	t.name === "svg" && r.space === "html" && (i = Yp, e.schema = i), e.ancestors.push(t);
	let a = t.name === null ? e.Fragment : Mm(e, t.name, !0), o = Om(e, t), s = km(e, t);
	return Cm(e, o, a, t), wm(o, s), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function xm(e, t, n) {
	let r = {};
	return wm(r, km(e, t)), e.create(t, e.Fragment, r, n);
}
function Sm(e, t) {
	return t.value;
}
function Cm(e, t, n, r) {
	typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function wm(e, t) {
	if (t.length > 0) {
		let n = t.length > 1 ? t : t[0];
		n && (e.children = n);
	}
}
function Tm(e, t, n) {
	return r;
	function r(e, r, i, a) {
		let o = Array.isArray(i.children) ? n : t;
		return a ? o(r, i, a) : o(r, i);
	}
}
function Em(e, t) {
	return n;
	function n(n, r, i, a) {
		let o = Array.isArray(i.children), s = tm(n);
		return t(r, i, a, o, {
			columnNumber: s ? s.column - 1 : void 0,
			fileName: e,
			lineNumber: s ? s.line : void 0
		}, void 0);
	}
}
function Dm(e, t) {
	let n = {}, r, i;
	for (i in t.properties) if (i !== "children" && lm.call(t.properties, i)) {
		let a = Am(e, i, t.properties[i]);
		if (a) {
			let [i, o] = a;
			e.tableCellAlignToStyle && i === "align" && typeof o == "string" && mm.has(t.tagName) ? r = o : n[i] = o;
		}
	}
	if (r) {
		let t = n.style ||= {};
		t[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
	}
	return n;
}
function Om(e, t) {
	let n = {};
	for (let r of t.attributes) if (r.type === "mdxJsxExpressionAttribute") if (r.data && r.data.estree && e.evaluater) {
		let t = r.data.estree.body[0];
		t.type;
		let i = t.expression;
		i.type;
		let a = i.properties[0];
		a.type, Object.assign(n, e.evaluater.evaluateExpression(a.argument));
	} else Nm(e, t.position);
	else {
		let i = r.name, a;
		if (r.value && typeof r.value == "object") if (r.value.data && r.value.data.estree && e.evaluater) {
			let t = r.value.data.estree.body[0];
			t.type, a = e.evaluater.evaluateExpression(t.expression);
		} else Nm(e, t.position);
		else a = r.value === null || r.value;
		n[i] = a;
	}
	return n;
}
function km(e, t) {
	let n = [], r = -1, i = e.passKeys ? /* @__PURE__ */ new Map() : um;
	for (; ++r < t.children.length;) {
		let a = t.children[r], o;
		if (e.passKeys) {
			let e = a.type === "element" ? a.tagName : a.type === "mdxJsxFlowElement" || a.type === "mdxJsxTextElement" ? a.name : void 0;
			if (e) {
				let t = i.get(e) || 0;
				o = e + "-" + t, i.set(e, t + 1);
			}
		}
		let s = gm(e, a, o);
		s !== void 0 && n.push(s);
	}
	return n;
}
function Am(e, t, n) {
	let r = Wp(e.schema, t);
	if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
		if (Array.isArray(n) && (n = r.commaSeparated ? sp(n) : Xp(n)), r.property === "style") {
			let t = typeof n == "object" ? n : jm(e, String(n));
			return e.stylePropertyNameCase === "css" && (t = Pm(t)), ["style", t];
		}
		return [e.elementAttributeNameCase === "react" && r.space ? qp[r.property] || r.property : r.attribute, n];
	}
}
function jm(e, t) {
	let n = {};
	try {
		$p(t, r);
	} catch (t) {
		if (!e.ignoreInvalidStyle) {
			let n = t, r = new cm("Cannot parse `style` attribute", {
				ancestors: e.ancestors,
				cause: n,
				ruleId: "style",
				source: "hast-util-to-jsx-runtime"
			});
			throw r.file = e.filePath || void 0, r.url = "https://github.com/syntax-tree/hast-util-to-jsx-runtime#cannot-parse-style-attribute", r;
		}
	}
	return n;
	function r(e, t) {
		let r = e;
		r.slice(0, 2) !== "--" && (r.slice(0, 4) === "-ms-" && (r = "ms-" + r.slice(4)), r = r.replace(fm, Im)), n[r] = t;
	}
}
function Mm(e, t, n) {
	let r;
	if (!n) r = {
		type: "Literal",
		value: t
	};
	else if (t.includes(".")) {
		let e = t.split("."), n = -1, i;
		for (; ++n < e.length;) {
			let t = dp(e[n]) ? {
				type: "Identifier",
				name: e[n]
			} : {
				type: "Literal",
				value: e[n]
			};
			i = i ? {
				type: "MemberExpression",
				object: i,
				property: t,
				computed: !!(n && t.type === "Literal"),
				optional: !1
			} : t;
		}
		r = i;
	} else r = dp(t) && !/^[a-z]/.test(t) ? {
		type: "Identifier",
		name: t
	} : {
		type: "Literal",
		value: t
	};
	if (r.type === "Literal") {
		let t = r.value;
		return lm.call(e.components, t) ? e.components[t] : t;
	}
	if (e.evaluater) return e.evaluater.evaluateExpression(r);
	Nm(e);
}
function Nm(e, t) {
	let n = new cm("Cannot handle MDX estrees without `createEvaluater`", {
		ancestors: e.ancestors,
		place: t,
		ruleId: "mdx-estree",
		source: "hast-util-to-jsx-runtime"
	});
	throw n.file = e.filePath || void 0, n.url = "https://github.com/syntax-tree/hast-util-to-jsx-runtime#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function Pm(e) {
	let t = {}, n;
	for (n in e) lm.call(e, n) && (t[Fm(n)] = e[n]);
	return t;
}
function Fm(e) {
	let t = e.replace(dm, Lm);
	return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function Im(e, t) {
	return t.toUpperCase();
}
function Lm(e) {
	return "-" + e.toLowerCase();
}
//#endregion
//#region ../../../node_modules/html-url-attributes/lib/index.js
var Rm = {
	action: ["form"],
	cite: [
		"blockquote",
		"del",
		"ins",
		"q"
	],
	data: ["object"],
	formAction: ["button", "input"],
	href: [
		"a",
		"area",
		"base",
		"link"
	],
	icon: ["menuitem"],
	itemId: null,
	manifest: ["html"],
	ping: ["a", "area"],
	poster: ["video"],
	src: [
		"audio",
		"embed",
		"iframe",
		"img",
		"input",
		"script",
		"source",
		"track",
		"video"
	]
}, zm = {};
function Bm(e, t) {
	let n = t || zm;
	return Vm(e, typeof n.includeImageAlt != "boolean" || n.includeImageAlt, typeof n.includeHtml != "boolean" || n.includeHtml);
}
function Vm(e, t, n) {
	if (Um(e)) {
		if ("value" in e) return e.type === "html" && !n ? "" : e.value;
		if (t && "alt" in e && e.alt) return e.alt;
		if ("children" in e) return Hm(e.children, t, n);
	}
	return Array.isArray(e) ? Hm(e, t, n) : "";
}
function Hm(e, t, n) {
	let r = [], i = -1;
	for (; ++i < e.length;) r[i] = Vm(e[i], t, n);
	return r.join("");
}
function Um(e) {
	return !!(e && typeof e == "object");
}
//#endregion
//#region ../../../node_modules/decode-named-character-reference/index.dom.js
var Wm = document.createElement("i");
function Gm(e) {
	let t = "&" + e + ";";
	Wm.innerHTML = t;
	let n = Wm.textContent;
	return n.charCodeAt(n.length - 1) === 59 && e !== "semi" ? !1 : n !== t && n;
}
//#endregion
//#region ../../../node_modules/micromark-util-chunked/index.js
function Km(e, t, n, r) {
	let i = e.length, a = 0, o;
	if (t = t < 0 ? -t > i ? 0 : i + t : t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4) o = Array.from(r), o.unshift(t, n), e.splice(...o);
	else for (n && e.splice(t, n); a < r.length;) o = r.slice(a, a + 1e4), o.unshift(t, 0), e.splice(...o), a += 1e4, t += 1e4;
}
function qm(e, t) {
	return e.length > 0 ? (Km(e, e.length, 0, t), e) : t;
}
//#endregion
//#region ../../../node_modules/micromark-util-combine-extensions/index.js
var Jm = {}.hasOwnProperty;
function Ym(e) {
	let t = {}, n = -1;
	for (; ++n < e.length;) Xm(t, e[n]);
	return t;
}
function Xm(e, t) {
	let n;
	for (n in t) {
		let r = (Jm.call(e, n) ? e[n] : void 0) || (e[n] = {}), i = t[n], a;
		if (i) for (a in i) {
			Jm.call(r, a) || (r[a] = []);
			let e = i[a];
			Zm(r[a], Array.isArray(e) ? e : e ? [e] : []);
		}
	}
}
function Zm(e, t) {
	let n = -1, r = [];
	for (; ++n < t.length;) (t[n].add === "after" ? e : r).push(t[n]);
	Km(e, 0, 0, r);
}
//#endregion
//#region ../../../node_modules/micromark-util-decode-numeric-character-reference/index.js
function Qm(e, t) {
	let n = Number.parseInt(e, t);
	return n < 9 || n === 11 || n > 13 && n < 32 || n > 126 && n < 160 || n > 55295 && n < 57344 || n > 64975 && n < 65008 || (n & 65535) == 65535 || (n & 65535) == 65534 || n > 1114111 ? "�" : String.fromCodePoint(n);
}
//#endregion
//#region ../../../node_modules/micromark-util-normalize-identifier/index.js
function $m(e) {
	return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
//#endregion
//#region ../../../node_modules/micromark-util-character/index.js
var eh = fh(/[A-Za-z]/), th = fh(/[\dA-Za-z]/), nh = fh(/[#-'*+\--9=?A-Z^-~]/);
function rh(e) {
	return e !== null && (e < 32 || e === 127);
}
var ih = fh(/\d/), ah = fh(/[\dA-Fa-f]/), oh = fh(/[!-/:-@[-`{-~]/);
function sh(e) {
	return e !== null && e < -2;
}
function ch(e) {
	return e !== null && (e < 0 || e === 32);
}
function lh(e) {
	return e === -2 || e === -1 || e === 32;
}
var uh = fh(/\p{P}|\p{S}/u), dh = fh(/\s/);
function fh(e) {
	return t;
	function t(t) {
		return t !== null && t > -1 && e.test(String.fromCharCode(t));
	}
}
//#endregion
//#region ../../../node_modules/micromark-util-sanitize-uri/index.js
function ph(e) {
	let t = [], n = -1, r = 0, i = 0;
	for (; ++n < e.length;) {
		let a = e.charCodeAt(n), o = "";
		if (a === 37 && th(e.charCodeAt(n + 1)) && th(e.charCodeAt(n + 2))) i = 2;
		else if (a < 128) /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(a)) || (o = String.fromCharCode(a));
		else if (a > 55295 && a < 57344) {
			let t = e.charCodeAt(n + 1);
			a < 56320 && t > 56319 && t < 57344 ? (o = String.fromCharCode(a, t), i = 1) : o = "�";
		} else o = String.fromCharCode(a);
		o &&= (t.push(e.slice(r, n), encodeURIComponent(o)), r = n + i + 1, ""), i &&= (n += i, 0);
	}
	return t.join("") + e.slice(r);
}
//#endregion
//#region ../../../node_modules/micromark-factory-space/index.js
function mh(e, t, n, r) {
	let i = r ? r - 1 : Infinity, a = 0;
	return o;
	function o(r) {
		return lh(r) ? (e.enter(n), s(r)) : t(r);
	}
	function s(r) {
		return lh(r) && a++ < i ? (e.consume(r), s) : (e.exit(n), t(r));
	}
}
//#endregion
//#region ../../../node_modules/micromark/lib/initialize/content.js
var hh = { tokenize: gh };
function gh(e) {
	let t = e.attempt(this.parser.constructs.contentInitial, r, i), n;
	return t;
	function r(n) {
		if (n === null) {
			e.consume(n);
			return;
		}
		return e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), mh(e, t, "linePrefix");
	}
	function i(t) {
		return e.enter("paragraph"), a(t);
	}
	function a(t) {
		let r = e.enter("chunkText", {
			contentType: "text",
			previous: n
		});
		return n && (n.next = r), n = r, o(t);
	}
	function o(t) {
		if (t === null) {
			e.exit("chunkText"), e.exit("paragraph"), e.consume(t);
			return;
		}
		return sh(t) ? (e.consume(t), e.exit("chunkText"), a) : (e.consume(t), o);
	}
}
//#endregion
//#region ../../../node_modules/micromark/lib/initialize/document.js
var _h = { tokenize: yh }, vh = { tokenize: bh };
function yh(e) {
	let t = this, n = [], r = 0, i, a, o;
	return s;
	function s(i) {
		if (r < n.length) {
			let a = n[r];
			return t.containerState = a[1], e.attempt(a[0].continuation, c, l)(i);
		}
		return l(i);
	}
	function c(e) {
		if (r++, t.containerState._closeFlow) {
			t.containerState._closeFlow = void 0, i && v();
			let n = t.events.length, a = n, o;
			for (; a--;) if (t.events[a][0] === "exit" && t.events[a][1].type === "chunkFlow") {
				o = t.events[a][1].end;
				break;
			}
			_(r);
			let s = n;
			for (; s < t.events.length;) t.events[s][1].end = { ...o }, s++;
			return Km(t.events, a + 1, 0, t.events.slice(n)), t.events.length = s, l(e);
		}
		return s(e);
	}
	function l(a) {
		if (r === n.length) {
			if (!i) return f(a);
			if (i.currentConstruct && i.currentConstruct.concrete) return m(a);
			t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
		}
		return t.containerState = {}, e.check(vh, u, d)(a);
	}
	function u(e) {
		return i && v(), _(r), f(e);
	}
	function d(e) {
		return t.parser.lazy[t.now().line] = r !== n.length, o = t.now().offset, m(e);
	}
	function f(n) {
		return t.containerState = {}, e.attempt(vh, p, m)(n);
	}
	function p(e) {
		return r++, n.push([t.currentConstruct, t.containerState]), f(e);
	}
	function m(n) {
		if (n === null) {
			i && v(), _(0), e.consume(n);
			return;
		}
		return i ||= t.parser.flow(t.now()), e.enter("chunkFlow", {
			_tokenizer: i,
			contentType: "flow",
			previous: a
		}), h(n);
	}
	function h(n) {
		if (n === null) {
			g(e.exit("chunkFlow"), !0), _(0), e.consume(n);
			return;
		}
		return sh(n) ? (e.consume(n), g(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, s) : (e.consume(n), h);
	}
	function g(e, n) {
		let s = t.sliceStream(e);
		if (n && s.push(null), e.previous = a, a && (a.next = e), a = e, i.defineSkip(e.start), i.write(s), t.parser.lazy[e.start.line]) {
			let e = i.events.length;
			for (; e--;) if (i.events[e][1].start.offset < o && (!i.events[e][1].end || i.events[e][1].end.offset > o)) return;
			let n = t.events.length, a = n, s, c;
			for (; a--;) if (t.events[a][0] === "exit" && t.events[a][1].type === "chunkFlow") {
				if (s) {
					c = t.events[a][1].end;
					break;
				}
				s = !0;
			}
			for (_(r), e = n; e < t.events.length;) t.events[e][1].end = { ...c }, e++;
			Km(t.events, a + 1, 0, t.events.slice(n)), t.events.length = e;
		}
	}
	function _(r) {
		let i = n.length;
		for (; i-- > r;) {
			let r = n[i];
			t.containerState = r[1], r[0].exit.call(t, e);
		}
		n.length = r;
	}
	function v() {
		i.write([null]), a = void 0, i = void 0, t.containerState._closeFlow = void 0;
	}
}
function bh(e, t, n) {
	return mh(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
//#endregion
//#region ../../../node_modules/micromark-util-classify-character/index.js
function xh(e) {
	if (e === null || ch(e) || dh(e)) return 1;
	if (uh(e)) return 2;
}
//#endregion
//#region ../../../node_modules/micromark-util-resolve-all/index.js
function Sh(e, t, n) {
	let r = [], i = -1;
	for (; ++i < e.length;) {
		let a = e[i].resolveAll;
		a && !r.includes(a) && (t = a(t, n), r.push(a));
	}
	return t;
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/attention.js
var Ch = {
	name: "attention",
	resolveAll: wh,
	tokenize: Th
};
function wh(e, t) {
	let n = -1, r, i, a, o, s, c, l, u;
	for (; ++n < e.length;) if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
		for (r = n; r--;) if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
			if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3)) continue;
			c = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
			let d = { ...e[r][1].end }, f = { ...e[n][1].start };
			Eh(d, -c), Eh(f, c), o = {
				type: c > 1 ? "strongSequence" : "emphasisSequence",
				start: d,
				end: { ...e[r][1].end }
			}, s = {
				type: c > 1 ? "strongSequence" : "emphasisSequence",
				start: { ...e[n][1].start },
				end: f
			}, a = {
				type: c > 1 ? "strongText" : "emphasisText",
				start: { ...e[r][1].end },
				end: { ...e[n][1].start }
			}, i = {
				type: c > 1 ? "strong" : "emphasis",
				start: { ...o.start },
				end: { ...s.end }
			}, e[r][1].end = { ...o.start }, e[n][1].start = { ...s.end }, l = [], e[r][1].end.offset - e[r][1].start.offset && (l = qm(l, [[
				"enter",
				e[r][1],
				t
			], [
				"exit",
				e[r][1],
				t
			]])), l = qm(l, [
				[
					"enter",
					i,
					t
				],
				[
					"enter",
					o,
					t
				],
				[
					"exit",
					o,
					t
				],
				[
					"enter",
					a,
					t
				]
			]), l = qm(l, Sh(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), l = qm(l, [
				[
					"exit",
					a,
					t
				],
				[
					"enter",
					s,
					t
				],
				[
					"exit",
					s,
					t
				],
				[
					"exit",
					i,
					t
				]
			]), e[n][1].end.offset - e[n][1].start.offset ? (u = 2, l = qm(l, [[
				"enter",
				e[n][1],
				t
			], [
				"exit",
				e[n][1],
				t
			]])) : u = 0, Km(e, r - 1, n - r + 3, l), n = r + l.length - u - 2;
			break;
		}
	}
	for (n = -1; ++n < e.length;) e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
	return e;
}
function Th(e, t) {
	let n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = xh(r), a;
	return o;
	function o(t) {
		return a = t, e.enter("attentionSequence"), s(t);
	}
	function s(o) {
		if (o === a) return e.consume(o), s;
		let c = e.exit("attentionSequence"), l = xh(o), u = !l || l === 2 && i || n.includes(o), d = !i || i === 2 && l || n.includes(r);
		return c._open = !!(a === 42 ? u : u && (i || !d)), c._close = !!(a === 42 ? d : d && (l || !u)), t(o);
	}
}
function Eh(e, t) {
	e.column += t, e.offset += t, e._bufferIndex += t;
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/autolink.js
var Dh = {
	name: "autolink",
	tokenize: Oh
};
function Oh(e, t, n) {
	let r = 0;
	return i;
	function i(t) {
		return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(t), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), a;
	}
	function a(t) {
		return eh(t) ? (e.consume(t), o) : t === 64 ? n(t) : l(t);
	}
	function o(e) {
		return e === 43 || e === 45 || e === 46 || th(e) ? (r = 1, s(e)) : l(e);
	}
	function s(t) {
		return t === 58 ? (e.consume(t), r = 0, c) : (t === 43 || t === 45 || t === 46 || th(t)) && r++ < 32 ? (e.consume(t), s) : (r = 0, l(t));
	}
	function c(r) {
		return r === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(r), e.exit("autolinkMarker"), e.exit("autolink"), t) : r === null || r === 32 || r === 60 || rh(r) ? n(r) : (e.consume(r), c);
	}
	function l(t) {
		return t === 64 ? (e.consume(t), u) : nh(t) ? (e.consume(t), l) : n(t);
	}
	function u(e) {
		return th(e) ? d(e) : n(e);
	}
	function d(n) {
		return n === 46 ? (e.consume(n), r = 0, u) : n === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(n), e.exit("autolinkMarker"), e.exit("autolink"), t) : f(n);
	}
	function f(t) {
		if ((t === 45 || th(t)) && r++ < 63) {
			let n = t === 45 ? f : d;
			return e.consume(t), n;
		}
		return n(t);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/blank-line.js
var kh = {
	partial: !0,
	tokenize: Ah
};
function Ah(e, t, n) {
	return r;
	function r(t) {
		return lh(t) ? mh(e, i, "linePrefix")(t) : i(t);
	}
	function i(e) {
		return e === null || sh(e) ? t(e) : n(e);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/block-quote.js
var jh = {
	continuation: { tokenize: Nh },
	exit: Ph,
	name: "blockQuote",
	tokenize: Mh
};
function Mh(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		if (t === 62) {
			let n = r.containerState;
			return n.open ||= (e.enter("blockQuote", { _container: !0 }), !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(t), e.exit("blockQuoteMarker"), a;
		}
		return n(t);
	}
	function a(n) {
		return lh(n) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(n), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(n));
	}
}
function Nh(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return lh(t) ? mh(e, a, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(t) : a(t);
	}
	function a(r) {
		return e.attempt(jh, t, n)(r);
	}
}
function Ph(e) {
	e.exit("blockQuote");
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/character-escape.js
var Fh = {
	name: "characterEscape",
	tokenize: Ih
};
function Ih(e, t, n) {
	return r;
	function r(t) {
		return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(t), e.exit("escapeMarker"), i;
	}
	function i(r) {
		return oh(r) ? (e.enter("characterEscapeValue"), e.consume(r), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(r);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/character-reference.js
var Lh = {
	name: "characterReference",
	tokenize: Rh
};
function Rh(e, t, n) {
	let r = this, i = 0, a, o;
	return s;
	function s(t) {
		return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(t), e.exit("characterReferenceMarker"), c;
	}
	function c(t) {
		return t === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(t), e.exit("characterReferenceMarkerNumeric"), l) : (e.enter("characterReferenceValue"), a = 31, o = th, u(t));
	}
	function l(t) {
		return t === 88 || t === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(t), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), a = 6, o = ah, u) : (e.enter("characterReferenceValue"), a = 7, o = ih, u(t));
	}
	function u(s) {
		if (s === 59 && i) {
			let i = e.exit("characterReferenceValue");
			return o === th && !Gm(r.sliceSerialize(i)) ? n(s) : (e.enter("characterReferenceMarker"), e.consume(s), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
		}
		return o(s) && i++ < a ? (e.consume(s), u) : n(s);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/code-fenced.js
var zh = {
	partial: !0,
	tokenize: Hh
}, Bh = {
	concrete: !0,
	name: "codeFenced",
	tokenize: Vh
};
function Vh(e, t, n) {
	let r = this, i = {
		partial: !0,
		tokenize: x
	}, a = 0, o = 0, s;
	return c;
	function c(e) {
		return l(e);
	}
	function l(t) {
		let n = r.events[r.events.length - 1];
		return a = n && n[1].type === "linePrefix" ? n[2].sliceSerialize(n[1], !0).length : 0, s = t, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(t);
	}
	function u(t) {
		return t === s ? (o++, e.consume(t), u) : o < 3 ? n(t) : (e.exit("codeFencedFenceSequence"), lh(t) ? mh(e, d, "whitespace")(t) : d(t));
	}
	function d(n) {
		return n === null || sh(n) ? (e.exit("codeFencedFence"), r.interrupt ? t(n) : e.check(zh, h, b)(n)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", { contentType: "string" }), f(n));
	}
	function f(t) {
		return t === null || sh(t) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), d(t)) : lh(t) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), mh(e, p, "whitespace")(t)) : t === 96 && t === s ? n(t) : (e.consume(t), f);
	}
	function p(t) {
		return t === null || sh(t) ? d(t) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", { contentType: "string" }), m(t));
	}
	function m(t) {
		return t === null || sh(t) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), d(t)) : t === 96 && t === s ? n(t) : (e.consume(t), m);
	}
	function h(t) {
		return e.attempt(i, b, g)(t);
	}
	function g(t) {
		return e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), _;
	}
	function _(t) {
		return a > 0 && lh(t) ? mh(e, v, "linePrefix", a + 1)(t) : v(t);
	}
	function v(t) {
		return t === null || sh(t) ? e.check(zh, h, b)(t) : (e.enter("codeFlowValue"), y(t));
	}
	function y(t) {
		return t === null || sh(t) ? (e.exit("codeFlowValue"), v(t)) : (e.consume(t), y);
	}
	function b(n) {
		return e.exit("codeFenced"), t(n);
	}
	function x(e, t, n) {
		let i = 0;
		return a;
		function a(t) {
			return e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), c;
		}
		function c(t) {
			return e.enter("codeFencedFence"), lh(t) ? mh(e, l, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(t) : l(t);
		}
		function l(t) {
			return t === s ? (e.enter("codeFencedFenceSequence"), u(t)) : n(t);
		}
		function u(t) {
			return t === s ? (i++, e.consume(t), u) : i >= o ? (e.exit("codeFencedFenceSequence"), lh(t) ? mh(e, d, "whitespace")(t) : d(t)) : n(t);
		}
		function d(r) {
			return r === null || sh(r) ? (e.exit("codeFencedFence"), t(r)) : n(r);
		}
	}
}
function Hh(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return t === null ? n(t) : (e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), a);
	}
	function a(e) {
		return r.parser.lazy[r.now().line] ? n(e) : t(e);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/code-indented.js
var Uh = {
	name: "codeIndented",
	tokenize: Gh
}, Wh = {
	partial: !0,
	tokenize: Kh
};
function Gh(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return e.enter("codeIndented"), mh(e, a, "linePrefix", 5)(t);
	}
	function a(e) {
		let t = r.events[r.events.length - 1];
		return t && t[1].type === "linePrefix" && t[2].sliceSerialize(t[1], !0).length >= 4 ? o(e) : n(e);
	}
	function o(t) {
		return t === null ? c(t) : sh(t) ? e.attempt(Wh, o, c)(t) : (e.enter("codeFlowValue"), s(t));
	}
	function s(t) {
		return t === null || sh(t) ? (e.exit("codeFlowValue"), o(t)) : (e.consume(t), s);
	}
	function c(n) {
		return e.exit("codeIndented"), t(n);
	}
}
function Kh(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return r.parser.lazy[r.now().line] ? n(t) : sh(t) ? (e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), i) : mh(e, a, "linePrefix", 5)(t);
	}
	function a(e) {
		let a = r.events[r.events.length - 1];
		return a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? t(e) : sh(e) ? i(e) : n(e);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/code-text.js
var qh = {
	name: "codeText",
	previous: Yh,
	resolve: Jh,
	tokenize: Xh
};
function Jh(e) {
	let t = e.length - 4, n = 3, r, i;
	if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
		for (r = n; ++r < t;) if (e[r][1].type === "codeTextData") {
			e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
			break;
		}
	}
	for (r = n - 1, t++; ++r <= t;) i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
	return e;
}
function Yh(e) {
	return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Xh(e, t, n) {
	let r = 0, i, a;
	return o;
	function o(t) {
		return e.enter("codeText"), e.enter("codeTextSequence"), s(t);
	}
	function s(t) {
		return t === 96 ? (e.consume(t), r++, s) : (e.exit("codeTextSequence"), c(t));
	}
	function c(t) {
		return t === null ? n(t) : t === 32 ? (e.enter("space"), e.consume(t), e.exit("space"), c) : t === 96 ? (a = e.enter("codeTextSequence"), i = 0, u(t)) : sh(t) ? (e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), c) : (e.enter("codeTextData"), l(t));
	}
	function l(t) {
		return t === null || t === 32 || t === 96 || sh(t) ? (e.exit("codeTextData"), c(t)) : (e.consume(t), l);
	}
	function u(n) {
		return n === 96 ? (e.consume(n), i++, u) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(n)) : (a.type = "codeTextData", l(n));
	}
}
//#endregion
//#region ../../../node_modules/micromark-util-subtokenize/lib/splice-buffer.js
var Zh = class {
	constructor(e) {
		this.left = e ? [...e] : [], this.right = [];
	}
	get(e) {
		if (e < 0 || e >= this.left.length + this.right.length) throw RangeError("Cannot access index `" + e + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
		return e < this.left.length ? this.left[e] : this.right[this.right.length - e + this.left.length - 1];
	}
	get length() {
		return this.left.length + this.right.length;
	}
	shift() {
		return this.setCursor(0), this.right.pop();
	}
	slice(e, t) {
		let n = t ?? Infinity;
		return n < this.left.length ? this.left.slice(e, n) : e > this.left.length ? this.right.slice(this.right.length - n + this.left.length, this.right.length - e + this.left.length).reverse() : this.left.slice(e).concat(this.right.slice(this.right.length - n + this.left.length).reverse());
	}
	splice(e, t, n) {
		let r = t || 0;
		this.setCursor(Math.trunc(e));
		let i = this.right.splice(this.right.length - r, Infinity);
		return n && Qh(this.left, n), i.reverse();
	}
	pop() {
		return this.setCursor(Infinity), this.left.pop();
	}
	push(e) {
		this.setCursor(Infinity), this.left.push(e);
	}
	pushMany(e) {
		this.setCursor(Infinity), Qh(this.left, e);
	}
	unshift(e) {
		this.setCursor(0), this.right.push(e);
	}
	unshiftMany(e) {
		this.setCursor(0), Qh(this.right, e.reverse());
	}
	setCursor(e) {
		if (!(e === this.left.length || e > this.left.length && this.right.length === 0 || e < 0 && this.left.length === 0)) if (e < this.left.length) {
			let t = this.left.splice(e, Infinity);
			Qh(this.right, t.reverse());
		} else {
			let t = this.right.splice(this.left.length + this.right.length - e, Infinity);
			Qh(this.left, t.reverse());
		}
	}
};
function Qh(e, t) {
	let n = 0;
	if (t.length < 1e4) e.push(...t);
	else for (; n < t.length;) e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
//#endregion
//#region ../../../node_modules/micromark-util-subtokenize/index.js
function $h(e) {
	let t = {}, n = -1, r, i, a, o, s, c, l, u = new Zh(e);
	for (; ++n < u.length;) {
		for (; n in t;) n = t[n];
		if (r = u.get(n), n && r[1].type === "chunkFlow" && u.get(n - 1)[1].type === "listItemPrefix" && (c = r[1]._tokenizer.events, a = 0, a < c.length && c[a][1].type === "lineEndingBlank" && (a += 2), a < c.length && c[a][1].type === "content")) for (; ++a < c.length && c[a][1].type !== "content";) c[a][1].type === "chunkText" && (c[a][1]._isInFirstContentOfListItem = !0, a++);
		if (r[0] === "enter") r[1].contentType && (Object.assign(t, eg(u, n)), n = t[n], l = !0);
		else if (r[1]._container) {
			for (a = n, i = void 0; a-- && (o = u.get(a), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank");) o[0] === "enter" && (i && (u.get(i)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", i = a);
			i && (r[1].end = { ...u.get(i)[1].start }, s = u.slice(i, n), s.unshift(r), u.splice(i, n - i + 1, s));
		}
	}
	return Km(e, 0, Infinity, u.slice(0)), !l;
}
function eg(e, t) {
	let n = e.get(t)[1], r = e.get(t)[2], i = t - 1, a = [], o = n._tokenizer || r.parser[n.contentType](n.start), s = o.events, c = [], l = {}, u, d, f = -1, p = n, m = 0, h = 0, g = [h];
	for (; p;) {
		for (; e.get(++i)[1] !== p;);
		a.push(i), p._tokenizer || (u = r.sliceStream(p), p.next || u.push(null), d && o.defineSkip(p.start), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(u), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), d = p, p = p.next;
	}
	for (p = n; ++f < s.length;) s[f][0] === "exit" && s[f - 1][0] === "enter" && s[f][1].type === s[f - 1][1].type && s[f][1].start.line !== s[f][1].end.line && (h = f + 1, g.push(h), p._tokenizer = void 0, p.previous = void 0, p = p.next);
	for (o.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : g.pop(), f = g.length; f--;) {
		let t = s.slice(g[f], g[f + 1]), n = a.pop();
		c.push([n, n + t.length - 1]), e.splice(n, 2, t);
	}
	for (c.reverse(), f = -1; ++f < c.length;) l[m + c[f][0]] = m + c[f][1], m += c[f][1] - c[f][0] - 1;
	return l;
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/content.js
var tg = {
	resolve: rg,
	tokenize: ig
}, ng = {
	partial: !0,
	tokenize: ag
};
function rg(e) {
	return $h(e), e;
}
function ig(e, t) {
	let n;
	return r;
	function r(t) {
		return e.enter("content"), n = e.enter("chunkContent", { contentType: "content" }), i(t);
	}
	function i(t) {
		return t === null ? a(t) : sh(t) ? e.check(ng, o, a)(t) : (e.consume(t), i);
	}
	function a(n) {
		return e.exit("chunkContent"), e.exit("content"), t(n);
	}
	function o(t) {
		return e.consume(t), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
			contentType: "content",
			previous: n
		}), n = n.next, i;
	}
}
function ag(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), mh(e, a, "linePrefix");
	}
	function a(i) {
		if (i === null || sh(i)) return n(i);
		let a = r.events[r.events.length - 1];
		return !r.parser.constructs.disable.null.includes("codeIndented") && a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? t(i) : e.interrupt(r.parser.constructs.flow, n, t)(i);
	}
}
//#endregion
//#region ../../../node_modules/micromark-factory-destination/index.js
function og(e, t, n, r, i, a, o, s, c) {
	let l = c || Infinity, u = 0;
	return d;
	function d(t) {
		return t === 60 ? (e.enter(r), e.enter(i), e.enter(a), e.consume(t), e.exit(a), f) : t === null || t === 32 || t === 41 || rh(t) ? n(t) : (e.enter(r), e.enter(o), e.enter(s), e.enter("chunkString", { contentType: "string" }), h(t));
	}
	function f(n) {
		return n === 62 ? (e.enter(a), e.consume(n), e.exit(a), e.exit(i), e.exit(r), t) : (e.enter(s), e.enter("chunkString", { contentType: "string" }), p(n));
	}
	function p(t) {
		return t === 62 ? (e.exit("chunkString"), e.exit(s), f(t)) : t === null || t === 60 || sh(t) ? n(t) : (e.consume(t), t === 92 ? m : p);
	}
	function m(t) {
		return t === 60 || t === 62 || t === 92 ? (e.consume(t), p) : p(t);
	}
	function h(i) {
		return !u && (i === null || i === 41 || ch(i)) ? (e.exit("chunkString"), e.exit(s), e.exit(o), e.exit(r), t(i)) : u < l && i === 40 ? (e.consume(i), u++, h) : i === 41 ? (e.consume(i), u--, h) : i === null || i === 32 || i === 40 || rh(i) ? n(i) : (e.consume(i), i === 92 ? g : h);
	}
	function g(t) {
		return t === 40 || t === 41 || t === 92 ? (e.consume(t), h) : h(t);
	}
}
//#endregion
//#region ../../../node_modules/micromark-factory-label/index.js
function sg(e, t, n, r, i, a) {
	let o = this, s = 0, c;
	return l;
	function l(t) {
		return e.enter(r), e.enter(i), e.consume(t), e.exit(i), e.enter(a), u;
	}
	function u(l) {
		return s > 999 || l === null || l === 91 || l === 93 && !c || l === 94 && !s && "_hiddenFootnoteSupport" in o.parser.constructs ? n(l) : l === 93 ? (e.exit(a), e.enter(i), e.consume(l), e.exit(i), e.exit(r), t) : sh(l) ? (e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), u) : (e.enter("chunkString", { contentType: "string" }), d(l));
	}
	function d(t) {
		return t === null || t === 91 || t === 93 || sh(t) || s++ > 999 ? (e.exit("chunkString"), u(t)) : (e.consume(t), c ||= !lh(t), t === 92 ? f : d);
	}
	function f(t) {
		return t === 91 || t === 92 || t === 93 ? (e.consume(t), s++, d) : d(t);
	}
}
//#endregion
//#region ../../../node_modules/micromark-factory-title/index.js
function cg(e, t, n, r, i, a) {
	let o;
	return s;
	function s(t) {
		return t === 34 || t === 39 || t === 40 ? (e.enter(r), e.enter(i), e.consume(t), e.exit(i), o = t === 40 ? 41 : t, c) : n(t);
	}
	function c(n) {
		return n === o ? (e.enter(i), e.consume(n), e.exit(i), e.exit(r), t) : (e.enter(a), l(n));
	}
	function l(t) {
		return t === o ? (e.exit(a), c(o)) : t === null ? n(t) : sh(t) ? (e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), mh(e, l, "linePrefix")) : (e.enter("chunkString", { contentType: "string" }), u(t));
	}
	function u(t) {
		return t === o || t === null || sh(t) ? (e.exit("chunkString"), l(t)) : (e.consume(t), t === 92 ? d : u);
	}
	function d(t) {
		return t === o || t === 92 ? (e.consume(t), u) : u(t);
	}
}
//#endregion
//#region ../../../node_modules/micromark-factory-whitespace/index.js
function lg(e, t) {
	let n;
	return r;
	function r(i) {
		return sh(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : lh(i) ? mh(e, r, n ? "linePrefix" : "lineSuffix")(i) : t(i);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/definition.js
var ug = {
	name: "definition",
	tokenize: fg
}, dg = {
	partial: !0,
	tokenize: pg
};
function fg(e, t, n) {
	let r = this, i;
	return a;
	function a(t) {
		return e.enter("definition"), o(t);
	}
	function o(t) {
		return sg.call(r, e, s, n, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(t);
	}
	function s(t) {
		return i = $m(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), t === 58 ? (e.enter("definitionMarker"), e.consume(t), e.exit("definitionMarker"), c) : n(t);
	}
	function c(t) {
		return ch(t) ? lg(e, l)(t) : l(t);
	}
	function l(t) {
		return og(e, u, n, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(t);
	}
	function u(t) {
		return e.attempt(dg, d, d)(t);
	}
	function d(t) {
		return lh(t) ? mh(e, f, "whitespace")(t) : f(t);
	}
	function f(a) {
		return a === null || sh(a) ? (e.exit("definition"), r.parser.defined.push(i), t(a)) : n(a);
	}
}
function pg(e, t, n) {
	return r;
	function r(t) {
		return ch(t) ? lg(e, i)(t) : n(t);
	}
	function i(t) {
		return cg(e, a, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(t);
	}
	function a(t) {
		return lh(t) ? mh(e, o, "whitespace")(t) : o(t);
	}
	function o(e) {
		return e === null || sh(e) ? t(e) : n(e);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/hard-break-escape.js
var mg = {
	name: "hardBreakEscape",
	tokenize: hg
};
function hg(e, t, n) {
	return r;
	function r(t) {
		return e.enter("hardBreakEscape"), e.consume(t), i;
	}
	function i(r) {
		return sh(r) ? (e.exit("hardBreakEscape"), t(r)) : n(r);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/heading-atx.js
var gg = {
	name: "headingAtx",
	resolve: _g,
	tokenize: vg
};
function _g(e, t) {
	let n = e.length - 2, r = 3, i, a;
	return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
		type: "atxHeadingText",
		start: e[r][1].start,
		end: e[n][1].end
	}, a = {
		type: "chunkText",
		start: e[r][1].start,
		end: e[n][1].end,
		contentType: "text"
	}, Km(e, r, n - r + 1, [
		[
			"enter",
			i,
			t
		],
		[
			"enter",
			a,
			t
		],
		[
			"exit",
			a,
			t
		],
		[
			"exit",
			i,
			t
		]
	])), e;
}
function vg(e, t, n) {
	let r = 0;
	return i;
	function i(t) {
		return e.enter("atxHeading"), a(t);
	}
	function a(t) {
		return e.enter("atxHeadingSequence"), o(t);
	}
	function o(t) {
		return t === 35 && r++ < 6 ? (e.consume(t), o) : t === null || ch(t) ? (e.exit("atxHeadingSequence"), s(t)) : n(t);
	}
	function s(n) {
		return n === 35 ? (e.enter("atxHeadingSequence"), c(n)) : n === null || sh(n) ? (e.exit("atxHeading"), t(n)) : lh(n) ? mh(e, s, "whitespace")(n) : (e.enter("atxHeadingText"), l(n));
	}
	function c(t) {
		return t === 35 ? (e.consume(t), c) : (e.exit("atxHeadingSequence"), s(t));
	}
	function l(t) {
		return t === null || t === 35 || ch(t) ? (e.exit("atxHeadingText"), s(t)) : (e.consume(t), l);
	}
}
//#endregion
//#region ../../../node_modules/micromark-util-html-tag-name/index.js
var yg = /* @__PURE__ */ "address.article.aside.base.basefont.blockquote.body.caption.center.col.colgroup.dd.details.dialog.dir.div.dl.dt.fieldset.figcaption.figure.footer.form.frame.frameset.h1.h2.h3.h4.h5.h6.head.header.hr.html.iframe.legend.li.link.main.menu.menuitem.nav.noframes.ol.optgroup.option.p.param.search.section.summary.table.tbody.td.tfoot.th.thead.title.tr.track.ul".split("."), bg = [
	"pre",
	"script",
	"style",
	"textarea"
], xg = {
	concrete: !0,
	name: "htmlFlow",
	resolveTo: wg,
	tokenize: Tg
}, Sg = {
	partial: !0,
	tokenize: Dg
}, Cg = {
	partial: !0,
	tokenize: Eg
};
function wg(e) {
	let t = e.length;
	for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"););
	return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function Tg(e, t, n) {
	let r = this, i, a, o, s, c;
	return l;
	function l(e) {
		return u(e);
	}
	function u(t) {
		return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(t), d;
	}
	function d(s) {
		return s === 33 ? (e.consume(s), f) : s === 47 ? (e.consume(s), a = !0, h) : s === 63 ? (e.consume(s), i = 3, r.interrupt ? t : I) : eh(s) ? (e.consume(s), o = String.fromCharCode(s), g) : n(s);
	}
	function f(a) {
		return a === 45 ? (e.consume(a), i = 2, p) : a === 91 ? (e.consume(a), i = 5, s = 0, m) : eh(a) ? (e.consume(a), i = 4, r.interrupt ? t : I) : n(a);
	}
	function p(i) {
		return i === 45 ? (e.consume(i), r.interrupt ? t : I) : n(i);
	}
	function m(i) {
		return i === "CDATA[".charCodeAt(s++) ? (e.consume(i), s === 6 ? r.interrupt ? t : O : m) : n(i);
	}
	function h(t) {
		return eh(t) ? (e.consume(t), o = String.fromCharCode(t), g) : n(t);
	}
	function g(s) {
		if (s === null || s === 47 || s === 62 || ch(s)) {
			let c = s === 47, l = o.toLowerCase();
			return !c && !a && bg.includes(l) ? (i = 1, r.interrupt ? t(s) : O(s)) : yg.includes(o.toLowerCase()) ? (i = 6, c ? (e.consume(s), _) : r.interrupt ? t(s) : O(s)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(s) : a ? v(s) : y(s));
		}
		return s === 45 || th(s) ? (e.consume(s), o += String.fromCharCode(s), g) : n(s);
	}
	function _(i) {
		return i === 62 ? (e.consume(i), r.interrupt ? t : O) : n(i);
	}
	function v(t) {
		return lh(t) ? (e.consume(t), v) : E(t);
	}
	function y(t) {
		return t === 47 ? (e.consume(t), E) : t === 58 || t === 95 || eh(t) ? (e.consume(t), b) : lh(t) ? (e.consume(t), y) : E(t);
	}
	function b(t) {
		return t === 45 || t === 46 || t === 58 || t === 95 || th(t) ? (e.consume(t), b) : x(t);
	}
	function x(t) {
		return t === 61 ? (e.consume(t), S) : lh(t) ? (e.consume(t), x) : y(t);
	}
	function S(t) {
		return t === null || t === 60 || t === 61 || t === 62 || t === 96 ? n(t) : t === 34 || t === 39 ? (e.consume(t), c = t, C) : lh(t) ? (e.consume(t), S) : w(t);
	}
	function C(t) {
		return t === c ? (e.consume(t), c = null, T) : t === null || sh(t) ? n(t) : (e.consume(t), C);
	}
	function w(t) {
		return t === null || t === 34 || t === 39 || t === 47 || t === 60 || t === 61 || t === 62 || t === 96 || ch(t) ? x(t) : (e.consume(t), w);
	}
	function T(e) {
		return e === 47 || e === 62 || lh(e) ? y(e) : n(e);
	}
	function E(t) {
		return t === 62 ? (e.consume(t), D) : n(t);
	}
	function D(t) {
		return t === null || sh(t) ? O(t) : lh(t) ? (e.consume(t), D) : n(t);
	}
	function O(t) {
		return t === 45 && i === 2 ? (e.consume(t), M) : t === 60 && i === 1 ? (e.consume(t), N) : t === 62 && i === 4 ? (e.consume(t), ee) : t === 63 && i === 3 ? (e.consume(t), I) : t === 93 && i === 5 ? (e.consume(t), F) : sh(t) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(Sg, L, k)(t)) : t === null || sh(t) ? (e.exit("htmlFlowData"), k(t)) : (e.consume(t), O);
	}
	function k(t) {
		return e.check(Cg, A, L)(t);
	}
	function A(t) {
		return e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), j;
	}
	function j(t) {
		return t === null || sh(t) ? k(t) : (e.enter("htmlFlowData"), O(t));
	}
	function M(t) {
		return t === 45 ? (e.consume(t), I) : O(t);
	}
	function N(t) {
		return t === 47 ? (e.consume(t), o = "", P) : O(t);
	}
	function P(t) {
		if (t === 62) {
			let n = o.toLowerCase();
			return bg.includes(n) ? (e.consume(t), ee) : O(t);
		}
		return eh(t) && o.length < 8 ? (e.consume(t), o += String.fromCharCode(t), P) : O(t);
	}
	function F(t) {
		return t === 93 ? (e.consume(t), I) : O(t);
	}
	function I(t) {
		return t === 62 ? (e.consume(t), ee) : t === 45 && i === 2 ? (e.consume(t), I) : O(t);
	}
	function ee(t) {
		return t === null || sh(t) ? (e.exit("htmlFlowData"), L(t)) : (e.consume(t), ee);
	}
	function L(n) {
		return e.exit("htmlFlow"), t(n);
	}
}
function Eg(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return sh(t) ? (e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), a) : n(t);
	}
	function a(e) {
		return r.parser.lazy[r.now().line] ? n(e) : t(e);
	}
}
function Dg(e, t, n) {
	return r;
	function r(r) {
		return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), e.attempt(kh, t, n);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/html-text.js
var Og = {
	name: "htmlText",
	tokenize: kg
};
function kg(e, t, n) {
	let r = this, i, a, o;
	return s;
	function s(t) {
		return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(t), c;
	}
	function c(t) {
		return t === 33 ? (e.consume(t), l) : t === 47 ? (e.consume(t), x) : t === 63 ? (e.consume(t), y) : eh(t) ? (e.consume(t), w) : n(t);
	}
	function l(t) {
		return t === 45 ? (e.consume(t), u) : t === 91 ? (e.consume(t), a = 0, m) : eh(t) ? (e.consume(t), v) : n(t);
	}
	function u(t) {
		return t === 45 ? (e.consume(t), p) : n(t);
	}
	function d(t) {
		return t === null ? n(t) : t === 45 ? (e.consume(t), f) : sh(t) ? (o = d, N(t)) : (e.consume(t), d);
	}
	function f(t) {
		return t === 45 ? (e.consume(t), p) : d(t);
	}
	function p(e) {
		return e === 62 ? M(e) : e === 45 ? f(e) : d(e);
	}
	function m(t) {
		return t === "CDATA[".charCodeAt(a++) ? (e.consume(t), a === 6 ? h : m) : n(t);
	}
	function h(t) {
		return t === null ? n(t) : t === 93 ? (e.consume(t), g) : sh(t) ? (o = h, N(t)) : (e.consume(t), h);
	}
	function g(t) {
		return t === 93 ? (e.consume(t), _) : h(t);
	}
	function _(t) {
		return t === 62 ? M(t) : t === 93 ? (e.consume(t), _) : h(t);
	}
	function v(t) {
		return t === null || t === 62 ? M(t) : sh(t) ? (o = v, N(t)) : (e.consume(t), v);
	}
	function y(t) {
		return t === null ? n(t) : t === 63 ? (e.consume(t), b) : sh(t) ? (o = y, N(t)) : (e.consume(t), y);
	}
	function b(e) {
		return e === 62 ? M(e) : y(e);
	}
	function x(t) {
		return eh(t) ? (e.consume(t), S) : n(t);
	}
	function S(t) {
		return t === 45 || th(t) ? (e.consume(t), S) : C(t);
	}
	function C(t) {
		return sh(t) ? (o = C, N(t)) : lh(t) ? (e.consume(t), C) : M(t);
	}
	function w(t) {
		return t === 45 || th(t) ? (e.consume(t), w) : t === 47 || t === 62 || ch(t) ? T(t) : n(t);
	}
	function T(t) {
		return t === 47 ? (e.consume(t), M) : t === 58 || t === 95 || eh(t) ? (e.consume(t), E) : sh(t) ? (o = T, N(t)) : lh(t) ? (e.consume(t), T) : M(t);
	}
	function E(t) {
		return t === 45 || t === 46 || t === 58 || t === 95 || th(t) ? (e.consume(t), E) : D(t);
	}
	function D(t) {
		return t === 61 ? (e.consume(t), O) : sh(t) ? (o = D, N(t)) : lh(t) ? (e.consume(t), D) : T(t);
	}
	function O(t) {
		return t === null || t === 60 || t === 61 || t === 62 || t === 96 ? n(t) : t === 34 || t === 39 ? (e.consume(t), i = t, k) : sh(t) ? (o = O, N(t)) : lh(t) ? (e.consume(t), O) : (e.consume(t), A);
	}
	function k(t) {
		return t === i ? (e.consume(t), i = void 0, j) : t === null ? n(t) : sh(t) ? (o = k, N(t)) : (e.consume(t), k);
	}
	function A(t) {
		return t === null || t === 34 || t === 39 || t === 60 || t === 61 || t === 96 ? n(t) : t === 47 || t === 62 || ch(t) ? T(t) : (e.consume(t), A);
	}
	function j(e) {
		return e === 47 || e === 62 || ch(e) ? T(e) : n(e);
	}
	function M(r) {
		return r === 62 ? (e.consume(r), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(r);
	}
	function N(t) {
		return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), P;
	}
	function P(t) {
		return lh(t) ? mh(e, F, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(t) : F(t);
	}
	function F(t) {
		return e.enter("htmlTextData"), o(t);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/label-end.js
var Ag = {
	name: "labelEnd",
	resolveAll: Pg,
	resolveTo: Fg,
	tokenize: Ig
}, jg = { tokenize: Lg }, Mg = { tokenize: Rg }, Ng = { tokenize: zg };
function Pg(e) {
	let t = -1, n = [];
	for (; ++t < e.length;) {
		let r = e[t][1];
		if (n.push(e[t]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
			let e = r.type === "labelImage" ? 4 : 2;
			r.type = "data", t += e;
		}
	}
	return e.length !== n.length && Km(e, 0, e.length, n), e;
}
function Fg(e, t) {
	let n = e.length, r = 0, i, a, o, s;
	for (; n--;) if (i = e[n][1], a) {
		if (i.type === "link" || i.type === "labelLink" && i._inactive) break;
		e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
	} else if (o) {
		if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (a = n, i.type !== "labelLink")) {
			r = 2;
			break;
		}
	} else i.type === "labelEnd" && (o = n);
	let c = {
		type: e[a][1].type === "labelLink" ? "link" : "image",
		start: { ...e[a][1].start },
		end: { ...e[e.length - 1][1].end }
	}, l = {
		type: "label",
		start: { ...e[a][1].start },
		end: { ...e[o][1].end }
	}, u = {
		type: "labelText",
		start: { ...e[a + r + 2][1].end },
		end: { ...e[o - 2][1].start }
	};
	return s = [[
		"enter",
		c,
		t
	], [
		"enter",
		l,
		t
	]], s = qm(s, e.slice(a + 1, a + r + 3)), s = qm(s, [[
		"enter",
		u,
		t
	]]), s = qm(s, Sh(t.parser.constructs.insideSpan.null, e.slice(a + r + 4, o - 3), t)), s = qm(s, [
		[
			"exit",
			u,
			t
		],
		e[o - 2],
		e[o - 1],
		[
			"exit",
			l,
			t
		]
	]), s = qm(s, e.slice(o + 1)), s = qm(s, [[
		"exit",
		c,
		t
	]]), Km(e, a, e.length, s), e;
}
function Ig(e, t, n) {
	let r = this, i = r.events.length, a, o;
	for (; i--;) if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
		a = r.events[i][1];
		break;
	}
	return s;
	function s(t) {
		return a ? a._inactive ? d(t) : (o = r.parser.defined.includes($m(r.sliceSerialize({
			start: a.end,
			end: r.now()
		}))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(t), e.exit("labelMarker"), e.exit("labelEnd"), c) : n(t);
	}
	function c(t) {
		return t === 40 ? e.attempt(jg, u, o ? u : d)(t) : t === 91 ? e.attempt(Mg, u, o ? l : d)(t) : o ? u(t) : d(t);
	}
	function l(t) {
		return e.attempt(Ng, u, d)(t);
	}
	function u(e) {
		return t(e);
	}
	function d(e) {
		return a._balanced = !0, n(e);
	}
}
function Lg(e, t, n) {
	return r;
	function r(t) {
		return e.enter("resource"), e.enter("resourceMarker"), e.consume(t), e.exit("resourceMarker"), i;
	}
	function i(t) {
		return ch(t) ? lg(e, a)(t) : a(t);
	}
	function a(t) {
		return t === 41 ? u(t) : og(e, o, s, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(t);
	}
	function o(t) {
		return ch(t) ? lg(e, c)(t) : u(t);
	}
	function s(e) {
		return n(e);
	}
	function c(t) {
		return t === 34 || t === 39 || t === 40 ? cg(e, l, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(t) : u(t);
	}
	function l(t) {
		return ch(t) ? lg(e, u)(t) : u(t);
	}
	function u(r) {
		return r === 41 ? (e.enter("resourceMarker"), e.consume(r), e.exit("resourceMarker"), e.exit("resource"), t) : n(r);
	}
}
function Rg(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return sg.call(r, e, a, o, "reference", "referenceMarker", "referenceString")(t);
	}
	function a(e) {
		return r.parser.defined.includes($m(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(e) : n(e);
	}
	function o(e) {
		return n(e);
	}
}
function zg(e, t, n) {
	return r;
	function r(t) {
		return e.enter("reference"), e.enter("referenceMarker"), e.consume(t), e.exit("referenceMarker"), i;
	}
	function i(r) {
		return r === 93 ? (e.enter("referenceMarker"), e.consume(r), e.exit("referenceMarker"), e.exit("reference"), t) : n(r);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/label-start-image.js
var Bg = {
	name: "labelStartImage",
	resolveAll: Ag.resolveAll,
	tokenize: Vg
};
function Vg(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(t), e.exit("labelImageMarker"), a;
	}
	function a(t) {
		return t === 91 ? (e.enter("labelMarker"), e.consume(t), e.exit("labelMarker"), e.exit("labelImage"), o) : n(t);
	}
	function o(e) {
		/* c8 ignore next 3 */
		return e === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(e) : t(e);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/label-start-link.js
var Hg = {
	name: "labelStartLink",
	resolveAll: Ag.resolveAll,
	tokenize: Ug
};
function Ug(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return e.enter("labelLink"), e.enter("labelMarker"), e.consume(t), e.exit("labelMarker"), e.exit("labelLink"), a;
	}
	function a(e) {
		/* c8 ignore next 3 */
		return e === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(e) : t(e);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/line-ending.js
var Wg = {
	name: "lineEnding",
	tokenize: Gg
};
function Gg(e, t) {
	return n;
	function n(n) {
		return e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), mh(e, t, "linePrefix");
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/thematic-break.js
var Kg = {
	name: "thematicBreak",
	tokenize: qg
};
function qg(e, t, n) {
	let r = 0, i;
	return a;
	function a(t) {
		return e.enter("thematicBreak"), o(t);
	}
	function o(e) {
		return i = e, s(e);
	}
	function s(a) {
		return a === i ? (e.enter("thematicBreakSequence"), c(a)) : r >= 3 && (a === null || sh(a)) ? (e.exit("thematicBreak"), t(a)) : n(a);
	}
	function c(t) {
		return t === i ? (e.consume(t), r++, c) : (e.exit("thematicBreakSequence"), lh(t) ? mh(e, s, "whitespace")(t) : s(t));
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/list.js
var Jg = {
	continuation: { tokenize: Qg },
	exit: e_,
	name: "list",
	tokenize: Zg
}, Yg = {
	partial: !0,
	tokenize: t_
}, Xg = {
	partial: !0,
	tokenize: $g
};
function Zg(e, t, n) {
	let r = this, i = r.events[r.events.length - 1], a = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, o = 0;
	return s;
	function s(t) {
		let i = r.containerState.type || (t === 42 || t === 43 || t === 45 ? "listUnordered" : "listOrdered");
		if (i === "listUnordered" ? !r.containerState.marker || t === r.containerState.marker : ih(t)) {
			if (r.containerState.type || (r.containerState.type = i, e.enter(i, { _container: !0 })), i === "listUnordered") return e.enter("listItemPrefix"), t === 42 || t === 45 ? e.check(Kg, n, l)(t) : l(t);
			if (!r.interrupt || t === 49) return e.enter("listItemPrefix"), e.enter("listItemValue"), c(t);
		}
		return n(t);
	}
	function c(t) {
		return ih(t) && ++o < 10 ? (e.consume(t), c) : (!r.interrupt || o < 2) && (r.containerState.marker ? t === r.containerState.marker : t === 41 || t === 46) ? (e.exit("listItemValue"), l(t)) : n(t);
	}
	function l(t) {
		return e.enter("listItemMarker"), e.consume(t), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || t, e.check(kh, r.interrupt ? n : u, e.attempt(Yg, f, d));
	}
	function u(e) {
		return r.containerState.initialBlankLine = !0, a++, f(e);
	}
	function d(t) {
		return lh(t) ? (e.enter("listItemPrefixWhitespace"), e.consume(t), e.exit("listItemPrefixWhitespace"), f) : n(t);
	}
	function f(n) {
		return r.containerState.size = a + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(n);
	}
}
function Qg(e, t, n) {
	let r = this;
	return r.containerState._closeFlow = void 0, e.check(kh, i, a);
	function i(n) {
		return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, mh(e, t, "listItemIndent", r.containerState.size + 1)(n);
	}
	function a(n) {
		return r.containerState.furtherBlankLines || !lh(n) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(n)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(Xg, t, o)(n));
	}
	function o(i) {
		return r.containerState._closeFlow = !0, r.interrupt = void 0, mh(e, e.attempt(Jg, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(i);
	}
}
function $g(e, t, n) {
	let r = this;
	return mh(e, i, "listItemIndent", r.containerState.size + 1);
	function i(e) {
		let i = r.events[r.events.length - 1];
		return i && i[1].type === "listItemIndent" && i[2].sliceSerialize(i[1], !0).length === r.containerState.size ? t(e) : n(e);
	}
}
function e_(e) {
	e.exit(this.containerState.type);
}
function t_(e, t, n) {
	let r = this;
	return mh(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
	function i(e) {
		let i = r.events[r.events.length - 1];
		return !lh(e) && i && i[1].type === "listItemPrefixWhitespace" ? t(e) : n(e);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/setext-underline.js
var n_ = {
	name: "setextUnderline",
	resolveTo: r_,
	tokenize: i_
};
function r_(e, t) {
	let n = e.length, r, i, a;
	for (; n--;) if (e[n][0] === "enter") {
		if (e[n][1].type === "content") {
			r = n;
			break;
		}
		e[n][1].type === "paragraph" && (i = n);
	} else e[n][1].type === "content" && e.splice(n, 1), !a && e[n][1].type === "definition" && (a = n);
	let o = {
		type: "setextHeading",
		start: { ...e[i][1].start },
		end: { ...e[e.length - 1][1].end }
	};
	return e[i][1].type = "setextHeadingText", a ? (e.splice(i, 0, [
		"enter",
		o,
		t
	]), e.splice(a + 1, 0, [
		"exit",
		e[r][1],
		t
	]), e[r][1].end = { ...e[a][1].end }) : e[r][1] = o, e.push([
		"exit",
		o,
		t
	]), e;
}
function i_(e, t, n) {
	let r = this, i;
	return a;
	function a(t) {
		let a = r.events.length, s;
		for (; a--;) if (r.events[a][1].type !== "lineEnding" && r.events[a][1].type !== "linePrefix" && r.events[a][1].type !== "content") {
			s = r.events[a][1].type === "paragraph";
			break;
		}
		return !r.parser.lazy[r.now().line] && (r.interrupt || s) ? (e.enter("setextHeadingLine"), i = t, o(t)) : n(t);
	}
	function o(t) {
		return e.enter("setextHeadingLineSequence"), s(t);
	}
	function s(t) {
		return t === i ? (e.consume(t), s) : (e.exit("setextHeadingLineSequence"), lh(t) ? mh(e, c, "lineSuffix")(t) : c(t));
	}
	function c(r) {
		return r === null || sh(r) ? (e.exit("setextHeadingLine"), t(r)) : n(r);
	}
}
//#endregion
//#region ../../../node_modules/micromark/lib/initialize/flow.js
var a_ = { tokenize: o_ };
function o_(e) {
	let t = this, n = e.attempt(kh, r, e.attempt(this.parser.constructs.flowInitial, i, mh(e, e.attempt(this.parser.constructs.flow, i, e.attempt(tg, i)), "linePrefix")));
	return n;
	function r(r) {
		if (r === null) {
			e.consume(r);
			return;
		}
		return e.enter("lineEndingBlank"), e.consume(r), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
	}
	function i(r) {
		if (r === null) {
			e.consume(r);
			return;
		}
		return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), t.currentConstruct = void 0, n;
	}
}
//#endregion
//#region ../../../node_modules/micromark/lib/initialize/text.js
var s_ = { resolveAll: d_() }, c_ = u_("string"), l_ = u_("text");
function u_(e) {
	return {
		resolveAll: d_(e === "text" ? f_ : void 0),
		tokenize: t
	};
	function t(t) {
		let n = this, r = this.parser.constructs[e], i = t.attempt(r, a, o);
		return a;
		function a(e) {
			return c(e) ? i(e) : o(e);
		}
		function o(e) {
			if (e === null) {
				t.consume(e);
				return;
			}
			return t.enter("data"), t.consume(e), s;
		}
		function s(e) {
			return c(e) ? (t.exit("data"), i(e)) : (t.consume(e), s);
		}
		function c(e) {
			if (e === null) return !0;
			let t = r[e], i = -1;
			if (t) for (; ++i < t.length;) {
				let e = t[i];
				if (!e.previous || e.previous.call(n, n.previous)) return !0;
			}
			return !1;
		}
	}
}
function d_(e) {
	return t;
	function t(t, n) {
		let r = -1, i;
		for (; ++r <= t.length;) i === void 0 ? t[r] && t[r][1].type === "data" && (i = r, r++) : (!t[r] || t[r][1].type !== "data") && (r !== i + 2 && (t[i][1].end = t[r - 1][1].end, t.splice(i + 2, r - i - 2), r = i + 2), i = void 0);
		return e ? e(t, n) : t;
	}
}
function f_(e, t) {
	let n = 0;
	for (; ++n <= e.length;) if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
		let r = e[n - 1][1], i = t.sliceStream(r), a = i.length, o = -1, s = 0, c;
		for (; a--;) {
			let e = i[a];
			if (typeof e == "string") {
				for (o = e.length; e.charCodeAt(o - 1) === 32;) s++, o--;
				if (o) break;
				o = -1;
			} else if (e === -2) c = !0, s++;
			else if (e !== -1) {
				a++;
				break;
			}
		}
		if (s) {
			let i = {
				type: n === e.length || c || s < 2 ? "lineSuffix" : "hardBreakTrailing",
				start: {
					_bufferIndex: a ? o : r.start._bufferIndex + o,
					_index: r.start._index + a,
					line: r.end.line,
					column: r.end.column - s,
					offset: r.end.offset - s
				},
				end: { ...r.end }
			};
			r.end = { ...i.start }, r.start.offset === r.end.offset ? Object.assign(r, i) : (e.splice(n, 0, [
				"enter",
				i,
				t
			], [
				"exit",
				i,
				t
			]), n += 2);
		}
		n++;
	}
	return e;
}
//#endregion
//#region ../../../node_modules/micromark/lib/constructs.js
var p_ = /* @__PURE__ */ Et({
	attentionMarkers: () => x_,
	contentInitial: () => h_,
	disable: () => S_,
	document: () => m_,
	flow: () => __,
	flowInitial: () => g_,
	insideSpan: () => b_,
	string: () => v_,
	text: () => y_
}), m_ = {
	42: Jg,
	43: Jg,
	45: Jg,
	48: Jg,
	49: Jg,
	50: Jg,
	51: Jg,
	52: Jg,
	53: Jg,
	54: Jg,
	55: Jg,
	56: Jg,
	57: Jg,
	62: jh
}, h_ = { 91: ug }, g_ = {
	[-2]: Uh,
	[-1]: Uh,
	32: Uh
}, __ = {
	35: gg,
	42: Kg,
	45: [n_, Kg],
	60: xg,
	61: n_,
	95: Kg,
	96: Bh,
	126: Bh
}, v_ = {
	38: Lh,
	92: Fh
}, y_ = {
	[-5]: Wg,
	[-4]: Wg,
	[-3]: Wg,
	33: Bg,
	38: Lh,
	42: Ch,
	60: [Dh, Og],
	91: Hg,
	92: [mg, Fh],
	93: Ag,
	95: Ch,
	96: qh
}, b_ = { null: [Ch, s_] }, x_ = { null: [42, 95] }, S_ = { null: [] };
//#endregion
//#region ../../../node_modules/micromark/lib/create-tokenizer.js
function C_(e, t, n) {
	let r = {
		_bufferIndex: -1,
		_index: 0,
		line: n && n.line || 1,
		column: n && n.column || 1,
		offset: n && n.offset || 0
	}, i = {}, a = [], o = [], s = [], c = {
		attempt: C(x),
		check: C(S),
		consume: v,
		enter: y,
		exit: b,
		interrupt: C(S, { interrupt: !0 })
	}, l = {
		code: null,
		containerState: {},
		defineSkip: h,
		events: [],
		now: m,
		parser: e,
		previous: null,
		sliceSerialize: f,
		sliceStream: p,
		write: d
	}, u = t.tokenize.call(l, c);
	return t.resolveAll && a.push(t), l;
	function d(e) {
		return o = qm(o, e), g(), o[o.length - 1] === null ? (w(t, 0), l.events = Sh(a, l.events, l), l.events) : [];
	}
	function f(e, t) {
		return T_(p(e), t);
	}
	function p(e) {
		return w_(o, e);
	}
	function m() {
		let { _bufferIndex: e, _index: t, line: n, column: i, offset: a } = r;
		return {
			_bufferIndex: e,
			_index: t,
			line: n,
			column: i,
			offset: a
		};
	}
	function h(e) {
		i[e.line] = e.column, E();
	}
	function g() {
		let e;
		for (; r._index < o.length;) {
			let t = o[r._index];
			if (typeof t == "string") for (e = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === e && r._bufferIndex < t.length;) _(t.charCodeAt(r._bufferIndex));
			else _(t);
		}
	}
	function _(e) {
		u = u(e);
	}
	function v(e) {
		sh(e) ? (r.line++, r.column = 1, r.offset += e === -3 ? 2 : 1, E()) : e !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === o[r._index].length && (r._bufferIndex = -1, r._index++)), l.previous = e;
	}
	function y(e, t) {
		let n = t || {};
		return n.type = e, n.start = m(), l.events.push([
			"enter",
			n,
			l
		]), s.push(n), n;
	}
	function b(e) {
		let t = s.pop();
		return t.end = m(), l.events.push([
			"exit",
			t,
			l
		]), t;
	}
	function x(e, t) {
		w(e, t.from);
	}
	function S(e, t) {
		t.restore();
	}
	function C(e, t) {
		return n;
		function n(n, r, i) {
			let a, o, s, u;
			return Array.isArray(n) ? f(n) : "tokenize" in n ? f([n]) : d(n);
			function d(e) {
				return t;
				function t(t) {
					let n = t !== null && e[t], r = t !== null && e.null;
					return f([...Array.isArray(n) ? n : n ? [n] : [], ...Array.isArray(r) ? r : r ? [r] : []])(t);
				}
			}
			function f(e) {
				return a = e, o = 0, e.length === 0 ? i : p(e[o]);
			}
			function p(e) {
				return n;
				function n(n) {
					return u = T(), s = e, e.partial || (l.currentConstruct = e), e.name && l.parser.constructs.disable.null.includes(e.name) ? h(n) : e.tokenize.call(t ? Object.assign(Object.create(l), t) : l, c, m, h)(n);
				}
			}
			function m(t) {
				return e(s, u), r;
			}
			function h(e) {
				return u.restore(), ++o < a.length ? p(a[o]) : i;
			}
		}
	}
	function w(e, t) {
		e.resolveAll && !a.includes(e) && a.push(e), e.resolve && Km(l.events, t, l.events.length - t, e.resolve(l.events.slice(t), l)), e.resolveTo && (l.events = e.resolveTo(l.events, l));
	}
	function T() {
		let e = m(), t = l.previous, n = l.currentConstruct, i = l.events.length, a = Array.from(s);
		return {
			from: i,
			restore: o
		};
		function o() {
			r = e, l.previous = t, l.currentConstruct = n, l.events.length = i, s = a, E();
		}
	}
	function E() {
		r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
	}
}
function w_(e, t) {
	let n = t.start._index, r = t.start._bufferIndex, i = t.end._index, a = t.end._bufferIndex, o;
	if (n === i) o = [e[n].slice(r, a)];
	else {
		if (o = e.slice(n, i), r > -1) {
			let e = o[0];
			typeof e == "string" ? o[0] = e.slice(r) : o.shift();
		}
		a > 0 && o.push(e[i].slice(0, a));
	}
	return o;
}
function T_(e, t) {
	let n = -1, r = [], i;
	for (; ++n < e.length;) {
		let a = e[n], o;
		if (typeof a == "string") o = a;
		else switch (a) {
			case -5:
				o = "\r";
				break;
			case -4:
				o = "\n";
				break;
			case -3:
				o = "\r\n";
				break;
			case -2:
				o = t ? " " : "	";
				break;
			case -1:
				if (!t && i) continue;
				o = " ";
				break;
			default: o = String.fromCharCode(a);
		}
		i = a === -2, r.push(o);
	}
	return r.join("");
}
//#endregion
//#region ../../../node_modules/micromark/lib/parse.js
function E_(e) {
	let t = {
		constructs: Ym([p_, ...(e || {}).extensions || []]),
		content: n(hh),
		defined: [],
		document: n(_h),
		flow: n(a_),
		lazy: {},
		string: n(c_),
		text: n(l_)
	};
	return t;
	function n(e) {
		return n;
		function n(n) {
			return C_(t, e, n);
		}
	}
}
//#endregion
//#region ../../../node_modules/micromark/lib/postprocess.js
function D_(e) {
	for (; !$h(e););
	return e;
}
//#endregion
//#region ../../../node_modules/micromark/lib/preprocess.js
var O_ = /[\0\t\n\r]/g;
function k_() {
	let e = 1, t = "", n = !0, r;
	return i;
	function i(i, a, o) {
		let s = [], c, l, u, d, f;
		for (i = t + (typeof i == "string" ? i.toString() : new TextDecoder(a || void 0).decode(i)), u = 0, t = "", n &&= (i.charCodeAt(0) === 65279 && u++, void 0); u < i.length;) {
			if (O_.lastIndex = u, c = O_.exec(i), d = c && c.index !== void 0 ? c.index : i.length, f = i.charCodeAt(d), !c) {
				t = i.slice(u);
				break;
			}
			if (f === 10 && u === d && r) s.push(-3), r = void 0;
			else switch (r &&= (s.push(-5), void 0), u < d && (s.push(i.slice(u, d)), e += d - u), f) {
				case 0:
					s.push(65533), e++;
					break;
				case 9:
					for (l = Math.ceil(e / 4) * 4, s.push(-2); e++ < l;) s.push(-1);
					break;
				case 10:
					s.push(-4), e = 1;
					break;
				default: r = !0, e = 1;
			}
			u = d + 1;
		}
		return o && (r && s.push(-5), t && s.push(t), s.push(null)), s;
	}
}
//#endregion
//#region ../../../node_modules/micromark-util-decode-string/index.js
var A_ = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function j_(e) {
	return e.replace(A_, M_);
}
function M_(e, t, n) {
	if (t) return t;
	if (n.charCodeAt(0) === 35) {
		let e = n.charCodeAt(1), t = e === 120 || e === 88;
		return Qm(n.slice(t ? 2 : 1), t ? 16 : 10);
	}
	return Gm(n) || e;
}
//#endregion
//#region ../../../node_modules/mdast-util-from-markdown/lib/index.js
var N_ = {}.hasOwnProperty;
function P_(e, t, n) {
	return typeof t != "string" && (n = t, t = void 0), F_(n)(D_(E_(n).document().write(k_()(e, t, !0))));
}
function F_(e) {
	let t = {
		transforms: [],
		canContainEols: [
			"emphasis",
			"fragment",
			"heading",
			"paragraph",
			"strong"
		],
		enter: {
			autolink: a(he),
			autolinkProtocol: T,
			autolinkEmail: T,
			atxHeading: a(de),
			blockQuote: a(oe),
			characterEscape: T,
			characterReference: T,
			codeFenced: a(se),
			codeFencedFenceInfo: o,
			codeFencedFenceMeta: o,
			codeIndented: a(se, o),
			codeText: a(ce, o),
			codeTextData: T,
			data: T,
			codeFlowValue: T,
			definition: a(le),
			definitionDestinationString: o,
			definitionLabelString: o,
			definitionTitleString: o,
			emphasis: a(ue),
			hardBreakEscape: a(fe),
			hardBreakTrailing: a(fe),
			htmlFlow: a(pe, o),
			htmlFlowData: T,
			htmlText: a(pe, o),
			htmlTextData: T,
			image: a(me),
			label: o,
			link: a(he),
			listItem: a(_e),
			listItemValue: f,
			listOrdered: a(ge, d),
			listUnordered: a(ge),
			paragraph: a(ve),
			reference: te,
			referenceString: o,
			resourceDestinationString: o,
			resourceTitleString: o,
			setextHeading: a(de),
			strong: a(ye),
			thematicBreak: a(xe)
		},
		exit: {
			atxHeading: c(),
			atxHeadingSequence: x,
			autolink: c(),
			autolinkEmail: z,
			autolinkProtocol: ae,
			blockQuote: c(),
			characterEscapeValue: E,
			characterReferenceMarkerHexadecimal: re,
			characterReferenceMarkerNumeric: re,
			characterReferenceValue: R,
			characterReference: ie,
			codeFenced: c(g),
			codeFencedFence: h,
			codeFencedFenceInfo: p,
			codeFencedFenceMeta: m,
			codeFlowValue: E,
			codeIndented: c(_),
			codeText: c(j),
			codeTextData: E,
			data: E,
			definition: c(),
			definitionDestinationString: b,
			definitionLabelString: v,
			definitionTitleString: y,
			emphasis: c(),
			hardBreakEscape: c(O),
			hardBreakTrailing: c(O),
			htmlFlow: c(k),
			htmlFlowData: E,
			htmlText: c(A),
			htmlTextData: E,
			image: c(N),
			label: F,
			labelText: P,
			lineEnding: D,
			link: c(M),
			listItem: c(),
			listOrdered: c(),
			listUnordered: c(),
			paragraph: c(),
			referenceString: ne,
			resourceDestinationString: I,
			resourceTitleString: ee,
			resource: L,
			setextHeading: c(w),
			setextHeadingLineSequence: C,
			setextHeadingText: S,
			strong: c(),
			thematicBreak: c()
		}
	};
	L_(t, (e || {}).mdastExtensions || []);
	let n = {};
	return r;
	function r(e) {
		let r = {
			type: "root",
			children: []
		}, a = {
			stack: [r],
			tokenStack: [],
			config: t,
			enter: s,
			exit: l,
			buffer: o,
			resume: u,
			data: n
		}, c = [], d = -1;
		for (; ++d < e.length;) (e[d][1].type === "listOrdered" || e[d][1].type === "listUnordered") && (e[d][0] === "enter" ? c.push(d) : d = i(e, c.pop(), d));
		for (d = -1; ++d < e.length;) {
			let n = t[e[d][0]];
			N_.call(n, e[d][1].type) && n[e[d][1].type].call(Object.assign({ sliceSerialize: e[d][2].sliceSerialize }, a), e[d][1]);
		}
		if (a.tokenStack.length > 0) {
			let e = a.tokenStack[a.tokenStack.length - 1];
			(e[1] || z_).call(a, void 0, e[0]);
		}
		for (r.position = {
			start: I_(e.length > 0 ? e[0][1].start : {
				line: 1,
				column: 1,
				offset: 0
			}),
			end: I_(e.length > 0 ? e[e.length - 2][1].end : {
				line: 1,
				column: 1,
				offset: 0
			})
		}, d = -1; ++d < t.transforms.length;) r = t.transforms[d](r) || r;
		return r;
	}
	function i(e, t, n) {
		let r = t - 1, i = -1, a = !1, o, s, c, l;
		for (; ++r <= n;) {
			let t = e[r];
			switch (t[1].type) {
				case "listUnordered":
				case "listOrdered":
				case "blockQuote":
					t[0] === "enter" ? i++ : i--, l = void 0;
					break;
				case "lineEndingBlank":
					t[0] === "enter" && (o && !l && !i && !c && (c = r), l = void 0);
					break;
				case "linePrefix":
				case "listItemValue":
				case "listItemMarker":
				case "listItemPrefix":
				case "listItemPrefixWhitespace": break;
				default: l = void 0;
			}
			if (!i && t[0] === "enter" && t[1].type === "listItemPrefix" || i === -1 && t[0] === "exit" && (t[1].type === "listUnordered" || t[1].type === "listOrdered")) {
				if (o) {
					let i = r;
					for (s = void 0; i--;) {
						let t = e[i];
						if (t[1].type === "lineEnding" || t[1].type === "lineEndingBlank") {
							if (t[0] === "exit") continue;
							s && (e[s][1].type = "lineEndingBlank", a = !0), t[1].type = "lineEnding", s = i;
						} else if (!(t[1].type === "linePrefix" || t[1].type === "blockQuotePrefix" || t[1].type === "blockQuotePrefixWhitespace" || t[1].type === "blockQuoteMarker" || t[1].type === "listItemIndent")) break;
					}
					c && (!s || c < s) && (o._spread = !0), o.end = Object.assign({}, s ? e[s][1].start : t[1].end), e.splice(s || r, 0, [
						"exit",
						o,
						t[2]
					]), r++, n++;
				}
				if (t[1].type === "listItemPrefix") {
					let i = {
						type: "listItem",
						_spread: !1,
						start: Object.assign({}, t[1].start),
						end: void 0
					};
					o = i, e.splice(r, 0, [
						"enter",
						i,
						t[2]
					]), r++, n++, c = void 0, l = !0;
				}
			}
		}
		return e[t][1]._spread = a, n;
	}
	function a(e, t) {
		return n;
		function n(n) {
			s.call(this, e(n), n), t && t.call(this, n);
		}
	}
	function o() {
		this.stack.push({
			type: "fragment",
			children: []
		});
	}
	function s(e, t, n) {
		this.stack[this.stack.length - 1].children.push(e), this.stack.push(e), this.tokenStack.push([t, n || void 0]), e.position = {
			start: I_(t.start),
			end: void 0
		};
	}
	function c(e) {
		return t;
		function t(t) {
			e && e.call(this, t), l.call(this, t);
		}
	}
	function l(e, t) {
		let n = this.stack.pop(), r = this.tokenStack.pop();
		if (r) r[0].type !== e.type && (t ? t.call(this, e, r[0]) : (r[1] || z_).call(this, e, r[0]));
		else throw Error("Cannot close `" + e.type + "` (" + im({
			start: e.start,
			end: e.end
		}) + "): it’s not open");
		n.position.end = I_(e.end);
	}
	function u() {
		return Bm(this.stack.pop());
	}
	function d() {
		this.data.expectingFirstListItemValue = !0;
	}
	function f(e) {
		if (this.data.expectingFirstListItemValue) {
			let t = this.stack[this.stack.length - 2];
			t.start = Number.parseInt(this.sliceSerialize(e), 10), this.data.expectingFirstListItemValue = void 0;
		}
	}
	function p() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.lang = e;
	}
	function m() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.meta = e;
	}
	function h() {
		this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
	}
	function g() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.value = e.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
	}
	function _() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.value = e.replace(/(\r?\n|\r)$/g, "");
	}
	function v(e) {
		let t = this.resume(), n = this.stack[this.stack.length - 1];
		n.label = t, n.identifier = $m(this.sliceSerialize(e)).toLowerCase();
	}
	function y() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.title = e;
	}
	function b() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.url = e;
	}
	function x(e) {
		let t = this.stack[this.stack.length - 1];
		t.depth ||= this.sliceSerialize(e).length;
	}
	function S() {
		this.data.setextHeadingSlurpLineEnding = !0;
	}
	function C(e) {
		let t = this.stack[this.stack.length - 1];
		t.depth = this.sliceSerialize(e).codePointAt(0) === 61 ? 1 : 2;
	}
	function w() {
		this.data.setextHeadingSlurpLineEnding = void 0;
	}
	function T(e) {
		let t = this.stack[this.stack.length - 1].children, n = t[t.length - 1];
		(!n || n.type !== "text") && (n = be(), n.position = {
			start: I_(e.start),
			end: void 0
		}, t.push(n)), this.stack.push(n);
	}
	function E(e) {
		let t = this.stack.pop();
		t.value += this.sliceSerialize(e), t.position.end = I_(e.end);
	}
	function D(e) {
		let n = this.stack[this.stack.length - 1];
		if (this.data.atHardBreak) {
			let t = n.children[n.children.length - 1];
			t.position.end = I_(e.end), this.data.atHardBreak = void 0;
			return;
		}
		!this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(n.type) && (T.call(this, e), E.call(this, e));
	}
	function O() {
		this.data.atHardBreak = !0;
	}
	function k() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.value = e;
	}
	function A() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.value = e;
	}
	function j() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.value = e;
	}
	function M() {
		let e = this.stack[this.stack.length - 1];
		if (this.data.inReference) {
			let t = this.data.referenceType || "shortcut";
			e.type += "Reference", e.referenceType = t, delete e.url, delete e.title;
		} else delete e.identifier, delete e.label;
		this.data.referenceType = void 0;
	}
	function N() {
		let e = this.stack[this.stack.length - 1];
		if (this.data.inReference) {
			let t = this.data.referenceType || "shortcut";
			e.type += "Reference", e.referenceType = t, delete e.url, delete e.title;
		} else delete e.identifier, delete e.label;
		this.data.referenceType = void 0;
	}
	function P(e) {
		let t = this.sliceSerialize(e), n = this.stack[this.stack.length - 2];
		n.label = j_(t), n.identifier = $m(t).toLowerCase();
	}
	function F() {
		let e = this.stack[this.stack.length - 1], t = this.resume(), n = this.stack[this.stack.length - 1];
		this.data.inReference = !0, n.type === "link" ? n.children = e.children : n.alt = t;
	}
	function I() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.url = e;
	}
	function ee() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.title = e;
	}
	function L() {
		this.data.inReference = void 0;
	}
	function te() {
		this.data.referenceType = "collapsed";
	}
	function ne(e) {
		let t = this.resume(), n = this.stack[this.stack.length - 1];
		n.label = t, n.identifier = $m(this.sliceSerialize(e)).toLowerCase(), this.data.referenceType = "full";
	}
	function re(e) {
		this.data.characterReferenceType = e.type;
	}
	function R(e) {
		let t = this.sliceSerialize(e), n = this.data.characterReferenceType, r;
		n ? (r = Qm(t, n === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : r = Gm(t);
		let i = this.stack[this.stack.length - 1];
		i.value += r;
	}
	function ie(e) {
		let t = this.stack.pop();
		t.position.end = I_(e.end);
	}
	function ae(e) {
		E.call(this, e);
		let t = this.stack[this.stack.length - 1];
		t.url = this.sliceSerialize(e);
	}
	function z(e) {
		E.call(this, e);
		let t = this.stack[this.stack.length - 1];
		t.url = "mailto:" + this.sliceSerialize(e);
	}
	function oe() {
		return {
			type: "blockquote",
			children: []
		};
	}
	function se() {
		return {
			type: "code",
			lang: null,
			meta: null,
			value: ""
		};
	}
	function ce() {
		return {
			type: "inlineCode",
			value: ""
		};
	}
	function le() {
		return {
			type: "definition",
			identifier: "",
			label: null,
			title: null,
			url: ""
		};
	}
	function ue() {
		return {
			type: "emphasis",
			children: []
		};
	}
	function de() {
		return {
			type: "heading",
			depth: 0,
			children: []
		};
	}
	function fe() {
		return { type: "break" };
	}
	function pe() {
		return {
			type: "html",
			value: ""
		};
	}
	function me() {
		return {
			type: "image",
			title: null,
			url: "",
			alt: null
		};
	}
	function he() {
		return {
			type: "link",
			title: null,
			url: "",
			children: []
		};
	}
	function ge(e) {
		return {
			type: "list",
			ordered: e.type === "listOrdered",
			start: null,
			spread: e._spread,
			children: []
		};
	}
	function _e(e) {
		return {
			type: "listItem",
			spread: e._spread,
			checked: null,
			children: []
		};
	}
	function ve() {
		return {
			type: "paragraph",
			children: []
		};
	}
	function ye() {
		return {
			type: "strong",
			children: []
		};
	}
	function be() {
		return {
			type: "text",
			value: ""
		};
	}
	function xe() {
		return { type: "thematicBreak" };
	}
}
function I_(e) {
	return {
		line: e.line,
		column: e.column,
		offset: e.offset
	};
}
function L_(e, t) {
	let n = -1;
	for (; ++n < t.length;) {
		let r = t[n];
		Array.isArray(r) ? L_(e, r) : R_(e, r);
	}
}
function R_(e, t) {
	let n;
	for (n in t) if (N_.call(t, n)) switch (n) {
		case "canContainEols": {
			let r = t[n];
			r && e[n].push(...r);
			break;
		}
		case "transforms": {
			let r = t[n];
			r && e[n].push(...r);
			break;
		}
		case "enter":
		case "exit": {
			let r = t[n];
			r && Object.assign(e[n], r);
			break;
		}
	}
}
function z_(e, t) {
	throw Error(e ? "Cannot close `" + e.type + "` (" + im({
		start: e.start,
		end: e.end
	}) + "): a different token (`" + t.type + "`, " + im({
		start: t.start,
		end: t.end
	}) + ") is open" : "Cannot close document, a token (`" + t.type + "`, " + im({
		start: t.start,
		end: t.end
	}) + ") is still open");
}
//#endregion
//#region ../../../node_modules/remark-parse/lib/index.js
function B_(e) {
	let t = this;
	t.parser = n;
	function n(n) {
		return P_(n, {
			...t.data("settings"),
			...e,
			extensions: t.data("micromarkExtensions") || [],
			mdastExtensions: t.data("fromMarkdownExtensions") || []
		});
	}
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/blockquote.js
function V_(e, t) {
	let n = {
		type: "element",
		tagName: "blockquote",
		properties: {},
		children: e.wrap(e.all(t), !0)
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/break.js
function H_(e, t) {
	let n = {
		type: "element",
		tagName: "br",
		properties: {},
		children: []
	};
	return e.patch(t, n), [e.applyData(t, n), {
		type: "text",
		value: "\n"
	}];
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/code.js
function U_(e, t) {
	let n = t.value ? t.value + "\n" : "", r = {}, i = t.lang ? t.lang.split(/\s+/) : [];
	i.length > 0 && (r.className = ["language-" + i[0]]);
	let a = {
		type: "element",
		tagName: "code",
		properties: r,
		children: [{
			type: "text",
			value: n
		}]
	};
	return t.meta && (a.data = { meta: t.meta }), e.patch(t, a), a = e.applyData(t, a), a = {
		type: "element",
		tagName: "pre",
		properties: {},
		children: [a]
	}, e.patch(t, a), a;
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/delete.js
function W_(e, t) {
	let n = {
		type: "element",
		tagName: "del",
		properties: {},
		children: e.all(t)
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/emphasis.js
function G_(e, t) {
	let n = {
		type: "element",
		tagName: "em",
		properties: {},
		children: e.all(t)
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/footnote-reference.js
function K_(e, t) {
	let n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), i = ph(r.toLowerCase()), a = e.footnoteOrder.indexOf(r), o, s = e.footnoteCounts.get(r);
	s === void 0 ? (s = 0, e.footnoteOrder.push(r), o = e.footnoteOrder.length) : o = a + 1, s += 1, e.footnoteCounts.set(r, s);
	let c = {
		type: "element",
		tagName: "a",
		properties: {
			href: "#" + n + "fn-" + i,
			id: n + "fnref-" + i + (s > 1 ? "-" + s : ""),
			dataFootnoteRef: !0,
			ariaDescribedBy: ["footnote-label"]
		},
		children: [{
			type: "text",
			value: String(o)
		}]
	};
	e.patch(t, c);
	let l = {
		type: "element",
		tagName: "sup",
		properties: {},
		children: [c]
	};
	return e.patch(t, l), e.applyData(t, l);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/heading.js
function q_(e, t) {
	let n = {
		type: "element",
		tagName: "h" + t.depth,
		properties: {},
		children: e.all(t)
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/html.js
function J_(e, t) {
	if (e.options.allowDangerousHtml) {
		let n = {
			type: "raw",
			value: t.value
		};
		return e.patch(t, n), e.applyData(t, n);
	}
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/revert.js
function Y_(e, t) {
	let n = t.referenceType, r = "]";
	if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference") return [{
		type: "text",
		value: "![" + t.alt + r
	}];
	let i = e.all(t), a = i[0];
	a && a.type === "text" ? a.value = "[" + a.value : i.unshift({
		type: "text",
		value: "["
	});
	let o = i[i.length - 1];
	return o && o.type === "text" ? o.value += r : i.push({
		type: "text",
		value: r
	}), i;
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/image-reference.js
function X_(e, t) {
	let n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
	if (!r) return Y_(e, t);
	let i = {
		src: ph(r.url || ""),
		alt: t.alt
	};
	r.title !== null && r.title !== void 0 && (i.title = r.title);
	let a = {
		type: "element",
		tagName: "img",
		properties: i,
		children: []
	};
	return e.patch(t, a), e.applyData(t, a);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/image.js
function Z_(e, t) {
	let n = { src: ph(t.url) };
	t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
	let r = {
		type: "element",
		tagName: "img",
		properties: n,
		children: []
	};
	return e.patch(t, r), e.applyData(t, r);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/inline-code.js
function Q_(e, t) {
	let n = {
		type: "text",
		value: t.value.replace(/\r?\n|\r/g, " ")
	};
	e.patch(t, n);
	let r = {
		type: "element",
		tagName: "code",
		properties: {},
		children: [n]
	};
	return e.patch(t, r), e.applyData(t, r);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/link-reference.js
function $_(e, t) {
	let n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
	if (!r) return Y_(e, t);
	let i = { href: ph(r.url || "") };
	r.title !== null && r.title !== void 0 && (i.title = r.title);
	let a = {
		type: "element",
		tagName: "a",
		properties: i,
		children: e.all(t)
	};
	return e.patch(t, a), e.applyData(t, a);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/link.js
function ev(e, t) {
	let n = { href: ph(t.url) };
	t.title !== null && t.title !== void 0 && (n.title = t.title);
	let r = {
		type: "element",
		tagName: "a",
		properties: n,
		children: e.all(t)
	};
	return e.patch(t, r), e.applyData(t, r);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/list-item.js
function tv(e, t, n) {
	let r = e.all(t), i = n ? nv(n) : rv(t), a = {}, o = [];
	if (typeof t.checked == "boolean") {
		let e = r[0], n;
		e && e.type === "element" && e.tagName === "p" ? n = e : (n = {
			type: "element",
			tagName: "p",
			properties: {},
			children: []
		}, r.unshift(n)), n.children.length > 0 && n.children.unshift({
			type: "text",
			value: " "
		}), n.children.unshift({
			type: "element",
			tagName: "input",
			properties: {
				type: "checkbox",
				checked: t.checked,
				disabled: !0
			},
			children: []
		}), a.className = ["task-list-item"];
	}
	let s = -1;
	for (; ++s < r.length;) {
		let e = r[s];
		(i || s !== 0 || e.type !== "element" || e.tagName !== "p") && o.push({
			type: "text",
			value: "\n"
		}), e.type === "element" && e.tagName === "p" && !i ? o.push(...e.children) : o.push(e);
	}
	let c = r[r.length - 1];
	c && (i || c.type !== "element" || c.tagName !== "p") && o.push({
		type: "text",
		value: "\n"
	});
	let l = {
		type: "element",
		tagName: "li",
		properties: a,
		children: o
	};
	return e.patch(t, l), e.applyData(t, l);
}
function nv(e) {
	let t = !1;
	if (e.type === "list") {
		t = e.spread || !1;
		let n = e.children, r = -1;
		for (; !t && ++r < n.length;) t = rv(n[r]);
	}
	return t;
}
function rv(e) {
	return e.spread ?? e.children.length > 1;
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/list.js
function iv(e, t) {
	let n = {}, r = e.all(t), i = -1;
	for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length;) {
		let e = r[i];
		if (e.type === "element" && e.tagName === "li" && e.properties && Array.isArray(e.properties.className) && e.properties.className.includes("task-list-item")) {
			n.className = ["contains-task-list"];
			break;
		}
	}
	let a = {
		type: "element",
		tagName: t.ordered ? "ol" : "ul",
		properties: n,
		children: e.wrap(r, !0)
	};
	return e.patch(t, a), e.applyData(t, a);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/paragraph.js
function av(e, t) {
	let n = {
		type: "element",
		tagName: "p",
		properties: {},
		children: e.all(t)
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/root.js
function ov(e, t) {
	let n = {
		type: "root",
		children: e.wrap(e.all(t))
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/strong.js
function sv(e, t) {
	let n = {
		type: "element",
		tagName: "strong",
		properties: {},
		children: e.all(t)
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/table.js
function cv(e, t) {
	let n = e.all(t), r = n.shift(), i = [];
	if (r) {
		let n = {
			type: "element",
			tagName: "thead",
			properties: {},
			children: e.wrap([r], !0)
		};
		e.patch(t.children[0], n), i.push(n);
	}
	if (n.length > 0) {
		let r = {
			type: "element",
			tagName: "tbody",
			properties: {},
			children: e.wrap(n, !0)
		}, a = tm(t.children[1]), o = em(t.children[t.children.length - 1]);
		a && o && (r.position = {
			start: a,
			end: o
		}), i.push(r);
	}
	let a = {
		type: "element",
		tagName: "table",
		properties: {},
		children: e.wrap(i, !0)
	};
	return e.patch(t, a), e.applyData(t, a);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/table-row.js
function lv(e, t, n) {
	let r = n ? n.children : void 0, i = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", a = n && n.type === "table" ? n.align : void 0, o = a ? a.length : t.children.length, s = -1, c = [];
	for (; ++s < o;) {
		let n = t.children[s], r = {}, o = a ? a[s] : void 0;
		o && (r.align = o);
		let l = {
			type: "element",
			tagName: i,
			properties: r,
			children: []
		};
		n && (l.children = e.all(n), e.patch(n, l), l = e.applyData(n, l)), c.push(l);
	}
	let l = {
		type: "element",
		tagName: "tr",
		properties: {},
		children: e.wrap(c, !0)
	};
	return e.patch(t, l), e.applyData(t, l);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/table-cell.js
function uv(e, t) {
	let n = {
		type: "element",
		tagName: "td",
		properties: {},
		children: e.all(t)
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/trim-lines/index.js
var dv = 9, fv = 32;
function pv(e) {
	let t = String(e), n = /\r?\n|\r/g, r = n.exec(t), i = 0, a = [];
	for (; r;) a.push(mv(t.slice(i, r.index), i > 0, !0), r[0]), i = r.index + r[0].length, r = n.exec(t);
	return a.push(mv(t.slice(i), i > 0, !1)), a.join("");
}
function mv(e, t, n) {
	let r = 0, i = e.length;
	if (t) {
		let t = e.codePointAt(r);
		for (; t === dv || t === fv;) r++, t = e.codePointAt(r);
	}
	if (n) {
		let t = e.codePointAt(i - 1);
		for (; t === dv || t === fv;) i--, t = e.codePointAt(i - 1);
	}
	return i > r ? e.slice(r, i) : "";
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/text.js
function hv(e, t) {
	let n = {
		type: "text",
		value: pv(String(t.value))
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/thematic-break.js
function gv(e, t) {
	let n = {
		type: "element",
		tagName: "hr",
		properties: {},
		children: []
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/index.js
var _v = {
	blockquote: V_,
	break: H_,
	code: U_,
	delete: W_,
	emphasis: G_,
	footnoteReference: K_,
	heading: q_,
	html: J_,
	imageReference: X_,
	image: Z_,
	inlineCode: Q_,
	linkReference: $_,
	link: ev,
	listItem: tv,
	list: iv,
	paragraph: av,
	root: ov,
	strong: sv,
	table: cv,
	tableCell: uv,
	tableRow: lv,
	text: hv,
	thematicBreak: gv,
	toml: vv,
	yaml: vv,
	definition: vv,
	footnoteDefinition: vv
};
function vv() {}
//#endregion
//#region ../../../node_modules/@ungap/structured-clone/esm/deserialize.js
var yv = typeof self == "object" ? self : globalThis, bv = (e, t) => {
	let n = (t, n) => (e.set(n, t), t), r = (i) => {
		if (e.has(i)) return e.get(i);
		let [a, o] = t[i];
		switch (a) {
			case 0:
			case -1: return n(o, i);
			case 1: {
				let e = n([], i);
				for (let t of o) e.push(r(t));
				return e;
			}
			case 2: {
				let e = n({}, i);
				for (let [t, n] of o) e[r(t)] = r(n);
				return e;
			}
			case 3: return n(new Date(o), i);
			case 4: {
				let { source: e, flags: t } = o;
				return n(new RegExp(e, t), i);
			}
			case 5: {
				let e = n(/* @__PURE__ */ new Map(), i);
				for (let [t, n] of o) e.set(r(t), r(n));
				return e;
			}
			case 6: {
				let e = n(/* @__PURE__ */ new Set(), i);
				for (let t of o) e.add(r(t));
				return e;
			}
			case 7: {
				let { name: e, message: t } = o;
				return n(new yv[e](t), i);
			}
			case 8: return n(BigInt(o), i);
			case "BigInt": return n(Object(BigInt(o)), i);
		}
		return n(new yv[a](o), i);
	};
	return r;
}, xv = (e) => bv(/* @__PURE__ */ new Map(), e)(0), Sv = "", { toString: Cv } = {}, { keys: wv } = Object, Tv = (e) => {
	let t = typeof e;
	if (t !== "object" || !e) return [0, t];
	let n = Cv.call(e).slice(8, -1);
	switch (n) {
		case "Array": return [1, Sv];
		case "Object": return [2, Sv];
		case "Date": return [3, Sv];
		case "RegExp": return [4, Sv];
		case "Map": return [5, Sv];
		case "Set": return [6, Sv];
	}
	return n.includes("Array") ? [1, n] : n.includes("Error") ? [7, n] : [2, n];
}, Ev = ([e, t]) => e === 0 && (t === "function" || t === "symbol"), Dv = (e, t, n, r) => {
	let i = (e, t) => {
		let i = r.push(e) - 1;
		return n.set(t, i), i;
	}, a = (r) => {
		if (n.has(r)) return n.get(r);
		let [o, s] = Tv(r);
		switch (o) {
			case 0: {
				let t = r;
				switch (s) {
					case "bigint":
						o = 8, t = r.toString();
						break;
					case "function":
					case "symbol":
						if (e) throw TypeError("unable to serialize " + s);
						t = null;
						break;
					case "undefined": return i([-1], r);
				}
				return i([o, t], r);
			}
			case 1: {
				if (s) return i([s, [...r]], r);
				let e = [], t = i([o, e], r);
				for (let t of r) e.push(a(t));
				return t;
			}
			case 2: {
				if (s) switch (s) {
					case "BigInt": return i([s, r.toString()], r);
					case "Boolean":
					case "Number":
					case "String": return i([s, r.valueOf()], r);
				}
				if (t && "toJSON" in r) return a(r.toJSON());
				let n = [], c = i([o, n], r);
				for (let t of wv(r)) (e || !Ev(Tv(r[t]))) && n.push([a(t), a(r[t])]);
				return c;
			}
			case 3: return i([o, r.toISOString()], r);
			case 4: {
				let { source: e, flags: t } = r;
				return i([o, {
					source: e,
					flags: t
				}], r);
			}
			case 5: {
				let t = [], n = i([o, t], r);
				for (let [n, i] of r) (e || !(Ev(Tv(n)) || Ev(Tv(i)))) && t.push([a(n), a(i)]);
				return n;
			}
			case 6: {
				let t = [], n = i([o, t], r);
				for (let n of r) (e || !Ev(Tv(n))) && t.push(a(n));
				return n;
			}
		}
		let { message: c } = r;
		return i([o, {
			name: s,
			message: c
		}], r);
	};
	return a;
}, Ov = (e, { json: t, lossy: n } = {}) => {
	let r = [];
	return Dv(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, kv = typeof structuredClone == "function" ? (e, t) => t && ("json" in t || "lossy" in t) ? xv(Ov(e, t)) : structuredClone(e) : (e, t) => xv(Ov(e, t));
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/footer.js
function Av(e, t) {
	let n = [{
		type: "text",
		value: "↩"
	}];
	return t > 1 && n.push({
		type: "element",
		tagName: "sup",
		properties: {},
		children: [{
			type: "text",
			value: String(t)
		}]
	}), n;
}
function jv(e, t) {
	return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function Mv(e) {
	let t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || Av, r = e.options.footnoteBackLabel || jv, i = e.options.footnoteLabel || "Footnotes", a = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || { className: ["sr-only"] }, s = [], c = -1;
	for (; ++c < e.footnoteOrder.length;) {
		let i = e.footnoteById.get(e.footnoteOrder[c]);
		if (!i) continue;
		let a = e.all(i), o = String(i.identifier).toUpperCase(), l = ph(o.toLowerCase()), u = 0, d = [], f = e.footnoteCounts.get(o);
		for (; f !== void 0 && ++u <= f;) {
			d.length > 0 && d.push({
				type: "text",
				value: " "
			});
			let e = typeof n == "string" ? n : n(c, u);
			typeof e == "string" && (e = {
				type: "text",
				value: e
			}), d.push({
				type: "element",
				tagName: "a",
				properties: {
					href: "#" + t + "fnref-" + l + (u > 1 ? "-" + u : ""),
					dataFootnoteBackref: "",
					ariaLabel: typeof r == "string" ? r : r(c, u),
					className: ["data-footnote-backref"]
				},
				children: Array.isArray(e) ? e : [e]
			});
		}
		let p = a[a.length - 1];
		if (p && p.type === "element" && p.tagName === "p") {
			let e = p.children[p.children.length - 1];
			e && e.type === "text" ? e.value += " " : p.children.push({
				type: "text",
				value: " "
			}), p.children.push(...d);
		} else a.push(...d);
		let m = {
			type: "element",
			tagName: "li",
			properties: { id: t + "fn-" + l },
			children: e.wrap(a, !0)
		};
		e.patch(i, m), s.push(m);
	}
	if (s.length !== 0) return {
		type: "element",
		tagName: "section",
		properties: {
			dataFootnotes: !0,
			className: ["footnotes"]
		},
		children: [
			{
				type: "element",
				tagName: a,
				properties: {
					...kv(o),
					id: "footnote-label"
				},
				children: [{
					type: "text",
					value: i
				}]
			},
			{
				type: "text",
				value: "\n"
			},
			{
				type: "element",
				tagName: "ol",
				properties: {},
				children: e.wrap(s, !0)
			},
			{
				type: "text",
				value: "\n"
			}
		]
	};
}
//#endregion
//#region ../../../node_modules/unist-util-is/lib/index.js
var Nv = (function(e) {
	if (e == null) return Rv;
	if (typeof e == "function") return Lv(e);
	if (typeof e == "object") return Array.isArray(e) ? Pv(e) : Fv(e);
	if (typeof e == "string") return Iv(e);
	throw Error("Expected function, string, or object as test");
});
function Pv(e) {
	let t = [], n = -1;
	for (; ++n < e.length;) t[n] = Nv(e[n]);
	return Lv(r);
	function r(...e) {
		let n = -1;
		for (; ++n < t.length;) if (t[n].apply(this, e)) return !0;
		return !1;
	}
}
function Fv(e) {
	let t = e;
	return Lv(n);
	function n(n) {
		let r = n, i;
		for (i in e) if (r[i] !== t[i]) return !1;
		return !0;
	}
}
function Iv(e) {
	return Lv(t);
	function t(t) {
		return t && t.type === e;
	}
}
function Lv(e) {
	return t;
	function t(t, n, r) {
		return !!(zv(t) && e.call(this, t, typeof n == "number" ? n : void 0, r || void 0));
	}
}
function Rv() {
	return !0;
}
function zv(e) {
	return typeof e == "object" && !!e && "type" in e;
}
//#endregion
//#region ../../../node_modules/unist-util-visit-parents/lib/color.js
function Bv(e) {
	return e;
}
//#endregion
//#region ../../../node_modules/unist-util-visit-parents/lib/index.js
var Vv = [];
function Hv(e, t, n, r) {
	let i;
	typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
	let a = Nv(i), o = r ? -1 : 1;
	s(e, void 0, [])();
	function s(e, i, c) {
		let l = e && typeof e == "object" ? e : {};
		if (typeof l.type == "string") {
			let t = typeof l.tagName == "string" ? l.tagName : typeof l.name == "string" ? l.name : void 0;
			Object.defineProperty(u, "name", { value: "node (" + Bv(e.type + (t ? "<" + t + ">" : "")) + ")" });
		}
		return u;
		function u() {
			let l = Vv, u, d, f;
			if ((!t || a(e, i, c[c.length - 1] || void 0)) && (l = Uv(n(e, c)), l[0] === !1)) return l;
			if ("children" in e && e.children) {
				let t = e;
				if (t.children && l[0] !== "skip") for (d = (r ? t.children.length : -1) + o, f = c.concat(t); d > -1 && d < t.children.length;) {
					let e = t.children[d];
					if (u = s(e, d, f)(), u[0] === !1) return u;
					d = typeof u[1] == "number" ? u[1] : d + o;
				}
			}
			return l;
		}
	}
}
function Uv(e) {
	return Array.isArray(e) ? e : typeof e == "number" ? [!0, e] : e == null ? Vv : [e];
}
//#endregion
//#region ../../../node_modules/unist-util-visit/lib/index.js
function Wv(e, t, n, r) {
	let i, a, o;
	typeof t == "function" && typeof n != "function" ? (a = void 0, o = t, i = n) : (a = t, o = n, i = r), Hv(e, a, s, i);
	function s(e, t) {
		let n = t[t.length - 1], r = n ? n.children.indexOf(e) : void 0;
		return o(e, r, n);
	}
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/state.js
var Gv = {}.hasOwnProperty, Kv = {};
function qv(e, t) {
	let n = t || Kv, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = {
		all: s,
		applyData: Yv,
		definitionById: r,
		footnoteById: i,
		footnoteCounts: /* @__PURE__ */ new Map(),
		footnoteOrder: [],
		handlers: {
			..._v,
			...n.handlers
		},
		one: o,
		options: n,
		patch: Jv,
		wrap: Zv
	};
	return Wv(e, function(e) {
		if (e.type === "definition" || e.type === "footnoteDefinition") {
			let t = e.type === "definition" ? r : i, n = String(e.identifier).toUpperCase();
			t.has(n) || t.set(n, e);
		}
	}), a;
	function o(e, t) {
		let n = e.type, r = a.handlers[n];
		if (Gv.call(a.handlers, n) && r) return r(a, e, t);
		if (a.options.passThrough && a.options.passThrough.includes(n)) {
			if ("children" in e) {
				let { children: t, ...n } = e, r = kv(n);
				return r.children = a.all(e), r;
			}
			return kv(e);
		}
		return (a.options.unknownHandler || Xv)(a, e, t);
	}
	function s(e) {
		let t = [];
		if ("children" in e) {
			let n = e.children, r = -1;
			for (; ++r < n.length;) {
				let i = a.one(n[r], e);
				if (i) {
					if (r && n[r - 1].type === "break" && (!Array.isArray(i) && i.type === "text" && (i.value = Qv(i.value)), !Array.isArray(i) && i.type === "element")) {
						let e = i.children[0];
						e && e.type === "text" && (e.value = Qv(e.value));
					}
					Array.isArray(i) ? t.push(...i) : t.push(i);
				}
			}
		}
		return t;
	}
}
function Jv(e, t) {
	e.position && (t.position = rm(e));
}
function Yv(e, t) {
	let n = t;
	if (e && e.data) {
		let t = e.data.hName, r = e.data.hChildren, i = e.data.hProperties;
		typeof t == "string" && (n.type === "element" ? n.tagName = t : n = {
			type: "element",
			tagName: t,
			properties: {},
			children: "children" in n ? n.children : [n]
		}), n.type === "element" && i && Object.assign(n.properties, kv(i)), "children" in n && n.children && r != null && (n.children = r);
	}
	return n;
}
function Xv(e, t) {
	let n = t.data || {}, r = "value" in t && !(Gv.call(n, "hProperties") || Gv.call(n, "hChildren")) ? {
		type: "text",
		value: t.value
	} : {
		type: "element",
		tagName: "div",
		properties: {},
		children: e.all(t)
	};
	return e.patch(t, r), e.applyData(t, r);
}
function Zv(e, t) {
	let n = [], r = -1;
	for (t && n.push({
		type: "text",
		value: "\n"
	}); ++r < e.length;) r && n.push({
		type: "text",
		value: "\n"
	}), n.push(e[r]);
	return t && e.length > 0 && n.push({
		type: "text",
		value: "\n"
	}), n;
}
function Qv(e) {
	let t = 0, n = e.charCodeAt(t);
	for (; n === 9 || n === 32;) t++, n = e.charCodeAt(t);
	return e.slice(t);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/index.js
function $v(e, t) {
	let n = qv(e, t), r = n.one(e, void 0), i = Mv(n), a = Array.isArray(r) ? {
		type: "root",
		children: r
	} : r || {
		type: "root",
		children: []
	};
	return i && ("children" in a, a.children.push({
		type: "text",
		value: "\n"
	}, i)), a;
}
//#endregion
//#region ../../../node_modules/remark-rehype/lib/index.js
function ey(e, t) {
	return e && "run" in e ? async function(n, r) {
		let i = $v(n, {
			file: r,
			...t
		});
		await e.run(i, r);
	} : function(n, r) {
		return $v(n, {
			file: r,
			...e || t
		});
	};
}
//#endregion
//#region ../../../node_modules/bail/index.js
function ty(e) {
	if (e) throw e;
}
//#endregion
//#region ../../../node_modules/extend/index.js
var ny = /* @__PURE__ */ Tt(((e, t) => {
	var n = Object.prototype.hasOwnProperty, r = Object.prototype.toString, i = Object.defineProperty, a = Object.getOwnPropertyDescriptor, o = function(e) {
		return typeof Array.isArray == "function" ? Array.isArray(e) : r.call(e) === "[object Array]";
	}, s = function(e) {
		if (!e || r.call(e) !== "[object Object]") return !1;
		var t = n.call(e, "constructor"), i = e.constructor && e.constructor.prototype && n.call(e.constructor.prototype, "isPrototypeOf");
		if (e.constructor && !t && !i) return !1;
		for (var a in e);
		return a === void 0 || n.call(e, a);
	}, c = function(e, t) {
		i && t.name === "__proto__" ? i(e, t.name, {
			enumerable: !0,
			configurable: !0,
			value: t.newValue,
			writable: !0
		}) : e[t.name] = t.newValue;
	}, l = function(e, t) {
		if (t === "__proto__") {
			if (!n.call(e, t)) return;
			if (a) return a(e, t).value;
		}
		return e[t];
	};
	t.exports = function e() {
		var t, n, r, i, a, u, d = arguments[0], f = 1, p = arguments.length, m = !1;
		for (typeof d == "boolean" && (m = d, d = arguments[1] || {}, f = 2), (d == null || typeof d != "object" && typeof d != "function") && (d = {}); f < p; ++f) if (t = arguments[f], t != null) for (n in t) r = l(d, n), i = l(t, n), d !== i && (m && i && (s(i) || (a = o(i))) ? (a ? (a = !1, u = r && o(r) ? r : []) : u = r && s(r) ? r : {}, c(d, {
			name: n,
			newValue: e(m, u, i)
		})) : i !== void 0 && c(d, {
			name: n,
			newValue: i
		}));
		return d;
	};
}));
//#endregion
//#region ../../../node_modules/is-plain-obj/index.js
function ry(e) {
	if (typeof e != "object" || !e) return !1;
	let t = Object.getPrototypeOf(e);
	return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
//#endregion
//#region ../../../node_modules/trough/index.js
function iy() {
	let e = [], t = {
		run: n,
		use: r
	};
	return t;
	function n(...t) {
		let n = -1, r = t.pop();
		if (typeof r != "function") throw TypeError("Expected function as last argument, not " + r);
		i(null, ...t);
		function i(a, ...o) {
			let s = e[++n], c = -1;
			if (a) {
				r(a);
				return;
			}
			for (; ++c < t.length;) (o[c] === null || o[c] === void 0) && (o[c] = t[c]);
			t = o, s ? ay(s, i)(...o) : r(null, ...o);
		}
	}
	function r(n) {
		if (typeof n != "function") throw TypeError("Expected `middelware` to be a function, not " + n);
		return e.push(n), t;
	}
}
function ay(e, t) {
	let n;
	return r;
	function r(...t) {
		let r = e.length > t.length, o;
		r && t.push(i);
		try {
			o = e.apply(this, t);
		} catch (e) {
			let t = e;
			if (r && n) throw t;
			return i(t);
		}
		r || (o instanceof Promise ? o.then(a, i) : o instanceof Error ? i(o) : a(o));
	}
	function i(e, ...r) {
		n || (n = !0, t(e, ...r));
	}
	function a(e) {
		i(null, e);
	}
}
//#endregion
//#region ../../../node_modules/vfile/lib/minpath.browser.js
var oy = {
	basename: sy,
	dirname: cy,
	extname: ly,
	join: uy,
	sep: "/"
};
function sy(e, t) {
	if (t !== void 0 && typeof t != "string") throw TypeError("\"ext\" argument must be a string");
	py(e);
	let n = 0, r = -1, i = e.length, a;
	if (t === void 0 || t.length === 0 || t.length > e.length) {
		for (; i--;) if (e.codePointAt(i) === 47) {
			if (a) {
				n = i + 1;
				break;
			}
		} else r < 0 && (a = !0, r = i + 1);
		return r < 0 ? "" : e.slice(n, r);
	}
	if (t === e) return "";
	let o = -1, s = t.length - 1;
	for (; i--;) if (e.codePointAt(i) === 47) {
		if (a) {
			n = i + 1;
			break;
		}
	} else o < 0 && (a = !0, o = i + 1), s > -1 && (e.codePointAt(i) === t.codePointAt(s--) ? s < 0 && (r = i) : (s = -1, r = o));
	return n === r ? r = o : r < 0 && (r = e.length), e.slice(n, r);
}
function cy(e) {
	if (py(e), e.length === 0) return ".";
	let t = -1, n = e.length, r;
	for (; --n;) if (e.codePointAt(n) === 47) {
		if (r) {
			t = n;
			break;
		}
	} else r ||= !0;
	return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function ly(e) {
	py(e);
	let t = e.length, n = -1, r = 0, i = -1, a = 0, o;
	for (; t--;) {
		let s = e.codePointAt(t);
		if (s === 47) {
			if (o) {
				r = t + 1;
				break;
			}
			continue;
		}
		n < 0 && (o = !0, n = t + 1), s === 46 ? i < 0 ? i = t : a !== 1 && (a = 1) : i > -1 && (a = -1);
	}
	return i < 0 || n < 0 || a === 0 || a === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function uy(...e) {
	let t = -1, n;
	for (; ++t < e.length;) py(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
	return n === void 0 ? "." : dy(n);
}
function dy(e) {
	py(e);
	let t = e.codePointAt(0) === 47, n = fy(e, !t);
	return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function fy(e, t) {
	let n = "", r = 0, i = -1, a = 0, o = -1, s, c;
	for (; ++o <= e.length;) {
		if (o < e.length) s = e.codePointAt(o);
		else if (s === 47) break;
		else s = 47;
		if (s === 47) {
			if (!(i === o - 1 || a === 1)) if (i !== o - 1 && a === 2) {
				if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
					if (n.length > 2) {
						if (c = n.lastIndexOf("/"), c !== n.length - 1) {
							c < 0 ? (n = "", r = 0) : (n = n.slice(0, c), r = n.length - 1 - n.lastIndexOf("/")), i = o, a = 0;
							continue;
						}
					} else if (n.length > 0) {
						n = "", r = 0, i = o, a = 0;
						continue;
					}
				}
				t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
			} else n.length > 0 ? n += "/" + e.slice(i + 1, o) : n = e.slice(i + 1, o), r = o - i - 1;
			i = o, a = 0;
		} else s === 46 && a > -1 ? a++ : a = -1;
	}
	return n;
}
function py(e) {
	if (typeof e != "string") throw TypeError("Path must be a string. Received " + JSON.stringify(e));
}
//#endregion
//#region ../../../node_modules/vfile/lib/minproc.browser.js
var my = { cwd: hy };
function hy() {
	return "/";
}
//#endregion
//#region ../../../node_modules/vfile/lib/minurl.shared.js
function gy(e) {
	return !!(typeof e == "object" && e && "href" in e && e.href && "protocol" in e && e.protocol && e.auth === void 0);
}
//#endregion
//#region ../../../node_modules/vfile/lib/minurl.browser.js
function _y(e) {
	if (typeof e == "string") e = new URL(e);
	else if (!gy(e)) {
		let t = /* @__PURE__ */ TypeError("The \"path\" argument must be of type string or an instance of URL. Received `" + e + "`");
		throw t.code = "ERR_INVALID_ARG_TYPE", t;
	}
	if (e.protocol !== "file:") {
		let e = /* @__PURE__ */ TypeError("The URL must be of scheme file");
		throw e.code = "ERR_INVALID_URL_SCHEME", e;
	}
	return vy(e);
}
function vy(e) {
	if (e.hostname !== "") {
		let e = /* @__PURE__ */ TypeError("File URL host must be \"localhost\" or empty on darwin");
		throw e.code = "ERR_INVALID_FILE_URL_HOST", e;
	}
	let t = e.pathname, n = -1;
	for (; ++n < t.length;) if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
		let e = t.codePointAt(n + 2);
		if (e === 70 || e === 102) {
			let e = /* @__PURE__ */ TypeError("File URL path must not include encoded / characters");
			throw e.code = "ERR_INVALID_FILE_URL_PATH", e;
		}
	}
	return decodeURIComponent(t);
}
//#endregion
//#region ../../../node_modules/vfile/lib/index.js
var yy = [
	"history",
	"path",
	"basename",
	"stem",
	"extname",
	"dirname"
], by = class {
	constructor(e) {
		let t;
		t = e ? gy(e) ? { path: e } : typeof e == "string" || wy(e) ? { value: e } : e : {}, this.cwd = "cwd" in t ? "" : my.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
		let n = -1;
		for (; ++n < yy.length;) {
			let e = yy[n];
			e in t && t[e] !== void 0 && t[e] !== null && (this[e] = e === "history" ? [...t[e]] : t[e]);
		}
		let r;
		for (r in t) yy.includes(r) || (this[r] = t[r]);
	}
	get basename() {
		return typeof this.path == "string" ? oy.basename(this.path) : void 0;
	}
	set basename(e) {
		Sy(e, "basename"), xy(e, "basename"), this.path = oy.join(this.dirname || "", e);
	}
	get dirname() {
		return typeof this.path == "string" ? oy.dirname(this.path) : void 0;
	}
	set dirname(e) {
		Cy(this.basename, "dirname"), this.path = oy.join(e || "", this.basename);
	}
	get extname() {
		return typeof this.path == "string" ? oy.extname(this.path) : void 0;
	}
	set extname(e) {
		if (xy(e, "extname"), Cy(this.dirname, "extname"), e) {
			if (e.codePointAt(0) !== 46) throw Error("`extname` must start with `.`");
			if (e.includes(".", 1)) throw Error("`extname` cannot contain multiple dots");
		}
		this.path = oy.join(this.dirname, this.stem + (e || ""));
	}
	get path() {
		return this.history[this.history.length - 1];
	}
	set path(e) {
		gy(e) && (e = _y(e)), Sy(e, "path"), this.path !== e && this.history.push(e);
	}
	get stem() {
		return typeof this.path == "string" ? oy.basename(this.path, this.extname) : void 0;
	}
	set stem(e) {
		Sy(e, "stem"), xy(e, "stem"), this.path = oy.join(this.dirname || "", e + (this.extname || ""));
	}
	fail(e, t, n) {
		let r = this.message(e, t, n);
		throw r.fatal = !0, r;
	}
	info(e, t, n) {
		let r = this.message(e, t, n);
		return r.fatal = void 0, r;
	}
	message(e, t, n) {
		let r = new cm(e, t, n);
		return this.path && (r.name = this.path + ":" + r.name, r.file = this.path), r.fatal = !1, this.messages.push(r), r;
	}
	toString(e) {
		return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(e || void 0).decode(this.value);
	}
};
function xy(e, t) {
	if (e && e.includes(oy.sep)) throw Error("`" + t + "` cannot be a path: did not expect `" + oy.sep + "`");
}
function Sy(e, t) {
	if (!e) throw Error("`" + t + "` cannot be empty");
}
function Cy(e, t) {
	if (!e) throw Error("Setting `" + t + "` requires `path` to be set too");
}
function wy(e) {
	return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
//#endregion
//#region ../../../node_modules/unified/lib/callable-instance.js
var Ty = (function(e) {
	let t = this.constructor.prototype, n = t[e], r = function() {
		return n.apply(r, arguments);
	};
	return Object.setPrototypeOf(r, t), r;
}), Ey = /* @__PURE__ */ Ot(ny()), Dy = {}.hasOwnProperty, Oy = new class e extends Ty {
	constructor() {
		super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = iy();
	}
	copy() {
		let t = new e(), n = -1;
		for (; ++n < this.attachers.length;) {
			let e = this.attachers[n];
			t.use(...e);
		}
		return t.data((0, Ey.default)(!0, {}, this.namespace)), t;
	}
	data(e, t) {
		return typeof e == "string" ? arguments.length === 2 ? (jy("data", this.frozen), this.namespace[e] = t, this) : Dy.call(this.namespace, e) && this.namespace[e] || void 0 : e ? (jy("data", this.frozen), this.namespace = e, this) : this.namespace;
	}
	freeze() {
		if (this.frozen) return this;
		let e = this;
		for (; ++this.freezeIndex < this.attachers.length;) {
			let [t, ...n] = this.attachers[this.freezeIndex];
			if (n[0] === !1) continue;
			n[0] === !0 && (n[0] = void 0);
			let r = t.call(e, ...n);
			typeof r == "function" && this.transformers.use(r);
		}
		return this.frozen = !0, this.freezeIndex = Infinity, this;
	}
	parse(e) {
		this.freeze();
		let t = Py(e), n = this.parser || this.Parser;
		return ky("parse", n), n(String(t), t);
	}
	process(e, t) {
		let n = this;
		return this.freeze(), ky("process", this.parser || this.Parser), Ay("process", this.compiler || this.Compiler), t ? r(void 0, t) : new Promise(r);
		function r(r, i) {
			let a = Py(e), o = n.parse(a);
			n.run(o, a, function(e, t, r) {
				if (e || !t || !r) return s(e);
				let i = t, a = n.stringify(i, r);
				Iy(a) ? r.value = a : r.result = a, s(e, r);
			});
			function s(e, n) {
				e || !n ? i(e) : r ? r(n) : t(void 0, n);
			}
		}
	}
	processSync(e) {
		let t = !1, n;
		return this.freeze(), ky("processSync", this.parser || this.Parser), Ay("processSync", this.compiler || this.Compiler), this.process(e, r), Ny("processSync", "process", t), n;
		function r(e, r) {
			t = !0, ty(e), n = r;
		}
	}
	run(e, t, n) {
		My(e), this.freeze();
		let r = this.transformers;
		return !n && typeof t == "function" && (n = t, t = void 0), n ? i(void 0, n) : new Promise(i);
		function i(i, a) {
			let o = Py(t);
			r.run(e, o, s);
			function s(t, r, o) {
				let s = r || e;
				t ? a(t) : i ? i(s) : n(void 0, s, o);
			}
		}
	}
	runSync(e, t) {
		let n = !1, r;
		return this.run(e, t, i), Ny("runSync", "run", n), r;
		function i(e, t) {
			ty(e), r = t, n = !0;
		}
	}
	stringify(e, t) {
		this.freeze();
		let n = Py(t), r = this.compiler || this.Compiler;
		return Ay("stringify", r), My(e), r(e, n);
	}
	use(e, ...t) {
		let n = this.attachers, r = this.namespace;
		if (jy("use", this.frozen), e != null) if (typeof e == "function") s(e, t);
		else if (typeof e == "object") Array.isArray(e) ? o(e) : a(e);
		else throw TypeError("Expected usable value, not `" + e + "`");
		return this;
		function i(e) {
			if (typeof e == "function") s(e, []);
			else if (typeof e == "object") if (Array.isArray(e)) {
				let [t, ...n] = e;
				s(t, n);
			} else a(e);
			else throw TypeError("Expected usable value, not `" + e + "`");
		}
		function a(e) {
			if (!("plugins" in e) && !("settings" in e)) throw Error("Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither");
			o(e.plugins), e.settings && (r.settings = (0, Ey.default)(!0, r.settings, e.settings));
		}
		function o(e) {
			let t = -1;
			if (e != null) if (Array.isArray(e)) for (; ++t < e.length;) {
				let n = e[t];
				i(n);
			}
			else throw TypeError("Expected a list of plugins, not `" + e + "`");
		}
		function s(e, t) {
			let r = -1, i = -1;
			for (; ++r < n.length;) if (n[r][0] === e) {
				i = r;
				break;
			}
			if (i === -1) n.push([e, ...t]);
			else if (t.length > 0) {
				let [r, ...a] = t, o = n[i][1];
				ry(o) && ry(r) && (r = (0, Ey.default)(!0, o, r)), n[i] = [
					e,
					r,
					...a
				];
			}
		}
	}
}().freeze();
function ky(e, t) {
	if (typeof t != "function") throw TypeError("Cannot `" + e + "` without `parser`");
}
function Ay(e, t) {
	if (typeof t != "function") throw TypeError("Cannot `" + e + "` without `compiler`");
}
function jy(e, t) {
	if (t) throw Error("Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
function My(e) {
	if (!ry(e) || typeof e.type != "string") throw TypeError("Expected node, got `" + e + "`");
}
function Ny(e, t, n) {
	if (!n) throw Error("`" + e + "` finished async. Use `" + t + "` instead");
}
function Py(e) {
	return Fy(e) ? e : new by(e);
}
function Fy(e) {
	return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function Iy(e) {
	return typeof e == "string" || Ly(e);
}
function Ly(e) {
	return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
//#endregion
//#region ../../../node_modules/react-markdown/lib/index.js
var Ry = [], zy = { allowDangerousHtml: !0 }, By = /^(https?|ircs?|mailto|xmpp)$/i, Vy = [
	{
		from: "astPlugins",
		id: "remove-buggy-html-in-markdown-parser"
	},
	{
		from: "allowDangerousHtml",
		id: "remove-buggy-html-in-markdown-parser"
	},
	{
		from: "allowNode",
		id: "replace-allownode-allowedtypes-and-disallowedtypes",
		to: "allowElement"
	},
	{
		from: "allowedTypes",
		id: "replace-allownode-allowedtypes-and-disallowedtypes",
		to: "allowedElements"
	},
	{
		from: "disallowedTypes",
		id: "replace-allownode-allowedtypes-and-disallowedtypes",
		to: "disallowedElements"
	},
	{
		from: "escapeHtml",
		id: "remove-buggy-html-in-markdown-parser"
	},
	{
		from: "includeElementIndex",
		id: "#remove-includeelementindex"
	},
	{
		from: "includeNodeIndex",
		id: "change-includenodeindex-to-includeelementindex"
	},
	{
		from: "linkTarget",
		id: "remove-linktarget"
	},
	{
		from: "plugins",
		id: "change-plugins-to-remarkplugins",
		to: "remarkPlugins"
	},
	{
		from: "rawSourcePos",
		id: "#remove-rawsourcepos"
	},
	{
		from: "renderers",
		id: "change-renderers-to-components",
		to: "components"
	},
	{
		from: "source",
		id: "change-source-to-children",
		to: "children"
	},
	{
		from: "sourcePos",
		id: "#remove-sourcepos"
	},
	{
		from: "transformImageUri",
		id: "#add-urltransform",
		to: "urlTransform"
	},
	{
		from: "transformLinkUri",
		id: "#add-urltransform",
		to: "urlTransform"
	}
];
function Hy(e) {
	let t = e.allowedElements, n = e.allowElement, r = e.children || "", i = e.className, a = e.components, o = e.disallowedElements, s = e.rehypePlugins || Ry, c = e.remarkPlugins || Ry, l = e.remarkRehypeOptions ? {
		...e.remarkRehypeOptions,
		...zy
	} : zy, u = e.skipHtml, d = e.unwrapDisallowed, f = e.urlTransform || Uy, p = Oy().use(B_).use(c).use(ey, l).use(s), m = new by();
	typeof r == "string" ? m.value = r : "" + r;
	for (let t of Vy) Object.hasOwn(e, t.from) && "" + t.from + (t.to ? "use `" + t.to + "` instead" : "remove it") + t.id;
	let h = p.parse(m), g = p.runSync(h, m);
	return i && (g = {
		type: "element",
		tagName: "div",
		properties: { className: i },
		children: g.type === "root" ? g.children : [g]
	}), Wv(g, _), hm(g, {
		Fragment: G,
		components: a,
		ignoreInvalidStyle: !0,
		jsx: K,
		jsxs: q,
		passKeys: !0,
		passNode: !0
	});
	function _(e, r, i) {
		if (e.type === "raw" && i && typeof r == "number") return u ? i.children.splice(r, 1) : i.children[r] = {
			type: "text",
			value: e.value
		}, r;
		if (e.type === "element") {
			let t;
			for (t in Rm) if (Object.hasOwn(Rm, t) && Object.hasOwn(e.properties, t)) {
				let n = e.properties[t], r = Rm[t];
				(r === null || r.includes(e.tagName)) && (e.properties[t] = f(String(n || ""), t, e));
			}
		}
		if (e.type === "element") {
			let a = t ? !t.includes(e.tagName) : o ? o.includes(e.tagName) : !1;
			if (!a && n && typeof r == "number" && (a = !n(e, r, i)), a && i && typeof r == "number") return d && e.children ? i.children.splice(r, 1, ...e.children) : i.children.splice(r, 1), r;
		}
	}
}
function Uy(e) {
	let t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
	return t < 0 || i > -1 && t > i || n > -1 && t > n || r > -1 && t > r || By.test(e.slice(0, t)) ? e : "";
}
//#endregion
//#region ../widget-linear/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;position:relative;overflow:hidden}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:\"\";background:linear-gradient(#fff0 0%,#ffffff01 1.8%,#ffffff02 4.8%,#ffffff05 9%,#ffffff0b 13.9%,#ffffff13 19.8%,#ffffff20 27%,#ffffff31 35%,#ffffff47 43.5%,#ffffff61 53%,#ffffff8a 66%,#ffffffbc 81%,#fff 100%);position:absolute;bottom:0;left:0}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;text-overflow:ellipsis;color:var(--dixa-color-neutral-600);overflow:hidden}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500);position:absolute}._loader_13xpk_1{width:100%;padding:var(--dixa-size-spacer-200);justify-content:center;display:flex}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);box-sizing:border-box;gap:var(--dixa-size-spacer-100);background-color:#0000;width:100%}._collapseHeader_su0f9_8>div:first-of-type{padding-right:var(--dixa-size-spacer-300);width:100%;padding:0!important}._collapseHeader_su0f9_8>div>div:first-of-type{width:100%;padding:0!important}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{margin:0;white-space:unset!important}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);flex-direction:row;display:flex}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{align-items:center;display:flex}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{gap:var(--dixa-size-spacer-100);display:flex}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var Wy = {
	"\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "createIssue"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "issueTitle"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "issueDescription"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "teamId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "projectId"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "statusId"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "priority"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Linear"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "issueCreate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "ObjectValue",
									fields: [
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "title"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "issueTitle"
												}
											}
										},
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "description"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "issueDescription"
												}
											}
										},
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "teamId"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "teamId"
												}
											}
										},
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "projectId"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "projectId"
												}
											}
										},
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "stateId"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "statusId"
												}
											}
										},
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "priority"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "priority"
												}
											}
										}
									]
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "success"
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "issue"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "title"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "identifier"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "url"
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "staticData"
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Linear"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "teams"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "edges"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "node"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "organization"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "urlKey"
																	}
																}]
															}
														}
													]
												}
											}]
										}
									}]
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "issuePriorityValues"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "priority"
										}
									}, {
										kind: "Field",
										name: {
											kind: "Name",
											value: "label"
										}
									}]
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "organization"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "urlKey"
										}
									}]
								}
							}
						]
					}
				}]
			}
		}]
	},
	"\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "teamData"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "teamId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Linear"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "team"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "teamId"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "projects"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "edges"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "node"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "id"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}]
														}
													}]
												}
											}]
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "states"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "edges"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "node"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "type"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "color"
																	}
																}
															]
														}
													}]
												}
											}]
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "templates"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "edges"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "node"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "type"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "templateData"
																	}
																}
															]
														}
													}]
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "searchIssues"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "issueQuery"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "after"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "first"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Linear"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "searchIssues"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "first"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "first"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "after"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "after"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "term"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "issueQuery"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "edges"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "node"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "description"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "identifier"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "priority"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "priorityLabel"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "url"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "state"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "type"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "color"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "assignee"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "displayName"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "avatarUrl"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "email"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "labels"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "edges"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "node"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "id"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "name"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "color"
																					}
																				}
																			]
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "team"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "organization"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "urlKey"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "project"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "id"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}]
														}
													}
												]
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "pageInfo"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "hasNextPage"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "endCursor"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "searchLinkedIssues"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "linkedIssues"
					}
				},
				type: {
					kind: "ListType",
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "ID"
							}
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Linear"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "issues"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "filter"
								},
								value: {
									kind: "ObjectValue",
									fields: [{
										kind: "ObjectField",
										name: {
											kind: "Name",
											value: "id"
										},
										value: {
											kind: "ObjectValue",
											fields: [{
												kind: "ObjectField",
												name: {
													kind: "Name",
													value: "in"
												},
												value: {
													kind: "Variable",
													name: {
														kind: "Name",
														value: "linkedIssues"
													}
												}
											}]
										}
									}]
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "edges"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "node"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "description"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "identifier"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "priority"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "priorityLabel"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "url"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "state"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "type"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "color"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "assignee"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "displayName"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "avatarUrl"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "email"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "labels"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "edges"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "node"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "id"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "name"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "color"
																					}
																				}
																			]
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "team"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "organization"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "urlKey"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "project"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "id"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	}
};
function Gy(e) {
	return Wy[e] ?? {};
}
var Ky = Gy("\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n"), qy = Gy("\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n"), Jy = ({ title: e, children: t }) => /* @__PURE__ */ q(_, {
	flexDirection: "column",
	gap: "100",
	children: [/* @__PURE__ */ K(L.Paragraph, {
		variant: "5",
		color: "neutral.500",
		children: e
	}), t]
}), Yy = {
	issueAvatar: "_issueAvatar_kc0sw_1",
	issueField: "_issueField_kc0sw_9",
	issueDescription: "_issueDescription_kc0sw_12"
}, Xy = ({ issue: e }) => /* @__PURE__ */ q(G, { children: [
	/* @__PURE__ */ K(Jy, {
		title: "Assignee",
		children: /* @__PURE__ */ q(_, {
			gap: "200",
			flexDirection: "row",
			alignContent: "center",
			className: Yy.issueAvatar,
			children: [/* @__PURE__ */ K(t, {
				size: "24",
				user: e.assignee ? {
					name: e.assignee.name || null,
					avatar_url: e.assignee.avatarUrl || null,
					email: e.assignee.email
				} : void 0
			}), /* @__PURE__ */ K(L.Heading, {
				variant: "heading-4",
				children: e.assignee ? e.assignee.name : "Unassigned"
			})]
		})
	}),
	e.team?.name && /* @__PURE__ */ K(Jy, {
		title: "Team",
		children: /* @__PURE__ */ K(L.Paragraph, {
			variant: "3",
			color: "neutral.800",
			className: Yy.issueField,
			children: e.team.name
		})
	}),
	e.project?.name && /* @__PURE__ */ K(Jy, {
		title: "Project",
		children: /* @__PURE__ */ K(L.Paragraph, {
			variant: "3",
			color: "neutral.800",
			className: Yy.issueField,
			children: e.project.name
		})
	}),
	/* @__PURE__ */ K(Jy, {
		title: "Description",
		children: /* @__PURE__ */ K(Hy, {
			className: Yy.issueDescription,
			children: e.description
		})
	})
] }), Zy = {
	0: /* @__PURE__ */ q("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "var(--dixa-color-neutral-500)",
		width: "16",
		height: "16",
		viewBox: "0 0 16 16",
		"aria-label": "No Priority",
		"data-testid": "noPriorityIcon",
		children: [
			/* @__PURE__ */ K("rect", {
				width: "2",
				height: "2",
				rx: "1",
				transform: "matrix(-1 0 0 1 5 7)"
			}),
			/* @__PURE__ */ K("rect", {
				width: "2",
				height: "2",
				rx: "1",
				transform: "matrix(-1 0 0 1 8 7)"
			}),
			/* @__PURE__ */ K("rect", {
				width: "2",
				height: "2",
				rx: "1",
				transform: "matrix(-1 0 0 1 11 7)"
			})
		]
	}),
	1: /* @__PURE__ */ K("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "16",
		height: "16",
		viewBox: "-1 -1 15 15",
		"aria-label": "Urgent Priority",
		fill: "var(--dixa-color-orange-400)",
		children: /* @__PURE__ */ K("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
		})
	}),
	2: /* @__PURE__ */ q("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "var(--dixa-color-neutral-500)",
		width: "16",
		height: "16",
		viewBox: "0 0 16 16",
		"aria-label": "High Priority",
		children: [
			/* @__PURE__ */ K("rect", {
				x: "1",
				y: "8",
				width: "3",
				height: "6",
				rx: "1"
			}),
			/* @__PURE__ */ K("rect", {
				x: "6",
				y: "5",
				width: "3",
				height: "9",
				rx: "1"
			}),
			/* @__PURE__ */ K("rect", {
				x: "11",
				y: "2",
				width: "3",
				height: "12",
				rx: "1"
			})
		]
	}),
	3: /* @__PURE__ */ q("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "var(--dixa-color-neutral-500)",
		width: "16",
		height: "16",
		viewBox: "0 0 16 16",
		"aria-label": "Medium Priority",
		children: [
			/* @__PURE__ */ K("rect", {
				x: "1",
				y: "8",
				width: "3",
				height: "6",
				rx: "1"
			}),
			/* @__PURE__ */ K("rect", {
				x: "6",
				y: "5",
				width: "3",
				height: "9",
				rx: "1"
			}),
			/* @__PURE__ */ K("rect", {
				x: "11",
				y: "2",
				width: "3",
				height: "12",
				rx: "1",
				fillOpacity: "0.4"
			})
		]
	}),
	4: /* @__PURE__ */ q("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "var(--dixa-color-neutral-500)",
		width: "16",
		height: "16",
		viewBox: "0 0 16 16",
		"aria-label": "Low Priority",
		children: [
			/* @__PURE__ */ K("rect", {
				x: "1",
				y: "8",
				width: "3",
				height: "6",
				rx: "1"
			}),
			/* @__PURE__ */ K("rect", {
				x: "6",
				y: "5",
				width: "3",
				height: "9",
				rx: "1",
				fillOpacity: "0.4"
			}),
			/* @__PURE__ */ K("rect", {
				x: "11",
				y: "2",
				width: "3",
				height: "12",
				rx: "1",
				fillOpacity: "0.4"
			})
		]
	})
}, Qy = (e) => e in Zy, $y = ({ priority: e }) => Qy(e) ? Zy[e] : /* @__PURE__ */ K(I, {
	"data-testid": "defaultPriorityTag",
	children: e
}), eb = (e, t) => /* @__PURE__ */ K("svg", {
	width: "14",
	height: "14",
	viewBox: "0 0 14 14",
	"aria-label": t,
	fill: e,
	"data-testid": "defaultStatusIcon",
	children: /* @__PURE__ */ K("path", {
		d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
		stroke: "none"
	})
}), tb = (e, t) => /* @__PURE__ */ q("svg", {
	width: "14",
	height: "14",
	viewBox: "0 0 14 14",
	fill: "none",
	"aria-label": t,
	"data-testid": "unstartedStatusIcon",
	children: [/* @__PURE__ */ K("rect", {
		x: "1",
		y: "1",
		width: "12",
		height: "12",
		rx: "6",
		stroke: e,
		strokeWidth: "2",
		fill: "none"
	}), /* @__PURE__ */ K("path", {
		fill: e,
		stroke: "none",
		d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
		transform: "translate(3.5,3.5)"
	})]
}), nb = (e, t) => /* @__PURE__ */ q("svg", {
	width: "14",
	height: "14",
	viewBox: "0 0 14 14",
	fill: "none",
	"aria-label": t,
	children: [/* @__PURE__ */ K("rect", {
		x: "1",
		y: "1",
		width: "12",
		height: "12",
		rx: "6",
		stroke: e,
		strokeWidth: "2",
		fill: "none"
	}), /* @__PURE__ */ K("path", {
		fill: e,
		stroke: "none",
		d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
		transform: "translate(3.5,3.5)"
	})]
}), rb = (e, t) => /* @__PURE__ */ K("svg", {
	width: "14",
	height: "14",
	viewBox: "0 0 14 14",
	"aria-label": t,
	fill: e,
	children: /* @__PURE__ */ K("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
	})
}), ib = (e, t) => /* @__PURE__ */ K("svg", {
	width: "14",
	height: "14",
	viewBox: "0 0 14 14",
	"aria-label": t,
	fill: e,
	children: /* @__PURE__ */ K("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
		stroke: "none"
	})
}), ab = (e, t) => /* @__PURE__ */ K("svg", {
	width: "14",
	height: "14",
	viewBox: "0 0 14 14",
	"aria-label": t,
	fill: e,
	children: /* @__PURE__ */ K("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
	})
}), ob = {
	backlog: (e, t) => eb(e, t),
	unstarted: (e, t) => tb(e, t),
	started: (e, t) => nb(e, t),
	done: (e, t) => rb(e, t),
	canceled: (e, t) => ib(e, t),
	completed: (e, t) => ab(e, t)
}, sb = (e) => e in ob, cb = ({ type: e = "backlog", color: t = "var(--dixa-color-neutral-400)", name: n = "linear-backlog-icon" }) => sb(e) ? ob[e](t, n) : ob.backlog("var(--dixa-color-neutral-400)", "linear-backlog-icon"), lb = {
	wrapper: "_wrapper_e0qj3_1",
	description: "_description_e0qj3_8",
	resultTitle: "_resultTitle_e0qj3_21",
	resultTooltipTitle: "_resultTooltipTitle_e0qj3_28",
	resultLinkIcon: "_resultLinkIcon_e0qj3_31"
}, ub = ({ issue: e }) => {
	let [t, n] = W(!1), { list: { isDisabled: r }, item: { onSelect: i } } = Ye(ie()), a = Je((t) => {
		r || i({
			value: e,
			meta: {
				target: t?.target,
				event: t || void 0
			}
		});
	}, [
		r,
		i,
		e
	]);
	return /* @__PURE__ */ K(R, {
		wrap: "none",
		side: "left",
		content: /* @__PURE__ */ q(_, {
			flexDirection: "column",
			gap: "300",
			className: lb.wrapper,
			children: [/* @__PURE__ */ q(_, {
				flexDirection: "row",
				justifyContent: "space-between",
				gap: "300",
				children: [/* @__PURE__ */ q(_, {
					flexDirection: "row",
					gap: "200",
					alignItems: "center",
					children: [
						/* @__PURE__ */ K(cb, {
							type: e.state.type,
							name: e.state.name,
							color: e.state.color
						}),
						/* @__PURE__ */ K(L.Heading, {
							variant: "heading-3",
							children: e.identifier
						}),
						/* @__PURE__ */ K($y, { priority: e.priority })
					]
				}), /* @__PURE__ */ K(I, { children: e.state.name })]
			}), /* @__PURE__ */ q(_, {
				gap: "200",
				flexDirection: "column",
				children: [/* @__PURE__ */ K(L.Heading, {
					variant: "heading-3",
					className: lb.resultTooltipTitle,
					children: e.title
				}), /* @__PURE__ */ K(Xy, { issue: e })]
			})]
		}),
		light: !0,
		children: /* @__PURE__ */ K(M.Item, {
			value: e,
			noFixedSelectionStateSpace: !0,
			className: lb.result,
			onMouseEnter: () => n(!0),
			onMouseLeave: () => n(!1),
			"data-testid": "selectionListItemWrapper",
			onClick: a,
			children: /* @__PURE__ */ q(_, {
				flexDirection: "column",
				style: { width: t ? "calc(100% - 32px)" : "100%" },
				children: [
					/* @__PURE__ */ q(_, {
						flexDirection: "row",
						gap: "200",
						alignItems: "center",
						children: [
							/* @__PURE__ */ K(cb, {
								type: e.state.type,
								color: e.state.color,
								name: e.state.name
							}),
							/* @__PURE__ */ K(L.Heading, {
								variant: "heading-3",
								children: e.identifier
							}),
							/* @__PURE__ */ K($y, { priority: e.priority })
						]
					}),
					/* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						className: lb.resultTitle,
						children: e.title
					}),
					t && /* @__PURE__ */ K(b, {
						className: lb.resultLinkIcon,
						name: "plus",
						size: 32
					})
				]
			})
		}, e.id)
	});
}, db = {
	loader: "_loader_13xpk_1",
	dropdown: "_dropdown_13xpk_8",
	loadMore: "_loadMore_13xpk_13"
}, fb = ({ handleSelect: e, linkedIssues: t }) => {
	let [n, r] = W(), [i, a] = W([]), [o, s] = W(""), [c, l] = W(!1), { useLazyQuery: u } = V(), [d, { data: f, loading: p, networkStatus: m }] = u(Ky, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0
	}), [h, g] = ul(() => {
		!p && o !== "" && m === ot.ready ? d({ variables: {
			issueQuery: o,
			first: 8
		} }) : a([]);
	}, 500, [o]);
	U(() => {
		p || a([]);
	}, [o]), U(() => {
		if (f && Object.keys(f).length > 0) {
			let e = f.Linear.searchIssues.edges.map(({ node: e }) => e), n = i.filter((e) => !t.find((t) => t.id === e.id)), o = n.filter((t) => !e.find((e) => e.id === t.id)), s = e.filter((e) => !t.find((t) => t.id === e.id));
			t.length > 0 ? a(c ? [...o, ...s] : s) : f?.Linear?.searchIssues?.edges && a(c ? [...n, ...e] : e), f.Linear.searchIssues.pageInfo.hasNextPage && l(!1), r(f.Linear.searchIssues?.pageInfo);
		}
	}, [f, t]);
	let v = () => {
		!p && o !== "" && m === ot.ready ? (l(!0), d({ variables: {
			issueQuery: o,
			first: 8,
			after: n?.endCursor
		} })) : a([]);
	};
	return /* @__PURE__ */ K(_, {
		flexDirection: "column",
		gap: "200",
		"data-testid": "searchBarWrapper",
		children: /* @__PURE__ */ q(C, {
			"data-testid": "searchBarComponent",
			clearable: !0,
			getItemTitleByValue: (e) => e?.title,
			onChange: (t) => e(t.selectedValues[0]),
			dropdownProps: { className: db.dropdown },
			filter: {
				value: o,
				onChange: (e) => {
					let t = e.target.value;
					s(t);
				}
			},
			placeholder: "Search Linear issues",
			children: [
				i?.map((e) => /* @__PURE__ */ K(ub, { issue: e }, e.id)),
				n?.hasNextPage && !p && o !== "" && i.length && /* @__PURE__ */ K(_, {
					gap: "100",
					justifyContent: "center",
					padding: "200",
					alignItems: "center",
					onClick: () => v(),
					className: db.loadMore,
					children: /* @__PURE__ */ K(L.Paragraph, {
						variant: "3",
						children: "Load more ..."
					})
				}),
				p && o !== "" && /* @__PURE__ */ K(_, {
					justifyContent: "center",
					className: db.loader,
					children: /* @__PURE__ */ K(N, { size: 24 })
				}),
				o === "" && i.length === 0 && /* @__PURE__ */ K(_, {
					justifyContent: "center",
					style: { margin: "var(--dixa-size-spacer-250)" },
					children: /* @__PURE__ */ K(L.Paragraph, {
						variant: "3",
						color: "neutral.400",
						children: "Enter issue title or description"
					})
				}),
				i.length === 0 && o !== "" && !p && /* @__PURE__ */ K(_, {
					justifyContent: "center",
					style: { margin: "var(--dixa-size-spacer-250)" },
					children: /* @__PURE__ */ K(L.Paragraph, {
						variant: "3",
						color: "neutral.400",
						children: "No Linear issues found"
					})
				})
			]
		})
	});
}, pb = {
	collapse: "_collapse_su0f9_1",
	collapseHeader: "_collapseHeader_su0f9_8",
	collapseContent: "_collapseContent_su0f9_31",
	url: "_url_su0f9_35",
	empty: "_empty_su0f9_47",
	externalLink: "_externalLink_su0f9_51",
	emptyState: "_emptyState_su0f9_55"
}, mb = ({ linkedIssues: e, isLoading: t, handleUnlinkIssue: n, showUnlinkAllModal: r, showUnlinkAllButton: i, organizationUrl: o }) => {
	let [c, l] = W(e.reduce((e, t) => ({
		...e,
		[t.id]: !1
	}), {})), { track: u } = B();
	return t ? /* @__PURE__ */ K(_, {
		flexDirection: "column",
		margin: "0 0 400 0",
		justifyContent: "center",
		alignItems: "center",
		children: /* @__PURE__ */ K(N, { size: 24 })
	}) : e.length === 0 ? /* @__PURE__ */ q(_, {
		flexDirection: "column",
		justifyContent: "center",
		margin: "0 0 300 0",
		gap: "300",
		children: [/* @__PURE__ */ K(L.Paragraph, {
			align: "center",
			variant: "3",
			color: "neutral.400",
			className: pb.emptyState,
			children: "No linked issues found"
		}), /* @__PURE__ */ K(A, {
			slotEnd: /* @__PURE__ */ K(b, { name: "external-link" }),
			variant: "tertiary",
			className: pb.externalLink,
			navigate: () => window.open(`https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`, "_blank")?.focus(),
			children: "Open Linear"
		})]
	}) : /* @__PURE__ */ q(_, {
		flexDirection: "column",
		gap: "250",
		margin: "0 0 400 0",
		"data-testid": "linkedIssueWrapper",
		children: [
			e.map((e) => {
				let t = c[e.id];
				return /* @__PURE__ */ q(s, {
					"data-testid": "collapseCard",
					onToggle: () => l({
						...c,
						[e.id]: !c[e.id]
					}),
					isOpen: t,
					className: pb.collapse,
					children: [/* @__PURE__ */ K(s.Header, {
						className: pb.collapseHeader,
						children: /* @__PURE__ */ q(_, {
							flexDirection: "column",
							gap: "100",
							children: [/* @__PURE__ */ q(_, {
								flexDirection: "row",
								justifyContent: "space-between",
								children: [/* @__PURE__ */ q(_, {
									gap: "100",
									alignItems: "center",
									children: [
										/* @__PURE__ */ K(R, {
											content: /* @__PURE__ */ K(_, { children: e.state.name }),
											children: /* @__PURE__ */ K(_, {
												alignSelf: "center",
												children: /* @__PURE__ */ K(cb, {
													type: e.state.type,
													color: e.state.color,
													name: e.state.name
												})
											})
										}),
										/* @__PURE__ */ q(L.ExternalLink, {
											className: pb.url,
											href: e.url,
											target: "_blank",
											rel: "noreferrer",
											children: [e.identifier, /* @__PURE__ */ K(b, { name: "external-link" })]
										}),
										/* @__PURE__ */ K(R, {
											content: /* @__PURE__ */ K(_, { children: e.priorityLabel }),
											children: /* @__PURE__ */ K(_, {
												alignSelf: "center",
												children: /* @__PURE__ */ K($y, { priority: e.priority })
											})
										})
									]
								}), /* @__PURE__ */ K(I, { children: e.state.name })]
							}), e.title]
						})
					}), /* @__PURE__ */ K(s.Content, {
						className: pb.collapseContent,
						children: /* @__PURE__ */ q(_, {
							flexDirection: "column",
							gap: "300",
							children: [
								e?.labels && e?.labels?.edges?.length > 0 && /* @__PURE__ */ K(_, {
									flexDirection: "row",
									gap: "200",
									alignItems: "center",
									flexWrap: "wrap",
									children: e.labels?.edges.map((e) => /* @__PURE__ */ K(I, {
										color: e.node.color,
										children: e.node.name
									}, e.node.id))
								}),
								/* @__PURE__ */ K(Xy, { issue: e }),
								/* @__PURE__ */ K(a, {
									slotStart: /* @__PURE__ */ K(b, { name: "link-slash" }),
									variant: "secondary",
									onClick: () => n(e.id),
									style: { marginTop: "var(--dixa-size-spacer-200)" },
									children: "Unlink issue from Linear"
								}),
								/* @__PURE__ */ q(A, {
									slotEnd: /* @__PURE__ */ K(b, { name: "external-link" }),
									variant: "tertiary",
									className: pb.externalLink,
									onClick: () => {
										u("linear:open:issue:clicked", {
											linearInstanceUrl: o,
											linearIssueKey: e.id
										});
									},
									navigate: () => window.open(e.url, "_blank")?.focus(),
									children: [
										"View ",
										e.identifier,
										" in Linear"
									]
								})
							]
						})
					})]
				}, e.id);
			}),
			e.length > 1 && i && /* @__PURE__ */ K(a, {
				slotStart: /* @__PURE__ */ K(b, { name: "link-slash" }),
				variant: "secondary",
				onClick: () => r(!0),
				children: "Unlink all issues"
			}),
			/* @__PURE__ */ K(A, {
				slotEnd: /* @__PURE__ */ K(b, { name: "external-link" }),
				variant: "tertiary",
				className: pb.externalLink,
				onClick: () => {
					u("linear:open:linear:clicked", {
						linearInstanceUrl: o,
						linearIssueKey: e[0].id
					});
				},
				disabled: !o,
				navigate: () => window.open(o, "_blank")?.focus(),
				children: "Open Linear"
			})
		]
	});
}, hb = {
	default: (e, t) => (t() ?? []).join(""),
	nodes: {
		doc: (e, t) => (t() ?? []).join(""),
		heading: (e, t) => `\n${"#".repeat(parseInt(e.attrs?.level) || 1)} ${t()}\n\n`,
		bullet_list: (e, t) => "\n" + t().map((e) => `- ${e}`).join(""),
		ordered_list: (e, t) => "\n" + t().map((e) => `1. ${e}`).join(""),
		paragraph: (e, t) => t().join("") + "\n",
		text: (e) => e.text ?? "",
		hard_break: () => "\n",
		blockquote: (e, t) => `> ${t().join("")}\n`,
		code_block: (e, t) => "\n```" + (e.attrs?.language || "") + "\n" + t() + "\n```\n"
	},
	marks: { text: {
		strong: (e, t) => `**${t()}**`,
		strike: (e, t) => `~~${t()}~~`,
		subsup: (e, t) => {
			switch (e.attrs?.type) {
				case "sub": return `<sub>${t()}</sub>`;
				case "sup": return `<sup>${t()}</sup>`;
				default: return t();
			}
		},
		underline: (e, t) => `<u>${t()}</u>`,
		em: (e, t) => `*${t()}*`,
		link: (e, t) => `[${t()}](${e.attrs?.href})`,
		code: (e, t) => `\`${t()}\``
	} }
}, gb = (e, t) => ((n) => (e.marks || []).map((n) => ({
	formatterFunction: t.marks[e.type]?.[n.type],
	mark: n
})).reduce((e, t) => () => t.formatterFunction?.(t.mark, e) || n, () => n)())((t.nodes[e.type] || t.default)(e, ((e, t) => () => e.content ? e.content.map((e) => gb(e, t)) : [])(e, t))), _b = {
	modalBody: "_modalBody_iv3ua_1",
	error: "_error_iv3ua_5",
	emptyState: "_emptyState_iv3ua_9",
	dropdown: "_dropdown_iv3ua_16"
}, vb = Gy("\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n"), yb = Gy("\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n"), bb = Gy("\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n"), xb = ({ setCreatedIssue: e, isCreateIssueModalOpen: t, setIsCreateIssueModalOpen: n, setIsCreationSuccessfulModalOpen: r, addToLinkedIssueIds: i, organizationUrl: a, setOrganizationUrl: o }) => {
	let { useLazyQuery: s, showNotification: c } = V(), { control: l, handleSubmit: u, reset: d } = xc(), [f, p] = W([]), [b, x] = W(), [S, w] = W([]), [T, A] = W(), [j, P] = W([]), [F, I] = W(), [ee, te] = W([]), [ne, re] = W(), [R, ie] = W([]), [oe, se] = W(), [ce, le] = W(!1), { useMutation: ue } = V(), { track: de } = B(), [fe, { loading: pe }] = ue(vb, {
		onError: () => {
			le(!1), c({
				title: "Creation was not successful",
				text: "Please try again later or contact your admin.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		},
		onCompleted: (e) => {
			let t = {
				identifier: e.Linear?.issueCreate?.issue?.identifier,
				url: e.Linear?.issueCreate?.issue?.url
			};
			e.Linear && e.Linear?.issueCreate?.issue?.id && (i(e.Linear?.issueCreate?.issue?.id), xe(t), le(!1), c({
				title: "Issue was created and linked to the conversation",
				text: `Issue ${e.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
				icon: "exclamation-triangle-filled",
				severity: "success"
			}), de("linear:create:new:issue:confirmed", { linearInstanceUrl: a }));
		}
	}), [me, { data: he, loading: ge, error: _e }] = s(yb, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0,
		onError: () => c({
			title: "Error while fetching team ID",
			text: "Please try again later or contact your admin.",
			icon: "exclamation-triangle-filled",
			severity: "warning"
		}),
		onCompleted: (e) => {
			let t = e.Linear.teams.edges.map(({ node: e }) => e);
			p(t), te(e.Linear.issuePriorityValues), o(`${wb}${e.Linear.organization.urlKey}`);
		}
	}), [ve, { data: ye, loading: be }] = s(bb, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0,
		onError: () => c({
			title: "Error while fetching team projects",
			text: "Please try again later or contact your admin.",
			icon: "exclamation-triangle-filled",
			severity: "warning"
		}),
		onCompleted: (e) => {
			let t = e?.Linear?.team?.projects?.edges?.map(({ node: e }) => e);
			w(t);
			let n = e?.Linear?.team?.states?.edges?.map(({ node: e }) => e);
			P(n);
			let r = e?.Linear?.team?.templates?.edges?.map(({ node: e }) => e);
			ie(r.filter((e) => e.type === "issue"));
		}
	}), xe = (t) => {
		n(!1), A(void 0), x(void 0), I(void 0), re(void 0), se(void 0), t && (e(t), r(!0)), d({
			title: "",
			description: "",
			projectId: "",
			teamId: "",
			statusId: "",
			priority: void 0
		});
	}, Se = (e) => {
		he && !ge && (fe({ variables: {
			issueTitle: e.title,
			issueDescription: e?.description,
			teamId: e.team.id,
			projectId: e?.project?.id,
			statusId: e?.status?.id,
			priority: e?.priority?.priority
		} }), le(!0));
	};
	U(() => {
		t && me();
	}, [t]);
	let Ce = () => {
		de("linear:create:new:issue:cancelled", { linearInstanceUrl: a });
	};
	return /* @__PURE__ */ q(E, {
		isOpen: t,
		onClose: () => {
			Ce(), xe();
		},
		children: [
			/* @__PURE__ */ K(k, {
				title: "Create new Linear issue",
				onClose: () => {
					Ce(), xe();
				}
			}),
			/* @__PURE__ */ K(D, {
				className: _b.modalBody,
				"data-testid": "createIssueModalBody",
				children: _e ? /* @__PURE__ */ K(z, { error: _e }) : /* @__PURE__ */ K("form", {
					onSubmit: u(Se),
					id: "issueCreationForm",
					children: /* @__PURE__ */ q(y, { children: [
						/* @__PURE__ */ K(v, {
							span: 3,
							children: /* @__PURE__ */ K(Es, {
								control: l,
								name: "team",
								rules: { required: "Team is required" },
								render: ({ field: { value: e, onChange: t }, fieldState: { error: n } }) => /* @__PURE__ */ K(g, {
									required: !0,
									label: "Team",
									meta: { error: n?.message ?? null },
									children: /* @__PURE__ */ K(C, {
										dropdownProps: { className: _b.dropdown },
										placeholder: "Select Linear team",
										className: ae({ [_b.error]: n }),
										getItemTitleByValue: (e) => e?.name,
										onChange: (e) => {
											A(void 0), I(void 0), re(void 0), se(void 0), x(e.selectedValues[0]), ve({ variables: { teamId: e.selectedValues[0].id } }), t(e.selectedValues[0]);
										},
										value: b ? [e] : void 0,
										children: f?.map((e) => /* @__PURE__ */ K(M.Item, {
											value: e,
											noFixedSelectionStateSpace: !0,
											children: /* @__PURE__ */ K(L.Paragraph, { children: e.name })
										}, e.id))
									})
								})
							})
						}),
						/* @__PURE__ */ K(v, {
							span: 3,
							children: /* @__PURE__ */ K(Es, {
								control: l,
								name: "project",
								render: ({ field: { value: e, onChange: t } }) => {
									let n = be ? [{
										name: "Loading projects...",
										id: ""
									}] : void 0;
									return /* @__PURE__ */ K(g, {
										label: "Project",
										children: /* @__PURE__ */ K(C, {
											dropdownProps: { className: _b.dropdown },
											clearable: !0,
											getItemTitleByValue: (e) => e?.name,
											disabled: b === void 0,
											placeholder: b ? "Select Linear project" : "Select a Team first",
											onChange: (e) => {
												A(e.selectedValues[0]), t(e.selectedValues[0]);
											},
											value: T ? [e] : n,
											children: /* @__PURE__ */ q(G, { children: [be && /* @__PURE__ */ K(_, {
												justifyContent: "center",
												style: { padding: "var(--dixa-size-spacer-200)" },
												children: /* @__PURE__ */ K(N, { size: 24 })
											}), ye && !be && S.map((e) => /* @__PURE__ */ K(M.Item, {
												value: e,
												noFixedSelectionStateSpace: !0,
												children: /* @__PURE__ */ K(L.Paragraph, { children: e.name })
											}, e.id))] })
										})
									});
								}
							})
						}),
						/* @__PURE__ */ K(v, {
							span: 6,
							children: /* @__PURE__ */ K(g, {
								label: "Template",
								children: /* @__PURE__ */ K(C, {
									clearable: !0,
									dropdownProps: { className: _b.dropdown },
									disabled: !b || be,
									placeholder: b ? "Select template" : "Select a Team first",
									getItemTitleByValue: (e) => e?.name,
									onChange: (e) => {
										if (e.selectedValues.length > 0) {
											se(e.selectedValues[0]);
											let t = JSON.parse(e.selectedValues[0].templateData), n = ee.filter((e) => e.priority === t.priority);
											re(n ? n[0] : void 0);
											let r = j.filter((e) => e.id === t.stateId);
											I(r ? r[0] : void 0);
											let i = S.filter((e) => e.id === t.projectId);
											A(i ? i[0] : void 0);
											let a = t.description;
											d({
												title: t?.title,
												priority: n[0],
												status: r[0],
												project: i[0],
												description: a ? gb(a, hb) : "",
												team: b
											});
										} else d({
											title: "",
											description: "",
											team: b
										}), A(void 0), re(void 0), I(void 0), se(void 0);
									},
									value: oe ? [oe] : void 0,
									children: R?.map((e) => /* @__PURE__ */ K(M.Item, {
										value: e,
										noFixedSelectionStateSpace: !0,
										children: /* @__PURE__ */ K(L.Paragraph, { children: e.name })
									}, e.id))
								})
							})
						}),
						/* @__PURE__ */ K(v, {
							span: 6,
							children: /* @__PURE__ */ K(Es, {
								control: l,
								name: "title",
								rules: {
									required: "Title field is required",
									minLength: 2
								},
								render: ({ field: { onChange: e, value: t }, fieldState: { error: n } }) => /* @__PURE__ */ K(m, {
									required: !0,
									label: "Title",
									placeholder: "Insert issue title here",
									input: {
										name: "issueTitle",
										value: t || "",
										onChange: e
									},
									meta: { error: n?.message ?? null }
								})
							})
						}),
						/* @__PURE__ */ K(v, {
							span: 3,
							children: /* @__PURE__ */ K(Es, {
								control: l,
								name: "status",
								render: ({ field: { value: e, onChange: t } }) => {
									let n = be ? [{
										name: "Loading statuses...",
										id: "",
										type: "",
										color: ""
									}] : void 0;
									return /* @__PURE__ */ K(g, {
										label: "Status",
										children: /* @__PURE__ */ K(C, {
											dropdownProps: { className: _b.dropdown },
											clearable: !0,
											getItemTitleByValue: (e) => e?.name,
											disabled: b === void 0,
											placeholder: b ? "Select Issue status" : "Select a Team first",
											onChange: (e) => {
												I(e.selectedValues[0]), t(e.selectedValues[0]);
											},
											value: F ? [e] : n,
											children: /* @__PURE__ */ q(G, { children: [be && /* @__PURE__ */ K(_, {
												justifyContent: "center",
												style: { padding: "var(--dixa-size-spacer-200)" },
												children: /* @__PURE__ */ K(N, { size: 24 })
											}), ye && !be && j.map((e) => /* @__PURE__ */ K(M.Item, {
												value: e,
												noFixedSelectionStateSpace: !0,
												children: /* @__PURE__ */ q(_, {
													flexDirection: "row",
													gap: "300",
													alignItems: "center",
													children: [/* @__PURE__ */ K(cb, {
														type: e.type,
														color: e.color,
														name: e.name
													}), /* @__PURE__ */ K(L.Paragraph, { children: e.name })]
												})
											}, e.id))] })
										})
									});
								}
							})
						}),
						/* @__PURE__ */ K(v, {
							span: 3,
							children: /* @__PURE__ */ K(Es, {
								control: l,
								name: "priority",
								render: ({ field: { value: e, onChange: t } }) => /* @__PURE__ */ K(g, {
									label: "Priority",
									children: /* @__PURE__ */ K(C, {
										clearable: !0,
										getItemTitleByValue: (e) => e?.label,
										disabled: b === void 0,
										placeholder: b ? "Select Issue priority" : "Select a Team first",
										onChange: (e) => {
											re(e.selectedValues[0]), t(e.selectedValues[0]);
										},
										value: ne ? [e] : ge ? [{
											label: "Loading Priorities...",
											priority: 0
										}] : void 0,
										children: /* @__PURE__ */ q(G, { children: [be && /* @__PURE__ */ K(_, {
											justifyContent: "center",
											style: { padding: "var(--dixa-size-spacer-200)" },
											children: /* @__PURE__ */ K(N, { size: 24 })
										}), he && !ge && ee.map((e) => /* @__PURE__ */ K(M.Item, {
											value: e,
											noFixedSelectionStateSpace: !0,
											children: /* @__PURE__ */ q(_, {
												flexDirection: "row",
												gap: "300",
												alignItems: "center",
												children: [/* @__PURE__ */ K($y, { priority: e.priority }), /* @__PURE__ */ K(L.Paragraph, { children: e.label })]
											})
										}, e.priority))] })
									})
								})
							})
						}),
						/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(Es, {
							control: l,
							name: "description",
							render: ({ field: { onChange: e, value: t }, fieldState: { error: n } }) => /* @__PURE__ */ K(h, {
								label: "Description",
								placeholder: "Insert Issue description here",
								input: {
									name: "description",
									value: t || "",
									onChange: e
								},
								meta: { error: n?.message ?? null }
							})
						}) })
					] })
				})
			}),
			/* @__PURE__ */ K(O, {
				confirmOnClick: u(Se),
				confirmProps: {
					disabled: pe || !he,
					isLoading: ce || ge || be,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 })
				},
				confirmName: "Save",
				cancelOnClick: () => {
					Ce(), xe();
				}
			})
		]
	});
}, Sb = {
	modalWrapper: "_modalWrapper_4kh9u_1",
	copyButton: "_copyButton_4kh9u_6",
	copyWrapper: "_copyWrapper_4kh9u_15",
	copyField: "_copyField_4kh9u_24",
	externalLink: "_externalLink_4kh9u_47",
	externalLinkIcon: "_externalLinkIcon_4kh9u_52",
	textWrapper: "_textWrapper_4kh9u_56"
}, Cb = ({ isCreationSuccessfulModalOpen: e, createdIssueData: t, setIsCreationSuccessfulModalOpen: n }) => /* @__PURE__ */ q(E, {
	isOpen: !!t && e,
	className: Sb.modalWrapper,
	onClose: () => n(!1),
	children: [
		/* @__PURE__ */ K(k, {
			title: "Issue creation successful",
			onClose: () => n(!1)
		}),
		/* @__PURE__ */ K(D, { children: /* @__PURE__ */ q(_, {
			gap: "300",
			flexDirection: "column",
			"data-testid": "creationSuccessfulModal",
			children: [/* @__PURE__ */ q(L.Paragraph, {
				className: Sb.textWrapper,
				children: [
					`You can visit issue ${t?.identifier} by following `,
					" ",
					/* @__PURE__ */ q(L.ExternalLink, {
						href: t?.url,
						target: "_blank",
						className: Sb.externalLink,
						children: [
							"this link",
							" ",
							/* @__PURE__ */ K(b, {
								name: "external-link",
								className: Sb.externalLinkIcon
							})
						]
					}),
					"or copy it from the field below."
				]
			}), /* @__PURE__ */ K(g, {
				label: "Linear issue link",
				children: /* @__PURE__ */ q(_, {
					flexDirection: "row",
					alignItems: "center",
					"data-testid": "copyInputField",
					className: Sb.copyWrapper,
					children: [/* @__PURE__ */ K(w, {
						readOnly: !0,
						value: t?.url,
						className: Sb.copyField
					}), /* @__PURE__ */ K(c, {
						className: Sb.copyButton,
						textToCopy: t?.url || "",
						clickedProps: { icon: "check-circle-filled" }
					})]
				})
			})]
		}) }),
		/* @__PURE__ */ K(O, {
			cancelOnClick: () => n(!1),
			cancelProps: { variant: "primary" },
			cancelName: "Close"
		})
	]
}), wb = "https://linear.app/", Tb = ({ conversationContext: e, settings: t }) => {
	let [n, r] = W([]), [i, o] = W([]), [s, c] = W(!1), [l, u] = W(!1), [d, f] = W(!1), [p, m] = W(), { useLazyQuery: h } = V(), [g, v] = W(""), y = t?.enableCreateIssue, b = !!t?.enableUnlinkAll, { track: x } = B(), { loading: S, data: C, error: w, store: T } = ze(e?.conversationId ?? null), [A, { data: j, loading: M, networkStatus: N, error: P }] = h(qy, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0
	});
	U(() => {
		!S && !w && C && C?.linear?.issues?.length > 0 ? (o(C.linear.issues), A({ variables: { linkedIssues: C.linear.issues } })) : !S && !w && (r([]), o([]));
	}, [
		C,
		S,
		w
	]), U(() => {
		j && j?.Linear && !M && N === ot.ready && Object.keys(j).length > 0 && r(j.Linear.issues?.edges?.map(({ node: e }) => e));
	}, [
		j,
		M,
		N
	]);
	let F = (e) => {
		e && e?.team?.organization?.urlKey && x("linear:link:issue:clicked", {
			linearInstanceUrl: g,
			linearIssueKey: e.id
		});
		let t = (t) => t.id === e?.id;
		n.some((e) => e && t(e)) || (C && i.length === 0 && o([]), T({ linear: { issues: [...i, e.id] } }));
	}, I = (e) => {
		let t = C?.linear.issues.filter((t) => t !== e) || [];
		x("linear:unlink:issue:clicked", {
			linearInstanceUrl: g,
			linearIssueKey: e
		}), r(n.filter(({ id: t }) => t !== e)), o(t), T({ linear: { issues: t } });
	}, ee = () => {
		c(!1), r([]), o([]), T({ linear: { issues: [] } });
	}, te = S || M || !C && !w || (C?.linear?.issues?.length ?? 0) > 0 && n.length === 0;
	return !S && !M && (P || w) ? /* @__PURE__ */ K(z, { error: P || w }) : /* @__PURE__ */ q(_, {
		flexDirection: "column",
		gap: "300",
		children: [
			/* @__PURE__ */ q(E, {
				isOpen: s,
				onClose: () => c(!1),
				children: [
					/* @__PURE__ */ K(k, {
						title: "Unlink all Linear issues?",
						onClose: () => c(!1)
					}),
					/* @__PURE__ */ K(D, {
						"data-testid": "unlinkAllIssuesModalBody",
						children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?"
					}),
					/* @__PURE__ */ K(O, {
						confirmOnClick: () => ee(),
						confirmName: "Unlink all",
						cancelOnClick: () => c(!1)
					})
				]
			}),
			/* @__PURE__ */ K(xb, {
				isCreateIssueModalOpen: l,
				setIsCreateIssueModalOpen: (e) => u(e),
				setIsCreationSuccessfulModalOpen: (e) => f(e),
				addToLinkedIssueIds: (e) => {
					T({ linear: { issues: [...i, e] } });
				},
				setCreatedIssue: (e) => m(e),
				organizationUrl: g,
				setOrganizationUrl: (e) => v(e)
			}),
			/* @__PURE__ */ K(Cb, {
				isCreationSuccessfulModalOpen: d,
				setIsCreationSuccessfulModalOpen: (e) => f(e),
				createdIssueData: p
			}),
			/* @__PURE__ */ q(_, {
				flexDirection: "column",
				background: "neutral.100",
				padding: "300",
				borderRadius: "100",
				gap: "250",
				children: [y && /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(a, {
					variant: "primary",
					onClick: () => {
						x("linear:create:new:issue:clicked", { linearInstanceUrl: g }), u(!0);
					},
					style: { minHeight: "38px" },
					children: "Create new issue"
				}), /* @__PURE__ */ K(L.Paragraph, {
					color: "neutral.600",
					align: "center",
					children: "or"
				})] }), /* @__PURE__ */ K(fb, {
					handleSelect: F,
					linkedIssues: n
				})]
			}),
			/* @__PURE__ */ K(mb, {
				linkedIssues: n,
				isLoading: te,
				handleUnlinkIssue: I,
				showUnlinkAllModal: (e) => c(e),
				showUnlinkAllButton: b,
				organizationUrl: g
			})
		]
	});
}, Eb = [{
	key: "enableCreateIssue",
	label: "Enable the \"Create issue\" button",
	type: "boolean",
	secret: !1,
	defaultValue: !0
}, {
	key: "enableUnlinkAll",
	label: "Enable the \"Unlink all\" button",
	type: "boolean",
	secret: !1,
	defaultValue: !0
}], Db = Pe(Eb), Ob = "LINEAR", kb = {
	enabled: !1,
	name: "",
	enableCreateIssue: !0,
	enableUnlinkAll: !0
}, Ab = ({ integrationId: e, configuration: t, handleRedirect: n, showNotification: r, automationCouplingState: i, renderConditionsEditor: a }) => {
	let o = !e, s = xc({
		mode: "onChange",
		defaultValues: kb
	}), { create: c, update: l, remove: u, isLoading: d, error: f, misconfigurationCause: p, setMisconfigurationCause: m } = Ve({
		integrationId: e,
		integrationType: Ob,
		handleRedirect: n,
		showNotification: r
	}), { isLoading: h, error: x, isWidgetUnknown: S, refetch: C, widgetConfiguration: w } = He({
		integrationId: e,
		fieldDefinitions: Eb,
		form: s,
		onMisconfigured: m
	}), { renderConditions: T, setRenderConditions: E, renderConditionsForSubmit: D } = Be({
		integrationId: e,
		widgetConfiguration: w,
		renderConditionsEditor: a
	}), O = (e) => ye(e, {
		fieldDefinitions: Eb,
		isCreationMode: o,
		create: c,
		update: l,
		renderConditions: D
	}), k = s.watch("name");
	return /* @__PURE__ */ q(de, {
		form: s,
		integrationId: e,
		onValidSubmit: O,
		error: x ?? f,
		onRetry: x ? C : void 0,
		isLoading: d || h,
		isWidgetUnknown: S,
		children: [
			p && /* @__PURE__ */ K(se, { cause: p }),
			/* @__PURE__ */ q(y, { children: [
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ K(Z, {
						name: "enabled",
						control: s.control
					})
				}) }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "name",
						label: "Widget name",
						control: s.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: Db.enableCreateIssue,
						children: /* @__PURE__ */ K(Z, {
							name: "enableCreateIssue",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: Db.enableUnlinkAll,
						children: /* @__PURE__ */ K(Z, {
							name: "enableUnlinkAll",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				!o && e && /* @__PURE__ */ K(ce, {
					configuration: t,
					integrationId: e,
					integrationType: Ob,
					label: "Authorize with OAuth"
				}),
				a && T !== null && /* @__PURE__ */ K(v, { children: a({
					value: T,
					onChange: E,
					configurationKey: w?.id
				}) })
			] }),
			/* @__PURE__ */ K(pe, {
				integrationType: Ob,
				integrationId: e,
				widgetName: k,
				isCreationMode: o,
				isSubmitting: s.formState.isSubmitting,
				automationCouplingState: i,
				onConfirmDelete: () => u(),
				confirmDeleteVariant: "danger",
				deleteConfirmationBody: /* @__PURE__ */ q(_, {
					gap: "400",
					children: [/* @__PURE__ */ K(b, {
						size: 24,
						name: "exclamation-triangle-filled",
						color: "red.500"
					}), /* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "column",
						children: [
							/* @__PURE__ */ q(L.Heading, {
								withMarginBottom: !0,
								children: [
									"By deleting the ",
									Ob,
									" integration, all links between Dixa and ",
									Ob,
									" are also deleted."
								]
							}),
							/* @__PURE__ */ q(L.Paragraph, { children: [
								"All data in ",
								Ob,
								" stays untouched."
							] }),
							/* @__PURE__ */ q(L.Paragraph, { children: [
								"Are you sure you want to delete the ",
								Ob,
								" ",
								"integration \"",
								k,
								"\"?"
							] })
						]
					})]
				})
			})
		]
	});
};
//#endregion
//#region ../widget-loyaltylion/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var jb = {
	"\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "FragmentDefinition",
			name: {
				kind: "Name",
				value: "BadRequest"
			},
			typeCondition: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "LoyaltyLion_BadRequest"
				}
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "message"
					}
				}]
			}
		}]
	},
	"\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "mutation",
				name: {
					kind: "Name",
					value: "addPoints"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "merchantId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}, {
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "input"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "LoyaltyLion_updateCustomersPoints_request_Input"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "LoyaltyLion"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "updateCustomersPoints"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "merchant_id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "merchantId"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "input"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "input"
										}
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "LoyaltyLion_updateCustomersPoints_response"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "UpdateCustomersPointsResponse"
												}
											}]
										}
									}]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "BadRequest"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_BadRequest"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "Unauthorized"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_Unauthorized"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "Forbidden"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_Forbidden"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "NotFound"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_NotFound"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "UnprocessableEntity"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_UnprocessableEntity"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerError"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_ServerError"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "UpdateCustomersPointsResponse"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_updateCustomersPoints_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "BadRequest"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "Unauthorized"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "Forbidden"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "NotFound"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "UnprocessableEntity"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "ServerError"
							}
						}
					]
				}
			}
		]
	},
	"\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "mutation",
				name: {
					kind: "Name",
					value: "removePoints"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "merchantId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}, {
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "input"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "LoyaltyLion_removeCustomersPoints_request_Input"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "LoyaltyLion"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "removeCustomersPoints"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "merchant_id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "merchantId"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "input"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "input"
										}
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "LoyaltyLion_removeCustomersPoints_response"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "RemoveCustomersPointsResponse"
												}
											}]
										}
									}]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "BadRequest"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_BadRequest"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "Unauthorized"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_Unauthorized"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "Forbidden"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_Forbidden"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "NotFound"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_NotFound"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "UnprocessableEntity"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_UnprocessableEntity"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerError"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_ServerError"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "RemoveCustomersPointsResponse"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_removeCustomersPoints_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "BadRequest"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "Unauthorized"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "Forbidden"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "NotFound"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "UnprocessableEntity"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "ServerError"
							}
						}
					]
				}
			}
		]
	},
	"\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getCustomers"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "email"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "LoyaltyLion"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getCustomers"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "email"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "email"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "LoyaltyLion_getCustomers_response"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "LoyaltyLion_Customers"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "customers"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "merchant_id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "email"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "points_approved"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "points_pending"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "points_spent"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "rewards_claimed"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "birthday"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "guest"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "blocked"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "enrolled"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "enrolled_at"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "referral_id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "referred_by"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "id"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "merchant_id"
																		}
																	}]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "loyalty_tier_membership"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "started_at"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "expires_at"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "manual"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "loyalty_tier"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "id"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "name"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "position"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "default"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "hidden"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "lower_bound"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "upper_bound"
																						}
																					}
																				]
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "insights_segment"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "referral_url"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "metadata"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "shopify_source_url"
																		}
																	}]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "properties"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "name"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "first_name"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "last_name"
																			}
																		}
																	]
																}
															}
														]
													}
												}]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getRewards"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "merchantId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "LoyaltyLion"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "getAvailableRewards"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "merchant_id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "merchantId"
										}
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "LoyaltyLion_getAvailableRewards_response"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [
												{
													kind: "InlineFragment",
													typeCondition: {
														kind: "NamedType",
														name: {
															kind: "Name",
															value: "LoyaltyLion_Rewards"
														}
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "rewards"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "id"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "title"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "description"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "site_id"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "target_site"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "id"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "name"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "url"
																					}
																				}
																			]
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "content"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "kind"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "point_cost"
																		}
																	}
																]
															}
														}]
													}
												},
												{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "BadRequest"
													}
												},
												{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "Unauthorized"
													}
												},
												{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "Forbidden"
													}
												},
												{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "NotFound"
													}
												},
												{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerError"
													}
												}
											]
										}
									}]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "BadRequest"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_BadRequest"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "Unauthorized"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_Unauthorized"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "Forbidden"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_Forbidden"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "NotFound"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_NotFound"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerError"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_ServerError"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			}
		]
	}
};
function Mb(e) {
	return jb[e] ?? {};
}
var Nb = Mb("\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), Pb = Mb("\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n"), Fb = Mb("\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n"), Ib = Mb("\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n"), Lb = Yo;
function Rb(e = !1, t) {
	let [n, r] = W(e);
	return U(() => {
		let e = n ? window.setTimeout(() => r(!1), t || 2e3) : void 0;
		return () => window.clearTimeout(e);
	}, [t, n]), {
		isCopied: n,
		copy: (e) => {
			navigator.clipboard.writeText(e), r(!0);
		}
	};
}
var zb = {
	wrapper: "_wrapper_27vny_1",
	textVariant: "_textVariant_27vny_7",
	copyIcon: "_copyIcon_27vny_12"
}, Bb = ({ customer: e }) => {
	let { isCopied: t, copy: n } = Rb(), { isCopied: r, copy: i } = Rb(), { isCopied: a, copy: o } = Rb();
	if (!e) return null;
	let { email: s, properties: c, metadata: l, birthday: u, created_at: d, enrolled: f, enrolled_at: p, referral_url: m } = e, h = u ? Lb(u).isSame(Date.now(), "day") : !1, { name: g, first_name: v, last_name: y } = c ?? {}, x = g ?? (`${v} ${y}`.trim() || "A customer has no name"), S = l?.shopify_source_url ? l.shopify_source_url.startsWith("https://") ? l.shopify_source_url : `https://${l.shopify_source_url}` : "";
	return /* @__PURE__ */ K(_, {
		gap: "300",
		flexDirection: "column",
		children: /* @__PURE__ */ q(_, {
			className: zb.wrapper,
			gap: "250",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ q(_, {
					justifyContent: "space-between",
					className: zb.block,
					alignItems: "center",
					children: [/* @__PURE__ */ K(L.Heading, {
						variant: "heading-2",
						children: x
					}), h && /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						color: "primary",
						children: "... has birthday today 🥳"
					})]
				}),
				d && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: "Member since"
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: Lb(d).format("DD MMM YYYY @ HH:mm")
					})]
				}),
				f && /* @__PURE__ */ K(_, {
					gap: "200",
					children: /* @__PURE__ */ q(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: ["Enrolled since ", Lb(p).format("DD MMM YYYY @ HH:mm")]
					})
				}),
				/* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						alignItems: "center",
						gap: "200",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "mail"
						}), /* @__PURE__ */ K(L.ExternalLink, {
							href: `mailto:${s}`,
							children: s
						})]
					}), /* @__PURE__ */ K(R, {
						content: t ? "Copied" : "Copy",
						children: /* @__PURE__ */ K(b, {
							size: 14,
							name: t ? "done" : "copy",
							onClick: () => n(s),
							className: zb.copyIcon
						})
					})]
				}),
				S && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						alignItems: "center",
						gap: "200",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "link"
						}), /* @__PURE__ */ K(R, {
							content: "Shopify shop",
							children: /* @__PURE__ */ K(L.ExternalLink, {
								href: S,
								target: "_blank",
								rel: "noreferrer",
								children: S.replace("https://", "")
							})
						})]
					}), /* @__PURE__ */ K(R, {
						content: r ? "Copied" : "Copy",
						children: /* @__PURE__ */ K(b, {
							size: 14,
							name: r ? "done" : "copy",
							onClick: () => i(S),
							className: zb.copyIcon
						})
					})]
				}),
				m && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						alignItems: "center",
						gap: "200",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "external-link"
						}), /* @__PURE__ */ K(R, {
							content: "Referral link",
							children: /* @__PURE__ */ K(L.ExternalLink, {
								href: m,
								target: "_blank",
								rel: "noreferrer",
								children: m.replace("https://", "")
							})
						})]
					}), /* @__PURE__ */ K(R, {
						content: a ? "Copied" : "Copy",
						children: /* @__PURE__ */ K(b, {
							size: 14,
							name: a ? "done" : "copy",
							onClick: () => o(m),
							className: zb.copyIcon
						})
					})]
				})
			]
		})
	});
}, Vb = {
	labelText: "_labelText_1q5b5_1",
	list: "_list_1q5b5_5",
	listItem: "_listItem_1q5b5_8",
	listItemEdit: "_listItemEdit_1q5b5_15",
	notificationText: "_notificationText_1q5b5_19"
}, Hb = { modalBody: "_modalBody_1clhs_1" }, Ub = ({ isOpen: e, points: t, merchantId: n, onClose: r, refetchCustomerData: i }) => {
	let { useMutation: a, showNotification: o } = V(), { track: s } = B(), [c, l] = W(t), [u, d] = W(""), [f, p] = W(), [h, { loading: g }] = a(Fb, { onCompleted: () => {
		o({
			title: "Success",
			text: "Added points successfully",
			icon: "check-circle-filled",
			severity: "success"
		}), s("loyaltylion:add:points:succeeded"), L();
	} }), [x, { loading: S }] = a(Ib), C = g || S, w = !!f, A = t === c ? "Change the value to update the points" : "", j = isNaN(c), M = j ? "Points can not be empty" : "", P = c > t && c - t > 1e6, F = P ? "Points can not exceed 1,000,000" : "", I = () => {
		if (!n) {
			p(["Merchant information is missing."]), c > t ? s("loyaltylion:add:points:failed") : c < t && s("loyaltylion:remove:points:failed");
			return;
		}
		c > t && h({ variables: {
			input: {
				points: c - t,
				reason: u
			},
			merchantId: n
		} }).catch((e) => {
			let t = e?.networkError;
			(t ? t?.statusCode : NaN) === 201 ? (s("loyaltylion:add:points:succeeded"), o({
				title: "Success",
				text: "Added points successfully",
				icon: "check-circle-filled",
				severity: "success"
			}), L()) : (s("loyaltylion:add:points:failed"), p(["Failed to add points, try again later."]));
		}), c < t && x({ variables: {
			input: {
				points: t - c,
				reason: u
			},
			merchantId: n
		} }).then((e) => {
			e.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (s("loyaltylion:remove:points:succeeded"), o({
				title: "Success",
				text: "Removed points successfully",
				icon: "check-circle-filled",
				severity: "success"
			}), L()) : "errors" in e && (s("loyaltylion:remove:points:failed"), p(e.errors?.map((e) => e.message) ?? ["Failed to remove points, try again later."]));
		}).catch(() => {
			s("loyaltylion:remove:points:failed"), p(["Failed to remove points, try again later."]);
		});
	}, ee = () => {
		j && l(t), d(""), r();
	}, L = () => {
		i(), ee();
	};
	return /* @__PURE__ */ q(E, {
		isOpen: e,
		onClose: ee,
		"data-testid": "change-points-modal",
		children: [
			/* @__PURE__ */ K(k, {
				title: "Change points",
				onClose: ee
			}),
			/* @__PURE__ */ q(D, {
				className: Hb.modalBody,
				children: [/* @__PURE__ */ q(y, { children: [/* @__PURE__ */ K(v, {
					span: 6,
					children: /* @__PURE__ */ K(m, {
						required: !0,
						label: "New points",
						type: "number",
						placeholder: "Insert new points",
						min: 0,
						max: 1e5,
						meta: {
							error: F || M,
							warning: A
						},
						input: {
							name: "points",
							value: c.toString(),
							onChange: (e) => l(e?.target.valueAsNumber ?? 0)
						},
						"data-testid": "points-input"
					})
				}), /* @__PURE__ */ K(v, {
					span: 6,
					children: /* @__PURE__ */ K(m, {
						label: "Reason",
						placeholder: "Insert an optional reason",
						input: {
							name: "reason",
							value: u,
							onChange: (e) => d(e?.target.value ?? "")
						}
					})
				})] }), !C && w && /* @__PURE__ */ K(_, {
					margin: "200 0",
					flexDirection: "column",
					children: /* @__PURE__ */ K(T, { children: f?.map((e, t) => /* @__PURE__ */ K(T.Item, {
						variant: "dense",
						title: e,
						contentLeft: /* @__PURE__ */ K(b, {
							color: "red.500",
							size: 16,
							name: "exclamation-triangle-filled"
						})
					}, t)) })
				})]
			}),
			/* @__PURE__ */ K(O, {
				confirmName: "Save",
				confirmOnClick: () => I(),
				confirmProps: {
					isLoading: C,
					disabled: j || P || t === c,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 })
				},
				cancelOnClick: ee
			})
		]
	});
}, Wb = ({ label: e, points: t, setIsModalOpen: r }) => {
	let i = t > 0 ? "green.500" : "neutral.400", a = t > 0 ? "warning" : "secondary";
	return /* @__PURE__ */ K(T.Text, {
		variant: "dense",
		className: Vb.listItem,
		children: /* @__PURE__ */ q(_, {
			justifyContent: "space-between",
			children: [/* @__PURE__ */ q(_, {
				gap: "200",
				alignItems: "center",
				children: [/* @__PURE__ */ K(b, {
					color: i,
					size: 10,
					name: "star-full"
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					children: e
				})]
			}), /* @__PURE__ */ q(_, {
				gap: "200",
				alignItems: "center",
				children: [r && /* @__PURE__ */ K(R, {
					content: "Edit points",
					children: /* @__PURE__ */ K(b, {
						name: "pen",
						size: 10,
						"aria-label": "Edit points",
						className: Vb.listItemEdit,
						onClick: () => r(!0)
					})
				}), /* @__PURE__ */ K(n, {
					size: "small",
					variant: a,
					children: t
				})]
			})]
		})
	});
}, Gb = ({ customer: e, refetchCustomerData: t }) => {
	let [n, r] = W(!1);
	if (!e) return null;
	let { merchant_id: i, points_approved: a, points_pending: o, points_spent: s, rewards_claimed: c } = e, l = [
		{
			id: "pointsApproved",
			label: "Points approved",
			points: a ?? 0,
			setIsModalOpen: r
		},
		{
			id: "pointsPending",
			label: "Points pending",
			points: o ?? 0
		},
		{
			id: "pointsSpent",
			label: "Points spent",
			points: s ?? 0
		},
		{
			id: "rewardClaimed",
			label: "Rewards claimed",
			points: c ?? 0
		}
	];
	return /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ K(L.Heading, {
				variant: "heading-3",
				children: "Points balance"
			}),
			/* @__PURE__ */ K(T, {
				className: Vb.list,
				children: l.map(({ id: e, points: t, label: n, setIsModalOpen: r }) => /* @__PURE__ */ K(Wb, {
					points: t,
					label: n,
					setIsModalOpen: r
				}, e))
			}),
			/* @__PURE__ */ K(Ub, {
				isOpen: n,
				points: a,
				merchantId: i,
				onClose: () => r(!1),
				refetchCustomerData: t
			})
		]
	});
}, Kb = { reward: "_reward_1wxia_1" }, qb = ({ reward: e }) => {
	let { title: t, point_cost: r, target_site: i, description: a } = e, o = i?.name, s = i?.url;
	return /* @__PURE__ */ K(_, {
		gap: "100",
		flexDirection: "column",
		className: Kb.reward,
		children: /* @__PURE__ */ K(R, {
			content: a ?? "No description",
			children: /* @__PURE__ */ q(_, {
				gap: "100",
				flexDirection: "column",
				children: [/* @__PURE__ */ q(_, {
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						gap: "100",
						alignItems: "center",
						children: [/* @__PURE__ */ K(b, {
							name: "star",
							size: 12,
							color: "neutral.500"
						}), t]
					}), /* @__PURE__ */ q(n, {
						size: "small",
						variant: "info",
						children: [r ?? 0, " points"]
					})]
				}), o && s && /* @__PURE__ */ q(_, {
					gap: "100",
					flexDirection: "row",
					alignItems: "center",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "external-link"
					}), /* @__PURE__ */ K(L.ExternalLink, {
						href: s,
						target: "_blank",
						rel: "noreferrer",
						children: o
					})]
				})]
			})
		})
	});
}, Jb = ({ customer: e }) => {
	let { useQuery: t } = V(), [n, r] = W(), { merchant_id: i } = e, { loading: a, error: o, data: s } = t(Pb, {
		skip: !i,
		variables: { merchantId: i }
	});
	if (U(() => {
		if (s?.LoyaltyLion) {
			let e = s.LoyaltyLion?.getAvailableRewards?.rewards;
			e && r(e);
		}
	}, [s]), o) {
		let e = o.graphQLErrors;
		return Se({ errors: e }) ? /* @__PURE__ */ K(_, {
			justifyContent: "center",
			margin: "200 0 300 0",
			className: Vb.notificationText,
			children: "No rewards found"
		}) : Ce({ errors: e }) ? /* @__PURE__ */ K(_, {
			justifyContent: "center",
			margin: "200 0 300 0",
			className: Vb.notificationText,
			children: "You don't have permissions to view rewards"
		}) : /* @__PURE__ */ K(z, { error: o });
	}
	return /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(L.Heading, {
			variant: "heading-3",
			children: "Available rewards"
		}), a ? /* @__PURE__ */ K(_, {
			justifyContent: "center",
			margin: "200 0 300 0",
			children: /* @__PURE__ */ K(N, {})
		}) : /* @__PURE__ */ K(_, {
			gap: "200",
			flexDirection: "column",
			children: n?.map((e) => /* @__PURE__ */ K(qb, { reward: e }, e.id))
		})]
	});
}, Yb = ({ customer: e }) => {
	let { blocked: t, guest: n, insights_segment: r } = e ?? {};
	return t || n || r ? /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "row",
		flexWrap: "wrap",
		children: [
			t && /* @__PURE__ */ K(_, {
				alignItems: "start",
				children: /* @__PURE__ */ K(I, { children: /* @__PURE__ */ q(_, {
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						color: "red.500",
						name: "exclamation-triangle-filled"
					}), "Blocked"]
				}) })
			}),
			n && /* @__PURE__ */ K(_, {
				alignItems: "start",
				children: /* @__PURE__ */ K(I, { children: /* @__PURE__ */ q(_, {
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						color: "green.500",
						name: "user"
					}), "Guest"]
				}) })
			}),
			r && /* @__PURE__ */ K(_, {
				alignItems: "start",
				children: /* @__PURE__ */ K(R, {
					content: "Insights segment",
					children: /* @__PURE__ */ K(I, { children: /* @__PURE__ */ q(_, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							color: "green.500",
							name: "team"
						}), r]
					}) })
				})
			})
		]
	}) : null;
}, Xb = ({ conversationContext: e, settings: t }) => {
	let { useQuery: n } = V(), { track: r } = B(), [i, a] = W(null), { customer: o } = e, { showCustomerSummary: s, showTags: c, showPointsBalance: l, showAvailableRewards: u } = t, d = !s && !c && !l && !u, { loading: f, error: p, data: m, refetch: h } = n(Nb, {
		skip: !o?.email,
		variables: { email: o?.email ?? "" }
	});
	return U(() => {
		if (m && !f) {
			let e = (m?.LoyaltyLion?.getCustomers).customers;
			e && e.length > 0 && (a(e[0]), r("loyaltylion:customer:received"));
		}
	}, [m, f]), o?.email ? p ? Se({ errors: p.graphQLErrors }) ? /* @__PURE__ */ q(_, {
		justifyContent: "center",
		margin: "200 0 300 0",
		className: Vb.notificationText,
		children: ["No user found for email: ", o?.email]
	}) : /* @__PURE__ */ K(z, { error: p }) : f ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: /* @__PURE__ */ K(N, {})
	}) : d ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "200 0 300 0",
		"data-testid": "no-feature-enabled-message",
		children: "All features toggles in the integration settings are disabled"
	}) : /* @__PURE__ */ K(_, {
		gap: "300",
		flexDirection: "column",
		margin: "0 0 300 0",
		"data-testid": "widget-wrapper",
		children: i ? /* @__PURE__ */ q(G, { children: [
			s && /* @__PURE__ */ K(Bb, { customer: i }),
			c && /* @__PURE__ */ K(Yb, { customer: i }),
			l && /* @__PURE__ */ K(Gb, {
				customer: i,
				refetchCustomerData: h
			}),
			u && /* @__PURE__ */ K(Jb, { customer: i })
		] }) : /* @__PURE__ */ K(_, {
			justifyContent: "center",
			padding: "200",
			children: "Nothing found"
		})
	}) : /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "200 0 300 0",
		"data-testid": "no-email-message",
		children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
	});
}, Zb = [
	{
		key: "basicAuthorization",
		label: "LoyaltyLion authorization",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "showCustomerSummary",
		label: "Show customer summary",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showTags",
		label: "Show tags",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showPointsBalance",
		label: "Show points balance",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showAvailableRewards",
		label: "Show available rewards",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	}
], Qb = Pe(Zb), $b = "LOYALTYLION", ex = {
	enabled: !1,
	name: "",
	basicAuthorization: "",
	showCustomerSummary: !0,
	showTags: !0,
	showPointsBalance: !0,
	showAvailableRewards: !0
}, tx = ({ integrationId: e, handleRedirect: t, showNotification: n, automationCouplingState: r, renderConditionsEditor: i }) => {
	let a = !e, o = xc({
		mode: "onChange",
		defaultValues: ex
	}), { create: s, update: c, remove: l, isLoading: u, error: d, misconfigurationCause: f, setMisconfigurationCause: p } = Ve({
		integrationId: e,
		integrationType: $b,
		handleRedirect: t,
		showNotification: n
	}), { isLoading: m, error: h, isWidgetUnknown: _, refetch: b, widgetConfiguration: x } = He({
		integrationId: e,
		fieldDefinitions: Zb,
		form: o,
		onMisconfigured: p
	}), { renderConditions: S, setRenderConditions: C, renderConditionsForSubmit: w } = Be({
		integrationId: e,
		widgetConfiguration: x,
		renderConditionsEditor: i
	}), T = (e) => ye(e, {
		fieldDefinitions: Zb,
		isCreationMode: a,
		create: s,
		update: c,
		renderConditions: w
	}), E = o.watch("name");
	return /* @__PURE__ */ q(de, {
		form: o,
		integrationId: e,
		onValidSubmit: T,
		error: h ?? d,
		onRetry: h ? b : void 0,
		isLoading: u || m,
		isWidgetUnknown: _,
		children: [
			f && /* @__PURE__ */ K(se, { cause: f }),
			/* @__PURE__ */ q(y, { children: [
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ K(Z, {
						name: "enabled",
						control: o.control
					})
				}) }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "name",
						label: "Widget name",
						control: o.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(le, {
						name: "basicAuthorization",
						label: Qb.basicAuthorization,
						control: o.control,
						isCreationMode: a,
						rules: { required: "Please insert a value for both fields" },
						usernameLabel: "Token",
						passwordLabel: "Secret",
						usernamePlaceholder: "Insert your token",
						passwordPlaceholder: "Insert your secret"
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: Qb.showCustomerSummary,
						children: /* @__PURE__ */ K(Z, {
							name: "showCustomerSummary",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: Qb.showTags,
						children: /* @__PURE__ */ K(Z, {
							name: "showTags",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: Qb.showPointsBalance,
						children: /* @__PURE__ */ K(Z, {
							name: "showPointsBalance",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: Qb.showAvailableRewards,
						children: /* @__PURE__ */ K(Z, {
							name: "showAvailableRewards",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				i && S !== null && /* @__PURE__ */ K(v, { children: i({
					value: S,
					onChange: C,
					configurationKey: x?.id
				}) })
			] }),
			/* @__PURE__ */ K(pe, {
				integrationType: $b,
				integrationId: e,
				widgetName: E,
				isCreationMode: a,
				isSubmitting: o.formState.isSubmitting,
				automationCouplingState: r,
				onConfirmDelete: () => l()
			})
		]
	});
};
//#endregion
//#region ../widget-miuros/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var nx = { "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": {
	kind: "Document",
	definitions: [{
		kind: "OperationDefinition",
		operation: "query",
		name: {
			kind: "Name",
			value: "conversationsQuery"
		},
		variableDefinitions: [{
			kind: "VariableDefinition",
			variable: {
				kind: "Variable",
				name: {
					kind: "Name",
					value: "query"
				}
			},
			type: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "String"
				}
			}
		}],
		selectionSet: {
			kind: "SelectionSet",
			selections: [{
				kind: "Field",
				name: {
					kind: "Name",
					value: "Miuros"
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "findTickets"
						},
						arguments: [{
							kind: "Argument",
							name: {
								kind: "Name",
								value: "query"
							},
							value: {
								kind: "Variable",
								name: {
									kind: "Name",
									value: "query"
								}
							}
						}, {
							kind: "Argument",
							name: {
								kind: "Name",
								value: "page_size"
							},
							value: {
								kind: "IntValue",
								value: "10"
							}
						}],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "data"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										},
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "labels"
											}
										},
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "subject"
											}
										},
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "messages"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "direction"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "body"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "agent"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "email"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "created_at"
														}
													}
												]
											}
										},
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "custom_fields"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "additionalProperties"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "key"
															}
														}, {
															kind: "Field",
															name: {
																kind: "Name",
																value: "value"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "value"
																	}
																}]
															}
														}]
													}
												}]
											}
										},
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "created_at"
											}
										}
									]
								}
							}]
						}
					}]
				}
			}]
		}
	}]
} };
function rx(e) {
	return nx[e] ?? {};
}
var ix = Yo;
function ax(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function ox(e) {
	if (Array.isArray(e)) return e;
}
function sx(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r, i, a, o, s = [], c = !0, l = !1;
		try {
			if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
		} catch (e) {
			l = !0, i = e;
		} finally {
			try {
				if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
			} finally {
				if (l) throw i;
			}
		}
		return s;
	}
}
function cx() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function lx(e, t) {
	return ox(e) || sx(e, t) || ux(e, t) || cx();
}
function ux(e, t) {
	if (e) {
		if (typeof e == "string") return ax(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ax(e, t) : void 0;
	}
}
var dx = Object.entries, fx = Object.setPrototypeOf, px = Object.isFrozen, mx = Object.getPrototypeOf, hx = Object.getOwnPropertyDescriptor, gx = Object.freeze, _x = Object.seal, vx = Object.create, yx = typeof Reflect < "u" && Reflect, bx = yx.apply, xx = yx.construct;
gx ||= function(e) {
	return e;
}, _x ||= function(e) {
	return e;
}, bx ||= function(e, t) {
	var n = [...arguments].slice(2);
	return e.apply(t, n);
}, xx ||= function(e) {
	return new e(...[...arguments].slice(1));
};
var Sx = Hx(Array.prototype.forEach), Cx = Hx(Array.prototype.lastIndexOf), wx = Hx(Array.prototype.pop), Tx = Hx(Array.prototype.push), Ex = Hx(Array.prototype.splice), Dx = Array.isArray, Ox = Hx(String.prototype.toLowerCase), kx = Hx(String.prototype.toString), Ax = Hx(String.prototype.match), jx = Hx(String.prototype.replace), Mx = Hx(String.prototype.indexOf), Nx = Hx(String.prototype.trim), Px = Hx(Number.prototype.toString), Fx = Hx(Boolean.prototype.toString), Ix = typeof BigInt > "u" ? null : Hx(BigInt.prototype.toString), Lx = typeof Symbol > "u" ? null : Hx(Symbol.prototype.toString), Rx = Hx(Object.prototype.hasOwnProperty), zx = Hx(Object.prototype.toString), Bx = Hx(RegExp.prototype.test), Vx = Ux(TypeError);
function Hx(e) {
	return function(t) {
		t instanceof RegExp && (t.lastIndex = 0);
		var n = [...arguments].slice(1);
		return bx(e, t, n);
	};
}
function Ux(e) {
	return function() {
		return xx(e, [...arguments]);
	};
}
function Wx(e, t) {
	let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ox;
	if (fx && fx(e, null), !Dx(t)) return e;
	let r = t.length;
	for (; r--;) {
		let i = t[r];
		if (typeof i == "string") {
			let e = n(i);
			e !== i && (px(t) || (t[r] = e), i = e);
		}
		e[i] = !0;
	}
	return e;
}
function Gx(e) {
	for (let t = 0; t < e.length; t++) Rx(e, t) || (e[t] = null);
	return e;
}
function Kx(e) {
	let t = vx(null);
	for (let r of dx(e)) {
		var n = lx(r, 2);
		let i = n[0], a = n[1];
		Rx(e, i) && (Dx(a) ? t[i] = Gx(a) : a && typeof a == "object" && a.constructor === Object ? t[i] = Kx(a) : t[i] = a);
	}
	return t;
}
function qx(e) {
	switch (typeof e) {
		case "string": return e;
		case "number": return Px(e);
		case "boolean": return Fx(e);
		case "bigint": return Ix ? Ix(e) : "0";
		case "symbol": return Lx ? Lx(e) : "Symbol()";
		case "undefined": return zx(e);
		case "function":
		case "object": {
			if (e === null) return zx(e);
			let t = e, n = Jx(t, "toString");
			if (typeof n == "function") {
				let e = n(t);
				return typeof e == "string" ? e : zx(e);
			}
			return zx(e);
		}
		default: return zx(e);
	}
}
function Jx(e, t) {
	for (; e !== null;) {
		let n = hx(e, t);
		if (n) {
			if (n.get) return Hx(n.get);
			if (typeof n.value == "function") return Hx(n.value);
		}
		e = mx(e);
	}
	function n() {
		return null;
	}
	return n;
}
function Yx(e) {
	try {
		return Bx(e, ""), !0;
	} catch {
		return !1;
	}
}
var Xx = gx(/* @__PURE__ */ "a.abbr.acronym.address.area.article.aside.audio.b.bdi.bdo.big.blink.blockquote.body.br.button.canvas.caption.center.cite.code.col.colgroup.content.data.datalist.dd.decorator.del.details.dfn.dialog.dir.div.dl.dt.element.em.fieldset.figcaption.figure.font.footer.form.h1.h2.h3.h4.h5.h6.head.header.hgroup.hr.html.i.img.input.ins.kbd.label.legend.li.main.map.mark.marquee.menu.menuitem.meter.nav.nobr.ol.optgroup.option.output.p.picture.pre.progress.q.rp.rt.ruby.s.samp.search.section.select.shadow.slot.small.source.spacer.span.strike.strong.style.sub.summary.sup.table.tbody.td.template.textarea.tfoot.th.thead.time.tr.track.tt.u.ul.var.video.wbr".split(".")), Zx = gx(/* @__PURE__ */ "svg.a.altglyph.altglyphdef.altglyphitem.animatecolor.animatemotion.animatetransform.circle.clippath.defs.desc.ellipse.enterkeyhint.exportparts.filter.font.g.glyph.glyphref.hkern.image.inputmode.line.lineargradient.marker.mask.metadata.mpath.part.path.pattern.polygon.polyline.radialgradient.rect.stop.style.switch.symbol.text.textpath.title.tref.tspan.view.vkern".split(".")), Qx = gx([
	"feBlend",
	"feColorMatrix",
	"feComponentTransfer",
	"feComposite",
	"feConvolveMatrix",
	"feDiffuseLighting",
	"feDisplacementMap",
	"feDistantLight",
	"feDropShadow",
	"feFlood",
	"feFuncA",
	"feFuncB",
	"feFuncG",
	"feFuncR",
	"feGaussianBlur",
	"feImage",
	"feMerge",
	"feMergeNode",
	"feMorphology",
	"feOffset",
	"fePointLight",
	"feSpecularLighting",
	"feSpotLight",
	"feTile",
	"feTurbulence"
]), $x = gx([
	"animate",
	"color-profile",
	"cursor",
	"discard",
	"font-face",
	"font-face-format",
	"font-face-name",
	"font-face-src",
	"font-face-uri",
	"foreignobject",
	"hatch",
	"hatchpath",
	"mesh",
	"meshgradient",
	"meshpatch",
	"meshrow",
	"missing-glyph",
	"script",
	"set",
	"solidcolor",
	"unknown",
	"use"
]), eS = gx(/* @__PURE__ */ "math.menclose.merror.mfenced.mfrac.mglyph.mi.mlabeledtr.mmultiscripts.mn.mo.mover.mpadded.mphantom.mroot.mrow.ms.mspace.msqrt.mstyle.msub.msup.msubsup.mtable.mtd.mtext.mtr.munder.munderover.mprescripts".split(".")), tS = gx([
	"maction",
	"maligngroup",
	"malignmark",
	"mlongdiv",
	"mscarries",
	"mscarry",
	"msgroup",
	"mstack",
	"msline",
	"msrow",
	"semantics",
	"annotation",
	"annotation-xml",
	"mprescripts",
	"none"
]), nS = gx(["#text"]), rS = gx(/* @__PURE__ */ "accept.action.align.alt.autocapitalize.autocomplete.autopictureinpicture.autoplay.background.bgcolor.border.capture.cellpadding.cellspacing.checked.cite.class.clear.color.cols.colspan.command.commandfor.controls.controlslist.coords.crossorigin.datetime.decoding.default.dir.disabled.disablepictureinpicture.disableremoteplayback.download.draggable.enctype.enterkeyhint.exportparts.face.for.headers.height.hidden.high.href.hreflang.id.inert.inputmode.integrity.ismap.kind.label.lang.list.loading.loop.low.max.maxlength.media.method.min.minlength.multiple.muted.name.nonce.noshade.novalidate.nowrap.open.optimum.part.pattern.placeholder.playsinline.popover.popovertarget.popovertargetaction.poster.preload.pubdate.radiogroup.readonly.rel.required.rev.reversed.role.rows.rowspan.spellcheck.scope.selected.shape.size.sizes.slot.span.srclang.start.src.srcset.step.style.summary.tabindex.title.translate.type.usemap.valign.value.width.wrap.xmlns".split(".")), iS = gx(/* @__PURE__ */ "accent-height.accumulate.additive.alignment-baseline.amplitude.ascent.attributename.attributetype.azimuth.basefrequency.baseline-shift.begin.bias.by.class.clip.clippathunits.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.cx.cy.d.dx.dy.diffuseconstant.direction.display.divisor.dur.edgemode.elevation.end.exponent.fill.fill-opacity.fill-rule.filter.filterunits.flood-color.flood-opacity.font-family.font-size.font-size-adjust.font-stretch.font-style.font-variant.font-weight.fx.fy.g1.g2.glyph-name.glyphref.gradientunits.gradienttransform.height.href.id.image-rendering.in.in2.intercept.k.k1.k2.k3.k4.kerning.keypoints.keysplines.keytimes.lang.lengthadjust.letter-spacing.kernelmatrix.kernelunitlength.lighting-color.local.marker-end.marker-mid.marker-start.markerheight.markerunits.markerwidth.maskcontentunits.maskunits.max.mask.mask-type.media.method.mode.min.name.numoctaves.offset.operator.opacity.order.orient.orientation.origin.overflow.paint-order.path.pathlength.patterncontentunits.patterntransform.patternunits.points.preservealpha.preserveaspectratio.primitiveunits.r.rx.ry.radius.refx.refy.repeatcount.repeatdur.restart.result.rotate.scale.seed.shape-rendering.slope.specularconstant.specularexponent.spreadmethod.startoffset.stddeviation.stitchtiles.stop-color.stop-opacity.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke.stroke-width.style.surfacescale.systemlanguage.tabindex.tablevalues.targetx.targety.transform.transform-origin.text-anchor.text-decoration.text-rendering.textlength.type.u1.u2.unicode.values.viewbox.visibility.version.vert-adv-y.vert-origin-x.vert-origin-y.width.word-spacing.wrap.writing-mode.xchannelselector.ychannelselector.x.x1.x2.xmlns.y.y1.y2.z.zoomandpan".split(".")), aS = gx(/* @__PURE__ */ "accent.accentunder.align.bevelled.close.columnalign.columnlines.columnspacing.columnspan.denomalign.depth.dir.display.displaystyle.encoding.fence.frame.height.href.id.largeop.length.linethickness.lquote.lspace.mathbackground.mathcolor.mathsize.mathvariant.maxsize.minsize.movablelimits.notation.numalign.open.rowalign.rowlines.rowspacing.rowspan.rspace.rquote.scriptlevel.scriptminsize.scriptsizemultiplier.selection.separator.separators.stretchy.subscriptshift.supscriptshift.symmetric.voffset.width.xmlns".split(".")), oS = gx([
	"xlink:href",
	"xml:id",
	"xlink:title",
	"xml:space",
	"xmlns:xlink"
]), sS = _x(/{{[\w\W]*|^[\w\W]*}}/g), cS = _x(/<%[\w\W]*|^[\w\W]*%>/g), lS = _x(/\${[\w\W]*/g), uS = _x(/^data-[\-\w.\u00B7-\uFFFF]+$/), dS = _x(/^aria-[\-\w]+$/), fS = _x(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), pS = _x(/^(?:\w+script|data):/i), mS = _x(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), hS = _x(/^html$/i), gS = _x(/^[a-z][.\w]*(-[.\w]+)+$/i), _S = _x(/<[/\w!]/g), vS = _x(/<[/\w]/g), yS = _x(/<\/no(script|embed|frames)/i), bS = _x(/\/>/i), xS = {
	element: 1,
	attribute: 2,
	text: 3,
	cdataSection: 4,
	entityReference: 5,
	entityNode: 6,
	processingInstruction: 7,
	comment: 8,
	document: 9,
	documentType: 10,
	documentFragment: 11,
	notation: 12
}, SS = function() {
	return typeof window > "u" ? null : window;
}, CS = function(e, t) {
	if (typeof e != "object" || typeof e.createPolicy != "function") return null;
	let n = null, r = "data-tt-policy-suffix";
	t && t.hasAttribute(r) && (n = t.getAttribute(r));
	let i = "dompurify" + (n ? "#" + n : "");
	try {
		return e.createPolicy(i, {
			createHTML(e) {
				return e;
			},
			createScriptURL(e) {
				return e;
			}
		});
	} catch {
		return console.warn("TrustedTypes policy " + i + " could not be created."), null;
	}
}, wS = function() {
	return {
		afterSanitizeAttributes: [],
		afterSanitizeElements: [],
		afterSanitizeShadowDOM: [],
		beforeSanitizeAttributes: [],
		beforeSanitizeElements: [],
		beforeSanitizeShadowDOM: [],
		uponSanitizeAttribute: [],
		uponSanitizeElement: [],
		uponSanitizeShadowNode: []
	};
}, TS = function(e, t, n, r) {
	return Rx(e, t) && Dx(e[t]) ? Wx(r.base ? Kx(r.base) : {}, e[t], r.transform) : n;
};
function ES() {
	let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : SS(), t = (e) => ES(e);
	if (t.version = "3.4.11", t.removed = [], !e || !e.document || e.document.nodeType !== xS.document || !e.Element) return t.isSupported = !1, t;
	let n = e.document, r = n, i = r.currentScript;
	e.DocumentFragment;
	let a = e.HTMLTemplateElement, o = e.Node, s = e.Element, c = e.NodeFilter;
	e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
	let l = e.DOMParser, u = e.trustedTypes, d = s.prototype, f = Jx(d, "cloneNode"), p = Jx(d, "remove"), m = Jx(d, "nextSibling"), h = Jx(d, "childNodes"), g = Jx(d, "parentNode"), _ = Jx(d, "shadowRoot"), v = Jx(d, "attributes"), y = o && o.prototype ? Jx(o.prototype, "nodeType") : null, b = o && o.prototype ? Jx(o.prototype, "nodeName") : null;
	if (typeof a == "function") {
		let e = n.createElement("template");
		e.content && e.content.ownerDocument && (n = e.content.ownerDocument);
	}
	let x, S = "", C, w = !1, T = 0, E = function() {
		if (T > 0) throw Vx("A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the \"DOMPurify and Trusted Types\" section of the README.");
	}, D = function(e) {
		E(), T++;
		try {
			return x.createHTML(e);
		} finally {
			T--;
		}
	}, O = function(e) {
		E(), T++;
		try {
			return x.createScriptURL(e);
		} finally {
			T--;
		}
	}, k = function() {
		return w ||= (C = CS(u, i), !0), C;
	}, A = n, j = A.implementation, M = A.createNodeIterator, N = A.createDocumentFragment, P = A.getElementsByTagName, F = r.importNode, I = wS();
	t.isSupported = typeof dx == "function" && typeof g == "function" && j && j.createHTMLDocument !== void 0;
	let ee = sS, L = cS, te = lS, ne = uS, re = dS, R = pS, ie = mS, ae = gS, z = fS, oe = null, se = Wx({}, [
		...Xx,
		...Zx,
		...Qx,
		...eS,
		...nS
	]), ce = null, le = Wx({}, [
		...rS,
		...iS,
		...aS,
		...oS
	]), ue = Object.seal(vx(null, {
		tagNameCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		attributeNameCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		allowCustomizedBuiltInElements: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: !1
		}
	})), de = null, fe = null, pe = Object.seal(vx(null, {
		tagCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		attributeCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		}
	})), me = !0, he = !0, ge = !1, _e = !0, ve = !1, ye = !0, be = !1, xe = !1, Se = null, Ce = null, we = !1, Te = !1, Ee = !1, De = !1, Oe = !0, ke = !1, Ae = "user-content-", je = !0, Me = !1, Ne = {}, Pe = null, Fe = Wx({}, /* @__PURE__ */ "annotation-xml.audio.colgroup.desc.foreignobject.head.iframe.math.mi.mn.mo.ms.mtext.noembed.noframes.noscript.plaintext.script.selectedcontent.style.svg.template.thead.title.video.xmp".split(".")), Ie = null, Le = Wx({}, [
		"audio",
		"video",
		"img",
		"source",
		"image",
		"track"
	]), Re = null, ze = Wx({}, [
		"alt",
		"class",
		"for",
		"id",
		"label",
		"name",
		"pattern",
		"placeholder",
		"role",
		"summary",
		"title",
		"value",
		"style",
		"xmlns"
	]), Be = "http://www.w3.org/1998/Math/MathML", B = "http://www.w3.org/2000/svg", V = "http://www.w3.org/1999/xhtml", Ve = V, He = !1, Ue = null, H = Wx({}, [
		Be,
		B,
		V
	], kx), We = gx([
		"mi",
		"mo",
		"mn",
		"ms",
		"mtext"
	]), Ge = Wx({}, We), Ke = gx(["annotation-xml"]), qe = Wx({}, Ke), Je = Wx({}, [
		"title",
		"style",
		"font",
		"a",
		"script"
	]), Ye = null, U = ["application/xhtml+xml", "text/html"], Xe = null, Ze = null, Qe = n.createElement("form"), $e = function(e) {
		return e instanceof RegExp || e instanceof Function;
	}, W = function() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		if (Ze && Ze === e) return;
		(!e || typeof e != "object") && (e = {}), e = Kx(e), Ye = U.indexOf(e.PARSER_MEDIA_TYPE) === -1 ? "text/html" : e.PARSER_MEDIA_TYPE, Xe = Ye === "application/xhtml+xml" ? kx : Ox, oe = TS(e, "ALLOWED_TAGS", se, { transform: Xe }), ce = TS(e, "ALLOWED_ATTR", le, { transform: Xe }), Ue = TS(e, "ALLOWED_NAMESPACES", H, { transform: kx }), Re = TS(e, "ADD_URI_SAFE_ATTR", ze, {
			transform: Xe,
			base: ze
		}), Ie = TS(e, "ADD_DATA_URI_TAGS", Le, {
			transform: Xe,
			base: Le
		}), Pe = TS(e, "FORBID_CONTENTS", Fe, { transform: Xe }), de = TS(e, "FORBID_TAGS", Kx({}), { transform: Xe }), fe = TS(e, "FORBID_ATTR", Kx({}), { transform: Xe }), Ne = Rx(e, "USE_PROFILES") ? e.USE_PROFILES && typeof e.USE_PROFILES == "object" ? Kx(e.USE_PROFILES) : e.USE_PROFILES : !1, me = e.ALLOW_ARIA_ATTR !== !1, he = e.ALLOW_DATA_ATTR !== !1, ge = e.ALLOW_UNKNOWN_PROTOCOLS || !1, _e = e.ALLOW_SELF_CLOSE_IN_ATTR !== !1, ve = e.SAFE_FOR_TEMPLATES || !1, ye = e.SAFE_FOR_XML !== !1, be = e.WHOLE_DOCUMENT || !1, Te = e.RETURN_DOM || !1, Ee = e.RETURN_DOM_FRAGMENT || !1, De = e.RETURN_TRUSTED_TYPE || !1, we = e.FORCE_BODY || !1, Oe = e.SANITIZE_DOM !== !1, ke = e.SANITIZE_NAMED_PROPS || !1, je = e.KEEP_CONTENT !== !1, Me = e.IN_PLACE || !1, z = Yx(e.ALLOWED_URI_REGEXP) ? e.ALLOWED_URI_REGEXP : fS, Ve = typeof e.NAMESPACE == "string" ? e.NAMESPACE : V, Ge = Rx(e, "MATHML_TEXT_INTEGRATION_POINTS") && e.MATHML_TEXT_INTEGRATION_POINTS && typeof e.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Kx(e.MATHML_TEXT_INTEGRATION_POINTS) : Wx({}, We), qe = Rx(e, "HTML_INTEGRATION_POINTS") && e.HTML_INTEGRATION_POINTS && typeof e.HTML_INTEGRATION_POINTS == "object" ? Kx(e.HTML_INTEGRATION_POINTS) : Wx({}, Ke);
		let t = Rx(e, "CUSTOM_ELEMENT_HANDLING") && e.CUSTOM_ELEMENT_HANDLING && typeof e.CUSTOM_ELEMENT_HANDLING == "object" ? Kx(e.CUSTOM_ELEMENT_HANDLING) : vx(null);
		if (ue = vx(null), Rx(t, "tagNameCheck") && $e(t.tagNameCheck) && (ue.tagNameCheck = t.tagNameCheck), Rx(t, "attributeNameCheck") && $e(t.attributeNameCheck) && (ue.attributeNameCheck = t.attributeNameCheck), Rx(t, "allowCustomizedBuiltInElements") && typeof t.allowCustomizedBuiltInElements == "boolean" && (ue.allowCustomizedBuiltInElements = t.allowCustomizedBuiltInElements), _x(ue), ve && (he = !1), Ee && (Te = !0), Ne && (oe = Wx({}, nS), ce = vx(null), Ne.html === !0 && (Wx(oe, Xx), Wx(ce, rS)), Ne.svg === !0 && (Wx(oe, Zx), Wx(ce, iS), Wx(ce, oS)), Ne.svgFilters === !0 && (Wx(oe, Qx), Wx(ce, iS), Wx(ce, oS)), Ne.mathMl === !0 && (Wx(oe, eS), Wx(ce, aS), Wx(ce, oS))), pe.tagCheck = null, pe.attributeCheck = null, Rx(e, "ADD_TAGS") && (typeof e.ADD_TAGS == "function" ? pe.tagCheck = e.ADD_TAGS : Dx(e.ADD_TAGS) && (oe === se && (oe = Kx(oe)), Wx(oe, e.ADD_TAGS, Xe))), Rx(e, "ADD_ATTR") && (typeof e.ADD_ATTR == "function" ? pe.attributeCheck = e.ADD_ATTR : Dx(e.ADD_ATTR) && (ce === le && (ce = Kx(ce)), Wx(ce, e.ADD_ATTR, Xe))), Rx(e, "ADD_URI_SAFE_ATTR") && Dx(e.ADD_URI_SAFE_ATTR) && Wx(Re, e.ADD_URI_SAFE_ATTR, Xe), Rx(e, "FORBID_CONTENTS") && Dx(e.FORBID_CONTENTS) && (Pe === Fe && (Pe = Kx(Pe)), Wx(Pe, e.FORBID_CONTENTS, Xe)), Rx(e, "ADD_FORBID_CONTENTS") && Dx(e.ADD_FORBID_CONTENTS) && (Pe === Fe && (Pe = Kx(Pe)), Wx(Pe, e.ADD_FORBID_CONTENTS, Xe)), je && (oe["#text"] = !0), be && Wx(oe, [
			"html",
			"head",
			"body"
		]), oe.table && (Wx(oe, ["tbody"]), delete de.tbody), e.TRUSTED_TYPES_POLICY) {
			if (typeof e.TRUSTED_TYPES_POLICY.createHTML != "function") throw Vx("TRUSTED_TYPES_POLICY configuration option must provide a \"createHTML\" hook.");
			if (typeof e.TRUSTED_TYPES_POLICY.createScriptURL != "function") throw Vx("TRUSTED_TYPES_POLICY configuration option must provide a \"createScriptURL\" hook.");
			let t = x;
			x = e.TRUSTED_TYPES_POLICY;
			try {
				S = D("");
			} catch (e) {
				throw x = t, e;
			}
		} else e.TRUSTED_TYPES_POLICY === null ? (x = void 0, S = "") : (x === void 0 && (x = k()), x && typeof S == "string" && (S = D("")));
		gx && gx(e), Ze = e;
	}, et = Wx({}, [
		...Zx,
		...Qx,
		...$x
	]), tt = Wx({}, [...eS, ...tS]), nt = function(e, t, n) {
		return t.namespaceURI === V ? e === "svg" : t.namespaceURI === Be ? e === "svg" && (n === "annotation-xml" || Ge[n]) : !!et[e];
	}, rt = function(e, t, n) {
		return t.namespaceURI === V ? e === "math" : t.namespaceURI === B ? e === "math" && qe[n] : !!tt[e];
	}, it = function(e, t, n) {
		return t.namespaceURI === B && !qe[n] || t.namespaceURI === Be && !Ge[n] ? !1 : !tt[e] && (Je[e] || !et[e]);
	}, at = function(e) {
		let t = g(e);
		(!t || !t.tagName) && (t = {
			namespaceURI: Ve,
			tagName: "template"
		});
		let n = Ox(e.tagName), r = Ox(t.tagName);
		return Ue[e.namespaceURI] ? e.namespaceURI === B ? nt(n, t, r) : e.namespaceURI === Be ? rt(n, t, r) : e.namespaceURI === V ? it(n, t, r) : !!(Ye === "application/xhtml+xml" && Ue[e.namespaceURI]) : !1;
	}, ot = function(e) {
		Tx(t.removed, { element: e });
		try {
			g(e).removeChild(e);
		} catch {
			if (p(e), !g(e)) throw Vx("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
		}
	}, st = function(e) {
		let t = h(e);
		if (t) {
			let e = [];
			Sx(t, (t) => {
				Tx(e, t);
			}), Sx(e, (e) => {
				try {
					p(e);
				} catch {}
			});
		}
		let n = v(e);
		if (n) for (let t = n.length - 1; t >= 0; --t) {
			let r = n[t], i = r && r.name;
			if (typeof i == "string") try {
				e.removeAttribute(i);
			} catch {}
		}
	}, ct = function(e, n) {
		try {
			Tx(t.removed, {
				attribute: n.getAttributeNode(e),
				from: n
			});
		} catch {
			Tx(t.removed, {
				attribute: null,
				from: n
			});
		}
		if (n.removeAttribute(e), e === "is") if (Te || Ee) try {
			ot(n);
		} catch {}
		else try {
			n.setAttribute(e, "");
		} catch {}
	}, lt = function(e) {
		let t = v(e);
		if (t) for (let n = t.length - 1; n >= 0; --n) {
			let r = t[n], i = r && r.name;
			if (!(typeof i != "string" || ce[Xe(i)])) try {
				e.removeAttribute(i);
			} catch {}
		}
	}, ut = function(e) {
		let t = [e];
		for (; t.length > 0;) {
			let e = t.pop();
			(y ? y(e) : e.nodeType) === xS.element && lt(e);
			let n = h(e);
			if (n) for (let e = n.length - 1; e >= 0; --e) t.push(n[e]);
		}
	}, dt = function(e) {
		let t = null, r = null;
		if (we) e = "<remove></remove>" + e;
		else {
			let t = Ax(e, /^[\r\n\t ]+/);
			r = t && t[0];
		}
		Ye === "application/xhtml+xml" && Ve === V && (e = "<html xmlns=\"http://www.w3.org/1999/xhtml\"><head></head><body>" + e + "</body></html>");
		let i = x ? D(e) : e;
		if (Ve === V) try {
			t = new l().parseFromString(i, Ye);
		} catch {}
		if (!t || !t.documentElement) {
			t = j.createDocument(Ve, "template", null);
			try {
				t.documentElement.innerHTML = He ? S : i;
			} catch {}
		}
		let a = t.body || t.documentElement;
		return e && r && a.insertBefore(n.createTextNode(r), a.childNodes[0] || null), Ve === V ? P.call(t, be ? "html" : "body")[0] : be ? t.documentElement : a;
	}, ft = function(e) {
		return M.call(e.ownerDocument || e, e, c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION, null);
	}, pt = function(e) {
		return e = jx(e, ee, " "), e = jx(e, L, " "), e = jx(e, te, " "), e;
	}, G = function(e) {
		e.normalize();
		let t = M.call(e.ownerDocument || e, e, c.SHOW_TEXT | c.SHOW_COMMENT | c.SHOW_CDATA_SECTION | c.SHOW_PROCESSING_INSTRUCTION, null), n = t.nextNode();
		for (; n;) n.data = pt(n.data), n = t.nextNode();
		let r = e.querySelectorAll?.call(e, "template");
		r && Sx(r, (e) => {
			q(e.content) && G(e.content);
		});
	}, K = function(e) {
		let t = b ? b(e) : null;
		return typeof t != "string" || Xe(t) !== "form" ? !1 : typeof e.nodeName != "string" || typeof e.textContent != "string" || typeof e.removeChild != "function" || e.attributes !== v(e) || typeof e.removeAttribute != "function" || typeof e.setAttribute != "function" || typeof e.namespaceURI != "string" || typeof e.insertBefore != "function" || typeof e.hasChildNodes != "function" || e.nodeType !== y(e) || e.childNodes !== h(e);
	}, q = function(e) {
		if (!y || typeof e != "object" || !e) return !1;
		try {
			return y(e) === xS.documentFragment;
		} catch {
			return !1;
		}
	}, mt = function(e) {
		if (!y || typeof e != "object" || !e) return !1;
		try {
			return typeof y(e) == "number";
		} catch {
			return !1;
		}
	};
	function ht(e, n, r) {
		e.length !== 0 && Sx(e, (e) => {
			e.call(t, n, r, Ze);
		});
	}
	let gt = function(e, t) {
		return !!(ye && e.hasChildNodes() && !mt(e.firstElementChild) && Bx(_S, e.textContent) && Bx(_S, e.innerHTML) || ye && e.namespaceURI === V && t === "style" && mt(e.firstElementChild) || e.nodeType === xS.processingInstruction || ye && e.nodeType === xS.comment && Bx(vS, e.data));
	}, _t = function(e, t) {
		if (!de[t] && xt(t) && (ue.tagNameCheck instanceof RegExp && Bx(ue.tagNameCheck, t) || ue.tagNameCheck instanceof Function && ue.tagNameCheck(t))) return !1;
		if (je && !Pe[t]) {
			let t = g(e), n = h(e);
			if (n && t) {
				let r = n.length;
				for (let i = r - 1; i >= 0; --i) {
					let r = Me ? n[i] : f(n[i], !0);
					t.insertBefore(r, m(e));
				}
			}
		}
		return ot(e), !0;
	}, vt = function(e) {
		if (ht(I.beforeSanitizeElements, e, null), K(e)) return ot(e), !0;
		let n = Xe(b ? b(e) : e.nodeName);
		if (ht(I.uponSanitizeElement, e, {
			tagName: n,
			allowedTags: oe
		}), gt(e, n)) return ot(e), !0;
		if (de[n] || !(pe.tagCheck instanceof Function && pe.tagCheck(n)) && !oe[n]) return _t(e, n);
		if ((y ? y(e) : e.nodeType) === xS.element && !at(e) || (n === "noscript" || n === "noembed" || n === "noframes") && Bx(yS, e.innerHTML)) return ot(e), !0;
		if (ve && e.nodeType === xS.text) {
			let n = pt(e.textContent);
			e.textContent !== n && (Tx(t.removed, { element: e.cloneNode() }), e.textContent = n);
		}
		return ht(I.afterSanitizeElements, e, null), !1;
	}, yt = function(e, t, r) {
		if (fe[t] || Oe && (t === "id" || t === "name") && (r in n || r in Qe)) return !1;
		let i = ce[t] || pe.attributeCheck instanceof Function && pe.attributeCheck(t, e);
		if (!(he && Bx(ne, t)) && !(me && Bx(re, t))) {
			if (!i) {
				if (!(xt(e) && (ue.tagNameCheck instanceof RegExp && Bx(ue.tagNameCheck, e) || ue.tagNameCheck instanceof Function && ue.tagNameCheck(e)) && (ue.attributeNameCheck instanceof RegExp && Bx(ue.attributeNameCheck, t) || ue.attributeNameCheck instanceof Function && ue.attributeNameCheck(t, e)) || t === "is" && ue.allowCustomizedBuiltInElements && (ue.tagNameCheck instanceof RegExp && Bx(ue.tagNameCheck, r) || ue.tagNameCheck instanceof Function && ue.tagNameCheck(r)))) return !1;
			} else if (!Re[t] && !Bx(z, jx(r, ie, "")) && !((t === "src" || t === "xlink:href" || t === "href") && e !== "script" && Mx(r, "data:") === 0 && Ie[e]) && !(ge && !Bx(R, jx(r, ie, ""))) && r) return !1;
		}
		return !0;
	}, bt = Wx({}, [
		"annotation-xml",
		"color-profile",
		"font-face",
		"font-face-format",
		"font-face-name",
		"font-face-src",
		"font-face-uri",
		"missing-glyph"
	]), xt = function(e) {
		return !bt[Ox(e)] && Bx(ae, e);
	}, St = function(e, t, n, r) {
		if (x && typeof u == "object" && typeof u.getAttributeType == "function" && !n) switch (u.getAttributeType(e, t)) {
			case "TrustedHTML": return D(r);
			case "TrustedScriptURL": return O(r);
		}
		return r;
	}, Ct = function(e, n, r, i) {
		try {
			r ? e.setAttributeNS(r, n, i) : e.setAttribute(n, i), K(e) ? ot(e) : wx(t.removed);
		} catch {
			ct(n, e);
		}
	}, wt = function(e) {
		ht(I.beforeSanitizeAttributes, e, null);
		let t = e.attributes;
		if (!t || K(e)) return;
		let n = {
			attrName: "",
			attrValue: "",
			keepAttr: !0,
			allowedAttributes: ce,
			forceKeepAttr: void 0
		}, r = t.length, i = Xe(e.nodeName);
		for (; r--;) {
			let a = t[r], o = a.name, s = a.namespaceURI, c = a.value, l = Xe(o), u = c, d = o === "value" ? u : Nx(u);
			if (n.attrName = l, n.attrValue = d, n.keepAttr = !0, n.forceKeepAttr = void 0, ht(I.uponSanitizeAttribute, e, n), d = n.attrValue, ke && (l === "id" || l === "name") && Mx(d, Ae) !== 0 && (ct(o, e), d = Ae + d), ye && Bx(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, d)) {
				ct(o, e);
				continue;
			}
			if (l === "attributename" && Ax(d, "href")) {
				ct(o, e);
				continue;
			}
			if (!n.forceKeepAttr) {
				if (!n.keepAttr) {
					ct(o, e);
					continue;
				}
				if (!_e && Bx(bS, d)) {
					ct(o, e);
					continue;
				}
				if (ve && (d = pt(d)), !yt(i, l, d)) {
					ct(o, e);
					continue;
				}
				d = St(i, l, s, d), d !== u && Ct(e, o, s, d);
			}
		}
		ht(I.afterSanitizeAttributes, e, null);
	}, Tt = function(e) {
		let t = null, n = ft(e);
		for (ht(I.beforeSanitizeShadowDOM, e, null); t = n.nextNode();) if (ht(I.uponSanitizeShadowNode, t, null), vt(t), wt(t), q(t.content) && Tt(t.content), (y ? y(t) : t.nodeType) === xS.element) {
			let e = _(t);
			q(e) && (Et(e), Tt(e));
		}
		ht(I.afterSanitizeShadowDOM, e, null);
	}, Et = function(e) {
		let t = [{
			node: e,
			shadow: null
		}];
		for (; t.length > 0;) {
			let e = t.pop();
			if (e.shadow) {
				Tt(e.shadow);
				continue;
			}
			let n = e.node, r = (y ? y(n) : n.nodeType) === xS.element, i = h(n);
			if (i) for (let e = i.length - 1; e >= 0; --e) t.push({
				node: i[e],
				shadow: null
			});
			if (r) {
				let e = b ? b(n) : null;
				if (typeof e == "string" && Xe(e) === "template") {
					let e = n.content;
					q(e) && t.push({
						node: e,
						shadow: null
					});
				}
			}
			if (r) {
				let e = _(n);
				q(e) && t.push({
					node: null,
					shadow: e
				}, {
					node: e,
					shadow: null
				});
			}
		}
	};
	return t.sanitize = function(e) {
		let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = null, a = null, o = null, s = null;
		if (He = !e, He && (e = "<!-->"), typeof e != "string" && !mt(e) && (e = qx(e), typeof e != "string")) throw Vx("dirty is not a string, aborting");
		if (!t.isSupported) return e;
		xe ? (oe = Se, ce = Ce) : W(n), (I.uponSanitizeElement.length > 0 || I.uponSanitizeAttribute.length > 0) && (oe = Kx(oe)), I.uponSanitizeAttribute.length > 0 && (ce = Kx(ce)), t.removed = [];
		let c = Me && typeof e != "string" && mt(e);
		if (c) {
			let t = b ? b(e) : e.nodeName;
			if (typeof t == "string") {
				let e = Xe(t);
				if (!oe[e] || de[e]) throw Vx("root node is forbidden and cannot be sanitized in-place");
			}
			if (K(e)) throw Vx("root node is clobbered and cannot be sanitized in-place");
			try {
				Et(e);
			} catch (t) {
				throw st(e), t;
			}
		} else if (mt(e)) i = dt("<!---->"), a = i.ownerDocument.importNode(e, !0), a.nodeType === xS.element && a.nodeName === "BODY" || a.nodeName === "HTML" ? i = a : i.appendChild(a), Et(a);
		else {
			if (!Te && !ve && !be && e.indexOf("<") === -1) return x && De ? D(e) : e;
			if (i = dt(e), !i) return Te ? null : De ? S : "";
		}
		i && we && ot(i.firstChild);
		let l = ft(c ? e : i);
		try {
			for (; o = l.nextNode();) vt(o), wt(o), q(o.content) && Tt(o.content);
		} catch (t) {
			throw c && st(e), t;
		}
		if (c) return Sx(t.removed, (e) => {
			e.element && ut(e.element);
		}), ve && G(e), e;
		if (Te) {
			if (ve && G(i), Ee) for (s = N.call(i.ownerDocument); i.firstChild;) s.appendChild(i.firstChild);
			else s = i;
			return (ce.shadowroot || ce.shadowrootmode) && (s = F.call(r, s, !0)), s;
		}
		let u = be ? i.outerHTML : i.innerHTML;
		return be && oe["!doctype"] && i.ownerDocument && i.ownerDocument.doctype && i.ownerDocument.doctype.name && Bx(hS, i.ownerDocument.doctype.name) && (u = "<!DOCTYPE " + i.ownerDocument.doctype.name + ">\n" + u), ve && (u = pt(u)), x && De ? D(u) : u;
	}, t.setConfig = function() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		W(e), xe = !0, Se = oe, Ce = ce;
	}, t.clearConfig = function() {
		Ze = null, xe = !1, Se = null, Ce = null, x = C, S = "";
	}, t.isValidAttribute = function(e, t, n) {
		Ze || W({});
		let r = Xe(e), i = Xe(t);
		return yt(r, i, n);
	}, t.addHook = function(e, t) {
		typeof t == "function" && Rx(I, e) && Tx(I[e], t);
	}, t.removeHook = function(e, t) {
		if (Rx(I, e)) {
			if (t !== void 0) {
				let n = Cx(I[e], t);
				return n === -1 ? void 0 : Ex(I[e], n, 1)[0];
			}
			return wx(I[e]);
		}
	}, t.removeHooks = function(e) {
		Rx(I, e) && (I[e] = []);
	}, t.removeAllHooks = function() {
		I = wS();
	}, t;
}
var DS = ES(), OS = {
	messageContainer: "_messageContainer_1rxr4_1",
	chip: "_chip_1rxr4_7",
	chipLabel: "_chipLabel_1rxr4_10",
	chipValue: "_chipValue_1rxr4_13"
}, kS = {
	INBOUND: {
		background: "var(--dixa-color-neutral-000)",
		borderColor: "var(--dixa-color-neutral-100)"
	},
	OUTBOUND: {
		background: "var(--dixa-color-neutral-100)",
		borderColor: "var(--dixa-color-neutral-200)"
	},
	INTERNAL: {
		background: "var(--dixa-color-orange-100)",
		borderColor: "var(--dixa-color-orange-200)"
	}
}, AS = ({ messages: n, customFields: r, attachments: a, conversationContext: o }) => {
	U(() => {
		document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
	}, [n]);
	let s = () => {
		let e = "Contact";
		if (!o?.customer) return e;
		let { name: t, given_name: n, family_name: r, email: i, phone_number: a } = o.customer;
		return t ?? n ?? r ?? i ?? a ?? e;
	};
	return /* @__PURE__ */ q(_, {
		flexDirection: "column",
		gap: "200",
		children: [
			/* @__PURE__ */ K(_, {
				flexDirection: "row",
				flexWrap: "wrap",
				margin: "0 0 300",
				children: !!r?.length && /* @__PURE__ */ q(_, {
					gap: "100",
					children: [/* @__PURE__ */ K(R, {
						content: "Conversation Attributes",
						children: /* @__PURE__ */ K(t, {
							icon: "input",
							color: {
								contentColor: "var(--dixa-color-neutral-700)",
								backgroundColor: "var(--dixa-color-neutral-200)"
							}
						})
					}), r.map((e, t) => /* @__PURE__ */ K(_, {
						alignItems: "center",
						children: /* @__PURE__ */ K(I, {
							className: OS.chip,
							children: /* @__PURE__ */ q(_, {
								gap: "100",
								children: [/* @__PURE__ */ q(i, {
									className: OS.chipLabel,
									children: [e.name, ":"]
								}), /* @__PURE__ */ K(i, {
									className: OS.chipValue,
									children: e.value
								})]
							})
						})
					}, `${t}-${e.name}`))]
				})
			}),
			n?.map((e) => /* @__PURE__ */ K(_, {
				className: OS.messageContainer,
				gap: "200",
				style: {
					backgroundColor: e?.direction ? kS[e.direction].background : "var(--dixa-color-neutral-000)",
					borderColor: e?.direction ? kS[e.direction].borderColor : "var(--dixa-color-neutral-100)"
				},
				children: /* @__PURE__ */ q(_, {
					flexDirection: "column",
					gap: "200",
					width: "100%",
					children: [/* @__PURE__ */ q(_, {
						flexDirection: "row",
						justifyContent: "space-between",
						children: [/* @__PURE__ */ K(L.Heading, {
							variant: "heading-3",
							children: e?.direction == "INBOUND" ? s() : e?.agent?.name
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: /* @__PURE__ */ K(re, {
								relative: !0,
								time: e?.created_at
							})
						})]
					}), /* @__PURE__ */ K("div", { dangerouslySetInnerHTML: { __html: DS.sanitize(e?.body?.replaceAll(/\r\n?|\n/g, "<br />") || "") } })]
				})
			}, e?.created_at)),
			a && /* @__PURE__ */ K(_, {
				gap: "200",
				flexDirection: "row",
				flexWrap: "wrap",
				margin: "300 0 0",
				children: a.map((t, n) => /* @__PURE__ */ K(e, {
					fileName: t.url,
					label: t.label,
					onDownload: () => {
						window.open(t.url, "_blank")?.focus();
					}
				}, `${n}-${t.url}`))
			}),
			/* @__PURE__ */ K("div", {
				id: "endOfConversationAnchor",
				children: "\xA0"
			})
		]
	});
}, jS = {
	conversation: "_conversation_1draa_1",
	conversationSubLine: "_conversationSubLine_1draa_9",
	modal: "_modal_1draa_14"
}, MS = (e) => (e && JSON.parse(e) || []).map((e) => ({
	url: e.URL__c,
	label: e.Name,
	type: e.File_Type__c
})), NS = (e) => Object.entries(e || {}).filter(([e]) => e.endsWith("__c")).map(([e, t]) => ({
	name: e.replace("__c", "").replaceAll("_", " "),
	value: t?.value ? t.value.toString() : ""
})), PS = ({ conversation: e, conversationContext: t }) => {
	let [r, i] = W(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
	return /* @__PURE__ */ q(_, {
		className: jS.conversation,
		gap: "300",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			justifyContent: "space-between",
			alignItems: "center",
			children: [/* @__PURE__ */ q(_, {
				flexDirection: "column",
				gap: "100",
				children: [
					/* @__PURE__ */ q(_, {
						flexDirection: "row",
						gap: "100",
						children: [/* @__PURE__ */ K(L.Heading, {
							variant: "heading-4",
							children: e?.id
						}), a && /* @__PURE__ */ K(n, {
							size: "small",
							variant: "info",
							children: ix(e?.created_at).format("DD MMM YYYY @ HH:mm")
						})]
					}),
					/* @__PURE__ */ K(L.Heading, {
						variant: "heading-4",
						className: jS.conversationSubLine,
						children: e?.subject
					}),
					!!e?.labels?.length && /* @__PURE__ */ K(_, {
						gap: "200",
						flexDirection: "row",
						flexWrap: "wrap",
						children: [...new Set(e.labels)].map((t) => /* @__PURE__ */ K(I, { children: t }, `${e.id}-${t}`))
					})
				]
			}), /* @__PURE__ */ K(R, {
				content: "Show conversation preview",
				children: /* @__PURE__ */ K(x, {
					variant: "secondary",
					icon: "eye",
					onClick: () => i(!0),
					"data-testid": "open-messages-preview"
				})
			})]
		}), /* @__PURE__ */ q(E, {
			isOpen: r,
			allowEscClose: !0,
			onClose: () => i(!1),
			className: jS.modal,
			children: [/* @__PURE__ */ K(k, {
				title: "Conversation preview",
				onClose: () => i(!1)
			}), /* @__PURE__ */ K(D, { children: /* @__PURE__ */ K(AS, {
				messages: e?.messages || [],
				...s && { attachments: MS(o?.attachments?.value) },
				conversationContext: t,
				customFields: NS(e?.custom_fields)
			}) })]
		})]
	});
}, FS = ({ conversations: e, conversationContext: t, conversationsToShow: n }) => {
	let [r, i] = W(!1), o = n > 0 ? n : 1, s = e?.length > o;
	return /* @__PURE__ */ q(_, {
		flexDirection: "column",
		gap: "200",
		margin: "200 0 300 0",
		children: [Ze(() => e?.sort((e, t) => t?.created_at.localeCompare(e?.created_at)).slice(0, r ? e.length : o), [
			e,
			r,
			o
		]).map((e, n) => /* @__PURE__ */ K(PS, {
			conversation: e,
			conversationContext: t
		}, `${n}-${e?.id}`)), s && /* @__PURE__ */ q(a, {
			variant: "secondary",
			onClick: () => i(!r),
			children: ["Show ", r ? "less" : "all"]
		})]
	});
}, IS = rx("\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n"), LS = ({ conversationContext: e, settings: t }) => {
	let [n, r] = W([]), i = Number.parseInt(t?.amountOfConversationsToShow) || 1, a = [e.customer?.email, e.customer?.phone_number].filter((e) => !!e).map((e) => `'${e}'`).join(","), { useQuery: o } = V(), { data: s, loading: c, error: l } = o(IS, {
		skip: a.length === 0,
		variables: { query: `requester_id=in=(${a})` }
	});
	return U(() => {
		if (s?.Miuros) {
			let e = s?.Miuros?.findTickets?.data;
			e && r(e);
		}
	}, [s]), l ? /* @__PURE__ */ K(z, { error: l }) : c ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: /* @__PURE__ */ K(N, {})
	}) : n?.length === 0 ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: "No conversations found for this customer"
	}) : /* @__PURE__ */ K(FS, {
		"data-testid": "conversation-list",
		conversationsToShow: i,
		conversations: n,
		conversationContext: e
	});
}, RS = [
	{
		key: "miurosClientId",
		label: "Authorization: Client ID",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "miurosClientSecret",
		label: "Authorization: Client secret",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "amountOfConversationsToShow",
		label: "Number of conversation to show before the fold",
		type: "string",
		secret: !1,
		defaultValue: "1"
	}
], zS = Pe(RS), BS = "MIUROS", VS = {
	enabled: !1,
	name: "",
	miurosClientId: "",
	miurosClientSecret: "",
	amountOfConversationsToShow: "1"
}, HS = ({ integrationId: e, configuration: t, handleRedirect: n, showNotification: r, automationCouplingState: i, renderConditionsEditor: a }) => {
	let o = !e, s = xc({
		mode: "onChange",
		defaultValues: VS
	}), { create: c, update: l, remove: u, isLoading: d, error: f, misconfigurationCause: p, setMisconfigurationCause: m } = Ve({
		integrationId: e,
		integrationType: BS,
		handleRedirect: n,
		showNotification: r
	}), { isLoading: h, error: _, isWidgetUnknown: b, refetch: x, widgetConfiguration: S } = He({
		integrationId: e,
		fieldDefinitions: RS,
		form: s,
		onMisconfigured: m
	}), { renderConditions: C, setRenderConditions: w, renderConditionsForSubmit: T } = Be({
		integrationId: e,
		widgetConfiguration: S,
		renderConditionsEditor: a
	}), E = (e) => ye(e, {
		fieldDefinitions: RS,
		isCreationMode: o,
		create: c,
		update: l,
		renderConditions: T
	}), D = s.watch("name");
	return /* @__PURE__ */ q(de, {
		form: s,
		integrationId: e,
		onValidSubmit: E,
		error: _ ?? f,
		onRetry: _ ? x : void 0,
		isLoading: d || h,
		isWidgetUnknown: b,
		children: [
			p && /* @__PURE__ */ K(se, { cause: p }),
			/* @__PURE__ */ q(y, { children: [
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ K(Z, {
						name: "enabled",
						control: s.control
					})
				}) }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "name",
						label: "Widget name",
						control: s.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "miurosClientId",
						label: zS.miurosClientId,
						control: s.control,
						rules: { required: "Client ID is required" },
						componentProps: {
							placeholder: "Insert client ID",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(ue, {
						name: "miurosClientSecret",
						label: zS.miurosClientSecret,
						control: s.control,
						isCreationMode: o,
						rules: { required: "Client secret is required" },
						componentProps: {
							placeholder: "Insert client secret",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "amountOfConversationsToShow",
						label: zS.amountOfConversationsToShow,
						control: s.control,
						rules: {
							required: "Please enter a number",
							validate: (e) => !Number.isNaN(Number.parseInt(e, 10)) || "Please enter a number"
						},
						componentProps: {
							placeholder: "Enter number",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				!o && e && /* @__PURE__ */ K(ce, {
					configuration: t,
					integrationId: e,
					integrationType: BS,
					label: "Authorize"
				}),
				a && C !== null && /* @__PURE__ */ K(v, { children: a({
					value: C,
					onChange: w,
					configurationKey: S?.id
				}) })
			] }),
			/* @__PURE__ */ K(pe, {
				integrationType: BS,
				integrationId: e,
				widgetName: D,
				isCreationMode: o,
				isSubmitting: s.formState.isSubmitting,
				automationCouplingState: i,
				onConfirmDelete: () => u()
			})
		]
	});
};
//#endregion
//#region ../widget-recharge/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._list_18ybb_1{padding:0}._listItem_18ybb_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_18ybb_4:last-child{border-bottom:none}._copyIcon_18ybb_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._fullWidth_18ybb_17{width:100%}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}._modal_1op1u_1{min-width:600px}._subscription_1xxl7_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._subscription_1xxl7_1:hover,._subscriptionIsOpen_1xxl7_9{border-color:var(--dixa-color-neutral-400)}._subscriptionHeader_1xxl7_12{cursor:pointer}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var US = {
	"\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getAddresses"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "customerId"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getAddresses"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "customer_id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "customerId"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Recharge_Addresses"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "addresses"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "payment_method_id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "address1"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "address2"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "city"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "company"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "country_code"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "created_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "customer_id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "discounts"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "code"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "value"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "value_type"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "first_name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "last_name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "order_attributes"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "value"
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "order_note"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "phone"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "presentment_currency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "shipping_lines_conserved"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "code"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "price"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "shipping_lines_override"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "code"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "price"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "updated_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "zip"
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getChargeById($id: Int!) {\n    Recharge {\n      getChargeById(id: $id) {\n        ... on Recharge_Charge {\n          charge {\n            id\n            status\n            scheduled_at\n            processed_at\n            total_price\n            currency\n            line_items {\n              title\n              variant_title\n              quantity\n              unit_price\n              total_price\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getChargeById"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "id"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getChargeById"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "id"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Recharge_Charge"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "charge"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "status"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "scheduled_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "processed_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_price"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "currency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "line_items"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "variant_title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "quantity"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "unit_price"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "total_price"
																	}
																}
															]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getCharges(\n    $customerId: String\n    $purchaseItemId: String\n    $status: String\n    $scheduledAtMin: String\n    $sortBy: String\n    $limit: String\n  ) {\n    Recharge {\n      getCharges(\n        customer_id: $customerId\n        purchase_item_id: $purchaseItemId\n        status: $status\n        scheduled_at_min: $scheduledAtMin\n        sort_by: $sortBy\n        limit: $limit\n      ) {\n        ... on Recharge_Charges {\n          charges {\n            id\n            status\n            scheduled_at\n            processed_at\n            total_price\n            currency\n            line_items {\n              title\n              variant_title\n              quantity\n              unit_price\n              total_price\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getCharges"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "customerId"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "purchaseItemId"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "status"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "scheduledAtMin"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "sortBy"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "limit"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getCharges"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "customer_id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "customerId"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "purchase_item_id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "purchaseItemId"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "status"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "status"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "scheduled_at_min"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "scheduledAtMin"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "sort_by"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "sortBy"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "limit"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "limit"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Recharge_Charges"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "charges"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "status"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "scheduled_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "processed_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_price"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "currency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "line_items"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "variant_title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "quantity"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "unit_price"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "total_price"
																	}
																}
															]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getCustomerDetails"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "email"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getStore"
							},
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Recharge_Store"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "store"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "external_platform"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "customer_portal_base_url"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "merchant_portal_base_url"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "identifier"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "checkout_platform"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "external_platform"
														}
													}
												]
											}
										}]
									}
								}]
							}
						}, {
							kind: "Field",
							name: {
								kind: "Name",
								value: "getCustomers"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "email"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "email"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Recharge_Customers"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "customers"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "email"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "phone"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "first_name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "last_name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "created_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "updated_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "external_customer_id"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "ecommerce"
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "subscriptions_active_count"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "subscriptions_total_count"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "has_valid_payment_method"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "hash"
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getOrders"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "customerId"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "limit"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "addressId"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getOrders"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "customer_id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "customerId"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "limit"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "limit"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "address_id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "addressId"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Recharge_Orders"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "orders"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "created_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "currency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "is_prepaid"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "note"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "status"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "subtotal_price"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_discounts"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_duties"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_line_items_price"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_price"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_refunds"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_tax"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_weight_grams"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "type"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "charge"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "external_transaction_id"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "payment_processor"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "billing_address"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "address1"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "address2"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "city"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "company"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "country_code"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "first_name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "last_name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "phone"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "province"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "zip"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "shipping_address"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "address1"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "address2"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "city"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "company"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "country_code"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "first_name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "last_name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "phone"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "province"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "zip"
																	}
																}
															]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getSubscriptionById($id: Int!) {\n    Recharge {\n      getSubscriptionById(id: $id) {\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            product_title\n            variant_title\n            quantity\n            price\n            presentment_currency\n            is_prepaid\n            next_charge_scheduled_at\n            order_interval_frequency\n            order_interval_unit\n            charge_interval_frequency\n            cancellation_reason\n            cancelled_at\n            created_at\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getSubscriptionById"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "id"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getSubscriptionById"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "id"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Recharge_Subscription_"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "subscription"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "status"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "product_title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "variant_title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "quantity"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "price"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "presentment_currency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "is_prepaid"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "next_charge_scheduled_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "order_interval_frequency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "order_interval_unit"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "charge_interval_frequency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "cancellation_reason"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "cancelled_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "created_at"
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getSubscriptions($customerId: String, $status: String, $limit: String) {\n    Recharge {\n      getSubscriptions(\n        customer_id: $customerId\n        status: $status\n        limit: $limit\n      ) {\n        ... on Recharge_Subscriptions {\n          subscriptions {\n            id\n            status\n            product_title\n            variant_title\n            quantity\n            price\n            presentment_currency\n            is_prepaid\n            is_skippable\n            is_swappable\n            next_charge_scheduled_at\n            order_interval_frequency\n            order_interval_unit\n            charge_interval_frequency\n            cancellation_reason\n            cancellation_reason_comments\n            cancelled_at\n            created_at\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getSubscriptions"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "customerId"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "status"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "limit"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getSubscriptions"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "customer_id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "customerId"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "status"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "status"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "limit"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "limit"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Recharge_Subscriptions"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "subscriptions"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "status"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "product_title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "variant_title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "quantity"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "price"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "presentment_currency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "is_prepaid"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "is_skippable"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "is_swappable"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "next_charge_scheduled_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "order_interval_frequency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "order_interval_unit"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "charge_interval_frequency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "cancellation_reason"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "cancellation_reason_comments"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "cancelled_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "created_at"
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation activateSubscription($id: Int!) {\n    Recharge {\n      activateSubscription(id: $id) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            cancelled_at\n            cancellation_reason\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "activateSubscription"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "id"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "activateSubscription"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "id"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "__typename"
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_Subscription_"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "subscription"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "cancelled_at"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "cancellation_reason"
															}
														}
													]
												}
											}]
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_BasicResponse"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "message"
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation cancelSubscription(\n    $id: Int!\n    $input: Recharge_SubscriptionCancelInput_Input\n  ) {\n    Recharge {\n      cancelSubscription(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            cancelled_at\n            cancellation_reason\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "cancelSubscription"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "id"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Recharge_SubscriptionCancelInput_Input"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "cancelSubscription"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "id"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "__typename"
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_Subscription_"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "subscription"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "cancelled_at"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "cancellation_reason"
															}
														}
													]
												}
											}]
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_BasicResponse"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "message"
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation changeSubscriptionNextChargeDate(\n    $id: Int!\n    $input: Recharge_SubscriptionChangeNextChargeDateInput_Input\n  ) {\n    Recharge {\n      changeSubscriptionNextChargeDate(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            next_charge_scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "changeSubscriptionNextChargeDate"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "id"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Recharge_SubscriptionChangeNextChargeDateInput_Input"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "changeSubscriptionNextChargeDate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "id"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "__typename"
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_Subscription_"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "subscription"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "next_charge_scheduled_at"
															}
														}
													]
												}
											}]
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_BasicResponse"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "message"
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation skipCharge($id: Int!, $input: Recharge_ChargeSkipInput_Input) {\n    Recharge {\n      skipCharge(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Charge {\n          charge {\n            id\n            status\n            scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "skipCharge"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "id"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Recharge_ChargeSkipInput_Input"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "skipCharge"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "id"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "__typename"
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_Charge"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "charge"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "scheduled_at"
															}
														}
													]
												}
											}]
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_BasicResponse"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "message"
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation unskipCharge($id: Int!, $input: Recharge_ChargeSkipInput_Input) {\n    Recharge {\n      unskipCharge(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Charge {\n          charge {\n            id\n            status\n            scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "unskipCharge"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "id"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Recharge_ChargeSkipInput_Input"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "unskipCharge"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "id"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "__typename"
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_Charge"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "charge"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "scheduled_at"
															}
														}
													]
												}
											}]
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_BasicResponse"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "message"
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation updateSubscription(\n    $id: Int!\n    $input: Recharge_SubscriptionUpdateInput_Input\n  ) {\n    Recharge {\n      updateSubscription(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            product_title\n            variant_title\n            price\n            quantity\n            next_charge_scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "updateSubscription"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "id"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Recharge_SubscriptionUpdateInput_Input"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "updateSubscription"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "id"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "__typename"
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_Subscription_"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "subscription"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "product_title"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "variant_title"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "price"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "quantity"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "next_charge_scheduled_at"
															}
														}
													]
												}
											}]
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_BasicResponse"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "message"
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	}
};
function WS(e) {
	return US[e] ?? {};
}
var GS = WS("\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n"), KS = WS("\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n"), qS = WS("\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n"), JS = WS("\n  query getSubscriptions($customerId: String, $status: String, $limit: String) {\n    Recharge {\n      getSubscriptions(\n        customer_id: $customerId\n        status: $status\n        limit: $limit\n      ) {\n        ... on Recharge_Subscriptions {\n          subscriptions {\n            id\n            status\n            product_title\n            variant_title\n            quantity\n            price\n            presentment_currency\n            is_prepaid\n            is_skippable\n            is_swappable\n            next_charge_scheduled_at\n            order_interval_frequency\n            order_interval_unit\n            charge_interval_frequency\n            cancellation_reason\n            cancellation_reason_comments\n            cancelled_at\n            created_at\n          }\n        }\n      }\n    }\n  }\n"), YS = WS("\n  query getCharges(\n    $customerId: String\n    $purchaseItemId: String\n    $status: String\n    $scheduledAtMin: String\n    $sortBy: String\n    $limit: String\n  ) {\n    Recharge {\n      getCharges(\n        customer_id: $customerId\n        purchase_item_id: $purchaseItemId\n        status: $status\n        scheduled_at_min: $scheduledAtMin\n        sort_by: $sortBy\n        limit: $limit\n      ) {\n        ... on Recharge_Charges {\n          charges {\n            id\n            status\n            scheduled_at\n            processed_at\n            total_price\n            currency\n            line_items {\n              title\n              variant_title\n              quantity\n              unit_price\n              total_price\n            }\n          }\n        }\n      }\n    }\n  }\n"), XS = WS("\n  mutation cancelSubscription(\n    $id: Int!\n    $input: Recharge_SubscriptionCancelInput_Input\n  ) {\n    Recharge {\n      cancelSubscription(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            cancelled_at\n            cancellation_reason\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n"), ZS = WS("\n  mutation activateSubscription($id: Int!) {\n    Recharge {\n      activateSubscription(id: $id) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            cancelled_at\n            cancellation_reason\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n"), QS = WS("\n  mutation updateSubscription(\n    $id: Int!\n    $input: Recharge_SubscriptionUpdateInput_Input\n  ) {\n    Recharge {\n      updateSubscription(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            product_title\n            variant_title\n            price\n            quantity\n            next_charge_scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n"), $S = WS("\n  mutation skipCharge($id: Int!, $input: Recharge_ChargeSkipInput_Input) {\n    Recharge {\n      skipCharge(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Charge {\n          charge {\n            id\n            status\n            scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n"), eC = WS("\n  mutation unskipCharge($id: Int!, $input: Recharge_ChargeSkipInput_Input) {\n    Recharge {\n      unskipCharge(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Charge {\n          charge {\n            id\n            status\n            scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n"), tC = Yo;
function nC(e = !1, t) {
	let [n, r] = W(e);
	return U(() => {
		let e = n ? window.setTimeout(() => r(!1), t || 2e3) : void 0;
		return () => window.clearTimeout(e);
	}, [t, n]), {
		isCopied: n,
		copy: (e) => {
			navigator.clipboard.writeText(e), r(!0);
		}
	};
}
var rC = ({ mutation: e, isSuccessful: t, successText: n, failureText: r, trackingAction: i, setIsMutationLoading: a, setIsOpen: o, refetchSubscriptions: s }) => {
	let { track: c } = B(), { useMutation: l, showNotification: u } = V(), d = () => {
		a(!1), u({
			title: "Something went wrong",
			text: r,
			icon: "exclamation-triangle-filled",
			severity: "warning"
		}), o(!1);
	}, [f, p] = l(e, {
		onError: d,
		onCompleted: async (e) => {
			if (!t(e)) {
				d();
				return;
			}
			await s().catch(() => void 0), a(!1), u({
				title: "Success",
				text: n,
				icon: "check-circle-filled",
				severity: "success"
			}), c(i), o(!1);
		}
	});
	return [(e) => f(e).catch(() => void 0), p];
}, iC = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, aC = "DD MMM YYYY @ HH:mm", oC = {
	list: "_list_18ybb_1",
	listItem: "_listItem_18ybb_4",
	copyIcon: "_copyIcon_18ybb_12",
	fullWidth: "_fullWidth_18ybb_17"
}, sC = ({ address: e, icon: t, title: n, isLoading: r = !1, hasMultipleAddresses: a = !1 }) => {
	let { isCopied: o, copy: s } = nC(), { first_name: c, last_name: l, address1: u, address2: d, city: f, zip: p, country_code: m } = e ?? {}, h = [
		`${c} ${l}`.trim() || void 0,
		u,
		d,
		`${f} ${p}`.trim() || void 0,
		m
	].filter(Boolean);
	return /* @__PURE__ */ q(_, {
		gap: "200",
		justifyContent: "space-between",
		children: [/* @__PURE__ */ q(_, {
			gap: "200",
			children: [/* @__PURE__ */ K(b, {
				size: 14,
				name: t
			}), r ? /* @__PURE__ */ K(N, { size: 14 }) : /* @__PURE__ */ q(_, {
				gap: "200",
				flexDirection: "column",
				children: [n && /* @__PURE__ */ K(L.Paragraph, {
					variant: "3",
					children: n
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					children: h.map((e, t) => /* @__PURE__ */ K(i, { children: e }, t))
				})]
			})]
		}), !r && /* @__PURE__ */ q(_, {
			gap: "100",
			children: [a && /* @__PURE__ */ K(R, {
				content: "The customer has multiple addresses, showing only the first here.",
				children: /* @__PURE__ */ K(b, {
					size: 14,
					name: "exclamation",
					className: oC.copyIcon
				})
			}), /* @__PURE__ */ K(R, {
				content: `Copy ${n ? n.toLowerCase() : "address"}`,
				children: /* @__PURE__ */ K(b, {
					size: 14,
					name: o ? "done" : "copy",
					onClick: () => s(h.join(", ")),
					className: oC.copyIcon
				})
			})]
		})]
	});
}, cC = { wrapper: "_wrapper_1nher_1" }, lC = ({ customer: e, store: t }) => {
	let { track: n } = B(), { isCopied: r, copy: i } = nC(), { isCopied: a, copy: o } = nC(), { useQuery: s } = V(), c = e?.id, { loading: l, error: u, data: d } = s(KS, {
		skip: !c,
		variables: { customerId: c?.toString() }
	}), f = d?.Recharge?.getAddresses, p = !l && f?.addresses?.[0] ? f.addresses[0] : void 0, m = (f?.addresses?.length ?? 0) > 1;
	if (U(() => {
		p && n("recharge:profile:received");
	}, [p, n]), u) return /* @__PURE__ */ K(z, { error: u });
	if (!e) return null;
	let { id: h, phone: g, email: v, first_name: y, last_name: x, created_at: S, has_valid_payment_method: C } = e, w = t ? `https://${t.identifier}.admin.rechargeapps.com/merchant/customers/${h}` : null, T = `${y || ""} ${x || ""}`.trim() || "A customer has no name";
	return /* @__PURE__ */ K(_, {
		gap: "300",
		flexDirection: "column",
		children: /* @__PURE__ */ q(_, {
			className: cC.wrapper,
			gap: "200",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ K(L.Heading, {
					variant: "heading-2",
					children: T
				}),
				S && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					margin: "0 0 200",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: "Member since"
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: tC(S).format("DD MMM YYYY @ HH:mm")
					})]
				}),
				v && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "mail"
						}), /* @__PURE__ */ K(L.ExternalLink, {
							href: `mailto:${v}`,
							children: v
						})]
					}), /* @__PURE__ */ K(R, {
						content: "Copy email",
						children: /* @__PURE__ */ K(b, {
							size: 14,
							name: r ? "done" : "copy",
							onClick: () => i(v),
							className: oC.copyIcon
						})
					})]
				}),
				g && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "phone"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: g
						})]
					}), /* @__PURE__ */ K(R, {
						content: "Copy phone number",
						children: /* @__PURE__ */ K(b, {
							size: 14,
							name: a ? "done" : "copy",
							onClick: () => o(g),
							className: oC.copyIcon
						})
					})]
				}),
				/* @__PURE__ */ K(sC, {
					address: p,
					icon: "home",
					isLoading: l,
					hasMultipleAddresses: m
				}),
				/* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "credit-card"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: "Has valid payment method"
						})]
					}), /* @__PURE__ */ K(b, {
						size: 14,
						name: C ? "check-circle" : "close-circle-filled",
						color: C ? "green.500" : "red.500"
					})]
				}),
				w && /* @__PURE__ */ q(_, {
					alignItems: "center",
					gap: "200",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "external-link"
					}), /* @__PURE__ */ K(L.ExternalLink, {
						href: w,
						target: "_blank",
						rel: "noreferrer",
						onClick: () => n("recharge:external:customer:overview:opened"),
						children: "View customer in Recharge"
					})]
				})
			]
		})
	});
}, uC = {
	order: "_order_1dlaa_1",
	orderIsOpen: "_orderIsOpen_1dlaa_9",
	orderHeader: "_orderHeader_1dlaa_12",
	note: "_note_1dlaa_16"
}, dC = ({ order: e, isOpenByDefault: t, store: n }) => {
	let { track: r } = B(), [i, a] = W(t), { id: o, status: s, charge: c, currency: l, note: u, created_at: d, billing_address: f, shipping_address: p, total_price: m, is_prepaid: h } = e, g = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/${o}` : null, v = c?.external_transaction_id?.payment_processor || void 0;
	return /* @__PURE__ */ q(_, {
		className: ae(uC.order, { [uC.orderIsOpen]: i }),
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			justifyContent: "space-between",
			alignItems: "center",
			className: uC.orderHeader,
			onClick: () => a(!i),
			children: [/* @__PURE__ */ q(_, {
				gap: "100",
				flexDirection: "column",
				children: [d && /* @__PURE__ */ K(_, {
					alignItems: "center",
					children: /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: tC(d).format("DD MMM YYYY @ HH:mm")
					})
				}), /* @__PURE__ */ q(L.Paragraph, {
					variant: "1",
					children: ["Order #", o]
				})]
			}), /* @__PURE__ */ K(x, {
				variant: "tertiary",
				icon: i ? "angle-down" : "angle-right"
			})]
		}), i && /* @__PURE__ */ q(_, {
			gap: "250",
			flexDirection: "column",
			margin: "200 0 0",
			children: [
				u && /* @__PURE__ */ K(R, {
					content: "Note",
					children: /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						color: "secondary",
						className: uC.note,
						children: u
					})
				}),
				s && /* @__PURE__ */ q(_, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "activity"
					}), /* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Status"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: iC(s)
						})]
					})]
				}),
				/* @__PURE__ */ q(_, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "credit-card"
					}), /* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Prepaid"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: h ? "Yes" : "No"
						})]
					})]
				}),
				v && /* @__PURE__ */ q(_, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "cog"
					}), /* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Payment processor"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: v
						})]
					})]
				}),
				/* @__PURE__ */ q(_, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "chart-bar"
					}), /* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Order value"
						}), /* @__PURE__ */ q(L.Paragraph, {
							variant: "4",
							children: [
								m,
								" ",
								l
							]
						})]
					})]
				}),
				/* @__PURE__ */ K(sC, {
					address: f,
					icon: "home",
					title: "Billing address"
				}),
				/* @__PURE__ */ K(sC, {
					address: p,
					icon: "map-pin",
					title: "Shipping address"
				}),
				g && /* @__PURE__ */ K(A, {
					variant: "secondary",
					style: {
						color: "var(--dixa-typography-color-link)",
						padding: "var(--dixa-size-spacer-100)"
					},
					navigate: () => window.open(g, "_blank")?.focus(),
					slotStart: /* @__PURE__ */ K(b, { name: "external-link" }),
					onClick: () => r("recharge:external:order:opened"),
					children: "View order in Recharge"
				})
			]
		})]
	});
}, fC = ({ customerId: e, store: t }) => {
	let { track: r } = B(), { useQuery: i } = V(), { loading: a, error: o, data: s } = i(qS, {
		skip: !e,
		variables: {
			customerId: e?.toString(),
			limit: "5"
		}
	}), c = s?.Recharge?.getOrders, l = !a && c?.orders && c.orders.length > 0 ? c.orders : [];
	if (!e) return null;
	if (o) return /* @__PURE__ */ K(z, { error: o });
	let u = t ? `https://${t.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
	return /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			gap: "200",
			flexDirection: "row",
			alignItems: "center",
			children: [/* @__PURE__ */ K(L.Heading, {
				variant: "heading-3",
				children: "Customer orders"
			}), !a && /* @__PURE__ */ K(n, {
				variant: "success",
				size: "small",
				children: l.length
			})]
		}), /* @__PURE__ */ q(_, {
			gap: "200",
			flexDirection: "column",
			children: [
				a && /* @__PURE__ */ K(_, {
					justifyContent: "center",
					margin: "300",
					children: /* @__PURE__ */ K(N, {})
				}),
				!a && l.length === 0 && /* @__PURE__ */ K(_, {
					justifyContent: "center",
					margin: "200 0 300 0",
					"data-testid": "widget-no-orders",
					children: /* @__PURE__ */ K(L.Paragraph, {
						color: "tertiary",
						children: "No orders found"
					})
				}),
				!a && l.length > 0 && /* @__PURE__ */ K(_, {
					gap: "200",
					flexDirection: "column",
					children: l.map((e, n) => /* @__PURE__ */ K(dC, {
						order: e,
						isOpenByDefault: n === 0,
						store: t
					}, `${n}-${e.id}`))
				}),
				u && /* @__PURE__ */ K(A, {
					variant: "secondary",
					style: {
						color: "var(--dixa-typography-color-link)",
						padding: "var(--dixa-size-spacer-100)"
					},
					navigate: () => window.open(u, "_blank")?.focus(),
					slotStart: /* @__PURE__ */ K(b, { name: "external-link" }),
					onClick: () => r("recharge:external:orders:list:opened"),
					children: "View all orders in Recharge"
				})
			]
		})]
	});
}, pC = [
	"Too expensive",
	"Quality issues",
	"Switching product",
	"No longer needed",
	"Delivery issues",
	"Other"
], mC = {
	reason: null,
	comments: "",
	sendEmail: !0
}, hC = ({ subscriptionId: e, productTitle: t, isOpen: n, setIsOpen: r, isMutationLoading: i, setIsMutationLoading: a, refetchSubscriptions: o }) => {
	let s = xc({ defaultValues: mC }), [c, { reset: l }] = rC({
		mutation: XS,
		isSuccessful: (e) => e.Recharge?.cancelSubscription?.__typename === "Recharge_Subscription_",
		successText: "The subscription got cancelled.",
		failureText: "Could not cancel the subscription.",
		trackingAction: "recharge:subscription:cancelled",
		setIsMutationLoading: a,
		setIsOpen: r,
		refetchSubscriptions: o
	}), u = Je((t) => {
		t.reason != null && (a(!0), c({ variables: {
			id: e,
			input: {
				cancellation_reason: t.reason,
				cancellation_reason_comments: t.comments || void 0,
				send_email: t.sendEmail
			}
		} }));
	}, [e]), d = () => {
		r(!1), l(), s.reset(mC);
	};
	return /* @__PURE__ */ q(E, {
		isOpen: n,
		onClose: d,
		children: [
			/* @__PURE__ */ K(k, {
				title: `Cancel subscription ${t}`,
				onClose: d
			}),
			/* @__PURE__ */ K(D, { children: /* @__PURE__ */ q(y, { children: [
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(kc, {
					control: s.control,
					label: "Reason",
					name: "reason",
					rules: { required: {
						value: !0,
						message: "Please select a reason"
					} },
					componentProps: {
						placeholder: "Select a reason",
						equalityFn: (e, t) => e === t,
						getItemTitleByValue: (e) => e ?? ""
					},
					children: pC.map((e) => /* @__PURE__ */ K(M.Item, {
						value: e,
						children: /* @__PURE__ */ K(L.Paragraph, { children: e })
					}, e))
				}) }),
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(jc, {
					name: "comments",
					label: "Comments (optional)",
					control: s.control
				}) }),
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Notify the customer by email",
					children: /* @__PURE__ */ K(Z, {
						control: s.control,
						name: "sendEmail"
					})
				}) })
			] }) }),
			/* @__PURE__ */ K(O, {
				confirmProps: {
					disabled: !(s.formState.isValid && s.formState.isDirty),
					isLoading: i,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 })
				},
				confirmOnClick: s.handleSubmit(u),
				cancelOnClick: d,
				confirmName: "Cancel subscription",
				cancelName: "Back"
			})
		]
	});
}, gC = ({ subscriptionId: e, productTitle: t, refetchSubscriptions: n }) => {
	let [r, i] = W(!1), [o, s] = W(!1);
	return /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(R, {
		content: "Cancel this subscription so it no longer creates future orders.",
		wrap: "div",
		wrapProps: { className: oC.fullWidth },
		children: /* @__PURE__ */ K(a, {
			variant: "secondary",
			onClick: () => i(!0),
			isLoading: o,
			loadingIndicator: /* @__PURE__ */ K(N, { size: 16 }),
			slotStart: /* @__PURE__ */ K(b, {
				size: 14,
				name: "close-circle-filled",
				color: "red.500"
			}),
			className: oC.fullWidth,
			children: "Cancel"
		})
	}), /* @__PURE__ */ K(hC, {
		subscriptionId: e,
		productTitle: t,
		isOpen: r,
		setIsOpen: i,
		isMutationLoading: o,
		setIsMutationLoading: s,
		refetchSubscriptions: n
	})] });
}, _C = ({ subscriptionId: e, productTitle: t, isOpen: n, setIsOpen: r, isMutationLoading: i, setIsMutationLoading: a, refetchSubscriptions: o }) => {
	let [s] = rC({
		mutation: ZS,
		isSuccessful: (e) => e.Recharge?.activateSubscription?.__typename === "Recharge_Subscription_",
		successText: "The subscription got reactivated.",
		failureText: "Could not reactivate the subscription.",
		trackingAction: "recharge:subscription:reactivated",
		setIsMutationLoading: a,
		setIsOpen: r,
		refetchSubscriptions: o
	}), c = Je(() => {
		a(!0), s({ variables: { id: e } });
	}, [e]), l = () => r(!1);
	return /* @__PURE__ */ q(E, {
		isOpen: n,
		onClose: l,
		children: [
			/* @__PURE__ */ K(k, {
				title: `Reactivate subscription ${t}`,
				onClose: l
			}),
			/* @__PURE__ */ K(D, { children: /* @__PURE__ */ K(L.Paragraph, { children: "Reactivating resumes this subscription. The customer will be charged again on the regular schedule." }) }),
			/* @__PURE__ */ K(O, {
				confirmProps: {
					isLoading: i,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 })
				},
				confirmOnClick: c,
				cancelOnClick: l,
				confirmName: "Reactivate subscription",
				cancelName: "Back"
			})
		]
	});
}, vC = ({ subscriptionId: e, productTitle: t, refetchSubscriptions: n }) => {
	let [r, i] = W(!1), [o, s] = W(!1);
	return /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(R, {
		content: "Reactivate this cancelled subscription so its orders start again.",
		wrap: "div",
		wrapProps: { className: oC.fullWidth },
		children: /* @__PURE__ */ K(a, {
			variant: "secondary",
			onClick: () => i(!0),
			isLoading: o,
			loadingIndicator: /* @__PURE__ */ K(N, { size: 16 }),
			slotStart: /* @__PURE__ */ K(b, {
				size: 14,
				name: "check-circle-filled",
				color: "green.500"
			}),
			className: oC.fullWidth,
			children: "Reactivate"
		})
	}), /* @__PURE__ */ K(_C, {
		subscriptionId: e,
		productTitle: t,
		isOpen: r,
		setIsOpen: i,
		isMutationLoading: o,
		setIsMutationLoading: s,
		refetchSubscriptions: n
	})] });
}, yC = {
	skip: {
		mutation: $S,
		title: "Skip next order",
		confirmName: "Skip next order",
		successText: "The next order was skipped.",
		failureText: "Could not skip the next order.",
		trackingAction: "recharge:subscription:order:skipped",
		describeScheduled: (e) => `This skips the upcoming order scheduled for ${e}. The following order proceeds as normal.`,
		describeUnscheduled: "This skips the next upcoming order. The following order proceeds as normal."
	},
	unskip: {
		mutation: eC,
		title: "Unskip next order",
		confirmName: "Unskip next order",
		successText: "The skipped order was restored.",
		failureText: "Could not restore the skipped order.",
		trackingAction: "recharge:subscription:order:unskipped",
		describeScheduled: (e) => `This restores the skipped order scheduled for ${e} so that it is processed again.`,
		describeUnscheduled: "This restores the skipped order so that it is processed again."
	}
}, bC = (e, t) => e === "skip" ? t.Recharge?.skipCharge : t.Recharge?.unskipCharge, xC = ({ action: e, subscriptionId: t, chargeId: n, productTitle: r, chargeDate: i, isOpen: a, setIsOpen: o, isMutationLoading: s, setIsMutationLoading: c, refetchSubscriptions: l }) => {
	let { mutation: u, title: d, confirmName: f, successText: p, failureText: m, trackingAction: h, describeScheduled: g, describeUnscheduled: _ } = yC[e], [v] = rC({
		mutation: u,
		isSuccessful: (t) => bC(e, t)?.__typename === "Recharge_Charge",
		successText: p,
		failureText: m,
		trackingAction: h,
		setIsMutationLoading: c,
		setIsOpen: o,
		refetchSubscriptions: l
	}), y = Je(() => {
		c(!0), v({ variables: {
			id: n,
			input: { purchase_item_ids: [t] }
		} });
	}, [
		e,
		n,
		t
	]), b = () => o(!1);
	return /* @__PURE__ */ q(E, {
		isOpen: a,
		onClose: b,
		children: [
			/* @__PURE__ */ K(k, {
				title: `${d} ${r}`,
				onClose: b
			}),
			/* @__PURE__ */ K(D, { children: /* @__PURE__ */ K(L.Paragraph, { children: i ? g(tC(i).format(aC)) : _ }) }),
			/* @__PURE__ */ K(O, {
				confirmProps: {
					isLoading: s,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 })
				},
				confirmOnClick: y,
				cancelOnClick: b,
				confirmName: f,
				cancelName: "Back"
			})
		]
	});
}, SC = "SKIPPED", CC = "YYYY-MM-DD", wC = "scheduled_at-asc", TC = {
	skip: {
		label: "Skip next",
		icon: "arrow-right",
		tooltip: "Skip this subscription's next order. The following order proceeds as normal."
	},
	unskip: {
		label: "Unskip next",
		icon: "undo",
		tooltip: "Restore this subscription's skipped order so that it is processed again."
	}
}, EC = "This subscription has no upcoming order that can be skipped.", DC = (e) => (e?.Recharge?.getCharges?.charges ?? []).find((e) => {
	let t = e.status?.toUpperCase();
	return !!e.id && (t === "QUEUED" || t === "SKIPPED");
}), OC = ({ subscriptionId: e, productTitle: t, disabled: n, isSkippable: r, refetchSubscriptions: i }) => {
	let { useQuery: o } = V(), [s, c] = W(!1), [l, u] = W(!1), { loading: d, data: f, refetch: p } = o(YS, {
		skip: n,
		variables: {
			purchaseItemId: e.toString(),
			scheduledAtMin: tC().format(CC),
			sortBy: wC,
			limit: "5"
		}
	}), m = DC(f), h = m?.status?.toUpperCase() === SC, g = h ? "unskip" : "skip", _ = h || !!m?.id && r, { label: v, icon: y, tooltip: x } = TC[g];
	return /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(R, {
		content: _ ? x : EC,
		wrap: "div",
		wrapProps: { className: oC.fullWidth },
		children: /* @__PURE__ */ K(a, {
			variant: "secondary",
			onClick: () => c(!0),
			disabled: n || !_,
			isLoading: d || l,
			loadingIndicator: /* @__PURE__ */ K(N, { size: 16 }),
			slotStart: /* @__PURE__ */ K(b, {
				size: 14,
				name: y
			}),
			className: oC.fullWidth,
			children: v
		})
	}), m?.id && /* @__PURE__ */ K(xC, {
		action: g,
		subscriptionId: e,
		chargeId: m.id,
		productTitle: t,
		chargeDate: m.scheduled_at,
		isOpen: s,
		setIsOpen: c,
		isMutationLoading: l,
		setIsMutationLoading: u,
		refetchSubscriptions: async () => {
			let e = await i();
			return await p().catch(() => void 0), e;
		}
	})] });
}, kC = { modal: "_modal_1op1u_1" }, AC = ({ subscriptionId: e, productTitle: t, isPrepaid: n, isOpen: r, setIsOpen: i, isMutationLoading: a, setIsMutationLoading: o, refetchSubscriptions: s }) => {
	let c = {
		externalVariantId: "",
		productTitle: "",
		price: ""
	}, l = xc({ defaultValues: c }), [u] = rC({
		mutation: QS,
		isSuccessful: (e) => e.Recharge?.updateSubscription?.__typename === "Recharge_Subscription_",
		successText: "The product was swapped.",
		failureText: "Could not swap the product.",
		trackingAction: "recharge:subscription:product:swapped",
		setIsMutationLoading: o,
		setIsOpen: i,
		refetchSubscriptions: s
	}), d = Je((t) => {
		o(!0), u({ variables: {
			id: e,
			input: {
				external_variant_id: { ecommerce: t.externalVariantId },
				product_title: t.productTitle || void 0,
				price: t.price ? Number(t.price) : void 0,
				override: n
			}
		} });
	}, [e]), f = () => {
		i(!1), l.reset(c);
	};
	return /* @__PURE__ */ q(E, {
		isOpen: r,
		onClose: f,
		className: kC.modal,
		children: [
			/* @__PURE__ */ K(k, {
				title: `Swap product ${t}`,
				onClose: f
			}),
			/* @__PURE__ */ K(D, { children: /* @__PURE__ */ q(y, { children: [
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(jc, {
					name: "externalVariantId",
					label: "New variant ID",
					control: l.control,
					rules: { required: "A variant ID is required" },
					componentProps: { placeholder: "External variant ID" }
				}) }),
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(jc, {
					name: "productTitle",
					label: "Product title (optional)",
					control: l.control
				}) }),
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(jc, {
					name: "price",
					label: "Price (optional)",
					control: l.control,
					rules: { validate: (e) => !e || !Number.isNaN(Number(e)) && Number(e) >= 0 || "Price must be zero or more" }
				}) })
			] }) }),
			/* @__PURE__ */ K(O, {
				confirmProps: {
					disabled: !(l.formState.isValid && l.formState.isDirty),
					isLoading: a,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 })
				},
				confirmOnClick: l.handleSubmit(d),
				cancelOnClick: f,
				confirmName: "Swap product",
				cancelName: "Back"
			})
		]
	});
}, jC = ({ subscriptionId: e, productTitle: t, isPrepaid: n, disabled: r, refetchSubscriptions: i }) => {
	let [o, s] = W(!1), [c, l] = W(!1);
	return /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(R, {
		content: "Replace the product or variant on this subscription. Future orders will ship the new item instead.",
		wrap: "div",
		wrapProps: { className: oC.fullWidth },
		children: /* @__PURE__ */ K(a, {
			variant: "secondary",
			onClick: () => s(!0),
			disabled: r,
			isLoading: c,
			loadingIndicator: /* @__PURE__ */ K(N, { size: 16 }),
			slotStart: /* @__PURE__ */ K(b, {
				size: 14,
				name: "exchange"
			}),
			className: oC.fullWidth,
			children: "Swap"
		})
	}), /* @__PURE__ */ K(AC, {
		subscriptionId: e,
		productTitle: t,
		isPrepaid: n,
		isOpen: o,
		setIsOpen: s,
		isMutationLoading: c,
		setIsMutationLoading: l,
		refetchSubscriptions: i
	})] });
}, MC = {
	subscription: "_subscription_1xxl7_1",
	subscriptionIsOpen: "_subscriptionIsOpen_1xxl7_9",
	subscriptionHeader: "_subscriptionHeader_1xxl7_12"
}, NC = "CANCELLED", PC = ({ subscription: e, isOpenByDefault: t, canCancel: r, canReactivate: i, canSkip: o, canSwap: s, store: c, refetchSubscriptions: l }) => {
	let { track: u } = B(), [d, f] = W(t), { id: p, status: m, product_title: h, variant_title: g, price: v, presentment_currency: y, is_prepaid: S, is_skippable: C, is_swappable: w, next_charge_scheduled_at: T, order_interval_frequency: E, order_interval_unit: D, cancellation_reason: O, cancellation_reason_comments: k, cancelled_at: A } = e, j = m?.toUpperCase() === NC || !!A, M = c && p ? `https://${c.identifier}.admin.rechargeapps.com/merchant/subscriptions/${p}/details` : null, N = E && D ? `Every ${E} ${D}` : null, P = j ? i : r, F = o || s, I = P || M !== null;
	return /* @__PURE__ */ q(_, {
		className: ae(MC.subscription, { [MC.subscriptionIsOpen]: d }),
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			justifyContent: "space-between",
			alignItems: "center",
			className: MC.subscriptionHeader,
			onClick: () => f(!d),
			children: [/* @__PURE__ */ q(_, {
				gap: "100",
				flexDirection: "column",
				children: [/* @__PURE__ */ q(_, {
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ q(L.Paragraph, {
						variant: "1",
						children: ["Subscription #", p]
					}), j && /* @__PURE__ */ K(n, {
						variant: "error",
						size: "small",
						children: "Cancelled"
					})]
				}), h && /* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					color: "secondary",
					children: h
				})]
			}), /* @__PURE__ */ K(x, {
				variant: "tertiary",
				icon: d ? "angle-down" : "angle-right"
			})]
		}), d && /* @__PURE__ */ q(_, {
			gap: "250",
			flexDirection: "column",
			margin: "200 0 0",
			children: [
				m && /* @__PURE__ */ q(_, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "activity"
					}), /* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Status"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: iC(m)
						})]
					})]
				}),
				g && /* @__PURE__ */ q(_, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "tag"
					}), /* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Variant"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: g
						})]
					})]
				}),
				/* @__PURE__ */ q(_, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "chart-bar"
					}), /* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Price"
						}), /* @__PURE__ */ q(L.Paragraph, {
							variant: "4",
							children: [
								v,
								" ",
								y
							]
						})]
					})]
				}),
				N && /* @__PURE__ */ q(_, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "sync"
					}), /* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Frequency"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: N
						})]
					})]
				}),
				!j && T && /* @__PURE__ */ q(_, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "calendar"
					}), /* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Next charge"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: tC(T).format("DD MMM YYYY @ HH:mm")
						})]
					})]
				}),
				/* @__PURE__ */ q(_, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "credit-card"
					}), /* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Prepaid"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: S ? "Yes" : "No"
						})]
					})]
				}),
				j && O && /* @__PURE__ */ q(_, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "info"
					}), /* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: O
						}), k && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							color: "secondary",
							children: /* @__PURE__ */ K("i", { children: k })
						})]
					})]
				}),
				p && F && /* @__PURE__ */ q(_, {
					flexDirection: "row",
					gap: "200",
					children: [o && /* @__PURE__ */ K(_, {
						flexDirection: "column",
						style: {
							flex: 1,
							minWidth: 0
						},
						children: /* @__PURE__ */ K(OC, {
							subscriptionId: p,
							productTitle: h ?? `#${p}`,
							disabled: j,
							isSkippable: !!C,
							refetchSubscriptions: l
						})
					}), s && /* @__PURE__ */ K(_, {
						flexDirection: "column",
						style: {
							flex: 1,
							minWidth: 0
						},
						children: /* @__PURE__ */ K(jC, {
							subscriptionId: p,
							productTitle: h ?? `#${p}`,
							isPrepaid: !!S,
							disabled: j || !w,
							refetchSubscriptions: l
						})
					})]
				}),
				p && I && /* @__PURE__ */ q(_, {
					flexDirection: "row",
					gap: "200",
					children: [P && /* @__PURE__ */ K(_, {
						flexDirection: "column",
						style: {
							flex: 1,
							minWidth: 0
						},
						children: K(j ? vC : gC, {
							subscriptionId: p,
							productTitle: h ?? `#${p}`,
							refetchSubscriptions: l
						})
					}), M && /* @__PURE__ */ K(_, {
						flexDirection: "column",
						style: {
							flex: 1,
							minWidth: 0
						},
						children: /* @__PURE__ */ K(R, {
							content: "Open this subscription in the Recharge merchant portal.",
							wrap: "div",
							wrapProps: { className: oC.fullWidth },
							children: /* @__PURE__ */ K(a, {
								variant: "secondary",
								onClick: () => {
									window.open(M, "_blank")?.focus(), u("recharge:external:subscription:opened");
								},
								slotStart: /* @__PURE__ */ K(b, { name: "external-link" }),
								className: oC.fullWidth,
								children: "Open"
							})
						})
					})]
				})
			]
		})]
	});
}, FC = ({ customerId: e, canCancel: t, canReactivate: r, canSkip: i, canSwap: a, store: o }) => {
	let { track: s } = B(), { useQuery: c } = V(), { loading: l, error: u, data: d, refetch: f } = c(JS, {
		skip: !e,
		variables: {
			customerId: e?.toString(),
			limit: "10"
		}
	}), p = d?.Recharge?.getSubscriptions, m = !l && p?.subscriptions && p.subscriptions.length > 0 ? p.subscriptions : [];
	if (!e) return null;
	if (u) return /* @__PURE__ */ K(z, { error: u });
	let h = o ? `https://${o.identifier}.admin.rechargeapps.com/merchant/subscriptions` : null;
	return /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			gap: "200",
			flexDirection: "row",
			alignItems: "center",
			children: [/* @__PURE__ */ K(L.Heading, {
				variant: "heading-3",
				children: "Subscriptions"
			}), !l && /* @__PURE__ */ K(n, {
				variant: "success",
				size: "small",
				children: m.length
			})]
		}), /* @__PURE__ */ q(_, {
			gap: "200",
			flexDirection: "column",
			children: [
				l && /* @__PURE__ */ K(_, {
					justifyContent: "center",
					margin: "300",
					children: /* @__PURE__ */ K(N, {})
				}),
				!l && m.length === 0 && /* @__PURE__ */ K(_, {
					justifyContent: "center",
					margin: "200 0 300 0",
					"data-testid": "widget-no-subscriptions",
					children: /* @__PURE__ */ K(L.Paragraph, {
						color: "tertiary",
						children: "No subscriptions found"
					})
				}),
				!l && m.length > 0 && /* @__PURE__ */ K(_, {
					gap: "200",
					flexDirection: "column",
					children: m.map((e, n) => /* @__PURE__ */ K(PC, {
						subscription: e,
						isOpenByDefault: n === 0,
						canCancel: t,
						canReactivate: r,
						canSkip: i,
						canSwap: a,
						store: o,
						refetchSubscriptions: f
					}, `${n}-${e.id}`))
				}),
				h && /* @__PURE__ */ K(A, {
					variant: "secondary",
					style: {
						color: "var(--dixa-typography-color-link)",
						padding: "var(--dixa-size-spacer-100)"
					},
					navigate: () => window.open(h, "_blank")?.focus(),
					slotStart: /* @__PURE__ */ K(b, { name: "external-link" }),
					onClick: () => s("recharge:external:subscriptions:list:opened"),
					children: "View all subscriptions in Recharge"
				})
			]
		})]
	});
}, IC = ({ customer: e }) => {
	if (!e) return null;
	let { subscriptions_active_count: t, subscriptions_total_count: n } = e, r = n ?? 0, i = t ?? 0;
	return /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(L.Heading, {
			variant: "heading-3",
			children: "Subscriptions overview"
		}), /* @__PURE__ */ q(T, {
			className: oC.list,
			children: [/* @__PURE__ */ K(T.Text, {
				variant: "dense",
				className: oC.listItem,
				children: /* @__PURE__ */ q(_, {
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: "Total subscriptions"
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: r
					})]
				})
			}), /* @__PURE__ */ K(T.Text, {
				variant: "dense",
				className: oC.listItem,
				children: /* @__PURE__ */ q(_, {
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: "Active subscriptions"
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: i
					})]
				})
			})]
		})]
	});
}, LC = ({ conversationContext: e, settings: t }) => {
	let { useQuery: n } = V(), r = e?.customer?.email, i = t.displayCustomerDetails ?? !1, a = t.displaysubscriptionOverview ?? !1, o = t.displaySubscriptions ?? !1, s = t.enableCancelSubscription ?? !1, c = t.enableReactivateSubscription ?? !1, l = t.enableSkipOrder ?? !1, u = t.enableSwapProduct ?? !1, d = t.displayOrders ?? !1, f = !i && !a && !o && !d, { loading: p, error: m, data: h } = n(GS, {
		skip: !r,
		variables: { email: r }
	}), g = !p && h ? (h?.Recharge?.getCustomers)?.customers?.[0] : void 0, v = !p && h ? h?.Recharge?.getStore?.store ?? void 0 : void 0;
	if (m) {
		let e = m.graphQLErrors;
		return xe({ errors: e }) ? /* @__PURE__ */ K(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			"data-testid": "widget-downstream-api-forbidden-error",
			children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
		}) : be({ errors: e }) ? /* @__PURE__ */ K(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			"data-testid": "widget-downstream-api-authorization-error",
			children: "The integration could not authorize against Recharge. Please contact your administrator."
		}) : /* @__PURE__ */ K(z, { error: m });
	}
	return p ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "300",
		children: /* @__PURE__ */ K(N, {})
	}) : g ? f ? /* @__PURE__ */ K(L.Paragraph, {
		margin: "200 0 300 0",
		color: "secondary",
		align: "center",
		"data-testid": "widget-no-features",
		children: "All features toggles in the settings are disabled."
	}) : /* @__PURE__ */ q(_, {
		gap: "300",
		flexDirection: "column",
		margin: "200 0 300 0",
		"data-testid": "widget-wrapper",
		children: [
			i && /* @__PURE__ */ K(lC, {
				customer: g,
				store: v
			}),
			a && /* @__PURE__ */ K(IC, { customer: g }),
			o && /* @__PURE__ */ K(FC, {
				customerId: g.id,
				canCancel: s,
				canReactivate: c,
				canSkip: l,
				canSwap: u,
				store: v
			}),
			d && /* @__PURE__ */ K(fC, {
				customerId: g.id,
				store: v
			})
		]
	}) : /* @__PURE__ */ K(L.Paragraph, {
		margin: "200 0 300 0",
		color: "secondary",
		align: "center",
		"data-testid": "widget-customer-not-found",
		children: "No data found for this customer in Recharge."
	});
}, RC = [
	{
		key: "rechargeAccessToken",
		label: "API token",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "rechargeStoreHostName",
		label: "Store host name",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "displayCustomerDetails",
		label: "Displays details of a customer",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displaysubscriptionOverview",
		label: "Displays the subscription overview",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displaySubscriptions",
		label: "Displays the list of subscriptions",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "enableCancelSubscription",
		label: "Allows agents to cancel a subscription",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "enableReactivateSubscription",
		label: "Allows agents to reactivate a cancelled subscription",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "enableSkipOrder",
		label: "Allows agents to skip the next order of a subscription, and to restore it once skipped",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "enableSwapProduct",
		label: "Allows agents to swap the product of a subscription",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "displayOrders",
		label: "Displays the last 5 orders",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	}
], zC = [
	"enableCancelSubscription",
	"enableReactivateSubscription",
	"enableSkipOrder",
	"enableSwapProduct"
], BC = Pe(RC), VC = "RECHARGE", HC = {
	enabled: !1,
	name: "",
	...Le([], RC)
}, UC = {
	...HC,
	...zC.reduce((e, t) => ({
		...e,
		[t]: !0
	}), {})
}, WC = ({ integrationId: e, configuration: t, handleRedirect: n, showNotification: r, automationCouplingState: i, renderConditionsEditor: a }) => {
	let o = !e, s = xc({
		mode: "onChange",
		defaultValues: o ? UC : HC
	}), { create: c, update: l, remove: u, isLoading: d, error: f, misconfigurationCause: p, setMisconfigurationCause: m } = Ve({
		integrationId: e,
		integrationType: VC,
		handleRedirect: n,
		showNotification: r
	}), { isLoading: h, error: _, isWidgetUnknown: b, refetch: x, widgetConfiguration: S } = He({
		integrationId: e,
		fieldDefinitions: RC,
		form: s,
		onMisconfigured: m
	}), { renderConditions: C, setRenderConditions: w, renderConditionsForSubmit: T } = Be({
		integrationId: e,
		widgetConfiguration: S,
		renderConditionsEditor: a
	}), E = o || !!S?.additionalProperties?.isUsingOAuth, D = E ? RC : RC.filter((e) => e.key !== "rechargeStoreHostName"), O = (e) => ye(e, {
		fieldDefinitions: D,
		isCreationMode: o,
		create: c,
		update: l,
		renderConditions: T
	}), k = s.watch("name");
	return /* @__PURE__ */ q(de, {
		form: s,
		integrationId: e,
		onValidSubmit: O,
		error: _ ?? f,
		onRetry: _ ? x : void 0,
		isLoading: d || h,
		isWidgetUnknown: b,
		children: [
			p && /* @__PURE__ */ K(se, { cause: p }),
			/* @__PURE__ */ q(y, { children: [
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ K(Z, {
						name: "enabled",
						control: s.control
					})
				}) }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "name",
						label: "Widget name",
						control: s.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				!E && /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(ue, {
						name: "rechargeAccessToken",
						label: BC.rechargeAccessToken,
						control: s.control,
						isCreationMode: o,
						rules: { required: "API token is required" },
						componentProps: {
							placeholder: "Insert the Admin API token for Recharge",
							autoComplete: "off"
						}
					})
				}), /* @__PURE__ */ K(v, { span: 3 })] }),
				E && /* @__PURE__ */ q(G, { children: [
					/* @__PURE__ */ K(v, {
						span: 3,
						children: /* @__PURE__ */ K(jc, {
							name: "rechargeStoreHostName",
							label: BC.rechargeStoreHostName,
							control: s.control,
							rules: {
								required: "Store host name is required",
								validate: (e) => Ue(String(e ?? "")) || !0
							},
							componentProps: {
								placeholder: "e.g. my-store.myshopify.com",
								autoComplete: "off",
								prefix: "https://"
							}
						})
					}),
					/* @__PURE__ */ K(v, { span: 3 }),
					!o && e && /* @__PURE__ */ K(ce, {
						configuration: t,
						integrationId: e,
						integrationType: VC,
						label: "Authorize with OAuth"
					})
				] }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: BC.displayCustomerDetails,
						children: /* @__PURE__ */ K(Z, {
							name: "displayCustomerDetails",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: BC.displaysubscriptionOverview,
						children: /* @__PURE__ */ K(Z, {
							name: "displaysubscriptionOverview",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: BC.displaySubscriptions,
						children: /* @__PURE__ */ K(Z, {
							name: "displaySubscriptions",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: BC.enableCancelSubscription,
						children: /* @__PURE__ */ K(Z, {
							name: "enableCancelSubscription",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: BC.enableReactivateSubscription,
						children: /* @__PURE__ */ K(Z, {
							name: "enableReactivateSubscription",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: BC.enableSkipOrder,
						children: /* @__PURE__ */ K(Z, {
							name: "enableSkipOrder",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: BC.enableSwapProduct,
						children: /* @__PURE__ */ K(Z, {
							name: "enableSwapProduct",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: BC.displayOrders,
						children: /* @__PURE__ */ K(Z, {
							name: "displayOrders",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				a && C !== null && /* @__PURE__ */ K(v, { children: a({
					value: C,
					onChange: w,
					configurationKey: S?.id
				}) })
			] }),
			/* @__PURE__ */ K(pe, {
				integrationType: VC,
				integrationId: e,
				widgetName: k,
				isCreationMode: o,
				isSubmitting: s.formState.isSubmitting,
				automationCouplingState: i,
				onConfirmDelete: () => u()
			})
		]
	});
};
//#endregion
//#region ../widget-rivoloyalty/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._wrapper_l5y5y_54{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_l5y5y_59{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_l5y5y_67{text-align:center}._inputSeparator_l5y5y_71{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_l5y5y_76{color:var(--dixa-typography-color-link)}._noIssuesFound_l5y5y_80{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._list_l5y5y_85{background:linear-gradient(var(--dixa-color-neutral-000) 33%, #fff0), linear-gradient(#fff0, var(--dixa-color-neutral-000) 66%) 0 100%, radial-gradient(farthest-side at 50% 0, var(--dixa-color-neutral-200), #0000), radial-gradient(farthest-side at 50% 100%, var(--dixa-color-neutral-200), #0000) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-200), 100% var(--dixa-size-spacer-200);max-height:230px;padding:0;overflow-y:auto}._listItem_l5y5y_95{padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200);background-color:#0000}._listItem_l5y5y_95:last-child{box-shadow:none}._listItemHighlighted_l5y5y_103{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._listItemEdit_l5y5y_106{cursor:pointer}._fullWidth_l5y5y_110{width:100%}._boxWrapper_l5y5y_114{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._clickableIcon_l5y5y_120{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._list_rxh85_1{max-height:230px;padding:0;overflow-y:auto}._listItem_rxh85_6{cursor:pointer;font-size:var(--dixa-typography-size-100);padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200);background-color:#0000}._listItem_rxh85_6:last-child{box-shadow:none}._listItemHighlighted_rxh85_16{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._modalBody_1clhs_1{width:400px}._reward_1gmba_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1gmba_1:hover{border-color:var(--dixa-color-neutral-400)}._clickable_1gmba_10{cursor:pointer}._voucherCode_1gmba_14{font-family:monospace}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var GC = /* @__PURE__ */ function(e) {
	return e.CustomAction = "custom_action", e.FacebookLike = "facebook_like", e.FacebookShare = "facebook_share", e.InstagramFollow = "instagram_follow", e.Manual = "manual", e.ReferralComplete = "referral_complete", e.TiktokFollow = "tiktok_follow", e.TwitterFollow = "twitter_follow", e.TwitterShare = "twitter_share", e.VisitUrl = "visit_url", e;
}({}), KC = /* @__PURE__ */ function(e) {
	return e.Excluded = "excluded", e.Guest = "guest", e.Member = "member", e;
}({}), qC = {
	"\n  mutation adjustCustomerPoints(\n    $input: RivoLoyalty_adjust_customer_points_request_Input\n  ) {\n    RivoLoyalty {\n      adjust_customer_points(input: $input)\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "adjustCustomerPoints"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "RivoLoyalty_adjust_customer_points_request_Input"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "RivoLoyalty"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "adjust_customer_points"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}]
						}]
					}
				}]
			}
		}]
	},
	"\n  query getCustomer($email: String!) {\n    RivoLoyalty {\n      return_customer(\n        customer_identifier: $email\n        fields: \"lifetime_earnings_tally,next_vip_tier\"\n      ) {\n        data {\n          attributes {\n            id\n            email\n            first_name\n            last_name\n            accepts_marketing\n            orders_count\n            verified_email\n            total_spent\n            loyalty_status\n            points_tally\n            credits_tally\n            vip_tier {\n              name\n              threshold\n            }\n            points_expire_at\n            next_vip_tier {\n              name\n              threshold\n              to_spend_or_earn\n            }\n            lifetime_earnings_tally\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getCustomer"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "email"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "RivoLoyalty"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "return_customer"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "customer_identifier"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "email"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "fields"
								},
								value: {
									kind: "StringValue",
									value: "lifetime_earnings_tally,next_vip_tier",
									block: !1
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "data"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "attributes"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "email"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "first_name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "last_name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "accepts_marketing"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "orders_count"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "verified_email"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_spent"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "loyalty_status"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "points_tally"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "credits_tally"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "vip_tier"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "threshold"
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "points_expire_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "next_vip_tier"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "threshold"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "to_spend_or_earn"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "lifetime_earnings_tally"
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getFavoriteProducts($customerId: String!) {\n    RivoLoyalty {\n      list_customer_favorite_products(\n        customer_id: $customerId\n        data_source: shopify\n      ) {\n        data {\n          product_id\n          title\n          handle\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getFavoriteProducts"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "customerId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "RivoLoyalty"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "list_customer_favorite_products"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "customer_id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "customerId"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "data_source"
								},
								value: {
									kind: "EnumValue",
									value: "shopify"
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "data"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "product_id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "title"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "handle"
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getPointsRedemptions($customerId: String!) {\n    RivoLoyalty {\n      list_points_redemptions(\n        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId\n      ) {\n        data {\n          id\n          attributes {\n            points_amount\n            name\n            code\n            expires_at\n            used_at\n            refunded_at\n            revoked_at\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getPointsRedemptions"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "customerId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "RivoLoyalty"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "list_points_redemptions"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "customerId"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "data"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "attributes"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "points_amount"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "code"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "expires_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "used_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "refunded_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "revoked_at"
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	}
};
function JC(e) {
	return qC[e] ?? {};
}
var YC = JC("\n  query getCustomer($email: String!) {\n    RivoLoyalty {\n      return_customer(\n        customer_identifier: $email\n        fields: \"lifetime_earnings_tally,next_vip_tier\"\n      ) {\n        data {\n          attributes {\n            id\n            email\n            first_name\n            last_name\n            accepts_marketing\n            orders_count\n            verified_email\n            total_spent\n            loyalty_status\n            points_tally\n            credits_tally\n            vip_tier {\n              name\n              threshold\n            }\n            points_expire_at\n            next_vip_tier {\n              name\n              threshold\n              to_spend_or_earn\n            }\n            lifetime_earnings_tally\n          }\n        }\n      }\n    }\n  }\n"), XC = JC("\n  query getFavoriteProducts($customerId: String!) {\n    RivoLoyalty {\n      list_customer_favorite_products(\n        customer_id: $customerId\n        data_source: shopify\n      ) {\n        data {\n          product_id\n          title\n          handle\n        }\n      }\n    }\n  }\n"), ZC = JC("\n  query getPointsRedemptions($customerId: String!) {\n    RivoLoyalty {\n      list_points_redemptions(\n        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId\n      ) {\n        data {\n          id\n          attributes {\n            points_amount\n            name\n            code\n            expires_at\n            used_at\n            refunded_at\n            revoked_at\n          }\n        }\n      }\n    }\n  }\n"), QC = JC("\n  mutation adjustCustomerPoints(\n    $input: RivoLoyalty_adjust_customer_points_request_Input\n  ) {\n    RivoLoyalty {\n      adjust_customer_points(input: $input)\n    }\n  }\n"), $C = {
	wrapper: "_wrapper_l5y5y_54",
	inputWrapper: "_inputWrapper_l5y5y_59",
	inputField: "_inputField_l5y5y_67",
	inputSeparator: "_inputSeparator_l5y5y_71",
	buttonLink: "_buttonLink_l5y5y_76",
	noIssuesFound: "_noIssuesFound_l5y5y_80",
	list: "_list_l5y5y_85",
	listItem: "_listItem_l5y5y_95",
	listItemHighlighted: "_listItemHighlighted_l5y5y_103",
	listItemEdit: "_listItemEdit_l5y5y_106",
	fullWidth: "_fullWidth_l5y5y_110",
	boxWrapper: "_boxWrapper_l5y5y_114",
	clickableIcon: "_clickableIcon_l5y5y_120"
}, ew = "rivoLoyaltyShopifyApiHostName", tw = "https://admin.shopify.com";
function nw(e) {
	return e.split(".")[0];
}
var rw = {
	wrapper: "_wrapper_1xucg_1",
	externalLink: "_externalLink_1xucg_7"
}, iw = ({ customerDetails: e, rivoLoyaltyShopifyApiHostName: t }) => {
	let { track: n } = B(), { isCopied: r, copy: i } = Re(), { attributes: a } = e, { first_name: o, last_name: s, email: c, verified_email: l } = a, u = `${o || ""} ${s || ""}`.trim() || "No name found for customer";
	return /* @__PURE__ */ K(_, {
		gap: "300",
		flexDirection: "column",
		children: /* @__PURE__ */ q(_, {
			className: rw.wrapper,
			gap: "200",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ K(_, {
					justifyContent: "space-between",
					className: rw.block,
					alignItems: "center",
					children: /* @__PURE__ */ K(L.Heading, {
						variant: "heading-2",
						children: u
					})
				}),
				c && /* @__PURE__ */ q(_, {
					justifyContent: "space-between",
					alignItems: "center",
					children: [/* @__PURE__ */ q(_, {
						alignItems: "center",
						gap: "200",
						children: [
							/* @__PURE__ */ K(b, {
								size: 14,
								name: "mail"
							}),
							/* @__PURE__ */ K(L.ExternalLink, {
								href: `mailto:${c}`,
								children: c
							}),
							/* @__PURE__ */ K(R, {
								content: l ? "Verified email" : "Email is not verified",
								children: /* @__PURE__ */ K(_, {
									alignItems: "center",
									children: /* @__PURE__ */ K(b, {
										size: 14,
										color: l ? "green.500" : "red.500",
										name: l ? "check-circle" : "exclamation"
									})
								})
							})
						]
					}), /* @__PURE__ */ K(R, {
						content: "Copy Email",
						children: /* @__PURE__ */ K(b, {
							size: 14,
							name: r ? "done" : "copy",
							onClick: () => i(c),
							className: $C.clickableIcon
						})
					})]
				}),
				/* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "sign-in"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "2",
							children: "Marketing consent"
						})]
					}), /* @__PURE__ */ K(b, {
						name: a.accepts_marketing ? "check-circle-filled" : "close-circle-filled",
						color: a.accepts_marketing ? "green.500" : "neutral.500"
					})]
				}),
				/* @__PURE__ */ q(_, {
					alignItems: "center",
					gap: "200",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "external-link"
					}), /* @__PURE__ */ K(L.ExternalLink, {
						href: aw(t, a.id),
						target: "_blank",
						rel: "noreferrer",
						onClick: () => {
							n("rivoloyalty:customer:clicked", {});
						},
						children: "View customer in Rivo Loyalty"
					})]
				})
			]
		})
	});
};
function aw(e, t) {
	return `${tw}/store/${nw(e)}/apps/rivo-loyalty/customers/${t}`;
}
var ow = {
	list: "_list_rxh85_1",
	listItem: "_listItem_rxh85_6",
	listItemHighlighted: "_listItemHighlighted_rxh85_16"
}, sw = ({ customerId: e, rivoLoyaltyShopifyApiHostName: t }) => {
	let { useQuery: n } = V(), { loading: r, error: i, data: a } = n(XC, {
		skip: !e,
		variables: { customerId: e?.toString() }
	}), o = !r && a ? a.RivoLoyalty?.list_customer_favorite_products?.data ?? [] : [];
	return /* @__PURE__ */ K(G, { children: /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(L.Heading, {
			variant: "heading-3",
			children: "Favorite products"
		}), i ? /* @__PURE__ */ K(z, { error: i }) : r ? /* @__PURE__ */ K(_, {
			justifyContent: "center",
			margin: "300",
			children: /* @__PURE__ */ K(N, {})
		}) : o.length === 0 ? /* @__PURE__ */ K(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "No favorite products found."
		}) : /* @__PURE__ */ K(T, {
			className: ow.list,
			children: o.map((e) => /* @__PURE__ */ q(_, {
				alignItems: "center",
				gap: "200",
				className: ow.listItem,
				children: [/* @__PURE__ */ K(b, {
					size: 14,
					name: "external-link"
				}), /* @__PURE__ */ K(L.ExternalLink, {
					href: cw(t, e.product_id),
					target: "_blank",
					rel: "noreferrer",
					children: e.title
				})]
			}, e.product_id))
		})]
	}) });
};
function cw(e, t) {
	return `${tw}/store/${nw(e)}/products/${t}`;
}
var lw = { modalBody: "_modalBody_1clhs_1" };
function uw(e, t) {
	if (isNaN(e)) return "Points can not be empty";
	if (e < t.min) return `Points cannot be below ${t.min}`;
	if (e > t.max) return `Points can not exceed ${t.max}`;
}
function dw(e, t) {
	if (e === t) return "Change the value to update the points";
}
var fw = GC, pw = {
	addPoints: {
		successEventName: "rivoloyalty:points:add:succeeded",
		successEventText: "Added points successfully",
		failEventName: "rivoloyalty:points:add:failed",
		failEventText: "Failed to add points, try again later."
	},
	removePoints: {
		successEventName: "rivoloyalty:points:remove:succeeded",
		successEventText: "Removed points successfully",
		failEventName: "rivoloyalty:points:remove:failed",
		failEventText: "Failed to remove points, try again later."
	}
}, mw = ({ customerIdentifier: e, isOpen: t, points: n, onClose: r, refetchCustomerData: i }) => {
	let { useMutation: a, showNotification: o } = V(), { track: s } = B(), [c, l] = W(n), [u, d] = W(""), [f, h] = W(!0), [x, S] = W(), C = {
		min: 0,
		max: 1e5
	}, [w, { loading: A }] = a(QC, { onCompleted: () => {
		let e = c > n ? pw.addPoints : pw.removePoints;
		o({
			title: "Success",
			text: e.successEventText,
			icon: "check-circle-filled",
			severity: "success"
		}), s(e.successEventName), L();
	} }), j = () => {
		l(n), d(""), h(!0), S(void 0);
	};
	U(() => {
		t && j();
	}, [t]);
	let M = !!x, P = uw(c, C), F = dw(n, c), I = () => {
		if (c !== n) {
			let t = c > n ? pw.addPoints : pw.removePoints, r = !f;
			w({ variables: { input: {
				points_amount: c - n,
				...u && { internal_note: u },
				customer_identifier: e?.toString(),
				source: fw.Manual,
				skip_email: r
			} } }).catch(() => {
				s(t.failEventName), S([t.failEventText]);
			});
		}
	}, ee = () => {
		j(), r();
	}, L = () => {
		i(), ee();
	};
	return /* @__PURE__ */ q(E, {
		isOpen: t,
		onClose: ee,
		"data-testid": "rivo-loyalty-change-points-modal",
		children: [
			/* @__PURE__ */ K(k, {
				title: "Change points",
				onClose: ee
			}),
			/* @__PURE__ */ q(D, {
				className: lw.modalBody,
				children: [/* @__PURE__ */ q(y, { children: [
					/* @__PURE__ */ K(v, {
						span: 6,
						"data-testid": "rivo-loyalty-points-input",
						children: /* @__PURE__ */ K(m, {
							label: "New points balance",
							type: "number",
							placeholder: "Insert points balance",
							min: C.min,
							max: C.max,
							meta: {
								error: P,
								warning: F
							},
							input: {
								name: "points",
								value: c.toString(),
								onChange: (e) => l(e?.target.valueAsNumber ?? 0)
							}
						})
					}),
					/* @__PURE__ */ K(v, {
						span: 6,
						children: /* @__PURE__ */ K(m, {
							label: "Internal note",
							placeholder: "Insert an internal note (optional)",
							input: {
								name: "internalNote",
								value: u,
								onChange: (e) => d(e?.target.value ?? "")
							}
						})
					}),
					/* @__PURE__ */ K(v, {
						span: 6,
						children: /* @__PURE__ */ K(g, {
							label: "Notify the customer by email",
							children: /* @__PURE__ */ K(p, { input: {
								name: "sendEmail",
								value: "sendEmail",
								checked: f,
								onChange: () => h(!f)
							} })
						})
					})
				] }), !A && M && /* @__PURE__ */ K(_, {
					margin: "200 0",
					flexDirection: "column",
					children: /* @__PURE__ */ K(T, { children: x?.map((e, t) => /* @__PURE__ */ K(T.Item, {
						variant: "dense",
						title: e,
						contentLeft: /* @__PURE__ */ K(b, {
							color: "red.500",
							size: 16,
							name: "exclamation-triangle-filled"
						})
					}, t)) })
				})]
			}),
			/* @__PURE__ */ K(O, {
				confirmName: "Save",
				confirmOnClick: () => I(),
				confirmProps: {
					isLoading: A,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 }),
					disabled: !!(P || F)
				},
				cancelOnClick: ee
			})
		]
	});
}, hw = ({ description: e, content: t, tooltip: n, isHighlighted: r = !1 }) => {
	if (t == null) return null;
	let i = qe(t);
	return /* @__PURE__ */ K(T.Text, {
		variant: "dense",
		className: ae($C.listItem, { [$C.listItemHighlighted]: r }),
		children: /* @__PURE__ */ K(R, {
			content: n,
			children: /* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				alignItems: "center",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					children: e
				}), i ? t : ge(t)]
			})
		})
	});
}, gw = {
	[KC.Guest]: {
		name: "Guest",
		tooltip: "Customers who can participate in your loyalty program without creating a full account. They can earn and redeem points through email verification or one-time codes.",
		badgeColor: "info"
	},
	[KC.Member]: {
		name: "Member",
		tooltip: "Customers who have activated their loyalty membership and have full access to all program features, including account dashboards and advanced features.",
		badgeColor: "success"
	},
	[KC.Excluded]: {
		name: "Excluded",
		tooltip: "Customers who have been excluded from the loyalty program (typically through the “Rivo Excluded” tag or manual exclusion).",
		badgeColor: "warning"
	}
}, _w = ({ customer: e, allowAdjustLoyaltyPoints: t, refetchCustomerData: r }) => {
	let { attributes: i } = e, a = i.loyalty_status ? gw[i.loyalty_status] : gw[KC.Guest], o = a?.name === KC.Excluded, s = i.lifetime_earnings_tally ?? 0, c = i.total_spent ?? 0, l = Math.trunc(i.points_tally ?? 0), u = i.next_vip_tier, d = i.next_vip_tier?.to_spend_or_earn ?? 0, f = u?.name ?? "None", [p, m] = W(!1), h = () => /* @__PURE__ */ K(T.Text, {
		variant: "dense",
		className: ae($C.listItem),
		children: /* @__PURE__ */ K(R, {
			content: a.tooltip,
			children: /* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				alignItems: "center",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					children: "Loyalty status"
				}), /* @__PURE__ */ K(n, {
					variant: a.badgeColor,
					size: "small",
					children: a.name
				})]
			})
		})
	});
	return /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(L.Heading, {
			variant: "heading-3",
			children: "Loyalty"
		}), /* @__PURE__ */ K(T, {
			className: $C.list,
			children: o ? h() : /* @__PURE__ */ q(G, { children: [
				/* @__PURE__ */ K(T.Text, {
					variant: "dense",
					className: ae($C.listItem, $C.listItemHighlighted, { [$C.listItemEdit]: t }),
					onClick: () => t ? m(!0) : void 0,
					children: /* @__PURE__ */ K(R, {
						content: "The current balance of loyalty points for the customer.",
						children: /* @__PURE__ */ q(_, {
							justifyContent: "space-between",
							alignItems: "center",
							children: [/* @__PURE__ */ K(L.Paragraph, {
								variant: "4",
								children: "Points balance"
							}), /* @__PURE__ */ q(_, {
								alignItems: "center",
								justifyContent: "space-between",
								gap: "100",
								children: [t && /* @__PURE__ */ K(b, {
									name: "pen",
									size: 10,
									"aria-label": "Edit points"
								}), /* @__PURE__ */ K(L.Paragraph, {
									variant: "4",
									children: ge(l)
								})]
							})]
						})
					})
				}),
				d != null && f && /* @__PURE__ */ K(hw, {
					description: `Points until ${f} tier`,
					tooltip: `Loyalty points until the customer advances to ${f} tier`,
					content: d.toFixed(2)
				}),
				/* @__PURE__ */ K(hw, {
					description: "Points expiry date",
					tooltip: "The timestamp when the customer's loyalty points are set to expire.",
					content: i.points_expire_at ?? "No expiry"
				}),
				/* @__PURE__ */ K(hw, {
					description: "Total points earned",
					tooltip: "The total number of loyalty points earned by the customer.",
					content: s?.toFixed(2)
				}),
				/* @__PURE__ */ K(hw, {
					description: "Total points spent",
					tooltip: "The total number of loyalty points spent by the customer.",
					content: c.toFixed(2)
				}),
				h(),
				/* @__PURE__ */ K(hw, {
					description: "VIP tier",
					tooltip: "The name of the customer's current VIP tier status.",
					content: i.vip_tier?.name ?? "None"
				}),
				/* @__PURE__ */ K(hw, {
					description: "Next VIP tier",
					tooltip: "The name of the customer's next VIP tier status.",
					content: f
				})
			] })
		})]
	}), /* @__PURE__ */ K(mw, {
		customerIdentifier: i.id,
		isOpen: p,
		points: l,
		onClose: () => m(!1),
		refetchCustomerData: r
	})] });
}, vw = ({ ordersCount: e }) => /* @__PURE__ */ K(G, { children: /* @__PURE__ */ q(_, {
	gap: "200",
	flexDirection: "column",
	children: [/* @__PURE__ */ K(L.Heading, {
		variant: "heading-3",
		children: "Orders overview"
	}), /* @__PURE__ */ K(T, {
		className: $C.list,
		children: /* @__PURE__ */ K(T.Text, {
			variant: "dense",
			className: $C.listItem,
			children: /* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					children: "Total orders"
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					children: e ?? 0
				})]
			})
		})
	})]
}) }), yw = {
	reward: "_reward_1gmba_1",
	clickable: "_clickable_1gmba_10",
	voucherCode: "_voucherCode_1gmba_14"
}, bw = ({ pointsRedemption: e }) => {
	let { isCopied: t, copy: r } = Re(), { name: i, code: a, points_amount: o } = e.attributes;
	return /* @__PURE__ */ K(_, {
		gap: "100",
		flexDirection: "column",
		children: /* @__PURE__ */ q(_, {
			gap: "100",
			flexDirection: "column",
			className: yw.reward,
			children: [/* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ q(_, {
					gap: "100",
					alignItems: "center",
					children: [/* @__PURE__ */ K(b, {
						name: "star",
						size: 12,
						color: "neutral.500"
					}), i]
				}), /* @__PURE__ */ q(n, {
					size: "small",
					variant: "info",
					children: [o ?? 0, " points"]
				})]
			}), /* @__PURE__ */ q(_, {
				gap: "100",
				flexDirection: "row",
				alignItems: "center",
				justifyContent: "space-between",
				children: [/* @__PURE__ */ q(_, {
					gap: "100",
					flexDirection: "row",
					alignItems: "center",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "tag"
					}), /* @__PURE__ */ K(_, { children: /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						className: yw.voucherCode,
						children: a
					}) })]
				}), /* @__PURE__ */ K(R, {
					content: "Copy reward code",
					children: /* @__PURE__ */ K(b, {
						size: 14,
						name: t ? "done" : "copy",
						className: $C.clickableIcon,
						onClick: () => r(a)
					})
				})]
			})]
		})
	});
}, xw = ({ customer: e }) => {
	let { useQuery: t } = V(), { loading: n, error: r, data: i } = t(ZC, {
		skip: !e,
		variables: { customerId: e.attributes.id.toString() }
	}), a = (!n && e && i ? i?.RivoLoyalty?.list_points_redemptions?.data ?? [] : []).filter(({ attributes: e }) => Sw({
		usedAt: e.used_at,
		revokedAt: e.revoked_at,
		refundedAt: e.refunded_at
	}) === "Issued");
	return /* @__PURE__ */ K(G, { children: /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(L.Heading, {
			variant: "heading-3",
			children: "Available rewards"
		}), r ? /* @__PURE__ */ K(z, { error: r }) : n ? /* @__PURE__ */ K(_, {
			justifyContent: "center",
			margin: "300",
			children: /* @__PURE__ */ K(N, {})
		}) : a.length > 0 ? /* @__PURE__ */ K(_, {
			gap: "200",
			flexDirection: "column",
			children: a.map((e) => /* @__PURE__ */ K(bw, { pointsRedemption: e }, e.id))
		}) : /* @__PURE__ */ K(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "No loyalty rewards found."
		})]
	}) });
};
function Sw(e) {
	return e.usedAt ? "Used" : e.revokedAt ? "Revoked" : e.refundedAt ? "Refunded" : "Issued";
}
var Cw = (e) => {
	let { conversationContext: t, settings: n } = e, { rivoLoyaltyShowOrders: r, rivoLoyaltyShowLoyalty: i, rivoLoyaltyAdjustLoyaltyPoints: a, rivoLoyaltyShowFavoriteProducts: o, rivoLoyaltyShowPointsRedemptions: s } = n, c = n[ew].toString(), { useQuery: l } = V(), { track: u } = B(), [d, f] = W(!1), p = t?.customer?.email, { loading: m, error: h, data: g, refetch: v } = l(YC, {
		skip: !p,
		variables: { email: p }
	}), y = !m && g ? g.RivoLoyalty?.return_customer?.data : void 0;
	U(() => {
		!m && y && !d && (u("rivoloyalty:customer:received"), f(!0));
	}, [m, y]);
	let b = () => /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: /* @__PURE__ */ K(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "No customer profile found."
		})
	});
	if (h) {
		let e = h.graphQLErrors;
		return Se({ errors: e }) ? b() : xe({ errors: e }) ? /* @__PURE__ */ K(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			variant: "4",
			"data-testid": "widget-downstream-api-forbidden-error",
			children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
		}) : be({ errors: e }) ? /* @__PURE__ */ K(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			variant: "4",
			"data-testid": "widget-downstream-api-authorization-error",
			children: "The integration could not authorize against Rivo Loyalty. Please contact your administrator."
		}) : /* @__PURE__ */ K(z, { error: h });
	}
	return m ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "300",
		children: /* @__PURE__ */ K(N, {})
	}) : !p || !y ? b() : /* @__PURE__ */ q(_, {
		gap: "300",
		flexDirection: "column",
		margin: "200 0 300 0",
		"data-testid": "widget-wrapper",
		children: [
			/* @__PURE__ */ K(iw, {
				customerDetails: y,
				rivoLoyaltyShopifyApiHostName: c
			}),
			r && /* @__PURE__ */ K(vw, { ordersCount: y.attributes?.orders_count ?? 0 }),
			i && /* @__PURE__ */ K(_w, {
				customer: y,
				refetchCustomerData: v,
				allowAdjustLoyaltyPoints: !!a
			}),
			o && /* @__PURE__ */ K(sw, {
				customerId: y.attributes.id,
				rivoLoyaltyShopifyApiHostName: c
			}),
			s && /* @__PURE__ */ K(xw, { customer: y })
		]
	});
}, ww = Xo, Tw = (e) => e.type === "checkbox", Ew = (e) => e instanceof Date, Dw = (e) => e == null, Ow = (e) => typeof e == "object", kw = (e) => !Dw(e) && !Array.isArray(e) && Ow(e) && !Ew(e), Aw = (e) => kw(e) && e.target ? Tw(e.target) ? e.target.checked : e.target.value : e, jw = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Mw = (e, t) => e.has(jw(t)), Nw = (e) => {
	let t = e.constructor && e.constructor.prototype;
	return kw(t) && t.hasOwnProperty("isPrototypeOf");
}, Pw = typeof window < "u" && window.HTMLElement !== void 0 && typeof document < "u";
function Fw(e) {
	let t, n = Array.isArray(e), r = typeof FileList < "u" && e instanceof FileList;
	if (e instanceof Date) t = new Date(e);
	else if (e instanceof Set) t = new Set(e);
	else if (!(Pw && (e instanceof Blob || r)) && (n || kw(e))) if (t = n ? [] : {}, !n && !Nw(e)) t = e;
	else for (let n in e) e.hasOwnProperty(n) && (t[n] = Fw(e[n]));
	else return e;
	return t;
}
var Iw = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Lw = (e) => e === void 0, $ = (e, t, n) => {
	if (!t || !kw(e)) return n;
	let r = Iw(t.split(/[,[\].]+?/)).reduce((e, t) => Dw(e) ? e : e[t], e);
	return Lw(r) || r === e ? Lw(e[t]) ? n : e[t] : r;
}, Rw = (e) => typeof e == "boolean", zw = (e) => /^\w*$/.test(e), Bw = (e) => Iw(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Vw = (e, t, n) => {
	let r = -1, i = zw(t) ? [t] : Bw(t), a = i.length, o = a - 1;
	for (; ++r < a;) {
		let t = i[r], a = n;
		if (r !== o) {
			let n = e[t];
			a = kw(n) || Array.isArray(n) ? n : isNaN(+i[r + 1]) ? {} : [];
		}
		if (t === "__proto__" || t === "constructor" || t === "prototype") return;
		e[t] = a, e = e[t];
	}
}, Hw = {
	BLUR: "blur",
	FOCUS_OUT: "focusout",
	CHANGE: "change"
}, Uw = {
	onBlur: "onBlur",
	onChange: "onChange",
	onSubmit: "onSubmit",
	onTouched: "onTouched",
	all: "all"
}, Ww = {
	max: "max",
	min: "min",
	maxLength: "maxLength",
	minLength: "minLength",
	pattern: "pattern",
	required: "required",
	validate: "validate"
}, Gw = H.createContext(null), Kw = () => H.useContext(Gw), qw = (e, t, n, r = !0) => {
	let i = { defaultValues: t._defaultValues };
	for (let a in e) Object.defineProperty(i, a, { get: () => {
		let i = a;
		return t._proxyFormState[i] !== Uw.all && (t._proxyFormState[i] = !r || Uw.all), n && (n[i] = !0), e[i];
	} });
	return i;
};
function Jw(e) {
	let t = Kw(), { control: n = t.control, disabled: r, name: i, exact: a } = e || {}, [o, s] = H.useState(n._formState), c = H.useRef({
		isDirty: !1,
		isLoading: !1,
		dirtyFields: !1,
		touchedFields: !1,
		validatingFields: !1,
		isValidating: !1,
		isValid: !1,
		errors: !1
	}), l = H.useRef(i);
	return l.current = i, H.useEffect(() => n._subscribe({
		name: l.current,
		formState: c.current,
		exact: a,
		callback: (e) => {
			!r && s({
				...n._formState,
				...e
			});
		}
	}), [
		n,
		r,
		a
	]), H.useEffect(() => {
		c.current.isValid && n._setValid(!0);
	}, [n]), H.useMemo(() => qw(o, n, c.current, !1), [o, n]);
}
var Yw = (e) => typeof e == "string", Xw = (e, t, n, r, i) => Yw(e) ? (r && t.watch.add(e), $(n, e, i)) : Array.isArray(e) ? e.map((e) => (r && t.watch.add(e), $(n, e))) : (r && (t.watchAll = !0), n);
function Zw(e) {
	let t = Kw(), { control: n = t.control, name: r, defaultValue: i, disabled: a, exact: o } = e || {}, s = H.useRef(r), c = H.useRef(i);
	s.current = r, H.useEffect(() => n._subscribe({
		name: s.current,
		formState: { values: !0 },
		exact: o,
		callback: (e) => !a && u(Xw(s.current, n._names, e.values || n._formValues, !1, c.current))
	}), [
		n,
		a,
		o
	]);
	let [l, u] = H.useState(n._getWatch(r, i));
	return H.useEffect(() => n._removeUnmounted()), l;
}
function Qw(e) {
	let t = Kw(), { name: n, disabled: r, control: i = t.control, shouldUnregister: a } = e, o = Mw(i._names.array, n), s = Zw({
		control: i,
		name: n,
		defaultValue: $(i._formValues, n, $(i._defaultValues, n, e.defaultValue)),
		exact: !0
	}), c = Jw({
		control: i,
		name: n,
		exact: !0
	}), l = H.useRef(e), u = H.useRef(i.register(n, {
		...e.rules,
		value: s,
		...Rw(e.disabled) ? { disabled: e.disabled } : {}
	})), d = H.useMemo(() => Object.defineProperties({}, {
		invalid: {
			enumerable: !0,
			get: () => !!$(c.errors, n)
		},
		isDirty: {
			enumerable: !0,
			get: () => !!$(c.dirtyFields, n)
		},
		isTouched: {
			enumerable: !0,
			get: () => !!$(c.touchedFields, n)
		},
		isValidating: {
			enumerable: !0,
			get: () => !!$(c.validatingFields, n)
		},
		error: {
			enumerable: !0,
			get: () => $(c.errors, n)
		}
	}), [c, n]), f = H.useCallback((e) => u.current.onChange({
		target: {
			value: Aw(e),
			name: n
		},
		type: Hw.CHANGE
	}), [n]), p = H.useCallback(() => u.current.onBlur({
		target: {
			value: $(i._formValues, n),
			name: n
		},
		type: Hw.BLUR
	}), [n, i._formValues]), m = H.useCallback((e) => {
		let t = $(i._fields, n);
		t && e && (t._f.ref = {
			focus: () => e.focus(),
			select: () => e.select(),
			setCustomValidity: (t) => e.setCustomValidity(t),
			reportValidity: () => e.reportValidity()
		});
	}, [i._fields, n]), h = H.useMemo(() => ({
		name: n,
		value: s,
		...Rw(r) || c.disabled ? { disabled: c.disabled || r } : {},
		onChange: f,
		onBlur: p,
		ref: m
	}), [
		n,
		r,
		c.disabled,
		f,
		p,
		m,
		s
	]);
	return H.useEffect(() => {
		let e = i._options.shouldUnregister || a;
		i.register(n, {
			...l.current.rules,
			...Rw(l.current.disabled) ? { disabled: l.current.disabled } : {}
		});
		let t = (e, t) => {
			let n = $(i._fields, e);
			n && n._f && (n._f.mount = t);
		};
		if (t(n, !0), e) {
			let e = Fw($(i._options.defaultValues, n));
			Vw(i._defaultValues, n, e), Lw($(i._formValues, n)) && Vw(i._formValues, n, e);
		}
		return !o && i.register(n), () => {
			(o ? e && !i._state.action : e) ? i.unregister(n) : t(n, !1);
		};
	}, [
		n,
		i,
		o,
		a
	]), H.useEffect(() => {
		i._setDisabledField({
			disabled: r,
			name: n
		});
	}, [
		r,
		n,
		i
	]), H.useMemo(() => ({
		field: h,
		formState: c,
		fieldState: d
	}), [
		h,
		c,
		d
	]);
}
var $w = (e, t, n, r, i) => t ? {
	...n[e],
	types: {
		...n[e] && n[e].types ? n[e].types : {},
		[r]: i || !0
	}
} : {}, eT = (e) => Array.isArray(e) ? e : [e], tT = () => {
	let e = [];
	return {
		get observers() {
			return e;
		},
		next: (t) => {
			for (let n of e) n.next && n.next(t);
		},
		subscribe: (t) => (e.push(t), { unsubscribe: () => {
			e = e.filter((e) => e !== t);
		} }),
		unsubscribe: () => {
			e = [];
		}
	};
}, nT = (e) => Dw(e) || !Ow(e);
function rT(e, t) {
	if (nT(e) || nT(t)) return e === t;
	if (Ew(e) && Ew(t)) return e.getTime() === t.getTime();
	let n = Object.keys(e), r = Object.keys(t);
	if (n.length !== r.length) return !1;
	for (let i of n) {
		let n = e[i];
		if (!r.includes(i)) return !1;
		if (i !== "ref") {
			let e = t[i];
			if (Ew(n) && Ew(e) || kw(n) && kw(e) || Array.isArray(n) && Array.isArray(e) ? !rT(n, e) : n !== e) return !1;
		}
	}
	return !0;
}
var iT = (e) => kw(e) && !Object.keys(e).length, aT = (e) => e.type === "file", oT = (e) => typeof e == "function", sT = (e) => {
	if (!Pw) return !1;
	let t = e ? e.ownerDocument : 0;
	return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, cT = (e) => e.type === "select-multiple", lT = (e) => e.type === "radio", uT = (e) => lT(e) || Tw(e), dT = (e) => sT(e) && e.isConnected;
function fT(e, t) {
	let n = t.slice(0, -1).length, r = 0;
	for (; r < n;) e = Lw(e) ? r++ : e[t[r++]];
	return e;
}
function pT(e) {
	for (let t in e) if (e.hasOwnProperty(t) && !Lw(e[t])) return !1;
	return !0;
}
function mT(e, t) {
	let n = Array.isArray(t) ? t : zw(t) ? [t] : Bw(t), r = n.length === 1 ? e : fT(e, n), i = n.length - 1, a = n[i];
	return r && delete r[a], i !== 0 && (kw(r) && iT(r) || Array.isArray(r) && pT(r)) && mT(e, n.slice(0, -1)), e;
}
var hT = (e) => {
	for (let t in e) if (oT(e[t])) return !0;
	return !1;
};
function gT(e, t = {}) {
	let n = Array.isArray(e);
	if (kw(e) || n) for (let n in e) Array.isArray(e[n]) || kw(e[n]) && !hT(e[n]) ? (t[n] = Array.isArray(e[n]) ? [] : {}, gT(e[n], t[n])) : Dw(e[n]) || (t[n] = !0);
	return t;
}
function _T(e, t, n) {
	let r = Array.isArray(e);
	if (kw(e) || r) for (let r in e) Array.isArray(e[r]) || kw(e[r]) && !hT(e[r]) ? Lw(t) || nT(n[r]) ? n[r] = Array.isArray(e[r]) ? gT(e[r], []) : { ...gT(e[r]) } : _T(e[r], Dw(t) ? {} : t[r], n[r]) : n[r] = !rT(e[r], t[r]);
	return n;
}
var vT = (e, t) => _T(e, t, gT(t)), yT = {
	value: !1,
	isValid: !1
}, bT = {
	value: !0,
	isValid: !0
}, xT = (e) => {
	if (Array.isArray(e)) {
		if (e.length > 1) {
			let t = e.filter((e) => e && e.checked && !e.disabled).map((e) => e.value);
			return {
				value: t,
				isValid: !!t.length
			};
		}
		return e[0].checked && !e[0].disabled ? e[0].attributes && !Lw(e[0].attributes.value) ? Lw(e[0].value) || e[0].value === "" ? bT : {
			value: e[0].value,
			isValid: !0
		} : bT : yT;
	}
	return yT;
}, ST = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => Lw(e) ? e : t ? e === "" ? NaN : e && +e : n && Yw(e) ? new Date(e) : r ? r(e) : e, CT = {
	isValid: !1,
	value: null
}, wT = (e) => Array.isArray(e) ? e.reduce((e, t) => t && t.checked && !t.disabled ? {
	isValid: !0,
	value: t.value
} : e, CT) : CT;
function TT(e) {
	let t = e.ref;
	return aT(t) ? t.files : lT(t) ? wT(e.refs).value : cT(t) ? [...t.selectedOptions].map(({ value: e }) => e) : Tw(t) ? xT(e.refs).value : ST(Lw(t.value) ? e.ref.value : t.value, e);
}
var ET = (e, t, n, r) => {
	let i = {};
	for (let n of e) {
		let e = $(t, n);
		e && Vw(i, n, e._f);
	}
	return {
		criteriaMode: n,
		names: [...e],
		fields: i,
		shouldUseNativeValidation: r
	};
}, DT = (e) => e instanceof RegExp, OT = (e) => Lw(e) ? e : DT(e) ? e.source : kw(e) ? DT(e.value) ? e.value.source : e.value : e, kT = (e) => ({
	isOnSubmit: !e || e === Uw.onSubmit,
	isOnBlur: e === Uw.onBlur,
	isOnChange: e === Uw.onChange,
	isOnAll: e === Uw.all,
	isOnTouch: e === Uw.onTouched
}), AT = "AsyncFunction", jT = (e) => !!e && !!e.validate && !!(oT(e.validate) && e.validate.constructor.name === AT || kw(e.validate) && Object.values(e.validate).find((e) => e.constructor.name === AT)), MT = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), NT = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((t) => e.startsWith(t) && /^\.\w+/.test(e.slice(t.length)))), PT = (e, t, n, r) => {
	for (let i of n || Object.keys(e)) {
		let n = $(e, i);
		if (n) {
			let { _f: e, ...a } = n;
			if (e) {
				if (e.refs && e.refs[0] && t(e.refs[0], i) && !r || e.ref && t(e.ref, e.name) && !r) return !0;
				if (PT(a, t)) break;
			} else if (kw(a) && PT(a, t)) break;
		}
	}
};
function FT(e, t, n) {
	let r = $(e, n);
	if (r || zw(n)) return {
		error: r,
		name: n
	};
	let i = n.split(".");
	for (; i.length;) {
		let r = i.join("."), a = $(t, r), o = $(e, r);
		if (a && !Array.isArray(a) && n !== r) return { name: n };
		if (o && o.type) return {
			name: r,
			error: o
		};
		i.pop();
	}
	return { name: n };
}
var IT = (e, t, n, r) => {
	n(e);
	let { name: i, ...a } = e;
	return iT(a) || Object.keys(a).length >= Object.keys(t).length || Object.keys(a).find((e) => t[e] === (!r || Uw.all));
}, LT = (e, t, n) => !e || !t || e === t || eT(e).some((e) => e && (n ? e === t : e.startsWith(t) || t.startsWith(e))), RT = (e, t, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(t || e) : (n ? r.isOnBlur : i.isOnBlur) ? !e : (n ? r.isOnChange : i.isOnChange) ? e : !0, zT = (e, t) => !Iw($(e, t)).length && mT(e, t), BT = (e, t, n) => {
	let r = eT($(e, n));
	return Vw(r, "root", t[n]), Vw(e, n, r), e;
}, VT = (e) => Yw(e);
function HT(e, t, n = "validate") {
	if (VT(e) || Array.isArray(e) && e.every(VT) || Rw(e) && !e) return {
		type: n,
		message: VT(e) ? e : "",
		ref: t
	};
}
var UT = (e) => kw(e) && !DT(e) ? e : {
	value: e,
	message: ""
}, WT = async (e, t, n, r, i, a) => {
	let { ref: o, refs: s, required: c, maxLength: l, minLength: u, min: d, max: f, pattern: p, validate: m, name: h, valueAsNumber: g, mount: _ } = e._f, v = $(n, h);
	if (!_ || t.has(h)) return {};
	let y = s ? s[0] : o, b = (e) => {
		i && y.reportValidity && (y.setCustomValidity(Rw(e) ? "" : e || ""), y.reportValidity());
	}, x = {}, S = lT(o), C = Tw(o), w = S || C, T = (g || aT(o)) && Lw(o.value) && Lw(v) || sT(o) && o.value === "" || v === "" || Array.isArray(v) && !v.length, E = $w.bind(null, h, r, x), D = (e, t, n, r = Ww.maxLength, i = Ww.minLength) => {
		let a = e ? t : n;
		x[h] = {
			type: e ? r : i,
			message: a,
			ref: o,
			...E(e ? r : i, a)
		};
	};
	if (a ? !Array.isArray(v) || !v.length : c && (!w && (T || Dw(v)) || Rw(v) && !v || C && !xT(s).isValid || S && !wT(s).isValid)) {
		let { value: e, message: t } = VT(c) ? {
			value: !!c,
			message: c
		} : UT(c);
		if (e && (x[h] = {
			type: Ww.required,
			message: t,
			ref: y,
			...E(Ww.required, t)
		}, !r)) return b(t), x;
	}
	if (!T && (!Dw(d) || !Dw(f))) {
		let e, t, n = UT(f), i = UT(d);
		if (!Dw(v) && !isNaN(v)) {
			let r = o.valueAsNumber || v && +v;
			Dw(n.value) || (e = r > n.value), Dw(i.value) || (t = r < i.value);
		} else {
			let r = o.valueAsDate || new Date(v), a = (e) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + e), s = o.type == "time", c = o.type == "week";
			Yw(n.value) && v && (e = s ? a(v) > a(n.value) : c ? v > n.value : r > new Date(n.value)), Yw(i.value) && v && (t = s ? a(v) < a(i.value) : c ? v < i.value : r < new Date(i.value));
		}
		if ((e || t) && (D(!!e, n.message, i.message, Ww.max, Ww.min), !r)) return b(x[h].message), x;
	}
	if ((l || u) && !T && (Yw(v) || a && Array.isArray(v))) {
		let e = UT(l), t = UT(u), n = !Dw(e.value) && v.length > +e.value, i = !Dw(t.value) && v.length < +t.value;
		if ((n || i) && (D(n, e.message, t.message), !r)) return b(x[h].message), x;
	}
	if (p && !T && Yw(v)) {
		let { value: e, message: t } = UT(p);
		if (DT(e) && !v.match(e) && (x[h] = {
			type: Ww.pattern,
			message: t,
			ref: o,
			...E(Ww.pattern, t)
		}, !r)) return b(t), x;
	}
	if (m) {
		if (oT(m)) {
			let e = HT(await m(v, n), y);
			if (e && (x[h] = {
				...e,
				...E(Ww.validate, e.message)
			}, !r)) return b(e.message), x;
		} else if (kw(m)) {
			let e = {};
			for (let t in m) {
				if (!iT(e) && !r) break;
				let i = HT(await m[t](v, n), y, t);
				i && (e = {
					...i,
					...E(t, i.message)
				}, b(i.message), r && (x[h] = e));
			}
			if (!iT(e) && (x[h] = {
				ref: y,
				...e
			}, !r)) return x;
		}
	}
	return b(!0), x;
}, GT = {
	mode: Uw.onSubmit,
	reValidateMode: Uw.onChange,
	shouldFocusError: !0
};
function KT(e = {}) {
	let t = {
		...GT,
		...e
	}, n = {
		submitCount: 0,
		isDirty: !1,
		isLoading: oT(t.defaultValues),
		isValidating: !1,
		isSubmitted: !1,
		isSubmitting: !1,
		isSubmitSuccessful: !1,
		isValid: !1,
		touchedFields: {},
		dirtyFields: {},
		validatingFields: {},
		errors: t.errors || {},
		disabled: t.disabled || !1
	}, r = {}, i = (kw(t.defaultValues) || kw(t.values)) && Fw(t.values || t.defaultValues) || {}, a = t.shouldUnregister ? {} : Fw(i), o = {
		action: !1,
		mount: !1,
		watch: !1
	}, s = {
		mount: /* @__PURE__ */ new Set(),
		disabled: /* @__PURE__ */ new Set(),
		unMount: /* @__PURE__ */ new Set(),
		array: /* @__PURE__ */ new Set(),
		watch: /* @__PURE__ */ new Set()
	}, c, l = 0, u = {
		isDirty: !1,
		dirtyFields: !1,
		validatingFields: !1,
		touchedFields: !1,
		isValidating: !1,
		isValid: !1,
		errors: !1
	}, d = { ...u }, f = {
		array: tT(),
		state: tT()
	}, p = kT(t.mode), m = kT(t.reValidateMode), h = t.criteriaMode === Uw.all, g = (e) => (t) => {
		clearTimeout(l), l = setTimeout(e, t);
	}, _ = async (e) => {
		if (!t.disabled && (u.isValid || d.isValid || e)) {
			let e = t.resolver ? iT((await T()).errors) : await D(r, !0);
			e !== n.isValid && f.state.next({ isValid: e });
		}
	}, v = (e, r) => {
		!t.disabled && (u.isValidating || u.validatingFields || d.isValidating || d.validatingFields) && ((e || Array.from(s.mount)).forEach((e) => {
			e && (r ? Vw(n.validatingFields, e, r) : mT(n.validatingFields, e));
		}), f.state.next({
			validatingFields: n.validatingFields,
			isValidating: !iT(n.validatingFields)
		}));
	}, y = (e, s = [], c, l, p = !0, m = !0) => {
		if (l && c && !t.disabled) {
			if (o.action = !0, m && Array.isArray($(r, e))) {
				let t = c($(r, e), l.argA, l.argB);
				p && Vw(r, e, t);
			}
			if (m && Array.isArray($(n.errors, e))) {
				let t = c($(n.errors, e), l.argA, l.argB);
				p && Vw(n.errors, e, t), zT(n.errors, e);
			}
			if ((u.touchedFields || d.touchedFields) && m && Array.isArray($(n.touchedFields, e))) {
				let t = c($(n.touchedFields, e), l.argA, l.argB);
				p && Vw(n.touchedFields, e, t);
			}
			(u.dirtyFields || d.dirtyFields) && (n.dirtyFields = vT(i, a)), f.state.next({
				name: e,
				isDirty: k(e, s),
				dirtyFields: n.dirtyFields,
				errors: n.errors,
				isValid: n.isValid
			});
		} else Vw(a, e, s);
	}, b = (e, t) => {
		Vw(n.errors, e, t), f.state.next({ errors: n.errors });
	}, x = (e) => {
		n.errors = e, f.state.next({
			errors: n.errors,
			isValid: !1
		});
	}, S = (e, t, n, s) => {
		let c = $(r, e);
		if (c) {
			let r = $(a, e, Lw(n) ? $(i, e) : n);
			Lw(r) || s && s.defaultChecked || t ? Vw(a, e, t ? r : TT(c._f)) : M(e, r), o.mount && _();
		}
	}, C = (e, r, a, o, s) => {
		let c = !1, l = !1, p = { name: e };
		if (!t.disabled) {
			if (!a || o) {
				(u.isDirty || d.isDirty) && (l = n.isDirty, n.isDirty = p.isDirty = k(), c = l !== p.isDirty);
				let t = rT($(i, e), r);
				l = !!$(n.dirtyFields, e), t ? mT(n.dirtyFields, e) : Vw(n.dirtyFields, e, !0), p.dirtyFields = n.dirtyFields, c ||= (u.dirtyFields || d.dirtyFields) && l !== !t;
			}
			if (a) {
				let t = $(n.touchedFields, e);
				t || (Vw(n.touchedFields, e, a), p.touchedFields = n.touchedFields, c ||= (u.touchedFields || d.touchedFields) && t !== a);
			}
			c && s && f.state.next(p);
		}
		return c ? p : {};
	}, w = (e, r, i, a) => {
		let o = $(n.errors, e), s = (u.isValid || d.isValid) && Rw(r) && n.isValid !== r;
		if (t.delayError && i ? (c = g(() => b(e, i)), c(t.delayError)) : (clearTimeout(l), c = null, i ? Vw(n.errors, e, i) : mT(n.errors, e)), (i ? !rT(o, i) : o) || !iT(a) || s) {
			let t = {
				...a,
				...s && Rw(r) ? { isValid: r } : {},
				errors: n.errors,
				name: e
			};
			n = {
				...n,
				...t
			}, f.state.next(t);
		}
	}, T = async (e) => {
		v(e, !0);
		let n = await t.resolver(a, t.context, ET(e || s.mount, r, t.criteriaMode, t.shouldUseNativeValidation));
		return v(e), n;
	}, E = async (e) => {
		let { errors: t } = await T(e);
		if (e) for (let r of e) {
			let e = $(t, r);
			e ? Vw(n.errors, r, e) : mT(n.errors, r);
		}
		else n.errors = t;
		return t;
	}, D = async (e, r, i = { valid: !0 }) => {
		for (let o in e) {
			let c = e[o];
			if (c) {
				let { _f: e, ...l } = c;
				if (e) {
					let l = s.array.has(e.name), d = c._f && jT(c._f);
					d && u.validatingFields && v([o], !0);
					let f = await WT(c, s.disabled, a, h, t.shouldUseNativeValidation && !r, l);
					if (d && u.validatingFields && v([o]), f[e.name] && (i.valid = !1, r)) break;
					!r && ($(f, e.name) ? l ? BT(n.errors, f, e.name) : Vw(n.errors, e.name, f[e.name]) : mT(n.errors, e.name));
				}
				!iT(l) && await D(l, r, i);
			}
		}
		return i.valid;
	}, O = () => {
		for (let e of s.unMount) {
			let t = $(r, e);
			t && (t._f.refs ? t._f.refs.every((e) => !dT(e)) : !dT(t._f.ref)) && z(e);
		}
		s.unMount = /* @__PURE__ */ new Set();
	}, k = (e, n) => !t.disabled && (e && n && Vw(a, e, n), !rT(L(), i)), A = (e, t, n) => Xw(e, s, { ...o.mount ? a : Lw(t) ? i : Yw(e) ? { [e]: t } : t }, n, t), j = (e) => Iw($(o.mount ? a : i, e, t.shouldUnregister ? $(i, e, []) : [])), M = (e, t, n = {}) => {
		let i = $(r, e), o = t;
		if (i) {
			let n = i._f;
			n && (!n.disabled && Vw(a, e, ST(t, n)), o = sT(n.ref) && Dw(t) ? "" : t, cT(n.ref) ? [...n.ref.options].forEach((e) => e.selected = o.includes(e.value)) : n.refs ? Tw(n.ref) ? n.refs.length > 1 ? n.refs.forEach((e) => (!e.defaultChecked || !e.disabled) && (e.checked = Array.isArray(o) ? !!o.find((t) => t === e.value) : o === e.value)) : n.refs[0] && (n.refs[0].checked = !!o) : n.refs.forEach((e) => e.checked = e.value === o) : aT(n.ref) ? n.ref.value = "" : (n.ref.value = o, n.ref.type || f.state.next({
				name: e,
				values: Fw(a)
			})));
		}
		(n.shouldDirty || n.shouldTouch) && C(e, o, n.shouldTouch, n.shouldDirty, !0), n.shouldValidate && ee(e);
	}, N = (e, t, n) => {
		for (let i in t) {
			let a = t[i], o = `${e}.${i}`, c = $(r, o);
			(s.array.has(e) || kw(a) || c && !c._f) && !Ew(a) ? N(o, a, n) : M(o, a, n);
		}
	}, P = (e, t, c = {}) => {
		let l = $(r, e), p = s.array.has(e), m = Fw(t);
		Vw(a, e, m), p ? (f.array.next({
			name: e,
			values: Fw(a)
		}), (u.isDirty || u.dirtyFields || d.isDirty || d.dirtyFields) && c.shouldDirty && f.state.next({
			name: e,
			dirtyFields: vT(i, a),
			isDirty: k(e, m)
		})) : l && !l._f && !Dw(m) ? N(e, m, c) : M(e, m, c), NT(e, s) && f.state.next({ ...n }), f.state.next({
			name: o.mount ? e : void 0,
			values: Fw(a)
		});
	}, F = async (e) => {
		o.mount = !0;
		let i = e.target, l = i.name, g = !0, y = $(r, l), b = (e) => {
			g = Number.isNaN(e) || Ew(e) && isNaN(e.getTime()) || rT(e, $(a, l, e));
		};
		if (y) {
			let o, x, S = i.type ? TT(y._f) : Aw(e), E = e.type === Hw.BLUR || e.type === Hw.FOCUS_OUT, O = !MT(y._f) && !t.resolver && !$(n.errors, l) && !y._f.deps || RT(E, $(n.touchedFields, l), n.isSubmitted, m, p), k = NT(l, s, E);
			Vw(a, l, S), E ? (y._f.onBlur && y._f.onBlur(e), c && c(0)) : y._f.onChange && y._f.onChange(e);
			let A = C(l, S, E), j = !iT(A) || k;
			if (!E && f.state.next({
				name: l,
				type: e.type,
				values: Fw(a)
			}), O) return (u.isValid || d.isValid) && (t.mode === "onBlur" ? E && _() : E || _()), j && f.state.next({
				name: l,
				...k ? {} : A
			});
			if (!E && k && f.state.next({ ...n }), t.resolver) {
				let { errors: e } = await T([l]);
				if (b(S), g) {
					let t = FT(n.errors, r, l), i = FT(e, r, t.name || l);
					o = i.error, l = i.name, x = iT(e);
				}
			} else v([l], !0), o = (await WT(y, s.disabled, a, h, t.shouldUseNativeValidation))[l], v([l]), b(S), g && (o ? x = !1 : (u.isValid || d.isValid) && (x = await D(r, !0)));
			g && (y._f.deps && ee(y._f.deps), w(l, x, o, A));
		}
	}, I = (e, t) => {
		if ($(n.errors, t) && e.focus) return e.focus(), 1;
	}, ee = async (e, i = {}) => {
		let a, o, c = eT(e);
		if (t.resolver) {
			let t = await E(Lw(e) ? e : c);
			a = iT(t), o = e ? !c.some((e) => $(t, e)) : a;
		} else e ? (o = (await Promise.all(c.map(async (e) => {
			let t = $(r, e);
			return await D(t && t._f ? { [e]: t } : t);
		}))).every(Boolean), !(!o && !n.isValid) && _()) : o = a = await D(r);
		return f.state.next({
			...!Yw(e) || (u.isValid || d.isValid) && a !== n.isValid ? {} : { name: e },
			...t.resolver || !e ? { isValid: a } : {},
			errors: n.errors
		}), i.shouldFocus && !o && PT(r, I, e ? c : s.mount), o;
	}, L = (e) => {
		let t = { ...o.mount ? a : i };
		return Lw(e) ? t : Yw(e) ? $(t, e) : e.map((e) => $(t, e));
	}, te = (e, t) => ({
		invalid: !!$((t || n).errors, e),
		isDirty: !!$((t || n).dirtyFields, e),
		error: $((t || n).errors, e),
		isValidating: !!$(n.validatingFields, e),
		isTouched: !!$((t || n).touchedFields, e)
	}), ne = (e) => {
		e && eT(e).forEach((e) => mT(n.errors, e)), f.state.next({ errors: e ? n.errors : {} });
	}, re = (e, t, i) => {
		let a = ($(r, e, { _f: {} })._f || {}).ref, { ref: o, message: s, type: c, ...l } = $(n.errors, e) || {};
		Vw(n.errors, e, {
			...l,
			...t,
			ref: a
		}), f.state.next({
			name: e,
			errors: n.errors,
			isValid: !1
		}), i && i.shouldFocus && a && a.focus && a.focus();
	}, R = (e, t) => oT(e) ? f.state.subscribe({ next: (n) => e(A(void 0, t), n) }) : A(e, t, !0), ie = (e) => f.state.subscribe({ next: (t) => {
		LT(e.name, t.name, e.exact) && IT(t, e.formState || u, he, e.reRenderRoot) && e.callback({
			values: { ...a },
			...n,
			...t
		});
	} }).unsubscribe, ae = (e) => (o.mount = !0, d = {
		...d,
		...e.formState
	}, ie({
		...e,
		formState: d
	})), z = (e, o = {}) => {
		for (let c of e ? eT(e) : s.mount) s.mount.delete(c), s.array.delete(c), o.keepValue || (mT(r, c), mT(a, c)), !o.keepError && mT(n.errors, c), !o.keepDirty && mT(n.dirtyFields, c), !o.keepTouched && mT(n.touchedFields, c), !o.keepIsValidating && mT(n.validatingFields, c), !t.shouldUnregister && !o.keepDefaultValue && mT(i, c);
		f.state.next({ values: Fw(a) }), f.state.next({
			...n,
			...o.keepDirty ? { isDirty: k() } : {}
		}), !o.keepIsValid && _();
	}, oe = ({ disabled: e, name: t }) => {
		(Rw(e) && o.mount || e || s.disabled.has(t)) && (e ? s.disabled.add(t) : s.disabled.delete(t));
	}, se = (e, n = {}) => {
		let a = $(r, e), c = Rw(n.disabled) || Rw(t.disabled);
		return Vw(r, e, {
			...a || {},
			_f: {
				...a && a._f ? a._f : { ref: { name: e } },
				name: e,
				mount: !0,
				...n
			}
		}), s.mount.add(e), a ? oe({
			disabled: Rw(n.disabled) ? n.disabled : t.disabled,
			name: e
		}) : S(e, !0, n.value), {
			...c ? { disabled: n.disabled || t.disabled } : {},
			...t.progressive ? {
				required: !!n.required,
				min: OT(n.min),
				max: OT(n.max),
				minLength: OT(n.minLength),
				maxLength: OT(n.maxLength),
				pattern: OT(n.pattern)
			} : {},
			name: e,
			onChange: F,
			onBlur: F,
			ref: (c) => {
				if (c) {
					se(e, n), a = $(r, e);
					let t = Lw(c.value) && c.querySelectorAll && c.querySelectorAll("input,select,textarea")[0] || c, o = uT(t), s = a._f.refs || [];
					if (o ? s.find((e) => e === t) : t === a._f.ref) return;
					Vw(r, e, { _f: {
						...a._f,
						...o ? {
							refs: [
								...s.filter(dT),
								t,
								...Array.isArray($(i, e)) ? [{}] : []
							],
							ref: {
								type: t.type,
								name: e
							}
						} : { ref: t }
					} }), S(e, !1, void 0, t);
				} else a = $(r, e, {}), a._f && (a._f.mount = !1), (t.shouldUnregister || n.shouldUnregister) && !(Mw(s.array, e) && o.action) && s.unMount.add(e);
			}
		};
	}, ce = () => t.shouldFocusError && PT(r, I, s.mount), le = (e) => {
		Rw(e) && (f.state.next({ disabled: e }), PT(r, (t, n) => {
			let i = $(r, n);
			i && (t.disabled = i._f.disabled || e, Array.isArray(i._f.refs) && i._f.refs.forEach((t) => {
				t.disabled = i._f.disabled || e;
			}));
		}, 0, !1));
	}, ue = (e, i) => async (o) => {
		let c;
		o && (o.preventDefault && o.preventDefault(), o.persist && o.persist());
		let l = Fw(a);
		if (f.state.next({ isSubmitting: !0 }), t.resolver) {
			let { errors: e, values: t } = await T();
			n.errors = e, l = t;
		} else await D(r);
		if (s.disabled.size) for (let e of s.disabled) Vw(l, e, void 0);
		if (mT(n.errors, "root"), iT(n.errors)) {
			f.state.next({ errors: {} });
			try {
				await e(l, o);
			} catch (e) {
				c = e;
			}
		} else i && await i({ ...n.errors }, o), ce(), setTimeout(ce);
		if (f.state.next({
			isSubmitted: !0,
			isSubmitting: !1,
			isSubmitSuccessful: iT(n.errors) && !c,
			submitCount: n.submitCount + 1,
			errors: n.errors
		}), c) throw c;
	}, de = (e, t = {}) => {
		$(r, e) && (Lw(t.defaultValue) ? P(e, Fw($(i, e))) : (P(e, t.defaultValue), Vw(i, e, Fw(t.defaultValue))), t.keepTouched || mT(n.touchedFields, e), t.keepDirty || (mT(n.dirtyFields, e), n.isDirty = t.defaultValue ? k(e, Fw($(i, e))) : k()), t.keepError || (mT(n.errors, e), u.isValid && _()), f.state.next({ ...n }));
	}, fe = (e, c = {}) => {
		let l = e ? Fw(e) : i, d = Fw(l), p = iT(e), m = p ? i : d;
		if (c.keepDefaultValues || (i = l), !c.keepValues) {
			if (c.keepDirtyValues) {
				let e = /* @__PURE__ */ new Set([...s.mount, ...Object.keys(vT(i, a))]);
				for (let t of Array.from(e)) $(n.dirtyFields, t) ? Vw(m, t, $(a, t)) : P(t, $(m, t));
			} else {
				if (Pw && Lw(e)) for (let e of s.mount) {
					let t = $(r, e);
					if (t && t._f) {
						let e = Array.isArray(t._f.refs) ? t._f.refs[0] : t._f.ref;
						if (sT(e)) {
							let t = e.closest("form");
							if (t) {
								t.reset();
								break;
							}
						}
					}
				}
				for (let e of s.mount) P(e, $(m, e));
			}
			a = Fw(m), f.array.next({ values: { ...m } }), f.state.next({ values: { ...m } });
		}
		s = {
			mount: c.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
			unMount: /* @__PURE__ */ new Set(),
			array: /* @__PURE__ */ new Set(),
			disabled: /* @__PURE__ */ new Set(),
			watch: /* @__PURE__ */ new Set(),
			watchAll: !1,
			focus: ""
		}, o.mount = !u.isValid || !!c.keepIsValid || !!c.keepDirtyValues, o.watch = !!t.shouldUnregister, f.state.next({
			submitCount: c.keepSubmitCount ? n.submitCount : 0,
			isDirty: p ? !1 : c.keepDirty ? n.isDirty : !!(c.keepDefaultValues && !rT(e, i)),
			isSubmitted: c.keepIsSubmitted ? n.isSubmitted : !1,
			dirtyFields: p ? {} : c.keepDirtyValues ? c.keepDefaultValues && a ? vT(i, a) : n.dirtyFields : c.keepDefaultValues && e ? vT(i, e) : c.keepDirty ? n.dirtyFields : {},
			touchedFields: c.keepTouched ? n.touchedFields : {},
			errors: c.keepErrors ? n.errors : {},
			isSubmitSuccessful: c.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
			isSubmitting: !1
		});
	}, pe = (e, t) => fe(oT(e) ? e(a) : e, t), me = (e, t = {}) => {
		let n = $(r, e), i = n && n._f;
		if (i) {
			let e = i.refs ? i.refs[0] : i.ref;
			e.focus && (e.focus(), t.shouldSelect && oT(e.select) && e.select());
		}
	}, he = (e) => {
		n = {
			...n,
			...e
		};
	}, ge = {
		control: {
			register: se,
			unregister: z,
			getFieldState: te,
			handleSubmit: ue,
			setError: re,
			_subscribe: ie,
			_runSchema: T,
			_getWatch: A,
			_getDirty: k,
			_setValid: _,
			_setFieldArray: y,
			_setDisabledField: oe,
			_setErrors: x,
			_getFieldArray: j,
			_reset: fe,
			_resetDefaultValues: () => oT(t.defaultValues) && t.defaultValues().then((e) => {
				pe(e, t.resetOptions), f.state.next({ isLoading: !1 });
			}),
			_removeUnmounted: O,
			_disableForm: le,
			_subjects: f,
			_proxyFormState: u,
			get _fields() {
				return r;
			},
			get _formValues() {
				return a;
			},
			get _state() {
				return o;
			},
			set _state(e) {
				o = e;
			},
			get _defaultValues() {
				return i;
			},
			get _names() {
				return s;
			},
			set _names(e) {
				s = e;
			},
			get _formState() {
				return n;
			},
			get _options() {
				return t;
			},
			set _options(e) {
				t = {
					...t,
					...e
				};
			}
		},
		subscribe: ae,
		trigger: ee,
		register: se,
		handleSubmit: ue,
		watch: R,
		setValue: P,
		getValues: L,
		reset: pe,
		resetField: de,
		clearErrors: ne,
		unregister: z,
		setError: re,
		setFocus: me,
		getFieldState: te
	};
	return {
		...ge,
		formControl: ge
	};
}
function qT(e = {}) {
	let t = H.useRef(void 0), n = H.useRef(void 0), [r, i] = H.useState({
		isDirty: !1,
		isValidating: !1,
		isLoading: oT(e.defaultValues),
		isSubmitted: !1,
		isSubmitting: !1,
		isSubmitSuccessful: !1,
		isValid: !1,
		submitCount: 0,
		dirtyFields: {},
		touchedFields: {},
		validatingFields: {},
		errors: e.errors || {},
		disabled: e.disabled || !1,
		defaultValues: oT(e.defaultValues) ? void 0 : e.defaultValues
	});
	t.current || (t.current = {
		...e.formControl ? e.formControl : KT(e),
		formState: r
	}, e.formControl && e.defaultValues && !oT(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
	let a = t.current.control;
	return a._options = e, H.useLayoutEffect(() => a._subscribe({
		formState: a._proxyFormState,
		callback: () => i({ ...a._formState }),
		reRenderRoot: !0
	}), [a]), H.useEffect(() => a._disableForm(e.disabled), [a, e.disabled]), H.useEffect(() => {
		if (a._proxyFormState.isDirty) {
			let e = a._getDirty();
			e !== r.isDirty && a._subjects.state.next({ isDirty: e });
		}
	}, [a, r.isDirty]), H.useEffect(() => {
		e.values && !rT(e.values, n.current) ? (a._reset(e.values, a._options.resetOptions), n.current = e.values, i((e) => ({ ...e }))) : a._resetDefaultValues();
	}, [e.values, a]), H.useEffect(() => {
		e.errors && !iT(e.errors) && a._setErrors(e.errors);
	}, [e.errors, a]), H.useEffect(() => {
		a._state.mount || (a._setValid(), a._state.mount = !0), a._state.watch && (a._state.watch = !1, a._subjects.state.next({ ...a._formState })), a._removeUnmounted();
	}), H.useEffect(() => {
		e.shouldUnregister && a._subjects.state.next({ values: a._getWatch() });
	}, [e.shouldUnregister, a]), t.current.formState = qw(r, a), t.current;
}
var JT = Sc;
function YT(e) {
	return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var XT = ww, ZT = [
	"control",
	"defaultValue",
	"name",
	"rules",
	"shouldUnregister"
];
function QT(e) {
	let t = XT(e, ZT);
	return {
		controller: Qw(t),
		controllerProps: t
	};
}
var $T = [
	"className",
	"description",
	"disabled",
	"helpIcon",
	"label",
	"noAlert",
	"noLabel",
	"style"
];
function eE(e) {
	let { controller: t, controllerProps: n } = QT(e);
	return {
		controller: t,
		controllerProps: n,
		fieldWrapperProps: {
			...XT(e, $T),
			required: YT(n.rules?.required),
			meta: {
				touched: t.fieldState.isTouched,
				error: t.fieldState.error?.message,
				success: e.meta?.success,
				warning: e.meta?.warning
			},
			labelFor: n.name,
			noLabel: e.noLabel,
			noAlert: e.noAlert
		}
	};
}
var tE = JT, nE = ({ transformValue: e = tE, label: t, helpIcon: n, className: r, ...i }) => {
	let { controller: { field: a }, controllerProps: { name: o } } = QT(i);
	return /* @__PURE__ */ q(_, {
		gap: "200",
		alignItems: "center",
		className: r,
		children: [/* @__PURE__ */ K(P, {
			...a,
			id: o,
			checked: e(a.value),
			disabled: i.componentProps?.disabled,
			onChange: (t) => {
				i.componentProps?.onChange?.(t), a.onChange(e(t.target.checked));
			}
		}), t && /* @__PURE__ */ K(f, {
			htmlFor: o,
			helpIcon: n,
			children: t
		})]
	});
}, rE = (e) => {
	let { controller: t, controllerProps: n, fieldWrapperProps: r } = eE(e);
	return /* @__PURE__ */ K(g, {
		...r,
		children: /* @__PURE__ */ K(w, {
			...e.componentProps,
			...t.field,
			value: e.componentProps?.type === "number" && isNaN(t.field.value) ? "" : t.field.value ?? "",
			onBlur: (n) => {
				e.componentProps?.onBlur?.(n), t.field.onBlur();
			},
			onChange: (n) => {
				e.componentProps?.onChange?.(n), t.field.onChange(e.componentProps?.type === "number" ? n.target.valueAsNumber : n);
			},
			id: n.name,
			"aria-disabled": r.disabled,
			disabled: r.disabled,
			"aria-required": r.required,
			required: r.required,
			status: g.getStatus(r.meta)
		})
	});
}, iE = [
	{
		key: "rivoLoyaltyApiKey",
		label: "API key",
		defaultValue: "",
		secret: !0,
		type: "string"
	},
	{
		key: ew,
		label: "Shopify API host name",
		defaultValue: "",
		secret: !1,
		type: "string"
	},
	{
		key: "rivoLoyaltyShowOrders",
		label: "Show orders overview",
		defaultValue: !0,
		secret: !1,
		type: "boolean"
	},
	{
		key: "rivoLoyaltyShowLoyalty",
		label: "Show loyalty",
		defaultValue: !0,
		secret: !1,
		type: "boolean"
	},
	{
		key: "rivoLoyaltyAdjustLoyaltyPoints",
		label: "Allow adjusting loyalty points",
		defaultValue: !0,
		secret: !1,
		type: "boolean"
	},
	{
		key: "rivoLoyaltyShowFavoriteProducts",
		label: "Show favorite products",
		defaultValue: !0,
		secret: !1,
		type: "boolean"
	},
	{
		key: "rivoLoyaltyShowPointsRedemptions",
		label: "Show available rewards",
		defaultValue: !0,
		secret: !1,
		type: "boolean"
	}
], aE = Pe(iE), oE = "RIVOLOYALTY", sE = "Rivo Loyalty", cE = {
	enabled: !1,
	name: "",
	rivoLoyaltyApiKey: "",
	[ew]: "",
	rivoLoyaltyShowOrders: !0,
	rivoLoyaltyShowLoyalty: !0,
	rivoLoyaltyAdjustLoyaltyPoints: !0,
	rivoLoyaltyShowFavoriteProducts: !0,
	rivoLoyaltyShowPointsRedemptions: !0
}, lE = ({ integrationId: e, handleRedirect: t, showNotification: n, automationCouplingState: r, renderConditionsEditor: i }) => {
	let a = !e, o = qT({
		mode: "onChange",
		defaultValues: cE
	}), { create: s, update: c, remove: l, isLoading: u, error: d, misconfigurationCause: f, setMisconfigurationCause: p } = Ve({
		integrationId: e,
		integrationType: oE,
		handleRedirect: t,
		showNotification: n
	}), { isLoading: m, error: h, isWidgetUnknown: x, refetch: S, widgetConfiguration: C } = He({
		integrationId: e,
		fieldDefinitions: iE,
		form: o,
		onMisconfigured: p
	}), { renderConditions: w, setRenderConditions: T, renderConditionsForSubmit: E } = Be({
		integrationId: e,
		widgetConfiguration: C,
		renderConditionsEditor: i
	}), D = (e) => ye(e, {
		fieldDefinitions: iE,
		isCreationMode: a,
		create: s,
		update: c,
		renderConditions: E
	}), O = o.watch("name");
	return /* @__PURE__ */ q(de, {
		form: o,
		integrationId: e,
		onValidSubmit: D,
		error: h ?? d,
		onRetry: h ? S : void 0,
		isLoading: u || m,
		isWidgetUnknown: x,
		children: [
			f && /* @__PURE__ */ K(se, { cause: f }),
			/* @__PURE__ */ q(y, { children: [
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ K(nE, {
						name: "enabled",
						control: o.control
					})
				}) }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(rE, {
						name: "name",
						label: "Widget name",
						control: o.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(rE, {
						name: "rivoLoyaltyShopifyApiHostName",
						label: aE[ew],
						control: o.control,
						rules: {
							required: "Shopify API host name is required",
							validate: (e) => Ue(e) ?? void 0
						},
						componentProps: {
							placeholder: "Host name of your Shopify shop, e.g. \"my-webshop.myshopify.com\"",
							prefix: "https://"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(ue, {
						name: "rivoLoyaltyApiKey",
						label: aE.rivoLoyaltyApiKey,
						control: o.control,
						isCreationMode: a,
						rules: { required: "API key is required" },
						componentProps: {
							placeholder: "Insert your Rivo API key",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: aE.rivoLoyaltyShowOrders,
						children: /* @__PURE__ */ K(nE, {
							name: "rivoLoyaltyShowOrders",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: aE.rivoLoyaltyShowLoyalty,
						children: /* @__PURE__ */ K(nE, {
							name: "rivoLoyaltyShowLoyalty",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: aE.rivoLoyaltyAdjustLoyaltyPoints,
						children: /* @__PURE__ */ K(nE, {
							name: "rivoLoyaltyAdjustLoyaltyPoints",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: aE.rivoLoyaltyShowFavoriteProducts,
						children: /* @__PURE__ */ K(nE, {
							name: "rivoLoyaltyShowFavoriteProducts",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: aE.rivoLoyaltyShowPointsRedemptions,
						children: /* @__PURE__ */ K(nE, {
							name: "rivoLoyaltyShowPointsRedemptions",
							control: o.control
						})
					})
				}),
				i && w !== null && /* @__PURE__ */ K(v, { children: i({
					value: w,
					onChange: T,
					configurationKey: C?.id
				}) })
			] }),
			/* @__PURE__ */ K(pe, {
				integrationType: oE,
				integrationId: e,
				widgetName: O,
				isCreationMode: a,
				isSubmitting: o.formState.isSubmitting,
				automationCouplingState: r,
				onConfirmDelete: () => l(),
				confirmDeleteVariant: "danger",
				deleteConfirmationBody: /* @__PURE__ */ q(_, {
					gap: "400",
					children: [/* @__PURE__ */ K(b, {
						size: 24,
						name: "exclamation-triangle-filled",
						color: "red.500"
					}), /* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "column",
						children: [
							/* @__PURE__ */ q(L.Heading, {
								withMarginBottom: !0,
								children: [
									"By deleting the ",
									sE,
									" integration, all links between Dixa and ",
									sE,
									" are also deleted."
								]
							}),
							/* @__PURE__ */ q(L.Paragraph, { children: [
								"All data in ",
								sE,
								" stays untouched."
							] }),
							/* @__PURE__ */ q(L.Paragraph, { children: [
								"Are you sure you want to delete the ",
								sE,
								" ",
								"integration \"",
								O,
								"\"?"
							] })
						]
					})]
				})
			})
		]
	});
};
//#endregion
//#region ../widget-shopify/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_1mprq_1{width:900px}._modal_al73g_1{width:600px}._editIcon_1yp2k_1,._copyIcon_1yp2k_2,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._copyIcon_u5m0p_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._strikethrough_u5m0p_6{text-decoration:line-through}._order_u5m0p_10{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_u5m0p_10:hover,._orderIsOpen_u5m0p_18{border-color:var(--dixa-color-neutral-400)}._orderHeader_u5m0p_21{cursor:pointer}._segmentName_1dkhk_1{white-space:nowrap;overflow:hidden}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var uE = "__PairingContext__", dE = globalThis[uE] ?? (() => {
	let e = Ge({});
	return globalThis[uE] = e, e;
})(), fE = () => Ye(dE), pE = {
	banner: "_banner_d9pot_1",
	list: "_list_d9pot_8"
}, mE = "https://apps.shopify.com/dixa-dashboard", hE = {
	install: {
		description: "Connect your Shopify store to Dixa with just a few clicks.",
		listHeading: "How it works:",
		listType: "ol",
		listItems: [
			"Click \"Install Dixa app in Shopify\" below to start the connection",
			"You'll be redirected to the Shopify App Store to install the Dixa app",
			"After installing, the connection is set up automatically",
			"Return to the Settings > Integrations overview to see your newly connected Shopify integration"
		],
		buttonText: "Install Dixa app in Shopify",
		buttonVariant: "primary"
	},
	migration: {
		description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
		listHeading: "Benefits of upgrading:",
		listType: "ul",
		listItems: [
			"No need to manage Client ID and Client Secret",
			"Automatic token refresh handled by the app",
			"Easier setup for new stores"
		],
		buttonText: "Upgrade via Shopify App Store",
		buttonVariant: "primary"
	}
}, gE = ({ label: e, bannerVariant: t = "install" }) => {
	let { initiateFromDixa: n } = fE(), [r, i] = W(!1), [o, s] = W(null), c = hE[t], l = async () => {
		if (t === "install" && n) {
			i(!0), s(null);
			try {
				let e = await n();
				window.open(e ?? "https://apps.shopify.com/dixa-dashboard", "_blank", "noopener,noreferrer");
			} catch {
				s("Failed to start the connection. Please try again.");
			} finally {
				i(!1);
			}
			return;
		}
		window.open(mE, "_blank", "noopener,noreferrer");
	}, u = c.listType === "ol" ? "ol" : "ul";
	return /* @__PURE__ */ K(v, { children: /* @__PURE__ */ q(_, {
		gap: "300",
		flexDirection: "column",
		className: pE.banner,
		children: [
			/* @__PURE__ */ K(L.Heading, {
				variant: "heading-2",
				children: e
			}),
			/* @__PURE__ */ q(_, {
				alignItems: "center",
				gap: "200",
				children: [/* @__PURE__ */ K(_, { children: /* @__PURE__ */ K(b, {
					size: 30,
					name: "shopify",
					color: "green.500"
				}) }), /* @__PURE__ */ K(L.Paragraph, { children: c.description })]
			}),
			/* @__PURE__ */ q(_, {
				gap: "200",
				flexDirection: "column",
				children: [/* @__PURE__ */ K(L.Heading, {
					variant: "heading-3",
					children: c.listHeading
				}), /* @__PURE__ */ K(L.Paragraph, {
					as: "div",
					children: /* @__PURE__ */ K(u, {
						className: pE.list,
						children: c.listItems.map((e, t) => /* @__PURE__ */ K("li", { children: e }, t))
					})
				})]
			}),
			o && /* @__PURE__ */ K(L.Paragraph, {
				color: "danger",
				children: o
			}),
			/* @__PURE__ */ K(_, {
				margin: "200 0 0 0",
				children: /* @__PURE__ */ K(a, {
					onClick: l,
					icon: "external-link",
					variant: c.buttonVariant,
					disabled: r,
					children: r ? /* @__PURE__ */ q(_, {
						alignItems: "center",
						gap: "200",
						children: [/* @__PURE__ */ K(N, { size: 16 }), "Connecting…"]
					}) : c.buttonText
				})
			})
		]
	}) });
}, _E = [
	{
		key: "apiHostName",
		label: "API host name",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "displayRefundOrder",
		label: "Display the refund order button",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "displayPartialRefundOrder",
		label: "Displays the partial refund order button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayCancelOrder",
		label: "Displays the cancel order button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "enableEditShippingAddress",
		label: "Enable the \"edit shipping address\" button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayOrdersOverview",
		label: "Displays short orders overview",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayEmailMarketingConsent",
		label: "Displays the email and phone marketing consent status of the customer",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displaySegmentMembership",
		label: "Displays the segment memberships of the customer",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayDiscountCodes",
		label: "Displays available discount codes",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayDiscountCodeCreation",
		label: "Displays the discount code creation button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayCreateOrder",
		label: "Displays the create order button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayCreateDraftOrder",
		label: "Displays the create draft order button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayDuplicateOrder",
		label: "Displays the duplicate order button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "apiAccessToken",
		label: "API Access Token",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "shopifyClientId",
		label: "Client ID",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "shopifyClientSecret",
		label: "Client Secret",
		type: "string",
		secret: !0,
		defaultValue: ""
	}
], vE = "SHOPIFY", yE = Pe(_E), bE = [
	"displayRefundOrder",
	"displayPartialRefundOrder",
	"displayCancelOrder",
	"enableEditShippingAddress",
	"displayOrdersOverview",
	"displayEmailMarketingConsent",
	"displaySegmentMembership",
	"displayDiscountCodes",
	"displayDiscountCodeCreation",
	"displayCreateOrder",
	"displayCreateDraftOrder",
	"displayDuplicateOrder"
], xE = {
	enabled: !1,
	name: "",
	...Le([], _E)
}, SE = ({ integrationId: e, handleRedirect: t, showNotification: n, automationCouplingState: r, renderConditionsEditor: i }) => {
	let a = !e, o = xc({
		mode: "onChange",
		defaultValues: xE
	}), { create: s, update: c, remove: l, isLoading: u, error: d, misconfigurationCause: f, setMisconfigurationCause: p } = Ve({
		integrationId: e,
		integrationType: vE,
		handleRedirect: t,
		showNotification: n
	}), { isLoading: m, error: h, isWidgetUnknown: _, refetch: b, widgetConfiguration: x } = He({
		integrationId: e,
		fieldDefinitions: _E,
		form: o,
		onMisconfigured: p
	}), { renderConditions: S, setRenderConditions: C, renderConditionsForSubmit: w } = Be({
		integrationId: e,
		widgetConfiguration: x,
		renderConditionsEditor: i
	}), T = x?.additionalProperties, E = T?.tokenSource === "marketplace_app", D = !!T?.isUsingOAuth, O = !E, k = (e) => ye(e, {
		fieldDefinitions: _E,
		isCreationMode: a,
		create: s,
		update: c,
		renderConditions: w
	}), A = o.watch("name");
	return /* @__PURE__ */ K(de, {
		form: o,
		integrationId: e,
		onValidSubmit: k,
		error: h ?? d,
		onRetry: h ? b : void 0,
		isLoading: u || m,
		isWidgetUnknown: _,
		children: a ? /* @__PURE__ */ K(y, { children: /* @__PURE__ */ K(gE, {
			label: "Connect your Shopify store",
			bannerVariant: "install"
		}) }) : /* @__PURE__ */ q(G, { children: [
			f && /* @__PURE__ */ K(se, { cause: f }),
			/* @__PURE__ */ q(y, { children: [
				O && /* @__PURE__ */ K(gE, {
					label: "Upgrade to simplified connection",
					bannerVariant: "migration"
				}),
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ K(Z, {
						name: "enabled",
						control: o.control
					})
				}) }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "name",
						label: "Widget name",
						control: o.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				O && D && /* @__PURE__ */ q(G, { children: [
					/* @__PURE__ */ K(v, {
						span: 3,
						children: /* @__PURE__ */ K(ue, {
							name: "shopifyClientId",
							label: yE.shopifyClientId,
							control: o.control,
							isCreationMode: a,
							rules: { required: "Client ID is required" },
							componentProps: {
								placeholder: "Client ID from Shopify",
								autoComplete: "off"
							}
						})
					}),
					/* @__PURE__ */ K(v, { span: 3 }),
					/* @__PURE__ */ K(v, {
						span: 3,
						children: /* @__PURE__ */ K(ue, {
							name: "shopifyClientSecret",
							label: yE.shopifyClientSecret,
							control: o.control,
							isCreationMode: a,
							rules: { required: "Client Secret is required" },
							componentProps: {
								placeholder: "Client Secret from Shopify",
								autoComplete: "off"
							}
						})
					}),
					/* @__PURE__ */ K(v, { span: 3 })
				] }),
				O && !D && /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(ue, {
						name: "apiAccessToken",
						label: yE.apiAccessToken,
						control: o.control,
						isCreationMode: a,
						rules: { required: "API access token is required" },
						componentProps: {
							placeholder: "API access token from Shopify",
							autoComplete: "off"
						}
					})
				}), /* @__PURE__ */ K(v, { span: 3 })] }),
				E ? /* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "apiHostName",
						label: "Connected Shopify store",
						control: o.control,
						componentProps: {
							readOnly: !0,
							autoComplete: "off",
							prefix: "https://"
						}
					})
				}) : /* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "apiHostName",
						label: "API host name",
						control: o.control,
						rules: {
							required: "API host name is required",
							validate: (e) => Ue(e) || !0
						},
						componentProps: {
							placeholder: "Host name of your shop, e.g. \"my-webshop.myshopify.com\"",
							autoComplete: "off",
							prefix: "https://"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				bE.map((e) => /* @__PURE__ */ q(We, { children: [/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: yE[e],
						children: /* @__PURE__ */ K(Z, {
							name: e,
							control: o.control
						})
					})
				}), /* @__PURE__ */ K(v, { span: 3 })] }, e)),
				i && S !== null && /* @__PURE__ */ K(v, { children: i({
					value: S,
					onChange: C,
					configurationKey: x?.id
				}) })
			] }),
			/* @__PURE__ */ K(pe, {
				integrationType: vE,
				integrationId: e,
				widgetName: A,
				isCreationMode: a,
				isSubmitting: o.formState.isSubmitting,
				automationCouplingState: r,
				onConfirmDelete: () => l()
			})
		] })
	});
}, CE = (e) => /* @__PURE__ */ K(gE, {
	...e,
	bannerVariant: "install"
}), wE = (e) => /* @__PURE__ */ K(gE, {
	...e,
	bannerVariant: "migration"
}), TE = [{
	key: "shopifyClientId",
	label: "Client ID",
	placeholder: "Client ID from Shopify",
	required: !0,
	secret: !0,
	type: "input"
}, {
	key: "shopifyClientSecret",
	label: "Client Secret",
	placeholder: "Client Secret from Shopify",
	required: !0,
	secret: !0,
	type: "input"
}], EE = [{
	key: "apiAccessToken",
	label: "API Access Token",
	placeholder: "API access token from Shopify",
	required: !0,
	secret: !0,
	type: "input"
}], DE = [{
	key: "marketplaceInstallBanner",
	label: "Connect your Shopify store",
	secret: !1,
	type: "custom",
	component: CE
}], OE = [{
	key: "apiHostName",
	label: "Connected Shopify store",
	placeholder: "",
	required: !1,
	secret: !1,
	type: "input",
	prefix: "https://",
	readOnly: !0
}], kE = [{
	key: "migrationBanner",
	label: "Upgrade to simplified connection",
	secret: !1,
	type: "custom",
	component: wE,
	additionalProperties: { renderAboveForm: !0 }
}], AE = [
	{
		key: "displayRefundOrder",
		label: "Display the refund order button",
		secret: !1,
		type: "switch",
		defaultValue: !1
	},
	{
		key: "displayPartialRefundOrder",
		label: "Displays the partial refund order button",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displayCancelOrder",
		label: "Displays the cancel order button",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "enableEditShippingAddress",
		label: "Enable the \"edit shipping address\" button",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displayOrdersOverview",
		label: "Displays short orders overview",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displayEmailMarketingConsent",
		label: "Displays the email and phone marketing consent status of the customer",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displaySegmentMembership",
		label: "Displays the segment memberships of the customer",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displayDiscountCodes",
		label: "Displays available discount codes",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displayDiscountCodeCreation",
		label: "Displays the discount code creation button",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displayCreateOrder",
		label: "Displays the create order button",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displayCreateDraftOrder",
		label: "Displays the create draft order button",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displayDuplicateOrder",
		label: "Displays the duplicate order button",
		secret: !1,
		type: "switch",
		defaultValue: !0
	}
], jE = [{
	key: "apiHostName",
	label: "API host name",
	placeholder: "Host name of your shop, e.g. \"my-webshop.myshopify.com\"",
	required: !0,
	secret: !1,
	type: "input",
	prefix: "https://",
	customValidation: (e) => Ue(e)
}, ...AE], ME = /* @__PURE__ */ function(e) {
	return e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e;
}({}), NE = /* @__PURE__ */ function(e) {
	return e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e;
}({}), PE = /* @__PURE__ */ function(e) {
	return e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e;
}({}), FE = /* @__PURE__ */ function(e) {
	return e.All = "ALL", e;
}({}), IE = /* @__PURE__ */ function(e) {
	return e.Active = "ACTIVE", e.Expired = "EXPIRED", e.Scheduled = "SCHEDULED", e;
}({}), LE = /* @__PURE__ */ function(e) {
	return e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e;
}({}), RE = /* @__PURE__ */ function(e) {
	return e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e;
}({}), zE = /* @__PURE__ */ function(e) {
	return e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e;
}({}), BE = /* @__PURE__ */ function(e) {
	return e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e;
}({}), VE = /* @__PURE__ */ function(e) {
	return e.Cancel = "CANCEL", e.LegacyRestock = "LEGACY_RESTOCK", e.NoRestock = "NO_RESTOCK", e.Return = "RETURN", e;
}({}), HE = {
	"\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "refundCreate"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_RefundInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "refundCreate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "orderUpdate"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_OrderInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "orderUpdate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "order"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "shippingAddress"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "firstName"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "lastName"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "company"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "address1"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "address2"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "city"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "countryCodeV2"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "provinceCode"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "zip"
														}
													}
												]
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "orderCancel"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "notifyCustomer"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Boolean"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "orderId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "ID"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "reason"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Shopify_OrderCancelReason"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "refundMethod"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Shopify_OrderCancelRefundMethodInput"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "restock"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Boolean"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "staffNote"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "orderCancel"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "notifyCustomer"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "notifyCustomer"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "orderId"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "orderId"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "reason"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "reason"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "refundMethod"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "refundMethod"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "restock"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "restock"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "staffNote"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "staffNote"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "job"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "done"
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "orderCancelUserErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "code"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "field"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "message"
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "createCustomer"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_CustomerInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "customerCreate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "customer"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "defaultEmailAddress"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "emailAddress"
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "defaultPhoneNumber"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "phoneNumber"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "marketingState"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "marketingOptInLevel"
															}
														}
													]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "taxExempt"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "firstName"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "lastName"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "amountSpent"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "amount"
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "currencyCode"
														}
													}]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "createOrder"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "order"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_OrderCreateOrderInput"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "options"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Shopify_OrderCreateOptionsInput"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "orderCreate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "order"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "order"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "options"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "options"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "order"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "name"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "createdAt"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "displayFulfillmentStatus"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "displayFinancialStatus"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "totalPriceSet"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "presentmentMoney"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "shopMoney"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}]
												}
											}
										]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "createDraftOrder"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_DraftOrderInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "draftOrderCreate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "draftOrder"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "name"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "createdAt"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "tags"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "status"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "totalPriceSet"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "presentmentMoney"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "shopMoney"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}]
												}
											}
										]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "createDiscountCode"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_DiscountCodeBasicInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "discountCodeBasicCreate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "basicCodeDiscount"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "codeDiscountNode"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "codeDiscount"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "InlineFragment",
													typeCondition: {
														kind: "NamedType",
														name: {
															kind: "Name",
															value: "Shopify_DiscountCodeBasic"
														}
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "codes"
																},
																arguments: [{
																	kind: "Argument",
																	name: {
																		kind: "Name",
																		value: "first"
																	},
																	value: {
																		kind: "IntValue",
																		value: "1"
																	}
																}],
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "nodes"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "code"
																				}
																			}]
																		}
																	}]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "title"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "status"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "startsAt"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "endsAt"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "usageLimit"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "appliesOncePerCustomer"
																}
															}
														]
													}
												}]
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation orderMarkAsPaid($input: Shopify_OrderMarkAsPaidInput!) {\n    Shopify {\n      orderMarkAsPaid(input: $input) {\n        order {\n          id\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "orderMarkAsPaid"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_OrderMarkAsPaidInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "orderMarkAsPaid"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "order"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation refundLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "refundLineItems"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_RefundInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "refundCreate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "refund"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "totalRefundedSet"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "presentmentMoney"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "amount"
															}
														}, {
															kind: "Field",
															name: {
																kind: "Name",
																value: "currencyCode"
															}
														}]
													}
												}]
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "updateOrder"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_OrderInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "orderUpdate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "order"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "tags"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "segments"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "first"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "segments"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "first"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "first"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "edges"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "node"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "id"
													}
												}, {
													kind: "Field",
													name: {
														kind: "Name",
														value: "name"
													}
												}]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "customerSegmentMembership"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "customerId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "ID"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "segmentIds"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "ListType",
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "ID"
								}
							}
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "customerSegmentMembership"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "customerId"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "customerId"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "segmentIds"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "segmentIds"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "memberships"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "segmentId"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "isMember"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      currentAppInstallation {\n        accessScopes {\n          handle\n        }\n      }\n\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "shopifyCustomerData"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "query"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "currentAppInstallation"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "accessScopes"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "handle"
												}
											}]
										}
									}]
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "shop"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "countriesInShippingZones"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "countryCodes"
												}
											}]
										}
									}]
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "customers"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "first"
									},
									value: {
										kind: "IntValue",
										value: "1"
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "query"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "query"
										}
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "edges"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "node"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "displayName"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "firstName"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "lastName"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "defaultEmailAddress"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "emailAddress"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "marketingOptInLevel"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "marketingState"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "marketingUpdatedAt"
																		}
																	}
																]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "defaultPhoneNumber"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "phoneNumber"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "marketingOptInLevel"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "marketingState"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "marketingUpdatedAt"
																		}
																	}
																]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "numberOfOrders"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "tags"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "verifiedEmail"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "amountSpent"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "amount"
																	}
																}, {
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "currencyCode"
																	}
																}]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "defaultAddress"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "firstName"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "lastName"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "address1"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "address2"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "city"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "country"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "zip"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "phone"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "provinceCode"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "countryCodeV2"
																		}
																	}
																]
															}
														}
													]
												}
											}]
										}
									}]
								}
							}
						]
					}
				}]
			}
		}]
	},
	"\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            discountCodes\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true, refundShipping: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              subtotalSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              totalTaxSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              shipping {\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n                maximumRefundableSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n            currentTotalDiscountsSet {\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "shopifyCustomerOrders"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "query"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "orders"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "first"
									},
									value: {
										kind: "IntValue",
										value: "5"
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "query"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "query"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "sortKey"
									},
									value: {
										kind: "EnumValue",
										value: "CREATED_AT"
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "reverse"
									},
									value: {
										kind: "BooleanValue",
										value: !0
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "edges"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "node"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "createdAt"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "displayFulfillmentStatus"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "displayFinancialStatus"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "cancelledAt"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "tags"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "discountCodes"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "netPaymentSet"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "presentmentMoney"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "amount"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "currencyCode"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "totalRefundedSet"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "presentmentMoney"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "amount"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "currencyCode"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "billingAddress"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "firstName"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "lastName"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "company"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "address1"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "address2"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "city"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "country"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "countryCodeV2"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "province"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "provinceCode"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "zip"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "phone"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "shippingAddress"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "firstName"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "lastName"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "company"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "address1"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "address2"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "city"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "country"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "countryCodeV2"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "province"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "provinceCode"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "zip"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "phone"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "suggestedRefund"
														},
														arguments: [{
															kind: "Argument",
															name: {
																kind: "Name",
																value: "suggestFullRefund"
															},
															value: {
																kind: "BooleanValue",
																value: !0
															}
														}, {
															kind: "Argument",
															name: {
																kind: "Name",
																value: "refundShipping"
															},
															value: {
																kind: "BooleanValue",
																value: !0
															}
														}],
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "amountSet"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "presentmentMoney"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "amount"
																					}
																				}, {
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "currencyCode"
																					}
																				}]
																			}
																		}]
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "subtotalSet"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "presentmentMoney"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "amount"
																					}
																				}, {
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "currencyCode"
																					}
																				}]
																			}
																		}]
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "totalTaxSet"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "presentmentMoney"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "amount"
																					}
																				}, {
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "currencyCode"
																					}
																				}]
																			}
																		}]
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "shipping"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "amountSet"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "presentmentMoney"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "amount"
																							}
																						}, {
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "currencyCode"
																							}
																						}]
																					}
																				}]
																			}
																		}, {
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "maximumRefundableSet"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "presentmentMoney"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "amount"
																							}
																						}, {
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "currencyCode"
																							}
																						}]
																					}
																				}]
																			}
																		}]
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "suggestedTransactions"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "accountNumber"
																				}
																			},
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "gateway"
																				}
																			},
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "kind"
																				}
																			},
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "parentTransaction"
																				},
																				selectionSet: {
																					kind: "SelectionSet",
																					selections: [{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "id"
																						}
																					}]
																				}
																			},
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "amountSet"
																				},
																				selectionSet: {
																					kind: "SelectionSet",
																					selections: [{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "presentmentMoney"
																						},
																						selectionSet: {
																							kind: "SelectionSet",
																							selections: [{
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "amount"
																								}
																							}, {
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "currencyCode"
																								}
																							}]
																						}
																					}]
																				}
																			}
																		]
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "refundLineItems"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "lineItem"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "id"
																					}
																				}, {
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "quantity"
																					}
																				}]
																			}
																		}]
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "shippingLines"
														},
														arguments: [{
															kind: "Argument",
															name: {
																kind: "Name",
																value: "first"
															},
															value: {
																kind: "IntValue",
																value: "5"
															}
														}],
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "edges"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "node"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "title"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "code"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "source"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "discountedPriceSet"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "shopMoney"
																							},
																							selectionSet: {
																								kind: "SelectionSet",
																								selections: [{
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "amount"
																									}
																								}, {
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "currencyCode"
																									}
																								}]
																							}
																						}]
																					}
																				}
																			]
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "fulfillments"
														},
														arguments: [{
															kind: "Argument",
															name: {
																kind: "Name",
																value: "first"
															},
															value: {
																kind: "IntValue",
																value: "2"
															}
														}],
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "trackingInfo"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "company"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "number"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "url"
																			}
																		}
																	]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "lineItems"
														},
														arguments: [{
															kind: "Argument",
															name: {
																kind: "Name",
																value: "first"
															},
															value: {
																kind: "IntValue",
																value: "15"
															}
														}],
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "edges"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "node"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "id"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "title"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "quantity"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "variantTitle"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "sku"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "image"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "url"
																							}
																						}]
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "product"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "id"
																							}
																						}]
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "discountedUnitPriceSet"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "shopMoney"
																							},
																							selectionSet: {
																								kind: "SelectionSet",
																								selections: [{
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "amount"
																									}
																								}, {
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "currencyCode"
																									}
																								}]
																							}
																						}]
																					}
																				}
																			]
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "refunds"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "totalRefunded"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "amount"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "currencyCode"
																		}
																	}]
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "refundLineItems"
																},
																arguments: [{
																	kind: "Argument",
																	name: {
																		kind: "Name",
																		value: "first"
																	},
																	value: {
																		kind: "IntValue",
																		value: "250"
																	}
																}],
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "edges"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "node"
																				},
																				selectionSet: {
																					kind: "SelectionSet",
																					selections: [
																						{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "id"
																							}
																						},
																						{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "quantity"
																							}
																						},
																						{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "lineItem"
																							},
																							selectionSet: {
																								kind: "SelectionSet",
																								selections: [{
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "id"
																									}
																								}, {
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "title"
																									}
																								}]
																							}
																						}
																					]
																				}
																			}]
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "currentTotalPriceSet"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "presentmentMoney"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "amount"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "currencyCode"
																		}
																	}]
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "shopMoney"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "amount"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "currencyCode"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "currentTotalDiscountsSet"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "shopMoney"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "amount"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "currencyCode"
																		}
																	}]
																}
															}]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query searchDiscountCodes($query: String, $first: Int, $after: String) {\n    Shopify {\n      discountNodes(query: $query, first: $first, after: $after) {\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n        nodes {\n          id\n          discount {\n            __typename\n\n            ... on Shopify_DiscountCodeApp {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n              customerGets {\n                value {\n                  __typename\n\n                  ... on Shopify_DiscountPercentage {\n                    percentage\n                  }\n\n                  ... on Shopify_DiscountAmount {\n                    amount {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "searchDiscountCodes"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "query"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "first"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "after"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "discountNodes"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "query"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "query"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "first"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "first"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "after"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "after"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "pageInfo"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "hasNextPage"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "endCursor"
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "nodes"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "discount"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "__typename"
														}
													},
													{
														kind: "InlineFragment",
														typeCondition: {
															kind: "NamedType",
															name: {
																kind: "Name",
																value: "Shopify_DiscountCodeApp"
															}
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "status"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "codes"
																	},
																	arguments: [{
																		kind: "Argument",
																		name: {
																			kind: "Name",
																			value: "first"
																		},
																		value: {
																			kind: "IntValue",
																			value: "100"
																		}
																	}],
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "nodes"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "code"
																					}
																				}]
																			}
																		}]
																	}
																}
															]
														}
													},
													{
														kind: "InlineFragment",
														typeCondition: {
															kind: "NamedType",
															name: {
																kind: "Name",
																value: "Shopify_DiscountCodeBasic"
															}
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "status"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "codes"
																	},
																	arguments: [{
																		kind: "Argument",
																		name: {
																			kind: "Name",
																			value: "first"
																		},
																		value: {
																			kind: "IntValue",
																			value: "100"
																		}
																	}],
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "nodes"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "code"
																					}
																				}]
																			}
																		}]
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "customerGets"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "value"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "__typename"
																						}
																					},
																					{
																						kind: "InlineFragment",
																						typeCondition: {
																							kind: "NamedType",
																							name: {
																								kind: "Name",
																								value: "Shopify_DiscountPercentage"
																							}
																						},
																						selectionSet: {
																							kind: "SelectionSet",
																							selections: [{
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "percentage"
																								}
																							}]
																						}
																					},
																					{
																						kind: "InlineFragment",
																						typeCondition: {
																							kind: "NamedType",
																							name: {
																								kind: "Name",
																								value: "Shopify_DiscountAmount"
																							}
																						},
																						selectionSet: {
																							kind: "SelectionSet",
																							selections: [{
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "amount"
																								},
																								selectionSet: {
																									kind: "SelectionSet",
																									selections: [{
																										kind: "Field",
																										name: {
																											kind: "Name",
																											value: "amount"
																										}
																									}, {
																										kind: "Field",
																										name: {
																											kind: "Name",
																											value: "currencyCode"
																										}
																									}]
																								}
																							}]
																						}
																					}
																				]
																			}
																		}]
																	}
																}
															]
														}
													},
													{
														kind: "InlineFragment",
														typeCondition: {
															kind: "NamedType",
															name: {
																kind: "Name",
																value: "Shopify_DiscountCodeBxgy"
															}
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "status"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "codes"
																	},
																	arguments: [{
																		kind: "Argument",
																		name: {
																			kind: "Name",
																			value: "first"
																		},
																		value: {
																			kind: "IntValue",
																			value: "100"
																		}
																	}],
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "nodes"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "code"
																					}
																				}]
																			}
																		}]
																	}
																}
															]
														}
													},
													{
														kind: "InlineFragment",
														typeCondition: {
															kind: "NamedType",
															name: {
																kind: "Name",
																value: "Shopify_DiscountCodeFreeShipping"
															}
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "status"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "codes"
																	},
																	arguments: [{
																		kind: "Argument",
																		name: {
																			kind: "Name",
																			value: "first"
																		},
																		value: {
																			kind: "IntValue",
																			value: "100"
																		}
																	}],
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "nodes"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "code"
																					}
																				}]
																			}
																		}]
																	}
																}
															]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "searchProducts"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "query"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "productCount"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "mediaCount"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "products"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "first"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "productCount"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "query"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "query"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "nodes"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "title"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "description"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "onlineStoreUrl"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "status"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "tags"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "title"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "totalInventory"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "priceRangeV2"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "maxVariantPrice"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "minVariantPrice"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "media"
												},
												arguments: [{
													kind: "Argument",
													name: {
														kind: "Name",
														value: "first"
													},
													value: {
														kind: "Variable",
														name: {
															kind: "Name",
															value: "mediaCount"
														}
													}
												}],
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "nodes"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "alt"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "status"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "mediaContentType"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "preview"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "image"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "id"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "altText"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "url"
																						}
																					}
																				]
																			}
																		}]
																	}
																}
															]
														}
													}]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query shopifySuggestedRefund(\n    $orderId: ID!\n    $refundLineItems: [Shopify_RefundLineItemInput!]\n    $refundShipping: Boolean\n    $suggestFullRefund: Boolean\n    $canReadLocations: Boolean!\n  ) {\n    Shopify {\n      order(id: $orderId) {\n        id\n        suggestedRefund(\n          refundLineItems: $refundLineItems\n          refundShipping: $refundShipping\n          suggestFullRefund: $suggestFullRefund\n        ) {\n          amountSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          subtotalSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          totalTaxSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          shipping {\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            maximumRefundableSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          suggestedTransactions {\n            accountNumber\n            gateway\n            kind\n            parentTransaction {\n              id\n            }\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          refundLineItems {\n            restockType\n            location @include(if: $canReadLocations) {\n              id\n            }\n            lineItem {\n              id\n              quantity\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "shopifySuggestedRefund"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "orderId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "ID"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "refundLineItems"
						}
					},
					type: {
						kind: "ListType",
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "Shopify_RefundLineItemInput"
								}
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "refundShipping"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Boolean"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "suggestFullRefund"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Boolean"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "canReadLocations"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Boolean"
							}
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "order"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "orderId"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "suggestedRefund"
									},
									arguments: [
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "refundLineItems"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "refundLineItems"
												}
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "refundShipping"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "refundShipping"
												}
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "suggestFullRefund"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "suggestFullRefund"
												}
											}
										}
									],
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "amountSet"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "presentmentMoney"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "subtotalSet"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "presentmentMoney"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "totalTaxSet"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "presentmentMoney"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "shipping"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "amountSet"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "presentmentMoney"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "amount"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "currencyCode"
																		}
																	}]
																}
															}]
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "maximumRefundableSet"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "presentmentMoney"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "amount"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "currencyCode"
																		}
																	}]
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "suggestedTransactions"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "accountNumber"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "gateway"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "kind"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "parentTransaction"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																}]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "amountSet"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "presentmentMoney"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "amount"
																			}
																		}, {
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "currencyCode"
																			}
																		}]
																	}
																}]
															}
														}
													]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "refundLineItems"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "restockType"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "location"
															},
															directives: [{
																kind: "Directive",
																name: {
																	kind: "Name",
																	value: "include"
																},
																arguments: [{
																	kind: "Argument",
																	name: {
																		kind: "Name",
																		value: "if"
																	},
																	value: {
																		kind: "Variable",
																		name: {
																			kind: "Name",
																			value: "canReadLocations"
																		}
																	}
																}]
															}],
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																}]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "lineItem"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																}, {
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "quantity"
																	}
																}]
															}
														}
													]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "test"
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "shop"
							},
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "name"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "email"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "description"
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	}
};
function UE(e) {
	return HE[e] ?? {};
}
var WE = UE("\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      currentAppInstallation {\n        accessScopes {\n          handle\n        }\n      }\n\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n"), GE = UE("\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            discountCodes\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true, refundShipping: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              subtotalSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              totalTaxSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              shipping {\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n                maximumRefundableSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n            currentTotalDiscountsSet {\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), KE = UE("\n  query shopifySuggestedRefund(\n    $orderId: ID!\n    $refundLineItems: [Shopify_RefundLineItemInput!]\n    $refundShipping: Boolean\n    $suggestFullRefund: Boolean\n    $canReadLocations: Boolean!\n  ) {\n    Shopify {\n      order(id: $orderId) {\n        id\n        suggestedRefund(\n          refundLineItems: $refundLineItems\n          refundShipping: $refundShipping\n          suggestFullRefund: $suggestFullRefund\n        ) {\n          amountSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          subtotalSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          totalTaxSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          shipping {\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            maximumRefundableSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          suggestedTransactions {\n            accountNumber\n            gateway\n            kind\n            parentTransaction {\n              id\n            }\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          refundLineItems {\n            restockType\n            location @include(if: $canReadLocations) {\n              id\n            }\n            lineItem {\n              id\n              quantity\n            }\n          }\n        }\n      }\n    }\n  }\n"), qE = UE("\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n"), JE = UE("\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n"), YE = UE("\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), XE = UE("\n  query searchDiscountCodes($query: String, $first: Int, $after: String) {\n    Shopify {\n      discountNodes(query: $query, first: $first, after: $after) {\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n        nodes {\n          id\n          discount {\n            __typename\n\n            ... on Shopify_DiscountCodeApp {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n              customerGets {\n                value {\n                  __typename\n\n                  ... on Shopify_DiscountPercentage {\n                    percentage\n                  }\n\n                  ... on Shopify_DiscountAmount {\n                    amount {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), ZE = UE("\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n"), QE = UE("\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n"), $E = UE("\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n"), eD = UE("\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n"), tD = UE("\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n"), nD = UE("\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n"), rD = lt`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, iD = lt`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, aD = UE("\n  mutation orderMarkAsPaid($input: Shopify_OrderMarkAsPaidInput!) {\n    Shopify {\n      orderMarkAsPaid(input: $input) {\n        order {\n          id\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n"), oD = ({ conversationContext: e, forcePhoneLookup: t }) => {
	let { useQuery: n } = V(), r = e.customer?.email, i = e.customer?.phone_number, a = r ? `email:"${r}"` : null, o = i ? `phone:"${i}"` : null, s = t ? o : a ?? o, { loading: c, error: l, data: u, refetch: d, networkStatus: f } = n(WE, {
		skip: !s,
		variables: { query: s },
		notifyOnNetworkStatusChange: !0
	});
	return {
		isCustomerLoading: c,
		customerError: l,
		customerData: u,
		refetchCustomer: d,
		customerNetworkStatus: f
	};
}, sD = () => {
	let { useLazyQuery: e } = V(), [t, { loading: n, error: r, data: i, refetch: a }] = e(GE);
	return {
		getCustomerOrders: t,
		isCustomerOrdersLoading: n,
		customerOrdersError: r,
		customerOrders: i,
		refetchCustomerOrders: a
	};
};
function cD(e = !1, t) {
	let [n, r] = W(e);
	return U(() => {
		let e = n ? window.setTimeout(() => r(!1), t || 2e3) : void 0;
		return () => window.clearTimeout(e);
	}, [t, n]), {
		isCopied: n,
		copy: (e) => {
			navigator.clipboard.writeText(e), r(!0);
		}
	};
}
var lD = (e, t) => (t ?? []).map(({ amountSet: t, gateway: n, parentTransaction: r }) => ({
	amount: String(t?.presentmentMoney?.amount ?? "0.00"),
	gateway: n ?? "",
	kind: BE.Refund,
	orderId: e,
	parentId: r?.id
})), uD = ({ orderId: e, transactions: t, refundLineItems: n, refundShipping: r, note: i, notify: a = !0 }) => ({
	orderId: e,
	notify: a,
	note: i,
	refundLineItems: n,
	transactions: t,
	shipping: { fullRefund: r }
}), dD = (e) => e.refundLineItems.map((t) => e.restock ? t : {
	lineItemId: t.lineItemId,
	quantity: t.quantity,
	restockType: VE.NoRestock
}), fD = (e) => {
	let t = new Map(e.restockSource.map((e) => [e.lineItemId, e]));
	return e.selectedLineItems.map((e) => {
		let n = t.get(e.lineItemId);
		return n ? {
			...e,
			restockType: n.restockType,
			locationId: n.locationId
		} : {
			lineItemId: e.lineItemId,
			quantity: e.quantity,
			restockType: VE.NoRestock
		};
	});
}, pD = (e) => !!e?.includes("read_locations"), mD = ({ ordersData: e }) => {
	let t = (e) => e?.fulfillments?.length > 0 ? e.fulfillments[0].trackingInfo : [];
	return e.map(({ node: e }) => ({
		id: e.id,
		name: e.name,
		createdAt: new Date(e.createdAt),
		cancelledAt: e.cancelledAt ? new Date(e.cancelledAt) : void 0,
		status: `${e.displayFulfillmentStatus?.toLowerCase()}, ${e.displayFinancialStatus?.toLowerCase()}${e.cancelledAt ? ", cancelled" : ""}`,
		displayFinancialStatus: e.displayFinancialStatus,
		currentTotalPriceSet: e.currentTotalPriceSet,
		currentTotalDiscountsSet: e.currentTotalDiscountsSet,
		value: e.netPaymentSet?.presentmentMoney?.amount,
		currencyCode: e.netPaymentSet?.presentmentMoney?.currencyCode,
		shippingAddress: e.shippingAddress,
		billingAddress: e.billingAddress,
		lineItems: e.lineItems?.edges?.map(({ node: e }) => e),
		suggestedRefund: {
			orderId: e.id,
			amount: e.suggestedRefund?.amountSet?.presentmentMoney?.amount,
			subtotal: e.suggestedRefund?.subtotalSet?.presentmentMoney?.amount,
			tax: e.suggestedRefund?.totalTaxSet?.presentmentMoney?.amount,
			currency: e.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
			notify: !0,
			refundLineItems: e.suggestedRefund?.refundLineItems.map(({ lineItem: e }) => ({
				lineItemId: e.id,
				quantity: e.quantity
			})),
			transactions: lD(e.id, e.suggestedRefund?.suggestedTransactions),
			shipping: {
				fullRefund: !0,
				amount: e.suggestedRefund?.shipping?.amountSet?.presentmentMoney?.amount,
				maximumRefundable: e.suggestedRefund?.shipping?.maximumRefundableSet?.presentmentMoney?.amount
			}
		},
		trackingInfos: t(e),
		shippingLines: e.shippingLines?.edges?.map(({ node: e }) => e),
		tags: e.tags,
		discountCodes: e.discountCodes,
		refunds: e.refunds
	}));
}, hD = [
	{
		value: RE.Pending,
		label: "Pending",
		description: "The payment is pending"
	},
	{
		value: RE.Authorized,
		label: "Authorized",
		description: "The payment has been authorized but not captured"
	},
	{
		value: RE.Paid,
		label: "Paid",
		description: "The payment has been completed"
	}
], gD = [
	{
		value: zE.Fulfilled,
		label: "Fulfilled",
		description: "Every line item in the order has been fulfilled"
	},
	{
		value: zE.Partial,
		label: "Partial",
		description: "At least one line item in the order has been fulfilled"
	},
	{
		value: zE.Restocked,
		label: "Restocked",
		description: "Every line item in the order has been restocked and the order canceled"
	}
], _D = (e) => e.length === 0 ? "" : e.map((e) => `id:${e.split("/").pop()}`).join(" OR "), vD = (e) => yD(bD(e)), yD = (e) => Object.fromEntries(Object.entries(e ?? {}).filter(([, e]) => e != null)), bD = (e) => {
	let t = e;
	if (typeof t == "object" && "countryCodeV2" in t) {
		let { countryCodeV2: e, ...n } = t;
		return {
			...n,
			...e && { countryCode: e }
		};
	}
	return e;
}, xD = ({ orderId: e, refundShipping: t, refundLineItems: n, suggestFullRefund: r, skip: i, canReadLocations: a }) => {
	let { useQuery: o } = V(), { data: s, previousData: c, loading: l, error: u } = o(KE, {
		skip: i,
		fetchPolicy: "cache-and-network",
		notifyOnNetworkStatusChange: !0,
		variables: {
			orderId: e,
			refundShipping: t,
			refundLineItems: n,
			suggestFullRefund: r,
			canReadLocations: a
		}
	}), d = i ? void 0 : s?.Shopify?.order?.suggestedRefund ?? c?.Shopify?.order?.suggestedRefund;
	return {
		suggestedRefund: Ze(() => {
			if (d) return {
				amount: String(d.amountSet.presentmentMoney.amount),
				subtotal: String(d.subtotalSet.presentmentMoney.amount),
				tax: String(d.totalTaxSet.presentmentMoney.amount),
				currency: d.amountSet.presentmentMoney.currencyCode,
				shipping: {
					amount: String(d.shipping.amountSet.presentmentMoney.amount),
					maximumRefundable: String(d.shipping.maximumRefundableSet.presentmentMoney.amount)
				},
				transactions: lD(e, d.suggestedTransactions),
				refundLineItems: d.refundLineItems.map(({ lineItem: e, restockType: t, location: n }) => ({
					lineItemId: e.id,
					quantity: e.quantity,
					restockType: t,
					locationId: n?.id
				}))
			};
		}, [d, e]),
		isLoading: l,
		error: u
	};
}, SD = {
	nodes: [],
	hasMoreResults: !1
}, CD = (e) => "codes" in e.discount, wD = (e) => CD(e) ? e.discount.codes.nodes[0]?.code ?? "" : "", TD = (e) => [...e].sort((e, t) => wD(e).localeCompare(wD(t))), ED = (e) => {
	let t = e?.Shopify?.discountNodes;
	return {
		nodes: TD((t?.nodes ?? []).filter(CD)),
		hasMoreResults: !!t?.pageInfo?.hasNextPage
	};
}, DD = 300, OD = 2, kD = 250, AD = ({ enabled: e = !0 } = {}) => {
	let { useLazyQuery: t, showNotification: n } = V(), [r, i] = W(""), [a, o] = W([]), [s, c] = W(!1), [l, u] = W(!1), d = $e(null), f = $e(0), [p] = t(XE, { fetchPolicy: "no-cache" }), m = (e) => {
		o(e.nodes), c(e.hasMoreResults);
	}, h = async (e, t) => {
		let r = f.current + 1;
		f.current = r, u(!0);
		try {
			let n = await p({ variables: {
				query: e,
				first: kD
			} });
			if (r !== f.current) return;
			if (n.error) throw n.error;
			let i = ED(n.data);
			t && (d.current = i), m(i);
		} catch {
			if (r !== f.current) return;
			m(SD), n({
				title: "Something went wrong",
				text: "Could not search for discount codes. Please try again.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		} finally {
			r === f.current && u(!1);
		}
	};
	return ul(() => {
		if (!e) return;
		let t = r.trim(), n = t.length === 0;
		if (!(!n && t.length < OD)) {
			if (n && d.current) {
				m(d.current);
				return;
			}
			h(n ? void 0 : t, n);
		}
	}, DD, [r, e]), {
		discountNodes: a,
		isLoading: l,
		hasMoreResults: s,
		filter: r,
		setFilter: i,
		minSearchCharacters: OD
	};
}, jD = {
	list: "_list_alvh6_1",
	listItem: "_listItem_alvh6_4",
	listItemEdit: "_listItemEdit_alvh6_11",
	fullWidth: "_fullWidth_alvh6_15",
	boxWrapper: "_boxWrapper_alvh6_19"
}, MD = {
	modal: "_modal_1vkwz_1",
	disabled: "_disabled_1vkwz_5"
}, ND = [
	{
		label: "Single Opt-In",
		description: "After providing their information, the customer receives marketing information without any intermediate steps.",
		value: NE.SingleOptIn
	},
	{
		label: "Confirmed Opt-In",
		description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
		value: NE.ConfirmedOptIn
	},
	{
		label: "Unknown",
		description: "The customer receives marketing information but how they were opted in is unknown.",
		value: NE.Unknown
	}
], PD = [
	{
		label: "Not Subscribed",
		description: "The customer hasn’t subscribed to SMS marketing.",
		value: PE.NotSubscribed
	},
	{
		label: "Pending",
		description: "The customer is in the process of subscribing to SMS marketing.",
		value: PE.Pending
	},
	{
		label: "Redacted",
		description: "The customer’s personal data is erased. This value is internally-set and read-only.",
		value: PE.Redacted
	},
	{
		label: "Subscribed",
		description: "The customer is subscribed to SMS marketing.",
		value: PE.Subscribed
	},
	{
		label: "Unsubscribed",
		description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
		value: PE.Unsubscribed
	}
], FD = ({ conversationContext: e, isOpen: t, setIsOpen: n, isMutationLoading: r, setIsMutationLoading: i, refetchCustomer: a }) => {
	let { track: o } = B(), { useMutation: s, showNotification: c } = V(), [l, u] = W(), [d, f] = W(), [p, m] = al(!0), [h, g] = al(!0), x = !!l, S = e.customer?.email, C = e.customer?.phone_number, w = e.customer?.given_name, T = e.customer?.family_name, A = {
		email: S ?? "",
		phone: C ?? "",
		firstName: w ?? "",
		lastName: T ?? "",
		smsMarketingState: null,
		smsMarketingOptInLevel: null
	}, j = xc({ defaultValues: A });
	U(() => {
		d?.forEach((e) => {
			let t = e?.field?.[0];
			t && (j.setError(t, {
				type: "server",
				message: e.message
			}), j.setFocus(t));
		});
	}, [d, j]);
	let [F, { error: I, reset: ee }] = s(tD, {
		onError: (e) => {
			u(e.message), i(!1), c({
				title: "Something went wrong",
				text: "The customer creation was not successful.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		},
		onCompleted: async (e) => {
			let t = e?.Shopify?.customerCreate?.userErrors || [];
			t.length > 0 ? (f(t), i(!1), c({
				title: "Something went wrong",
				text: "The customer creation was not successful.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			})) : (setTimeout(async () => {
				await a(), i(!1);
			}, 3e3), c({
				title: "Success",
				text: "The customer creation was successful.",
				icon: "check-circle-filled",
				severity: "success"
			}), o("shopify:profile:created"), n(!1));
		}
	}), te = Je((e) => {
		i(!0), u(void 0), F({ variables: { input: {
			firstName: e.firstName,
			lastName: e.lastName,
			...p && { email: e.email },
			...h && { phone: e.phone },
			...e.smsMarketingState && { smsMarketingConsent: {
				marketingState: e.smsMarketingState,
				marketingOptInLevel: e.smsMarketingOptInLevel
			} }
		} } });
	}, [
		F,
		i,
		h,
		p
	]), ne = () => {
		n(!1), ee(), u(void 0), j.reset(A);
	};
	return /* @__PURE__ */ q(E, {
		isOpen: t,
		onClose: ne,
		className: MD.modal,
		children: [
			/* @__PURE__ */ K(k, {
				title: "Create new customer",
				onClose: ne
			}),
			/* @__PURE__ */ K(D, { children: /* @__PURE__ */ q(y, { children: [
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						label: "First name",
						name: "firstName",
						control: j.control,
						rules: { required: "First name is required" }
					})
				}),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						label: "Last name",
						name: "lastName",
						control: j.control,
						rules: { required: "Last name is required" }
					})
				}),
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(jc, {
					label: "Email",
					name: "email",
					control: j.control,
					rules: { required: p ? "Email is required" : void 0 },
					componentProps: {
						className: ae({ [MD.disabled]: !p }),
						prefix: {
							type: "custom",
							value: /* @__PURE__ */ K(P, {
								disabled: !h,
								name: "hasEmail",
								value: "email",
								checked: p,
								onChange: () => m()
							})
						}
					}
				}) }),
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(jc, {
					label: "Phone",
					name: "phone",
					control: j.control,
					rules: { required: h ? "Phone is required" : void 0 },
					componentProps: {
						className: ae({ [MD.disabled]: !h }),
						prefix: {
							type: "custom",
							value: /* @__PURE__ */ K(P, {
								disabled: !p,
								name: "hasPhone",
								value: "phone",
								checked: h,
								onChange: () => g()
							})
						}
					}
				}) }),
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(kc, {
					control: j.control,
					label: "SMS marketing state",
					name: "smsMarketingState",
					rules: { required: {
						value: !0,
						message: "Please select a marketing state"
					} },
					componentProps: {
						placeholder: "Select a marketing state",
						equalityFn: (e, t) => e === t,
						getItemTitleByValue: (e) => {
							let t = PD.find((t) => t.value === e);
							return /* @__PURE__ */ q(_, {
								flexDirection: "column",
								gap: "100",
								margin: "100 0 200",
								children: [/* @__PURE__ */ K(L.Heading, {
									variant: "heading-3",
									children: t.label
								}), /* @__PURE__ */ K(L.Paragraph, {
									color: "secondary",
									children: t.description
								})]
							});
						}
					},
					children: PD.map((e) => /* @__PURE__ */ K(M.Item, {
						value: e.value,
						children: /* @__PURE__ */ q(_, {
							flexDirection: "column",
							gap: "100",
							children: [/* @__PURE__ */ K(L.Heading, {
								variant: "heading-3",
								children: e.label
							}), /* @__PURE__ */ K(L.Paragraph, {
								color: "secondary",
								children: e.description
							})]
						})
					}, e.value))
				}) }),
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(kc, {
					control: j.control,
					label: "SMS marketing opt-in level",
					name: "smsMarketingOptInLevel",
					rules: { required: {
						value: !0,
						message: "Please select a marketing opt-in level"
					} },
					componentProps: {
						placeholder: "Select a marketing opt-in level",
						equalityFn: (e, t) => e === t,
						getItemTitleByValue: (e) => {
							let t = ND.find((t) => t.value === e);
							return /* @__PURE__ */ q(_, {
								flexDirection: "column",
								gap: "100",
								margin: "100 0 200",
								children: [/* @__PURE__ */ K(L.Heading, {
									variant: "heading-3",
									children: t.label
								}), /* @__PURE__ */ K(L.Paragraph, {
									color: "secondary",
									children: t.description
								})]
							});
						}
					},
					children: ND.map((e) => /* @__PURE__ */ K(M.Item, {
						value: e.value,
						children: /* @__PURE__ */ q(_, {
							flexDirection: "column",
							gap: "100",
							children: [/* @__PURE__ */ K(L.Heading, {
								variant: "heading-3",
								children: e.label
							}), /* @__PURE__ */ K(L.Paragraph, {
								color: "secondary",
								children: e.description
							})]
						})
					}, e.value))
				}) }),
				x && /* @__PURE__ */ K(v, { children: /* @__PURE__ */ q(_, {
					flexDirection: "row",
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ K(b, {
						name: "close-circle-filled",
						color: "red.500"
					}), /* @__PURE__ */ K(L.Paragraph, { children: l })]
				}) })
			] }) }),
			/* @__PURE__ */ K(O, {
				confirmProps: {
					disabled: !(j.formState.isValid && j.formState.isDirty),
					isLoading: r,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 })
				},
				confirmOnClick: j.handleSubmit(te),
				cancelOnClick: ne,
				confirmName: I ? "Close" : "Save",
				cancelName: I ? void 0 : "Cancel"
			})
		]
	});
}, ID = ({ conversationContext: e, refetchCustomer: t }) => {
	let [n, r] = W(!1), [i, o] = W(!1);
	return /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(a, {
		variant: "secondary",
		onClick: () => r(!0),
		isLoading: i,
		loadingIndicator: /* @__PURE__ */ K(N, { size: 16 }),
		slotStart: /* @__PURE__ */ K(b, {
			size: 14,
			name: "user-plus",
			color: "green.500"
		}),
		className: jD.fullWidth,
		children: "Create new Shopify profile"
	}), /* @__PURE__ */ K(FD, {
		isOpen: n,
		setIsOpen: r,
		isMutationLoading: i,
		setIsMutationLoading: o,
		conversationContext: e,
		refetchCustomer: t
	})] });
}, LD = (e) => {
	let t = e?.match(/shopify\/\w+\/(\d+)/);
	return t ? t[1] : null;
}, RD = {
	wrapper: "_wrapper_10fld_1",
	copyIcon: "_copyIcon_10fld_7"
}, zD = ({ customer: e, shopifyDomain: t, refresh: n, loading: r, networkStatus: i }) => {
	let { isCopied: a, copy: o } = cD(), { isCopied: s, copy: c } = cD(), { track: l } = B();
	if (!e) return null;
	let { id: u, displayName: d, defaultEmailAddress: f, defaultPhoneNumber: p, tags: m = [], verifiedEmail: h } = e, g = f?.emailAddress, v = p?.phoneNumber, y = `https://${t}/admin/customers/${LD(u) ?? ""}`, x = r && i === ot.refetch;
	return /* @__PURE__ */ q(_, {
		gap: "300",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			className: RD.wrapper,
			gap: "200",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ q(_, {
					justifyContent: "space-between",
					alignItems: "center",
					children: [/* @__PURE__ */ K(L.Heading, {
						variant: "heading-3",
						children: d
					}), x ? /* @__PURE__ */ K(N, { size: 14 }) : /* @__PURE__ */ K(R, {
						content: "Reload customer",
						children: /* @__PURE__ */ K(b, {
							size: 14,
							name: "sync",
							onClick: () => {
								l("shopify:refreshed", { shopifyId: u }), n();
							},
							className: RD.copyIcon
						})
					})]
				}),
				g && /* @__PURE__ */ q(_, {
					justifyContent: "space-between",
					alignItems: "center",
					children: [/* @__PURE__ */ q(_, {
						alignItems: "center",
						gap: "200",
						children: [
							/* @__PURE__ */ K(b, {
								size: 14,
								name: "mail"
							}),
							/* @__PURE__ */ K(L.ExternalLink, {
								href: `mailto:${g}`,
								children: g
							}),
							/* @__PURE__ */ K(R, {
								content: h ? "Verified email" : "Email is not verified",
								children: /* @__PURE__ */ K(_, {
									alignItems: "center",
									children: /* @__PURE__ */ K(b, {
										size: 14,
										color: h ? "green.500" : "red.500",
										name: h ? "check-circle" : "exclamation"
									})
								})
							})
						]
					}), /* @__PURE__ */ K(R, {
						content: "Copy Email",
						children: /* @__PURE__ */ K(b, {
							size: 14,
							name: a ? "done" : "copy",
							onClick: () => o(g),
							className: RD.copyIcon
						})
					})]
				}),
				v && /* @__PURE__ */ q(_, {
					justifyContent: "space-between",
					alignItems: "center",
					children: [/* @__PURE__ */ q(_, {
						alignItems: "center",
						gap: "200",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "phone"
						}), /* @__PURE__ */ K(L.ExternalLink, {
							href: `tel:${v}`,
							children: v
						})]
					}), /* @__PURE__ */ K(R, {
						content: "Copy phone number",
						children: /* @__PURE__ */ K(b, {
							size: 14,
							name: s ? "done" : "copy",
							onClick: () => c(v),
							className: RD.copyIcon
						})
					})]
				}),
				/* @__PURE__ */ q(_, {
					alignItems: "center",
					gap: "200",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "external-link"
					}), /* @__PURE__ */ K(L.ExternalLink, {
						href: y,
						target: "_blank",
						rel: "noreferrer",
						children: "View customer in Shopify"
					})]
				})
			]
		}), m.length > 0 && /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(L.Heading, {
			variant: "heading-3",
			children: "Customer Tags"
		}), /* @__PURE__ */ K(_, {
			gap: "200",
			flexDirection: "row",
			flexWrap: "wrap",
			children: m.map((e) => /* @__PURE__ */ K(I, { children: e }, `${u}-${e}`))
		})] })]
	});
}, BD = {
	creationModal: "_creationModal_pbe64_1",
	detailsModal: "_detailsModal_pbe64_5",
	percentageSuffix: "_percentageSuffix_pbe64_9"
}, VD = () => Array.from({ length: 12 }, () => "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789".charAt(Math.floor(Math.random() * 36))).join(""), HD = (e) => {
	let t = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, n = (() => {
		switch (e.minimumRequirementOption) {
			case "quantity": return "greaterThanOrEqualToQuantity";
			case "subtotal": return "greaterThanOrEqualToSubtotal";
			default: return null;
		}
	})(), r = e.maximumUsage;
	return {
		code: e.code,
		title: e.title,
		usageLimit: r === "only-once" ? 1 : null,
		appliesOncePerCustomer: r === "once-per-customer",
		customerGets: {
			value: { [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: t } : t },
			items: { all: !0 }
		},
		context: { all: FE.All },
		...n && { minimumRequirement: { [e.minimumRequirementOption]: { [n]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue } } },
		startsAt: (/* @__PURE__ */ new Date()).toISOString()
	};
}, UD = [{
	label: "Percentage",
	description: "The percentage value of the discount.",
	value: "percentage"
}, {
	label: "Amount",
	description: "The value of the discount.",
	value: "discountAmount"
}], WD = [
	{
		label: "None",
		description: "No minimum requirements.",
		value: "none"
	},
	{
		label: "Quantity",
		description: "Minimum required quantity of items.",
		value: "quantity"
	},
	{
		label: "Subtotal",
		description: "Minimum required order subtotal.",
		value: "subtotal"
	}
], GD = [
	{
		label: "No limit",
		value: "no-limit",
		description: "The discount code can be used unlimited times."
	},
	{
		label: "Only once",
		value: "only-once",
		description: "The discount code can only be used once."
	},
	{
		label: "Once per customer",
		value: "once-per-customer",
		description: "The discount code can be used once per customer."
	}
], KD = Yo, qD = ({ codeDiscount: e }) => {
	let t = e?.codes?.nodes?.[0]?.code, { isCopied: n, copy: r } = Re(), i = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
	return /* @__PURE__ */ q(_, {
		flexDirection: "column",
		gap: "400",
		children: [/* @__PURE__ */ q(T, { children: [
			/* @__PURE__ */ K(T.Text, { children: /* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "1",
					children: "Title"
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "2",
					color: "secondary",
					children: e?.title
				})]
			}) }),
			/* @__PURE__ */ K(T.Text, { children: /* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "1",
					children: "Status"
				}), /* @__PURE__ */ q(_, {
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ K(b, {
						name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
						color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "2",
						color: "secondary",
						children: e?.status
					})]
				})]
			}) }),
			/* @__PURE__ */ K(T.Text, { children: /* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "1",
					children: "Usage limit"
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "2",
					color: "secondary",
					children: i
				})]
			}) }),
			/* @__PURE__ */ K(T.Text, { children: /* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "1",
					children: "Applies once per customer"
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "2",
					color: "secondary",
					children: e?.appliesOncePerCustomer ? "Yes" : "No"
				})]
			}) }),
			/* @__PURE__ */ K(T.Text, { children: /* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "1",
					children: "Starts at"
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "2",
					color: "secondary",
					children: KD(e?.startsAt).format(he)
				})]
			}) })
		] }), /* @__PURE__ */ K(g, {
			label: "Discount code",
			children: /* @__PURE__ */ K(w, {
				readOnly: !0,
				value: t,
				suffix: {
					type: "button",
					button: {
						icon: n ? "done" : "copy",
						onClick: () => {
							r(t);
						}
					}
				}
			})
		})]
	});
}, JD = "shopify-discount-code-form", YD = {
	title: "",
	code: "",
	customerGets: void 0,
	customerGetsOption: "percentage",
	minimumRequirementOption: "none",
	minimumRequirementValue: void 0,
	maximumUsage: "only-once"
}, XD = ({ isOpen: e, setIsOpen: t }) => {
	let { track: n } = B(), { useMutation: i, showNotification: a } = V(), [o, s] = W([]), [c, l] = W(), u = xc({
		mode: "all",
		defaultValues: YD
	});
	U(() => {
		o?.forEach((e) => {
			let t = e?.field?.[1];
			t && u.setError(t, {
				type: "server",
				message: e.message
			});
		});
	}, [o, u]);
	let d = !!c, f = u.watch("minimumRequirementOption"), p = u.watch("customerGetsOption"), m = Ze(() => {
		switch (f) {
			case "quantity": return "Minimum quantity";
			case "subtotal": return "Minimum subtotal";
			default: return "";
		}
	}, [f]), [h, { loading: g, error: b, reset: x }] = i(nD, {
		onError: () => {
			a({
				title: "Something went wrong",
				text: "The discount code creation was not successful.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		},
		onCompleted: (e) => {
			let t = e?.Shopify?.discountCodeBasicCreate?.userErrors;
			if (t && t.length > 0) s(t);
			else {
				let t = e?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
				t && "codes" in t && l(t), a({
					title: "Success",
					text: "The discount code was created successfully.",
					icon: "check-circle-filled",
					severity: "success"
				}), n("shopify:discount:code:created"), s([]);
			}
		}
	}), S = () => {
		u.setValue("code", VD(), {
			shouldDirty: !0,
			shouldValidate: !0,
			shouldTouch: !0
		});
	}, C = (e) => {
		h({ variables: { input: HD(e) } });
	}, w = () => {
		u.reset(YD), s([]), x(), l(void 0), t(!1);
	};
	return /* @__PURE__ */ q(E, {
		isOpen: e,
		onClose: w,
		className: ae({
			[BD.creationModal]: !d,
			[BD.detailsModal]: d
		}),
		children: [
			/* @__PURE__ */ K(k, {
				title: d ? "Discount code details" : "Create new discount code",
				onClose: w
			}),
			/* @__PURE__ */ q(D, { children: [
				d && /* @__PURE__ */ K(qD, { codeDiscount: c }),
				!d && /* @__PURE__ */ q("form", {
					noValidate: !0,
					id: JD,
					onSubmit: u.handleSubmit(C),
					children: [/* @__PURE__ */ K(_, {
						margin: "0 0 400",
						children: /* @__PURE__ */ K(r, {
							variant: "info",
							description: /* @__PURE__ */ K(L.Paragraph, { children: "This code will be eligible for all customers." })
						})
					}), /* @__PURE__ */ q(y, { children: [
						/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(jc, {
							label: "Title",
							name: "title",
							control: u.control,
							rules: { required: "Please enter a title" },
							componentProps: { placeholder: "Enter a title" }
						}) }),
						/* @__PURE__ */ K(v, {
							span: 3,
							children: /* @__PURE__ */ K(kc, {
								control: u.control,
								label: "Discount type",
								name: "customerGetsOption",
								rules: { required: "Please select a discount type" },
								componentProps: {
									placeholder: "Select a discount type",
									equalityFn: (e, t) => e === t,
									onChange: () => {
										u.setValue("customerGets", void 0), u.clearErrors("customerGets");
									},
									getItemTitleByValue: (e) => {
										let t = UD.find((t) => t.value === e);
										return /* @__PURE__ */ K(_, {
											margin: "0 0 100",
											children: /* @__PURE__ */ K(L.Heading, {
												variant: "heading-3",
												children: t?.label
											})
										});
									}
								},
								children: UD.map((e) => /* @__PURE__ */ K(M.Item, {
									value: e.value,
									children: /* @__PURE__ */ q(_, {
										flexDirection: "column",
										gap: "100",
										children: [/* @__PURE__ */ K(L.Heading, {
											variant: "heading-3",
											children: e.label
										}), /* @__PURE__ */ K(L.Paragraph, {
											color: "secondary",
											children: e.description
										})]
									})
								}, e.value))
							})
						}),
						/* @__PURE__ */ K(v, {
							span: 3,
							children: /* @__PURE__ */ K(jc, {
								label: "Discount value",
								name: "customerGets",
								control: u.control,
								rules: {
									required: "Please enter a value",
									validate: (e) => {
										if (e) {
											if (p === "percentage" && (e < 0 || e > 100)) return "Percentage must be between 0 and 100";
											if (p === "discountAmount" && e < 0) return "Discount amount must be greater than 0";
										}
									}
								},
								componentProps: {
									placeholder: "Enter a value",
									type: "number",
									...p === "percentage" && { suffix: {
										type: "custom",
										noWrap: !0,
										value: /* @__PURE__ */ K(_, {
											alignItems: "center",
											className: BD.percentageSuffix,
											children: "%"
										})
									} }
								}
							})
						}),
						/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(jc, {
							label: "Code",
							name: "code",
							control: u.control,
							rules: { required: "Please enter a code" },
							componentProps: {
								placeholder: "Enter a code or click to the right to generate",
								suffix: {
									type: "button",
									button: {
										icon: "sync",
										onClick: S
									}
								}
							}
						}) }),
						/* @__PURE__ */ K(v, {
							span: 3,
							children: /* @__PURE__ */ K(kc, {
								control: u.control,
								label: "Minimum purchase requirements",
								name: "minimumRequirementOption",
								rules: { required: "Please select a minimum requirement option" },
								componentProps: {
									placeholder: "Select a minimum purchase requirement",
									equalityFn: (e, t) => e === t,
									onChange: () => {
										u.setValue("minimumRequirementValue", void 0), u.clearErrors("minimumRequirementValue");
									},
									getItemTitleByValue: (e) => {
										let t = WD.find((t) => t.value === e);
										return /* @__PURE__ */ K(_, {
											margin: "0 0 100",
											children: /* @__PURE__ */ K(L.Heading, {
												variant: "heading-3",
												children: t?.label
											})
										});
									}
								},
								children: WD.map((e) => /* @__PURE__ */ K(M.Item, {
									value: e.value,
									children: /* @__PURE__ */ q(_, {
										flexDirection: "column",
										gap: "100",
										children: [/* @__PURE__ */ K(L.Heading, {
											variant: "heading-3",
											children: e.label
										}), /* @__PURE__ */ K(L.Paragraph, {
											color: "secondary",
											children: e.description
										})]
									})
								}, e.value))
							})
						}),
						/* @__PURE__ */ K(v, {
							span: 3,
							children: /* @__PURE__ */ K(jc, {
								name: "minimumRequirementValue",
								label: m,
								control: u.control,
								disabled: f === "none",
								rules: {
									required: {
										value: f !== "none",
										message: "Please enter a value"
									},
									validate: (e) => {
										if (e && f !== "none" && e < 0) return `Minimum ${f} must be greater than 0`;
									}
								},
								componentProps: {
									type: "number",
									placeholder: "Enter a value"
								}
							})
						}),
						/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(kc, {
							name: "maximumUsage",
							label: "Maximum usage",
							control: u.control,
							componentProps: {
								placeholder: "Select a maximum usage",
								equalityFn: (e, t) => e === t,
								getItemTitleByValue: (e) => {
									let t = GD.find((t) => t.value === e);
									return /* @__PURE__ */ K(_, {
										margin: "0 0 100",
										children: /* @__PURE__ */ K(L.Heading, {
											variant: "heading-3",
											children: t?.label
										})
									});
								}
							},
							children: GD.map((e) => /* @__PURE__ */ K(M.Item, {
								value: e.value,
								children: /* @__PURE__ */ q(_, {
									flexDirection: "column",
									gap: "100",
									children: [/* @__PURE__ */ K(L.Heading, {
										variant: "heading-3",
										children: e.label
									}), /* @__PURE__ */ K(L.Paragraph, {
										color: "secondary",
										children: e.description
									})]
								})
							}, e.value))
						}) })
					] })]
				}),
				b && /* @__PURE__ */ K(z, { error: b })
			] }),
			/* @__PURE__ */ K(O, {
				confirmProps: {
					disabled: !d && !(u.formState.isValid && u.formState.isDirty),
					isLoading: g,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 })
				},
				confirmName: d ? "Close" : "Save",
				confirmOnClick: d ? w : u.handleSubmit(C),
				cancelOnClick: d ? void 0 : w
			})
		]
	});
}, ZD = ({ code: e }) => {
	let { isCopied: t, copy: n } = cD();
	return /* @__PURE__ */ q(_, {
		justifyContent: "space-between",
		alignItems: "center",
		gap: "200",
		width: "100%",
		children: [/* @__PURE__ */ q(_, {
			gap: "200",
			alignItems: "center",
			children: [/* @__PURE__ */ K(b, {
				size: 12,
				name: "shopify",
				color: "green.500"
			}), /* @__PURE__ */ K(L.Paragraph, {
				variant: "3",
				children: e
			})]
		}), /* @__PURE__ */ K(x, {
			icon: t ? "done" : "copy",
			onClick: () => n(e),
			variant: "secondary"
		})]
	});
}, QD = ({ discountCode: e }) => {
	let { discount: t } = e;
	if (!("codes" in t)) return null;
	let n = t?.codes?.nodes ?? [];
	return /* @__PURE__ */ q(_, {
		flexDirection: "column",
		gap: "100",
		children: [/* @__PURE__ */ K(L.Heading, {
			variant: "heading-3",
			children: t.title
		}), /* @__PURE__ */ K(T, { children: n.map((e) => /* @__PURE__ */ K(T.Item, {
			className: jD.listItem,
			children: /* @__PURE__ */ K(ZD, { code: e.code })
		}, e.code)) })]
	});
}, $D = {
	modal: "_modal_11d6e_1",
	modalBody: "_modalBody_11d6e_4",
	codeContainer: "_codeContainer_11d6e_9"
}, eO = ({ isOpen: e, setIsOpen: t }) => {
	let { discountNodes: n, isLoading: r, filter: i, setFilter: a, minSearchCharacters: o } = AD({ enabled: e }), s = n.length === 0, c = () => {
		a(""), t(!1);
	};
	return /* @__PURE__ */ q(E, {
		isOpen: e,
		onClose: c,
		className: $D.modal,
		children: [
			/* @__PURE__ */ K(k, {
				title: "Discount codes",
				onClose: c
			}),
			/* @__PURE__ */ q(D, {
				className: $D.modalBody,
				children: [
					/* @__PURE__ */ K(w, {
						type: "search",
						icon: "search",
						value: i,
						placeholder: `Search discount codes (min. ${o} characters)`,
						onChange: (e) => {
							a(e.target.value);
						}
					}),
					r && /* @__PURE__ */ K(_, {
						justifyContent: "center",
						margin: "300",
						children: /* @__PURE__ */ K(N, {})
					}),
					!r && s && /* @__PURE__ */ K(u, {
						title: "No discount codes found.",
						description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
					}),
					!r && !s && n.map((e) => /* @__PURE__ */ K("div", {
						className: $D.codeContainer,
						children: /* @__PURE__ */ K(QD, { discountCode: e })
					}, e.id))
				]
			}),
			/* @__PURE__ */ K(O, {
				confirmName: "Close",
				confirmOnClick: c
			})
		]
	});
}, tO = ({ displayDiscountCodeCreation: e }) => {
	let [t, n] = W(!1), [r, i] = W(!1);
	return /* @__PURE__ */ q(G, { children: [
		/* @__PURE__ */ q(_, {
			gap: "200",
			flexDirection: "column",
			children: [/* @__PURE__ */ K(L.Heading, {
				variant: "heading-3",
				children: "Discount codes"
			}), /* @__PURE__ */ q(_, {
				gap: "100",
				flexDirection: "row",
				alignItems: "center",
				width: "100%",
				children: [/* @__PURE__ */ K(_, {
					flex: "1",
					children: /* @__PURE__ */ K(a, {
						variant: "secondary",
						icon: "gift",
						onClick: () => i(!0),
						style: { width: "100%" },
						children: "View discount codes"
					})
				}), e && /* @__PURE__ */ K(_, {
					flex: "1",
					children: /* @__PURE__ */ K(a, {
						variant: "secondary",
						icon: "plus",
						onClick: () => n(!0),
						style: { width: "100%" },
						children: "Create new"
					})
				})]
			})]
		}),
		/* @__PURE__ */ K(eO, {
			isOpen: r,
			setIsOpen: i
		}),
		/* @__PURE__ */ K(XD, {
			isOpen: t,
			setIsOpen: n
		})
	] });
}, nO = ({ customer: e }) => {
	if (!e) return null;
	let { defaultEmailAddress: t, defaultPhoneNumber: r } = e, i = (e) => e ? me(e.replaceAll("_", " ")) : "No state available", a = (e) => {
		switch (e) {
			case ME.Invalid:
			case ME.NotSubscribed:
			case PE.NotSubscribed: return "red.500";
			case ME.Pending:
			case PE.Pending:
			case ME.Unsubscribed:
			case PE.Unsubscribed: return "orange.500";
			case ME.Subscribed:
			case PE.Subscribed: return "green.500";
			default: return "neutral.500";
		}
	}, o = (e) => {
		switch (e) {
			case NE.SingleOptIn:
			case NE.ConfirmedOptIn: return "green.500";
			case NE.Unknown:
			default: return "neutral.200";
		}
	}, { marketingState: s, marketingUpdatedAt: c, marketingOptInLevel: l } = t ?? {}, { marketingState: u, marketingUpdatedAt: d, marketingOptInLevel: f } = r ?? {};
	return /* @__PURE__ */ q(_, {
		gap: "300",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ K(L.Heading, {
				variant: "heading-3",
				children: "Marketing consent"
			}),
			/* @__PURE__ */ q(_, {
				gap: "200",
				flexDirection: "column",
				children: [
					/* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "row",
						children: [/* @__PURE__ */ K(b, {
							name: "mail",
							color: "neutral.500"
						}), /* @__PURE__ */ K(L.Heading, {
							variant: "heading-4",
							children: "Email"
						})]
					}),
					c && /* @__PURE__ */ K(R, {
						content: "Last updated at",
						children: /* @__PURE__ */ K(n, {
							size: "small",
							variant: "info",
							children: KD(c).format("DD MMM YYYY @ HH:mm")
						})
					}),
					/* @__PURE__ */ q(_, {
						gap: "100",
						flexDirection: "row",
						children: [/* @__PURE__ */ K(R, {
							content: "Opt-In state",
							children: /* @__PURE__ */ K(I, {
								color: o(l),
								children: i(l)
							})
						}), /* @__PURE__ */ K(R, {
							content: "Marketing state",
							children: /* @__PURE__ */ K(I, {
								color: a(s),
								children: i(s)
							})
						})]
					})
				]
			}),
			/* @__PURE__ */ q(_, {
				gap: "200",
				flexDirection: "column",
				children: [
					/* @__PURE__ */ q(_, {
						gap: "200",
						flexDirection: "row",
						alignItems: "center",
						children: [/* @__PURE__ */ K(b, {
							name: "phone",
							color: "neutral.500"
						}), /* @__PURE__ */ K(L.Heading, {
							variant: "heading-4",
							children: "Phone"
						})]
					}),
					d && /* @__PURE__ */ K(R, {
						content: "Last updated at",
						children: /* @__PURE__ */ K(n, {
							size: "small",
							variant: "info",
							children: KD(d).format("DD MMM YYYY @ HH:mm")
						})
					}),
					/* @__PURE__ */ q(_, {
						gap: "100",
						flexDirection: "row",
						children: [/* @__PURE__ */ K(R, {
							content: "Opt-In state",
							children: /* @__PURE__ */ K(I, {
								color: o(f),
								children: i(f)
							})
						}), /* @__PURE__ */ K(R, {
							content: "Marketing state",
							children: /* @__PURE__ */ K(I, {
								color: a(u),
								children: i(u)
							})
						})]
					})
				]
			})
		]
	});
}, rO = (e) => {
	let { discount: t } = e;
	switch (t.__typename) {
		case "Shopify_DiscountCodeBasic": {
			if (t.status !== IE.Active) return null;
			let e = t.codes.nodes[0]?.code;
			if (!e) return null;
			let { value: n } = t.customerGets;
			return n.__typename === "Shopify_DiscountPercentage" ? {
				code: e,
				kind: "percentage",
				percentage: Number((n.percentage * 100).toFixed(2))
			} : n.__typename === "Shopify_DiscountAmount" ? {
				code: e,
				kind: "fixedAmount",
				amount: String(n.amount.amount),
				currencyCode: n.amount.currencyCode
			} : null;
		}
		case "Shopify_DiscountCodeFreeShipping": {
			if (t.status !== IE.Active) return null;
			let e = t.codes.nodes[0]?.code;
			return e ? {
				code: e,
				kind: "freeShipping"
			} : null;
		}
		default: return null;
	}
}, iO = (e) => {
	let t = e.map(rO).filter((e) => !!e), n = /* @__PURE__ */ new Map();
	return t.forEach((e) => {
		n.has(e.code) || n.set(e.code, e);
	}), Array.from(n.values());
}, aO = (e) => {
	if (e) switch (e.kind) {
		case "percentage": return { itemPercentageDiscountCode: {
			code: e.code,
			percentage: e.percentage
		} };
		case "fixedAmount": return { itemFixedDiscountCode: {
			code: e.code,
			amountSet: { shopMoney: {
				amount: e.amount,
				currencyCode: e.currencyCode
			} }
		} };
		case "freeShipping": return { freeShippingDiscountCode: { code: e.code } };
		default: return;
	}
}, oO = (e) => e ? [e.code] : void 0, sO = (e) => {
	switch (e.kind) {
		case "percentage": return `${e.percentage}% off`;
		case "fixedAmount": return `${e.amount} ${e.currencyCode} off`;
		case "freeShipping": return "Free shipping";
		default: return "";
	}
}, cO = ({ enabled: e }) => {
	let t = vs(), { discountNodes: n, isLoading: r, filter: i, setFilter: a, minSearchCharacters: o } = AD({ enabled: e }), s = Ze(() => iO(n), [n]), c = i.trim().length > 0;
	if (!r && !c && s.length === 0) return null;
	let l = !r && s.length === 0;
	return /* @__PURE__ */ K(kc, {
		label: "Discount code",
		control: t.control,
		name: "discountCode",
		componentProps: {
			clearable: !0,
			placeholder: "Search discount codes",
			tabIndex: 0,
			equalityFn: (e, t) => e?.code === t?.code,
			getItemTitleByValue: (e) => e ? /* @__PURE__ */ q(L.Paragraph, { children: [
				e.code,
				" · ",
				sO(e)
			] }) : null,
			filter: {
				value: i,
				placeholder: `Search discount codes (min. ${o} characters)`,
				onChange: (e) => {
					a(e.target.value);
				}
			},
			onToggleDropdown: (e) => {
				!e && i !== "" && a("");
			}
		},
		children: /* @__PURE__ */ q(G, { children: [
			r && /* @__PURE__ */ K(M.Item, {
				noFixedSelectionStateSpace: !0,
				children: /* @__PURE__ */ K(_, {
					justifyContent: "center",
					padding: "300",
					children: /* @__PURE__ */ K(N, {})
				})
			}),
			!r && s.map((e) => /* @__PURE__ */ K(M.Item, {
				value: e,
				children: /* @__PURE__ */ q(_, {
					justifyContent: "space-between",
					alignItems: "center",
					gap: "200",
					children: [c ? /* @__PURE__ */ K(te, {
						text: e.code,
						highlight: i
					}) : /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: e.code
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "5",
						color: "tertiary",
						children: sO(e)
					})]
				})
			}, e.code)),
			l && /* @__PURE__ */ K(M.Item, {
				noFixedSelectionStateSpace: !0,
				children: /* @__PURE__ */ K(u, {
					title: "No discount codes found",
					description: "Try changing your search criteria."
				})
			})
		] })
	});
}, lO = ({ control: e, name: t, label: n, placeholder: r, required: i = !1, apiUserError: a }) => /* @__PURE__ */ K(Es, {
	name: t,
	control: e,
	rules: { required: i ? {
		value: !0,
		message: "This field is required"
	} : !1 },
	render: ({ field: e, fieldState: t }) => /* @__PURE__ */ K(m, {
		required: i,
		label: n,
		input: e,
		placeholder: r,
		meta: {
			warning: t?.error?.message,
			error: t?.error?.message || a?.[e.name]
		}
	})
}), uO = { modal: "_modal_1wlra_1" };
function dO(e) {
	try {
		return new Intl.DisplayNames(["en"], { type: "region" }).of(e.toUpperCase()) ?? e;
	} catch {
		return e;
	}
}
var fO = /* @__PURE__ */ "AF.AX.AL.DZ.AD.AO.AI.AG.AR.AM.AW.AC.AU.AT.AZ.BS.BH.BD.BB.BY.BE.BZ.BJ.BM.BT.BO.BA.BW.BV.BR.IO.BN.BG.BF.BI.KH.CA.CV.BQ.KY.CF.TD.CL.CN.CX.CC.CO.KM.CG.CD.CK.CR.HR.CU.CW.CY.CZ.CI.DK.DJ.DM.DO.EC.EG.SV.GQ.ER.EE.SZ.ET.FK.FO.FJ.FI.FR.GF.PF.TF.GA.GM.GE.DE.GH.GI.GR.GL.GD.GP.GT.GG.GN.GW.GY.HT.HM.VA.HN.HK.HU.IS.IN.ID.IR.IQ.IE.IM.IL.IT.JM.JP.JE.JO.KZ.KE.KI.KP.XK.KW.KG.LA.LV.LB.LS.LR.LY.LI.LT.LU.MO.MG.MW.MY.MV.ML.MT.MQ.MR.MU.YT.MX.MD.MC.MN.ME.MS.MA.MZ.MM.NA.NR.NP.NL.AN.NC.NZ.NI.NE.NG.NU.NF.MK.NO.OM.PK.PS.PA.PG.PY.PE.PH.PN.PL.PT.QA.CM.RE.RO.RU.RW.BL.SH.KN.LC.MF.PM.WS.SM.ST.SA.SN.RS.SC.SL.SG.SX.SK.SI.SB.SO.ZA.GS.KR.SS.ES.LK.VC.SD.SR.SJ.SE.CH.SY.TW.TJ.TZ.TH.TL.TG.TK.TO.TT.TA.TN.TR.TM.TC.TV.UG.UA.AE.GB.US.UM.UY.UZ.VU.VE.VN.VG.WF.EH.YE.ZM.ZW.ZZ".split("."), pO = "shopify-shiping-address-form", mO = ({ title: e, address: t, isOpen: n, setIsOpen: r, orderId: i, shopifyId: a, shippingCountryCodes: o, onChange: s, refetchOrders: c }) => {
	let { useMutation: l, showNotification: u } = V(), { track: d } = B(), [f, p] = W(!1), [m, h] = W({}), g = !s, [_, { error: b, reset: x }] = l(ZE, {
		onError: () => {
			p(!1), u({
				title: "Something went wrong",
				text: "The address change was not successful.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		},
		onCompleted: (e) => {
			p(!1);
			let t = e?.Shopify?.orderUpdate?.userErrors;
			if (t != null && t.length > 0) {
				let e = t.reduce((e, t) => {
					let n = t.field;
					if (n == null || n.length === 0) return e;
					let r = n[n.length - 1];
					return r != null && (e[r] = t.message), e;
				}, {});
				h(e);
			} else u({
				title: "Success",
				text: "The address change was successful.",
				icon: "check-circle-filled",
				severity: "success"
			}), c(), P();
		}
	}), S = Je(() => ({
		firstName: t?.firstName || "",
		lastName: t?.lastName || "",
		company: t?.company || "",
		address1: t?.address1 || "",
		address2: t?.address2 || "",
		city: t?.city || "",
		countryCodeV2: fO.find((e) => e === t?.countryCodeV2),
		provinceCode: t?.province || "",
		zip: t?.zip || ""
	}), [t]), { control: C, handleSubmit: w, formState: T, reset: A } = xc({
		mode: "all",
		defaultValues: S()
	}), j = w((e) => {
		if (g) {
			if (p(!0), !a || !i) {
				p(!1);
				return;
			}
			d("shopify:order:edit:shipping:address:modal:submitted", {
				shopifyId: a,
				orderId: i
			});
			let { countryCodeV2: t, ...n } = e, r = {
				...n,
				countryCode: t
			};
			_({ variables: { input: {
				id: i,
				shippingAddress: r
			} } });
		} else s(e), P();
	});
	U(() => {
		n && A(S());
	}, [
		n,
		t,
		A,
		S
	]);
	let P = () => {
		A(S()), h({}), x(), r(!1);
	};
	return /* @__PURE__ */ q(E, {
		isOpen: n,
		onClose: P,
		className: uO.modal,
		"data-testid": "edit-shipping-address-modal",
		children: [
			/* @__PURE__ */ K(k, {
				title: e,
				onClose: () => P()
			}),
			/* @__PURE__ */ K(D, { children: /* @__PURE__ */ q("form", {
				noValidate: !0,
				id: pO,
				onSubmit: j,
				children: [b && /* @__PURE__ */ K(z, { error: b }), /* @__PURE__ */ q(y, { children: [
					/* @__PURE__ */ K(v, {
						span: 3,
						children: /* @__PURE__ */ K(lO, {
							required: !0,
							control: C,
							name: "firstName",
							label: "First name",
							placeholder: "Insert your first name",
							apiUserError: m
						})
					}),
					/* @__PURE__ */ K(v, {
						span: 3,
						children: /* @__PURE__ */ K(lO, {
							required: !0,
							control: C,
							name: "lastName",
							label: "Last name",
							placeholder: "Insert your last name",
							apiUserError: m
						})
					}),
					/* @__PURE__ */ K(v, {
						span: 6,
						children: /* @__PURE__ */ K(lO, {
							control: C,
							name: "company",
							label: "Company",
							placeholder: "Insert your company name"
						})
					}),
					/* @__PURE__ */ K(v, {
						span: 6,
						children: /* @__PURE__ */ K(lO, {
							required: !0,
							control: C,
							name: "address1",
							label: "Address",
							placeholder: "Insert your address",
							apiUserError: m
						})
					}),
					/* @__PURE__ */ K(v, {
						span: 6,
						children: /* @__PURE__ */ K(lO, {
							control: C,
							name: "address2",
							label: "Additional address details",
							placeholder: "Insert more address details"
						})
					}),
					/* @__PURE__ */ K(v, {
						span: 3,
						children: /* @__PURE__ */ K(lO, {
							required: !0,
							control: C,
							name: "zip",
							label: "Zip / postal code",
							placeholder: "Insert your zip / postal code",
							apiUserError: m
						})
					}),
					/* @__PURE__ */ K(v, {
						span: 3,
						children: /* @__PURE__ */ K(lO, {
							required: !0,
							control: C,
							name: "city",
							label: "City",
							placeholder: "Insert your city",
							apiUserError: m
						})
					}),
					/* @__PURE__ */ K(v, {
						span: 6,
						children: /* @__PURE__ */ K(kc, {
							name: "countryCodeV2",
							control: C,
							label: "Country",
							rules: { required: {
								value: !0,
								message: "Please select a country"
							} },
							componentProps: {
								placeholder: "Select your country",
								getItemTitleByValue: (e) => e ? dO(e) : ""
							},
							children: fO.filter((e) => o.includes(e)).map((e) => /* @__PURE__ */ K(M.Item, {
								value: e,
								children: /* @__PURE__ */ K(L.Paragraph, { children: dO(e) })
							}, e))
						})
					})
				] })]
			}) }),
			/* @__PURE__ */ K(O, {
				confirmProps: {
					disabled: !(T.isValid && T.isDirty),
					type: "submit",
					form: pO,
					isLoading: f,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 })
				},
				confirmOnClick: () => {
					b && P();
				},
				cancelOnClick: () => {
					a && i && !b && d("shopify:order:edit:shipping:address:modal:canceled", {
						shopifyId: a,
						orderId: i
					}), P();
				},
				confirmName: b ? "Close" : "Save",
				cancelName: b ? void 0 : "Cancel"
			})
		]
	});
}, hO = { clickableIcon: "_clickableIcon_33mqm_1" }, gO = ({ formFieldName: e, ...t }) => {
	let { field: n } = Ts({
		control: vs().control,
		name: e
	});
	return /* @__PURE__ */ K(_O, {
		enableEditAddress: !0,
		openByDefault: !0,
		onChange: n.onChange,
		...t
	});
}, _O = ({ labelText: e, address: t, orderId: n, shopifyId: r, shippingCountryCodes: i, enableEditAddress: a, icon: o = "home", onChange: s, refetchOrders: c, openByDefault: l = !1 }) => {
	let [u, d] = W(!1), [f, p] = W(l), { isCopied: m, copy: h } = cD(), { track: g } = B(), v = a && (!!n || !!s), y = [t?.zip || "", t?.city || ""].filter(Boolean).join(" "), x = [t?.firstName || "", t?.lastName || ""].filter(Boolean).join(" "), S = t?.countryCodeV2 && _e(t.countryCodeV2), C = Je(() => [
		x,
		t?.company,
		t?.address1,
		t?.address2,
		y,
		t?.province,
		S
	].filter(Boolean).join("\n"), [
		t,
		x,
		y,
		S
	]);
	if (!t) return null;
	let w = () => {
		r && n && g("shopify:order:edit:shipping:address:modal:opened", {
			shopifyId: r,
			orderId: n
		}), d(!0);
	};
	return /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ q(_, {
		justifyContent: "space-between",
		children: [/* @__PURE__ */ q(_, {
			gap: "250",
			flexDirection: "row",
			children: [/* @__PURE__ */ K(b, {
				size: 14,
				name: o,
				color: "green.500"
			}), /* @__PURE__ */ q(_, {
				gap: "200",
				flexDirection: "column",
				children: [/* @__PURE__ */ q(_, {
					gap: "100",
					flexDirection: "row",
					onClick: () => p(!f),
					className: hO.clickableIcon,
					alignItems: "center",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "3",
						children: e
					}), /* @__PURE__ */ K(b, {
						size: 14,
						name: f ? "angle-down" : "angle-right"
					})]
				}), f && /* @__PURE__ */ q(_, {
					gap: "100",
					flexDirection: "column",
					children: [
						x && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: x
						}),
						t?.company && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: t.company
						}),
						t?.address1 && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: t.address1
						}),
						t?.address2 && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: t.address2
						}),
						y && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: y
						}),
						t?.province && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: t.province
						}),
						S && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: S
						})
					]
				})]
			})]
		}), /* @__PURE__ */ q(_, {
			gap: "250",
			flexDirection: "row",
			children: [v && /* @__PURE__ */ K(R, {
				content: `Edit ${e.toLowerCase()}`,
				children: /* @__PURE__ */ K(b, {
					size: 14,
					name: "pen",
					onClick: () => w(),
					className: hO.clickableIcon
				})
			}), /* @__PURE__ */ K(R, {
				content: `Copy ${e.toLowerCase()}`,
				children: /* @__PURE__ */ K(b, {
					size: 14,
					name: m ? "done" : "copy",
					onClick: () => h(C()),
					className: hO.clickableIcon
				})
			})]
		})]
	}), v && /* @__PURE__ */ K(mO, {
		title: `Edit ${e}`,
		address: t,
		isOpen: u,
		setIsOpen: d,
		orderId: n,
		shopifyId: r,
		shippingCountryCodes: i,
		onChange: s,
		refetchOrders: c
	})] });
}, vO = ({ withAddresses: e = !0, selectedProductIds: t }) => {
	let n = vs(), r = ws({
		control: n.control,
		name: "lineItems"
	}), i = ws({
		control: n.control,
		name: "billingAddress"
	}), a = ws({
		control: n.control,
		name: "shippingAddress"
	}), o = ws({
		control: n.control,
		name: "discountCode"
	}), s = Ze(() => t ? t.length === 0 ? [] : (r || []).filter((e) => t.includes(e.id)) : r, [r, t]), c = Ze(() => !s || s.length === 0 ? 0 : s.reduce((e, t) => e + (t.priceRangeV2?.minVariantPrice?.amount || 0) * (t.quantity || 0), 0), [s]), u = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
	return /* @__PURE__ */ q(_, {
		flexDirection: "column",
		gap: "300",
		children: [
			e && /* @__PURE__ */ q(G, { children: [
				/* @__PURE__ */ q(L.Paragraph, {
					variant: "3",
					children: [
						i?.firstName,
						" ",
						i?.lastName
					]
				}),
				/* @__PURE__ */ K(gO, {
					formFieldName: "billingAddress",
					address: i,
					labelText: "Billing address",
					shippingCountryCodes: [],
					refetchOrders: () => Promise.resolve({})
				}),
				/* @__PURE__ */ K(gO, {
					formFieldName: "shippingAddress",
					address: a,
					labelText: "Shipping address",
					shippingCountryCodes: [],
					icon: "map-pin",
					refetchOrders: () => Promise.resolve({})
				})
			] }),
			/* @__PURE__ */ K(l, {}),
			/* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "3",
					children: "Subtotal"
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "3",
					children: `${c.toFixed(2)} ${u}`
				})]
			}),
			o && /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ q(L.Paragraph, {
					variant: "4",
					children: [
						"Discount (",
						o.code,
						")"
					]
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					children: sO(o)
				})]
			}), /* @__PURE__ */ K(L.Paragraph, {
				color: "tertiary",
				variant: "5",
				children: "The discount will be deducted after the order is created."
			})] }),
			/* @__PURE__ */ K(L.Paragraph, {
				color: "tertiary",
				variant: "5",
				children: "Tax and shipping will be calculated by Shopify based on customer address and store settings."
			})
		]
	});
}, yO = {
	productTableHeader: "_productTableHeader_6h6pl_1",
	productImage: "_productImage_6h6pl_5"
}, bO = (e) => (e.media?.nodes?.[0])?.preview?.image?.url || null, xO = ({ product: e, index: t, onRemove: n }) => {
	let r = vs(), i = e.priceRangeV2.minVariantPrice.amount, a = e.priceRangeV2.minVariantPrice.currencyCode, o = `lineItems.${t}.quantity`, s = r.watch(o), c = bO(e);
	return /* @__PURE__ */ q(F.Tr, { children: [
		/* @__PURE__ */ K(F.Td, { children: /* @__PURE__ */ q(_, {
			gap: "200",
			alignItems: "center",
			children: [c && /* @__PURE__ */ K(S, {
				src: c,
				alt: e.title,
				className: yO.productImage
			}), /* @__PURE__ */ K(L.Paragraph, {
				variant: "4",
				children: e.title
			})]
		}) }),
		/* @__PURE__ */ K(F.Td, { children: /* @__PURE__ */ K(L.Paragraph, {
			variant: "4",
			children: e.totalInventory
		}) }),
		/* @__PURE__ */ K(F.Td, { children: /* @__PURE__ */ K(L.Paragraph, {
			variant: "4",
			children: `${i} ${a}`
		}) }),
		/* @__PURE__ */ K(F.Td, { children: /* @__PURE__ */ K(jc, {
			noLabel: !0,
			noAlert: !0,
			name: o,
			control: r.control,
			componentProps: {
				type: "number",
				min: 1,
				max: e.totalInventory,
				tabIndex: 0
			}
		}, `${o}-${s}`) }),
		/* @__PURE__ */ K(F.Td, { children: /* @__PURE__ */ K(L.Paragraph, {
			variant: "4",
			children: `${i * s} ${a}`
		}) }),
		/* @__PURE__ */ K(F.Td, { children: /* @__PURE__ */ K(_, {
			justifyContent: "flex-end",
			children: /* @__PURE__ */ K(x, {
				icon: "trash",
				variant: "secondary",
				onClick: n
			})
		}) })
	] });
}, SO = 300, CO = 2, wO = 25, TO = ({ onProductSelected: e }) => {
	let { useLazyQuery: t, showNotification: n } = V(), [r, i] = W(""), [a, o] = W([]), s = vs(), c = s.watch("selectedProductId"), [l, { loading: d, networkStatus: f }] = t(YE, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0,
		onCompleted: (e) => {
			let t = e?.Shopify?.products?.nodes || [];
			o(t.filter((e) => !!e).sort((e, t) => e.title.localeCompare(t.title)));
		},
		onError: () => {
			o([]), n({
				title: "Something went wrong",
				text: "Could not search for products. Please try again.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		}
	});
	ul(() => {
		r.trim().length >= CO && !d && f === ot.ready ? l({ variables: {
			query: r.trim(),
			productCount: wO,
			mediaCount: 1
		} }) : r.trim().length < CO && o([]);
	}, SO, [r]), U(() => {
		if (!c) return;
		let t = a.find((e) => e.id === c);
		t && e(t), s.setValue("selectedProductId", void 0);
	}, [
		c,
		a,
		s,
		e
	]);
	let p = d && f !== ot.ready, m = r.trim().length >= CO, h = !a.length && !p && m;
	return /* @__PURE__ */ K(kc, {
		noAlert: !0,
		label: "Product selection",
		control: s.control,
		name: "selectedProductId",
		componentProps: {
			placeholder: `Search products (min. ${CO} characters)`,
			tabIndex: 0,
			getItemTitleByValue: (e) => {
				let t = a.find((t) => t.id === e);
				return t ? /* @__PURE__ */ K(L.Paragraph, { children: t.title }) : null;
			},
			filter: {
				value: r,
				onChange: (e) => {
					i(e.target.value);
				}
			},
			onToggleDropdown: (e) => {
				!e && r !== "" && i("");
			}
		},
		children: /* @__PURE__ */ q(G, { children: [
			p && /* @__PURE__ */ K(M.Item, {
				noFixedSelectionStateSpace: !0,
				children: /* @__PURE__ */ K(_, {
					justifyContent: "center",
					padding: "300",
					children: /* @__PURE__ */ K(N, {})
				})
			}),
			!p && a.map((e) => {
				let t = e.totalInventory <= 0, n = bO(e);
				return /* @__PURE__ */ K(M.Item, {
					value: e.id,
					isDisabled: t,
					children: /* @__PURE__ */ q(_, {
						justifyContent: "space-between",
						alignItems: "center",
						children: [/* @__PURE__ */ q(_, {
							gap: "200",
							alignItems: "center",
							children: [n && /* @__PURE__ */ K(S, {
								src: n,
								alt: e.title,
								className: yO.productImage
							}), r ? /* @__PURE__ */ K(te, {
								text: e.title,
								highlight: r
							}) : /* @__PURE__ */ K(L.Paragraph, {
								variant: "4",
								children: e.title
							})]
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "5",
							children: t ? "Out of stock" : `${e.totalInventory} in stock`
						})]
					})
				}, e.id);
			}),
			h && /* @__PURE__ */ K(M.Item, {
				noFixedSelectionStateSpace: !0,
				children: /* @__PURE__ */ K(u, {
					title: "No products found",
					description: "Try changing your search criteria."
				})
			}),
			!m && !p && /* @__PURE__ */ K(M.Item, {
				noFixedSelectionStateSpace: !0,
				children: /* @__PURE__ */ K(u, {
					title: "Search for products",
					description: `Type at least ${CO} characters to search.`
				})
			})
		] })
	});
}, EO = ({ loading: e = !1, selectionMode: t = !1, hideDeleteButton: n = !1, hideProductSelect: r = !1, selectedProductIds: i = [], disabledProductIds: a = [], maxQuantities: s, onToggleSelect: c, onToggleSelectAll: l }) => {
	let d = vs(), f = d.watch("lineItems"), p = !!f?.length, m = t && p ? f.filter((e) => !a.includes(e?.id)) : [], h = m.length > 0 && m.every((e) => i.includes(e?.id)), g = m.some((e) => i.includes(e?.id)) && !h, v = Je((e) => {
		let t = d.getValues("lineItems"), n = t.findIndex((t) => t?.id === e.id);
		if (n > -1) {
			let e = d.getValues(`lineItems.${n}.quantity`) || 0, r = [...t];
			r[n] = {
				...r[n],
				quantity: e + 1
			}, d.setValue("lineItems", r);
		} else d.setValue("lineItems", [...t, {
			...e,
			quantity: 1
		}]);
	}, [d]);
	return /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [
			!r && /* @__PURE__ */ K(TO, { onProductSelected: v }),
			!p && e && /* @__PURE__ */ K(_, {
				margin: "200 0",
				justifyContent: "center",
				padding: "300",
				className: jD.boxWrapper,
				children: /* @__PURE__ */ K(N, {})
			}),
			!p && !e && /* @__PURE__ */ K(_, {
				margin: "200 0",
				justifyContent: "center",
				className: jD.boxWrapper,
				children: /* @__PURE__ */ K(u, {
					title: "No products selected",
					description: "Select a product above for your new order"
				})
			}),
			p && /* @__PURE__ */ K(_, {
				margin: "300 0",
				children: /* @__PURE__ */ q(F, {
					hoverable: !0,
					framed: !1,
					headerWithBackground: !1,
					className: yO.productTable,
					children: [/* @__PURE__ */ K(F.Thead, {
						className: yO.productTableHeader,
						children: /* @__PURE__ */ q(F.Tr, { children: [
							t && /* @__PURE__ */ K(F.Th, { children: /* @__PURE__ */ K(o, {
								checked: h,
								indeterminate: g,
								onChange: () => l?.(!h)
							}) }),
							/* @__PURE__ */ K(F.Th, { children: "Product" }),
							/* @__PURE__ */ K(F.Th, { children: "In stock" }),
							/* @__PURE__ */ K(F.Th, { children: "Price" }),
							/* @__PURE__ */ K(F.Th, { children: "Quantity" }),
							/* @__PURE__ */ K(F.Th, { children: "Total" }),
							!n && /* @__PURE__ */ K(F.Th, {})
						] })
					}), /* @__PURE__ */ K(F.Tbody, { children: f?.map((e, r) => {
						if (!t) return /* @__PURE__ */ K(xO, {
							product: e,
							index: r,
							onRemove: () => {
								let e = f.filter((e, t) => t !== r);
								d.setValue("lineItems", e);
							}
						}, `${e?.id}-${r}`);
						let l = e, u = l.priceRangeV2.minVariantPrice.amount, p = l.priceRangeV2.minVariantPrice.currencyCode, m = `lineItems.${r}.quantity`, h = u * (d.watch(m) || 0), g = bO(l), v = i.includes(l.id), y = a.includes(l.id), b = s?.[l.id] ?? l.totalInventory;
						return /* @__PURE__ */ q(F.Tr, {
							style: y ? { opacity: .5 } : void 0,
							children: [
								/* @__PURE__ */ K(F.Td, { children: /* @__PURE__ */ K(o, {
									checked: v,
									disabled: y,
									onChange: () => c?.(l.id, !v)
								}) }),
								/* @__PURE__ */ K(F.Td, { children: /* @__PURE__ */ q(_, {
									gap: "200",
									alignItems: "center",
									children: [g && /* @__PURE__ */ K(S, {
										src: g,
										alt: l.title,
										className: yO.productImage
									}), /* @__PURE__ */ q(_, {
										flexDirection: "column",
										children: [/* @__PURE__ */ K(L.Paragraph, {
											variant: "4",
											children: l.title
										}), y && /* @__PURE__ */ K(L.Paragraph, {
											variant: "5",
											children: "Already refunded"
										})]
									})]
								}) }),
								/* @__PURE__ */ K(F.Td, { children: /* @__PURE__ */ K(L.Paragraph, {
									variant: "4",
									children: l.totalInventory
								}) }),
								/* @__PURE__ */ K(F.Td, { children: /* @__PURE__ */ K(L.Paragraph, {
									variant: "4",
									children: `${u} ${p}`
								}) }),
								/* @__PURE__ */ K(F.Td, { children: /* @__PURE__ */ K(jc, {
									noLabel: !0,
									noAlert: !0,
									disabled: y || b <= 1,
									name: m,
									control: d.control,
									componentProps: {
										type: "number",
										min: 1,
										max: b,
										tabIndex: 0
									}
								}, `${m}-${d.watch(m)}`) }),
								/* @__PURE__ */ K(F.Td, { children: /* @__PURE__ */ K(L.Paragraph, {
									variant: "4",
									children: `${h} ${p}`
								}) }),
								!n && /* @__PURE__ */ K(F.Td, { children: /* @__PURE__ */ K(_, {
									justifyContent: "flex-end",
									children: /* @__PURE__ */ K(x, {
										icon: "trash",
										variant: "secondary",
										onClick: () => {
											let e = f.filter((e, t) => t !== r);
											d.setValue("lineItems", e), v && c?.(l.id, !1);
										}
									})
								}) })
							]
						}, `${l.id}-${r}`);
					}) })]
				})
			})
		]
	});
}, DO = ({ previousOrderStatus: e } = {}) => /* @__PURE__ */ K(kc, {
	label: "Payment Status",
	name: "financialStatus",
	control: vs().control,
	rules: { required: {
		value: !0,
		message: "Please select a payment status"
	} },
	componentProps: {
		placeholder: "Select payment status",
		tabIndex: 0,
		getItemTitleByValue: (e) => {
			let t = hD.find((t) => t.value === e);
			return t ? /* @__PURE__ */ q(_, {
				flexDirection: "row",
				gap: "200",
				alignItems: "center",
				margin: "0 0 100 0",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					children: t.label
				}), /* @__PURE__ */ q(L.Paragraph, {
					variant: "5",
					color: "secondary",
					children: [
						"(",
						t.description,
						")"
					]
				})]
			}) : null;
		}
	},
	children: hD.map((t) => {
		let n = e && t.value === e;
		return /* @__PURE__ */ K(M.Item, {
			value: t.value,
			children: /* @__PURE__ */ q(_, {
				flexDirection: "column",
				gap: "100",
				children: [/* @__PURE__ */ q(_, {
					flexDirection: "row",
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: t.label
					}), n && /* @__PURE__ */ K(L.Paragraph, {
						variant: "5",
						color: "secondary",
						children: "(previous order status)"
					})]
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "5",
					color: "secondary",
					children: t.description
				})]
			})
		}, t.value);
	})
}), OO = () => /* @__PURE__ */ K(kc, {
	label: "Fulfillment Status",
	helpIcon: { text: "Defaults to 'unfulfilled' if nothing is selected" },
	name: "fulfillmentStatus",
	control: vs().control,
	componentProps: {
		clearable: !0,
		placeholder: "Select fulfillment status",
		tabIndex: 0,
		getItemTitleByValue: (e) => {
			let t = gD.find((t) => t.value === e);
			return t ? /* @__PURE__ */ q(_, {
				gap: "200",
				alignItems: "center",
				margin: "0 0 100 0",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					children: t.label
				}), /* @__PURE__ */ q(L.Paragraph, {
					variant: "5",
					color: "secondary",
					children: [
						"(",
						t.description,
						")"
					]
				})]
			}) : null;
		}
	},
	children: gD.map((e) => /* @__PURE__ */ K(M.Item, {
		value: e.value,
		children: /* @__PURE__ */ q(_, {
			flexDirection: "column",
			gap: "100",
			children: [/* @__PURE__ */ K(L.Paragraph, {
				variant: "4",
				children: e.label
			}), /* @__PURE__ */ K(L.Paragraph, {
				variant: "5",
				color: "secondary",
				children: e.description
			})]
		})
	}, e.value))
}), kO = { modal: "_modal_1mprq_1" }, AO = "create-shopify-order-form", jO = ({ isOpen: e, shopifyCustomer: t, displayCreateDraftOrder: n, setIsOpen: r, refetchCustomerOrders: i }) => {
	let { useMutation: a, showNotification: o } = V(), { track: s } = B(), [c, l] = W(!1), [u, d] = W(!1), f = {
		firstName: t.defaultAddress?.firstName,
		lastName: t.defaultAddress?.lastName,
		address1: t.defaultAddress?.address1,
		address2: t.defaultAddress?.address2,
		city: t.defaultAddress?.city,
		zip: t.defaultAddress?.zip,
		countryCodeV2: t.defaultAddress?.countryCodeV2,
		phone: t.defaultAddress?.phone
	}, p = {
		selectedProductId: void 0,
		lineItems: [],
		customNote: "",
		tags: [],
		billingAddress: f,
		shippingAddress: f,
		financialStatus: RE.Pending,
		fulfillmentStatus: void 0,
		discountCode: void 0
	}, [m, h] = W([]), b = xc({
		mode: "all",
		defaultValues: p
	}), x = b.watch("lineItems").length > 0, S = () => {
		b.reset(p), h([]), r(!1);
	};
	U(() => {
		m.length > 0 && b.setValue("tags", m, { shouldDirty: !0 });
	}, [m, b]);
	let C = $e(!1), w = () => {
		i(), l(!1), o({
			title: "Success",
			text: "The order was created successfully.",
			icon: "check-circle-filled",
			severity: "success"
		}), s("shopify:order:create:succeeded"), S();
	}, T = () => {
		i(), l(!1), o({
			title: "Order created but not marked as paid",
			text: "The order was created but recording the payment failed. You can mark it as paid in Shopify.",
			icon: "exclamation-triangle-filled",
			severity: "warning"
		}), S();
	}, A = () => {
		l(!1), o({
			title: "Something went wrong",
			text: "The order creation was not successful.",
			icon: "exclamation-triangle-filled",
			severity: "warning"
		}), s("shopify:order:create:failed"), S();
	}, [j] = a(aD, {
		onError: T,
		onCompleted: (e) => {
			let t = e.Shopify?.orderMarkAsPaid?.userErrors;
			if (t && t.length > 0) {
				T();
				return;
			}
			w();
		}
	}), [M, { error: P }] = a(rD, {
		onError: A,
		onCompleted: (e) => {
			let t = e.Shopify?.orderCreate, n = t?.order?.id;
			if (t?.userErrors?.length || !n) {
				A();
				return;
			}
			if (C.current) {
				j({ variables: { input: { id: n } } });
				return;
			}
			w();
		}
	}), [F, { error: I }] = a(iD, {
		onError: () => {
			d(!1), o({
				title: "Something went wrong",
				text: "The draft order creation was not successful.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), s("shopify:order:create:draft:failed"), S();
		},
		onCompleted: () => {
			i(), d(!1), o({
				title: "Success",
				text: "The draft order creation was successful.",
				icon: "check-circle-filled",
				severity: "success"
			}), s("shopify:order:create:draft:succeeded"), S();
		}
	}), L = (e) => {
		let n = e.lineItems.map((e) => ({
			productId: e.id,
			requiresShipping: !0,
			priceSet: { shopMoney: {
				amount: e.priceRangeV2.maxVariantPrice.amount,
				currencyCode: e.priceRangeV2.maxVariantPrice.currencyCode
			} },
			quantity: e.quantity
		}));
		l(!0);
		let r = vD(e?.billingAddress), i = vD(e?.shippingAddress), a = e.financialStatus === RE.Paid;
		C.current = a, M({ variables: { order: {
			lineItems: n,
			customer: { toAssociate: { id: t?.id } },
			note: e.customNote,
			tags: e.tags,
			financialStatus: a ? void 0 : e.financialStatus,
			fulfillmentStatus: e.fulfillmentStatus,
			discountCode: aO(e.discountCode),
			shippingAddress: i,
			billingAddress: r
		} } });
	}, te = (e) => {
		let n = e.lineItems.map((e) => ({
			title: e.title,
			requiresShipping: !0,
			originalUnitPriceWithCurrency: {
				amount: e.priceRangeV2.maxVariantPrice.amount,
				currencyCode: e.priceRangeV2.maxVariantPrice.currencyCode
			},
			quantity: e.quantity
		}));
		d(!0);
		let r = vD(e?.billingAddress), i = vD(e?.shippingAddress);
		F({ variables: { input: {
			email: t.defaultEmailAddress?.emailAddress,
			note: e.customNote,
			tags: e.tags,
			lineItems: n,
			discountCodes: oO(e.discountCode),
			shippingAddress: i,
			billingAddress: r
		} } });
	};
	return /* @__PURE__ */ q(E, {
		isOpen: e,
		onClose: S,
		className: kO.modal,
		allowEscClose: !1,
		children: [
			/* @__PURE__ */ K(k, {
				title: "Create new order",
				onClose: S
			}),
			/* @__PURE__ */ q(D, { children: [/* @__PURE__ */ K(ys, {
				...b,
				children: /* @__PURE__ */ K("form", {
					id: AO,
					children: /* @__PURE__ */ q(y, { children: [
						/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(EO, {}) }),
						/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(Es, {
							name: "tags",
							render: ({ fieldState: { error: t } }) => /* @__PURE__ */ K(g, {
								label: "Tags",
								meta: { error: t?.message },
								children: /* @__PURE__ */ K("div", {
									tabIndex: 0,
									onKeyDown: (e) => {
										e.key === "Enter" && (e.preventDefault(), e.stopPropagation());
									},
									children: /* @__PURE__ */ K(ee, {
										placeholder: "Type and hit enter to add tags",
										selectedTags: m,
										onChange: (e) => {
											h(e);
										}
									}, `tags-input-${e}`)
								})
							})
						}) }),
						/* @__PURE__ */ K(v, {
							span: 4,
							children: /* @__PURE__ */ q(_, {
								flexDirection: "column",
								gap: "300",
								children: [
									/* @__PURE__ */ K(DO, {}),
									/* @__PURE__ */ K(OO, {}),
									/* @__PURE__ */ K(cO, { enabled: e }),
									/* @__PURE__ */ K(jc, {
										label: "Custom note",
										name: "customNote",
										componentProps: {
											placeholder: "Enter custom note",
											tabIndex: 0
										}
									})
								]
							})
						}),
						/* @__PURE__ */ K(v, {
							span: 2,
							children: /* @__PURE__ */ K(g, {
								label: "Details",
								noAlert: !0,
								children: /* @__PURE__ */ K(_, {
									flexDirection: "column",
									gap: "200",
									justifyContent: "end",
									className: jD.boxWrapper,
									children: /* @__PURE__ */ K(vO, {})
								})
							})
						})
					] })
				})
			}), (P || I) && /* @__PURE__ */ K(z, { error: P || I })] }),
			/* @__PURE__ */ K(O, {
				confirmProps: {
					type: "submit",
					form: AO,
					disabled: !x || c,
					isLoading: c,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 }),
					tabIndex: 0
				},
				confirmName: "Create order",
				confirmOnClick: b.handleSubmit(L),
				...n && {
					confirmSecondaryName: "Create draft order",
					confirmSecondaryOnClick: () => {
						b.handleSubmit(te)();
					},
					confirmSecondaryProps: {
						type: "submit",
						form: AO,
						disabled: !x || u,
						isLoading: u,
						loadingIndicator: /* @__PURE__ */ K(N, { size: 16 }),
						tabIndex: 0
					}
				}
			})
		]
	});
}, MO = { modal: "_modal_al73g_1" }, NO = [
	{
		label: "Customer",
		value: LE.Customer,
		description: "The customer wanted to cancel the order."
	},
	{
		label: "Declined",
		value: LE.Declined,
		description: "Payment was declined."
	},
	{
		label: "Fraud",
		value: LE.Fraud,
		description: "The order was fraudulent."
	},
	{
		label: "Inventory",
		value: LE.Inventory,
		description: "There was insufficient inventory."
	},
	{
		label: "Other",
		value: LE.Other,
		description: "The order was canceled for an unlisted reason."
	},
	{
		label: "Staff",
		value: LE.Staff,
		description: "Staff made an error."
	}
], PO = ({ orderId: e, isOpen: t, orderName: n, setIsOpen: r, isMutationLoading: i, setIsMutationLoading: a, refetchOrders: o }) => {
	let { track: s } = B(), { useMutation: c, showNotification: l } = V(), [u, d] = W([]), f = u.length > 0, p = {
		orderId: e,
		reason: null,
		refundMethod: { originalPaymentMethodsRefund: !0 },
		restock: !0,
		notifyCustomer: !1,
		staffNote: ""
	}, m = xc({ defaultValues: p }), [h, { error: x, reset: S }] = c($E, {
		onError: () => {
			a(!1), l({
				title: "Something went wrong",
				text: "Could not cancel the order.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), r(!1);
		},
		onCompleted: async (e) => {
			let t = e.Shopify?.orderCancel?.orderCancelUserErrors || [];
			if (t.length > 0) a(!1), d(t), l({
				title: "Something went wrong",
				text: "Could not cancel the order.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
			else {
				let t = e.Shopify?.orderCancel?.job?.done;
				setTimeout(async () => {
					await o().finally(() => a(!1));
				}, t ? 0 : 4e3), l({
					title: "Success",
					text: `${t ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
					icon: "check-circle-filled",
					severity: "success"
				}), s("shopify:order:cancelled"), r(!1);
			}
		}
	}), C = Je((e) => {
		e.reason != null && (a(!0), h({ variables: {
			orderId: e.orderId,
			reason: e.reason,
			refundMethod: e.refundMethod,
			restock: e.restock,
			notifyCustomer: e.notifyCustomer,
			staffNote: e.staffNote ?? ""
		} }));
	}, [e]), w = () => {
		r(!1), S(), d([]), m.reset(p);
	};
	return /* @__PURE__ */ q(E, {
		isOpen: t,
		onClose: w,
		className: MO.modal,
		children: [
			/* @__PURE__ */ K(k, {
				title: `Cancel order ${n}`,
				onClose: w
			}),
			/* @__PURE__ */ K(D, { children: /* @__PURE__ */ q(y, { children: [
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(kc, {
					control: m.control,
					label: "Reason",
					name: "reason",
					rules: { required: {
						value: !0,
						message: "Please select a reason"
					} },
					componentProps: {
						placeholder: "Select a reason",
						equalityFn: (e, t) => e === t,
						getItemTitleByValue: (e) => {
							if (!e) return "";
							let t = NO.find((t) => t.value === e);
							return /* @__PURE__ */ q(_, {
								flexDirection: "row",
								gap: "200",
								children: [/* @__PURE__ */ K(L.Heading, {
									variant: "heading-3",
									children: t.label
								}), /* @__PURE__ */ K(L.Paragraph, {
									color: "secondary",
									children: t.description
								})]
							});
						}
					},
					children: NO.map((e) => /* @__PURE__ */ K(M.Item, {
						value: e.value,
						children: /* @__PURE__ */ q(_, {
							flexDirection: "row",
							gap: "200",
							children: [/* @__PURE__ */ K(L.Heading, {
								variant: "heading-3",
								children: e.label
							}), /* @__PURE__ */ K(L.Paragraph, {
								color: "secondary",
								children: e.description
							})]
						})
					}, e.value))
				}) }),
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Refund order",
					children: /* @__PURE__ */ K(Z, {
						control: m.control,
						name: "refundMethod.originalPaymentMethodsRefund"
					})
				}) }),
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Restock items",
					children: /* @__PURE__ */ K(Z, {
						control: m.control,
						name: "restock"
					})
				}) }),
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Notify the customer",
					children: /* @__PURE__ */ K(Z, {
						control: m.control,
						name: "notifyCustomer"
					})
				}) }),
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(jc, {
					name: "staffNote",
					label: "Staff note",
					control: m.control
				}) }),
				f && /* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(_, {
					gap: "200",
					flexDirection: "column",
					children: u.map((e) => /* @__PURE__ */ q(_, {
						flexDirection: "row",
						gap: "200",
						alignItems: "center",
						children: [
							/* @__PURE__ */ K(b, {
								name: "close-circle-filled",
								color: "red.500"
							}),
							/* @__PURE__ */ K(L.Heading, {
								variant: "heading-3",
								children: e.code
							}),
							/* @__PURE__ */ q(L.Paragraph, { children: [
								"(",
								e.field?.join(","),
								") ",
								e.message
							] })
						]
					}, e.code))
				}) })
			] }) }),
			/* @__PURE__ */ K(O, {
				confirmProps: {
					disabled: !(m.formState.isValid && m.formState.isDirty),
					isLoading: i,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 })
				},
				confirmOnClick: m.handleSubmit(C),
				cancelOnClick: w,
				confirmName: x ? "Close" : "Cancel order",
				cancelName: x ? void 0 : "Cancel"
			})
		]
	});
}, FO = ({ orderId: e, orderName: t, refetchOrders: n, disabled: r }) => {
	let [i, o] = W(!1), [s, c] = W(!1);
	return /* @__PURE__ */ q(_, {
		width: "100%",
		children: [/* @__PURE__ */ K(a, {
			variant: "secondary",
			onClick: () => o(!0),
			isLoading: s,
			loadingIndicator: /* @__PURE__ */ K(N, { size: 16 }),
			disabled: r,
			slotStart: /* @__PURE__ */ K(b, {
				size: 14,
				name: "close-circle-filled",
				color: "red.500"
			}),
			className: jD.fullWidth,
			children: "Cancel"
		}), /* @__PURE__ */ K(PO, {
			orderId: e,
			orderName: t,
			isOpen: i,
			setIsOpen: o,
			isMutationLoading: s,
			setIsMutationLoading: c,
			refetchOrders: n
		})]
	});
}, IO = { modal: "_modal_1mprq_1" }, LO = ({ order: e, orderName: t, isOpen: n, shopifyId: r, setIsOpen: i, refetchOrders: a }) => {
	let { useMutation: o, showNotification: s, useQuery: c } = V(), { track: l } = B(), [u, d] = W(!1), [f, p] = W(e?.tags || []), m = "duplicate-shopify-order-form", h = (e) => ({
		firstName: e?.firstName,
		lastName: e?.lastName,
		company: e?.company,
		address1: e?.address1,
		address2: e?.address2,
		city: e?.city,
		provinceCode: e?.provinceCode,
		zip: e?.zip,
		countryCode: e?.countryCodeV2,
		phone: e?.phone
	}), b = {
		selectedProductId: void 0,
		lineItems: [],
		customNote: "",
		tags: e?.tags || [],
		billingAddress: h(e?.billingAddress ?? e?.shippingAddress),
		shippingAddress: h(e?.shippingAddress),
		financialStatus: void 0,
		fulfillmentStatus: void 0,
		discountCode: void 0
	}, x = xc({
		mode: "all",
		defaultValues: b
	}), S = x.watch("lineItems").length > 0, C = Ze(() => (e?.lineItems || []).map((e) => e.product?.id).filter((e) => !!e), [e]), w = Ze(() => _D(C), [C]), { data: T, loading: A, error: j } = c(YE, {
		skip: !w,
		variables: {
			query: w,
			productCount: C.length,
			mediaCount: 1
		}
	});
	U(() => {
		j && s({
			title: "Something went wrong",
			text: "Could not load products for this order.",
			icon: "exclamation-triangle-filled",
			severity: "warning"
		});
	}, [j, s]), U(() => {
		if (!n || A || !T || x.getValues("lineItems")?.length) return;
		let t = T?.Shopify?.products?.nodes || [], r = [];
		e?.lineItems?.forEach((e) => {
			let n = t.find((t) => t.id === e.product?.id);
			n && r.push({
				...n,
				quantity: e.quantity || 1,
				sku: e.sku,
				discountedUnitPrice: e.discountedUnitPriceSet?.shopMoney
			});
		}), r.length > 0 && x.setValue("lineItems", r, { shouldDirty: !0 });
	}, [
		n,
		T,
		A,
		e,
		x
	]), U(() => {
		(f.length > 0 || (x.getValues("tags") || []).length > 0) && x.setValue("tags", f, { shouldDirty: !0 });
	}, [f, x]);
	let M = $e(!1), P = () => {
		a(), d(!1), s({
			title: "Success",
			text: "The order was duplicated successfully.",
			icon: "check-circle-filled",
			severity: "success"
		}), l("shopify:order:duplicate:succeeded"), R();
	}, F = () => {
		a(), d(!1), s({
			title: "Order duplicated but not marked as paid",
			text: "The order was duplicated but recording the payment failed. You can mark it as paid in Shopify.",
			icon: "exclamation-triangle-filled",
			severity: "warning"
		}), R();
	}, I = () => {
		d(!1), s({
			title: "Something went wrong",
			text: "The order duplication was not successful.",
			icon: "exclamation-triangle-filled",
			severity: "warning"
		}), l("shopify:order:duplicate:failed"), R();
	}, [L] = o(aD, {
		onError: F,
		onCompleted: (e) => {
			let t = e.Shopify?.orderMarkAsPaid?.userErrors;
			if (t && t.length > 0) {
				F();
				return;
			}
			P();
		}
	}), [te, { error: ne }] = o(rD, {
		onError: I,
		onCompleted: (e) => {
			let t = e.Shopify?.orderCreate, n = t?.order?.id;
			if (t?.userErrors?.length || !n) {
				I();
				return;
			}
			if (M.current) {
				L({ variables: { input: { id: n } } });
				return;
			}
			P();
		}
	}), re = (t) => {
		let n = t.lineItems.map((e) => ({
			productId: e.id,
			requiresShipping: !0,
			priceSet: { shopMoney: {
				amount: e.discountedUnitPrice?.amount ?? e.priceRangeV2.maxVariantPrice.amount,
				currencyCode: e.discountedUnitPrice?.currencyCode ?? e.priceRangeV2.maxVariantPrice.currencyCode
			} },
			quantity: e.quantity,
			sku: e.sku
		})), i = (e?.shippingLines ?? []).map((e) => ({
			title: e.title,
			code: e.code,
			source: e.source,
			priceSet: { shopMoney: {
				amount: e.discountedPriceSet?.shopMoney?.amount ?? "0.00",
				currencyCode: e.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
			} }
		}));
		d(!0);
		let a = t.financialStatus === RE.Paid;
		M.current = a, te({ variables: { order: {
			customer: { toAssociate: { id: r } },
			lineItems: n,
			shippingLines: i,
			note: t.customNote,
			tags: t.tags,
			financialStatus: a ? void 0 : t.financialStatus,
			fulfillmentStatus: t.fulfillmentStatus,
			discountCode: aO(t.discountCode),
			shippingAddress: vD(t?.shippingAddress),
			billingAddress: vD(t?.billingAddress)
		} } });
	}, R = () => {
		x.reset(b), p(e?.tags || []), i(!1);
	};
	return /* @__PURE__ */ q(E, {
		isOpen: n,
		onClose: R,
		className: IO.modal,
		allowEscClose: !1,
		children: [
			/* @__PURE__ */ K(k, {
				title: `Duplicate order ${t}`,
				onClose: R
			}),
			/* @__PURE__ */ q(D, { children: [/* @__PURE__ */ K(ys, {
				...x,
				children: /* @__PURE__ */ K("form", {
					id: m,
					children: /* @__PURE__ */ q(y, { children: [
						/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(EO, { loading: A }) }),
						/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(Es, {
							name: "tags",
							render: ({ fieldState: { error: e } }) => /* @__PURE__ */ K(g, {
								label: "Tags",
								meta: { error: e?.message },
								children: /* @__PURE__ */ K("div", {
									tabIndex: 0,
									onKeyDown: (e) => {
										e.key === "Enter" && (e.preventDefault(), e.stopPropagation());
									},
									children: /* @__PURE__ */ K(ee, {
										placeholder: "Type and hit enter to add tags",
										selectedTags: f,
										onChange: (e) => {
											p(e);
										}
									}, `tags-input-${n}`)
								})
							})
						}) }),
						/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(cO, { enabled: n }) }),
						/* @__PURE__ */ K(v, {
							span: 4,
							children: /* @__PURE__ */ q(_, {
								flexDirection: "column",
								gap: "300",
								children: [
									/* @__PURE__ */ K(DO, { previousOrderStatus: e?.displayFinancialStatus }),
									/* @__PURE__ */ K(OO, {}),
									/* @__PURE__ */ K(jc, {
										label: "Custom note",
										name: "customNote",
										componentProps: {
											placeholder: "Enter custom note",
											tabIndex: 0
										}
									})
								]
							})
						}),
						/* @__PURE__ */ K(v, {
							span: 2,
							children: /* @__PURE__ */ K(g, {
								label: "Details",
								noAlert: !0,
								children: /* @__PURE__ */ K(_, {
									flexDirection: "column",
									gap: "200",
									justifyContent: "end",
									className: jD.boxWrapper,
									children: /* @__PURE__ */ K(vO, {})
								})
							})
						})
					] })
				})
			}), ne && /* @__PURE__ */ K(z, { error: ne })] }),
			/* @__PURE__ */ K(O, {
				confirmProps: {
					type: "submit",
					form: m,
					disabled: !S || u || A,
					isLoading: u || A,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 }),
					tabIndex: 0
				},
				confirmName: "Create order",
				confirmOnClick: x.handleSubmit(re)
			})
		]
	});
}, RO = { copyIcon: "_copyIcon_1dlzg_1" }, zO = ({ orderId: e, lineItems: t, refundedQuantities: n = {} }) => {
	let { isCopied: r, copy: i } = cD();
	if (!t || t?.length === 0) return null;
	let a = Object.values(n).some((e) => e > 0), o = t.every(({ id: e, quantity: t }) => (n[e] || 0) >= t), s = t.map(({ title: e, quantity: t, variantTitle: n }) => n ? `${t}x ${e} (${n})` : `${t}x ${e}`).join("\n");
	return /* @__PURE__ */ q(_, {
		gap: "100",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ q(_, {
				gap: "250",
				flexDirection: "row",
				justifyContent: "space-between",
				alignItems: "center",
				children: [/* @__PURE__ */ q(_, {
					gap: "250",
					flexDirection: "row",
					alignItems: "center",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "shopify",
						color: "green.500"
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "3",
						children: "Line items"
					})]
				}), /* @__PURE__ */ K(R, {
					content: "Copy line items",
					children: /* @__PURE__ */ K(b, {
						size: 14,
						name: r ? "done" : "copy",
						onClick: () => i(s),
						className: RO.copyIcon
					})
				})]
			}),
			a && /* @__PURE__ */ K(_, {
				gap: "100",
				flexDirection: "row",
				margin: "200 0 0",
				justifyContent: "center",
				children: /* @__PURE__ */ K(I, {
					color: "red.500",
					children: o ? "The order has been refunded" : "Order has refunded items"
				})
			}),
			/* @__PURE__ */ K(T, { children: t.map(({ id: t, title: r, quantity: i, variantTitle: a, image: o }) => {
				let s = n[t], c = s > 0, l = s > 1 ? `Refunded (${s} items)` : "Refunded";
				return /* @__PURE__ */ K(T.Item, {
					contentLeft: /* @__PURE__ */ q(_, {
						gap: "200",
						children: [/* @__PURE__ */ K(L.Paragraph, { children: i }), /* @__PURE__ */ K(L.Paragraph, { children: "×" })]
					}),
					title: /* @__PURE__ */ q(L.Paragraph, {
						variant: "4",
						children: [
							r,
							" ",
							a && `(${a})`,
							c && /* @__PURE__ */ K(L.Paragraph, {
								variant: "3",
								color: "red.500",
								children: l
							})
						]
					}),
					contentRight: o?.url && /* @__PURE__ */ K(S, {
						src: `${o?.url}&height=48`,
						alt: r
					})
				}, `list-${e}-${t}`);
			}) })
		]
	});
}, BO = lt`
  mutation refundLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, VO = (e) => {
	let t = [];
	return e.refunds.forEach((e) => {
		let n = e.refundLineItems.edges.filter((e) => e.node.id !== null);
		n.length > 0 && t.push({
			...e,
			refundLineItems: {
				...e.refundLineItems,
				edges: n
			}
		});
	}), t;
}, HO = (e) => {
	let t = {}, n = VO(e);
	return e.lineItems?.forEach((e) => {
		t[e.id] = 0;
	}), n.forEach((e) => {
		e.refundLineItems.edges.forEach((e) => {
			let n = e.node;
			if (n.id !== null) {
				let e = n.lineItem.id;
				t[e] += n.quantity;
			}
		});
	}), t;
}, UO = (e, t) => `${Number(e || 0).toFixed(2)} ${t}`, WO = "To restock items, the Dixa app must be re-authorised in Shopify. Please contact your admin", GO = ({ refund: e, currencyCode: t, refundShipping: n, onToggleShipping: r, isLoading: i = !1, restockItems: a, onToggleRestock: o, restockItemsLabel: s, restockDisabled: c = !1, canRestock: l }) => {
	let u = e?.currency || t, d = Number(e?.shipping.maximumRefundable || 0) > 0, f = d && n;
	return /* @__PURE__ */ q(_, {
		flexDirection: "column",
		gap: "300",
		children: [
			/* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					children: "Subtotal"
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					children: UO(e?.subtotal || "0", u)
				})]
			}),
			/* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					children: "Tax"
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					children: UO(e?.tax || "0", u)
				})]
			}),
			/* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				alignItems: "center",
				children: [/* @__PURE__ */ q(_, {
					alignItems: "center",
					gap: "200",
					children: [/* @__PURE__ */ K(P, {
						name: "refundShipping",
						value: "shipping",
						checked: f,
						disabled: !d || i,
						onChange: () => r(!n)
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						subdued: !f,
						children: "Refund shipping"
					})]
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					subdued: !f,
					children: UO(e?.shipping.amount || "0", u)
				})]
			}),
			/* @__PURE__ */ q(_, {
				alignItems: "center",
				gap: "200",
				children: [
					/* @__PURE__ */ K(P, {
						name: "restockItems",
						value: "restock",
						checked: l && a,
						disabled: c || !l,
						onChange: () => o(!a)
					}),
					/* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						subdued: !l || !a,
						children: s
					}),
					!l && /* @__PURE__ */ K(R, {
						content: WO,
						wrap: "span",
						children: /* @__PURE__ */ K("span", {
							"aria-label": WO,
							role: "img",
							children: /* @__PURE__ */ K(b, {
								name: "info",
								size: 16
							})
						})
					})
				]
			}),
			/* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "3",
					children: "Total refund"
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "3",
					children: UO(e?.amount || "0", u)
				})]
			})
		]
	});
}, KO = { modal: "_modal_1mprq_1" }, qO = "partial-refund-shopify-order-form", JO = ({ order: e, orderName: t, isOpen: n, setIsOpen: r, refetchOrders: i, canRestockOnRefund: a }) => {
	let { useMutation: o, showNotification: s } = V(), { track: c } = B(), { useQuery: l } = V(), [u, d] = W(!1), [f, p] = W([]), [m, h] = W(!1), [b, x] = W(!1), S = Ze(() => e?.refunds ? HO(e) : {}, [e]), C = Ze(() => (e?.lineItems || []).filter((e) => (S[e.id] || 0) >= (e.quantity || 0)).map((e) => e.product?.id).filter((e) => !!e), [e, S]), w = Ze(() => {
		let t = {};
		return (e?.lineItems || []).forEach((e) => {
			if (e.product?.id) {
				let n = S[e.id] || 0, r = Math.max(0, (e.quantity || 0) - n);
				t[e.product.id] = r;
			}
		}), t;
	}, [e, S]), T = Ze(() => (e?.lineItems || []).map((e) => e.product?.id).filter((e) => !!e), [e]), A = Ze(() => _D(T), [T]), { data: j, loading: M, error: P } = l(YE, {
		skip: !A,
		variables: {
			query: A,
			productCount: T.length,
			mediaCount: 1
		}
	});
	U(() => {
		P && s({
			title: "Something went wrong",
			text: "Could not load products for this order.",
			icon: "exclamation-triangle-filled",
			severity: "warning"
		});
	}, [P, s]);
	let F = {
		selectedProductId: void 0,
		lineItems: [],
		customNote: ""
	}, I = xc({
		mode: "all",
		defaultValues: F
	}), ee = f.length > 0;
	U(() => {
		ee || (m && h(!1), b && x(!1));
	}, [
		ee,
		m,
		b
	]);
	let L = ws({
		control: I.control,
		name: "lineItems"
	}), te = Ze(() => (L || []).filter((e) => f.includes(e.id)).map((t) => {
		let n = e?.lineItems?.find((e) => e.product?.id === t.id), r = S[n?.id || ""] || 0, i = (n?.quantity || 0) - r, a = Math.max(0, Math.min(i, t.quantity || 0));
		return n && a > 0 ? {
			lineItemId: n.id,
			quantity: a
		} : void 0;
	}).filter((e) => !!e), [
		L,
		f,
		e,
		S
	]), { suggestedRefund: ne, isLoading: re, error: R } = xD({
		orderId: e.id,
		refundShipping: m,
		canReadLocations: a,
		refundLineItems: te,
		skip: !ee
	}), { suggestedRefund: ie, isLoading: ae, error: oe } = xD({
		orderId: e.id,
		refundShipping: !1,
		suggestFullRefund: !0,
		skip: !n || !b,
		canReadLocations: a
	}), [se, { error: ce }] = o(BO, {
		onError: () => {
			s({
				title: "Something went wrong",
				text: "The partial refund was not successful.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), c("shopify:order:partial:refund:failed"), ue();
		},
		onCompleted: () => {
			i(), s({
				title: "Success",
				text: "The partial refund was created successfully.",
				icon: "check-circle-filled",
				severity: "success"
			}), c("shopify:order:partial:refund:succeeded"), ue();
		}
	});
	U(() => {
		if (!n || M || !j || I.getValues("lineItems")?.length) return;
		let t = j?.Shopify?.products?.nodes || [], r = [];
		e?.lineItems?.forEach((e) => {
			let n = t.find((t) => t.id === e.product?.id);
			if (n) {
				let t = S[e.id] || 0, i = (e.quantity || 1) - t;
				r.push({
					...n,
					quantity: i > 0 ? i : e.quantity || 1
				});
			}
		}), r.length > 0 && (I.setValue("lineItems", r, { shouldDirty: !0 }), p([]));
	}, [
		n,
		j,
		M,
		e,
		I,
		S
	]);
	let le = (t) => {
		d(!0), se({ variables: { input: uD({
			orderId: e.id,
			transactions: ne?.transactions,
			refundLineItems: dD({
				refundLineItems: fD({
					selectedLineItems: te,
					restockSource: ie?.refundLineItems ?? []
				}),
				restock: a && b
			}),
			refundShipping: m,
			note: t.customNote || void 0,
			notify: !0
		}) } });
	}, ue = () => {
		I.reset(F), d(!1), x(!1), r(!1);
	}, de = te.length > 1 ? "Restock selected items" : "Restock selected item", fe = ce ?? R ?? oe;
	return /* @__PURE__ */ q(E, {
		isOpen: n,
		onClose: ue,
		className: KO.modal,
		children: [
			/* @__PURE__ */ K(k, {
				title: `Refund order ${t}`,
				onClose: ue
			}),
			/* @__PURE__ */ q(D, { children: [/* @__PURE__ */ K(ys, {
				...I,
				children: /* @__PURE__ */ K("form", {
					id: qO,
					children: /* @__PURE__ */ q(y, { children: [
						/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(EO, {
							loading: M,
							selectionMode: !0,
							hideDeleteButton: !0,
							hideProductSelect: !0,
							selectedProductIds: f,
							disabledProductIds: C,
							maxQuantities: w,
							onToggleSelect: (e, t) => {
								p((n) => t ? Array.from(/* @__PURE__ */ new Set([...n, e])) : n.filter((t) => t !== e));
							},
							onToggleSelectAll: (e) => {
								let t = (I.getValues("lineItems") || []).map((e) => e.id).filter((e) => !C.includes(e));
								p(e ? t : []);
							}
						}) }),
						/* @__PURE__ */ K(v, {
							span: 4,
							children: /* @__PURE__ */ K(_, {
								flexDirection: "column",
								gap: "300",
								children: /* @__PURE__ */ K(jc, {
									label: "Custom note",
									name: "customNote",
									componentProps: {
										placeholder: "Enter custom note (optional)",
										tabIndex: 0
									}
								})
							})
						}),
						/* @__PURE__ */ K(v, {
							span: 2,
							children: /* @__PURE__ */ K(g, {
								label: "Details",
								noAlert: !0,
								children: /* @__PURE__ */ K(_, {
									flexDirection: "column",
									gap: "200",
									justifyContent: "end",
									className: jD.boxWrapper,
									children: /* @__PURE__ */ K(GO, {
										refund: ne,
										currencyCode: e.currencyCode,
										refundShipping: m,
										onToggleShipping: h,
										isLoading: re,
										restockItems: b,
										onToggleRestock: x,
										restockItemsLabel: de,
										restockDisabled: !ee || re || u,
										canRestock: a
									})
								})
							})
						})
					] })
				})
			}), fe && /* @__PURE__ */ K(z, { error: fe })] }),
			/* @__PURE__ */ K(O, {
				confirmProps: {
					type: "submit",
					form: qO,
					disabled: !ee || u || M || re || !ne || b && (ae || !ie),
					isLoading: u || M,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 }),
					tabIndex: 0
				},
				confirmName: "Refund selected",
				confirmOnClick: I.handleSubmit(le)
			})
		]
	});
}, YO = { modal: "_modal_al73g_1" }, XO = ({ order: e, shopifyId: t, orderLink: n, isOpen: r, setIsOpen: i, refetchOrders: a, canRestockOnRefund: o }) => {
	let { useMutation: s, showNotification: c } = V(), { track: l } = B(), { id: u, name: d, currencyCode: f } = e, [p, m] = W(!0), [h, g] = W(!1), [v, y] = W(), { suggestedRefund: x, isLoading: S, error: C } = xD({
		orderId: u,
		suggestFullRefund: !0,
		refundShipping: p,
		skip: !r,
		canReadLocations: o
	}), [w, { loading: T }] = s(QE, {
		onError: (e) => y(e),
		onCompleted: (e) => {
			let t = e.Shopify?.refundCreate?.userErrors;
			if (t && t.length > 0) {
				y(new nt({ graphQLErrors: t.map((e) => ({ message: e.message })) }));
				return;
			}
			c({
				title: "Order refunded",
				text: `You refunded order ${d}`,
				icon: "check-circle-filled",
				severity: "success"
			}), a(), j();
		}
	}), j = () => {
		m(!0), g(!1), y(void 0), i(!1);
	}, M = () => {
		x && (l("shopify:order:refund:confirmed", {
			shopifyId: t,
			orderId: u
		}), w({ variables: { input: uD({
			orderId: u,
			transactions: x.transactions,
			refundLineItems: dD({
				refundLineItems: x.refundLineItems,
				restock: o && h
			}),
			refundShipping: p,
			notify: e.suggestedRefund.notify
		}) } }));
	}, P = (x?.refundLineItems.length ?? 0) > 1 ? "Restock items" : "Restock item", F = v ?? C;
	return /* @__PURE__ */ q(E, {
		isOpen: r,
		onClose: j,
		className: YO.modal,
		children: [
			/* @__PURE__ */ K(k, {
				title: `Refund order ${d}`,
				onClose: j
			}),
			/* @__PURE__ */ K(D, { children: /* @__PURE__ */ q(_, {
				flexDirection: "column",
				gap: "300",
				children: [/* @__PURE__ */ K(GO, {
					refund: x,
					currencyCode: f,
					refundShipping: p,
					onToggleShipping: m,
					isLoading: S,
					restockItems: h,
					onToggleRestock: g,
					restockItemsLabel: P,
					restockDisabled: S || T,
					canRestock: o
				}), F && /* @__PURE__ */ q(_, {
					flexDirection: "column",
					children: [/* @__PURE__ */ K(z, { error: F }), /* @__PURE__ */ K(A, {
						variant: "secondary",
						style: {
							color: "var(--dixa-typography-color-link)",
							padding: "var(--dixa-size-spacer-100)"
						},
						navigate: () => window.open(n, "_blank")?.focus(),
						slotStart: /* @__PURE__ */ K(b, { name: "external-link" }),
						children: "View order in Shopify"
					})]
				})]
			}) }),
			/* @__PURE__ */ K(O, {
				confirmProps: {
					disabled: !x || S || T,
					isLoading: T || S,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 }),
					tabIndex: 0
				},
				confirmName: "Confirm order refund",
				confirmOnClick: M
			})
		]
	});
}, ZO = ({ order: e, shopifyId: t, orderLink: n, refetchOrders: r, canRestockOnRefund: i }) => {
	let { showModal: o } = V(), { track: s } = B(), { suggestedRefund: c, id: l } = e, [u, d] = W(!1), f = parseFloat(String(c?.amount)), p = !isNaN(f) && f > 0;
	return /* @__PURE__ */ q(_, {
		width: "100%",
		children: [/* @__PURE__ */ K(a, {
			variant: "secondary",
			onClick: Je(() => {
				s("shopify:order:refund:requested", {
					shopifyId: t,
					orderId: l
				}), p ? d(!0) : o({
					headline: `Refund Order ${e.name}`,
					children: /* @__PURE__ */ K(L.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
					confirmLabel: "Close",
					confirmVariant: "secondary",
					onConfirm: () => {}
				});
			}, [
				t,
				l,
				e.name,
				p,
				o,
				s
			]),
			disabled: c?.refundLineItems?.length === 0 || !p,
			slotStart: /* @__PURE__ */ K(b, {
				size: 14,
				name: "undo"
			}),
			className: jD.fullWidth,
			children: "Full refund"
		}), /* @__PURE__ */ K(XO, {
			order: e,
			shopifyId: t,
			orderLink: n,
			isOpen: u,
			setIsOpen: d,
			refetchOrders: r,
			canRestockOnRefund: i
		})]
	});
}, QO = { modal: "_modal_al73g_1" }, $O = ({ orderId: e, tags: t, isOpen: n, setIsOpen: r, refetchOrders: i }) => {
	let { track: a } = B(), { useMutation: o, showNotification: s } = V(), [c, l] = W(t), [u, d] = W(!1), f = xc({ defaultValues: { tags: t } });
	U(() => {
		c && f.setValue("tags", c, { shouldDirty: !0 });
	}, [c]);
	let [p, { error: m, reset: h }] = o(eD, {
		onError: () => {
			d(!1), s({
				title: "Something went wrong",
				text: "The tags change was not successful.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), r(!1);
		},
		onCompleted: async () => {
			await i(), d(!1), s({
				title: "Success",
				text: "The tags change was successful.",
				icon: "check-circle-filled",
				severity: "success"
			}), a("shopify:order:tags:updated"), r(!1);
		}
	}), _ = Je((t) => {
		d(!0), p({ variables: { input: {
			id: e,
			tags: t.tags
		} } }).then((e) => {
			let n = e.data?.Shopify?.orderUpdate?.order?.tags ?? t.tags;
			f.reset({ tags: n });
		});
	}, [
		e,
		f,
		p
	]), b = () => {
		r(!1), h();
	};
	return /* @__PURE__ */ q(E, {
		isOpen: n,
		onClose: b,
		className: QO.modal,
		children: [
			/* @__PURE__ */ K(k, {
				title: "Manage tags for order",
				onClose: b
			}),
			/* @__PURE__ */ q(D, { children: [/* @__PURE__ */ K(y, { children: /* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(Es, {
				control: f.control,
				name: "tags",
				render: ({ fieldState: { error: e } }) => /* @__PURE__ */ K(g, {
					label: "Tags",
					meta: { error: e?.message },
					children: /* @__PURE__ */ K(ee, {
						placeholder: "Add tags here",
						selectedTags: t,
						onChange: (e) => l(e)
					})
				})
			}) }) }), m && /* @__PURE__ */ K(z, { error: m })] }),
			/* @__PURE__ */ K(O, {
				confirmProps: {
					disabled: !(f.formState.isValid && f.formState.isDirty),
					isLoading: u,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 })
				},
				confirmOnClick: f.handleSubmit(_),
				cancelOnClick: b,
				confirmName: m ? "Close" : "Save",
				cancelName: m ? void 0 : "Cancel"
			})
		]
	});
}, ek = {
	editIcon: "_editIcon_1yp2k_1",
	copyIcon: "_copyIcon_1yp2k_2"
}, tk = ({ orderId: e, tags: t, refetchOrders: r }) => {
	let [i, a] = W(!1), { isCopied: o, copy: s } = cD(), c = t.length > 0;
	return /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ q(_, {
		justifyContent: "space-between",
		children: [/* @__PURE__ */ q(_, {
			gap: "250",
			flexDirection: "row",
			children: [/* @__PURE__ */ K(b, {
				size: 14,
				name: "tag",
				color: "green.500"
			}), /* @__PURE__ */ q(_, {
				gap: "200",
				flexDirection: "column",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "3",
					children: "Tags"
				}), /* @__PURE__ */ q(_, {
					gap: "100",
					flexDirection: "row",
					flexWrap: "wrap",
					children: [!c && /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						color: "tertiary",
						children: "No tags here yet"
					}), c && t.map((e, t) => /* @__PURE__ */ K(n, {
						size: "small",
						variant: "primary",
						children: e
					}, t))]
				})]
			})]
		}), /* @__PURE__ */ q(_, {
			gap: "250",
			flexDirection: "row",
			children: [/* @__PURE__ */ K(R, {
				content: "Edit tags",
				children: /* @__PURE__ */ K(b, {
					size: 14,
					name: "pen",
					className: ek.editIcon,
					onClick: () => a(!0)
				})
			}), c && /* @__PURE__ */ K(R, {
				content: "Copy tags",
				children: /* @__PURE__ */ K(b, {
					size: 14,
					name: o ? "done" : "copy",
					className: ek.copyIcon,
					onClick: () => s(t.join(", "))
				})
			})]
		})]
	}), /* @__PURE__ */ K($O, {
		orderId: e,
		tags: t,
		isOpen: i,
		setIsOpen: a,
		refetchOrders: r
	})] });
}, nk = {
	icon: "_icon_cddi1_1",
	link: "_link_cddi1_6"
}, rk = ({ trackingInfo: e }) => {
	let { isCopied: t, copy: n } = cD(), { company: r, number: i, url: a } = e;
	return /* @__PURE__ */ K(T.Item, {
		contentLeft: /* @__PURE__ */ K(L.Paragraph, {
			variant: "3",
			children: i
		}),
		title: /* @__PURE__ */ K(L.ExternalLink, {
			href: a,
			target: "_blank",
			rel: "noreferrer",
			className: nk.link,
			children: r
		}),
		contentRight: i && /* @__PURE__ */ K(R, {
			content: "Copy tracking code",
			children: /* @__PURE__ */ K(b, {
				size: 14,
				name: t ? "done" : "copy",
				onClick: () => n(i.toString()),
				className: nk.icon
			})
		})
	});
}, ik = ({ trackingInfos: e }) => !e || e?.length === 0 ? null : /* @__PURE__ */ q(_, {
	gap: "200",
	flexDirection: "column",
	children: [/* @__PURE__ */ q(_, {
		gap: "250",
		flexDirection: "row",
		children: [/* @__PURE__ */ K(b, {
			size: 14,
			name: "eye",
			color: "green.500"
		}), /* @__PURE__ */ K(L.Paragraph, {
			variant: "3",
			children: "Tracking"
		})]
	}), /* @__PURE__ */ K(T, { children: e.map((e) => /* @__PURE__ */ K(rk, { trackingInfo: e }, e.number)) })]
}), ak = {
	copyIcon: "_copyIcon_u5m0p_1",
	strikethrough: "_strikethrough_u5m0p_6",
	order: "_order_u5m0p_10",
	orderIsOpen: "_orderIsOpen_u5m0p_18",
	orderHeader: "_orderHeader_u5m0p_21"
}, ok = ({ order: e, shopifyId: t, openByDefault: n, customerCountryCodes: r, enableEditShippingAddress: i, displayRefund: o, displayCancel: s, shopifyDomain: c, displayDuplicateOrder: l, displayPartialRefundOrder: u, canRestockOnRefund: d, refetchOrders: f }) => {
	let { track: p } = B(), { isCopied: m, copy: h } = cD(), { isCopied: g, copy: v } = cD(), { isCopied: y, copy: S } = cD(), [C, w] = W(!1), [T, E] = W(!1), [D, O] = W(n), { id: k, name: j, createdAt: M, status: N, currentTotalPriceSet: P, currencyCode: F, lineItems: I, billingAddress: ee, shippingAddress: te, trackingInfos: ne, tags: re, discountCodes: ie, currentTotalDiscountsSet: z } = e, oe = !!te, se = `https://${c}/admin/orders/${LD(k) ?? ""}`, ce = P?.shopMoney?.amount ?? 0, le = N.includes("cancelled"), ue = (e) => new Intl.NumberFormat(void 0, {
		style: "currency",
		currency: F
	}).format(e), de = Number(z?.shopMoney?.amount ?? 0), fe = de > 0, pe = ie?.join(", ") ?? "", me = ue(Number(ce)), he = ue(Number(ce) + de), ge = e?.refunds ? HO(e) : {}, _e = !!I?.length && I.every((e) => (ge[e.id] || 0) >= (e.quantity || 0));
	return /* @__PURE__ */ q(_, {
		className: ae(ak.order, { [ak.orderIsOpen]: D }),
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				alignItems: "center",
				className: ak.orderHeader,
				onClick: () => O(!D),
				children: [/* @__PURE__ */ q(_, {
					gap: "100",
					flexDirection: "column",
					children: [M && /* @__PURE__ */ K(_, {
						alignItems: "center",
						children: /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: KD(M).format("DD MMM YYYY @ HH:mm")
						})
					}), /* @__PURE__ */ q(L.Paragraph, {
						variant: "1",
						children: ["Order ", j]
					})]
				}), /* @__PURE__ */ K(x, {
					variant: "tertiary",
					icon: D ? "angle-down" : "angle-right"
				})]
			}),
			D && /* @__PURE__ */ q(_, {
				gap: "250",
				flexDirection: "column",
				margin: "200 0 0",
				children: [
					/* @__PURE__ */ q(_, {
						gap: "250",
						flexDirection: "row",
						justifyContent: "space-between",
						alignItems: "flex-start",
						children: [/* @__PURE__ */ q(_, {
							gap: "250",
							flexDirection: "row",
							alignItems: "flex-start",
							children: [/* @__PURE__ */ K(b, {
								size: 14,
								name: "info",
								color: "green.500"
							}), /* @__PURE__ */ q(_, {
								gap: "200",
								flexDirection: "column",
								children: [/* @__PURE__ */ K(L.Paragraph, {
									variant: "3",
									children: "Order number"
								}), /* @__PURE__ */ K(L.Paragraph, {
									variant: "4",
									children: j.replace("#", "")
								})]
							})]
						}), /* @__PURE__ */ K(R, {
							content: "Copy order number",
							children: /* @__PURE__ */ K(b, {
								size: 14,
								name: m ? "done" : "copy",
								onClick: () => h(j.replace("#", "")),
								className: ak.copyIcon
							})
						})]
					}),
					/* @__PURE__ */ q(_, {
						gap: "250",
						flexDirection: "row",
						justifyContent: "space-between",
						alignItems: "flex-start",
						children: [/* @__PURE__ */ q(_, {
							gap: "250",
							flexDirection: "row",
							alignItems: "flex-start",
							children: [/* @__PURE__ */ K(b, {
								size: 14,
								name: "activity",
								color: "green.500"
							}), /* @__PURE__ */ q(_, {
								gap: "200",
								flexDirection: "column",
								children: [/* @__PURE__ */ K(L.Paragraph, {
									variant: "3",
									children: "Order status"
								}), /* @__PURE__ */ K(L.Paragraph, {
									variant: "4",
									children: N
								})]
							})]
						}), /* @__PURE__ */ K(R, {
							content: "Copy order status",
							children: /* @__PURE__ */ K(b, {
								size: 14,
								name: y ? "done" : "copy",
								onClick: () => S(N),
								className: ak.copyIcon
							})
						})]
					}),
					/* @__PURE__ */ q(_, {
						gap: "250",
						flexDirection: "row",
						justifyContent: "space-between",
						alignItems: "flex-start",
						children: [/* @__PURE__ */ q(_, {
							gap: "250",
							flexDirection: "row",
							alignItems: "flex-start",
							children: [/* @__PURE__ */ K(b, {
								size: 14,
								name: "chart-bar",
								color: "green.500"
							}), /* @__PURE__ */ q(_, {
								gap: "200",
								flexDirection: "column",
								children: [
									/* @__PURE__ */ K(L.Paragraph, {
										variant: "3",
										children: "Order value"
									}),
									fe && /* @__PURE__ */ K(L.Paragraph, {
										variant: "4",
										className: ak.strikethrough,
										children: he
									}),
									/* @__PURE__ */ q(_, {
										gap: "200",
										flexDirection: "row",
										alignItems: "center",
										children: [/* @__PURE__ */ K(L.Paragraph, {
											variant: "4",
											children: me
										}), pe && /* @__PURE__ */ q(L.Paragraph, {
											variant: "4",
											color: "tertiary",
											children: [
												"(",
												pe,
												")"
											]
										})]
									})
								]
							})]
						}), /* @__PURE__ */ K(R, {
							content: "Copy order value",
							children: /* @__PURE__ */ K(b, {
								size: 14,
								name: g ? "done" : "copy",
								onClick: () => v(ce),
								className: ak.copyIcon
							})
						})]
					}),
					/* @__PURE__ */ K(tk, {
						orderId: k,
						tags: re,
						refetchOrders: f
					}),
					/* @__PURE__ */ K(_O, {
						openByDefault: !oe,
						labelText: "Billing address",
						address: ee,
						shippingCountryCodes: r,
						refetchOrders: f
					}),
					/* @__PURE__ */ K(_O, {
						openByDefault: oe,
						shopifyId: t,
						orderId: k,
						icon: "map-pin",
						labelText: "Shipping address",
						address: te,
						shippingCountryCodes: r,
						enableEditAddress: i,
						refetchOrders: f
					}),
					/* @__PURE__ */ K(zO, {
						orderId: k,
						lineItems: I,
						refundedQuantities: ge
					}),
					/* @__PURE__ */ K(ik, { trackingInfos: ne }),
					(o || u) && /* @__PURE__ */ q(_, {
						flexDirection: "row",
						gap: "200",
						children: [o && /* @__PURE__ */ K(ZO, {
							order: e,
							shopifyId: t,
							refetchOrders: f,
							orderLink: se,
							canRestockOnRefund: d
						}), u && /* @__PURE__ */ K(_, {
							width: "100%",
							children: /* @__PURE__ */ K(a, {
								variant: "secondary",
								icon: "undo",
								onClick: () => E(!0),
								className: jD.fullWidth,
								disabled: le || _e,
								children: "Partial refund"
							})
						})]
					}),
					(l || s) && /* @__PURE__ */ q(_, {
						flexDirection: "row",
						gap: "200",
						children: [l && /* @__PURE__ */ K(_, {
							width: "100%",
							children: /* @__PURE__ */ K(a, {
								variant: "secondary",
								icon: "plus",
								onClick: () => w(!0),
								className: jD.fullWidth,
								children: "Duplicate"
							})
						}), s && /* @__PURE__ */ K(FO, {
							orderId: k,
							orderName: j,
							disabled: le,
							refetchOrders: f
						})]
					}),
					/* @__PURE__ */ K(A, {
						variant: "secondary",
						style: {
							color: "var(--dixa-typography-color-link)",
							padding: "var(--dixa-size-spacer-100)"
						},
						navigate: () => window.open(se, "_blank")?.focus(),
						slotStart: /* @__PURE__ */ K(b, { name: "external-link" }),
						onClick: () => p("shopify:view:order:clicked", {
							shopifyId: t,
							orderId: k
						}),
						children: "View order in Shopify"
					})
				]
			}),
			C && /* @__PURE__ */ K(LO, {
				order: e,
				shopifyId: t,
				orderName: j,
				isOpen: C,
				setIsOpen: w,
				refetchOrders: f
			}),
			T && /* @__PURE__ */ K(JO, {
				order: e,
				orderName: j,
				isOpen: T,
				setIsOpen: E,
				canRestockOnRefund: d,
				refetchOrders: () => {
					f();
				}
			})
		]
	});
}, sk = ({ customerCountryCodes: e, shopifyDomain: t, displayRefund: r, displayCancel: i, displayCreateOrder: o, displayCreateDraftOrder: s, displayDuplicateOrder: c, displayPartialRefundOrder: l, enableEditShippingAddress: u, shopifyCustomer: d, canRestockOnRefund: f }) => {
	let { track: p } = B(), [m, h] = W([]), [g, v] = W(!1), y = LD(d?.id), x = `https://${t}/admin/orders?customer_id=${y ?? ""}`, { getCustomerOrders: S, isCustomerOrdersLoading: C, customerOrdersError: w, customerOrders: T, refetchCustomerOrders: E } = sD();
	return U(() => {
		!C && y && S({ variables: { query: `customer_id:${y}` } });
	}, [y]), U(() => {
		let e = T?.Shopify?.orders?.edges;
		e && h(mD({ ordersData: e }));
	}, [T]), d ? w ? /* @__PURE__ */ K(z, { error: w }) : /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ q(_, {
				gap: "200",
				flexDirection: "row",
				alignItems: "center",
				children: [/* @__PURE__ */ K(L.Heading, {
					variant: "heading-3",
					children: "Customer orders"
				}), !C && /* @__PURE__ */ K(n, {
					variant: "success",
					size: "small",
					children: m.length
				})]
			}),
			o && /* @__PURE__ */ K(a, {
				variant: "secondary",
				icon: "plus",
				onClick: () => v(!0),
				children: "Create new order"
			}),
			/* @__PURE__ */ q(_, {
				gap: "200",
				flexDirection: "column",
				children: [
					C && /* @__PURE__ */ K(_, {
						justifyContent: "center",
						margin: "300",
						children: /* @__PURE__ */ K(N, {})
					}),
					!C && m.length === 0 && /* @__PURE__ */ K(_, {
						justifyContent: "center",
						margin: "200 0 300 0",
						children: /* @__PURE__ */ K(L.Paragraph, {
							color: "tertiary",
							children: "No orders found"
						})
					}),
					!C && m.length > 0 && /* @__PURE__ */ K(_, {
						gap: "200",
						flexDirection: "column",
						children: m.map((n, a) => /* @__PURE__ */ K(ok, {
							order: n,
							openByDefault: a === 0,
							shopifyId: d?.id,
							displayRefund: r,
							displayCancel: i,
							enableEditShippingAddress: u,
							customerCountryCodes: e,
							refetchOrders: E,
							shopifyDomain: t,
							displayDuplicateOrder: c,
							displayPartialRefundOrder: l,
							canRestockOnRefund: f
						}, `${a}-${n.id}`))
					}),
					/* @__PURE__ */ K(A, {
						variant: "secondary",
						style: {
							color: "var(--dixa-typography-color-link)",
							padding: "var(--dixa-size-spacer-100)"
						},
						navigate: () => window.open(x, "_blank")?.focus(),
						slotStart: /* @__PURE__ */ K(b, { name: "external-link" }),
						onClick: () => p("shopify:view:all:orders:clicked", { shopifyId: d?.id }),
						children: "View all orders in Shopify"
					})
				]
			}),
			o && /* @__PURE__ */ K(jO, {
				isOpen: g,
				setIsOpen: v,
				shopifyCustomer: d,
				refetchCustomerOrders: E,
				displayCreateDraftOrder: s
			})
		]
	}) : null;
}, ck = ({ totalOrders: e, amountSpent: t }) => {
	let n = t?.amount ?? 0, r = t?.currencyCode ?? "", i = `${Number.parseFloat(n).toFixed(2)} ${r}`;
	return /* @__PURE__ */ K(G, { children: /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(L.Heading, {
			variant: "heading-3",
			children: "Orders overview"
		}), /* @__PURE__ */ q(T, {
			className: jD.list,
			children: [/* @__PURE__ */ K(T.Text, {
				variant: "dense",
				className: jD.listItem,
				children: /* @__PURE__ */ q(_, {
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: "Total orders"
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: e
					})]
				})
			}), /* @__PURE__ */ K(T.Text, {
				variant: "dense",
				className: jD.listItem,
				children: /* @__PURE__ */ q(_, {
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: "Total revenue"
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: i
					})]
				})
			})]
		})]
	}) });
}, lk = { segmentName: "_segmentName_1dkhk_1" }, uk = 100, dk = 10, fk = ({ shopifyId: e }) => {
	let { useQuery: t, useLazyQuery: r } = V(), [i, o] = W([]), [s, c] = W(dk), [l, u] = W(!1), d = Ze(() => i.filter((e) => e.isMember).length, [i]), { loading: f, error: p } = t(qE, {
		skip: !e,
		variables: { first: uk },
		onCompleted: (t) => {
			let n = t?.Shopify?.segments?.edges;
			if (n && n.length > 0) {
				let t = n.map(({ node: e }) => ({
					...e,
					isMember: !1
				})).sort((e, t) => e.name.localeCompare(t.name));
				o(t), m({ variables: {
					customerId: e,
					segmentIds: t.map((e) => e.id)
				} });
			}
		}
	}), [m, { loading: h, error: g }] = r(JE, { onCompleted: (e) => {
		let t = e?.Shopify?.customerSegmentMembership?.memberships;
		if (t && t.length > 0) {
			let e = i.map((e) => {
				let n = t.find((t) => t.segmentId === e.id);
				return {
					...e,
					...n?.isMember && { isMember: n.isMember }
				};
			}).sort((e, t) => e.isMember === t.isMember ? 0 : e.isMember ? -1 : 1);
			o(e);
		}
	} });
	return U(() => {
		c(l ? i.length : dk);
	}, [l]), e ? /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ q(_, {
				gap: "200",
				flexDirection: "row",
				alignItems: "center",
				children: [/* @__PURE__ */ K(L.Heading, {
					variant: "heading-3",
					children: "Segment membership"
				}), !f && /* @__PURE__ */ K(n, {
					variant: "success",
					size: "small",
					children: d
				})]
			}),
			f && /* @__PURE__ */ K(_, {
				justifyContent: "center",
				margin: "300",
				children: /* @__PURE__ */ K(N, {})
			}),
			!f && i.length === 0 && /* @__PURE__ */ K(L.Paragraph, {
				color: "tertiary",
				margin: "200 0 300 0",
				align: "center",
				children: "No segments found"
			}),
			p && /* @__PURE__ */ K(z, { error: p }),
			g && /* @__PURE__ */ K(z, { error: g }),
			!f && i.length > 0 && /* @__PURE__ */ q(T, {
				className: jD.list,
				children: [i.slice(0, s).map(({ id: e, name: t, isMember: n }) => /* @__PURE__ */ K(T.Text, {
					className: jD.listItem,
					children: /* @__PURE__ */ K(R, {
						content: `${n ? "Member of" : "Not a member of"} ${t}`,
						children: /* @__PURE__ */ q(_, {
							justifyContent: "space-between",
							children: [
								/* @__PURE__ */ K(L.Paragraph, {
									variant: "4",
									className: lk.segmentName,
									children: t
								}),
								h && /* @__PURE__ */ K(N, { size: 12 }),
								!h && /* @__PURE__ */ K(_, { children: /* @__PURE__ */ K(b, {
									color: n ? "green.500" : "neutral.300",
									name: "shopify"
								}) })
							]
						})
					})
				}, e)), i.length > dk && /* @__PURE__ */ K(_, {
					justifyContent: "center",
					margin: "200 0 0",
					children: /* @__PURE__ */ K(a, {
						variant: "secondary",
						onClick: () => u(!l),
						icon: l ? "angle-up" : "angle-down",
						children: l ? "Show less" : `Show ${i.length - dk} more`
					})
				})]
			})
		]
	}) : null;
}, pk = ({ conversationContext: e, settings: t }) => {
	let [n, r] = W(!1);
	U(() => {
		r(!1);
	}, [e.customer?.phone_number, e.customer?.email]);
	let { isCustomerLoading: i, customerError: a, customerData: o, refetchCustomer: s, customerNetworkStatus: c } = oD({
		conversationContext: e,
		forcePhoneLookup: n
	}), [l, u] = W(), [d, f] = W([]), p = t.apiHostName, m = t.displayRefundOrder ?? !1, h = t.displayCancelOrder ?? !1, g = t.enableEditShippingAddress ?? !1, v = t.displayEmailMarketingConsent ?? !1, y = t.displayOrdersOverview ?? !1, x = t.displaySegmentMembership ?? !1, S = t.displayDiscountCodeCreation ?? !1, C = t.displayDiscountCodes ?? !1, w = t.displayCreateOrder ?? !1, T = t.displayDuplicateOrder ?? !1, E = t.displayCreateDraftOrder ?? !1, D = t.displayPartialRefundOrder ?? !1, O = pD(o?.Shopify?.currentAppInstallation?.accessScopes.map(({ handle: e }) => e));
	if (U(() => {
		let t = o?.Shopify?.customers?.edges[0]?.node, a = !!e.customer?.phone_number && !!e.customer?.email;
		t && !i ? (f(o?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []), u(t)) : !t && !i && a && !n ? r(!0) : u(void 0);
	}, [o, e]), !i && a) return /* @__PURE__ */ K(z, {
		error: a,
		retry: s
	});
	if (!i && !a && !l) {
		let t = `https://${p}/admin/customers?search=${e.customer?.name || ""}`;
		return /* @__PURE__ */ q(_, {
			margin: "200 0 300",
			gap: "300",
			flexDirection: "column",
			"data-testid": "widget-customer-not-found",
			children: [/* @__PURE__ */ K(L.Paragraph, {
				color: "secondary",
				children: "We cannot find the customer in Shopify."
			}), /* @__PURE__ */ q(_, {
				gap: "200",
				flexDirection: "column",
				children: [/* @__PURE__ */ K(ID, {
					refetchCustomer: s,
					conversationContext: e
				}), /* @__PURE__ */ K(A, {
					variant: "secondary",
					style: {
						color: "var(--dixa-typography-color-link)",
						padding: "var(--dixa-size-spacer-100)"
					},
					navigate: () => window.open(t, "_blank")?.focus(),
					slotStart: /* @__PURE__ */ K(b, { name: "external-link" }),
					children: "Search customers in Shopify"
				})]
			})]
		});
	}
	return i && c !== ot.refetch ? /* @__PURE__ */ K(_, {
		margin: "200 0 300",
		justifyContent: "center",
		children: /* @__PURE__ */ K(N, {})
	}) : /* @__PURE__ */ q(_, {
		gap: "300",
		flexDirection: "column",
		margin: "200 0 300",
		"data-testid": "widget-wrapper",
		children: [
			/* @__PURE__ */ K(zD, {
				customer: l,
				shopifyDomain: p,
				refresh: s,
				loading: i,
				networkStatus: c
			}),
			y && /* @__PURE__ */ K(ck, {
				totalOrders: l?.numberOfOrders,
				amountSpent: l?.amountSpent
			}),
			x && /* @__PURE__ */ K(fk, { shopifyId: l?.id }),
			v && /* @__PURE__ */ K(nO, { customer: l }),
			C && /* @__PURE__ */ K(tO, { displayDiscountCodeCreation: S }),
			/* @__PURE__ */ K(sk, {
				shopifyCustomer: l,
				shopifyDomain: p,
				displayRefund: m,
				displayCancel: h,
				displayCreateOrder: w,
				displayCreateDraftOrder: E,
				enableEditShippingAddress: g,
				customerCountryCodes: d,
				displayDuplicateOrder: T,
				displayPartialRefundOrder: D,
				canRestockOnRefund: O
			})
		]
	});
}, mk = [];
for (let e = 0; e < 256; ++e) mk.push((e + 256).toString(16).slice(1));
function hk(e, t = 0) {
	return (mk[e[t + 0]] + mk[e[t + 1]] + mk[e[t + 2]] + mk[e[t + 3]] + "-" + mk[e[t + 4]] + mk[e[t + 5]] + "-" + mk[e[t + 6]] + mk[e[t + 7]] + "-" + mk[e[t + 8]] + mk[e[t + 9]] + "-" + mk[e[t + 10]] + mk[e[t + 11]] + mk[e[t + 12]] + mk[e[t + 13]] + mk[e[t + 14]] + mk[e[t + 15]]).toLowerCase();
}
//#endregion
//#region ../../../node_modules/uuid/dist/rng.js
var gk = /* @__PURE__ */ new Uint8Array(16);
function _k() {
	return crypto.getRandomValues(gk);
}
//#endregion
//#region ../../../node_modules/uuid/dist/v4.js
function vk(e, t, n) {
	return !t && !e && crypto.randomUUID ? crypto.randomUUID() : yk(e, t, n);
}
function yk(e, t, n) {
	e ||= {};
	let r = e.random ?? e.rng?.() ?? _k();
	if (r.length < 16) throw Error("Random bytes length must be >= 16");
	if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
		if (n ||= 0, n < 0 || n + 16 > t.length) throw RangeError(`UUID byte range ${n}:${n + 15} is out of buffer bounds`);
		for (let e = 0; e < 16; ++e) t[n + e] = r[e];
		return t;
	}
	return hk(r);
}
//#endregion
//#region ../widget-voyado/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._pointer_pn2q5_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_pn2q5_59{background:linear-gradient(var(--dixa-color-neutral-000) 33%, #fff0), linear-gradient(#fff0, var(--dixa-color-neutral-000) 66%) 0 100%, radial-gradient(farthest-side at 50% 0, var(--dixa-color-neutral-200), #0000), radial-gradient(farthest-side at 50% 100%, var(--dixa-color-neutral-200), #0000) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-200), 100% var(--dixa-size-spacer-200);max-height:230px;padding:0;overflow-y:auto}._listItem_pn2q5_69{cursor:pointer;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);background-color:#0000}._listItem_pn2q5_69:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_4z55u_54{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_4z55u_54:hover,._messageIsOpen_4z55u_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_4z55u_66{cursor:pointer}._messageText_4z55u_70{max-height:150px;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_4z55u_70::-webkit-scrollbar{width:7px;height:7px}._messageText_4z55u_70::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_4z55u_70::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_4z55u_70::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._buttonLink_4z55u_93{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var bk = /* @__PURE__ */ function(e) {
	return e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e;
}({}), xk = /* @__PURE__ */ function(e) {
	return e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e;
}({}), Sk = {
	"\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "updatePreferences"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "contactId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Voyado_UUID"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Voyado_contactAttributes_Input"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "ContactsV_ContactPatch"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "contactId"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "contactId"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "updatePoints"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Voyado_AddPointTransactionRequestModel_Input"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "PointTransaction_AddPointTransacion"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}]
						}]
					}
				}]
			}
		}]
	},
	"\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getContactById"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "contactId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Voyado_UUID"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "ContactsV_GetContactById"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "contactId"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "contactId"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "id"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "attributes"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "meta"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "preferences"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "consents"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "id"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "date"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "value"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "source"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "comment"
													}
												}
											]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getContactOverviewById"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "contactId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "ContactOverview_GetContactOverviewAsync"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "contactId"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "contactId"
									}
								}
							}]
						}]
					}
				}]
			}
		}]
	},
	"\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getContactId"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "email"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "mobilePhone"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "ContactOverview_GetContactIdAsync"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "email"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "email"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "mobilePhone"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "mobilePhone"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Voyado_ContactOverview_GetContactIdAsync_response"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Voyado_String_container"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "String"
													}
												}]
											}
										}, {
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Voyado_ApiExceptionMultipleMatchesResponse"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "errorCode"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "message"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "requestId"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "messageDetails"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "multipleMatchesFound"
																}
															}]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getLatestMessagesByContactId"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "contactId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Voyado_UUID"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "count"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Int"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "ContactMessage_GetSmsMessagesByContactId"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "contactId"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "contactId"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "count"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "count"
										}
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Voyado_ListResultOfApiMessage"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "count"
												}
											}, {
												kind: "Field",
												name: {
													kind: "Name",
													value: "items"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageId"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "sendDateTime"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "type"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "source"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "isTransactional"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageLink"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageText"
															}
														}
													]
												}
											}]
										}
									}]
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "ContactMessage_GetPostalMessagesByContactId"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "contactId"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "contactId"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "count"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "count"
										}
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Voyado_ListResultOfApiMessage"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "count"
												}
											}, {
												kind: "Field",
												name: {
													kind: "Name",
													value: "items"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageId"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "sendDateTime"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "type"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "source"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "isTransactional"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageLink"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageText"
															}
														}
													]
												}
											}]
										}
									}]
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "ContactMessage_GetEmailMessagesByContactId"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "contactId"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "contactId"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "count"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "count"
										}
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Voyado_ListResultOfApiMessage"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "count"
												}
											}, {
												kind: "Field",
												name: {
													kind: "Name",
													value: "items"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageId"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "sendDateTime"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "type"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "source"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "isTransactional"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageLink"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageText"
															}
														}
													]
												}
											}]
										}
									}]
								}
							}
						]
					}
				}]
			}
		}]
	},
	"\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getCustomerTransactions"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "contactId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Voyado_UUID"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "offset"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "count"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "Transactions_GetTransactionsWithArticlesByContactId"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "contactId"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "contactId"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "offset"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "offset"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "count"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "count"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "count"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "totalCount"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "items"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "id"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "createdDate"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "transactionNumber"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "storeName"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "numberOfItems"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "netPriceSum"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "localNetPriceSum"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "localCurrency"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "lineItems"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "quantity"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "article"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "name"
																		}
																	}]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "localPrice"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "type"
																}
															}
														]
													}
												}
											]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getOrdersByContactId"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "contactId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Voyado_UUID"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "offset"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "count"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "Orders_GetAllByContact"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "contactId"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "contactId"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "offset"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "offset"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "count"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "count"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "totalCount"
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "items"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "orderId"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "createdAt"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "lastChangedAt"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "channel"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "status"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "externalStatus"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "totalPrice"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "currencyCode"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "lineItems"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "items"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "quantity"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "totalPrice"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "article"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "sku"
																				}
																			},
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "name"
																				}
																			},
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "description"
																				}
																			},
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "imageUri"
																				}
																			},
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "targetUri"
																				}
																			}
																		]
																	}
																}
															]
														}
													}]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getPoints"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "contactId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Voyado_UUID"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "PointAccountV_GetPointAccounts"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "contactId"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "contactId"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Voyado_PointAccountModelV3"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "balance"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	}
};
function Ck(e) {
	return Sk[e] ?? {};
}
var wk = Ck("\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n"), Tk = Ck("\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n"), Ek = Ck("\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n"), Dk = Ck("\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n"), Ok = Ck("\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n"), kk = Ck("\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), Ak = Ck("\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n"), jk = Ck("\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n"), Mk = Ck("\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n"), Nk = ({ contactId: e }) => {
	let { useQuery: t } = V(), { track: n } = B(), [r, i] = W(), [a, o] = W(), [s, c] = W(), { loading: l, error: u, data: d, refetch: f } = t(wk, {
		skip: !e,
		variables: { contactId: e }
	});
	return U(() => {
		let e = d?.Voyado?.ContactsV_GetContactById;
		!l && e && typeof e == "object" && ("id" in e && n("voyado:profile:received", { hasProfile: !0 }), "attributes" in e && i(e.attributes), "preferences" in e && o(e.preferences), "consents" in e && c(e?.consents?.filter((e) => e !== null) || void 0)), !l && (!e || typeof e != "object") && n("voyado:profile:received", { hasProfile: !1 });
	}, [d?.Voyado, l]), Ze(() => ({
		isLoading: l,
		error: u,
		refetch: f,
		attributes: r,
		preferences: a,
		consents: s
	}), [
		u,
		r,
		a,
		s
	]);
};
function Pk(e = !1, t) {
	let [n, r] = W(e);
	return U(() => {
		let e = n ? window.setTimeout(() => r(!1), t || 2e3) : void 0;
		return () => window.clearTimeout(e);
	}, [t, n]), {
		isCopied: n,
		copy: (e) => {
			navigator.clipboard.writeText(e), r(!0);
		}
	};
}
var Fk = {
	count: 0,
	items: []
}, Ik = ({ contactId: e }) => {
	let { useQuery: t } = V(), { track: n } = B(), [r, i] = W(Fk), { loading: a, error: o, data: s } = t(Dk, {
		skip: !e,
		variables: {
			contactId: e,
			count: 5
		}
	});
	return U(() => {
		if (!a && (s?.Voyado?.ContactMessage_GetSmsMessagesByContactId || s?.Voyado?.ContactMessage_GetPostalMessagesByContactId || s?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
			let e = s?.Voyado?.ContactMessage_GetEmailMessagesByContactId, t = s?.Voyado?.ContactMessage_GetSmsMessagesByContactId, r = s?.Voyado?.ContactMessage_GetPostalMessagesByContactId, a = {
				count: (t?.count ?? 0) + (r?.count ?? 0) + (e?.count ?? 0),
				items: [
					...t.items ?? [],
					...e.items ?? [],
					...r.items ?? []
				]
			};
			i(a), n("voyado:messages:received", {
				emailsReceived: e.count ?? 0,
				smsReceived: t.count ?? 0,
				postalReceived: r.count ?? 0,
				total: a.count ?? 0
			});
		}
	}, [s?.Voyado, a]), {
		isLoading: a,
		error: o,
		lastMessages: r
	};
}, Lk = {
	count: 0,
	totalCount: 0,
	items: []
}, Rk = ({ contactId: e }) => {
	let { useQuery: t } = V(), { track: n } = B(), [r, i] = W(Lk), { loading: a, error: o, data: s } = t(Ok, {
		skip: !e,
		variables: {
			contactId: e,
			count: 5
		}
	});
	return U(() => {
		let e = s?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
		if (!a && e) {
			i(e);
			let { count: t } = e;
			t && n("voyado:transactions:received", { count: t });
		}
	}, [s?.Voyado, a]), {
		isLoading: a,
		error: o,
		transactions: r
	};
}, zk = ({ conversationContext: e }) => {
	let { useQuery: t } = V(), [n, r] = W(void 0), [i, a] = W(!1), { customer: o } = e, { loading: s, error: c, data: l, refetch: u } = t(Ek, {
		skip: !(o?.email || o?.phone_number),
		variables: {
			email: o?.email ?? "",
			mobilePhone: o?.phone_number ?? ""
		}
	});
	return U(() => {
		let e = l?.Voyado?.ContactOverview_GetContactIdAsync;
		e?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && e?.messageDetails?.multipleMatchesFound && e?.messageDetails?.multipleMatchesFound.length > 0 && (a(!0), r(void 0)), e?.__typename === "Voyado_String_container" && e?.String && (a(!1), r(e.String));
	}, [l?.Voyado, s]), {
		isLoading: s,
		contactId: n,
		hasMultipleContacts: i,
		error: c,
		refetch: u
	};
}, Bk = ({ contactId: e, skip: t }) => {
	let { useQuery: n } = V(), [r, i] = W(void 0), { loading: a, error: o, data: s, refetch: c } = n(Tk, {
		skip: !e || t,
		variables: { contactId: e }
	});
	return U(() => {
		let e = s?.Voyado?.ContactOverview_GetContactOverviewAsync;
		if (!a && e && Object.hasOwn(e, "memberlevel")) {
			let t = e?.memberlevel;
			i({
				levelName: t?.levelName,
				remainingToUpgrade: t?.remainingToUpgrade,
				basedOnRewardPoints: t?.basedOnRewardPoints,
				levelId: t?.levelId,
				latestChange: t?.latestChange,
				expires: t?.expires
			});
		} else i(void 0);
	}, [s?.Voyado, a]), Ze(() => ({
		isLoading: a,
		error: o,
		memberLevel: r,
		refetch: c
	}), [
		a,
		o,
		r,
		c
	]);
}, Vk = {
	pointer: "_pointer_pn2q5_54",
	list: "_list_pn2q5_59",
	listItem: "_listItem_pn2q5_69"
}, Hk = { modalBody: "_modalBody_1clhs_1" }, Uk = ({ isOpen: e, onClose: t, pointsAccount: n, setHasPointsBeenUpdated: r, refetchPointsQuery: i }) => {
	let { useMutation: a, showNotification: o } = V(), { track: s } = B(), c = n?.id, l = n?.balance ?? 0, u = {
		balance: l?.toString() ?? "0",
		description: "",
		transactionType: null
	}, { control: d, setValue: f, reset: p } = xc({
		defaultValues: u,
		mode: "onChange"
	}), h = ws({ control: d }), g = parseInt(h?.balance ?? "0", 10), _ = l === g, b = _ ? "Change the value to update the points" : "", x = g < 0, S = x ? "Points can not be negative" : "", C = h.description === "", w = C ? "Description can not be empty" : "";
	U(() => {
		g > l ? f("transactionType", xk.Addition) : g < l && f("transactionType", xk.Deduction);
	}, [
		l,
		g,
		f
	]);
	let [T, { loading: A, error: j, reset: M }] = a(Mk, { onCompleted: () => {
		o({
			title: "Success",
			text: "Points updated successfully",
			icon: "check-circle-filled",
			severity: "success"
		});
	} }), P = () => {
		if (c) {
			let e = vk();
			T({ variables: { input: {
				accountId: c,
				transactionId: e,
				amount: Math.abs(g - l),
				transactionType: h.transactionType,
				description: h.description,
				source: bk.UpdateBalance
			} } }).then(async (e) => {
				e?.errors ? s("voyado:update:points:failed") : (s("voyado:update:points:succeeded"), r(!0), await i(), F());
			}).catch(() => {
				s("voyado:update:points:failed");
			});
		}
	}, F = () => {
		p(u), M(), t();
	};
	return /* @__PURE__ */ q(E, {
		isOpen: e,
		onClose: F,
		"data-testid": "change-points-modal",
		children: [
			/* @__PURE__ */ K(k, {
				title: "Update points balance",
				onClose: F
			}),
			/* @__PURE__ */ q(D, {
				className: Hk.modalBody,
				children: [/* @__PURE__ */ q(y, { children: [/* @__PURE__ */ K(v, {
					span: 6,
					children: /* @__PURE__ */ K(Es, {
						name: "balance",
						control: d,
						render: ({ field: e }) => /* @__PURE__ */ K(m, {
							label: "New points balance",
							type: "number",
							placeholder: "Insert new points",
							min: 0,
							max: 1e5,
							meta: { warning: b || S },
							input: {
								...e,
								value: e.value.toString(),
								onChange: (t) => e.onChange(t)
							}
						})
					})
				}), /* @__PURE__ */ K(v, {
					span: 6,
					children: /* @__PURE__ */ K(Es, {
						name: "description",
						control: d,
						render: ({ field: e }) => /* @__PURE__ */ K(m, {
							required: !0,
							label: "Description",
							placeholder: "Insert a description",
							input: e,
							meta: { warning: w }
						})
					})
				})] }), j && /* @__PURE__ */ K(z, { error: j })]
			}),
			/* @__PURE__ */ K(O, {
				confirmName: "Save",
				confirmOnClick: () => P(),
				confirmProps: {
					isLoading: A,
					disabled: _ || x || C,
					loadingIndicator: /* @__PURE__ */ K(N, { size: 16 })
				},
				cancelOnClick: F
			})
		]
	});
}, Wk = {
	wrapper: "_wrapper_1ge6c_1",
	textVariant: "_textVariant_1ge6c_7",
	block: "_block_1ge6c_12"
}, Gk = ({ contactAttributes: e, contactId: t }) => {
	let { useQuery: r } = V(), { isCopied: a, copy: o } = Pk(), { isCopied: s, copy: c } = Pk(), { isCopied: l, copy: u } = Pk(), [d, f] = W(!1), [p, m] = W(), [h, g] = W(!1), { loading: v, data: y, refetch: x } = r(Ak, {
		variables: { contactId: t },
		skip: !t
	});
	U(() => {
		if (y) {
			let e = y?.Voyado?.PointAccountV_GetPointAccounts;
			e && e?.length > 0 && m(e[0]);
		}
	}, [y]);
	let S = !!p?.id, C = p?.balance ?? 0;
	if (!e) return null;
	let { firstName: w, lastName: T, street: E, zipCode: D, city: O, country: k, isRegistrationCompleted: A, email: j, mobilePhone: M } = e, P = `${w || ""} ${T || ""}`.trim() || "Anonymous";
	return /* @__PURE__ */ q(_, {
		flexDirection: "column",
		className: Wk.wrapper,
		children: [
			/* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				className: Wk.block,
				alignItems: "center",
				children: [
					/* @__PURE__ */ K(L.Heading, {
						variant: "heading-2",
						children: P
					}),
					v && /* @__PURE__ */ K(N, { size: 12 }),
					S && !v && /* @__PURE__ */ q(_, {
						gap: "100",
						alignItems: "center",
						children: [
							/* @__PURE__ */ q(n, {
								size: "small",
								variant: "warning",
								children: [C, " points"]
							}),
							/* @__PURE__ */ K(R, {
								content: "Update points balance",
								children: /* @__PURE__ */ K(b, {
									name: "pen",
									size: 12,
									onClick: () => f(!0),
									className: Vk.pointer
								})
							}),
							h && /* @__PURE__ */ K(R, {
								content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.",
								children: /* @__PURE__ */ K(b, {
									name: "info",
									size: 12,
									className: Vk.pointer
								})
							})
						]
					})
				]
			}),
			(E || O || D || k || M || j) && /* @__PURE__ */ q(_, {
				gap: "200",
				flexDirection: "column",
				children: [
					M && /* @__PURE__ */ q(_, {
						gap: "200",
						justifyContent: "space-between",
						children: [/* @__PURE__ */ q(_, {
							gap: "200",
							alignItems: "center",
							children: [/* @__PURE__ */ K(b, {
								size: 14,
								name: "phone"
							}), /* @__PURE__ */ K(L.Paragraph, {
								variant: "4",
								children: M
							})]
						}), /* @__PURE__ */ K(b, {
							size: 14,
							name: s ? "done" : "copy",
							onClick: () => c(M),
							className: Vk.pointer
						})]
					}),
					j && /* @__PURE__ */ q(_, {
						gap: "200",
						justifyContent: "space-between",
						children: [/* @__PURE__ */ q(_, {
							gap: "200",
							alignItems: "center",
							children: [/* @__PURE__ */ K(b, {
								size: 14,
								name: "mail"
							}), /* @__PURE__ */ K(L.Paragraph, {
								variant: "4",
								children: j
							})]
						}), /* @__PURE__ */ K(b, {
							size: 14,
							name: a ? "done" : "copy",
							onClick: () => o(j),
							className: Vk.pointer
						})]
					}),
					(E || O || D || k) && /* @__PURE__ */ q(_, {
						gap: "200",
						justifyContent: "space-between",
						children: [/* @__PURE__ */ q(_, {
							gap: "200",
							children: [/* @__PURE__ */ K(b, {
								size: 14,
								name: "home"
							}), /* @__PURE__ */ q(L.Paragraph, {
								variant: "4",
								color: "secondary",
								children: [
									/* @__PURE__ */ K(i, { children: E }),
									/* @__PURE__ */ q(i, { children: [
										D,
										" ",
										O
									] }),
									/* @__PURE__ */ K(i, { children: k })
								]
							})]
						}), /* @__PURE__ */ K(b, {
							size: 14,
							name: l ? "done" : "copy",
							onClick: () => u(`${E}, ${D} ${O}, ${k}`),
							className: Vk.pointer
						})]
					}),
					/* @__PURE__ */ q(_, {
						gap: "200",
						justifyContent: "space-between",
						children: [/* @__PURE__ */ q(_, {
							gap: "200",
							alignItems: "center",
							children: [/* @__PURE__ */ K(b, {
								size: 14,
								name: "sign-in"
							}), /* @__PURE__ */ K(L.Paragraph, {
								variant: "4",
								children: "Is registration completed"
							})]
						}), /* @__PURE__ */ K(b, {
							name: A ? "check-circle-filled" : "close-circle-filled",
							color: A ? "green.500" : "neutral.500"
						})]
					})
				]
			}),
			S && /* @__PURE__ */ K(Uk, {
				isOpen: d,
				pointsAccount: p,
				onClose: () => f(!1),
				setHasPointsBeenUpdated: g,
				refetchPointsQuery: x
			})
		]
	});
}, Kk = Yo, qk = {
	wrapper: "_wrapper_yud4a_1",
	list: "_list_yud4a_7",
	listItem: "_listItem_yud4a_11",
	listItemTooltip: "_listItemTooltip_yud4a_15",
	listItemTimestamp: "_listItemTimestamp_yud4a_18"
}, Jk = ({ contactConsents: e }) => !e || e.length === 0 ? null : /* @__PURE__ */ q(_, {
	gap: "200",
	flexDirection: "column",
	children: [/* @__PURE__ */ K(L.Heading, {
		variant: "heading-3",
		children: "Consents"
	}), /* @__PURE__ */ K(T, {
		className: qk.list,
		children: e.map((e, t) => /* @__PURE__ */ K(T.Text, {
			variant: "dense",
			className: qk.listItem,
			children: /* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				alignItems: "center",
				children: [/* @__PURE__ */ K(R, {
					content: e?.comment,
					children: /* @__PURE__ */ q(_, {
						gap: "200",
						alignItems: "center",
						className: ae({ [qk.listItemTooltip]: e?.comment }),
						children: [
							/* @__PURE__ */ K(L.Paragraph, {
								variant: "4",
								children: e.id
							}),
							/* @__PURE__ */ K(L.Paragraph, {
								className: qk.listItemTimestamp,
								children: Kk(e.date).format(he)
							}),
							e?.comment && /* @__PURE__ */ K(b, {
								name: "info",
								color: "neutral.400"
							})
						]
					})
				}), /* @__PURE__ */ K(b, {
					name: e.value ? "check-circle-filled" : "close-circle-filled",
					color: e.value ? "green.500" : "red.500"
				})]
			})
		}, t))
	})]
}), Yk = ({ memberLevel: e }) => {
	let t = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Kk(e.latestChange).format(he) : null, o = e?.expires ? `${Kk(e.expires).fromNow()} (${Kk(e.expires).format(he)})` : null, s = !t && !a && !r && !i && !o;
	return /* @__PURE__ */ K(_, {
		gap: "200",
		flexDirection: "column",
		children: /* @__PURE__ */ q(_, {
			gap: "200",
			flexDirection: "column",
			children: [/* @__PURE__ */ q(_, {
				alignItems: "center",
				gap: "100",
				children: [/* @__PURE__ */ K(L.Heading, {
					variant: "heading-3",
					children: "Member level"
				}), /* @__PURE__ */ K(R, {
					content: "Voyado updates the member level data in a nightly batch process",
					children: /* @__PURE__ */ K(b, {
						name: "question",
						size: 14,
						className: Vk.pointer
					})
				})]
			}), /* @__PURE__ */ K(_, {
				flexDirection: "column",
				children: /* @__PURE__ */ q(T, {
					className: Vk.list,
					children: [
						s && /* @__PURE__ */ K(T.Text, {
							variant: "dense",
							className: Vk.listItem,
							children: /* @__PURE__ */ K(L.Paragraph, {
								variant: "4",
								color: "secondary",
								children: "No member level properties found"
							})
						}),
						t && /* @__PURE__ */ K(T.Text, {
							variant: "dense",
							className: Vk.listItem,
							children: /* @__PURE__ */ K(R, {
								content: "",
								children: /* @__PURE__ */ q(_, {
									justifyContent: "space-between",
									alignItems: "center",
									children: [/* @__PURE__ */ K(L.Paragraph, {
										variant: "4",
										children: "Level"
									}), /* @__PURE__ */ K(n, {
										variant: "info",
										size: "small",
										children: e?.levelName ?? ""
									})]
								})
							})
						}),
						i && /* @__PURE__ */ K(T.Text, {
							variant: "dense",
							className: Vk.listItem,
							children: /* @__PURE__ */ K(R, {
								content: "Voyado updates the member level data once a day in a nightly job",
								children: /* @__PURE__ */ q(_, {
									justifyContent: "space-between",
									alignItems: "center",
									children: [/* @__PURE__ */ K(L.Paragraph, {
										variant: "4",
										children: "Based on reward points"
									}), /* @__PURE__ */ K(n, {
										variant: "success",
										size: "small",
										children: i
									})]
								})
							})
						}),
						r && /* @__PURE__ */ K(T.Text, {
							variant: "dense",
							className: Vk.listItem,
							children: /* @__PURE__ */ K(R, {
								content: "",
								children: /* @__PURE__ */ q(_, {
									justifyContent: "space-between",
									alignItems: "center",
									children: [/* @__PURE__ */ K(L.Paragraph, {
										variant: "4",
										children: "Remaining to upgrade"
									}), /* @__PURE__ */ K(n, {
										variant: "success",
										size: "small",
										children: r
									})]
								})
							})
						}),
						a && /* @__PURE__ */ K(T.Text, {
							variant: "dense",
							className: Vk.listItem,
							children: /* @__PURE__ */ K(R, {
								content: "",
								children: /* @__PURE__ */ q(_, {
									justifyContent: "space-between",
									alignItems: "center",
									children: [/* @__PURE__ */ K(L.Paragraph, {
										variant: "4",
										children: "Latest change"
									}), /* @__PURE__ */ K(L.Paragraph, {
										variant: "5",
										color: "secondary",
										children: a
									})]
								})
							})
						}),
						o && /* @__PURE__ */ K(T.Text, {
							variant: "dense",
							className: Vk.listItem,
							children: /* @__PURE__ */ K(R, {
								content: "",
								children: /* @__PURE__ */ q(_, {
									justifyContent: "space-between",
									alignItems: "center",
									children: [/* @__PURE__ */ K(L.Paragraph, {
										variant: "4",
										children: "Expires"
									}), /* @__PURE__ */ K(L.Paragraph, {
										variant: "5",
										color: "secondary",
										children: o
									})]
								})
							})
						})
					]
				})
			})]
		})
	});
}, Xk = {
	tagHover: "_tagHover_kzbzk_1",
	channelUnsubscribed: "_channelUnsubscribed_kzbzk_6"
}, Zk = ({ isSubscribed: e, channelName: t, channelIcon: n, contactId: r, contactPreferences: i, refetchContact: a }) => {
	let { track: o } = B(), { useMutation: s } = V(), [c, l] = W(!1), [u, { loading: d }] = s(jk), f = async ({ newPreference: e, isSubscribed: t, channelType: n }) => {
		l(!0), (await u({ variables: {
			contactId: r,
			input: { preferences: {
				...i,
				...e
			} }
		} }))?.data?.Voyado.ContactsV_ContactPatch?.id ? o(t ? "voyado:channel:unsubscribe:succeeded" : "voyado:channel:subscribe:succeeded", { channel: n }) : o(t ? "voyado:channel:unsubscribe:failed" : "voyado:channel:subscribe:failed", { channel: n }), setTimeout(async () => {
			await a().finally(() => l(!1));
		}, 1e3);
	}, p = c || d;
	return /* @__PURE__ */ K(R, {
		content: e ? "Unsubscribe" : "Subscribe",
		children: /* @__PURE__ */ K(I, {
			className: Xk.tagHover,
			color: e ? "green.500" : "neutral.200",
			children: /* @__PURE__ */ q(_, {
				"data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
				gap: "200",
				alignItems: "center",
				className: ae({ [Xk.channelUnsubscribed]: !e }),
				onClick: () => {
					o(e ? "voyado:channel:unsubscribe:clicked" : "voyado:channel:subscribe:clicked", { channel: t.toUpperCase() }), f({
						newPreference: { [`accepts${t}`]: !e },
						isSubscribed: e,
						channelType: t.toUpperCase()
					});
				},
				children: [p ? /* @__PURE__ */ K(N, { size: 16 }) : /* @__PURE__ */ K(b, {
					size: 16,
					name: n
				}), t]
			})
		})
	});
}, Qk = ({ contactPreferences: e, contactId: t, refetchContact: n }) => {
	if (!e || !t) return null;
	let { acceptsEmail: r, acceptsPostal: i, acceptsSms: a } = e;
	return /* @__PURE__ */ K(_, {
		gap: "200",
		flexDirection: "column",
		children: /* @__PURE__ */ q(_, {
			gap: "200",
			flexDirection: "column",
			children: [/* @__PURE__ */ K(L.Heading, {
				variant: "heading-3",
				children: "Subscriptions"
			}), /* @__PURE__ */ q(_, {
				gap: "100",
				flexDirection: "row",
				children: [
					/* @__PURE__ */ K(Zk, {
						channelName: "Email",
						channelIcon: "mail",
						isSubscribed: r,
						contactId: t,
						contactPreferences: e,
						refetchContact: n
					}),
					/* @__PURE__ */ K(Zk, {
						channelName: "Sms",
						channelIcon: "sms",
						isSubscribed: a,
						contactId: t,
						contactPreferences: e,
						refetchContact: n
					}),
					/* @__PURE__ */ K(Zk, {
						channelName: "Postal",
						channelIcon: "paper-plane",
						isSubscribed: i,
						contactId: t,
						contactPreferences: e,
						refetchContact: n
					})
				]
			})]
		})
	});
}, $k = ({ contactId: e, settings: t }) => {
	let { showCustomerAttributes: n, showPreferences: r, showAudiences: i, showConsents: a, showMemberLevel: o } = t, { isLoading: s, error: c, refetch: l, attributes: u, preferences: d, consents: f } = Nk({ contactId: e }), { isLoading: p, error: m, memberLevel: h } = Bk({
		contactId: e,
		skip: !o
	}), g = p || s, v = Ze(() => f?.filter((e) => e !== null), [f]);
	return c || m ? Se({ errors: c?.graphQLErrors || m?.graphQLErrors || [] }) ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		children: /* @__PURE__ */ K(L.Paragraph, {
			color: "secondary",
			children: "No contact informations found"
		})
	}) : /* @__PURE__ */ K(z, { error: c || m }) : !n && !r && !i && !a && !o ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		children: /* @__PURE__ */ K(L.Paragraph, {
			color: "secondary",
			children: "All contact related features in the settings are disabled."
		})
	}) : g ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "300",
		children: /* @__PURE__ */ K(N, {})
	}) : /* @__PURE__ */ q(G, { children: [
		n && /* @__PURE__ */ K(Gk, {
			contactAttributes: u,
			contactId: e
		}),
		o && /* @__PURE__ */ K(Yk, { memberLevel: h }),
		r && /* @__PURE__ */ K(Qk, {
			refetchContact: l,
			contactPreferences: d,
			contactId: e
		}),
		a && /* @__PURE__ */ K(Jk, { contactConsents: v })
	] });
}, eA = (e, t) => `${e ? e.toFixed(2) : "0.00"} ${t}`, tA = {
	list: "_list_zu4s7_1",
	listItem: "_listItem_zu4s7_4",
	listSum: "_listSum_zu4s7_7"
}, nA = ({ lineItems: e, localCurrency: t, localNetPriceSum: n }) => /* @__PURE__ */ q(T, {
	className: tA.list,
	children: [e?.map(({ quantity: e, article: n, localPrice: r, type: i }, a) => /* @__PURE__ */ K(T.Text, {
		variant: "dense",
		className: tA.listItem,
		children: /* @__PURE__ */ K(R, {
			content: i,
			children: /* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				gap: "200",
				children: [
					/* @__PURE__ */ q(_, {
						flex: "0 0 auto",
						gap: "200",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: e
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: "×"
						})]
					}),
					/* @__PURE__ */ K(_, {
						flex: "auto",
						children: /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: n?.name
						})
					}),
					r && t && /* @__PURE__ */ K(_, {
						flex: "0 0 auto",
						gap: "100",
						children: /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: eA(r, t)
						})
					})
				]
			})
		})
	}, a)), /* @__PURE__ */ K(T.Text, {
		variant: "dense",
		className: ae(tA.listItem, tA.listSum),
		children: /* @__PURE__ */ q(_, {
			gap: "100",
			justifyContent: "space-between",
			children: [/* @__PURE__ */ K(L.Paragraph, {
				variant: "3",
				children: "Sum"
			}), /* @__PURE__ */ K(L.Paragraph, {
				variant: "3",
				children: eA(n, t)
			})]
		})
	}, "theSumOfItAll")]
}), rA = {
	transaction: "_transaction_1kr8d_1",
	transactionIsOpen: "_transactionIsOpen_1kr8d_9",
	transactionHeader: "_transactionHeader_1kr8d_12",
	transactionHeaderSubLine: "_transactionHeaderSubLine_1kr8d_15",
	transactionHeaderAlignItemRight: "_transactionHeaderAlignItemRight_1kr8d_19"
}, iA = ({ transaction: e, openByDefault: t }) => {
	let [r, i] = W(t), { transactionNumber: a, createdDate: o, storeName: s, numberOfItems: c, storeType: u, lineItems: d, localCurrency: f, localNetPriceSum: p } = e, m = f ?? "", h = p ?? 0, g = d?.length ? d : [];
	return /* @__PURE__ */ q(_, {
		className: ae(rA.transaction, { [rA.transactionIsOpen]: r }),
		gap: "300",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			justifyContent: "space-between",
			alignItems: "center",
			className: rA.transactionHeader,
			onClick: () => i(!r),
			"data-testid": "contact-transaction-header",
			children: [/* @__PURE__ */ q(_, {
				style: { flexGrow: 1 },
				children: [/* @__PURE__ */ q(_, {
					flexDirection: "column",
					gap: "100",
					children: [o && /* @__PURE__ */ K(n, {
						size: "small",
						variant: "info",
						children: Kk(o).format(he)
					}), /* @__PURE__ */ q(L.Heading, {
						variant: "heading-4",
						className: rA.transactionHeaderSubLine,
						children: ["ID: ", a]
					})]
				}), /* @__PURE__ */ q(_, {
					flexDirection: "column",
					gap: "100",
					className: rA.transactionHeaderAlignItemRight,
					children: [/* @__PURE__ */ K(L.Heading, {
						variant: "heading-4",
						children: eA(h, m)
					}), /* @__PURE__ */ q(L.Heading, {
						variant: "heading-4",
						className: rA.transactionHeaderSubLine,
						children: [
							c,
							" line ",
							`${c === 1 ? "item" : "items"}`
						]
					})]
				})]
			}), /* @__PURE__ */ K(_, {
				flexDirection: "column",
				children: /* @__PURE__ */ K(x, {
					variant: "tertiary",
					icon: r ? "angle-up" : "angle-down"
				})
			})]
		}), r && /* @__PURE__ */ q(_, {
			gap: "300",
			flexDirection: "column",
			"data-testid": "contact-transaction-content",
			children: [/* @__PURE__ */ K(l, {}), /* @__PURE__ */ q(_, {
				gap: "100",
				flexDirection: "column",
				children: [
					s && /* @__PURE__ */ K(L.Heading, {
						variant: "heading-2",
						children: s
					}),
					u && /* @__PURE__ */ K(I, { children: /* @__PURE__ */ K(_, {
						alignItems: "center",
						children: u
					}) }),
					/* @__PURE__ */ K(nA, {
						lineItems: g,
						localCurrency: m,
						localNetPriceSum: h
					})
				]
			})]
		})]
	});
}, aA = ({ contactId: e }) => {
	let { isLoading: t, error: r, transactions: i } = Rk({ contactId: e });
	if (!e) return null;
	let { items: a, totalCount: o } = i, s = o ?? 0;
	return r ? /* @__PURE__ */ K(z, { error: r }) : /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		"data-testid": "contact-transactions-wrapper",
		children: [/* @__PURE__ */ q(_, {
			gap: "200",
			flexDirection: "row",
			alignItems: "center",
			children: [/* @__PURE__ */ K(L.Heading, {
				variant: "heading-3",
				children: "Transactions"
			}), !t && s > 0 && /* @__PURE__ */ K(n, {
				size: "small",
				variant: "success",
				children: s
			})]
		}), t ? /* @__PURE__ */ K(_, {
			justifyContent: "center",
			margin: "300",
			children: /* @__PURE__ */ K(N, {})
		}) : /* @__PURE__ */ q(G, { children: [s === 0 && /* @__PURE__ */ K(_, {
			justifyContent: "center",
			padding: "200",
			children: /* @__PURE__ */ K(L.Paragraph, {
				variant: "4",
				color: "secondary",
				children: "There are no transactions for this contact"
			})
		}), s > 0 && a?.map((e, t) => /* @__PURE__ */ K(iA, {
			transaction: e,
			openByDefault: t === 0
		}, t))] })]
	});
}, oA = {
	message: "_message_4z55u_54",
	messageIsOpen: "_messageIsOpen_4z55u_62",
	messageHeader: "_messageHeader_4z55u_66",
	messageText: "_messageText_4z55u_70",
	buttonLink: "_buttonLink_4z55u_93"
}, sA = {
	status: {
		Delivered: "check-circle",
		Waiting: "clock",
		Hardbounce: "close-circle-filled",
		Softbounce: "close"
	},
	type: {
		EmailMessage: "mail",
		SmsMessage: "sms",
		PostalMessage: "paper-plane"
	},
	source: {
		Automation: "chat-bot",
		Manual: "user",
		System: "eye"
	}
}, cA = (e, t) => t && e in sA && t in sA[e] ? sA[e][t] : null, lA = ({ message: e, openByDefault: t }) => {
	let [r, i] = W(t), { track: a } = B();
	if (!e) return null;
	let { name: o, sendDateTime: s, type: c, source: u, isTransactional: d, status: f, messageLink: p, messageText: m } = e, h = c ? cA("type", c) : null, g = u ? cA("source", u) : null, v = f ? cA("status", f) : null, y = c?.replace("Message", "");
	return /* @__PURE__ */ q(_, {
		className: ae(oA.message, { [oA.messageIsOpen]: r }),
		gap: "300",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			justifyContent: "space-between",
			alignItems: "center",
			className: oA.messageHeader,
			onClick: () => i(!r),
			children: [/* @__PURE__ */ q(_, {
				gap: "100",
				flexDirection: "column",
				children: [/* @__PURE__ */ q(_, {
					gap: "200",
					alignItems: "center",
					children: [h && /* @__PURE__ */ q(G, { children: [
						/* @__PURE__ */ K(b, {
							name: h,
							size: 16
						}),
						" ",
						y
					] }), s && /* @__PURE__ */ K(n, {
						size: "small",
						variant: "info",
						children: Kk(s).format(he)
					})]
				}), o]
			}), /* @__PURE__ */ K(x, {
				variant: "tertiary",
				icon: r ? "angle-up" : "angle-down"
			})]
		}), r && /* @__PURE__ */ q(_, {
			gap: "300",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ K(l, {}),
				/* @__PURE__ */ q(_, {
					gap: "200",
					flexDirection: "row",
					flexWrap: "wrap",
					children: [
						v && /* @__PURE__ */ K(I, { children: /* @__PURE__ */ q(_, {
							alignItems: "center",
							gap: "200",
							children: [
								/* @__PURE__ */ K(b, { name: v }),
								" ",
								f
							]
						}) }),
						g && /* @__PURE__ */ K(I, { children: /* @__PURE__ */ q(_, {
							alignItems: "center",
							gap: "200",
							children: [
								/* @__PURE__ */ K(b, { name: g }),
								" ",
								u
							]
						}) }),
						d && /* @__PURE__ */ K(I, { children: /* @__PURE__ */ q(_, {
							alignItems: "center",
							gap: "200",
							children: [/* @__PURE__ */ K(b, { name: "exchange" }), " Transactional"]
						}) })
					]
				}),
				/* @__PURE__ */ q(_, {
					gap: "100",
					flexDirection: "column",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: "Message text"
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						className: oA.messageText,
						children: m
					})]
				}),
				p && /* @__PURE__ */ K(A, {
					slotEnd: /* @__PURE__ */ K(b, { name: "external-link" }),
					variant: "tertiary",
					className: oA.buttonLink,
					navigate: () => {
						y && a("voyado:message:external-link:opened", { channel: y.toUpperCase() }), window.open(p, "_blank")?.focus();
					},
					children: "Open message in new tab"
				})
			]
		})]
	});
}, uA = ({ contactId: e }) => {
	let { isLoading: t, error: r, lastMessages: i } = Ik({ contactId: e });
	if (!e) return null;
	if (r) return /* @__PURE__ */ K(z, { error: r });
	let { count: a, items: o } = i, s = (a && a) ?? 0, c = s > 0;
	return /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			gap: "200",
			flexDirection: "row",
			alignItems: "center",
			children: [/* @__PURE__ */ K(L.Heading, {
				variant: "heading-3",
				children: "Last Messages"
			}), !t && c && /* @__PURE__ */ K(n, {
				variant: "success",
				size: "small",
				children: s
			})]
		}), /* @__PURE__ */ K(_, {
			gap: "200",
			flexDirection: "column",
			children: t ? /* @__PURE__ */ K(_, {
				justifyContent: "center",
				margin: "300",
				children: /* @__PURE__ */ K(N, {})
			}) : /* @__PURE__ */ q(G, { children: [c && o?.map((e, t) => /* @__PURE__ */ K(lA, {
				message: e || void 0,
				openByDefault: t === 0
			}, t)), !c && /* @__PURE__ */ K(_, {
				justifyContent: "center",
				margin: "200",
				children: /* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					color: "secondary",
					children: "No messages available"
				})
			})] })
		})]
	});
}, dA = ({ value: e, currencyCode: t }) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${t ?? ""}`, fA = ({ labelText: e, address: t, icon: n = "home" }) => {
	let { isCopied: r, copy: i } = Pk(), a = [
		t?.title,
		t?.firstname,
		t?.lastname
	].filter(Boolean).join(" "), o = Je(() => [
		a,
		t?.streetAddress,
		t?.streetAddress2,
		t?.postalCode,
		t?.region,
		t?.city,
		t?.country
	].filter(Boolean).join("\n"), [t, a]);
	return t ? /* @__PURE__ */ q(_, {
		justifyContent: "space-between",
		children: [/* @__PURE__ */ q(_, {
			gap: "250",
			flexDirection: "row",
			children: [/* @__PURE__ */ K(b, {
				size: 14,
				name: n,
				color: "green.500"
			}), /* @__PURE__ */ q(_, {
				gap: "200",
				flexDirection: "column",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "3",
					children: e
				}), /* @__PURE__ */ q(_, {
					gap: "100",
					flexDirection: "column",
					children: [
						a && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: a
						}),
						t?.streetAddress && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: t.streetAddress
						}),
						t?.streetAddress2 && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: t.streetAddress2
						}),
						t?.postalCode && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: t?.postalCode
						}),
						t?.region && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: t.region
						}),
						t?.city && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: t.city
						}),
						t?.country && /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: t.country
						})
					]
				})]
			})]
		}), /* @__PURE__ */ K(R, {
			content: `Copy ${e.toLowerCase()}`,
			children: /* @__PURE__ */ K(b, {
				size: 14,
				name: r ? "done" : "copy",
				onClick: () => i(o()),
				className: Vk.pointer
			})
		})]
	}) : null;
}, pA = {
	order: "_order_19t4p_1",
	orderIsOpen: "_orderIsOpen_19t4p_9",
	orderHeader: "_orderHeader_19t4p_12",
	orderIconColor: "_orderIconColor_19t4p_15"
}, mA = {
	delivery: "_delivery_1m9nb_1",
	deliveryCode: "_deliveryCode_1m9nb_4"
}, hA = ({ delivery: e }) => {
	let { isCopied: t, copy: n } = Re();
	if (!e) return null;
	let { method: r, trackingNumber: i, trackingUri: a, deliveryDate: o } = e;
	return /* @__PURE__ */ q(_, {
		gap: "250",
		flexDirection: "row",
		children: [
			/* @__PURE__ */ K(b, {
				size: 14,
				name: "eye",
				className: pA.orderIconColor
			}),
			/* @__PURE__ */ q(_, {
				flexDirection: "column",
				gap: "200",
				width: "100%",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "3",
					children: "Delivery"
				}), /* @__PURE__ */ K(R, {
					content: /* @__PURE__ */ q(L.Paragraph, {
						variant: "4",
						color: "inherit",
						children: ["Arrives: ", Kk(o).format(he)]
					}),
					children: /* @__PURE__ */ q(_, {
						gap: "100",
						flexDirection: "column",
						children: [a ? /* @__PURE__ */ K(L.ExternalLink, {
							href: a,
							target: "_blank",
							rel: "noreferrer",
							children: /* @__PURE__ */ q(_, {
								gap: "100",
								alignItems: "center",
								className: mA.delivery,
								children: [/* @__PURE__ */ K(b, {
									name: "external-link",
									size: 14
								}), r]
							})
						}) : r, /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							className: ae(mA.delivery, mA.deliveryCode),
							children: i
						})]
					})
				})]
			}),
			i && /* @__PURE__ */ K(R, {
				content: "Copy tracking code",
				children: /* @__PURE__ */ K(b, {
					size: 14,
					name: t ? "done" : "copy",
					onClick: () => n(i.toString()),
					className: Vk.pointer
				})
			})
		]
	});
}, gA = ({ fees: e, currencyCode: t }) => {
	if (!e) return null;
	let n = e?.items ?? [];
	return /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			gap: "250",
			flexDirection: "row",
			children: [/* @__PURE__ */ K(b, {
				size: 14,
				name: "file-text",
				className: pA.orderIconColor
			}), /* @__PURE__ */ K(L.Paragraph, {
				variant: "3",
				children: "Fees"
			})]
		}), /* @__PURE__ */ K(T, {
			className: Vk.list,
			children: n?.map((e, n) => /* @__PURE__ */ K(T.Item, {
				className: Vk.listItem,
				children: /* @__PURE__ */ q(_, {
					justifyContent: "space-between",
					alignItems: "center",
					width: "100%",
					children: [/* @__PURE__ */ q(_, {
						flexDirection: "column",
						gap: "100",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "5",
							children: e?.type
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: e?.description
						})]
					}), /* @__PURE__ */ K(_, {
						flexDirection: "column",
						gap: "100",
						children: e?.taxes?.items?.map((e, n) => /* @__PURE__ */ q(_, {
							gap: "100",
							flexDirection: "column",
							className: Vk.listItemAlignRight,
							children: [/* @__PURE__ */ K(L.Paragraph, {
								variant: "5",
								children: `${e?.description} ${e?.percent}%`
							}), /* @__PURE__ */ K(L.Paragraph, {
								variant: "4",
								children: dA({
									value: e?.amount,
									currencyCode: t
								})
							})]
						}, `tax-${n}`))
					})]
				})
			}, `fees-${n}`))
		})]
	});
}, _A = ({ lineItems: e, currencyCode: t }) => {
	if (!e) return null;
	let r = e?.items ?? [];
	return /* @__PURE__ */ q(_, {
		gap: "100",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			gap: "250",
			flexDirection: "row",
			children: [/* @__PURE__ */ K(b, {
				size: 14,
				name: "tag",
				className: pA.orderIconColor
			}), /* @__PURE__ */ K(L.Paragraph, {
				variant: "3",
				children: "Line items"
			})]
		}), /* @__PURE__ */ K(T, {
			className: Vk.list,
			children: r?.map((e) => /* @__PURE__ */ K(T.Item, {
				className: Vk.listItem,
				contentLeft: /* @__PURE__ */ q(_, {
					gap: "200",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: e?.quantity
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: "×"
					})]
				}),
				title: /* @__PURE__ */ K(R, {
					content: /* @__PURE__ */ K(L.Paragraph, {
						variant: "3",
						color: "inherit",
						children: e?.article?.sku
					}),
					children: /* @__PURE__ */ q(_, {
						gap: "100",
						flexDirection: "column",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: e?.article?.name
						}), /* @__PURE__ */ K(_, { children: /* @__PURE__ */ K(n, {
							size: "small",
							variant: "info",
							children: dA({
								value: e?.totalPrice,
								currencyCode: t
							})
						}) })]
					})
				}),
				contentRight: e?.article?.imageUri && /* @__PURE__ */ K(S, {
					src: e?.article?.imageUri,
					alt: e?.article?.name,
					style: { height: "48px" }
				})
			}, `list-${e?.id}`))
		})]
	});
}, vA = ({ payments: e, currencyCode: t }) => {
	if (!e) return null;
	let n = e?.items ?? [];
	return /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			gap: "250",
			flexDirection: "row",
			children: [/* @__PURE__ */ K(b, {
				size: 14,
				name: "credit-card",
				className: pA.orderIconColor
			}), /* @__PURE__ */ K(L.Paragraph, {
				variant: "3",
				children: "Payment methods"
			})]
		}), /* @__PURE__ */ K(T, {
			className: Vk.list,
			children: n?.map((e, n) => /* @__PURE__ */ K(T.Item, {
				className: Vk.listItem,
				children: /* @__PURE__ */ q(_, {
					justifyContent: "space-between",
					alignItems: "center",
					width: "100%",
					children: [/* @__PURE__ */ q(_, {
						flexDirection: "column",
						gap: "100",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "5",
							children: e?.description
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: e?.method
						})]
					}), /* @__PURE__ */ q(_, {
						gap: "100",
						flexDirection: "column",
						className: Vk.listItemAlignRight,
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "5",
							children: Kk(e?.paidAt).format(he)
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: dA({
								value: e?.amount,
								currencyCode: t
							})
						})]
					})]
				})
			}, `payments-${n}`))
		})]
	});
}, yA = ({ order: e, openByDefault: t }) => {
	let [r, i] = W(t);
	if (!e) return null;
	let { orderId: a, status: o, externalStatus: s, currencyCode: c, channel: l, createdAt: u, lastChangedAt: d, lineItems: f, billingAddress: p, deliveryAddress: m, totalPrice: h } = e;
	return /* @__PURE__ */ q(_, {
		className: ae(pA.order, { [pA.orderIsOpen]: r }),
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ q(_, {
			justifyContent: "space-between",
			alignItems: "center",
			className: pA.orderHeader,
			onClick: () => i(!r),
			children: [/* @__PURE__ */ q(_, {
				gap: "100",
				flexDirection: "column",
				children: [u && /* @__PURE__ */ K(_, {
					alignItems: "center",
					children: /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: Kk(u).format(he)
					})
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "1",
					children: a
				})]
			}), /* @__PURE__ */ K(x, {
				variant: "tertiary",
				icon: r ? "angle-down" : "angle-right"
			})]
		}), r && /* @__PURE__ */ q(_, {
			gap: "250",
			flexDirection: "column",
			margin: "200 0 0",
			children: [
				/* @__PURE__ */ q(_, {
					gap: "250",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "activity",
						className: pA.orderIconColor
					}), /* @__PURE__ */ q(_, {
						flexDirection: "column",
						gap: "200",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Order status"
						}), /* @__PURE__ */ q(_, {
							gap: "100",
							alignItems: "center",
							flexWrap: "wrap",
							children: [
								o && /* @__PURE__ */ K(R, {
									content: "Internal status",
									children: /* @__PURE__ */ K(n, {
										size: "small",
										variant: "info",
										children: /* @__PURE__ */ K(G, { children: o })
									})
								}),
								s && /* @__PURE__ */ K(R, {
									content: "External status",
									children: /* @__PURE__ */ K(n, {
										size: "small",
										variant: "info",
										children: /* @__PURE__ */ K(G, { children: s })
									})
								}),
								/* @__PURE__ */ K(R, {
									content: "Last updated at",
									children: /* @__PURE__ */ K(L.Paragraph, {
										as: "span",
										variant: "5",
										children: Kk(d).format(he)
									})
								})
							]
						})]
					})]
				}),
				/* @__PURE__ */ q(_, {
					gap: "250",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "chart-bar",
						className: pA.orderIconColor
					}), /* @__PURE__ */ q(_, {
						flexDirection: "column",
						gap: "200",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Order value"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: dA({
								value: h,
								currencyCode: c
							})
						})]
					})]
				}),
				l && /* @__PURE__ */ q(_, {
					gap: "250",
					children: [/* @__PURE__ */ K(b, {
						size: 14,
						name: "channels",
						className: pA.orderIconColor
					}), /* @__PURE__ */ q(_, {
						flexDirection: "column",
						gap: "200",
						children: [/* @__PURE__ */ K(L.Paragraph, {
							variant: "3",
							children: "Channel"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: /* @__PURE__ */ K(n, {
								size: "small",
								variant: "info",
								children: /* @__PURE__ */ K(G, { children: l })
							})
						})]
					})]
				}),
				/* @__PURE__ */ K(fA, {
					labelText: "Billing address",
					address: p
				}),
				/* @__PURE__ */ K(fA, {
					icon: "map-pin",
					labelText: "Delivery address",
					address: m
				}),
				/* @__PURE__ */ K(hA, { delivery: e.delivery }),
				/* @__PURE__ */ K(_A, {
					lineItems: f,
					currencyCode: c
				}),
				/* @__PURE__ */ K(gA, {
					fees: e.fees,
					currencyCode: c
				}),
				/* @__PURE__ */ K(vA, {
					payments: e.payments,
					currencyCode: c
				})
			]
		})]
	});
}, bA = ({ error: e, itemCount: t, children: n }) => e ? t === 0 || Se({ errors: e.graphQLErrors }) ? /* @__PURE__ */ K(_, {
	justifyContent: "center",
	children: /* @__PURE__ */ K(L.Paragraph, {
		variant: "4",
		color: "secondary",
		children: "There are no orders for this contact"
	})
}) : /* @__PURE__ */ K(z, { error: e }) : /* @__PURE__ */ K(G, { children: n }), xA = ({ contactId: e }) => {
	let { useQuery: t } = V(), [r, i] = W([]), { track: a } = B(), { loading: o, error: s, data: c } = t(kk, {
		skip: !e,
		variables: { contactId: e }
	});
	return U(() => {
		if (c?.Voyado) {
			let e = c?.Voyado.Orders_GetAllByContact;
			if (!o && e?.items) {
				i(e.items);
				let { totalCount: t } = e;
				t && a("voyado:orders:received", { count: t });
			}
		}
	}, [c?.Voyado]), e ? /* @__PURE__ */ q(_, {
		gap: "200",
		flexDirection: "column",
		margin: "200 0 300 0",
		children: [/* @__PURE__ */ q(_, {
			gap: "200",
			flexDirection: "row",
			alignItems: "center",
			children: [/* @__PURE__ */ K(L.Heading, {
				variant: "heading-3",
				children: "Orders"
			}), r.length > 0 && /* @__PURE__ */ K(n, {
				size: "small",
				variant: "success",
				children: r.length
			})]
		}), o ? /* @__PURE__ */ K(_, {
			justifyContent: "center",
			children: /* @__PURE__ */ K(N, {})
		}) : /* @__PURE__ */ K(bA, {
			error: s,
			itemCount: r.length,
			children: r.map((e, t) => /* @__PURE__ */ K(yA, {
				order: e,
				openByDefault: t === 0
			}, t))
		})]
	}) : null;
}, SA = ({ conversationContext: e, settings: t }) => {
	let { isLoading: n, contactId: r, hasMultipleContacts: i, error: a } = zk({ conversationContext: e }), o = !e?.customer?.email && !e?.customer?.phone_number, s = !!r, { showCustomerAttributes: c, showPreferences: l, showAudiences: u, showConsents: d, showLastMessages: f, showCustomerTransactions: p, showOrders: m } = t;
	return o ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "200 0 300 0",
		"data-testid": "widget-no-contact-message",
		children: /* @__PURE__ */ K(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "No email nor phone number are available in this conversation to look up a profile."
		})
	}) : i ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "200 0 300 0",
		"data-testid": "multiple-contacts-found-message",
		children: /* @__PURE__ */ K(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized."
		})
	}) : a ? Se({ errors: a.graphQLErrors }) ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: /* @__PURE__ */ K(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "No profile found"
		})
	}) : /* @__PURE__ */ K(z, { error: a }) : !c && !l && !u && !d && !f && !p ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: /* @__PURE__ */ K(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "All features toggles in the widget settings are disabled."
		})
	}) : n ? /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "300",
		children: /* @__PURE__ */ K(N, {})
	}) : /* @__PURE__ */ q(_, {
		gap: "300",
		flexDirection: "column",
		margin: "200 0 300 0",
		"data-testid": "widget-wrapper",
		children: [
			/* @__PURE__ */ K($k, {
				contactId: r,
				settings: t
			}),
			f && /* @__PURE__ */ K(uA, { contactId: r }),
			p && /* @__PURE__ */ K(aA, { contactId: r }),
			m && /* @__PURE__ */ K(xA, { contactId: r }),
			!s && /* @__PURE__ */ K(_, {
				justifyContent: "center",
				padding: "200",
				children: /* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					color: "secondary",
					children: "No contact found."
				})
			})
		]
	});
}, CA = [
	{
		key: "voyadoApiKey",
		label: "API key",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "apiHostName",
		label: "API URL",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "showCustomerAttributes",
		label: "Show the customer attributes",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showPreferences",
		label: "Show preferences",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showAudiences",
		label: "Show audiences",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showConsents",
		label: "Show consents",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showLastMessages",
		label: "Show the last 5 messages",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showCustomerTransactions",
		label: "Show customer transactions",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showOrders",
		label: "Show orders by contact",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showMemberLevel",
		label: "Show member level",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	}
], wA = Pe(CA), TA = {
	enabled: !1,
	name: "",
	voyadoApiKey: "",
	apiHostName: "",
	showCustomerAttributes: !0,
	showPreferences: !0,
	showAudiences: !0,
	showConsents: !0,
	showLastMessages: !0,
	showCustomerTransactions: !0,
	showOrders: !0,
	showMemberLevel: !0
}, EA = ({ integrationId: e, handleRedirect: t, showNotification: n, automationCouplingState: r, renderConditionsEditor: i }) => {
	let a = !e, o = xc({
		mode: "onChange",
		defaultValues: TA
	}), { create: s, update: c, remove: l, isLoading: u, error: d, misconfigurationCause: f, setMisconfigurationCause: p } = Ve({
		integrationId: e,
		integrationType: "VOYADO",
		handleRedirect: t,
		showNotification: n
	}), { isLoading: m, error: h, isWidgetUnknown: _, refetch: b, widgetConfiguration: x } = He({
		integrationId: e,
		fieldDefinitions: CA,
		form: o,
		onMisconfigured: p
	}), { renderConditions: S, setRenderConditions: C, renderConditionsForSubmit: w } = Be({
		integrationId: e,
		widgetConfiguration: x,
		renderConditionsEditor: i
	}), T = (e) => ye(e, {
		fieldDefinitions: CA,
		isCreationMode: a,
		create: s,
		update: c,
		renderConditions: w
	}), E = o.watch("name");
	return /* @__PURE__ */ q(de, {
		form: o,
		integrationId: e,
		onValidSubmit: T,
		error: h ?? d,
		onRetry: h ? b : void 0,
		isLoading: u || m,
		isWidgetUnknown: _,
		children: [
			f && /* @__PURE__ */ K(se, { cause: f }),
			/* @__PURE__ */ q(y, { children: [
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ K(Z, {
						name: "enabled",
						control: o.control
					})
				}) }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "name",
						label: "Widget name",
						control: o.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(ue, {
						name: "voyadoApiKey",
						label: wA.voyadoApiKey,
						control: o.control,
						isCreationMode: a,
						rules: { required: "API key is required" },
						componentProps: {
							placeholder: "API key from Voyado",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "apiHostName",
						label: wA.apiHostName,
						control: o.control,
						rules: { required: "API URL is required" },
						componentProps: {
							placeholder: "The URL of the Voyado API",
							autoComplete: "off",
							prefix: "https://"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: wA.showCustomerAttributes,
						children: /* @__PURE__ */ K(Z, {
							name: "showCustomerAttributes",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: wA.showPreferences,
						children: /* @__PURE__ */ K(Z, {
							name: "showPreferences",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: wA.showAudiences,
						children: /* @__PURE__ */ K(Z, {
							name: "showAudiences",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: wA.showConsents,
						children: /* @__PURE__ */ K(Z, {
							name: "showConsents",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: wA.showLastMessages,
						children: /* @__PURE__ */ K(Z, {
							name: "showLastMessages",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: wA.showCustomerTransactions,
						children: /* @__PURE__ */ K(Z, {
							name: "showCustomerTransactions",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: wA.showOrders,
						children: /* @__PURE__ */ K(Z, {
							name: "showOrders",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: wA.showMemberLevel,
						children: /* @__PURE__ */ K(Z, {
							name: "showMemberLevel",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				i && S !== null && /* @__PURE__ */ K(v, { children: i({
					value: S,
					onChange: C,
					configurationKey: x?.id
				}) })
			] }),
			/* @__PURE__ */ K(pe, {
				integrationType: "VOYADO",
				integrationId: e,
				widgetName: E,
				isCreationMode: a,
				isSubmitting: o.formState.isSubmitting,
				automationCouplingState: r,
				onConfirmDelete: () => l()
			})
		]
	});
};
//#endregion
//#region ../widget-yotpo/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._copyIcon_1pfts_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1pfts_59{background:linear-gradient(var(--dixa-color-neutral-000) 33%, #fff0), linear-gradient(#fff0, var(--dixa-color-neutral-000) 66%) 0 100%, radial-gradient(farthest-side at 50% 0, var(--dixa-color-neutral-200), #0000), radial-gradient(farthest-side at 50% 100%, var(--dixa-color-neutral-200), #0000) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-200), 100% var(--dixa-size-spacer-200);max-height:230px;padding:0;overflow-y:auto}._listItem_1pfts_69{cursor:pointer;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200);background-color:#0000}._listItem_1pfts_69:last-child{box-shadow:none}._listItemHighlighted_1pfts_78{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);overflow:auto}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var DA = { "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
	kind: "Document",
	definitions: [{
		kind: "OperationDefinition",
		operation: "query",
		name: {
			kind: "Name",
			value: "getCustomerDetails"
		},
		variableDefinitions: [
			{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "email"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			},
			{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "phone"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			},
			{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "limit"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Int"
					}
				}
			},
			{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "externalIds"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			},
			{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "storeId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			},
			{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "expand"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			}
		],
		selectionSet: {
			kind: "SelectionSet",
			selections: [{
				kind: "Field",
				name: {
					kind: "Name",
					value: "Yotpo"
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "getCustomers"
						},
						arguments: [
							{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "email"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "email"
									}
								}
							},
							{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "phone_number"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "phone"
									}
								}
							},
							{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "limit"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "limit"
									}
								}
							},
							{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "external_ids"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "externalIds"
									}
								}
							},
							{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "store_id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "storeId"
									}
								}
							},
							{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "expand"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "expand"
									}
								}
							}
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "InlineFragment",
								typeCondition: {
									kind: "NamedType",
									name: {
										kind: "Name",
										value: "Yotpo_getCustomers_response"
									}
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Yotpo_Customers"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "customers"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "external_id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "email"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "phone_number"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "first_name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "last_name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "gender"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "account_created_at"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "account_updated_at"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "default_language"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "dafault_currency"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "lists"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																}, {
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "since"
																	}
																}]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "yotpo_ugc"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "total_reviews"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "avg_product_rating"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "avg_site_rating"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "total_avg_rating"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "sentiment_avg_product"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "sentiment_avg_site"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "total_avg_sentiment"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "top_topics"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "last_star_rating"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "last_review_date"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "last_sentiment"
																		}
																	}
																]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "yotpo_loyalty"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "points_earned"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "points_balance"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "last_seen_at"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "total_redemptions"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "total_points_redeemed"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "vip_tier_name"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "successful_referrals"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "referrals_made_and_clicked"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "is_referred_by_other_customer"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "points_expire_date"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "credit_balance_amount"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "credit_balance_customer_currency"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "is_opt_in"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "opt_in_date"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "opt_out_date"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "has_store_account"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "referred_by_customer"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "vip_entry_date"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "vip_expiration_date"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "next_points_expire_on"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "next_points_expire_amount"
																		}
																	}
																]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "yotpo_subscriptions"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "active_subscriptions"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalProductId"
																				}
																			}, {
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalVariantId"
																				}
																			}]
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "paused_subscriptions"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalProductId"
																				}
																			}, {
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalVariantId"
																				}
																			}]
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "failed_subscriptions"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalProductId"
																				}
																			}, {
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalVariantId"
																				}
																			}]
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "expired_subscriptions"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalProductId"
																				}
																			}, {
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalVariantId"
																				}
																			}]
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "canceled_subscriptions"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalProductId"
																				}
																			}, {
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalVariantId"
																				}
																			}]
																		}
																	}
																]
															}
														}
													]
												}
											}]
										}
									}]
								}
							}]
						}
					}]
				}
			}]
		}
	}]
} };
function OA(e) {
	return DA[e] ?? {};
}
var kA = OA("\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), AA = Yo, jA = {
	copyIcon: "_copyIcon_1pfts_54",
	list: "_list_1pfts_59",
	listItem: "_listItem_1pfts_69",
	listItemHighlighted: "_listItemHighlighted_1pfts_78"
}, MA = {
	wrapper: "_wrapper_1xucg_1",
	externalLink: "_externalLink_1xucg_7"
}, NA = ({ customerDetails: e }) => {
	let { isCopied: t, copy: n } = Re(), { isCopied: r, copy: i } = Re();
	if (!e) return null;
	let { first_name: a, last_name: o, email: s, phone_number: c, account_created_at: l } = e, u = `${a || ""} ${o || ""}`.trim() || "A customer has no name";
	return /* @__PURE__ */ K(_, {
		gap: "300",
		flexDirection: "column",
		children: /* @__PURE__ */ q(_, {
			className: MA.wrapper,
			gap: "200",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ K(_, {
					justifyContent: "space-between",
					className: MA.block,
					alignItems: "center",
					children: /* @__PURE__ */ K(L.Heading, {
						variant: "heading-2",
						children: u
					})
				}),
				l && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					margin: "0 0 200",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: "Member since"
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						children: AA(l).format(he)
					})]
				}),
				s && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "mail"
						}), /* @__PURE__ */ K("span", {
							className: MA.externalLink,
							children: s
						})]
					}), /* @__PURE__ */ K(R, {
						content: "Copy email",
						children: /* @__PURE__ */ K(_, {
							alignItems: "center",
							children: /* @__PURE__ */ K(b, {
								size: 14,
								name: t ? "done" : "copy",
								onClick: () => n(s),
								className: jA.copyIcon
							})
						})
					})]
				}),
				c && /* @__PURE__ */ q(_, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ q(_, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ K(b, {
							size: 14,
							name: "phone"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: c
						})]
					}), /* @__PURE__ */ K(R, {
						content: "Copy phone number",
						children: /* @__PURE__ */ K(_, {
							alignItems: "center",
							children: /* @__PURE__ */ K(b, {
								size: 14,
								name: r ? "done" : "copy",
								onClick: () => i(c),
								className: jA.copyIcon
							})
						})
					})]
				})
			]
		})
	});
}, PA = ({ description: e, content: t, tooltip: n, isHighlighted: r = !1, as: i }) => {
	if (t == null) return null;
	let a = qe(t);
	return /* @__PURE__ */ K(T.Text, {
		variant: "dense",
		className: ae(jA.listItem, { [jA.listItemHighlighted]: r }),
		children: /* @__PURE__ */ K(R, {
			content: n,
			children: /* @__PURE__ */ q(_, {
				justifyContent: "space-between",
				alignItems: "center",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					children: e
				}), a ? t : ge(t, i)]
			})
		})
	});
}, FA = ({ loyalty: e }) => /* @__PURE__ */ q(_, {
	gap: "200",
	flexDirection: "column",
	children: [
		/* @__PURE__ */ K(L.Heading, {
			variant: "heading-3",
			children: "Loyalty"
		}),
		!e && /* @__PURE__ */ K(_, {
			justifyContent: "center",
			children: /* @__PURE__ */ K(L.Paragraph, {
				variant: "4",
				color: "secondary",
				children: "No loyalty data available"
			})
		}),
		e && /* @__PURE__ */ q(T, {
			className: jA.list,
			children: [
				/* @__PURE__ */ K(PA, {
					isHighlighted: !0,
					description: "Successful referrals",
					tooltip: "The total number of successful referrals made by the customer.",
					content: e.successful_referrals
				}),
				/* @__PURE__ */ K(PA, {
					isHighlighted: !0,
					description: "Referrals made and clicked",
					tooltip: "The total number of referrals made by the customer and clicked on by others.",
					content: e.referrals_made_and_clicked
				}),
				/* @__PURE__ */ K(PA, {
					description: "Points earned",
					tooltip: "The total number of loyalty points earned by the customer.",
					content: e.points_earned
				}),
				/* @__PURE__ */ K(PA, {
					description: "Points balance",
					tooltip: "The current balance of loyalty points for the customer.",
					content: e.points_balance
				}),
				/* @__PURE__ */ K(PA, {
					description: "Last seen",
					tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
					content: e.last_seen_at
				}),
				/* @__PURE__ */ K(PA, {
					description: "Total redemptions",
					tooltip: "The total number of times the customer has redeemed loyalty points.",
					content: e.total_redemptions
				}),
				/* @__PURE__ */ K(PA, {
					description: "Total points redeemed",
					tooltip: "The total number of loyalty points redeemed by the customer.",
					content: e.total_points_redeemed
				}),
				/* @__PURE__ */ K(PA, {
					description: "VIP tier",
					tooltip: "The name of the customer's current VIP tier status.",
					content: e.vip_tier_name
				}),
				/* @__PURE__ */ K(PA, {
					description: "Referred by other customer",
					tooltip: "Indicates whether the customer was referred by another customer.",
					content: e.is_referred_by_other_customer
				}),
				/* @__PURE__ */ K(PA, {
					description: "Points expiry date",
					tooltip: "The timestamp when the customer's loyalty points are set to expire.",
					content: e.next_points_expire_on || e.points_expire_date
				}),
				/* @__PURE__ */ K(PA, {
					description: "Points expiry amount",
					tooltip: "The number of points that are about to expire",
					content: e.next_points_expire_amount
				}),
				/* @__PURE__ */ K(PA, {
					description: "Credit balance amount",
					tooltip: "The amount of store credit available to the customer in the default currency of the store.",
					content: e.credit_balance_amount
				}),
				/* @__PURE__ */ K(PA, {
					description: "Credit balance customer currency",
					tooltip: "The store credit amount in the customer's preferred currency.",
					content: e.credit_balance_customer_currency,
					as: "string"
				}),
				/* @__PURE__ */ K(PA, {
					description: "Opt in",
					tooltip: "Indicates whether the customer has opted into the loyalty program.",
					content: e.is_opt_in
				}),
				/* @__PURE__ */ K(PA, {
					description: "Opt in date",
					tooltip: "The timestamp for when the customer opted into the loyalty program.",
					content: e.opt_in_date
				}),
				/* @__PURE__ */ K(PA, {
					description: "Opt out date",
					tooltip: "The timestamp for when the customer opted out of the loyalty program.",
					content: e.opt_out_date
				}),
				/* @__PURE__ */ K(PA, {
					description: "Has store account",
					tooltip: "Indicates whether the customer has a store account.",
					content: e.has_store_account
				}),
				/* @__PURE__ */ K(PA, {
					description: "Referred by customer",
					tooltip: "The email address of the customer who referred this customer to the loyalty program.",
					content: e.referred_by_customer
				}),
				/* @__PURE__ */ K(PA, {
					description: "VIP entry date",
					tooltip: "The timestamp for when the customer entered the VIP tier.",
					content: e.vip_entry_date
				}),
				/* @__PURE__ */ K(PA, {
					description: "VIP expiration date",
					tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
					content: e.vip_expiration_date
				})
			]
		})
	]
}), IA = .8, LA = .4, RA = (e) => {
	if (e != null) return e >= IA ? /* @__PURE__ */ K(n, {
		variant: "success",
		size: "small",
		children: "Positive"
	}) : e <= LA ? /* @__PURE__ */ K(n, {
		variant: "error",
		size: "small",
		children: "Negative"
	}) : /* @__PURE__ */ K(n, {
		variant: "warning",
		size: "small",
		children: "Neutral"
	});
}, zA = ({ userGeneratedContent: e }) => /* @__PURE__ */ q(_, {
	gap: "200",
	flexDirection: "column",
	children: [
		/* @__PURE__ */ K(L.Heading, {
			variant: "heading-3",
			children: "User generated content"
		}),
		!e && /* @__PURE__ */ K(_, {
			justifyContent: "center",
			children: /* @__PURE__ */ K(L.Paragraph, {
				variant: "4",
				color: "secondary",
				children: "No user generated content available"
			})
		}),
		e && /* @__PURE__ */ q(T, {
			className: jA.list,
			children: [
				/* @__PURE__ */ K(PA, {
					isHighlighted: !0,
					description: "Total reviews",
					tooltip: "The total number of reviews submitted by the customer.",
					content: e.total_reviews
				}),
				/* @__PURE__ */ K(PA, {
					isHighlighted: !0,
					description: "Total average rating",
					tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
					content: e.total_avg_rating?.toFixed(2)
				}),
				/* @__PURE__ */ K(PA, {
					isHighlighted: !0,
					description: "Total average sentiment score",
					tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
					content: RA(e.total_avg_sentiment)
				}),
				/* @__PURE__ */ K(PA, {
					description: "Average product rating",
					tooltip: "The average product rating given by the customer.",
					content: e.avg_product_rating
				}),
				/* @__PURE__ */ K(PA, {
					description: "Average site rating",
					tooltip: "The average rating of the site/store given by the customer.",
					content: e.avg_site_rating?.toFixed(2)
				}),
				/* @__PURE__ */ K(PA, {
					description: "Last sentiment",
					tooltip: "The sentiment score of the customer's last review.",
					content: RA(e.last_sentiment)
				}),
				/* @__PURE__ */ K(PA, {
					description: "Last star rating",
					tooltip: "The star rating of the customer's last review.",
					content: e.last_star_rating
				}),
				/* @__PURE__ */ K(PA, {
					description: "Last review date",
					tooltip: "The timestamp for when the customer last submitted a review.",
					content: AA(e.last_review_date).format(he)
				}),
				/* @__PURE__ */ K(PA, {
					description: "Topics",
					tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
					content: /* @__PURE__ */ K(_, {
						gap: "100",
						width: "80%",
						flexWrap: "wrap",
						justifyContent: "flex-end",
						children: e.top_topics?.map((e, t) => /* @__PURE__ */ K(n, {
							variant: "info",
							size: "small",
							children: /* @__PURE__ */ K(G, { children: e })
						}, t))
					})
				})
			]
		})
	]
}), BA = ({ conversationContext: e, settings: t }) => {
	let { useQuery: n } = V(), { track: r } = B(), [i, a] = W(), [o, s] = W(!1), c = e?.customer?.email, l = e?.customer?.phone_number, u = !c && !l, d = t?.yotpoStoreId, f = t?.showCustomerDetails ?? !1, p = t?.showUserGeneratedContent ?? !1, m = t?.displayLoyalty ?? !1, h = t?.displaySubscriptions ?? !1, g = !d, v = !f && !p && !m && !h, { loading: y, error: b, data: x } = n(kA, {
		skip: u || g,
		variables: {
			...c && { email: c },
			...!c && l && { phone: l },
			storeId: d,
			expand: "all"
		}
	});
	if (U(() => {
		let e = (x?.Yotpo?.getCustomers)?.customers?.[0];
		e ? (a(e), s(!1), r("yotpo:customer:received")) : s(!0);
	}, [x?.Yotpo, y]), g) return /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: /* @__PURE__ */ K(z, {
			error: new nt({ graphQLErrors: [{ message: "Integration needs to be re-/authorized in the settings." }] }),
			hideCopyButton: !0
		})
	});
	if (u) return /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "200 0 300 0",
		"data-testid": "widget-no-contact-message",
		children: /* @__PURE__ */ K(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "No email nor phone number are available in this conversation to look up a profile."
		})
	});
	if (v) return /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "200 0 300 0",
		"data-testid": "widget-no-features",
		children: /* @__PURE__ */ K(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "All features toggles in the widget settings are disabled."
		})
	});
	if (y) return /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "300",
		children: /* @__PURE__ */ K(N, {})
	});
	if (o) return /* @__PURE__ */ K(_, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: /* @__PURE__ */ K(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "No customer profile found."
		})
	});
	if (b) {
		let e = b.graphQLErrors;
		return xe({ errors: e }) ? /* @__PURE__ */ K(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			variant: "4",
			"data-testid": "widget-downstream-api-forbidden-error",
			children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
		}) : be({ errors: e }) ? /* @__PURE__ */ K(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			variant: "4",
			"data-testid": "widget-downstream-api-authorization-error",
			children: "The integration could not authorize against Yotpo. Please contact your administrator."
		}) : /* @__PURE__ */ K(z, { error: b });
	}
	return /* @__PURE__ */ q(_, {
		gap: "300",
		flexDirection: "column",
		margin: "200 0 300 0",
		"data-testid": "widget-wrapper",
		children: [
			f && /* @__PURE__ */ K(NA, { customerDetails: i }),
			p && /* @__PURE__ */ K(zA, { userGeneratedContent: i?.yotpo_ugc }),
			m && /* @__PURE__ */ K(FA, { loyalty: i?.yotpo_loyalty })
		]
	});
}, VA = {
	settingsWrapper: "_settingsWrapper_1ycvy_1",
	settingsWrapperHeader: "_settingsWrapperHeader_1ycvy_6",
	settingsWrapperContent: "_settingsWrapperContent_1ycvy_10",
	settingsWrapperContentCode: "_settingsWrapperContentCode_1ycvy_18",
	settingsWrapperContentCURL: "_settingsWrapperContentCURL_1ycvy_26"
}, HA = ({ handleChangeText: e }) => {
	let [t, n] = W(!1), { isCopied: i, copy: o } = Re(), { control: s } = xc({
		defaultValues: {
			storeId: "",
			secret: ""
		},
		mode: "onChange"
	}), c = ws({ control: s }), l = c.storeId !== "" && c.secret !== "", u = Je(() => {
		let e = c.storeId, t = c.secret;
		return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${e || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${t ? ` \\
  --data '{"secret":"${t}"}'` : ""}`;
	}, [c.storeId, c.secret]);
	return /* @__PURE__ */ K(G, { children: /* @__PURE__ */ K(v, {
		span: 6,
		children: /* @__PURE__ */ q(_, {
			flexDirection: "column",
			className: VA.settingsWrapper,
			children: [/* @__PURE__ */ q(_, {
				gap: "200",
				alignItems: "center",
				className: VA.settingsWrapperHeader,
				onClick: () => n(!t),
				children: [/* @__PURE__ */ K(L.Heading, {
					variant: "heading-3",
					children: "How to get the Yotpo access token"
				}), /* @__PURE__ */ K(b, { name: t ? "angle-down" : "angle-right" })]
			}), t && /* @__PURE__ */ q(_, {
				flexDirection: "column",
				className: VA.settingsWrapperContent,
				children: [
					/* @__PURE__ */ K(_, {
						margin: "0 0 400",
						children: /* @__PURE__ */ K(r, {
							variant: "announcement",
							headline: "In order to get the Yotpo access token, you have to follow the steps below",
							description: /* @__PURE__ */ q("ol", { children: [
								/* @__PURE__ */ K("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
								/* @__PURE__ */ K("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
								/* @__PURE__ */ q("li", { children: [
									"The response should look like this",
									" ",
									/* @__PURE__ */ K("span", {
										className: VA.settingsWrapperContentCode,
										children: "{ \"access_token\": \"this-is-your-token\" }"
									})
								] }),
								/* @__PURE__ */ q("li", { children: [
									"Copy the token without quotes and paste it in the",
									" ",
									/* @__PURE__ */ K("i", { children: "Yotpo access token" }),
									" input field below"
								] }),
								/* @__PURE__ */ K("li", { children: "Click the save button" })
							] })
						})
					}),
					/* @__PURE__ */ K(Es, {
						name: "storeId",
						control: s,
						render: ({ field: t }) => /* @__PURE__ */ K(m, {
							label: "Yotpo store ID",
							placeholder: "Please insert the store ID",
							input: {
								...t,
								onChange: (n) => {
									t.onChange(n), e({ target: {
										name: "yotpoStoreId",
										value: n?.target.value ?? ""
									} });
								}
							}
						})
					}),
					/* @__PURE__ */ K(Es, {
						name: "secret",
						control: s,
						render: ({ field: e }) => /* @__PURE__ */ K(m, {
							label: "Yotpo secret",
							placeholder: "Please insert the secret",
							input: e
						})
					}),
					l && /* @__PURE__ */ q(G, { children: [/* @__PURE__ */ K(g, {
						label: "Generated CURL command",
						noAlert: !0,
						children: /* @__PURE__ */ K(_, {
							as: "pre",
							gap: "200",
							margin: "100 0 250",
							className: VA.settingsWrapperContentCURL,
							children: u()
						})
					}), /* @__PURE__ */ K(_, {
						alignContent: "start",
						children: /* @__PURE__ */ K(R, {
							content: i ? "Copied!" : "Copy CURL command",
							children: /* @__PURE__ */ K(a, {
								variant: "secondary",
								icon: i ? "check-circle" : "copy",
								onClick: () => o(u()),
								children: "Copy CURL"
							})
						})
					})] })
				]
			})]
		})
	}) });
}, UA = [
	{
		key: "yotpoStoreId",
		label: "Yotpo store ID",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "yotpoAccessToken",
		label: "Yotpo access token",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "showCustomerDetails",
		label: "Show customer details",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showUserGeneratedContent",
		label: "Show user generated content",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayLoyalty",
		label: "Show loyalty data",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	}
], WA = [{
	key: "yotpoStoreId",
	label: "Yotpo store ID",
	placeholder: "",
	readOnly: !0,
	required: !1,
	secret: !1,
	type: "hidden",
	hideOnCreate: !0
}, {
	key: "authorizeWithOauth",
	label: "Authorize with OAuth",
	secret: !1,
	type: "custom",
	hideOnCreate: !0,
	component: ce
}], GA = [
	{
		key: "accessTokenComponent",
		label: "Retrieve Yotpo access token",
		secret: !1,
		type: "custom",
		component: HA
	},
	{
		key: "yotpoStoreId",
		label: "Yotpo store ID",
		placeholder: "See \"How to get the Yotpo access token\" above.",
		readOnly: !0,
		required: !0,
		secret: !1,
		type: "input"
	},
	{
		key: "yotpoAccessToken",
		label: "Yotpo access token",
		placeholder: "Insert the Yotpo access token",
		required: !0,
		secret: !0,
		type: "input"
	}
], KA = Pe(UA), qA = "YOTPO", JA = {
	enabled: !1,
	name: "",
	...Le([], UA)
}, YA = ({ integrationId: e, configuration: t, handleRedirect: n, showNotification: r, automationCouplingState: i, renderConditionsEditor: a }) => {
	let o = !e, s = xc({
		mode: "onChange",
		defaultValues: JA
	}), { create: c, update: l, remove: u, isLoading: d, error: f, misconfigurationCause: p, setMisconfigurationCause: m } = Ve({
		integrationId: e,
		integrationType: qA,
		handleRedirect: n,
		showNotification: r
	}), { isLoading: h, error: _, isWidgetUnknown: b, refetch: x, widgetConfiguration: S } = He({
		integrationId: e,
		fieldDefinitions: UA,
		form: s,
		onMisconfigured: m
	}), { renderConditions: C, setRenderConditions: w, renderConditionsForSubmit: T } = Be({
		integrationId: e,
		widgetConfiguration: S,
		renderConditionsEditor: a
	}), E = o || !!S?.additionalProperties?.isUsingOAuth, D = (e) => ye(e, {
		fieldDefinitions: UA,
		isCreationMode: o,
		create: c,
		update: l,
		renderConditions: T
	}), O = s.watch("name");
	return /* @__PURE__ */ q(de, {
		form: s,
		integrationId: e,
		onValidSubmit: D,
		error: _ ?? f,
		onRetry: _ ? x : void 0,
		isLoading: d || h,
		isWidgetUnknown: b,
		children: [
			p && /* @__PURE__ */ K(se, { cause: p }),
			/* @__PURE__ */ q(y, { children: [
				/* @__PURE__ */ K(v, { children: /* @__PURE__ */ K(g, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ K(Z, {
						name: "enabled",
						control: s.control
					})
				}) }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(jc, {
						name: "name",
						label: "Widget name",
						control: s.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				!E && /* @__PURE__ */ q(G, { children: [
					/* @__PURE__ */ K(HA, { handleChangeText: (e) => s.setValue("yotpoStoreId", e?.target.value ?? "") }),
					/* @__PURE__ */ K(v, {
						span: 3,
						children: /* @__PURE__ */ K(jc, {
							name: "yotpoStoreId",
							label: KA.yotpoStoreId,
							control: s.control,
							rules: { required: "Yotpo store ID is required" },
							componentProps: {
								placeholder: "See \"How to get the Yotpo access token\" above.",
								readOnly: !0,
								autoComplete: "off"
							}
						})
					}),
					/* @__PURE__ */ K(v, { span: 3 }),
					/* @__PURE__ */ K(v, {
						span: 3,
						children: /* @__PURE__ */ K(ue, {
							name: "yotpoAccessToken",
							label: KA.yotpoAccessToken,
							control: s.control,
							isCreationMode: o,
							rules: { required: "Yotpo access token is required" },
							componentProps: {
								placeholder: "Insert the Yotpo access token",
								autoComplete: "off"
							}
						})
					}),
					/* @__PURE__ */ K(v, { span: 3 })
				] }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: KA.showCustomerDetails,
						children: /* @__PURE__ */ K(Z, {
							name: "showCustomerDetails",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: KA.showUserGeneratedContent,
						children: /* @__PURE__ */ K(Z, {
							name: "showUserGeneratedContent",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				/* @__PURE__ */ K(v, {
					span: 3,
					children: /* @__PURE__ */ K(g, {
						label: KA.displayLoyalty,
						children: /* @__PURE__ */ K(Z, {
							name: "displayLoyalty",
							control: s.control
						})
					})
				}),
				/* @__PURE__ */ K(v, { span: 3 }),
				E && !o && e && /* @__PURE__ */ K(ce, {
					configuration: t,
					integrationId: e,
					integrationType: qA,
					label: "Authorize with OAuth"
				}),
				a && C !== null && /* @__PURE__ */ K(v, { children: a({
					value: C,
					onChange: w,
					configurationKey: S?.id
				}) })
			] }),
			/* @__PURE__ */ K(pe, {
				integrationType: qA,
				integrationId: e,
				widgetName: O,
				isCreationMode: o,
				isSubmitting: s.formState.isSubmitting,
				automationCouplingState: i,
				onConfirmDelete: () => u()
			})
		]
	});
}, XA = ({ hasShopifyOAuth: e = !1, isShopifyMarketplaceApp: t = !1, isCreationMode: n = !1 }) => n ? {
	authSettings: DE,
	featureSettings: []
} : t ? {
	authSettings: OE,
	featureSettings: [...AE]
} : e ? {
	authSettings: [...kE, ...TE],
	featureSettings: [...jE]
} : {
	authSettings: [...kE, ...EE],
	featureSettings: [...jE]
}, ZA = (e, t) => ({ hasOAuth: n = !1, isCreationMode: r = !1 }) => n || r ? e : t, QA = ZA(WA, GA), $A = ZA(Jf, Yf), ej = (e = {
	SHOPIFY: {},
	YOTPO: {},
	KLAVIYO: {}
}) => {
	let { SHOPIFY: t, YOTPO: n, KLAVIYO: r } = e, { authSettings: i, featureSettings: a } = XA(t), o = QA(n), s = $A(r);
	return {
		SHOPIFY: {
			widget: pk,
			icon: "shopify",
			iconColors: {
				contentColor: "rgb(148, 190, 69)",
				backgroundColor: "rgba(148, 190, 69, 0.1)"
			},
			fieldDefinitions: _E,
			WidgetSettings: SE,
			settingsConfiguration: [...i, ...a]
		},
		JIRA: {
			widget: Td,
			icon: "jira",
			iconColors: {
				contentColor: "rgb(38, 132, 255)",
				backgroundColor: "rgba(38, 132, 255, 0.075)"
			},
			fieldDefinitions: Ed,
			WidgetSettings: jd
		},
		GITHUB: {
			widget: Ql,
			icon: "github",
			iconColors: {
				contentColor: "rgb(87, 96, 106)",
				backgroundColor: "rgba(221, 244, 255, 0.75)"
			},
			fieldDefinitions: $l,
			WidgetSettings: ru
		},
		MIUROS: {
			widget: LS,
			icon: "miuros",
			iconColors: {
				contentColor: "rgb(246, 135, 179)",
				backgroundColor: "rgba(246, 135, 179, 0.15)"
			},
			fieldDefinitions: RS,
			WidgetSettings: HS
		},
		KLAVIYO: {
			widget: Kf,
			icon: "klaviyo",
			iconColors: {
				contentColor: "rgb(0, 0, 0)",
				backgroundColor: "rgba(0, 0, 0, 0.075)"
			},
			fieldDefinitions: qf,
			WidgetSettings: op,
			settingsConfiguration: [...s]
		},
		LINEAR: {
			widget: Tb,
			icon: "linear",
			iconColors: {
				contentColor: "rgb(94, 106, 210)",
				backgroundColor: "rgba(94, 106, 210, 0.15)"
			},
			fieldDefinitions: Eb,
			WidgetSettings: Ab
		},
		VOYADO: {
			widget: SA,
			icon: "voyado",
			iconColors: {
				contentColor: "rgb(0, 0, 0)",
				backgroundColor: "rgba(0, 0, 0, 0.075)"
			},
			fieldDefinitions: CA,
			WidgetSettings: EA
		},
		LOYALTYLION: {
			widget: Xb,
			icon: "loyaltylion",
			iconColors: {
				contentColor: "rgb(36, 31, 79)",
				backgroundColor: "rgba(36, 31, 79, 0.075)"
			},
			fieldDefinitions: Zb,
			WidgetSettings: tx
		},
		RECHARGE: {
			widget: LC,
			icon: "recharge",
			iconColors: {
				contentColor: "rgb(57, 1, 241)",
				backgroundColor: "rgba(57, 1, 241, 0.075)"
			},
			fieldDefinitions: RC,
			WidgetSettings: WC
		},
		BRAZE: {
			widget: Zc,
			icon: "braze",
			iconColors: {
				contentColor: "rgb(48, 2, 102)",
				backgroundColor: "rgba(48, 2, 102, 0.075)"
			},
			fieldDefinitions: Qc,
			WidgetSettings: tl
		},
		YOTPO: {
			widget: BA,
			icon: "yotpo",
			iconColors: {
				contentColor: "rgb(0, 66, 228)",
				backgroundColor: "rgba(0, 66, 228, 0.075)"
			},
			fieldDefinitions: UA,
			WidgetSettings: YA,
			settingsConfiguration: [...o]
		},
		INGRID: {
			widget: Au,
			icon: "ingrid",
			iconColors: {
				contentColor: "rgb(0, 0, 0)",
				backgroundColor: "rgba(0, 0, 0, 0.075)"
			},
			fieldDefinitions: ju,
			WidgetSettings: Pu
		},
		RIVOLOYALTY: {
			widget: Cw,
			icon: "rivoloyalty",
			iconColors: {
				contentColor: "rgb(0, 0, 0)",
				backgroundColor: "rgba(0, 0, 0, 0.075)"
			},
			fieldDefinitions: iE,
			WidgetSettings: lE
		}
	};
}, tj = (e, t) => {
	let n = t.find((t) => t.key === e.key)?.value;
	return e.type === "boolean" ? Fe(n, e.defaultValue) : Ie(n, e.defaultValue);
}, nj = (e, t) => e.map((e) => ({
	key: e.key,
	value: tj(e, t)
})), rj = ({ fieldDefinitions: e }, t) => nj((e ?? []).filter(({ secret: e }) => !e), t), ij = (e) => {
	let t = ej();
	return e.map(({ id: e, type: n, name: r, settings: i, misconfigured: a, renderConditions: o, integrationKey: s }) => {
		let c = t[n];
		return {
			id: e,
			type: n,
			name: r,
			settings: rj(c, i),
			misconfigured: a,
			renderConditions: o,
			icon: c.icon,
			iconColors: c.iconColors,
			widget: c.widget,
			integrationKey: s
		};
	});
}, aj = ({ widget: e, index: n, configuration: r, conversationContext: i, showNotification: a, onToggleFn: o, isOpenFn: c, isMinimized: l, isUnmatched: u, renderVisibilityToggleElement: f, renderDragElement: p, renderConditionMatchedIndicator: m }) => {
	let { track: h } = B(), g = Ko(), v = $e(null), { id: y, name: b, type: x, widget: S, settings: C, misconfigured: w, renderConditions: T, icon: E, iconColors: D, integrationKey: O } = Ze(() => ij([e])[0], [e]), k = `partner-integration-${x}`, A = /* @__PURE__ */ K(t, {
		icon: E,
		color: D
	}), j = C?.reduce((e, t) => (e[t.key] = t.value, e), {});
	return l ? /* @__PURE__ */ K("div", {
		className: "icon-holder",
		children: A
	}, `partner-icon-${y}`) : /* @__PURE__ */ q(s, {
		onToggle: () => {
			h(c(O) ? "widget:collapse:closed" : "widget:collapse:opened", {
				widgetId: y,
				widgetType: x.toLowerCase()
			}), o(O);
		},
		isOpen: c(O),
		className: k,
		containerRef: v,
		children: [/* @__PURE__ */ K(s.Header, {
			className: ae({ [Jo.unmatchedHeader]: u }),
			wrap: "normal",
			avatar: A,
			slotBeforeTitle: p?.(O, n, v),
			slotAfterTitle: /* @__PURE__ */ K(G, { children: f?.(O) }),
			children: /* @__PURE__ */ q(_, {
				alignItems: "center",
				flexDirection: "row",
				gap: "200",
				children: [b, m?.(T ?? [], y)]
			})
		}), /* @__PURE__ */ K(s.Content, { children: w ? /* @__PURE__ */ K(z, { isMisconfigured: !0 }) : /* @__PURE__ */ K(d.Provider, {
			value: { onError: (e, t) => console.warn(`Something went wrong with a partner widget of type '${x}' and id '${y}'`, e, t) },
			children: /* @__PURE__ */ K(Wo, {
				integrationId: y,
				type: x,
				configuration: r,
				showNotification: a,
				showModal: g,
				children: Ke(S, {
					conversationContext: i,
					settings: j
				})
			})
		}) })]
	}, O);
}, oj = ({ widgets: e, configuration: t, conversationContext: n, showNotification: r, onToggleFn: i, isOpenFn: a, isMinimized: o, renderVisibilityToggleElement: s, renderDragElement: c, renderConditionMatchedIndicator: l, widgetAnnotations: u }) => /* @__PURE__ */ K(qo, { children: e.map((e, d) => /* @__PURE__ */ K(aj, {
	widget: e,
	index: d,
	configuration: t,
	conversationContext: n,
	showNotification: r,
	onToggleFn: i,
	isOpenFn: a,
	isMinimized: o,
	isUnmatched: u?.get(e.id) === !1,
	renderVisibilityToggleElement: s,
	renderDragElement: c,
	renderConditionMatchedIndicator: l
}, e.integrationKey)) }), sj = ({ configuration: e, integrationId: t, type: n, handleRedirect: r, showNotification: i, automationCouplingState: a, renderConditionsEditor: o }) => {
	let s = ej()[n]?.WidgetSettings;
	return /* @__PURE__ */ K(d.Provider, {
		value: { onError: (e, r) => console.warn(`Something went wrong with the partner widget settings of type ${n} and id ${t}`, e, r) },
		children: /* @__PURE__ */ K(Wo, {
			integrationId: t,
			type: n,
			configuration: e,
			showNotification: i,
			children: /* @__PURE__ */ K(G, { children: s && /* @__PURE__ */ K(s, {
				configuration: e,
				integrationId: t,
				handleRedirect: r,
				showNotification: i,
				automationCouplingState: a,
				renderConditionsEditor: o
			}) })
		})
	});
}, cj = "__PairingContext__", lj = globalThis[cj] ?? (() => {
	let e = Ge({});
	return globalThis[cj] = e, e;
})(), uj = () => Ye(lj), dj = ({ value: e, children: t }) => /* @__PURE__ */ K(lj.Provider, {
	value: e,
	children: t
}), fj = lt`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`;
function pj(e, { skip: t = !1 } = {}) {
	let [n, r] = W([]), [i, a] = W(!1);
	return U(() => {
		if (t) {
			a(!1);
			return;
		}
		let n = !1;
		return a(!0), zo(e).query({ query: fj }).then(({ data: e }) => {
			n || (r((e?.Management?.widgetConfigurations ?? []).filter((e) => e != null).map((e) => ({
				...e,
				integrationKey: `partner-integration-${e.id}`
			}))), a(!1));
		}).catch(() => {
			n || a(!1);
		}), () => {
			n = !0;
		};
	}, [e, t]), {
		isLoading: i,
		widgets: n
	};
}
//#endregion
//#region src/helpers/initializePartnerEventEmitter/initializePartnerEventEmitter.ts
var mj = (/* @__PURE__ */ Tt(((e, t) => {
	var n = typeof Reflect == "object" ? Reflect : null, r = n && typeof n.apply == "function" ? n.apply : function(e, t, n) {
		return Function.prototype.apply.call(e, t, n);
	}, i = n && typeof n.ownKeys == "function" ? n.ownKeys : Object.getOwnPropertySymbols ? function(e) {
		return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
	} : function(e) {
		return Object.getOwnPropertyNames(e);
	};
	function a(e) {
		console && console.warn && console.warn(e);
	}
	var o = Number.isNaN || function(e) {
		return e !== e;
	};
	function s() {
		s.init.call(this);
	}
	t.exports = s, t.exports.once = y, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
	var c = 10;
	function l(e) {
		if (typeof e != "function") throw TypeError("The \"listener\" argument must be of type Function. Received type " + typeof e);
	}
	Object.defineProperty(s, "defaultMaxListeners", {
		enumerable: !0,
		get: function() {
			return c;
		},
		set: function(e) {
			if (typeof e != "number" || e < 0 || o(e)) throw RangeError("The value of \"defaultMaxListeners\" is out of range. It must be a non-negative number. Received " + e + ".");
			c = e;
		}
	}), s.init = function() {
		(this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
	}, s.prototype.setMaxListeners = function(e) {
		if (typeof e != "number" || e < 0 || o(e)) throw RangeError("The value of \"n\" is out of range. It must be a non-negative number. Received " + e + ".");
		return this._maxListeners = e, this;
	};
	function u(e) {
		return e._maxListeners === void 0 ? s.defaultMaxListeners : e._maxListeners;
	}
	s.prototype.getMaxListeners = function() {
		return u(this);
	}, s.prototype.emit = function(e) {
		for (var t = [], n = 1; n < arguments.length; n++) t.push(arguments[n]);
		var i = e === "error", a = this._events;
		if (a !== void 0) i &&= a.error === void 0;
		else if (!i) return !1;
		if (i) {
			var o;
			if (t.length > 0 && (o = t[0]), o instanceof Error) throw o;
			var s = /* @__PURE__ */ Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
			throw s.context = o, s;
		}
		var c = a[e];
		if (c === void 0) return !1;
		if (typeof c == "function") r(c, this, t);
		else for (var l = c.length, u = g(c, l), n = 0; n < l; ++n) r(u[n], this, t);
		return !0;
	};
	function d(e, t, n, r) {
		var i, o, s;
		if (l(n), o = e._events, o === void 0 ? (o = e._events = Object.create(null), e._eventsCount = 0) : (o.newListener !== void 0 && (e.emit("newListener", t, n.listener ? n.listener : n), o = e._events), s = o[t]), s === void 0) s = o[t] = n, ++e._eventsCount;
		else if (typeof s == "function" ? s = o[t] = r ? [n, s] : [s, n] : r ? s.unshift(n) : s.push(n), i = u(e), i > 0 && s.length > i && !s.warned) {
			s.warned = !0;
			var c = /* @__PURE__ */ Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
			c.name = "MaxListenersExceededWarning", c.emitter = e, c.type = t, c.count = s.length, a(c);
		}
		return e;
	}
	s.prototype.addListener = function(e, t) {
		return d(this, e, t, !1);
	}, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function(e, t) {
		return d(this, e, t, !0);
	};
	function f() {
		if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
	}
	function p(e, t, n) {
		var r = {
			fired: !1,
			wrapFn: void 0,
			target: e,
			type: t,
			listener: n
		}, i = f.bind(r);
		return i.listener = n, r.wrapFn = i, i;
	}
	s.prototype.once = function(e, t) {
		return l(t), this.on(e, p(this, e, t)), this;
	}, s.prototype.prependOnceListener = function(e, t) {
		return l(t), this.prependListener(e, p(this, e, t)), this;
	}, s.prototype.removeListener = function(e, t) {
		var n, r, i, a, o;
		if (l(t), r = this._events, r === void 0 || (n = r[e], n === void 0)) return this;
		if (n === t || n.listener === t) --this._eventsCount === 0 ? this._events = Object.create(null) : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));
		else if (typeof n != "function") {
			for (i = -1, a = n.length - 1; a >= 0; a--) if (n[a] === t || n[a].listener === t) {
				o = n[a].listener, i = a;
				break;
			}
			if (i < 0) return this;
			i === 0 ? n.shift() : _(n, i), n.length === 1 && (r[e] = n[0]), r.removeListener !== void 0 && this.emit("removeListener", e, o || t);
		}
		return this;
	}, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function(e) {
		var t, n = this._events, r;
		if (n === void 0) return this;
		if (n.removeListener === void 0) return arguments.length === 0 ? (this._events = Object.create(null), this._eventsCount = 0) : n[e] !== void 0 && (--this._eventsCount === 0 ? this._events = Object.create(null) : delete n[e]), this;
		if (arguments.length === 0) {
			var i = Object.keys(n), a;
			for (r = 0; r < i.length; ++r) a = i[r], a !== "removeListener" && this.removeAllListeners(a);
			return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
		}
		if (t = n[e], typeof t == "function") this.removeListener(e, t);
		else if (t !== void 0) for (r = t.length - 1; r >= 0; r--) this.removeListener(e, t[r]);
		return this;
	};
	function m(e, t, n) {
		var r = e._events;
		if (r === void 0) return [];
		var i = r[t];
		return i === void 0 ? [] : typeof i == "function" ? n ? [i.listener || i] : [i] : n ? v(i) : g(i, i.length);
	}
	s.prototype.listeners = function(e) {
		return m(this, e, !0);
	}, s.prototype.rawListeners = function(e) {
		return m(this, e, !1);
	}, s.listenerCount = function(e, t) {
		return typeof e.listenerCount == "function" ? e.listenerCount(t) : h.call(e, t);
	}, s.prototype.listenerCount = h;
	function h(e) {
		var t = this._events;
		if (t !== void 0) {
			var n = t[e];
			if (typeof n == "function") return 1;
			if (n !== void 0) return n.length;
		}
		return 0;
	}
	s.prototype.eventNames = function() {
		return this._eventsCount > 0 ? i(this._events) : [];
	};
	function g(e, t) {
		for (var n = Array(t), r = 0; r < t; ++r) n[r] = e[r];
		return n;
	}
	function _(e, t) {
		for (; t + 1 < e.length; t++) e[t] = e[t + 1];
		e.pop();
	}
	function v(e) {
		for (var t = Array(e.length), n = 0; n < t.length; ++n) t[n] = e[n].listener || e[n];
		return t;
	}
	function y(e, t) {
		return new Promise(function(n, r) {
			function i(n) {
				e.removeListener(t, a), r(n);
			}
			function a() {
				typeof e.removeListener == "function" && e.removeListener("error", i), n([].slice.call(arguments));
			}
			x(e, t, a, { once: !0 }), t !== "error" && b(e, i, { once: !0 });
		});
	}
	function b(e, t, n) {
		typeof e.on == "function" && x(e, "error", t, n);
	}
	function x(e, t, n, r) {
		if (typeof e.on == "function") r.once ? e.once(t, n) : e.on(t, n);
		else if (typeof e.addEventListener == "function") e.addEventListener(t, function i(a) {
			r.once && e.removeEventListener(t, i), n(a);
		});
		else throw TypeError("The \"emitter\" argument must be of type EventEmitter. Received type " + typeof e);
	}
})))();
function hj() {
	let e = new mj.EventEmitter();
	return e && typeof window < "u" ? window._partner = { events: e } : console.warn("Initialization of partner-integration events was not successfull."), e;
}
//#endregion
export { Bo as GraphQLClientProvider, lj as PairingContext, dj as PairingProvider, aj as PartnerIntegrationCard, qo as PartnerIntegrationModalProvider, oj as PartnerIntegrations, sj as PartnerIntegrationsSettings, ej as getWidgetDefinitions, hj as initializePartnerEventEmitter, uj as usePairing, Ko as usePartnerIntegrationModal, pj as usePartnerIntegrationWidgetConfigurations };
